import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  Date: { input: any; output: any }
  DateTime: { input: any; output: any }
  JSON: { input: any; output: any }
  Long: { input: any; output: any }
}

export type IAbout = {
  __typename?: 'About'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  documentId: Scalars['ID']['output']
  email?: Maybe<Scalars['String']['output']>
  ourTeam?: Maybe<Array<Maybe<IComponentAboutPropsTeamMember>>>
  phone?: Maybe<Scalars['Long']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  what?: Maybe<Scalars['String']['output']>
  who?: Maybe<Scalars['String']['output']>
}

export type IAboutOurTeamArgs = {
  filters?: InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IAboutInput = {
  description?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  ourTeam?: InputMaybe<Array<InputMaybe<IComponentAboutPropsTeamMemberInput>>>
  phone?: InputMaybe<Scalars['Long']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  what?: InputMaybe<Scalars['String']['input']>
  who?: InputMaybe<Scalars['String']['input']>
}

export type IAnnouncement = {
  __typename?: 'Announcement'
  announcement: Scalars['String']['output']
  archived_at?: Maybe<Scalars['DateTime']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  created_by_user?: Maybe<IUser>
  documentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  isArchived?: Maybe<Scalars['Boolean']['output']>
  optionalLink?: Maybe<Scalars['String']['output']>
  previous_published_at?: Maybe<Scalars['DateTime']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  solution?: Maybe<ISolution>
  solution_request?: Maybe<ISolutionRequest>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IAnnouncementEntityResponseCollection = {
  __typename?: 'AnnouncementEntityResponseCollection'
  nodes: Array<IAnnouncement>
  pageInfo: IPagination
}

export type IAnnouncementFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IAnnouncementFiltersInput>>>
  announcement?: InputMaybe<IStringFilterInput>
  archived_at?: InputMaybe<IDateTimeFilterInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  created_by_user?: InputMaybe<IUserFiltersInput>
  documentId?: InputMaybe<IIdFilterInput>
  isArchived?: InputMaybe<IBooleanFilterInput>
  not?: InputMaybe<IAnnouncementFiltersInput>
  optionalLink?: InputMaybe<IStringFilterInput>
  or?: InputMaybe<Array<InputMaybe<IAnnouncementFiltersInput>>>
  previous_published_at?: InputMaybe<IDateTimeFilterInput>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  solution?: InputMaybe<ISolutionFiltersInput>
  solution_request?: InputMaybe<ISolutionRequestFiltersInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IAnnouncementInput = {
  announcement?: InputMaybe<Scalars['String']['input']>
  archived_at?: InputMaybe<Scalars['DateTime']['input']>
  created_by_user?: InputMaybe<Scalars['ID']['input']>
  isArchived?: InputMaybe<Scalars['Boolean']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  optionalLink?: InputMaybe<Scalars['String']['input']>
  previous_published_at?: InputMaybe<Scalars['DateTime']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  solution?: InputMaybe<Scalars['ID']['input']>
  solution_request?: InputMaybe<Scalars['ID']['input']>
}

export type IAnnouncementItem = {
  __typename?: 'AnnouncementItem'
  announcement: Scalars['String']['output']
  description?: Maybe<Scalars['String']['output']>
  documentId: Scalars['String']['output']
  optionalLink: Scalars['String']['output']
  solution: Scalars['String']['output']
}

export type IAnnouncementRelationResponseCollection = {
  __typename?: 'AnnouncementRelationResponseCollection'
  nodes: Array<IAnnouncement>
}

export type IArticleData = {
  __typename?: 'ArticleData'
  author?: Maybe<Scalars['String']['output']>
  content?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  image?: Maybe<IUploadFile>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  publishedTime?: Maybe<Scalars['Date']['output']>
  slug: Scalars['String']['output']
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IArticleDataEntityResponseCollection = {
  __typename?: 'ArticleDataEntityResponseCollection'
  nodes: Array<IArticleData>
  pageInfo: IPagination
}

export type IArticleDataFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IArticleDataFiltersInput>>>
  author?: InputMaybe<IStringFilterInput>
  content?: InputMaybe<IStringFilterInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  not?: InputMaybe<IArticleDataFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IArticleDataFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  publishedTime?: InputMaybe<IDateFilterInput>
  slug?: InputMaybe<IStringFilterInput>
  title?: InputMaybe<IStringFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IArticleDataInput = {
  author?: InputMaybe<Scalars['String']['input']>
  content?: InputMaybe<Scalars['String']['input']>
  image?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  publishedTime?: InputMaybe<Scalars['Date']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type IAskAiLog = {
  __typename?: 'AskAiLog'
  AskAIUserLog?: Maybe<IComponentAskAiUserLogAskAiUserLog>
  Cost?: Maybe<Scalars['JSON']['output']>
  Identical?: Maybe<Array<Maybe<IComponentIdenticalIdentical>>>
  Question?: Maybe<Scalars['String']['output']>
  Rating?: Maybe<IComponentAskAiRatingAskAiRating>
  Response?: Maybe<Scalars['String']['output']>
  Source?: Maybe<Array<Maybe<IComponentSourcesSources>>>
  cacheHours?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  sendEmail?: Maybe<Scalars['Boolean']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IAskAiLogIdenticalArgs = {
  filters?: InputMaybe<IComponentIdenticalIdenticalFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IAskAiLogSourceArgs = {
  filters?: InputMaybe<IComponentSourcesSourcesFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IAskAiLogEntityResponseCollection = {
  __typename?: 'AskAiLogEntityResponseCollection'
  nodes: Array<IAskAiLog>
  pageInfo: IPagination
}

export type IAskAiLogFiltersInput = {
  AskAIUserLog?: InputMaybe<IComponentAskAiUserLogAskAiUserLogFiltersInput>
  Cost?: InputMaybe<IJsonFilterInput>
  Identical?: InputMaybe<IComponentIdenticalIdenticalFiltersInput>
  Question?: InputMaybe<IStringFilterInput>
  Rating?: InputMaybe<IComponentAskAiRatingAskAiRatingFiltersInput>
  Response?: InputMaybe<IStringFilterInput>
  Source?: InputMaybe<IComponentSourcesSourcesFiltersInput>
  and?: InputMaybe<Array<InputMaybe<IAskAiLogFiltersInput>>>
  cacheHours?: InputMaybe<IIntFilterInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  not?: InputMaybe<IAskAiLogFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IAskAiLogFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  sendEmail?: InputMaybe<IBooleanFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IAskAiLogInput = {
  AskAIUserLog?: InputMaybe<IComponentAskAiUserLogAskAiUserLogInput>
  Cost?: InputMaybe<Scalars['JSON']['input']>
  Identical?: InputMaybe<Array<InputMaybe<IComponentIdenticalIdenticalInput>>>
  Question?: InputMaybe<Scalars['String']['input']>
  Rating?: InputMaybe<IComponentAskAiRatingAskAiRatingInput>
  Response?: InputMaybe<Scalars['String']['input']>
  Source?: InputMaybe<Array<InputMaybe<IComponentSourcesSourcesInput>>>
  cacheHours?: InputMaybe<Scalars['Int']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>
}

export type IAttribute = {
  __typename?: 'Attribute'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IAttributeEntityResponseCollection = {
  __typename?: 'AttributeEntityResponseCollection'
  nodes: Array<IAttribute>
  pageInfo: IPagination
}

export type IAttributeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IAttributeFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IAttributeFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IAttributeFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IAttributeInput = {
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IAttributeRelationResponseCollection = {
  __typename?: 'AttributeRelationResponseCollection'
  nodes: Array<IAttribute>
}

export type IAudience = {
  __typename?: 'Audience'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IAudienceEntityResponseCollection = {
  __typename?: 'AudienceEntityResponseCollection'
  nodes: Array<IAudience>
  pageInfo: IPagination
}

export type IAudienceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IAudienceFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IAudienceFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IAudienceFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IAudienceInput = {
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IAudienceRelationResponseCollection = {
  __typename?: 'AudienceRelationResponseCollection'
  nodes: Array<IAudience>
}

export type IAuthor = {
  __typename?: 'Author'
  avatar?: Maybe<IUploadFile>
  bio?: Maybe<Scalars['String']['output']>
  company?: Maybe<Scalars['String']['output']>
  contents: Array<Maybe<IContent>>
  contents_connection?: Maybe<IContentRelationResponseCollection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  displayName?: Maybe<Scalars['String']['output']>
  documentId: Scalars['ID']['output']
  firstName: Scalars['String']['output']
  jobTitle?: Maybe<Scalars['String']['output']>
  lastName: Scalars['String']['output']
  linkedin?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  subjectMatters: Array<Maybe<ISubjectMatter>>
  subjectMatters_connection?: Maybe<ISubjectMatterRelationResponseCollection>
  themes: Array<Maybe<ITheme>>
  themes_connection?: Maybe<IThemeRelationResponseCollection>
  twitter?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IAuthorContentsArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IAuthorContents_ConnectionArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IAuthorSubjectMattersArgs = {
  filters?: InputMaybe<ISubjectMatterFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IAuthorSubjectMatters_ConnectionArgs = {
  filters?: InputMaybe<ISubjectMatterFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IAuthorThemesArgs = {
  filters?: InputMaybe<IThemeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IAuthorThemes_ConnectionArgs = {
  filters?: InputMaybe<IThemeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IAuthorEntityResponseCollection = {
  __typename?: 'AuthorEntityResponseCollection'
  nodes: Array<IAuthor>
  pageInfo: IPagination
}

export type IAuthorFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IAuthorFiltersInput>>>
  bio?: InputMaybe<IStringFilterInput>
  company?: InputMaybe<IStringFilterInput>
  contents?: InputMaybe<IContentFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  displayName?: InputMaybe<IStringFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  firstName?: InputMaybe<IStringFilterInput>
  jobTitle?: InputMaybe<IStringFilterInput>
  lastName?: InputMaybe<IStringFilterInput>
  linkedin?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IAuthorFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IAuthorFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  slug?: InputMaybe<IStringFilterInput>
  subjectMatters?: InputMaybe<ISubjectMatterFiltersInput>
  themes?: InputMaybe<IThemeFiltersInput>
  twitter?: InputMaybe<IStringFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IAuthorInput = {
  avatar?: InputMaybe<Scalars['ID']['input']>
  bio?: InputMaybe<Scalars['String']['input']>
  company?: InputMaybe<Scalars['String']['input']>
  contactEmail?: InputMaybe<Scalars['String']['input']>
  contents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  displayName?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  subjectMatters?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  themes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  twitter?: InputMaybe<Scalars['String']['input']>
}

export type IAutosuggestData = {
  __typename?: 'AutosuggestData'
  categories: Array<ISuggest>
  companies: Array<ISuggest>
  contents: Array<ISuggest>
  events: Array<ISuggest>
  isFreeSearch?: Maybe<Scalars['Boolean']['output']>
  solutions: Array<ISuggest>
  success: Scalars['Boolean']['output']
}

export type IBannerAnnouncement = {
  __typename?: 'BannerAnnouncement'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  externalLink: Scalars['String']['output']
  linkButtonLabel?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  title: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IBannerAnnouncementInput = {
  externalLink?: InputMaybe<Scalars['String']['input']>
  linkButtonLabel?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type IBlogTaxonomy = {
  __typename?: 'BlogTaxonomy'
  contents: Array<Maybe<IContent>>
  contents_connection?: Maybe<IContentRelationResponseCollection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  documentId: Scalars['ID']['output']
  latestContent?: Maybe<IContent>
  name?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  showVendorTopics?: Maybe<Scalars['Boolean']['output']>
  slug?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IBlogTaxonomyContentsArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IBlogTaxonomyContents_ConnectionArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IBlogTaxonomyEntityResponseCollection = {
  __typename?: 'BlogTaxonomyEntityResponseCollection'
  nodes: Array<IBlogTaxonomy>
  pageInfo: IPagination
}

export type IBlogTaxonomyFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IBlogTaxonomyFiltersInput>>>
  contents?: InputMaybe<IContentFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  description?: InputMaybe<IStringFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  latestContent?: InputMaybe<IContentFiltersInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IBlogTaxonomyFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IBlogTaxonomyFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  showVendorTopics?: InputMaybe<IBooleanFilterInput>
  slug?: InputMaybe<IStringFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IBlogTaxonomyInput = {
  contents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  description?: InputMaybe<Scalars['String']['input']>
  latestContent?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  showVendorTopics?: InputMaybe<Scalars['Boolean']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
}

export type IBlogTaxonomyRelationResponseCollection = {
  __typename?: 'BlogTaxonomyRelationResponseCollection'
  nodes: Array<IBlogTaxonomy>
}

export type IBooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>
  contains?: InputMaybe<Scalars['Boolean']['input']>
  containsi?: InputMaybe<Scalars['Boolean']['input']>
  endsWith?: InputMaybe<Scalars['Boolean']['input']>
  eq?: InputMaybe<Scalars['Boolean']['input']>
  eqi?: InputMaybe<Scalars['Boolean']['input']>
  gt?: InputMaybe<Scalars['Boolean']['input']>
  gte?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>
  lt?: InputMaybe<Scalars['Boolean']['input']>
  lte?: InputMaybe<Scalars['Boolean']['input']>
  ne?: InputMaybe<Scalars['Boolean']['input']>
  nei?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<IBooleanFilterInput>
  notContains?: InputMaybe<Scalars['Boolean']['input']>
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>
  notNull?: InputMaybe<Scalars['Boolean']['input']>
  null?: InputMaybe<Scalars['Boolean']['input']>
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>
  startsWith?: InputMaybe<Scalars['Boolean']['input']>
}

export type IChangePasswordPayload = {
  __typename?: 'ChangePasswordPayload'
  jwt?: Maybe<Scalars['String']['output']>
  user: IUsersPermissionsMe
}

export type IChangePasswordRequest = {
  confirmPassword: Scalars['String']['input']
  identifier: Scalars['String']['input']
  newPassword: Scalars['String']['input']
  password: Scalars['String']['input']
}

export type ICheckFreeSearchResultType = {
  __typename?: 'CheckFreeSearchResultType'
  isFreeSearch?: Maybe<Scalars['Boolean']['output']>
  isFreeSearchLeft?: Maybe<Scalars['Int']['output']>
}

export type ICollection = {
  __typename?: 'Collection'
  contents: Array<Maybe<IContent>>
  contents_connection?: Maybe<IContentRelationResponseCollection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  documentId: Scalars['ID']['output']
  featuredOnHomepage?: Maybe<Scalars['Boolean']['output']>
  iconName?: Maybe<IUploadFile>
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  solutions: Array<Maybe<ISolution>>
  solutions_connection?: Maybe<ISolutionRelationResponseCollection>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ICollectionContentsArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ICollectionContents_ConnectionArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ICollectionSolutionsArgs = {
  filters?: InputMaybe<ISolutionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ICollectionSolutions_ConnectionArgs = {
  filters?: InputMaybe<ISolutionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ICollectionEntityResponseCollection = {
  __typename?: 'CollectionEntityResponseCollection'
  nodes: Array<ICollection>
  pageInfo: IPagination
}

export type ICollectionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ICollectionFiltersInput>>>
  contents?: InputMaybe<IContentFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  description?: InputMaybe<IStringFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  featuredOnHomepage?: InputMaybe<IBooleanFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<ICollectionFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ICollectionFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  slug?: InputMaybe<IStringFilterInput>
  solutions?: InputMaybe<ISolutionFiltersInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type ICollectionInput = {
  contents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  description?: InputMaybe<Scalars['String']['input']>
  featuredOnHomepage?: InputMaybe<Scalars['Boolean']['input']>
  iconName?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  solutions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type ICollectionRelationResponseCollection = {
  __typename?: 'CollectionRelationResponseCollection'
  nodes: Array<ICollection>
}

export type ICompany = {
  __typename?: 'Company'
  consolidationData?: Maybe<IComponentCompanyCompanyConsolidation>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description: Scalars['String']['output']
  documentId: Scalars['ID']['output']
  founders?: Maybe<Array<Maybe<IComponentCompanyCompanyFounder>>>
  fundingAmount?: Maybe<IEnum_Company_Fundingamount>
  fundingDetails?: Maybe<Scalars['String']['output']>
  fundingInfo?: Maybe<IEnum_Company_Fundinginfo>
  hqs: Array<Maybe<IHq>>
  hqs_connection?: Maybe<IHqRelationResponseCollection>
  iltaSponsorships: Array<Maybe<IIltaSponsorship>>
  iltaSponsorships_connection?: Maybe<IIltaSponsorshipRelationResponseCollection>
  isDiverseLeadership?: Maybe<Scalars['Boolean']['output']>
  linkedin?: Maybe<Scalars['String']['output']>
  logo?: Maybe<IUploadFile>
  name: Scalars['String']['output']
  openToInvestment?: Maybe<Scalars['Boolean']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  regionsServed: Array<Maybe<IRegionsServed>>
  regionsServed_connection?: Maybe<IRegionsServedRelationResponseCollection>
  services?: Maybe<Scalars['String']['output']>
  size?: Maybe<Scalars['Int']['output']>
  slug?: Maybe<Scalars['String']['output']>
  solutions: Array<Maybe<ISolution>>
  solutions_connection?: Maybe<ISolutionRelationResponseCollection>
  twitter?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  website: Scalars['String']['output']
  yearFounded?: Maybe<Scalars['Date']['output']>
}

export type ICompanyFoundersArgs = {
  filters?: InputMaybe<IComponentCompanyCompanyFounderFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ICompanyHqsArgs = {
  filters?: InputMaybe<IHqFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ICompanyHqs_ConnectionArgs = {
  filters?: InputMaybe<IHqFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ICompanyIltaSponsorshipsArgs = {
  filters?: InputMaybe<IIltaSponsorshipFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ICompanyIltaSponsorships_ConnectionArgs = {
  filters?: InputMaybe<IIltaSponsorshipFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ICompanyRegionsServedArgs = {
  filters?: InputMaybe<IRegionsServedFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ICompanyRegionsServed_ConnectionArgs = {
  filters?: InputMaybe<IRegionsServedFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ICompanySolutionsArgs = {
  filters?: InputMaybe<ISolutionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ICompanySolutions_ConnectionArgs = {
  filters?: InputMaybe<ISolutionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ICompanyEntityResponseCollection = {
  __typename?: 'CompanyEntityResponseCollection'
  nodes: Array<ICompany>
  pageInfo: IPagination
}

export type ICompanyFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ICompanyFiltersInput>>>
  consolidationData?: InputMaybe<IComponentCompanyCompanyConsolidationFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  description?: InputMaybe<IStringFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  founders?: InputMaybe<IComponentCompanyCompanyFounderFiltersInput>
  fundingAmount?: InputMaybe<IStringFilterInput>
  fundingDetails?: InputMaybe<IStringFilterInput>
  fundingInfo?: InputMaybe<IStringFilterInput>
  hqs?: InputMaybe<IHqFiltersInput>
  iltaSponsorships?: InputMaybe<IIltaSponsorshipFiltersInput>
  isDiverseLeadership?: InputMaybe<IBooleanFilterInput>
  linkedin?: InputMaybe<IStringFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<ICompanyFiltersInput>
  openToInvestment?: InputMaybe<IBooleanFilterInput>
  or?: InputMaybe<Array<InputMaybe<ICompanyFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  regionsServed?: InputMaybe<IRegionsServedFiltersInput>
  services?: InputMaybe<IStringFilterInput>
  size?: InputMaybe<IIntFilterInput>
  slug?: InputMaybe<IStringFilterInput>
  solutions?: InputMaybe<ISolutionFiltersInput>
  twitter?: InputMaybe<IStringFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
  website?: InputMaybe<IStringFilterInput>
  yearFounded?: InputMaybe<IDateFilterInput>
}

export type ICompanyInput = {
  consolidationData?: InputMaybe<IComponentCompanyCompanyConsolidationInput>
  description?: InputMaybe<Scalars['String']['input']>
  firstPublishAt?: InputMaybe<Scalars['DateTime']['input']>
  founders?: InputMaybe<Array<InputMaybe<IComponentCompanyCompanyFounderInput>>>
  fundingAmount?: InputMaybe<IEnum_Company_Fundingamount>
  fundingDetails?: InputMaybe<Scalars['String']['input']>
  fundingInfo?: InputMaybe<IEnum_Company_Fundinginfo>
  hqs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  iltaSponsorships?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  isDiverseLeadership?: InputMaybe<Scalars['Boolean']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  logo?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  openToInvestment?: InputMaybe<Scalars['Boolean']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  regionsServed?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  services?: InputMaybe<Scalars['String']['input']>
  size?: InputMaybe<Scalars['Int']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  solutions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  twitter?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  yearFounded?: InputMaybe<Scalars['Date']['input']>
}

export type ICompanyRelationResponseCollection = {
  __typename?: 'CompanyRelationResponseCollection'
  nodes: Array<ICompany>
}

export type IComponentAboutPropsTeamMember = {
  __typename?: 'ComponentAboutPropsTeamMember'
  avatar?: Maybe<IUploadFile>
  bio?: Maybe<Scalars['String']['output']>
  externalLink?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  role?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type IComponentAboutPropsTeamMemberFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>>>
  bio?: InputMaybe<IStringFilterInput>
  externalLink?: InputMaybe<IStringFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>>>
  role?: InputMaybe<IStringFilterInput>
  title?: InputMaybe<IStringFilterInput>
}

export type IComponentAboutPropsTeamMemberInput = {
  avatar?: InputMaybe<Scalars['ID']['input']>
  bio?: InputMaybe<Scalars['String']['input']>
  externalLink?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  role?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type IComponentAlspPropsAlspEnhanced = {
  __typename?: 'ComponentAlspPropsAlspEnhanced'
  callToAction?: Maybe<IComponentGlobalCallToAction>
  dedicatedResources?: Maybe<Array<Maybe<IComponentConPropsDedicatedResource>>>
  engagementLen?: Maybe<Scalars['Int']['output']>
  founders?: Maybe<Array<Maybe<IComponentAboutPropsTeamMember>>>
  id: Scalars['ID']['output']
  pricing?: Maybe<Array<Maybe<IComponentGlobalPricingModel>>>
  pricingData?: Maybe<Scalars['String']['output']>
  screenshots?: Maybe<Array<Maybe<IComponentGlobalPicture>>>
  serviceBreakdown?: Maybe<Scalars['String']['output']>
  specialists?: Maybe<Array<Maybe<IComponentAboutPropsTeamMember>>>
  stories?: Maybe<Array<Maybe<IComponentGlobalSuccessStory>>>
  technology?: Maybe<Scalars['String']['output']>
  testimonials?: Maybe<Array<Maybe<IComponentGlobalTestimonial>>>
  valueProposition?: Maybe<Scalars['String']['output']>
  vendorResources?: Maybe<Array<Maybe<IComponentVendorPropsPoC>>>
  videos?: Maybe<Array<Maybe<IComponentVendorPropsVideo>>>
}

export type IComponentAlspPropsAlspEnhancedDedicatedResourcesArgs = {
  filters?: InputMaybe<IComponentConPropsDedicatedResourceFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentAlspPropsAlspEnhancedFoundersArgs = {
  filters?: InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentAlspPropsAlspEnhancedPricingArgs = {
  filters?: InputMaybe<IComponentGlobalPricingModelFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentAlspPropsAlspEnhancedScreenshotsArgs = {
  filters?: InputMaybe<IComponentGlobalPictureFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentAlspPropsAlspEnhancedSpecialistsArgs = {
  filters?: InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentAlspPropsAlspEnhancedStoriesArgs = {
  filters?: InputMaybe<IComponentGlobalSuccessStoryFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentAlspPropsAlspEnhancedTestimonialsArgs = {
  filters?: InputMaybe<IComponentGlobalTestimonialFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentAlspPropsAlspEnhancedVendorResourcesArgs = {
  filters?: InputMaybe<IComponentVendorPropsPoCFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentAlspPropsAlspEnhancedVideosArgs = {
  filters?: InputMaybe<IComponentVendorPropsVideoFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentAskAiRatingAskAiRating = {
  __typename?: 'ComponentAskAiRatingAskAiRating'
  User?: Maybe<IUser>
  feedback?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  rating?: Maybe<Scalars['String']['output']>
}

export type IComponentAskAiRatingAskAiRatingFiltersInput = {
  User?: InputMaybe<IUserFiltersInput>
  and?: InputMaybe<Array<InputMaybe<IComponentAskAiRatingAskAiRatingFiltersInput>>>
  feedback?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentAskAiRatingAskAiRatingFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentAskAiRatingAskAiRatingFiltersInput>>>
  rating?: InputMaybe<IStringFilterInput>
}

export type IComponentAskAiRatingAskAiRatingInput = {
  User?: InputMaybe<Scalars['ID']['input']>
  feedback?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  rating?: InputMaybe<Scalars['String']['input']>
}

export type IComponentAskAiUserLogAskAiUserLog = {
  __typename?: 'ComponentAskAiUserLogAskAiUserLog'
  Fingerprint?: Maybe<Scalars['String']['output']>
  IpAddress?: Maybe<Scalars['String']['output']>
  RequestId?: Maybe<Scalars['String']['output']>
  User?: Maybe<IUser>
  id: Scalars['ID']['output']
}

export type IComponentAskAiUserLogAskAiUserLogFiltersInput = {
  Fingerprint?: InputMaybe<IStringFilterInput>
  IpAddress?: InputMaybe<IStringFilterInput>
  RequestId?: InputMaybe<IStringFilterInput>
  User?: InputMaybe<IUserFiltersInput>
  and?: InputMaybe<Array<InputMaybe<IComponentAskAiUserLogAskAiUserLogFiltersInput>>>
  not?: InputMaybe<IComponentAskAiUserLogAskAiUserLogFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentAskAiUserLogAskAiUserLogFiltersInput>>>
}

export type IComponentAskAiUserLogAskAiUserLogInput = {
  Fingerprint?: InputMaybe<Scalars['String']['input']>
  IpAddress?: InputMaybe<Scalars['String']['input']>
  RequestId?: InputMaybe<Scalars['String']['input']>
  User?: InputMaybe<Scalars['ID']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
}

export type IComponentBillingAddressBillingAddress = {
  __typename?: 'ComponentBillingAddressBillingAddress'
  addressLine1: Scalars['String']['output']
  addressLine2?: Maybe<Scalars['String']['output']>
  city: Scalars['String']['output']
  country?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  state?: Maybe<Scalars['String']['output']>
  zipcode: Scalars['String']['output']
}

export type IComponentBillingAddressBillingAddressFiltersInput = {
  addressLine1?: InputMaybe<IStringFilterInput>
  addressLine2?: InputMaybe<IStringFilterInput>
  and?: InputMaybe<Array<InputMaybe<IComponentBillingAddressBillingAddressFiltersInput>>>
  city?: InputMaybe<IStringFilterInput>
  country?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentBillingAddressBillingAddressFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentBillingAddressBillingAddressFiltersInput>>>
  state?: InputMaybe<IStringFilterInput>
  zipcode?: InputMaybe<IStringFilterInput>
}

export type IComponentBillingAddressBillingAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>
  addressLine2?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  zipcode?: InputMaybe<Scalars['String']['input']>
}

export type IComponentCompanyCompanyConsolidation = {
  __typename?: 'ComponentCompanyCompanyConsolidation'
  amount?: Maybe<Scalars['Int']['output']>
  article?: Maybe<Scalars['String']['output']>
  articleLink?: Maybe<Scalars['String']['output']>
  buyer?: Maybe<Scalars['String']['output']>
  date?: Maybe<Scalars['Date']['output']>
  enableInActiveDir?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  originalTargetName?: Maybe<Scalars['String']['output']>
}

export type IComponentCompanyCompanyConsolidationFiltersInput = {
  amount?: InputMaybe<IIntFilterInput>
  and?: InputMaybe<Array<InputMaybe<IComponentCompanyCompanyConsolidationFiltersInput>>>
  article?: InputMaybe<IStringFilterInput>
  articleLink?: InputMaybe<IStringFilterInput>
  buyer?: InputMaybe<IStringFilterInput>
  date?: InputMaybe<IDateFilterInput>
  enableInActiveDir?: InputMaybe<IBooleanFilterInput>
  not?: InputMaybe<IComponentCompanyCompanyConsolidationFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentCompanyCompanyConsolidationFiltersInput>>>
  originalTargetName?: InputMaybe<IStringFilterInput>
}

export type IComponentCompanyCompanyConsolidationInput = {
  amount?: InputMaybe<Scalars['Int']['input']>
  article?: InputMaybe<Scalars['String']['input']>
  articleLink?: InputMaybe<Scalars['String']['input']>
  buyer?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['Date']['input']>
  enableInActiveDir?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  originalTargetName?: InputMaybe<Scalars['String']['input']>
}

export type IComponentCompanyCompanyFounder = {
  __typename?: 'ComponentCompanyCompanyFounder'
  avatar?: Maybe<IUploadFile>
  bio?: Maybe<Scalars['String']['output']>
  experiencedFounder?: Maybe<Scalars['Boolean']['output']>
  externalLink?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  role?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type IComponentCompanyCompanyFounderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentCompanyCompanyFounderFiltersInput>>>
  bio?: InputMaybe<IStringFilterInput>
  experiencedFounder?: InputMaybe<IBooleanFilterInput>
  externalLink?: InputMaybe<IStringFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentCompanyCompanyFounderFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentCompanyCompanyFounderFiltersInput>>>
  role?: InputMaybe<IStringFilterInput>
  title?: InputMaybe<IStringFilterInput>
}

export type IComponentCompanyCompanyFounderInput = {
  avatar?: InputMaybe<Scalars['ID']['input']>
  bio?: InputMaybe<Scalars['String']['input']>
  experiencedFounder?: InputMaybe<Scalars['Boolean']['input']>
  externalLink?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  role?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type IComponentConPropsConEnhancedListing = {
  __typename?: 'ComponentConPropsConEnhancedListing'
  callToAction?: Maybe<IComponentGlobalCallToAction>
  dedicatedResources?: Maybe<Array<Maybe<IComponentConPropsDedicatedResource>>>
  engagementLen?: Maybe<Scalars['Int']['output']>
  founders?: Maybe<Array<Maybe<IComponentAboutPropsTeamMember>>>
  id: Scalars['ID']['output']
  pricing?: Maybe<Array<Maybe<IComponentGlobalPricingModel>>>
  pricingData?: Maybe<Scalars['String']['output']>
  screenshots?: Maybe<Array<Maybe<IComponentGlobalPicture>>>
  serviceBreakdown?: Maybe<Scalars['String']['output']>
  specialists?: Maybe<Array<Maybe<IComponentAboutPropsTeamMember>>>
  stories?: Maybe<Array<Maybe<IComponentGlobalSuccessStory>>>
  testimonials?: Maybe<Array<Maybe<IComponentGlobalTestimonial>>>
  valueProposition?: Maybe<Scalars['String']['output']>
  vendorResources?: Maybe<Array<Maybe<IComponentVendorPropsPoC>>>
  videos?: Maybe<Array<Maybe<IComponentVendorPropsVideo>>>
}

export type IComponentConPropsConEnhancedListingDedicatedResourcesArgs = {
  filters?: InputMaybe<IComponentConPropsDedicatedResourceFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentConPropsConEnhancedListingFoundersArgs = {
  filters?: InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentConPropsConEnhancedListingPricingArgs = {
  filters?: InputMaybe<IComponentGlobalPricingModelFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentConPropsConEnhancedListingScreenshotsArgs = {
  filters?: InputMaybe<IComponentGlobalPictureFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentConPropsConEnhancedListingSpecialistsArgs = {
  filters?: InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentConPropsConEnhancedListingStoriesArgs = {
  filters?: InputMaybe<IComponentGlobalSuccessStoryFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentConPropsConEnhancedListingTestimonialsArgs = {
  filters?: InputMaybe<IComponentGlobalTestimonialFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentConPropsConEnhancedListingVendorResourcesArgs = {
  filters?: InputMaybe<IComponentVendorPropsPoCFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentConPropsConEnhancedListingVideosArgs = {
  filters?: InputMaybe<IComponentVendorPropsVideoFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentConPropsDedicatedResource = {
  __typename?: 'ComponentConPropsDedicatedResource'
  count?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  type?: Maybe<IEnum_Componentconpropsdedicatedresource_Type>
}

export type IComponentConPropsDedicatedResourceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentConPropsDedicatedResourceFiltersInput>>>
  count?: InputMaybe<IIntFilterInput>
  not?: InputMaybe<IComponentConPropsDedicatedResourceFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentConPropsDedicatedResourceFiltersInput>>>
  type?: InputMaybe<IStringFilterInput>
}

export type IComponentConPropsDedicatedResourceInput = {
  count?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  type?: InputMaybe<IEnum_Componentconpropsdedicatedresource_Type>
}

export type IComponentContentContentWriter = {
  __typename?: 'ComponentContentContentWriter'
  author?: Maybe<IAuthor>
  expert?: Maybe<IExpert>
  id: Scalars['ID']['output']
  oneTimeAuthorName?: Maybe<Scalars['String']['output']>
  solution?: Maybe<ISolution>
  writerOption: IEnum_Componentcontentcontentwriter_Writeroption
}

export type IComponentContentContentWriterFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentContentContentWriterFiltersInput>>>
  author?: InputMaybe<IAuthorFiltersInput>
  expert?: InputMaybe<IExpertFiltersInput>
  not?: InputMaybe<IComponentContentContentWriterFiltersInput>
  oneTimeAuthorName?: InputMaybe<IStringFilterInput>
  or?: InputMaybe<Array<InputMaybe<IComponentContentContentWriterFiltersInput>>>
  solution?: InputMaybe<ISolutionFiltersInput>
  writerOption?: InputMaybe<IStringFilterInput>
}

export type IComponentContentContentWriterInput = {
  author?: InputMaybe<Scalars['ID']['input']>
  expert?: InputMaybe<Scalars['ID']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  oneTimeAuthorName?: InputMaybe<Scalars['String']['input']>
  solution?: InputMaybe<Scalars['ID']['input']>
  writerOption?: InputMaybe<IEnum_Componentcontentcontentwriter_Writeroption>
}

export type IComponentContentDownloadMaterial = {
  __typename?: 'ComponentContentDownloadMaterial'
  downloadButtonName?: Maybe<Scalars['String']['output']>
  files?: Maybe<IUploadFile>
  format?: Maybe<IEnum_Componentcontentdownloadmaterial_Format>
  id: Scalars['ID']['output']
  isEnabled?: Maybe<Scalars['Boolean']['output']>
  lastUpdated?: Maybe<Scalars['Date']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type IComponentContentDownloadMaterialFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentContentDownloadMaterialFiltersInput>>>
  downloadButtonName?: InputMaybe<IStringFilterInput>
  format?: InputMaybe<IStringFilterInput>
  isEnabled?: InputMaybe<IBooleanFilterInput>
  lastUpdated?: InputMaybe<IDateFilterInput>
  not?: InputMaybe<IComponentContentDownloadMaterialFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentContentDownloadMaterialFiltersInput>>>
  title?: InputMaybe<IStringFilterInput>
}

export type IComponentContentDownloadMaterialInput = {
  downloadButtonName?: InputMaybe<Scalars['String']['input']>
  files?: InputMaybe<Scalars['ID']['input']>
  format?: InputMaybe<IEnum_Componentcontentdownloadmaterial_Format>
  id?: InputMaybe<Scalars['ID']['input']>
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>
  lastUpdated?: InputMaybe<Scalars['Date']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type IComponentContentFeaturedCategories = {
  __typename?: 'ComponentContentFeaturedCategories'
  id: Scalars['ID']['output']
  subTopics: Array<Maybe<ISubTopic>>
  subTopics_connection?: Maybe<ISubTopicRelationResponseCollection>
  topics: Array<Maybe<ITopic>>
  topics_connection?: Maybe<ITopicRelationResponseCollection>
}

export type IComponentContentFeaturedCategoriesSubTopicsArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentContentFeaturedCategoriesSubTopics_ConnectionArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentContentFeaturedCategoriesTopicsArgs = {
  filters?: InputMaybe<ITopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentContentFeaturedCategoriesTopics_ConnectionArgs = {
  filters?: InputMaybe<ITopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentContentFeaturedCategoriesInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  subTopics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  topics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type IComponentFollowingSolutionsData = {
  __typename?: 'ComponentFollowingSolutionsData'
  followingSolutionNote?: Maybe<Scalars['String']['output']>
  followingType?: Maybe<Scalars['String']['output']>
  noteCreatedAt?: Maybe<Scalars['String']['output']>
  noteCreatedByName?: Maybe<Scalars['String']['output']>
  noteLastEditedAt?: Maybe<Scalars['String']['output']>
  noteLastEditedByName?: Maybe<Scalars['String']['output']>
}

export type IComponentGlobalArticle = {
  __typename?: 'ComponentGlobalArticle'
  date?: Maybe<Scalars['Date']['output']>
  id: Scalars['ID']['output']
  image?: Maybe<IUploadFile>
  link?: Maybe<Scalars['String']['output']>
  publishedBy?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type IComponentGlobalArticleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentGlobalArticleFiltersInput>>>
  date?: InputMaybe<IDateFilterInput>
  link?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentGlobalArticleFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentGlobalArticleFiltersInput>>>
  publishedBy?: InputMaybe<IStringFilterInput>
  title?: InputMaybe<IStringFilterInput>
}

export type IComponentGlobalArticleInput = {
  date?: InputMaybe<Scalars['Date']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<Scalars['ID']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  publishedBy?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type IComponentGlobalCallToAction = {
  __typename?: 'ComponentGlobalCallToAction'
  id: Scalars['ID']['output']
  label?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type IComponentGlobalCallToActionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentGlobalCallToActionFiltersInput>>>
  label?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentGlobalCallToActionFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentGlobalCallToActionFiltersInput>>>
  url?: InputMaybe<IStringFilterInput>
}

export type IComponentGlobalCallToActionInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type IComponentGlobalPicture = {
  __typename?: 'ComponentGlobalPicture'
  id: Scalars['ID']['output']
  image?: Maybe<IUploadFile>
  summary?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type IComponentGlobalPictureFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentGlobalPictureFiltersInput>>>
  not?: InputMaybe<IComponentGlobalPictureFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentGlobalPictureFiltersInput>>>
  summary?: InputMaybe<IStringFilterInput>
  title?: InputMaybe<IStringFilterInput>
}

export type IComponentGlobalPictureInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<Scalars['ID']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type IComponentGlobalPricingModel = {
  __typename?: 'ComponentGlobalPricingModel'
  exampleTypeAccount?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  pricingModel?: Maybe<Scalars['String']['output']>
  startPrice?: Maybe<Scalars['Int']['output']>
}

export type IComponentGlobalPricingModelFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentGlobalPricingModelFiltersInput>>>
  exampleTypeAccount?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentGlobalPricingModelFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentGlobalPricingModelFiltersInput>>>
  pricingModel?: InputMaybe<IStringFilterInput>
  startPrice?: InputMaybe<IIntFilterInput>
}

export type IComponentGlobalSuccessStory = {
  __typename?: 'ComponentGlobalSuccessStory'
  id: Scalars['ID']['output']
  link?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type IComponentGlobalSuccessStoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentGlobalSuccessStoryFiltersInput>>>
  link?: InputMaybe<IStringFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentGlobalSuccessStoryFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentGlobalSuccessStoryFiltersInput>>>
}

export type IComponentGlobalSuccessStoryInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type IComponentGlobalTestimonial = {
  __typename?: 'ComponentGlobalTestimonial'
  avatar?: Maybe<IUploadFile>
  company?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  role?: Maybe<Scalars['String']['output']>
}

export type IComponentGlobalTestimonialFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentGlobalTestimonialFiltersInput>>>
  company?: InputMaybe<IStringFilterInput>
  description?: InputMaybe<IStringFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentGlobalTestimonialFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentGlobalTestimonialFiltersInput>>>
  role?: InputMaybe<IStringFilterInput>
}

export type IComponentGlobalTestimonialInput = {
  avatar?: InputMaybe<Scalars['ID']['input']>
  company?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  role?: InputMaybe<Scalars['String']['input']>
}

export type IComponentIdenticalIdentical = {
  __typename?: 'ComponentIdenticalIdentical'
  AskAIUserLog?: Maybe<IComponentAskAiUserLogAskAiUserLog>
  Question?: Maybe<Scalars['String']['output']>
  Rating?: Maybe<IComponentAskAiRatingAskAiRating>
  id: Scalars['ID']['output']
  similarityScore?: Maybe<Scalars['Float']['output']>
}

export type IComponentIdenticalIdenticalFiltersInput = {
  AskAIUserLog?: InputMaybe<IComponentAskAiUserLogAskAiUserLogFiltersInput>
  Question?: InputMaybe<IStringFilterInput>
  Rating?: InputMaybe<IComponentAskAiRatingAskAiRatingFiltersInput>
  and?: InputMaybe<Array<InputMaybe<IComponentIdenticalIdenticalFiltersInput>>>
  not?: InputMaybe<IComponentIdenticalIdenticalFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentIdenticalIdenticalFiltersInput>>>
  similarityScore?: InputMaybe<IFloatFilterInput>
}

export type IComponentIdenticalIdenticalInput = {
  AskAIUserLog?: InputMaybe<IComponentAskAiUserLogAskAiUserLogInput>
  Question?: InputMaybe<Scalars['String']['input']>
  Rating?: InputMaybe<IComponentAskAiRatingAskAiRatingInput>
  id?: InputMaybe<Scalars['ID']['input']>
  similarityScore?: InputMaybe<Scalars['Float']['input']>
}

export type IComponentInvitationsInvitations = {
  __typename?: 'ComponentInvitationsInvitations'
  email: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  status?: Maybe<IEnum_Componentinvitationsinvitations_Status>
}

export type IComponentInvitationsInvitationsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentInvitationsInvitationsFiltersInput>>>
  email?: InputMaybe<IStringFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentInvitationsInvitationsFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentInvitationsInvitationsFiltersInput>>>
  status?: InputMaybe<IStringFilterInput>
}

export type IComponentInvitationsInvitationsInput = {
  email?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<IEnum_Componentinvitationsinvitations_Status>
  token?: InputMaybe<Scalars['String']['input']>
  tokenExpired?: InputMaybe<Scalars['Boolean']['input']>
}

export type IComponentRegistrationContactRegistrationContact = {
  __typename?: 'ComponentRegistrationContactRegistrationContact'
  email: Scalars['String']['output']
  id: Scalars['ID']['output']
  jobTitle: Scalars['String']['output']
  name: Scalars['String']['output']
  phone?: Maybe<Scalars['String']['output']>
}

export type IComponentRegistrationContactRegistrationContactFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentRegistrationContactRegistrationContactFiltersInput>>>
  email?: InputMaybe<IStringFilterInput>
  jobTitle?: InputMaybe<IStringFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentRegistrationContactRegistrationContactFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentRegistrationContactRegistrationContactFiltersInput>>>
  phone?: InputMaybe<IStringFilterInput>
}

export type IComponentRegistrationContactRegistrationContactInput = {
  email?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  token?: InputMaybe<Scalars['String']['input']>
  tokenExpired?: InputMaybe<Scalars['Boolean']['input']>
}

export type IComponentRequestEnhancedListReq = {
  __typename?: 'ComponentRequestEnhancedListReq'
  callToActionText?: Maybe<Scalars['String']['output']>
  callToActionUrl?: Maybe<Scalars['String']['output']>
  competitor?: Maybe<Scalars['String']['output']>
  dedicatedResources?: Maybe<Array<Maybe<IComponentConPropsDedicatedResource>>>
  engagementLen?: Maybe<Scalars['Int']['output']>
  founders?: Maybe<Array<Maybe<IComponentAboutPropsTeamMember>>>
  id: Scalars['ID']['output']
  pricingData?: Maybe<Scalars['String']['output']>
  productVideos?: Maybe<Array<Maybe<IComponentVendorPropsVideo>>>
  screenShots?: Maybe<Array<Maybe<IComponentGlobalPicture>>>
  serviceBreakdown?: Maybe<Scalars['String']['output']>
  specialists?: Maybe<Array<Maybe<IComponentAboutPropsTeamMember>>>
  technology?: Maybe<Scalars['String']['output']>
  testimonials?: Maybe<Array<Maybe<IComponentGlobalTestimonial>>>
  valueProposition?: Maybe<Scalars['String']['output']>
  vendorResources?: Maybe<Array<Maybe<IComponentVendorPropsPoC>>>
}

export type IComponentRequestEnhancedListReqDedicatedResourcesArgs = {
  filters?: InputMaybe<IComponentConPropsDedicatedResourceFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestEnhancedListReqFoundersArgs = {
  filters?: InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestEnhancedListReqProductVideosArgs = {
  filters?: InputMaybe<IComponentVendorPropsVideoFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestEnhancedListReqScreenShotsArgs = {
  filters?: InputMaybe<IComponentGlobalPictureFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestEnhancedListReqSpecialistsArgs = {
  filters?: InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestEnhancedListReqTestimonialsArgs = {
  filters?: InputMaybe<IComponentGlobalTestimonialFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestEnhancedListReqVendorResourcesArgs = {
  filters?: InputMaybe<IComponentVendorPropsPoCFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestEnhancedListReqFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentRequestEnhancedListReqFiltersInput>>>
  callToActionText?: InputMaybe<IStringFilterInput>
  callToActionUrl?: InputMaybe<IStringFilterInput>
  competitor?: InputMaybe<IStringFilterInput>
  dedicatedResources?: InputMaybe<IComponentConPropsDedicatedResourceFiltersInput>
  engagementLen?: InputMaybe<IIntFilterInput>
  founders?: InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>
  not?: InputMaybe<IComponentRequestEnhancedListReqFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentRequestEnhancedListReqFiltersInput>>>
  pricingData?: InputMaybe<IStringFilterInput>
  productVideos?: InputMaybe<IComponentVendorPropsVideoFiltersInput>
  screenShots?: InputMaybe<IComponentGlobalPictureFiltersInput>
  serviceBreakdown?: InputMaybe<IStringFilterInput>
  specialists?: InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>
  technology?: InputMaybe<IStringFilterInput>
  testimonials?: InputMaybe<IComponentGlobalTestimonialFiltersInput>
  valueProposition?: InputMaybe<IStringFilterInput>
  vendorResources?: InputMaybe<IComponentVendorPropsPoCFiltersInput>
}

export type IComponentRequestEnhancedListReqInput = {
  callToActionText?: InputMaybe<Scalars['String']['input']>
  callToActionUrl?: InputMaybe<Scalars['String']['input']>
  competitor?: InputMaybe<Scalars['String']['input']>
  dedicatedResources?: InputMaybe<Array<InputMaybe<IComponentConPropsDedicatedResourceInput>>>
  engagementLen?: InputMaybe<Scalars['Int']['input']>
  founders?: InputMaybe<Array<InputMaybe<IComponentAboutPropsTeamMemberInput>>>
  id?: InputMaybe<Scalars['ID']['input']>
  pricingData?: InputMaybe<Scalars['String']['input']>
  productVideos?: InputMaybe<Array<InputMaybe<IComponentVendorPropsVideoInput>>>
  screenShots?: InputMaybe<Array<InputMaybe<IComponentGlobalPictureInput>>>
  serviceBreakdown?: InputMaybe<Scalars['String']['input']>
  specialists?: InputMaybe<Array<InputMaybe<IComponentAboutPropsTeamMemberInput>>>
  technology?: InputMaybe<Scalars['String']['input']>
  testimonials?: InputMaybe<Array<InputMaybe<IComponentGlobalTestimonialInput>>>
  valueProposition?: InputMaybe<Scalars['String']['input']>
  vendorResources?: InputMaybe<Array<InputMaybe<IComponentVendorPropsPoCInput>>>
}

export type IComponentRequestEnhancedVendorReq = {
  __typename?: 'ComponentRequestEnhancedVendorReq'
  callToActionText?: Maybe<Scalars['String']['output']>
  callToActionUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  pricingData?: Maybe<Scalars['String']['output']>
  productVideos?: Maybe<Array<Maybe<IComponentVendorPropsVideo>>>
  screenShots?: Maybe<Array<Maybe<IComponentGlobalPicture>>>
  testimonials?: Maybe<Array<Maybe<IComponentGlobalTestimonial>>>
  vendorResources?: Maybe<Array<Maybe<IComponentVendorPropsPoC>>>
}

export type IComponentRequestEnhancedVendorReqProductVideosArgs = {
  filters?: InputMaybe<IComponentVendorPropsVideoFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestEnhancedVendorReqScreenShotsArgs = {
  filters?: InputMaybe<IComponentGlobalPictureFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestEnhancedVendorReqTestimonialsArgs = {
  filters?: InputMaybe<IComponentGlobalTestimonialFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestEnhancedVendorReqVendorResourcesArgs = {
  filters?: InputMaybe<IComponentVendorPropsPoCFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestEnhancedVendorReqFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentRequestEnhancedVendorReqFiltersInput>>>
  callToActionText?: InputMaybe<IStringFilterInput>
  callToActionUrl?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentRequestEnhancedVendorReqFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentRequestEnhancedVendorReqFiltersInput>>>
  pricingData?: InputMaybe<IStringFilterInput>
  productVideos?: InputMaybe<IComponentVendorPropsVideoFiltersInput>
  screenShots?: InputMaybe<IComponentGlobalPictureFiltersInput>
  testimonials?: InputMaybe<IComponentGlobalTestimonialFiltersInput>
  vendorResources?: InputMaybe<IComponentVendorPropsPoCFiltersInput>
}

export type IComponentRequestEnhancedVendorReqInput = {
  callToActionText?: InputMaybe<Scalars['String']['input']>
  callToActionUrl?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  pricingData?: InputMaybe<Scalars['String']['input']>
  productVideos?: InputMaybe<Array<InputMaybe<IComponentVendorPropsVideoInput>>>
  screenShots?: InputMaybe<Array<InputMaybe<IComponentGlobalPictureInput>>>
  testimonials?: InputMaybe<Array<InputMaybe<IComponentGlobalTestimonialInput>>>
  vendorResources?: InputMaybe<Array<InputMaybe<IComponentVendorPropsPoCInput>>>
}

export type IComponentRequestListingReq = {
  __typename?: 'ComponentRequestListingReq'
  audiences: Array<Maybe<IDemographic>>
  audiences_connection?: Maybe<IDemographicRelationResponseCollection>
  ceoEmail?: Maybe<Scalars['String']['output']>
  ceoName?: Maybe<Scalars['String']['output']>
  hqs: Array<Maybe<IHq>>
  hqs_connection?: Maybe<IHqRelationResponseCollection>
  id: Scalars['ID']['output']
  isCreate?: Maybe<Scalars['Boolean']['output']>
  languages: Array<Maybe<IPlatformLanguage>>
  languages_connection?: Maybe<IPlatformLanguageRelationResponseCollection>
  listingName?: Maybe<Scalars['String']['output']>
  logo?: Maybe<IUploadFile>
  longDescription?: Maybe<Scalars['String']['output']>
  marketEmail?: Maybe<Scalars['String']['output']>
  marketName?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  offices: Array<Maybe<IOffice>>
  offices_connection?: Maybe<IOfficeRelationResponseCollection>
  partners?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  regionsServed: Array<Maybe<IRegionsServed>>
  regionsServed_connection?: Maybe<IRegionsServedRelationResponseCollection>
  serviceName?: Maybe<Scalars['String']['output']>
  serviceOfferings: Array<Maybe<ISubTopic>>
  serviceOfferings_connection?: Maybe<ISubTopicRelationResponseCollection>
  shortDescription?: Maybe<Scalars['String']['output']>
  size?: Maybe<Scalars['Int']['output']>
  userEmail?: Maybe<Scalars['String']['output']>
  userName?: Maybe<Scalars['String']['output']>
  userRole?: Maybe<Scalars['String']['output']>
  website?: Maybe<Scalars['String']['output']>
  yearFounded?: Maybe<Scalars['Int']['output']>
}

export type IComponentRequestListingReqAudiencesArgs = {
  filters?: InputMaybe<IDemographicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestListingReqAudiences_ConnectionArgs = {
  filters?: InputMaybe<IDemographicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestListingReqHqsArgs = {
  filters?: InputMaybe<IHqFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestListingReqHqs_ConnectionArgs = {
  filters?: InputMaybe<IHqFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestListingReqLanguagesArgs = {
  filters?: InputMaybe<IPlatformLanguageFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestListingReqLanguages_ConnectionArgs = {
  filters?: InputMaybe<IPlatformLanguageFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestListingReqOfficesArgs = {
  filters?: InputMaybe<IOfficeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestListingReqOffices_ConnectionArgs = {
  filters?: InputMaybe<IOfficeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestListingReqRegionsServedArgs = {
  filters?: InputMaybe<IRegionsServedFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestListingReqRegionsServed_ConnectionArgs = {
  filters?: InputMaybe<IRegionsServedFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestListingReqServiceOfferingsArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestListingReqServiceOfferings_ConnectionArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestListingReqFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentRequestListingReqFiltersInput>>>
  audiences?: InputMaybe<IDemographicFiltersInput>
  ceoEmail?: InputMaybe<IStringFilterInput>
  ceoName?: InputMaybe<IStringFilterInput>
  hqs?: InputMaybe<IHqFiltersInput>
  isCreate?: InputMaybe<IBooleanFilterInput>
  languages?: InputMaybe<IPlatformLanguageFiltersInput>
  listingName?: InputMaybe<IStringFilterInput>
  longDescription?: InputMaybe<IStringFilterInput>
  marketEmail?: InputMaybe<IStringFilterInput>
  marketName?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentRequestListingReqFiltersInput>
  notes?: InputMaybe<IStringFilterInput>
  offices?: InputMaybe<IOfficeFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentRequestListingReqFiltersInput>>>
  partners?: InputMaybe<IStringFilterInput>
  phone?: InputMaybe<IStringFilterInput>
  regionsServed?: InputMaybe<IRegionsServedFiltersInput>
  serviceName?: InputMaybe<IStringFilterInput>
  serviceOfferings?: InputMaybe<ISubTopicFiltersInput>
  shortDescription?: InputMaybe<IStringFilterInput>
  size?: InputMaybe<IIntFilterInput>
  userEmail?: InputMaybe<IStringFilterInput>
  userName?: InputMaybe<IStringFilterInput>
  userRole?: InputMaybe<IStringFilterInput>
  website?: InputMaybe<IStringFilterInput>
  yearFounded?: InputMaybe<IIntFilterInput>
}

export type IComponentRequestListingReqInput = {
  audiences?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  ceoEmail?: InputMaybe<Scalars['String']['input']>
  ceoName?: InputMaybe<Scalars['String']['input']>
  hqs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  id?: InputMaybe<Scalars['ID']['input']>
  isCreate?: InputMaybe<Scalars['Boolean']['input']>
  languages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  listingName?: InputMaybe<Scalars['String']['input']>
  logo?: InputMaybe<Scalars['ID']['input']>
  longDescription?: InputMaybe<Scalars['String']['input']>
  marketEmail?: InputMaybe<Scalars['String']['input']>
  marketName?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  offices?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  partners?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  regionsServed?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  serviceName?: InputMaybe<Scalars['String']['input']>
  serviceOfferings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  shortDescription?: InputMaybe<Scalars['String']['input']>
  size?: InputMaybe<Scalars['Int']['input']>
  userEmail?: InputMaybe<Scalars['String']['input']>
  userName?: InputMaybe<Scalars['String']['input']>
  userRole?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  yearFounded?: InputMaybe<Scalars['Int']['input']>
}

export type IComponentRequestVendorReq = {
  __typename?: 'ComponentRequestVendorReq'
  audiences: Array<Maybe<IDemographic>>
  audiences_connection?: Maybe<IDemographicRelationResponseCollection>
  ceoEmail?: Maybe<Scalars['String']['output']>
  ceoName?: Maybe<Scalars['String']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  competitor?: Maybe<Scalars['String']['output']>
  deployments: Array<Maybe<IInstallation>>
  deployments_connection?: Maybe<IInstallationRelationResponseCollection>
  descOtherExistingCustomer?: Maybe<Scalars['String']['output']>
  descOtherIntegration?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  existingCustomers: Array<Maybe<IExistingCustomer>>
  existingCustomers_connection?: Maybe<IExistingCustomerRelationResponseCollection>
  hqs: Array<Maybe<IHq>>
  hqs_connection?: Maybe<IHqRelationResponseCollection>
  id: Scalars['ID']['output']
  integrations: Array<Maybe<IIntegration>>
  integrations_connection?: Maybe<IIntegrationRelationResponseCollection>
  isCreate?: Maybe<Scalars['Boolean']['output']>
  isOpenJobPosition?: Maybe<Scalars['Boolean']['output']>
  languages: Array<Maybe<IPlatformLanguage>>
  languages_connection?: Maybe<IPlatformLanguageRelationResponseCollection>
  logo?: Maybe<IUploadFile>
  longDescription?: Maybe<Scalars['String']['output']>
  marketEmail?: Maybe<Scalars['String']['output']>
  marketName?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  offices: Array<Maybe<IOffice>>
  offices_connection?: Maybe<IOfficeRelationResponseCollection>
  practiceAreas: Array<Maybe<IPracticeArea>>
  practiceAreas_connection?: Maybe<IPracticeAreaRelationResponseCollection>
  productName?: Maybe<Scalars['String']['output']>
  shortDescription?: Maybe<Scalars['String']['output']>
  subTopics: Array<Maybe<ISubTopic>>
  subTopics_connection?: Maybe<ISubTopicRelationResponseCollection>
  typeOfUsers: Array<Maybe<ITypeOfUser>>
  typeOfUsers_connection?: Maybe<ITypeOfUserRelationResponseCollection>
  website?: Maybe<Scalars['String']['output']>
  yearFounded?: Maybe<Scalars['Int']['output']>
}

export type IComponentRequestVendorReqAudiencesArgs = {
  filters?: InputMaybe<IDemographicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqAudiences_ConnectionArgs = {
  filters?: InputMaybe<IDemographicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqDeploymentsArgs = {
  filters?: InputMaybe<IInstallationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqDeployments_ConnectionArgs = {
  filters?: InputMaybe<IInstallationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqExistingCustomersArgs = {
  filters?: InputMaybe<IExistingCustomerFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqExistingCustomers_ConnectionArgs = {
  filters?: InputMaybe<IExistingCustomerFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqHqsArgs = {
  filters?: InputMaybe<IHqFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqHqs_ConnectionArgs = {
  filters?: InputMaybe<IHqFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqIntegrationsArgs = {
  filters?: InputMaybe<IIntegrationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqIntegrations_ConnectionArgs = {
  filters?: InputMaybe<IIntegrationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqLanguagesArgs = {
  filters?: InputMaybe<IPlatformLanguageFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqLanguages_ConnectionArgs = {
  filters?: InputMaybe<IPlatformLanguageFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqOfficesArgs = {
  filters?: InputMaybe<IOfficeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqOffices_ConnectionArgs = {
  filters?: InputMaybe<IOfficeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqPracticeAreasArgs = {
  filters?: InputMaybe<IPracticeAreaFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqPracticeAreas_ConnectionArgs = {
  filters?: InputMaybe<IPracticeAreaFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqSubTopicsArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqSubTopics_ConnectionArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqTypeOfUsersArgs = {
  filters?: InputMaybe<ITypeOfUserFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqTypeOfUsers_ConnectionArgs = {
  filters?: InputMaybe<ITypeOfUserFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentRequestVendorReqFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentRequestVendorReqFiltersInput>>>
  audiences?: InputMaybe<IDemographicFiltersInput>
  ceoEmail?: InputMaybe<IStringFilterInput>
  ceoName?: InputMaybe<IStringFilterInput>
  companyName?: InputMaybe<IStringFilterInput>
  competitor?: InputMaybe<IStringFilterInput>
  deployments?: InputMaybe<IInstallationFiltersInput>
  descOtherExistingCustomer?: InputMaybe<IStringFilterInput>
  descOtherIntegration?: InputMaybe<IStringFilterInput>
  email?: InputMaybe<IStringFilterInput>
  existingCustomers?: InputMaybe<IExistingCustomerFiltersInput>
  hqs?: InputMaybe<IHqFiltersInput>
  integrations?: InputMaybe<IIntegrationFiltersInput>
  isCreate?: InputMaybe<IBooleanFilterInput>
  isOpenJobPosition?: InputMaybe<IBooleanFilterInput>
  languages?: InputMaybe<IPlatformLanguageFiltersInput>
  longDescription?: InputMaybe<IStringFilterInput>
  marketEmail?: InputMaybe<IStringFilterInput>
  marketName?: InputMaybe<IStringFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentRequestVendorReqFiltersInput>
  notes?: InputMaybe<IStringFilterInput>
  offices?: InputMaybe<IOfficeFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentRequestVendorReqFiltersInput>>>
  practiceAreas?: InputMaybe<IPracticeAreaFiltersInput>
  productName?: InputMaybe<IStringFilterInput>
  shortDescription?: InputMaybe<IStringFilterInput>
  subTopics?: InputMaybe<ISubTopicFiltersInput>
  typeOfUsers?: InputMaybe<ITypeOfUserFiltersInput>
  website?: InputMaybe<IStringFilterInput>
  yearFounded?: InputMaybe<IIntFilterInput>
}

export type IComponentRequestVendorReqInput = {
  audiences?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  ceoEmail?: InputMaybe<Scalars['String']['input']>
  ceoName?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  competitor?: InputMaybe<Scalars['String']['input']>
  deployments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  descOtherExistingCustomer?: InputMaybe<Scalars['String']['input']>
  descOtherIntegration?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  existingCustomers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  hqs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  id?: InputMaybe<Scalars['ID']['input']>
  integrations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  isCreate?: InputMaybe<Scalars['Boolean']['input']>
  isOpenJobPosition?: InputMaybe<Scalars['Boolean']['input']>
  languages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  logo?: InputMaybe<Scalars['ID']['input']>
  longDescription?: InputMaybe<Scalars['String']['input']>
  marketEmail?: InputMaybe<Scalars['String']['input']>
  marketName?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  offices?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  practiceAreas?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  productName?: InputMaybe<Scalars['String']['input']>
  shortDescription?: InputMaybe<Scalars['String']['input']>
  subTopics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  typeOfUsers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  website?: InputMaybe<Scalars['String']['input']>
  yearFounded?: InputMaybe<Scalars['Int']['input']>
}

export type IComponentSolutionAlspData = {
  __typename?: 'ComponentSolutionAlspData'
  audiences: Array<Maybe<IDemographic>>
  audiences_connection?: Maybe<IDemographicRelationResponseCollection>
  enhancedListingData?: Maybe<IComponentSolutionPropsAlspEnhanced>
  fundingAmount?: Maybe<IEnum_Componentsolutionalspdata_Fundingamount>
  fundingDetails?: Maybe<Scalars['String']['output']>
  fundingInfo?: Maybe<IEnum_Componentsolutionalspdata_Fundinginfo>
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  openToInvestment?: Maybe<Scalars['Boolean']['output']>
  partners?: Maybe<Scalars['String']['output']>
  security: Array<Maybe<ISecurity>>
  security_connection?: Maybe<ISecurityRelationResponseCollection>
  serviceName?: Maybe<Scalars['String']['output']>
  size?: Maybe<Scalars['Int']['output']>
  valueProposition?: Maybe<Scalars['String']['output']>
}

export type IComponentSolutionAlspDataAudiencesArgs = {
  filters?: InputMaybe<IDemographicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionAlspDataAudiences_ConnectionArgs = {
  filters?: InputMaybe<IDemographicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionAlspDataSecurityArgs = {
  filters?: InputMaybe<ISecurityFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionAlspDataSecurity_ConnectionArgs = {
  filters?: InputMaybe<ISecurityFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionAlspDataFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSolutionAlspDataFiltersInput>>>
  audiences?: InputMaybe<IDemographicFiltersInput>
  enhancedListingData?: InputMaybe<IComponentSolutionPropsAlspEnhancedFiltersInput>
  fundingAmount?: InputMaybe<IStringFilterInput>
  fundingDetails?: InputMaybe<IStringFilterInput>
  fundingInfo?: InputMaybe<IStringFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentSolutionAlspDataFiltersInput>
  openToInvestment?: InputMaybe<IBooleanFilterInput>
  or?: InputMaybe<Array<InputMaybe<IComponentSolutionAlspDataFiltersInput>>>
  partners?: InputMaybe<IStringFilterInput>
  security?: InputMaybe<ISecurityFiltersInput>
  serviceName?: InputMaybe<IStringFilterInput>
  size?: InputMaybe<IIntFilterInput>
  valueProposition?: InputMaybe<IStringFilterInput>
}

export type IComponentSolutionAlspDataInput = {
  audiences?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  enhancedListingData?: InputMaybe<IComponentSolutionPropsAlspEnhancedInput>
  fundingAmount?: InputMaybe<IEnum_Componentsolutionalspdata_Fundingamount>
  fundingDetails?: InputMaybe<Scalars['String']['input']>
  fundingInfo?: InputMaybe<IEnum_Componentsolutionalspdata_Fundinginfo>
  id?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  openToInvestment?: InputMaybe<Scalars['Boolean']['input']>
  partners?: InputMaybe<Scalars['String']['input']>
  security?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  serviceName?: InputMaybe<Scalars['String']['input']>
  size?: InputMaybe<Scalars['Int']['input']>
  valueProposition?: InputMaybe<Scalars['String']['input']>
}

export type IComponentSolutionConsultantData = {
  __typename?: 'ComponentSolutionConsultantData'
  audiences: Array<Maybe<IDemographic>>
  audiences_connection?: Maybe<IDemographicRelationResponseCollection>
  enhancedListingData?: Maybe<IComponentSolutionPropsConsultantEnhanced>
  fundingAmount?: Maybe<IEnum_Componentsolutionconsultantdata_Fundingamount>
  fundingDetails?: Maybe<Scalars['String']['output']>
  fundingInfo?: Maybe<IEnum_Componentsolutionconsultantdata_Fundinginfo>
  id: Scalars['ID']['output']
  integrations: Array<Maybe<IIntegration>>
  integrations_connection?: Maybe<IIntegrationRelationResponseCollection>
  name?: Maybe<Scalars['String']['output']>
  openToInvestment?: Maybe<Scalars['Boolean']['output']>
  partners?: Maybe<Scalars['String']['output']>
  practiceAreas: Array<Maybe<IPracticeArea>>
  practiceAreas_connection?: Maybe<IPracticeAreaRelationResponseCollection>
  security: Array<Maybe<ISecurity>>
  security_connection?: Maybe<ISecurityRelationResponseCollection>
  serviceName?: Maybe<Scalars['String']['output']>
  size?: Maybe<Scalars['Int']['output']>
  typeOfUser: Array<Maybe<ITypeOfUser>>
  typeOfUser_connection?: Maybe<ITypeOfUserRelationResponseCollection>
  valueProposition?: Maybe<Scalars['String']['output']>
}

export type IComponentSolutionConsultantDataAudiencesArgs = {
  filters?: InputMaybe<IDemographicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionConsultantDataAudiences_ConnectionArgs = {
  filters?: InputMaybe<IDemographicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionConsultantDataIntegrationsArgs = {
  filters?: InputMaybe<IIntegrationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionConsultantDataIntegrations_ConnectionArgs = {
  filters?: InputMaybe<IIntegrationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionConsultantDataPracticeAreasArgs = {
  filters?: InputMaybe<IPracticeAreaFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionConsultantDataPracticeAreas_ConnectionArgs = {
  filters?: InputMaybe<IPracticeAreaFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionConsultantDataSecurityArgs = {
  filters?: InputMaybe<ISecurityFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionConsultantDataSecurity_ConnectionArgs = {
  filters?: InputMaybe<ISecurityFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionConsultantDataTypeOfUserArgs = {
  filters?: InputMaybe<ITypeOfUserFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionConsultantDataTypeOfUser_ConnectionArgs = {
  filters?: InputMaybe<ITypeOfUserFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionConsultantDataFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSolutionConsultantDataFiltersInput>>>
  audiences?: InputMaybe<IDemographicFiltersInput>
  enhancedListingData?: InputMaybe<IComponentSolutionPropsConsultantEnhancedFiltersInput>
  fundingAmount?: InputMaybe<IStringFilterInput>
  fundingDetails?: InputMaybe<IStringFilterInput>
  fundingInfo?: InputMaybe<IStringFilterInput>
  integrations?: InputMaybe<IIntegrationFiltersInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentSolutionConsultantDataFiltersInput>
  openToInvestment?: InputMaybe<IBooleanFilterInput>
  or?: InputMaybe<Array<InputMaybe<IComponentSolutionConsultantDataFiltersInput>>>
  partners?: InputMaybe<IStringFilterInput>
  practiceAreas?: InputMaybe<IPracticeAreaFiltersInput>
  security?: InputMaybe<ISecurityFiltersInput>
  serviceName?: InputMaybe<IStringFilterInput>
  size?: InputMaybe<IIntFilterInput>
  typeOfUser?: InputMaybe<ITypeOfUserFiltersInput>
  valueProposition?: InputMaybe<IStringFilterInput>
}

export type IComponentSolutionConsultantDataInput = {
  audiences?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  enhancedListingData?: InputMaybe<IComponentSolutionPropsConsultantEnhancedInput>
  fundingAmount?: InputMaybe<IEnum_Componentsolutionconsultantdata_Fundingamount>
  fundingDetails?: InputMaybe<Scalars['String']['input']>
  fundingInfo?: InputMaybe<IEnum_Componentsolutionconsultantdata_Fundinginfo>
  id?: InputMaybe<Scalars['ID']['input']>
  integrations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  name?: InputMaybe<Scalars['String']['input']>
  openToInvestment?: InputMaybe<Scalars['Boolean']['input']>
  partners?: InputMaybe<Scalars['String']['input']>
  practiceAreas?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  security?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  serviceName?: InputMaybe<Scalars['String']['input']>
  size?: InputMaybe<Scalars['Int']['input']>
  typeOfUser?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  valueProposition?: InputMaybe<Scalars['String']['input']>
}

export type IComponentSolutionProductData = {
  __typename?: 'ComponentSolutionProductData'
  attributes: Array<Maybe<IAttribute>>
  attributes_connection?: Maybe<IAttributeRelationResponseCollection>
  audiences: Array<Maybe<IDemographic>>
  audiences_connection?: Maybe<IDemographicRelationResponseCollection>
  dataHostingLocations: Array<Maybe<IOffice>>
  dataHostingLocations_connection?: Maybe<IOfficeRelationResponseCollection>
  deployments: Array<Maybe<IInstallation>>
  deployments_connection?: Maybe<IInstallationRelationResponseCollection>
  enhancedListingData?: Maybe<IComponentSolutionPropsProductEnhanced>
  fundingAmount?: Maybe<IEnum_Componentsolutionproductdata_Fundingamount>
  fundingDetails?: Maybe<Scalars['String']['output']>
  fundingInfo?: Maybe<IEnum_Componentsolutionproductdata_Fundinginfo>
  id: Scalars['ID']['output']
  integrations: Array<Maybe<IIntegration>>
  integrations_connection?: Maybe<IIntegrationRelationResponseCollection>
  name?: Maybe<Scalars['String']['output']>
  openToInvestment?: Maybe<Scalars['Boolean']['output']>
  practiceAreas: Array<Maybe<IPracticeArea>>
  practiceAreas_connection?: Maybe<IPracticeAreaRelationResponseCollection>
  security: Array<Maybe<ISecurity>>
  security_connection?: Maybe<ISecurityRelationResponseCollection>
  tool?: Maybe<Scalars['String']['output']>
  typeOfUser: Array<Maybe<ITypeOfUser>>
  typeOfUser_connection?: Maybe<ITypeOfUserRelationResponseCollection>
  valueProposition?: Maybe<Scalars['String']['output']>
}

export type IComponentSolutionProductDataAttributesArgs = {
  filters?: InputMaybe<IAttributeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionProductDataAttributes_ConnectionArgs = {
  filters?: InputMaybe<IAttributeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionProductDataAudiencesArgs = {
  filters?: InputMaybe<IDemographicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionProductDataAudiences_ConnectionArgs = {
  filters?: InputMaybe<IDemographicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionProductDataDataHostingLocationsArgs = {
  filters?: InputMaybe<IOfficeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionProductDataDataHostingLocations_ConnectionArgs = {
  filters?: InputMaybe<IOfficeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionProductDataDeploymentsArgs = {
  filters?: InputMaybe<IInstallationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionProductDataDeployments_ConnectionArgs = {
  filters?: InputMaybe<IInstallationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionProductDataIntegrationsArgs = {
  filters?: InputMaybe<IIntegrationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionProductDataIntegrations_ConnectionArgs = {
  filters?: InputMaybe<IIntegrationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionProductDataPracticeAreasArgs = {
  filters?: InputMaybe<IPracticeAreaFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionProductDataPracticeAreas_ConnectionArgs = {
  filters?: InputMaybe<IPracticeAreaFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionProductDataSecurityArgs = {
  filters?: InputMaybe<ISecurityFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionProductDataSecurity_ConnectionArgs = {
  filters?: InputMaybe<ISecurityFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionProductDataTypeOfUserArgs = {
  filters?: InputMaybe<ITypeOfUserFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionProductDataTypeOfUser_ConnectionArgs = {
  filters?: InputMaybe<ITypeOfUserFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionProductDataFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSolutionProductDataFiltersInput>>>
  attributes?: InputMaybe<IAttributeFiltersInput>
  audiences?: InputMaybe<IDemographicFiltersInput>
  dataHostingLocations?: InputMaybe<IOfficeFiltersInput>
  deployments?: InputMaybe<IInstallationFiltersInput>
  enhancedListingData?: InputMaybe<IComponentSolutionPropsProductEnhancedFiltersInput>
  fundingAmount?: InputMaybe<IStringFilterInput>
  fundingDetails?: InputMaybe<IStringFilterInput>
  fundingInfo?: InputMaybe<IStringFilterInput>
  integrations?: InputMaybe<IIntegrationFiltersInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentSolutionProductDataFiltersInput>
  openToInvestment?: InputMaybe<IBooleanFilterInput>
  or?: InputMaybe<Array<InputMaybe<IComponentSolutionProductDataFiltersInput>>>
  practiceAreas?: InputMaybe<IPracticeAreaFiltersInput>
  security?: InputMaybe<ISecurityFiltersInput>
  tool?: InputMaybe<IStringFilterInput>
  typeOfUser?: InputMaybe<ITypeOfUserFiltersInput>
  valueProposition?: InputMaybe<IStringFilterInput>
}

export type IComponentSolutionProductDataInput = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  audiences?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  dataHostingLocations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  deployments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  enhancedListingData?: InputMaybe<IComponentSolutionPropsProductEnhancedInput>
  fundingAmount?: InputMaybe<IEnum_Componentsolutionproductdata_Fundingamount>
  fundingDetails?: InputMaybe<Scalars['String']['input']>
  fundingInfo?: InputMaybe<IEnum_Componentsolutionproductdata_Fundinginfo>
  id?: InputMaybe<Scalars['ID']['input']>
  integrations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  name?: InputMaybe<Scalars['String']['input']>
  openToInvestment?: InputMaybe<Scalars['Boolean']['input']>
  practiceAreas?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  security?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  tool?: InputMaybe<Scalars['String']['input']>
  typeOfUser?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  valueProposition?: InputMaybe<Scalars['String']['input']>
}

export type IComponentSolutionPropsAlspEnhanced = {
  __typename?: 'ComponentSolutionPropsAlspEnhanced'
  averageLengthOfEngagement?: Maybe<Scalars['Int']['output']>
  callToAction?: Maybe<IComponentGlobalCallToAction>
  caseStudies?: Maybe<Array<Maybe<IComponentGlobalSuccessStory>>>
  dedicatedResources?: Maybe<Array<Maybe<IComponentSolutionPropsDedicatedResource>>>
  id: Scalars['ID']['output']
  pricingData?: Maybe<Scalars['String']['output']>
  screenshots?: Maybe<Array<Maybe<IComponentGlobalPicture>>>
  serviceDescription?: Maybe<Scalars['String']['output']>
  specialists?: Maybe<Array<Maybe<IComponentAboutPropsTeamMember>>>
  technologyPartners?: Maybe<Scalars['String']['output']>
  testimonials?: Maybe<Array<Maybe<IComponentTestimonialsTestimonials>>>
  videos?: Maybe<Array<Maybe<IComponentSolutionPropsVideo>>>
}

export type IComponentSolutionPropsAlspEnhancedCaseStudiesArgs = {
  filters?: InputMaybe<IComponentGlobalSuccessStoryFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionPropsAlspEnhancedDedicatedResourcesArgs = {
  filters?: InputMaybe<IComponentSolutionPropsDedicatedResourceFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionPropsAlspEnhancedScreenshotsArgs = {
  filters?: InputMaybe<IComponentGlobalPictureFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionPropsAlspEnhancedSpecialistsArgs = {
  filters?: InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionPropsAlspEnhancedTestimonialsArgs = {
  filters?: InputMaybe<IComponentTestimonialsTestimonialsFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionPropsAlspEnhancedVideosArgs = {
  filters?: InputMaybe<IComponentSolutionPropsVideoFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionPropsAlspEnhancedFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsAlspEnhancedFiltersInput>>>
  averageLengthOfEngagement?: InputMaybe<IIntFilterInput>
  callToAction?: InputMaybe<IComponentGlobalCallToActionFiltersInput>
  caseStudies?: InputMaybe<IComponentGlobalSuccessStoryFiltersInput>
  dedicatedResources?: InputMaybe<IComponentSolutionPropsDedicatedResourceFiltersInput>
  not?: InputMaybe<IComponentSolutionPropsAlspEnhancedFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsAlspEnhancedFiltersInput>>>
  pricingData?: InputMaybe<IStringFilterInput>
  screenshots?: InputMaybe<IComponentGlobalPictureFiltersInput>
  serviceDescription?: InputMaybe<IStringFilterInput>
  specialists?: InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>
  technologyPartners?: InputMaybe<IStringFilterInput>
  testimonials?: InputMaybe<IComponentTestimonialsTestimonialsFiltersInput>
  videos?: InputMaybe<IComponentSolutionPropsVideoFiltersInput>
}

export type IComponentSolutionPropsAlspEnhancedInput = {
  averageLengthOfEngagement?: InputMaybe<Scalars['Int']['input']>
  callToAction?: InputMaybe<IComponentGlobalCallToActionInput>
  caseStudies?: InputMaybe<Array<InputMaybe<IComponentGlobalSuccessStoryInput>>>
  dedicatedResources?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsDedicatedResourceInput>>>
  id?: InputMaybe<Scalars['ID']['input']>
  pricingData?: InputMaybe<Scalars['String']['input']>
  screenshots?: InputMaybe<Array<InputMaybe<IComponentGlobalPictureInput>>>
  serviceDescription?: InputMaybe<Scalars['String']['input']>
  specialists?: InputMaybe<Array<InputMaybe<IComponentAboutPropsTeamMemberInput>>>
  technologyPartners?: InputMaybe<Scalars['String']['input']>
  testimonials?: InputMaybe<Array<InputMaybe<IComponentTestimonialsTestimonialsInput>>>
  videos?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsVideoInput>>>
}

export type IComponentSolutionPropsConsolidation = {
  __typename?: 'ComponentSolutionPropsConsolidation'
  amount?: Maybe<Scalars['Int']['output']>
  article?: Maybe<Scalars['String']['output']>
  articleLink?: Maybe<Scalars['String']['output']>
  buyer?: Maybe<Scalars['String']['output']>
  date?: Maybe<Scalars['Date']['output']>
  enableInActiveDir?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  originalTargetName?: Maybe<Scalars['String']['output']>
}

export type IComponentSolutionPropsConsolidationFiltersInput = {
  amount?: InputMaybe<IIntFilterInput>
  and?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsConsolidationFiltersInput>>>
  article?: InputMaybe<IStringFilterInput>
  articleLink?: InputMaybe<IStringFilterInput>
  buyer?: InputMaybe<IStringFilterInput>
  date?: InputMaybe<IDateFilterInput>
  enableInActiveDir?: InputMaybe<IBooleanFilterInput>
  not?: InputMaybe<IComponentSolutionPropsConsolidationFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsConsolidationFiltersInput>>>
  originalTargetName?: InputMaybe<IStringFilterInput>
}

export type IComponentSolutionPropsConsolidationInput = {
  amount?: InputMaybe<Scalars['Int']['input']>
  article?: InputMaybe<Scalars['String']['input']>
  articleLink?: InputMaybe<Scalars['String']['input']>
  buyer?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['Date']['input']>
  enableInActiveDir?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  originalTargetName?: InputMaybe<Scalars['String']['input']>
}

export type IComponentSolutionPropsConsultantEnhanced = {
  __typename?: 'ComponentSolutionPropsConsultantEnhanced'
  averageLengthOfEngagement?: Maybe<Scalars['Int']['output']>
  callToAction?: Maybe<IComponentGlobalCallToAction>
  caseStudies?: Maybe<Array<Maybe<IComponentGlobalSuccessStory>>>
  dedicatedResources?: Maybe<Array<Maybe<IComponentSolutionPropsDedicatedResource>>>
  id: Scalars['ID']['output']
  pricingData?: Maybe<Scalars['String']['output']>
  screenshots?: Maybe<Array<Maybe<IComponentGlobalPicture>>>
  serviceDescription?: Maybe<Scalars['String']['output']>
  specialists?: Maybe<Array<Maybe<IComponentAboutPropsTeamMember>>>
  technologyPartners?: Maybe<Scalars['String']['output']>
  testimonials?: Maybe<Array<Maybe<IComponentTestimonialsTestimonials>>>
  videos?: Maybe<Array<Maybe<IComponentSolutionPropsVideo>>>
}

export type IComponentSolutionPropsConsultantEnhancedCaseStudiesArgs = {
  filters?: InputMaybe<IComponentGlobalSuccessStoryFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionPropsConsultantEnhancedDedicatedResourcesArgs = {
  filters?: InputMaybe<IComponentSolutionPropsDedicatedResourceFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionPropsConsultantEnhancedScreenshotsArgs = {
  filters?: InputMaybe<IComponentGlobalPictureFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionPropsConsultantEnhancedSpecialistsArgs = {
  filters?: InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionPropsConsultantEnhancedTestimonialsArgs = {
  filters?: InputMaybe<IComponentTestimonialsTestimonialsFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionPropsConsultantEnhancedVideosArgs = {
  filters?: InputMaybe<IComponentSolutionPropsVideoFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionPropsConsultantEnhancedFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsConsultantEnhancedFiltersInput>>>
  averageLengthOfEngagement?: InputMaybe<IIntFilterInput>
  callToAction?: InputMaybe<IComponentGlobalCallToActionFiltersInput>
  caseStudies?: InputMaybe<IComponentGlobalSuccessStoryFiltersInput>
  dedicatedResources?: InputMaybe<IComponentSolutionPropsDedicatedResourceFiltersInput>
  not?: InputMaybe<IComponentSolutionPropsConsultantEnhancedFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsConsultantEnhancedFiltersInput>>>
  pricingData?: InputMaybe<IStringFilterInput>
  screenshots?: InputMaybe<IComponentGlobalPictureFiltersInput>
  serviceDescription?: InputMaybe<IStringFilterInput>
  specialists?: InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>
  technologyPartners?: InputMaybe<IStringFilterInput>
  testimonials?: InputMaybe<IComponentTestimonialsTestimonialsFiltersInput>
  videos?: InputMaybe<IComponentSolutionPropsVideoFiltersInput>
}

export type IComponentSolutionPropsConsultantEnhancedInput = {
  averageLengthOfEngagement?: InputMaybe<Scalars['Int']['input']>
  callToAction?: InputMaybe<IComponentGlobalCallToActionInput>
  caseStudies?: InputMaybe<Array<InputMaybe<IComponentGlobalSuccessStoryInput>>>
  dedicatedResources?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsDedicatedResourceInput>>>
  id?: InputMaybe<Scalars['ID']['input']>
  pricingData?: InputMaybe<Scalars['String']['input']>
  screenshots?: InputMaybe<Array<InputMaybe<IComponentGlobalPictureInput>>>
  serviceDescription?: InputMaybe<Scalars['String']['input']>
  specialists?: InputMaybe<Array<InputMaybe<IComponentAboutPropsTeamMemberInput>>>
  technologyPartners?: InputMaybe<Scalars['String']['input']>
  testimonials?: InputMaybe<Array<InputMaybe<IComponentTestimonialsTestimonialsInput>>>
  videos?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsVideoInput>>>
}

export type IComponentSolutionPropsDedicatedResource = {
  __typename?: 'ComponentSolutionPropsDedicatedResource'
  count?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  type?: Maybe<IEnum_Componentsolutionpropsdedicatedresource_Type>
}

export type IComponentSolutionPropsDedicatedResourceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsDedicatedResourceFiltersInput>>>
  count?: InputMaybe<IIntFilterInput>
  not?: InputMaybe<IComponentSolutionPropsDedicatedResourceFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsDedicatedResourceFiltersInput>>>
  type?: InputMaybe<IStringFilterInput>
}

export type IComponentSolutionPropsDedicatedResourceInput = {
  count?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  type?: InputMaybe<IEnum_Componentsolutionpropsdedicatedresource_Type>
}

export type IComponentSolutionPropsGraveyard = {
  __typename?: 'ComponentSolutionPropsGraveyard'
  date?: Maybe<Scalars['Date']['output']>
  id: Scalars['ID']['output']
}

export type IComponentSolutionPropsGraveyardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsGraveyardFiltersInput>>>
  date?: InputMaybe<IDateFilterInput>
  not?: InputMaybe<IComponentSolutionPropsGraveyardFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsGraveyardFiltersInput>>>
}

export type IComponentSolutionPropsGraveyardInput = {
  date?: InputMaybe<Scalars['Date']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
}

export type IComponentSolutionPropsProductEnhanced = {
  __typename?: 'ComponentSolutionPropsProductEnhanced'
  callToAction?: Maybe<IComponentGlobalCallToAction>
  id: Scalars['ID']['output']
  pricingData?: Maybe<Scalars['String']['output']>
  screenshots?: Maybe<Array<Maybe<IComponentGlobalPicture>>>
  testimonials?: Maybe<Array<Maybe<IComponentTestimonialsTestimonials>>>
  videos?: Maybe<Array<Maybe<IComponentSolutionPropsVideo>>>
}

export type IComponentSolutionPropsProductEnhancedScreenshotsArgs = {
  filters?: InputMaybe<IComponentGlobalPictureFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionPropsProductEnhancedTestimonialsArgs = {
  filters?: InputMaybe<IComponentTestimonialsTestimonialsFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionPropsProductEnhancedVideosArgs = {
  filters?: InputMaybe<IComponentSolutionPropsVideoFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionPropsProductEnhancedFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsProductEnhancedFiltersInput>>>
  callToAction?: InputMaybe<IComponentGlobalCallToActionFiltersInput>
  not?: InputMaybe<IComponentSolutionPropsProductEnhancedFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsProductEnhancedFiltersInput>>>
  pricingData?: InputMaybe<IStringFilterInput>
  screenshots?: InputMaybe<IComponentGlobalPictureFiltersInput>
  testimonials?: InputMaybe<IComponentTestimonialsTestimonialsFiltersInput>
  videos?: InputMaybe<IComponentSolutionPropsVideoFiltersInput>
}

export type IComponentSolutionPropsProductEnhancedInput = {
  callToAction?: InputMaybe<IComponentGlobalCallToActionInput>
  id?: InputMaybe<Scalars['ID']['input']>
  pricingData?: InputMaybe<Scalars['String']['input']>
  screenshots?: InputMaybe<Array<InputMaybe<IComponentGlobalPictureInput>>>
  testimonials?: InputMaybe<Array<InputMaybe<IComponentTestimonialsTestimonialsInput>>>
  videos?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsVideoInput>>>
}

export type IComponentSolutionPropsVendorResource = {
  __typename?: 'ComponentSolutionPropsVendorResource'
  content?: Maybe<IContent>
  external?: Maybe<IComponentSolutionPropsVendorResourceExternal>
  id: Scalars['ID']['output']
  type?: Maybe<IEnum_Componentsolutionpropsvendorresource_Type>
}

export type IComponentSolutionPropsVendorResourceExternal = {
  __typename?: 'ComponentSolutionPropsVendorResourceExternal'
  author?: Maybe<Scalars['String']['output']>
  documentType?: Maybe<IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype>
  id: Scalars['ID']['output']
  link?: Maybe<Scalars['String']['output']>
  publishedDate?: Maybe<Scalars['Date']['output']>
  summary?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type IComponentSolutionPropsVendorResourceExternalFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsVendorResourceExternalFiltersInput>>>
  author?: InputMaybe<IStringFilterInput>
  documentType?: InputMaybe<IStringFilterInput>
  link?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentSolutionPropsVendorResourceExternalFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsVendorResourceExternalFiltersInput>>>
  publishedDate?: InputMaybe<IDateFilterInput>
  summary?: InputMaybe<IStringFilterInput>
  title?: InputMaybe<IStringFilterInput>
}

export type IComponentSolutionPropsVendorResourceExternalInput = {
  author?: InputMaybe<Scalars['String']['input']>
  documentType?: InputMaybe<IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype>
  id?: InputMaybe<Scalars['ID']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  publishedDate?: InputMaybe<Scalars['Date']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type IComponentSolutionPropsVendorResourceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsVendorResourceFiltersInput>>>
  content?: InputMaybe<IContentFiltersInput>
  external?: InputMaybe<IComponentSolutionPropsVendorResourceExternalFiltersInput>
  not?: InputMaybe<IComponentSolutionPropsVendorResourceFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsVendorResourceFiltersInput>>>
  type?: InputMaybe<IStringFilterInput>
}

export type IComponentSolutionPropsVendorResourceInput = {
  content?: InputMaybe<Scalars['ID']['input']>
  external?: InputMaybe<IComponentSolutionPropsVendorResourceExternalInput>
  id?: InputMaybe<Scalars['ID']['input']>
  type?: InputMaybe<IEnum_Componentsolutionpropsvendorresource_Type>
}

export type IComponentSolutionPropsVideo = {
  __typename?: 'ComponentSolutionPropsVideo'
  id: Scalars['ID']['output']
  summary?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type IComponentSolutionPropsVideoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsVideoFiltersInput>>>
  not?: InputMaybe<IComponentSolutionPropsVideoFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsVideoFiltersInput>>>
  summary?: InputMaybe<IStringFilterInput>
  title?: InputMaybe<IStringFilterInput>
  url?: InputMaybe<IStringFilterInput>
}

export type IComponentSolutionPropsVideoInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type IComponentSolutionPushUpdateMessageDetails = {
  __typename?: 'ComponentSolutionPushUpdateMessageDetails'
  followedUsersEmail?: Maybe<Scalars['JSON']['output']>
  id: Scalars['ID']['output']
  pushMessageDesc?: Maybe<Scalars['String']['output']>
  sentBy?: Maybe<Scalars['String']['output']>
  sentDate?: Maybe<Scalars['Date']['output']>
}

export type IComponentSolutionPushUpdateMessageDetailsInput = {
  followedUsersEmail?: InputMaybe<Scalars['JSON']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  pushMessageDesc?: InputMaybe<Scalars['String']['input']>
  sentBy?: InputMaybe<Scalars['String']['input']>
  sentDate?: InputMaybe<Scalars['Date']['input']>
}

export type IComponentSolutionRequestAlspData = {
  __typename?: 'ComponentSolutionRequestAlspData'
  audiences: Array<Maybe<IDemographic>>
  audiences_connection?: Maybe<IDemographicRelationResponseCollection>
  enhancedListingData?: Maybe<IComponentSolutionPropsAlspEnhanced>
  fundingAmount?: Maybe<IEnum_Componentsolutionrequestalspdata_Fundingamount>
  fundingInfo?: Maybe<IEnum_Componentsolutionrequestalspdata_Fundinginfo>
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  partners?: Maybe<Scalars['String']['output']>
  security: Array<Maybe<ISecurity>>
  security_connection?: Maybe<ISecurityRelationResponseCollection>
  serviceName?: Maybe<Scalars['String']['output']>
  size?: Maybe<Scalars['Int']['output']>
  valueProposition?: Maybe<Scalars['String']['output']>
}

export type IComponentSolutionRequestAlspDataAudiencesArgs = {
  filters?: InputMaybe<IDemographicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestAlspDataAudiences_ConnectionArgs = {
  filters?: InputMaybe<IDemographicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestAlspDataSecurityArgs = {
  filters?: InputMaybe<ISecurityFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestAlspDataSecurity_ConnectionArgs = {
  filters?: InputMaybe<ISecurityFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestAlspDataFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSolutionRequestAlspDataFiltersInput>>>
  audiences?: InputMaybe<IDemographicFiltersInput>
  enhancedListingData?: InputMaybe<IComponentSolutionPropsAlspEnhancedFiltersInput>
  fundingAmount?: InputMaybe<IStringFilterInput>
  fundingInfo?: InputMaybe<IStringFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentSolutionRequestAlspDataFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentSolutionRequestAlspDataFiltersInput>>>
  partners?: InputMaybe<IStringFilterInput>
  security?: InputMaybe<ISecurityFiltersInput>
  serviceName?: InputMaybe<IStringFilterInput>
  size?: InputMaybe<IIntFilterInput>
  valueProposition?: InputMaybe<IStringFilterInput>
}

export type IComponentSolutionRequestAlspDataInput = {
  audiences?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  enhancedListingData?: InputMaybe<IComponentSolutionPropsAlspEnhancedInput>
  fundingAmount?: InputMaybe<IEnum_Componentsolutionrequestalspdata_Fundingamount>
  fundingInfo?: InputMaybe<IEnum_Componentsolutionrequestalspdata_Fundinginfo>
  id?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  partners?: InputMaybe<Scalars['String']['input']>
  security?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  serviceName?: InputMaybe<Scalars['String']['input']>
  size?: InputMaybe<Scalars['Int']['input']>
  valueProposition?: InputMaybe<Scalars['String']['input']>
}

export type IComponentSolutionRequestConsultantData = {
  __typename?: 'ComponentSolutionRequestConsultantData'
  audiences: Array<Maybe<IDemographic>>
  audiences_connection?: Maybe<IDemographicRelationResponseCollection>
  enhancedListingData?: Maybe<IComponentSolutionPropsConsultantEnhanced>
  fundingAmount?: Maybe<IEnum_Componentsolutionrequestconsultantdata_Fundingamount>
  fundingInfo?: Maybe<IEnum_Componentsolutionrequestconsultantdata_Fundinginfo>
  id: Scalars['ID']['output']
  integrations: Array<Maybe<IIntegration>>
  integrations_connection?: Maybe<IIntegrationRelationResponseCollection>
  name?: Maybe<Scalars['String']['output']>
  partners?: Maybe<Scalars['String']['output']>
  practiceAreas: Array<Maybe<IPracticeArea>>
  practiceAreas_connection?: Maybe<IPracticeAreaRelationResponseCollection>
  security: Array<Maybe<ISecurity>>
  security_connection?: Maybe<ISecurityRelationResponseCollection>
  serviceName?: Maybe<Scalars['String']['output']>
  size?: Maybe<Scalars['Int']['output']>
  typeOfUser: Array<Maybe<ITypeOfUser>>
  typeOfUser_connection?: Maybe<ITypeOfUserRelationResponseCollection>
  valueProposition?: Maybe<Scalars['String']['output']>
}

export type IComponentSolutionRequestConsultantDataAudiencesArgs = {
  filters?: InputMaybe<IDemographicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestConsultantDataAudiences_ConnectionArgs = {
  filters?: InputMaybe<IDemographicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestConsultantDataIntegrationsArgs = {
  filters?: InputMaybe<IIntegrationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestConsultantDataIntegrations_ConnectionArgs = {
  filters?: InputMaybe<IIntegrationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestConsultantDataPracticeAreasArgs = {
  filters?: InputMaybe<IPracticeAreaFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestConsultantDataPracticeAreas_ConnectionArgs = {
  filters?: InputMaybe<IPracticeAreaFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestConsultantDataSecurityArgs = {
  filters?: InputMaybe<ISecurityFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestConsultantDataSecurity_ConnectionArgs = {
  filters?: InputMaybe<ISecurityFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestConsultantDataTypeOfUserArgs = {
  filters?: InputMaybe<ITypeOfUserFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestConsultantDataTypeOfUser_ConnectionArgs = {
  filters?: InputMaybe<ITypeOfUserFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestConsultantDataFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSolutionRequestConsultantDataFiltersInput>>>
  audiences?: InputMaybe<IDemographicFiltersInput>
  enhancedListingData?: InputMaybe<IComponentSolutionPropsConsultantEnhancedFiltersInput>
  fundingAmount?: InputMaybe<IStringFilterInput>
  fundingInfo?: InputMaybe<IStringFilterInput>
  integrations?: InputMaybe<IIntegrationFiltersInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentSolutionRequestConsultantDataFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentSolutionRequestConsultantDataFiltersInput>>>
  partners?: InputMaybe<IStringFilterInput>
  practiceAreas?: InputMaybe<IPracticeAreaFiltersInput>
  security?: InputMaybe<ISecurityFiltersInput>
  serviceName?: InputMaybe<IStringFilterInput>
  size?: InputMaybe<IIntFilterInput>
  typeOfUser?: InputMaybe<ITypeOfUserFiltersInput>
  valueProposition?: InputMaybe<IStringFilterInput>
}

export type IComponentSolutionRequestConsultantDataInput = {
  audiences?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  enhancedListingData?: InputMaybe<IComponentSolutionPropsConsultantEnhancedInput>
  fundingAmount?: InputMaybe<IEnum_Componentsolutionrequestconsultantdata_Fundingamount>
  fundingInfo?: InputMaybe<IEnum_Componentsolutionrequestconsultantdata_Fundinginfo>
  id?: InputMaybe<Scalars['ID']['input']>
  integrations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  name?: InputMaybe<Scalars['String']['input']>
  partners?: InputMaybe<Scalars['String']['input']>
  practiceAreas?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  security?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  serviceName?: InputMaybe<Scalars['String']['input']>
  size?: InputMaybe<Scalars['Int']['input']>
  typeOfUser?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  valueProposition?: InputMaybe<Scalars['String']['input']>
}

export type IComponentSolutionRequestProductData = {
  __typename?: 'ComponentSolutionRequestProductData'
  attributes: Array<Maybe<IAttribute>>
  attributes_connection?: Maybe<IAttributeRelationResponseCollection>
  audiences: Array<Maybe<IDemographic>>
  audiences_connection?: Maybe<IDemographicRelationResponseCollection>
  dataHosting: Array<Maybe<IOffice>>
  dataHosting_connection?: Maybe<IOfficeRelationResponseCollection>
  deployments: Array<Maybe<IInstallation>>
  deployments_connection?: Maybe<IInstallationRelationResponseCollection>
  enhancedListingData?: Maybe<IComponentSolutionRequestPropsProductEnhanced>
  fundingAmount?: Maybe<IEnum_Componentsolutionrequestproductdata_Fundingamount>
  fundingInfo?: Maybe<IEnum_Componentsolutionrequestproductdata_Fundinginfo>
  id: Scalars['ID']['output']
  integrations: Array<Maybe<IIntegration>>
  integrations_connection?: Maybe<IIntegrationRelationResponseCollection>
  name?: Maybe<Scalars['String']['output']>
  practiceAreas: Array<Maybe<IPracticeArea>>
  practiceAreas_connection?: Maybe<IPracticeAreaRelationResponseCollection>
  security: Array<Maybe<ISecurity>>
  security_connection?: Maybe<ISecurityRelationResponseCollection>
  tool?: Maybe<Scalars['String']['output']>
  typeOfUser: Array<Maybe<ITypeOfUser>>
  typeOfUser_connection?: Maybe<ITypeOfUserRelationResponseCollection>
  valueProposition?: Maybe<Scalars['String']['output']>
}

export type IComponentSolutionRequestProductDataAttributesArgs = {
  filters?: InputMaybe<IAttributeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestProductDataAttributes_ConnectionArgs = {
  filters?: InputMaybe<IAttributeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestProductDataAudiencesArgs = {
  filters?: InputMaybe<IDemographicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestProductDataAudiences_ConnectionArgs = {
  filters?: InputMaybe<IDemographicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestProductDataDataHostingArgs = {
  filters?: InputMaybe<IOfficeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestProductDataDataHosting_ConnectionArgs = {
  filters?: InputMaybe<IOfficeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestProductDataDeploymentsArgs = {
  filters?: InputMaybe<IInstallationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestProductDataDeployments_ConnectionArgs = {
  filters?: InputMaybe<IInstallationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestProductDataIntegrationsArgs = {
  filters?: InputMaybe<IIntegrationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestProductDataIntegrations_ConnectionArgs = {
  filters?: InputMaybe<IIntegrationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestProductDataPracticeAreasArgs = {
  filters?: InputMaybe<IPracticeAreaFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestProductDataPracticeAreas_ConnectionArgs = {
  filters?: InputMaybe<IPracticeAreaFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestProductDataSecurityArgs = {
  filters?: InputMaybe<ISecurityFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestProductDataSecurity_ConnectionArgs = {
  filters?: InputMaybe<ISecurityFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestProductDataTypeOfUserArgs = {
  filters?: InputMaybe<ITypeOfUserFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestProductDataTypeOfUser_ConnectionArgs = {
  filters?: InputMaybe<ITypeOfUserFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestProductDataFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSolutionRequestProductDataFiltersInput>>>
  attributes?: InputMaybe<IAttributeFiltersInput>
  audiences?: InputMaybe<IDemographicFiltersInput>
  dataHosting?: InputMaybe<IOfficeFiltersInput>
  deployments?: InputMaybe<IInstallationFiltersInput>
  enhancedListingData?: InputMaybe<IComponentSolutionRequestPropsProductEnhancedFiltersInput>
  fundingAmount?: InputMaybe<IStringFilterInput>
  fundingInfo?: InputMaybe<IStringFilterInput>
  integrations?: InputMaybe<IIntegrationFiltersInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentSolutionRequestProductDataFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentSolutionRequestProductDataFiltersInput>>>
  practiceAreas?: InputMaybe<IPracticeAreaFiltersInput>
  security?: InputMaybe<ISecurityFiltersInput>
  tool?: InputMaybe<IStringFilterInput>
  typeOfUser?: InputMaybe<ITypeOfUserFiltersInput>
  valueProposition?: InputMaybe<IStringFilterInput>
}

export type IComponentSolutionRequestProductDataInput = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  audiences?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  dataHosting?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  deployments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  enhancedListingData?: InputMaybe<IComponentSolutionRequestPropsProductEnhancedInput>
  fundingAmount?: InputMaybe<IEnum_Componentsolutionrequestproductdata_Fundingamount>
  fundingInfo?: InputMaybe<IEnum_Componentsolutionrequestproductdata_Fundinginfo>
  id?: InputMaybe<Scalars['ID']['input']>
  integrations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  name?: InputMaybe<Scalars['String']['input']>
  practiceAreas?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  security?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  tool?: InputMaybe<Scalars['String']['input']>
  typeOfUser?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  valueProposition?: InputMaybe<Scalars['String']['input']>
}

export type IComponentSolutionRequestPropsProductEnhanced = {
  __typename?: 'ComponentSolutionRequestPropsProductEnhanced'
  callToAction?: Maybe<IComponentGlobalCallToAction>
  id: Scalars['ID']['output']
  pricingData?: Maybe<Scalars['String']['output']>
  screenshots?: Maybe<Array<Maybe<IComponentGlobalPicture>>>
  testimonials?: Maybe<Array<Maybe<IComponentTestimonialsTestimonials>>>
  videos?: Maybe<Array<Maybe<IComponentSolutionPropsVideo>>>
}

export type IComponentSolutionRequestPropsProductEnhancedScreenshotsArgs = {
  filters?: InputMaybe<IComponentGlobalPictureFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestPropsProductEnhancedTestimonialsArgs = {
  filters?: InputMaybe<IComponentTestimonialsTestimonialsFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestPropsProductEnhancedVideosArgs = {
  filters?: InputMaybe<IComponentSolutionPropsVideoFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentSolutionRequestPropsProductEnhancedFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSolutionRequestPropsProductEnhancedFiltersInput>>>
  callToAction?: InputMaybe<IComponentGlobalCallToActionFiltersInput>
  not?: InputMaybe<IComponentSolutionRequestPropsProductEnhancedFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentSolutionRequestPropsProductEnhancedFiltersInput>>>
  pricingData?: InputMaybe<IStringFilterInput>
  screenshots?: InputMaybe<IComponentGlobalPictureFiltersInput>
  testimonials?: InputMaybe<IComponentTestimonialsTestimonialsFiltersInput>
  videos?: InputMaybe<IComponentSolutionPropsVideoFiltersInput>
}

export type IComponentSolutionRequestPropsProductEnhancedInput = {
  callToAction?: InputMaybe<IComponentGlobalCallToActionInput>
  id?: InputMaybe<Scalars['ID']['input']>
  pricingData?: InputMaybe<Scalars['String']['input']>
  screenshots?: InputMaybe<Array<InputMaybe<IComponentGlobalPictureInput>>>
  testimonials?: InputMaybe<Array<InputMaybe<IComponentTestimonialsTestimonialsInput>>>
  videos?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsVideoInput>>>
}

export type IComponentSolutionSolutionsFollowing = {
  __typename?: 'ComponentSolutionSolutionsFollowing'
  followingSolutionNote?: Maybe<Scalars['String']['output']>
  followingType?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  solutions?: Maybe<ISolution>
}

export type IComponentSolutionSolutionsFollowingFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSolutionSolutionsFollowingFiltersInput>>>
  followingSolutionNote?: InputMaybe<IStringFilterInput>
  followingType?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentSolutionSolutionsFollowingFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentSolutionSolutionsFollowingFiltersInput>>>
  solutions?: InputMaybe<ISolutionFiltersInput>
}

export type IComponentSolutionSolutionsFollowingInput = {
  followingSolutionNote?: InputMaybe<Scalars['String']['input']>
  followingType?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  solutions?: InputMaybe<Scalars['ID']['input']>
}

export type IComponentSourcesSources = {
  __typename?: 'ComponentSourcesSources'
  ContentType?: Maybe<Scalars['String']['output']>
  Description?: Maybe<Scalars['String']['output']>
  Logo?: Maybe<Scalars['String']['output']>
  Title?: Maybe<Scalars['String']['output']>
  URL?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
}

export type IComponentSourcesSourcesFiltersInput = {
  ContentType?: InputMaybe<IStringFilterInput>
  Description?: InputMaybe<IStringFilterInput>
  Logo?: InputMaybe<IStringFilterInput>
  Title?: InputMaybe<IStringFilterInput>
  URL?: InputMaybe<IStringFilterInput>
  and?: InputMaybe<Array<InputMaybe<IComponentSourcesSourcesFiltersInput>>>
  not?: InputMaybe<IComponentSourcesSourcesFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentSourcesSourcesFiltersInput>>>
}

export type IComponentSourcesSourcesInput = {
  ContentType?: InputMaybe<Scalars['String']['input']>
  Description?: InputMaybe<Scalars['String']['input']>
  Logo?: InputMaybe<Scalars['String']['input']>
  Title?: InputMaybe<Scalars['String']['input']>
  URL?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
}

export type IComponentTestimonialsPropsAuthor = {
  __typename?: 'ComponentTestimonialsPropsAuthor'
  avatar?: Maybe<IUploadFile>
  company?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  role?: Maybe<Scalars['String']['output']>
}

export type IComponentTestimonialsPropsAuthorFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentTestimonialsPropsAuthorFiltersInput>>>
  company?: InputMaybe<IStringFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentTestimonialsPropsAuthorFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentTestimonialsPropsAuthorFiltersInput>>>
  role?: InputMaybe<IStringFilterInput>
}

export type IComponentTestimonialsPropsAuthorInput = {
  avatar?: InputMaybe<Scalars['ID']['input']>
  company?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  role?: InputMaybe<Scalars['String']['input']>
}

export type IComponentTestimonialsTestimonials = {
  __typename?: 'ComponentTestimonialsTestimonials'
  author?: Maybe<IComponentTestimonialsPropsAuthor>
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
}

export type IComponentTestimonialsTestimonialsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentTestimonialsTestimonialsFiltersInput>>>
  author?: InputMaybe<IComponentTestimonialsPropsAuthorFiltersInput>
  description?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentTestimonialsTestimonialsFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentTestimonialsTestimonialsFiltersInput>>>
}

export type IComponentTestimonialsTestimonialsInput = {
  author?: InputMaybe<IComponentTestimonialsPropsAuthorInput>
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
}

export type IComponentUserPortfolioCustomTag = {
  __typename?: 'ComponentUserPortfolioCustomTag'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  slug?: Maybe<Scalars['String']['output']>
  solutionIds?: Maybe<Scalars['JSON']['output']>
}

export type IComponentUserPortfolioCustomTagFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentUserPortfolioCustomTagFiltersInput>>>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentUserPortfolioCustomTagFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentUserPortfolioCustomTagFiltersInput>>>
  slug?: InputMaybe<IStringFilterInput>
  solutionIds?: InputMaybe<IJsonFilterInput>
}

export type IComponentUserPortfolioCustomTagInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  solutionIds?: InputMaybe<Scalars['JSON']['input']>
}

export type IComponentVendorPropsConsolidation = {
  __typename?: 'ComponentVendorPropsConsolidation'
  amount?: Maybe<Scalars['Int']['output']>
  article?: Maybe<Scalars['String']['output']>
  articleLink?: Maybe<Scalars['String']['output']>
  buyer?: Maybe<Scalars['String']['output']>
  date?: Maybe<Scalars['Date']['output']>
  enableInActiveDir?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
}

export type IComponentVendorPropsEnhancedlisting = {
  __typename?: 'ComponentVendorPropsEnhancedlisting'
  callToAction?: Maybe<IComponentGlobalCallToAction>
  id: Scalars['ID']['output']
  pricingData?: Maybe<Scalars['String']['output']>
  screenShots?: Maybe<Array<Maybe<IComponentGlobalPicture>>>
  testimonials?: Maybe<Array<Maybe<IComponentGlobalTestimonial>>>
  vendorResources?: Maybe<Array<Maybe<IComponentVendorPropsPoC>>>
  videos?: Maybe<Array<Maybe<IComponentVendorPropsVideo>>>
}

export type IComponentVendorPropsEnhancedlistingScreenShotsArgs = {
  filters?: InputMaybe<IComponentGlobalPictureFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentVendorPropsEnhancedlistingTestimonialsArgs = {
  filters?: InputMaybe<IComponentGlobalTestimonialFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentVendorPropsEnhancedlistingVendorResourcesArgs = {
  filters?: InputMaybe<IComponentVendorPropsPoCFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentVendorPropsEnhancedlistingVideosArgs = {
  filters?: InputMaybe<IComponentVendorPropsVideoFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IComponentVendorPropsGraveyard = {
  __typename?: 'ComponentVendorPropsGraveyard'
  date?: Maybe<Scalars['Date']['output']>
  id: Scalars['ID']['output']
}

export type IComponentVendorPropsPoC = {
  __typename?: 'ComponentVendorPropsPoC'
  author?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  link?: Maybe<Scalars['String']['output']>
  publishedDate?: Maybe<Scalars['Date']['output']>
  summary?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  type?: Maybe<IEnum_Componentvendorpropspoc_Type>
}

export type IComponentVendorPropsPoCFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentVendorPropsPoCFiltersInput>>>
  author?: InputMaybe<IStringFilterInput>
  link?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IComponentVendorPropsPoCFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentVendorPropsPoCFiltersInput>>>
  publishedDate?: InputMaybe<IDateFilterInput>
  summary?: InputMaybe<IStringFilterInput>
  title?: InputMaybe<IStringFilterInput>
  type?: InputMaybe<IStringFilterInput>
}

export type IComponentVendorPropsPoCInput = {
  author?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  publishedDate?: InputMaybe<Scalars['Date']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<IEnum_Componentvendorpropspoc_Type>
}

export type IComponentVendorPropsPricingResource = {
  __typename?: 'ComponentVendorPropsPricingResource'
  id: Scalars['ID']['output']
  label?: Maybe<Scalars['String']['output']>
  link?: Maybe<Scalars['String']['output']>
}

export type IComponentVendorPropsVideo = {
  __typename?: 'ComponentVendorPropsVideo'
  id: Scalars['ID']['output']
  summary?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type IComponentVendorPropsVideoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentVendorPropsVideoFiltersInput>>>
  not?: InputMaybe<IComponentVendorPropsVideoFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IComponentVendorPropsVideoFiltersInput>>>
  summary?: InputMaybe<IStringFilterInput>
  title?: InputMaybe<IStringFilterInput>
  url?: InputMaybe<IStringFilterInput>
}

export type IComponentVendorPropsVideoInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type IConfiguration = {
  __typename?: 'Configuration'
  NonRegisteredFreeArticleLimit: Scalars['Int']['output']
  NonRegisteredFreeLTHNavigatorSearchLimit: Scalars['Int']['output']
  NonRegisteredFreeSearchLimit: Scalars['Int']['output']
  RegisteredFreeArticleLimit: Scalars['Int']['output']
  RegisteredFreeLTHNavigatorSearchLimit: Scalars['Int']['output']
  RegisteredFreeSearchLimit: Scalars['Int']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IConfigurationInput = {
  NonRegisteredFreeArticleLimit?: InputMaybe<Scalars['Int']['input']>
  NonRegisteredFreeLTHNavigatorSearchLimit?: InputMaybe<Scalars['Int']['input']>
  NonRegisteredFreeSearchLimit?: InputMaybe<Scalars['Int']['input']>
  RegisteredFreeArticleLimit?: InputMaybe<Scalars['Int']['input']>
  RegisteredFreeLTHNavigatorSearchLimit?: InputMaybe<Scalars['Int']['input']>
  RegisteredFreeSearchLimit?: InputMaybe<Scalars['Int']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IConsultantListingRequest = {
  audiences?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  ceoEmail?: InputMaybe<Scalars['String']['input']>
  ceoName?: InputMaybe<Scalars['String']['input']>
  hqs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  isCreate?: InputMaybe<Scalars['Boolean']['input']>
  lanuages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  listingName?: InputMaybe<Scalars['String']['input']>
  logo?: InputMaybe<Scalars['ID']['input']>
  longDescription?: InputMaybe<Scalars['String']['input']>
  marketEmail?: InputMaybe<Scalars['String']['input']>
  marketName?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  offices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  phone?: InputMaybe<Scalars['String']['input']>
  regionsServed?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  serviceName?: InputMaybe<Scalars['String']['input']>
  serviceOfferings?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  shortDescription?: InputMaybe<Scalars['String']['input']>
  size?: InputMaybe<Scalars['Int']['input']>
  userEmail?: InputMaybe<Scalars['String']['input']>
  userName?: InputMaybe<Scalars['String']['input']>
  userRole?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  yearFounded?: InputMaybe<Scalars['Int']['input']>
}

export type IContactHistory = {
  __typename?: 'ContactHistory'
  company?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  email: Scalars['String']['output']
  firstName: Scalars['String']['output']
  lastName: Scalars['String']['output']
  message: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IContactHistoryEntityResponseCollection = {
  __typename?: 'ContactHistoryEntityResponseCollection'
  nodes: Array<IContactHistory>
  pageInfo: IPagination
}

export type IContactHistoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IContactHistoryFiltersInput>>>
  company?: InputMaybe<IStringFilterInput>
  country?: InputMaybe<IStringFilterInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  email?: InputMaybe<IStringFilterInput>
  firstName?: InputMaybe<IStringFilterInput>
  lastName?: InputMaybe<IStringFilterInput>
  message?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IContactHistoryFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IContactHistoryFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IContactHistoryInput = {
  company?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IContent = {
  __typename?: 'Content'
  audiences: Array<Maybe<IPremiumAudience>>
  audiences_connection?: Maybe<IPremiumAudienceRelationResponseCollection>
  authorVendor?: Maybe<ISolution>
  blogTaxonomies: Array<Maybe<IBlogTaxonomy>>
  blogTaxonomies_connection?: Maybe<IBlogTaxonomyRelationResponseCollection>
  collections: Array<Maybe<ICollection>>
  collections_connection?: Maybe<ICollectionRelationResponseCollection>
  contentType?: Maybe<IEnum_Content_Contenttype>
  content_download: Array<Maybe<IContentDownload>>
  content_download_connection?: Maybe<IContentDownloadRelationResponseCollection>
  content_visit: Array<Maybe<IContentVisit>>
  content_visit_connection?: Maybe<IContentVisitRelationResponseCollection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  defaultImage: Array<Maybe<IUploadFile>>
  defaultImage_connection?: Maybe<IUploadFileRelationResponseCollection>
  documentId: Scalars['ID']['output']
  documentType?: Maybe<IEnum_Content_Documenttype>
  downloadMaterial?: Maybe<IComponentContentDownloadMaterial>
  includeInVendorContents?: Maybe<Scalars['Boolean']['output']>
  isLatestBlog?: Maybe<Scalars['Boolean']['output']>
  isMaintained?: Maybe<Scalars['Boolean']['output']>
  isPremium?: Maybe<Scalars['Boolean']['output']>
  isTrending?: Maybe<Scalars['Boolean']['output']>
  lastMaintained?: Maybe<Scalars['Date']['output']>
  phase?: Maybe<IPhase>
  practiceAreas: Array<Maybe<IPracticeArea>>
  practiceAreas_connection?: Maybe<IPracticeAreaRelationResponseCollection>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  publishedTime?: Maybe<Scalars['Date']['output']>
  resourceSolutions: Array<Maybe<ISolution>>
  resourceSolutions_connection?: Maybe<ISolutionRelationResponseCollection>
  resource_invitations: Array<Maybe<IResourceInvitation>>
  resource_invitations_connection?: Maybe<IResourceInvitationRelationResponseCollection>
  slug: Scalars['String']['output']
  snippet: Scalars['String']['output']
  subTopics: Array<Maybe<ISubTopic>>
  subTopics_connection?: Maybe<ISubTopicRelationResponseCollection>
  subjectMatterIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  subjectMatters: Array<Maybe<ISubjectMatter>>
  subjectMatters_connection?: Maybe<ISubjectMatterRelationResponseCollection>
  themeIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  themes: Array<Maybe<ITheme>>
  themes_connection?: Maybe<IThemeRelationResponseCollection>
  title: Scalars['String']['output']
  topics: Array<Maybe<ITopic>>
  topics_connection?: Maybe<ITopicRelationResponseCollection>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  vendorTopicIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  vendorTopics: Array<Maybe<IVendorTopic>>
  vendorTopics_connection?: Maybe<IVendorTopicRelationResponseCollection>
  writer?: Maybe<Array<Maybe<IComponentContentContentWriter>>>
}

export type IContentAudiencesArgs = {
  filters?: InputMaybe<IPremiumAudienceFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentAudiences_ConnectionArgs = {
  filters?: InputMaybe<IPremiumAudienceFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentBlogTaxonomiesArgs = {
  filters?: InputMaybe<IBlogTaxonomyFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentBlogTaxonomies_ConnectionArgs = {
  filters?: InputMaybe<IBlogTaxonomyFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentCollectionsArgs = {
  filters?: InputMaybe<ICollectionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentCollections_ConnectionArgs = {
  filters?: InputMaybe<ICollectionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentContent_DownloadArgs = {
  filters?: InputMaybe<IContentDownloadFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentContent_Download_ConnectionArgs = {
  filters?: InputMaybe<IContentDownloadFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentContent_VisitArgs = {
  filters?: InputMaybe<IContentVisitFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentContent_Visit_ConnectionArgs = {
  filters?: InputMaybe<IContentVisitFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentDefaultImageArgs = {
  filters?: InputMaybe<IUploadFileFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentDefaultImage_ConnectionArgs = {
  filters?: InputMaybe<IUploadFileFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentPracticeAreasArgs = {
  filters?: InputMaybe<IPracticeAreaFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentPracticeAreas_ConnectionArgs = {
  filters?: InputMaybe<IPracticeAreaFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentResourceSolutionsArgs = {
  filters?: InputMaybe<ISolutionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentResourceSolutions_ConnectionArgs = {
  filters?: InputMaybe<ISolutionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentResource_InvitationsArgs = {
  filters?: InputMaybe<IResourceInvitationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentResource_Invitations_ConnectionArgs = {
  filters?: InputMaybe<IResourceInvitationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentSubTopicsArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentSubTopics_ConnectionArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentSubjectMattersArgs = {
  filters?: InputMaybe<ISubjectMatterFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentSubjectMatters_ConnectionArgs = {
  filters?: InputMaybe<ISubjectMatterFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentThemesArgs = {
  filters?: InputMaybe<IThemeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentThemes_ConnectionArgs = {
  filters?: InputMaybe<IThemeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentTopicsArgs = {
  filters?: InputMaybe<ITopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentTopics_ConnectionArgs = {
  filters?: InputMaybe<ITopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentVendorTopicsArgs = {
  filters?: InputMaybe<IVendorTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentVendorTopics_ConnectionArgs = {
  filters?: InputMaybe<IVendorTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentWriterArgs = {
  filters?: InputMaybe<IComponentContentContentWriterFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IContentDownload = {
  __typename?: 'ContentDownload'
  content?: Maybe<IContent>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  downloaded_at?: Maybe<Scalars['DateTime']['output']>
  downloaded_by?: Maybe<IUser>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IContentDownloadEntityResponseCollection = {
  __typename?: 'ContentDownloadEntityResponseCollection'
  nodes: Array<IContentDownload>
  pageInfo: IPagination
}

export type IContentDownloadFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IContentDownloadFiltersInput>>>
  content?: InputMaybe<IContentFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  downloaded_at?: InputMaybe<IDateTimeFilterInput>
  downloaded_by?: InputMaybe<IUserFiltersInput>
  not?: InputMaybe<IContentDownloadFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IContentDownloadFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IContentDownloadInput = {
  content?: InputMaybe<Scalars['ID']['input']>
  downloaded_at?: InputMaybe<Scalars['DateTime']['input']>
  downloaded_by?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IContentDownloadRelationResponseCollection = {
  __typename?: 'ContentDownloadRelationResponseCollection'
  nodes: Array<IContentDownload>
}

export type IContentEntity = {
  __typename?: 'ContentEntity'
  attributes?: Maybe<IContent>
  id?: Maybe<Scalars['ID']['output']>
}

export type IContentEntityBySlug = {
  __typename?: 'ContentEntityBySlug'
  content: IContentEntity
  freeArticleLeft?: Maybe<Scalars['Int']['output']>
  includeInKnowHow?: Maybe<Scalars['Boolean']['output']>
  includeInLegalTechForLawyers?: Maybe<Scalars['Boolean']['output']>
  includeInVendorContents?: Maybe<Scalars['Boolean']['output']>
  isFreeArticle?: Maybe<Scalars['Boolean']['output']>
  isInvited?: Maybe<Scalars['Boolean']['output']>
  isUserVendor?: Maybe<Scalars['Boolean']['output']>
  resourcePublishedAt?: Maybe<Scalars['String']['output']>
  vendorSelfContent?: Maybe<Scalars['Boolean']['output']>
}

export type IContentEntityResponseCollection = {
  __typename?: 'ContentEntityResponseCollection'
  nodes: Array<IContent>
  pageInfo: IPagination
}

export type IContentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IContentFiltersInput>>>
  audiences?: InputMaybe<IPremiumAudienceFiltersInput>
  authorVendor?: InputMaybe<ISolutionFiltersInput>
  blogTaxonomies?: InputMaybe<IBlogTaxonomyFiltersInput>
  collections?: InputMaybe<ICollectionFiltersInput>
  contentType?: InputMaybe<IStringFilterInput>
  content_download?: InputMaybe<IContentDownloadFiltersInput>
  content_visit?: InputMaybe<IContentVisitFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  documentType?: InputMaybe<IStringFilterInput>
  downloadMaterial?: InputMaybe<IComponentContentDownloadMaterialFiltersInput>
  includeInVendorContents?: InputMaybe<IBooleanFilterInput>
  isLatestBlog?: InputMaybe<IBooleanFilterInput>
  isMaintained?: InputMaybe<IBooleanFilterInput>
  isPremium?: InputMaybe<IBooleanFilterInput>
  isTrending?: InputMaybe<IBooleanFilterInput>
  lastMaintained?: InputMaybe<IDateFilterInput>
  not?: InputMaybe<IContentFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IContentFiltersInput>>>
  phase?: InputMaybe<IPhaseFiltersInput>
  practiceAreas?: InputMaybe<IPracticeAreaFiltersInput>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  publishedTime?: InputMaybe<IDateFilterInput>
  resourceSolutions?: InputMaybe<ISolutionFiltersInput>
  resource_invitations?: InputMaybe<IResourceInvitationFiltersInput>
  slug?: InputMaybe<IStringFilterInput>
  snippet?: InputMaybe<IStringFilterInput>
  subTopics?: InputMaybe<ISubTopicFiltersInput>
  subjectMatters?: InputMaybe<ISubjectMatterFiltersInput>
  themes?: InputMaybe<IThemeFiltersInput>
  title?: InputMaybe<IStringFilterInput>
  topics?: InputMaybe<ITopicFiltersInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
  vendorTopics?: InputMaybe<IVendorTopicFiltersInput>
  writer?: InputMaybe<IComponentContentContentWriterFiltersInput>
}

export type IContentId = {
  content_id: Scalars['ID']['input']
}

export type IContentInput = {
  audiences?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  authorVendor?: InputMaybe<Scalars['ID']['input']>
  blogTaxonomies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  collections?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  content?: InputMaybe<Scalars['String']['input']>
  contentType?: InputMaybe<IEnum_Content_Contenttype>
  content_download?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  content_visit?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  defaultImage?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  documentType?: InputMaybe<IEnum_Content_Documenttype>
  downloadMaterial?: InputMaybe<IComponentContentDownloadMaterialInput>
  featuredCategories?: InputMaybe<IComponentContentFeaturedCategoriesInput>
  includeInKnowHow?: InputMaybe<Scalars['Boolean']['input']>
  includeInLegalTechForLawyers?: InputMaybe<Scalars['Boolean']['input']>
  includeInVendorContents?: InputMaybe<Scalars['Boolean']['input']>
  isLatestBlog?: InputMaybe<Scalars['Boolean']['input']>
  isMaintained?: InputMaybe<Scalars['Boolean']['input']>
  isPremium?: InputMaybe<Scalars['Boolean']['input']>
  isTrending?: InputMaybe<Scalars['Boolean']['input']>
  lastMaintained?: InputMaybe<Scalars['Date']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  phase?: InputMaybe<Scalars['ID']['input']>
  practiceAreas?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  publishedTime?: InputMaybe<Scalars['Date']['input']>
  resourceSolutions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  resource_invitations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  slug?: InputMaybe<Scalars['String']['input']>
  snippet?: InputMaybe<Scalars['String']['input']>
  subTopics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  subjectMatters?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  themes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  title?: InputMaybe<Scalars['String']['input']>
  topics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  vendorTopics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  writer?: InputMaybe<Array<InputMaybe<IComponentContentContentWriterInput>>>
}

export type IContentItem = {
  __typename?: 'ContentItem'
  contentType?: Maybe<IEnum_Content_Contenttype>
  defaultImage?: Maybe<Scalars['String']['output']>
  documentId: Scalars['String']['output']
  documentType?: Maybe<IEnum_Content_Documenttype>
  id: Scalars['Int']['output']
  includeInKnowHow?: Maybe<Scalars['Boolean']['output']>
  includeInLegalTechForLawyers?: Maybe<Scalars['Boolean']['output']>
  includeInVendorContents?: Maybe<Scalars['Boolean']['output']>
  isMaintained?: Maybe<Scalars['Boolean']['output']>
  lastMaintainedAt?: Maybe<Scalars['DateTime']['output']>
  practiceArea?: Maybe<Scalars['String']['output']>
  practiceAreaIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  publishedAt: Scalars['DateTime']['output']
  publishedTime: Scalars['DateTime']['output']
  resourceSolutionIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  resourceSolutions?: Maybe<Scalars['String']['output']>
  slug: Scalars['String']['output']
  snippet: Scalars['String']['output']
  subTopicIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  subTopics?: Maybe<Scalars['String']['output']>
  subjectMatterIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  subjectMatters?: Maybe<Scalars['String']['output']>
  themeIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  themes?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  vendorTopicIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  vendorTopics?: Maybe<Scalars['String']['output']>
  writer?: Maybe<IContentItemWriter>
  writers?: Maybe<Array<IContentItemWriter>>
}

export type IContentItemWriter = {
  __typename?: 'ContentItemWriter'
  avatar?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  title?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
  writerOption: IEnum_Componentcontentcontentwriter_Writeroption
}

export type IContentRelationResponseCollection = {
  __typename?: 'ContentRelationResponseCollection'
  nodes: Array<IContent>
}

export type IContentSearchResult = {
  __typename?: 'ContentSearchResult'
  contents?: Maybe<Array<Maybe<IContentItem>>>
  total?: Maybe<Scalars['Int']['output']>
}

export type IContentSearchReturnType = {
  __typename?: 'ContentSearchReturnType'
  data?: Maybe<IContentSearchResult>
  success?: Maybe<Scalars['Boolean']['output']>
}

export type IContentVisit = {
  __typename?: 'ContentVisit'
  content?: Maybe<IContent>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  visited_at?: Maybe<Scalars['DateTime']['output']>
  visited_by?: Maybe<IUser>
}

export type IContentVisitDownloadCountResult = {
  __typename?: 'ContentVisitDownloadCountResult'
  downloads?: Maybe<Array<Maybe<IContentDownload>>>
  visits?: Maybe<Array<Maybe<IContentVisit>>>
}

export type IContentVisitEntityResponseCollection = {
  __typename?: 'ContentVisitEntityResponseCollection'
  nodes: Array<IContentVisit>
  pageInfo: IPagination
}

export type IContentVisitFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IContentVisitFiltersInput>>>
  content?: InputMaybe<IContentFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  not?: InputMaybe<IContentVisitFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IContentVisitFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
  visited_at?: InputMaybe<IDateTimeFilterInput>
  visited_by?: InputMaybe<IUserFiltersInput>
}

export type IContentVisitInput = {
  content?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  visited_at?: InputMaybe<Scalars['DateTime']['input']>
  visited_by?: InputMaybe<Scalars['ID']['input']>
}

export type IContentVisitRelationResponseCollection = {
  __typename?: 'ContentVisitRelationResponseCollection'
  nodes: Array<IContentVisit>
}

export type ICountry = {
  __typename?: 'Country'
  alpha2: Scalars['String']['output']
  alpha3?: Maybe<Scalars['String']['output']>
  code: Scalars['String']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ICountryEntityResponseCollection = {
  __typename?: 'CountryEntityResponseCollection'
  nodes: Array<ICountry>
  pageInfo: IPagination
}

export type ICountryFiltersInput = {
  alpha2?: InputMaybe<IStringFilterInput>
  alpha3?: InputMaybe<IStringFilterInput>
  and?: InputMaybe<Array<InputMaybe<ICountryFiltersInput>>>
  code?: InputMaybe<IStringFilterInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<ICountryFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ICountryFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type ICountryInput = {
  alpha2?: InputMaybe<Scalars['String']['input']>
  alpha3?: InputMaybe<Scalars['String']['input']>
  code?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ICustomTag = {
  __typename?: 'CustomTag'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdByUser?: Maybe<IUser>
  documentId: Scalars['ID']['output']
  isSharedPortfolio?: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
  portfolioId?: Maybe<Scalars['String']['output']>
  premiumOrganization?: Maybe<IPremiumOrganization>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  solutionIds?: Maybe<Scalars['JSON']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ICustomTagEntityResponseCollection = {
  __typename?: 'CustomTagEntityResponseCollection'
  nodes: Array<ICustomTag>
  pageInfo: IPagination
}

export type ICustomTagFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ICustomTagFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  createdByUser?: InputMaybe<IUserFiltersInput>
  documentId?: InputMaybe<IIdFilterInput>
  isSharedPortfolio?: InputMaybe<IBooleanFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<ICustomTagFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ICustomTagFiltersInput>>>
  portfolioId?: InputMaybe<IStringFilterInput>
  premiumOrganization?: InputMaybe<IPremiumOrganizationFiltersInput>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  slug?: InputMaybe<IStringFilterInput>
  solutionIds?: InputMaybe<IJsonFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type ICustomTagInput = {
  createdByUser?: InputMaybe<Scalars['ID']['input']>
  isSharedPortfolio?: InputMaybe<Scalars['Boolean']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  portfolioId?: InputMaybe<Scalars['String']['input']>
  premiumOrganization?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  solutionIds?: InputMaybe<Scalars['JSON']['input']>
}

export type ICustomTagItem = {
  __typename?: 'CustomTagItem'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  slug: Scalars['String']['output']
}

export type ICustomTagResult = {
  __typename?: 'CustomTagResult'
  id: Scalars['ID']['output']
  isSharedPortfolio?: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
  portfolioId?: Maybe<Scalars['String']['output']>
  sharedPortfolio?: Maybe<ISharedPortfolioSummary>
  slug?: Maybe<Scalars['String']['output']>
  solutionDocumentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  solutionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type IDateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>
  contains?: InputMaybe<Scalars['Date']['input']>
  containsi?: InputMaybe<Scalars['Date']['input']>
  endsWith?: InputMaybe<Scalars['Date']['input']>
  eq?: InputMaybe<Scalars['Date']['input']>
  eqi?: InputMaybe<Scalars['Date']['input']>
  gt?: InputMaybe<Scalars['Date']['input']>
  gte?: InputMaybe<Scalars['Date']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>
  lt?: InputMaybe<Scalars['Date']['input']>
  lte?: InputMaybe<Scalars['Date']['input']>
  ne?: InputMaybe<Scalars['Date']['input']>
  nei?: InputMaybe<Scalars['Date']['input']>
  not?: InputMaybe<IDateFilterInput>
  notContains?: InputMaybe<Scalars['Date']['input']>
  notContainsi?: InputMaybe<Scalars['Date']['input']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>
  notNull?: InputMaybe<Scalars['Boolean']['input']>
  null?: InputMaybe<Scalars['Boolean']['input']>
  or?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>
  startsWith?: InputMaybe<Scalars['Date']['input']>
}

export type IDateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  contains?: InputMaybe<Scalars['DateTime']['input']>
  containsi?: InputMaybe<Scalars['DateTime']['input']>
  endsWith?: InputMaybe<Scalars['DateTime']['input']>
  eq?: InputMaybe<Scalars['DateTime']['input']>
  eqi?: InputMaybe<Scalars['DateTime']['input']>
  gt?: InputMaybe<Scalars['DateTime']['input']>
  gte?: InputMaybe<Scalars['DateTime']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  lt?: InputMaybe<Scalars['DateTime']['input']>
  lte?: InputMaybe<Scalars['DateTime']['input']>
  ne?: InputMaybe<Scalars['DateTime']['input']>
  nei?: InputMaybe<Scalars['DateTime']['input']>
  not?: InputMaybe<IDateTimeFilterInput>
  notContains?: InputMaybe<Scalars['DateTime']['input']>
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  notNull?: InputMaybe<Scalars['Boolean']['input']>
  null?: InputMaybe<Scalars['Boolean']['input']>
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  startsWith?: InputMaybe<Scalars['DateTime']['input']>
}

export type IDeleteMutationResponse = {
  __typename?: 'DeleteMutationResponse'
  documentId: Scalars['ID']['output']
}

export type IDemographic = {
  __typename?: 'Demographic'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IDemographicEntityResponseCollection = {
  __typename?: 'DemographicEntityResponseCollection'
  nodes: Array<IDemographic>
  pageInfo: IPagination
}

export type IDemographicFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IDemographicFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IDemographicFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IDemographicFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IDemographicInput = {
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IDemographicRelationResponseCollection = {
  __typename?: 'DemographicRelationResponseCollection'
  nodes: Array<IDemographic>
}

export type IDuration = {
  __typename?: 'Duration'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  days?: Maybe<Scalars['Int']['output']>
  documentId: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IDurationEntityResponseCollection = {
  __typename?: 'DurationEntityResponseCollection'
  nodes: Array<IDuration>
  pageInfo: IPagination
}

export type IDurationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IDurationFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  days?: InputMaybe<IIntFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IDurationFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IDurationFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IDurationInput = {
  days?: InputMaybe<Scalars['Int']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export enum IEnum_Company_Fundingamount {
  FiftyToHundredM = 'Fifty_To_Hundred_M',
  FiveToTenM = 'Five_To_Ten_M',
  LessThanOneM = 'Less_than_One_M',
  MoreThanHundredM = 'More_Than_Hundred_M',
  NA = 'N_A',
  OneToFiveM = 'One_To_Five_M',
  TenToTwentyFiveM = 'Ten_To_TwentyFive_M',
  TwentyFiveToFiftyM = 'TwentyFive_To_Fifty_M',
}

export enum IEnum_Company_Fundinginfo {
  NA = 'N_A',
  Other = 'Other',
  PreSeed = 'Pre_Seed',
  Seed = 'Seed',
  SeriesA = 'Series_A',
  SeriesB = 'Series_B',
  SeriesC = 'Series_C',
  SeriesD = 'Series_D',
}

export enum IEnum_Componentconpropsdedicatedresource_Type {
  FullTime = 'FullTime',
  PartTime = 'PartTime',
}

export enum IEnum_Componentcontentcontentwriter_Writeroption {
  Author = 'Author',
  Expert = 'Expert',
  OneTimeAuthor = 'One_time_author',
  Vendor = 'Vendor',
}

export enum IEnum_Componentcontentdownloadmaterial_Format {
  Excel = 'Excel',
  Pdf = 'Pdf',
  Word = 'Word',
}

export enum IEnum_Componentinvitationsinvitations_Status {
  Accepted = 'Accepted',
  Pending = 'Pending',
  Sent = 'Sent',
}

export enum IEnum_Componentsolutionalspdata_Fundingamount {
  FiftyToHundredM = 'Fifty_To_Hundred_M',
  FiveToTenM = 'Five_To_Ten_M',
  LessThanOneM = 'Less_than_One_M',
  MoreThanHundredM = 'More_Than_Hundred_M',
  NA = 'N_A',
  OneToFiveM = 'One_To_Five_M',
  TenToTwentyFiveM = 'Ten_To_TwentyFive_M',
  TwentyFiveToFiftyM = 'TwentyFive_To_Fifty_M',
}

export enum IEnum_Componentsolutionalspdata_Fundinginfo {
  NA = 'N_A',
  Other = 'Other',
  PreSeed = 'Pre_Seed',
  Seed = 'Seed',
  SeriesA = 'Series_A',
  SeriesB = 'Series_B',
  SeriesC = 'Series_C',
  SeriesD = 'Series_D',
}

export enum IEnum_Componentsolutionconsultantdata_Fundingamount {
  FiftyToHundredM = 'Fifty_To_Hundred_M',
  FiveToTenM = 'Five_To_Ten_M',
  LessThanOneM = 'Less_than_One_M',
  MoreThanHundredM = 'More_Than_Hundred_M',
  NA = 'N_A',
  OneToFiveM = 'One_To_Five_M',
  TenToTwentyFiveM = 'Ten_To_TwentyFive_M',
  TwentyFiveToFiftyM = 'TwentyFive_To_Fifty_M',
}

export enum IEnum_Componentsolutionconsultantdata_Fundinginfo {
  NA = 'N_A',
  Other = 'Other',
  PreSeed = 'Pre_Seed',
  Seed = 'Seed',
  SeriesA = 'Series_A',
  SeriesB = 'Series_B',
  SeriesC = 'Series_C',
  SeriesD = 'Series_D',
}

export enum IEnum_Componentsolutionproductdata_Fundingamount {
  FiftyToHundredM = 'Fifty_To_Hundred_M',
  FiveToTenM = 'Five_To_Ten_M',
  LessThanOneM = 'Less_than_One_M',
  MoreThanHundredM = 'More_Than_Hundred_M',
  NA = 'N_A',
  OneToFiveM = 'One_To_Five_M',
  TenToTwentyFiveM = 'Ten_To_TwentyFive_M',
  TwentyFiveToFiftyM = 'TwentyFive_To_Fifty_M',
}

export enum IEnum_Componentsolutionproductdata_Fundinginfo {
  NA = 'N_A',
  Other = 'Other',
  PreSeed = 'Pre_Seed',
  Seed = 'Seed',
  SeriesA = 'Series_A',
  SeriesB = 'Series_B',
  SeriesC = 'Series_C',
  SeriesD = 'Series_D',
}

export enum IEnum_Componentsolutionpropsdedicatedresource_Type {
  FullTime = 'FullTime',
  PartTime = 'PartTime',
}

export enum IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype {
  Article = 'Article',
  CaseStudy = 'Case_Study',
  Checklist = 'Checklist',
  PracticalGuidance = 'Practical_Guidance',
  PressRelease = 'Press_Release',
  WhitePaper = 'White_Paper',
}

export enum IEnum_Componentsolutionpropsvendorresource_Type {
  Content = 'Content',
  External = 'External',
}

export enum IEnum_Componentsolutionrequestalspdata_Fundingamount {
  FiftyToHundredM = 'Fifty_To_Hundred_M',
  FiveToTenM = 'Five_To_Ten_M',
  LessThanOneM = 'Less_than_One_M',
  MoreThanHundredM = 'More_Than_Hundred_M',
  NA = 'N_A',
  OneToFiveM = 'One_To_Five_M',
  TenToTwentyFiveM = 'Ten_To_TwentyFive_M',
  TwentyFiveToFiftyM = 'TwentyFive_To_Fifty_M',
}

export enum IEnum_Componentsolutionrequestalspdata_Fundinginfo {
  NA = 'N_A',
  Other = 'Other',
  PreSeed = 'Pre_Seed',
  Seed = 'Seed',
  SeriesA = 'Series_A',
  SeriesB = 'Series_B',
  SeriesC = 'Series_C',
  SeriesD = 'Series_D',
}

export enum IEnum_Componentsolutionrequestconsultantdata_Fundingamount {
  FiftyToHundredM = 'Fifty_To_Hundred_M',
  FiveToTenM = 'Five_To_Ten_M',
  LessThanOneM = 'Less_than_One_M',
  MoreThanHundredM = 'More_Than_Hundred_M',
  NA = 'N_A',
  OneToFiveM = 'One_To_Five_M',
  TenToTwentyFiveM = 'Ten_To_TwentyFive_M',
  TwentyFiveToFiftyM = 'TwentyFive_To_Fifty_M',
}

export enum IEnum_Componentsolutionrequestconsultantdata_Fundinginfo {
  NA = 'N_A',
  Other = 'Other',
  PreSeed = 'Pre_Seed',
  Seed = 'Seed',
  SeriesA = 'Series_A',
  SeriesB = 'Series_B',
  SeriesC = 'Series_C',
  SeriesD = 'Series_D',
}

export enum IEnum_Componentsolutionrequestproductdata_Fundingamount {
  FiftyToHundredM = 'Fifty_To_Hundred_M',
  FiveToTenM = 'Five_To_Ten_M',
  LessThanOneM = 'Less_than_One_M',
  MoreThanHundredM = 'More_Than_Hundred_M',
  NA = 'N_A',
  OneToFiveM = 'One_To_Five_M',
  TenToTwentyFiveM = 'Ten_To_TwentyFive_M',
  TwentyFiveToFiftyM = 'TwentyFive_To_Fifty_M',
}

export enum IEnum_Componentsolutionrequestproductdata_Fundinginfo {
  NA = 'N_A',
  Other = 'Other',
  PreSeed = 'Pre_Seed',
  Seed = 'Seed',
  SeriesA = 'Series_A',
  SeriesB = 'Series_B',
  SeriesC = 'Series_C',
  SeriesD = 'Series_D',
}

export enum IEnum_Componentvendorpropspoc_Type {
  Article = 'Article',
  CaseStudy = 'CaseStudy',
  PressRelease = 'PressRelease',
  Whitepaper = 'Whitepaper',
}

export enum IEnum_Content_Contenttype {
  Blog = 'Blog',
  BusinessCase = 'Business_Case',
  BuyersGuide = 'Buyers_Guide',
  CompetitiveAnalysis = 'Competitive_Analysis',
  EvaluationFramework = 'Evaluation_Framework',
  IndustryAnalysis = 'Industry_Analysis',
  KnowHow = 'KnowHow',
  LandscapeArticle = 'Landscape_Article',
  LegaltechResourcesForLawyers = 'Legaltech_Resources_for_Lawyers',
  PilotGuide = 'Pilot_Guide',
  PremiumResource = 'Premium_Resource',
  RequirementsTemplate = 'Requirements_Template',
  ThoughtLeadership = 'Thought_Leadership',
  VendorAnalysis = 'Vendor_Analysis',
  VendorContent = 'Vendor_Content',
  VendorResource = 'Vendor_Resource',
}

export enum IEnum_Content_Documenttype {
  Article = 'Article',
  CaseStudy = 'Case_Study',
  Checklist = 'Checklist',
  PracticalGuidance = 'Practical_Guidance',
  PressRelease = 'Press_Release',
  ProductBriefing = 'Product_Briefing',
  Review = 'Review',
  Template = 'Template',
  WhitePaper = 'White_Paper',
}

export enum IEnum_Listingrequest_Basicorenhanced {
  Basic = 'Basic',
  Enhanced = 'Enhanced',
}

export enum IEnum_Listingrequest_Createorupdate {
  Create = 'Create',
  Update = 'Update',
}

export enum IEnum_Listingrequest_Listingtype {
  Alsp = 'ALSP',
  Consultant = 'Consultant',
  Vendor = 'Vendor',
}

export enum IEnum_Listingrequest_Status {
  Assigned = 'Assigned',
  Completed = 'Completed',
  Initial = 'Initial',
  Review = 'Review',
}

export enum IEnum_Premiumorganization_Premiumorganizationstatus {
  Paid = 'Paid',
  RegisteredNotPaid = 'Registered_Not_Paid',
  Reviewing = 'Reviewing',
}

export enum IEnum_Premiumpricingplan_Companysize {
  AlspInEarlyStage = 'ALSP_in_early_stage',
  AlspInMatureStage = 'ALSP_in_mature_stage',
  ConsultantWithLessThan_25Consultants = 'Consultant_with_less_than_25_consultants',
  ConsultantWithMoreThan_25Consultants = 'Consultant_with_more_than_25_consultants',
  Employees_1To_10 = 'Employees_1_to_10',
  Employees_11To_50 = 'Employees_11_to_50',
  Employees_51To_200 = 'Employees_51_to_200',
  Employees_201To_500 = 'Employees_201_to_500',
  Employees_501To_1000 = 'Employees_501_to_1000',
  EmployeesMoreThan_1000 = 'Employees_more_than_1000',
  LawFirmWith_5To_25Lawyers = 'Law_firm_with_5_to_25_lawyers',
  LawFirmWith_25To_100Lawyers = 'Law_firm_with_25_to_100_lawyers',
  LawFirmWith_100To_250Lawyers = 'Law_firm_with_100_to_250_lawyers',
  LawFirmWith_250To_1000Lawyers = 'Law_firm_with_250_to_1000_lawyers',
  LawFirmWithLessThan_5Lawyers = 'Law_firm_with_less_than_5_lawyers',
  LawFirmWithMoreThan_1000Lawyers = 'Law_firm_with_more_than_1000_lawyers',
  LegalTechVendorInEarlyStage = 'Legal_Tech_Vendor_in_early_stage',
  LegalTechVendorInMatureStage = 'Legal_Tech_Vendor_in_mature_stage',
  LegalDepartmentWith_5To_25Lawyers = 'Legal_department_with_5_to_25_lawyers',
  LegalDepartmentWith_25To_100Lawyers = 'Legal_department_with_25_to_100_lawyers',
  LegalDepartmentWithLessThan_5Lawyers = 'Legal_department_with_less_than_5_lawyers',
  LegalDepartmentWithMoreThan_100Lawyers = 'Legal_department_with_more_than_100_lawyers',
  Other = 'Other',
}

export enum IEnum_Premiumpricingplan_Companytype {
  Alsp = 'ALSP',
  Consultant = 'Consultant',
  LawDepartment = 'Law_department',
  LawFirm = 'Law_firm',
  Other = 'Other',
  Vendor = 'Vendor',
}

export enum IEnum_Review_Status {
  Approved = 'Approved',
  InReview = 'InReview',
  Rejected = 'Rejected',
  Submitted = 'Submitted',
}

export enum IEnum_Sharedportfoliomembership_Role {
  Admin = 'admin',
  Editor = 'editor',
}

export enum IEnum_Sharedportfoliosolution_Category {
  Following = 'Following',
  Portfolio = 'Portfolio',
  Reviewed = 'Reviewed',
  Watching = 'Watching',
}

export enum IEnum_Solutionrequest_Type {
  Alsp = 'ALSP',
  Consultancy = 'Consultancy',
  Product = 'Product',
}

export enum IEnum_Solution_Item_Type {
  Alsp = 'ALSP',
  Company = 'Company',
  Consultancy = 'Consultancy',
  Product = 'Product',
}

export enum IEnum_Solution_Producttype {
  Consolidation = 'consolidation',
  Default = 'default',
  Graveyard = 'graveyard',
}

export enum IEnum_Solution_Solutionlevel {
  Engaged = 'Engaged',
  Free = 'Free',
  Standard = 'Standard',
  Strategic = 'Strategic',
}

export enum IEnum_Solution_Type {
  Alsp = 'ALSP',
  Consultancy = 'Consultancy',
  Product = 'Product',
}

export enum IEnum_User_Companysize {
  AlspInEarlyStage = 'ALSP_in_early_stage',
  AlspInMatureStage = 'ALSP_in_mature_stage',
  Angel = 'Angel',
  ConsultantWithLessThan_25Consultants = 'Consultant_with_less_than_25_consultants',
  ConsultantWithMoreThan_25Consultants = 'Consultant_with_more_than_25_consultants',
  Employees_1To_10 = 'Employees_1_to_10',
  Employees_11To_50 = 'Employees_11_to_50',
  Employees_51To_200 = 'Employees_51_to_200',
  Employees_201To_500 = 'Employees_201_to_500',
  Employees_501To_1000 = 'Employees_501_to_1000',
  EmployeesMoreThan_1000 = 'Employees_more_than_1000',
  LawFirmWith_5To_25Lawyers = 'Law_firm_with_5_to_25_lawyers',
  LawFirmWith_25To_100Lawyers = 'Law_firm_with_25_to_100_lawyers',
  LawFirmWith_100To_250Lawyers = 'Law_firm_with_100_to_250_lawyers',
  LawFirmWith_250To_1000Lawyers = 'Law_firm_with_250_to_1000_lawyers',
  LawFirmWithLessThan_5Lawyers = 'Law_firm_with_less_than_5_lawyers',
  LawFirmWithMoreThan_1000Lawyers = 'Law_firm_with_more_than_1000_lawyers',
  LegalTechVendorInEarlyStage = 'Legal_Tech_Vendor_in_early_stage',
  LegalTechVendorInMatureStage = 'Legal_Tech_Vendor_in_mature_stage',
  LegalDepartmentWith_5To_25Lawyers = 'Legal_department_with_5_to_25_lawyers',
  LegalDepartmentWith_25To_100Lawyers = 'Legal_department_with_25_to_100_lawyers',
  LegalDepartmentWithLessThan_5Lawyers = 'Legal_department_with_less_than_5_lawyers',
  LegalDepartmentWithMoreThan_100Lawyers = 'Legal_department_with_more_than_100_lawyers',
  Other = 'Other',
  PrivateEquityFirm = 'Private_Equity_Firm',
  Vc = 'VC',
  VendorOrganizationWith_10To_20 = 'Vendor_organization_with_10_to_20',
  VendorOrganizationWith_20To_50 = 'Vendor_organization_with_20_to_50',
  VendorOrganizationWithLessThan_10 = 'Vendor_organization_with_less_than_10',
  VendorOrganizationWithMoreThan_50 = 'Vendor_organization_with_more_than_50',
}

export enum IEnum_User_Companytype {
  Alsp = 'ALSP',
  Consultant = 'Consultant',
  Investor = 'Investor',
  LawDepartment = 'Law_department',
  LawFirm = 'Law_firm',
  Other = 'Other',
  Vendor = 'Vendor',
}

export enum IEnum_User_Useraccesslevel {
  Free = 'Free',
  FullLthPremiumKnowledge = 'Full_LTH_Premium_Knowledge',
  VendorCentral = 'Vendor_Central',
  VendorCentralLthPremiumForVendors = 'Vendor_Central_LTH_Premium_for_Vendors',
}

export enum IEnum_Vendor_Companysize {
  VendorOrganizationWith_10To_20 = 'Vendor_organization_with_10_to_20',
  VendorOrganizationWith_20To_50 = 'Vendor_organization_with_20_to_50',
  VendorOrganizationWithLessThan_10 = 'Vendor_organization_with_less_than_10',
  VendorOrganizationWithMoreThan_50 = 'Vendor_organization_with_more_than_50',
}

export enum IEnum_Vendor_Vendorstatus {
  Paid = 'Paid',
  RegisteredNotPaid = 'Registered_Not_Paid',
  Reviewing = 'Reviewing',
}

export enum IEnum_Vendor_Vendorsubscriptionlevel {
  Engaged = 'Engaged',
  Standard = 'Standard',
  Strategic = 'Strategic',
}

export type IEmailReceiver = {
  __typename?: 'EmailReceiver'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  email?: Maybe<Scalars['String']['output']>
  enable?: Maybe<Scalars['Boolean']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IEmailReceiverEntityResponseCollection = {
  __typename?: 'EmailReceiverEntityResponseCollection'
  nodes: Array<IEmailReceiver>
  pageInfo: IPagination
}

export type IEmailReceiverFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IEmailReceiverFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  email?: InputMaybe<IStringFilterInput>
  enable?: InputMaybe<IBooleanFilterInput>
  not?: InputMaybe<IEmailReceiverFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IEmailReceiverFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IEmailReceiverInput = {
  email?: InputMaybe<Scalars['String']['input']>
  enable?: InputMaybe<Scalars['Boolean']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IEnhancedRequestContent = {
  __typename?: 'EnhancedRequestContent'
  callToAction?: Maybe<Scalars['String']['output']>
  competitor?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  documentId: Scalars['ID']['output']
  moreVisibility?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  screenshots?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IEnhancedRequestContentInput = {
  callToAction?: InputMaybe<Scalars['String']['input']>
  competitor?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  moreVisibility?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  screenshots?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type IEvent = {
  __typename?: 'Event'
  audiences: Array<Maybe<IAudience>>
  audiences_connection?: Maybe<IAudienceRelationResponseCollection>
  city?: Maybe<Scalars['String']['output']>
  country: Scalars['String']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  date?: Maybe<Scalars['Date']['output']>
  description?: Maybe<Scalars['String']['output']>
  documentId: Scalars['ID']['output']
  durationId?: Maybe<IDuration>
  featured?: Maybe<Scalars['Boolean']['output']>
  features: Array<Maybe<IEventFeature>>
  features_connection?: Maybe<IEventFeatureRelationResponseCollection>
  formatId?: Maybe<IEventFormat>
  logo?: Maybe<IUploadFile>
  notes?: Maybe<Scalars['String']['output']>
  organizer: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  recurrenceId?: Maybe<IRecurrence>
  slug: Scalars['String']['output']
  title: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  website: Scalars['String']['output']
}

export type IEventAudiencesArgs = {
  filters?: InputMaybe<IAudienceFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IEventAudiences_ConnectionArgs = {
  filters?: InputMaybe<IAudienceFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IEventFeaturesArgs = {
  filters?: InputMaybe<IEventFeatureFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IEventFeatures_ConnectionArgs = {
  filters?: InputMaybe<IEventFeatureFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IEventEntityResponseCollection = {
  __typename?: 'EventEntityResponseCollection'
  nodes: Array<IEvent>
  pageInfo: IPagination
}

export type IEventFeature = {
  __typename?: 'EventFeature'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IEventFeatureEntityResponseCollection = {
  __typename?: 'EventFeatureEntityResponseCollection'
  nodes: Array<IEventFeature>
  pageInfo: IPagination
}

export type IEventFeatureFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IEventFeatureFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IEventFeatureFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IEventFeatureFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IEventFeatureInput = {
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IEventFeatureRelationResponseCollection = {
  __typename?: 'EventFeatureRelationResponseCollection'
  nodes: Array<IEventFeature>
}

export type IEventFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IEventFiltersInput>>>
  audiences?: InputMaybe<IAudienceFiltersInput>
  city?: InputMaybe<IStringFilterInput>
  country?: InputMaybe<IStringFilterInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  date?: InputMaybe<IDateFilterInput>
  description?: InputMaybe<IStringFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  durationId?: InputMaybe<IDurationFiltersInput>
  featured?: InputMaybe<IBooleanFilterInput>
  features?: InputMaybe<IEventFeatureFiltersInput>
  formatId?: InputMaybe<IEventFormatFiltersInput>
  not?: InputMaybe<IEventFiltersInput>
  notes?: InputMaybe<IStringFilterInput>
  or?: InputMaybe<Array<InputMaybe<IEventFiltersInput>>>
  organizer?: InputMaybe<IStringFilterInput>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  recurrenceId?: InputMaybe<IRecurrenceFiltersInput>
  slug?: InputMaybe<IStringFilterInput>
  title?: InputMaybe<IStringFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
  website?: InputMaybe<IStringFilterInput>
}

export type IEventFormat = {
  __typename?: 'EventFormat'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IEventFormatEntityResponseCollection = {
  __typename?: 'EventFormatEntityResponseCollection'
  nodes: Array<IEventFormat>
  pageInfo: IPagination
}

export type IEventFormatFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IEventFormatFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IEventFormatFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IEventFormatFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IEventFormatInput = {
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IEventInput = {
  audiences?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['Date']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  durationId?: InputMaybe<Scalars['ID']['input']>
  featured?: InputMaybe<Scalars['Boolean']['input']>
  features?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  formatId?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  logo?: InputMaybe<Scalars['ID']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  organizer?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  recurrenceId?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
}

export type IEventSearchResult = {
  __typename?: 'EventSearchResult'
  events?: Maybe<Array<Maybe<IEvent>>>
  total?: Maybe<Scalars['Int']['output']>
}

export type IEventSearchReturnType = {
  __typename?: 'EventSearchReturnType'
  data?: Maybe<IEventSearchResult>
  success?: Maybe<Scalars['Boolean']['output']>
}

export type IExistingCustomer = {
  __typename?: 'ExistingCustomer'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IExistingCustomerEntityResponseCollection = {
  __typename?: 'ExistingCustomerEntityResponseCollection'
  nodes: Array<IExistingCustomer>
  pageInfo: IPagination
}

export type IExistingCustomerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IExistingCustomerFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IExistingCustomerFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IExistingCustomerFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IExistingCustomerInput = {
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IExistingCustomerItem = {
  __typename?: 'ExistingCustomerItem'
  documentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type IExistingCustomerRelationResponseCollection = {
  __typename?: 'ExistingCustomerRelationResponseCollection'
  nodes: Array<IExistingCustomer>
}

export type IExistingCustomersFiltersInput = {
  name?: InputMaybe<IStringFilterInput>
}

export type IExpert = {
  __typename?: 'Expert'
  avatar?: Maybe<IUploadFile>
  bio?: Maybe<Scalars['String']['output']>
  company?: Maybe<Scalars['String']['output']>
  contents: Array<Maybe<IContent>>
  contents_connection?: Maybe<IContentRelationResponseCollection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  displayName?: Maybe<Scalars['String']['output']>
  documentId: Scalars['ID']['output']
  experience?: Maybe<Scalars['String']['output']>
  expertiseSubTopics: Array<Maybe<ISubTopic>>
  expertiseSubTopics_connection?: Maybe<ISubTopicRelationResponseCollection>
  expertiseTopics: Array<Maybe<ITopic>>
  expertiseTopics_connection?: Maybe<ITopicRelationResponseCollection>
  firstName: Scalars['String']['output']
  jobTitle?: Maybe<Scalars['String']['output']>
  lastName: Scalars['String']['output']
  linkedin?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  secondaryExpertiseSubTopics: Array<Maybe<ISubTopic>>
  secondaryExpertiseSubTopics_connection?: Maybe<ISubTopicRelationResponseCollection>
  secondaryExpertiseTopics: Array<Maybe<ITopic>>
  secondaryExpertiseTopics_connection?: Maybe<ITopicRelationResponseCollection>
  slug?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  twitter?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IExpertContentsArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IExpertContents_ConnectionArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IExpertExpertiseSubTopicsArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IExpertExpertiseSubTopics_ConnectionArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IExpertExpertiseTopicsArgs = {
  filters?: InputMaybe<ITopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IExpertExpertiseTopics_ConnectionArgs = {
  filters?: InputMaybe<ITopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IExpertSecondaryExpertiseSubTopicsArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IExpertSecondaryExpertiseSubTopics_ConnectionArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IExpertSecondaryExpertiseTopicsArgs = {
  filters?: InputMaybe<ITopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IExpertSecondaryExpertiseTopics_ConnectionArgs = {
  filters?: InputMaybe<ITopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IExpertEntityResponseCollection = {
  __typename?: 'ExpertEntityResponseCollection'
  nodes: Array<IExpert>
  pageInfo: IPagination
}

export type IExpertFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IExpertFiltersInput>>>
  bio?: InputMaybe<IStringFilterInput>
  company?: InputMaybe<IStringFilterInput>
  contents?: InputMaybe<IContentFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  displayName?: InputMaybe<IStringFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  experience?: InputMaybe<IStringFilterInput>
  expertiseSubTopics?: InputMaybe<ISubTopicFiltersInput>
  expertiseTopics?: InputMaybe<ITopicFiltersInput>
  firstName?: InputMaybe<IStringFilterInput>
  jobTitle?: InputMaybe<IStringFilterInput>
  lastName?: InputMaybe<IStringFilterInput>
  linkedin?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IExpertFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IExpertFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  secondaryExpertiseSubTopics?: InputMaybe<ISubTopicFiltersInput>
  secondaryExpertiseTopics?: InputMaybe<ITopicFiltersInput>
  slug?: InputMaybe<IStringFilterInput>
  title?: InputMaybe<IStringFilterInput>
  twitter?: InputMaybe<IStringFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IExpertInput = {
  avatar?: InputMaybe<Scalars['ID']['input']>
  bio?: InputMaybe<Scalars['String']['input']>
  company?: InputMaybe<Scalars['String']['input']>
  contactEmail?: InputMaybe<Scalars['String']['input']>
  contents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  displayName?: InputMaybe<Scalars['String']['input']>
  experience?: InputMaybe<Scalars['String']['input']>
  expertiseSubTopics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  expertiseTopics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  firstName?: InputMaybe<Scalars['String']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  secondaryExpertiseSubTopics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  secondaryExpertiseTopics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  twitter?: InputMaybe<Scalars['String']['input']>
}

export type IFeature = {
  __typename?: 'Feature'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  subTopics: Array<Maybe<ISubTopic>>
  subTopics_connection?: Maybe<ISubTopicRelationResponseCollection>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IFeatureSubTopicsArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IFeatureSubTopics_ConnectionArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IFeatureEntityResponseCollection = {
  __typename?: 'FeatureEntityResponseCollection'
  nodes: Array<IFeature>
  pageInfo: IPagination
}

export type IFeatureFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IFeatureFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IFeatureFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IFeatureFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  subTopics?: InputMaybe<ISubTopicFiltersInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IFeatureInput = {
  internalName?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  subTopics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type IFeatureRelationResponseCollection = {
  __typename?: 'FeatureRelationResponseCollection'
  nodes: Array<IFeature>
}

export type IFileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>
  caption?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type IFloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  contains?: InputMaybe<Scalars['Float']['input']>
  containsi?: InputMaybe<Scalars['Float']['input']>
  endsWith?: InputMaybe<Scalars['Float']['input']>
  eq?: InputMaybe<Scalars['Float']['input']>
  eqi?: InputMaybe<Scalars['Float']['input']>
  gt?: InputMaybe<Scalars['Float']['input']>
  gte?: InputMaybe<Scalars['Float']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  lt?: InputMaybe<Scalars['Float']['input']>
  lte?: InputMaybe<Scalars['Float']['input']>
  ne?: InputMaybe<Scalars['Float']['input']>
  nei?: InputMaybe<Scalars['Float']['input']>
  not?: InputMaybe<IFloatFilterInput>
  notContains?: InputMaybe<Scalars['Float']['input']>
  notContainsi?: InputMaybe<Scalars['Float']['input']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  notNull?: InputMaybe<Scalars['Boolean']['input']>
  null?: InputMaybe<Scalars['Boolean']['input']>
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  startsWith?: InputMaybe<Scalars['Float']['input']>
}

export type IFollowingTopicEntity = {
  __typename?: 'FollowingTopicEntity'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  documentId?: Maybe<Scalars['String']['output']>
  featuredOnHome?: Maybe<Scalars['Boolean']['output']>
  iconName?: Maybe<Scalars['String']['output']>
  isPremium?: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug: Scalars['String']['output']
  subTopics?: Maybe<Array<Maybe<ISubtopicItem>>>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IFreeAskAiLog = {
  __typename?: 'FreeAskAiLog'
  ASKAIData?: Maybe<Scalars['JSON']['output']>
  Fid?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IFreeAskAiLogEntityResponseCollection = {
  __typename?: 'FreeAskAiLogEntityResponseCollection'
  nodes: Array<IFreeAskAiLog>
  pageInfo: IPagination
}

export type IFreeAskAiLogFiltersInput = {
  ASKAIData?: InputMaybe<IJsonFilterInput>
  Fid?: InputMaybe<IStringFilterInput>
  and?: InputMaybe<Array<InputMaybe<IFreeAskAiLogFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  not?: InputMaybe<IFreeAskAiLogFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IFreeAskAiLogFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IFreeAskAiLogInput = {
  ASKAIData?: InputMaybe<Scalars['JSON']['input']>
  Fid?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IFreeContentLog = {
  __typename?: 'FreeContentLog'
  ContentData?: Maybe<Scalars['JSON']['output']>
  Fid?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IFreeContentLogEntityResponseCollection = {
  __typename?: 'FreeContentLogEntityResponseCollection'
  nodes: Array<IFreeContentLog>
  pageInfo: IPagination
}

export type IFreeContentLogFiltersInput = {
  ContentData?: InputMaybe<IJsonFilterInput>
  Fid?: InputMaybe<IStringFilterInput>
  and?: InputMaybe<Array<InputMaybe<IFreeContentLogFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  not?: InputMaybe<IFreeContentLogFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IFreeContentLogFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IFreeContentLogInput = {
  ContentData?: InputMaybe<Scalars['JSON']['input']>
  Fid?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IFreeSearchLog = {
  __typename?: 'FreeSearchLog'
  Fid?: Maybe<Scalars['String']['output']>
  SearchData?: Maybe<Scalars['JSON']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IFreeSearchLogEntityResponseCollection = {
  __typename?: 'FreeSearchLogEntityResponseCollection'
  nodes: Array<IFreeSearchLog>
  pageInfo: IPagination
}

export type IFreeSearchLogFiltersInput = {
  Fid?: InputMaybe<IStringFilterInput>
  SearchData?: InputMaybe<IJsonFilterInput>
  and?: InputMaybe<Array<InputMaybe<IFreeSearchLogFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  not?: InputMaybe<IFreeSearchLogFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IFreeSearchLogFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IFreeSearchLogInput = {
  Fid?: InputMaybe<Scalars['String']['input']>
  SearchData?: InputMaybe<Scalars['JSON']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IGenericMorph =
  | IAbout
  | IAnnouncement
  | IArticleData
  | IAskAiLog
  | IAttribute
  | IAudience
  | IAuthor
  | IBannerAnnouncement
  | IBlogTaxonomy
  | ICollection
  | ICompany
  | IComponentAboutPropsTeamMember
  | IComponentAlspPropsAlspEnhanced
  | IComponentAskAiRatingAskAiRating
  | IComponentAskAiUserLogAskAiUserLog
  | IComponentBillingAddressBillingAddress
  | IComponentCompanyCompanyConsolidation
  | IComponentCompanyCompanyFounder
  | IComponentConPropsConEnhancedListing
  | IComponentConPropsDedicatedResource
  | IComponentContentContentWriter
  | IComponentContentDownloadMaterial
  | IComponentContentFeaturedCategories
  | IComponentGlobalArticle
  | IComponentGlobalCallToAction
  | IComponentGlobalPicture
  | IComponentGlobalPricingModel
  | IComponentGlobalSuccessStory
  | IComponentGlobalTestimonial
  | IComponentIdenticalIdentical
  | IComponentInvitationsInvitations
  | IComponentRegistrationContactRegistrationContact
  | IComponentRequestEnhancedListReq
  | IComponentRequestEnhancedVendorReq
  | IComponentRequestListingReq
  | IComponentRequestVendorReq
  | IComponentSolutionAlspData
  | IComponentSolutionConsultantData
  | IComponentSolutionProductData
  | IComponentSolutionPropsAlspEnhanced
  | IComponentSolutionPropsConsolidation
  | IComponentSolutionPropsConsultantEnhanced
  | IComponentSolutionPropsDedicatedResource
  | IComponentSolutionPropsGraveyard
  | IComponentSolutionPropsProductEnhanced
  | IComponentSolutionPropsVendorResource
  | IComponentSolutionPropsVendorResourceExternal
  | IComponentSolutionPropsVideo
  | IComponentSolutionPushUpdateMessageDetails
  | IComponentSolutionRequestAlspData
  | IComponentSolutionRequestConsultantData
  | IComponentSolutionRequestProductData
  | IComponentSolutionRequestPropsProductEnhanced
  | IComponentSolutionSolutionsFollowing
  | IComponentSourcesSources
  | IComponentTestimonialsPropsAuthor
  | IComponentTestimonialsTestimonials
  | IComponentUserPortfolioCustomTag
  | IComponentVendorPropsConsolidation
  | IComponentVendorPropsEnhancedlisting
  | IComponentVendorPropsGraveyard
  | IComponentVendorPropsPoC
  | IComponentVendorPropsPricingResource
  | IComponentVendorPropsVideo
  | IConfiguration
  | IContactHistory
  | IContent
  | IContentDownload
  | IContentVisit
  | ICountry
  | ICustomTag
  | IDemographic
  | IDuration
  | IEmailReceiver
  | IEnhancedRequestContent
  | IEvent
  | IEventFeature
  | IEventFormat
  | IExistingCustomer
  | IExpert
  | IFeature
  | IFreeAskAiLog
  | IFreeContentLog
  | IFreeSearchLog
  | IHq
  | II18NLocale
  | IIltaData
  | IIltaSponsorship
  | IInstallation
  | IIntegration
  | IListingRequest
  | INewsletterCategory
  | INewsletterSubscription
  | INotificationSent
  | IOffice
  | IPhase
  | IPlatformLanguage
  | IPracticeArea
  | IPremiumAudience
  | IPremiumOrganization
  | IPremiumPricingPlan
  | IPrivacyPolicy
  | IPublisherAction
  | IRecordLockingOpenEntity
  | IRecurrence
  | IRegionsServed
  | IResourceInvitation
  | IReview
  | IReviewWorkflowsWorkflow
  | IReviewWorkflowsWorkflowStage
  | ISecurity
  | ISharedPortfolio
  | ISharedPortfolioMembership
  | ISharedPortfolioSolution
  | ISlugUpdate
  | ISolution
  | ISolutionRequest
  | ISubTopic
  | ISubjectMatter
  | ITermsConditions
  | ITestimonials
  | ITheme
  | ITopic
  | ITypeOfUser
  | IUploadFile
  | IUser
  | IUserSystemFeature
  | IUsersPermissionsPermission
  | IUsersPermissionsRole
  | IVendor
  | IVendorTopic

export type IGetAllMasterDataResult = {
  __typename?: 'GetAllMasterDataResult'
  attributes: Array<IMasterDataItem>
  demographics: Array<IMasterDataItem>
  existingCustomers: Array<IMasterDataItem>
  hqs: Array<IMasterDataItem>
  installations: Array<IMasterDataItem>
  integrations: Array<IMasterDataItem>
  offices: Array<IMasterDataItem>
  platformLanguages: Array<IMasterDataItem>
  practiceAreas: Array<IMasterDataItem>
  regionsServed: Array<IMasterDataItem>
  securities: Array<IMasterDataItem>
  subTopics: Array<IMasterDataItem>
  typeOfUsers: Array<IMasterDataItem>
}

export type IHq = {
  __typename?: 'Hq'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IHqEntityResponseCollection = {
  __typename?: 'HqEntityResponseCollection'
  nodes: Array<IHq>
  pageInfo: IPagination
}

export type IHqFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IHqFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IHqFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IHqFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IHqInput = {
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IHqItem = {
  __typename?: 'HqItem'
  documentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type IHqRelationResponseCollection = {
  __typename?: 'HqRelationResponseCollection'
  nodes: Array<IHq>
}

export type IHqsFiltersInput = {
  name?: InputMaybe<IStringFilterInput>
}

export type II18NLocale = {
  __typename?: 'I18NLocale'
  code?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type II18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection'
  nodes: Array<II18NLocale>
  pageInfo: IPagination
}

export type II18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<II18NLocaleFiltersInput>>>
  code?: InputMaybe<IStringFilterInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<II18NLocaleFiltersInput>
  or?: InputMaybe<Array<InputMaybe<II18NLocaleFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IIdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  contains?: InputMaybe<Scalars['ID']['input']>
  containsi?: InputMaybe<Scalars['ID']['input']>
  endsWith?: InputMaybe<Scalars['ID']['input']>
  eq?: InputMaybe<Scalars['ID']['input']>
  eqi?: InputMaybe<Scalars['ID']['input']>
  gt?: InputMaybe<Scalars['ID']['input']>
  gte?: InputMaybe<Scalars['ID']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  lt?: InputMaybe<Scalars['ID']['input']>
  lte?: InputMaybe<Scalars['ID']['input']>
  ne?: InputMaybe<Scalars['ID']['input']>
  nei?: InputMaybe<Scalars['ID']['input']>
  not?: InputMaybe<IIdFilterInput>
  notContains?: InputMaybe<Scalars['ID']['input']>
  notContainsi?: InputMaybe<Scalars['ID']['input']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  notNull?: InputMaybe<Scalars['Boolean']['input']>
  null?: InputMaybe<Scalars['Boolean']['input']>
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  startsWith?: InputMaybe<Scalars['ID']['input']>
}

export type IIltaData = {
  __typename?: 'IltaData'
  bulkUploadIltaSponsorship?: Maybe<IUploadFile>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IIltaDataInput = {
  bulkUploadIltaSponsorship?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IIltaSponsorship = {
  __typename?: 'IltaSponsorship'
  companies: Array<Maybe<ICompany>>
  companies_connection?: Maybe<ICompanyRelationResponseCollection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  documentId: Scalars['ID']['output']
  level?: Maybe<Scalars['Int']['output']>
  logo?: Maybe<IUploadFile>
  name?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IIltaSponsorshipCompaniesArgs = {
  filters?: InputMaybe<ICompanyFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IIltaSponsorshipCompanies_ConnectionArgs = {
  filters?: InputMaybe<ICompanyFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IIltaSponsorshipEntityResponseCollection = {
  __typename?: 'IltaSponsorshipEntityResponseCollection'
  nodes: Array<IIltaSponsorship>
  pageInfo: IPagination
}

export type IIltaSponsorshipFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IIltaSponsorshipFiltersInput>>>
  companies?: InputMaybe<ICompanyFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  description?: InputMaybe<IStringFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  level?: InputMaybe<IIntFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IIltaSponsorshipFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IIltaSponsorshipFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IIltaSponsorshipInput = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  description?: InputMaybe<Scalars['String']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  logo?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IIltaSponsorshipRelationResponseCollection = {
  __typename?: 'IltaSponsorshipRelationResponseCollection'
  nodes: Array<IIltaSponsorship>
}

export type IInstallation = {
  __typename?: 'Installation'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IInstallationEntityResponseCollection = {
  __typename?: 'InstallationEntityResponseCollection'
  nodes: Array<IInstallation>
  pageInfo: IPagination
}

export type IInstallationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IInstallationFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IInstallationFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IInstallationFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IInstallationInput = {
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IInstallationRelationResponseCollection = {
  __typename?: 'InstallationRelationResponseCollection'
  nodes: Array<IInstallation>
}

export type IIntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  contains?: InputMaybe<Scalars['Int']['input']>
  containsi?: InputMaybe<Scalars['Int']['input']>
  endsWith?: InputMaybe<Scalars['Int']['input']>
  eq?: InputMaybe<Scalars['Int']['input']>
  eqi?: InputMaybe<Scalars['Int']['input']>
  gt?: InputMaybe<Scalars['Int']['input']>
  gte?: InputMaybe<Scalars['Int']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  lt?: InputMaybe<Scalars['Int']['input']>
  lte?: InputMaybe<Scalars['Int']['input']>
  ne?: InputMaybe<Scalars['Int']['input']>
  nei?: InputMaybe<Scalars['Int']['input']>
  not?: InputMaybe<IIntFilterInput>
  notContains?: InputMaybe<Scalars['Int']['input']>
  notContainsi?: InputMaybe<Scalars['Int']['input']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  notNull?: InputMaybe<Scalars['Boolean']['input']>
  null?: InputMaybe<Scalars['Boolean']['input']>
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  startsWith?: InputMaybe<Scalars['Int']['input']>
}

export type IIntegration = {
  __typename?: 'Integration'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IIntegrationEntityResponseCollection = {
  __typename?: 'IntegrationEntityResponseCollection'
  nodes: Array<IIntegration>
  pageInfo: IPagination
}

export type IIntegrationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IIntegrationFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IIntegrationFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IIntegrationFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IIntegrationInput = {
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IIntegrationItem = {
  __typename?: 'IntegrationItem'
  documentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type IIntegrationRelationResponseCollection = {
  __typename?: 'IntegrationRelationResponseCollection'
  nodes: Array<IIntegration>
}

export type IIntegrationsFiltersInput = {
  name?: InputMaybe<IStringFilterInput>
}

export type IInvitationInput = {
  businessEmail: Scalars['String']['input']
  companyLawFirmName: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type IJsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  contains?: InputMaybe<Scalars['JSON']['input']>
  containsi?: InputMaybe<Scalars['JSON']['input']>
  endsWith?: InputMaybe<Scalars['JSON']['input']>
  eq?: InputMaybe<Scalars['JSON']['input']>
  eqi?: InputMaybe<Scalars['JSON']['input']>
  gt?: InputMaybe<Scalars['JSON']['input']>
  gte?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  lt?: InputMaybe<Scalars['JSON']['input']>
  lte?: InputMaybe<Scalars['JSON']['input']>
  ne?: InputMaybe<Scalars['JSON']['input']>
  nei?: InputMaybe<Scalars['JSON']['input']>
  not?: InputMaybe<IJsonFilterInput>
  notContains?: InputMaybe<Scalars['JSON']['input']>
  notContainsi?: InputMaybe<Scalars['JSON']['input']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  notNull?: InputMaybe<Scalars['Boolean']['input']>
  null?: InputMaybe<Scalars['Boolean']['input']>
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  startsWith?: InputMaybe<Scalars['JSON']['input']>
}

export type IListingRequest = {
  __typename?: 'ListingRequest'
  alspReq?: Maybe<IComponentRequestListingReq>
  basicOrEnhanced?: Maybe<IEnum_Listingrequest_Basicorenhanced>
  companyName?: Maybe<Scalars['String']['output']>
  consultantReq?: Maybe<IComponentRequestListingReq>
  createOrUpdate?: Maybe<IEnum_Listingrequest_Createorupdate>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  enhancedAlspReq?: Maybe<IComponentRequestEnhancedListReq>
  enhancedConsultantReq?: Maybe<IComponentRequestEnhancedListReq>
  enhancedVendorReq?: Maybe<IComponentRequestEnhancedVendorReq>
  listingType?: Maybe<IEnum_Listingrequest_Listingtype>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  status?: Maybe<IEnum_Listingrequest_Status>
  submittedEmail?: Maybe<Scalars['String']['output']>
  submittedName?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  vendorReq?: Maybe<IComponentRequestVendorReq>
}

export type IListingRequestData = {
  alspReq?: InputMaybe<IConsultantListingRequest>
  consultantReq?: InputMaybe<IConsultantListingRequest>
  enhancedAlspReq?: InputMaybe<IComponentRequestEnhancedListReqInput>
  enhancedConsultantReq?: InputMaybe<IComponentRequestEnhancedListReqInput>
  enhancedVendorReq?: InputMaybe<IComponentRequestEnhancedVendorReqInput>
  gReCaptchaToken?: InputMaybe<Scalars['String']['input']>
  listingType?: InputMaybe<IEnum_Listingrequest_Listingtype>
  vendorReq?: InputMaybe<IVendorListingRequest>
}

export type IListingRequestEntityResponseCollection = {
  __typename?: 'ListingRequestEntityResponseCollection'
  nodes: Array<IListingRequest>
  pageInfo: IPagination
}

export type IListingRequestFiltersInput = {
  alspReq?: InputMaybe<IComponentRequestListingReqFiltersInput>
  and?: InputMaybe<Array<InputMaybe<IListingRequestFiltersInput>>>
  basicOrEnhanced?: InputMaybe<IStringFilterInput>
  companyName?: InputMaybe<IStringFilterInput>
  consultantReq?: InputMaybe<IComponentRequestListingReqFiltersInput>
  createOrUpdate?: InputMaybe<IStringFilterInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  enhancedAlspReq?: InputMaybe<IComponentRequestEnhancedListReqFiltersInput>
  enhancedConsultantReq?: InputMaybe<IComponentRequestEnhancedListReqFiltersInput>
  enhancedVendorReq?: InputMaybe<IComponentRequestEnhancedVendorReqFiltersInput>
  listingType?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IListingRequestFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IListingRequestFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  status?: InputMaybe<IStringFilterInput>
  submittedEmail?: InputMaybe<IStringFilterInput>
  submittedName?: InputMaybe<IStringFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
  vendorReq?: InputMaybe<IComponentRequestVendorReqFiltersInput>
}

export type IListingRequestInput = {
  alspReq?: InputMaybe<IComponentRequestListingReqInput>
  basicOrEnhanced?: InputMaybe<IEnum_Listingrequest_Basicorenhanced>
  companyName?: InputMaybe<Scalars['String']['input']>
  consultantReq?: InputMaybe<IComponentRequestListingReqInput>
  createOrUpdate?: InputMaybe<IEnum_Listingrequest_Createorupdate>
  enhancedAlspReq?: InputMaybe<IComponentRequestEnhancedListReqInput>
  enhancedConsultantReq?: InputMaybe<IComponentRequestEnhancedListReqInput>
  enhancedVendorReq?: InputMaybe<IComponentRequestEnhancedVendorReqInput>
  listingType?: InputMaybe<IEnum_Listingrequest_Listingtype>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  status?: InputMaybe<IEnum_Listingrequest_Status>
  submittedEmail?: InputMaybe<Scalars['String']['input']>
  submittedName?: InputMaybe<Scalars['String']['input']>
  vendorReq?: InputMaybe<IComponentRequestVendorReqInput>
}

export type ILocations = {
  __typename?: 'Locations'
  createdAt?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  name?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
}

export type IMasterDataItem = {
  __typename?: 'MasterDataItem'
  documentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt: Scalars['String']['output']
}

export type IMutation = {
  __typename?: 'Mutation'
  /** Attach a solution id to a portfolio custom tag */
  addPortfolioTagToSolution?: Maybe<Scalars['Boolean']['output']>
  /** Authenticated mutation: add a solution by shared portfolio id (`sharedID`). Categories: Portfolio | Reviewed | Watching. Bearer token required; lastModifiedByUser is the current user. */
  addSolutionToSharedPortfolio?: Maybe<ISharedPortfolioSolutionEntity>
  /** change user password request */
  changeMyPassword?: Maybe<IChangePasswordPayload>
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<IUsersPermissionsLoginPayload>
  /** Claim Vendor Listing - Request to associate solution with vendor account */
  claimVendorListing?: Maybe<IVendorSatus>
  createAnnouncement?: Maybe<IAnnouncement>
  createArticleData?: Maybe<IArticleData>
  createAskAiLog?: Maybe<IAskAiLog>
  createAttribute?: Maybe<IAttribute>
  createAudience?: Maybe<IAudience>
  createAuthor?: Maybe<IAuthor>
  createBlogTaxonomy?: Maybe<IBlogTaxonomy>
  createCollection?: Maybe<ICollection>
  createCompany?: Maybe<ICompany>
  createContactHistory?: Maybe<IContactHistory>
  createContent?: Maybe<IContent>
  createContentDownload?: Maybe<IContentDownload>
  createContentVisit?: Maybe<IContentVisit>
  createCountry?: Maybe<ICountry>
  createCustomTag?: Maybe<ICustomTag>
  createDemographic?: Maybe<IDemographic>
  createDuration?: Maybe<IDuration>
  createEmailReceiver?: Maybe<IEmailReceiver>
  createEvent?: Maybe<IEvent>
  createEventFeature?: Maybe<IEventFeature>
  createEventFormat?: Maybe<IEventFormat>
  createExistingCustomer?: Maybe<IExistingCustomer>
  createExpert?: Maybe<IExpert>
  createFeature?: Maybe<IFeature>
  createFreeAskAiLog?: Maybe<IFreeAskAiLog>
  createFreeContentLog?: Maybe<IFreeContentLog>
  createFreeSearchLog?: Maybe<IFreeSearchLog>
  createHq?: Maybe<IHq>
  createIltaSponsorship?: Maybe<IIltaSponsorship>
  createInstallation?: Maybe<IInstallation>
  createIntegration?: Maybe<IIntegration>
  createListingRequest?: Maybe<IListingRequest>
  /** create listing request */
  createListingRequestData?: Maybe<IListingRequest>
  createNewsletterCategory?: Maybe<INewsletterCategory>
  createNewsletterSubscription?: Maybe<INewsletterSubscription>
  createNotificationSent?: Maybe<INotificationSent>
  createOffice?: Maybe<IOffice>
  createPhase?: Maybe<IPhase>
  createPlatformLanguage?: Maybe<IPlatformLanguage>
  /** Create a reusable portfolio custom tag */
  createPortfolioTag?: Maybe<ICustomTagResult>
  createPracticeArea?: Maybe<IPracticeArea>
  createPremiumAudience?: Maybe<IPremiumAudience>
  createPremiumOrganization?: Maybe<IPremiumOrganization>
  createPremiumPricingPlan?: Maybe<IPremiumPricingPlan>
  createPublisherAction?: Maybe<IPublisherAction>
  createRecordLockingOpenEntity?: Maybe<IRecordLockingOpenEntity>
  createRecurrence?: Maybe<IRecurrence>
  createRegionsServed?: Maybe<IRegionsServed>
  createResourceInvitation?: Maybe<IResourceInvitation>
  createReview?: Maybe<IReview>
  createReviewWorkflowsWorkflow?: Maybe<IReviewWorkflowsWorkflow>
  createReviewWorkflowsWorkflowStage?: Maybe<IReviewWorkflowsWorkflowStage>
  createSecurity?: Maybe<ISecurity>
  createSharedPortfolio?: Maybe<ISharedPortfolio>
  createSharedPortfolioMembership?: Maybe<ISharedPortfolioMembership>
  /** Create a shared portfolio with name and editors; premium organization is taken from the logged-in user */
  createSharedPortfolioWithMembers?: Maybe<ISharedPortfolioEntity>
  createSlugUpdate?: Maybe<ISlugUpdate>
  createSolution?: Maybe<ISolution>
  createSolutionRequest?: Maybe<ISolutionRequest>
  createSubTopic?: Maybe<ISubTopic>
  createSubjectMatter?: Maybe<ISubjectMatter>
  createTestimonials?: Maybe<ITestimonials>
  createTheme?: Maybe<ITheme>
  createTopic?: Maybe<ITopic>
  createTypeOfUser?: Maybe<ITypeOfUser>
  /** Create a new user */
  createUser: IUserEntityResponse
  createUserSystemFeature?: Maybe<IUserSystemFeature>
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<IUsersPermissionsCreateRolePayload>
  createVendor?: Maybe<IVendor>
  createVendorTopic?: Maybe<IVendorTopic>
  deleteAbout?: Maybe<IDeleteMutationResponse>
  deleteAnnouncement?: Maybe<IDeleteMutationResponse>
  deleteArticleData?: Maybe<IDeleteMutationResponse>
  deleteAskAiLog?: Maybe<IDeleteMutationResponse>
  deleteAttribute?: Maybe<IDeleteMutationResponse>
  deleteAudience?: Maybe<IDeleteMutationResponse>
  deleteAuthor?: Maybe<IDeleteMutationResponse>
  deleteBannerAnnouncement?: Maybe<IDeleteMutationResponse>
  deleteBlogTaxonomy?: Maybe<IDeleteMutationResponse>
  deleteCollection?: Maybe<IDeleteMutationResponse>
  deleteCompany?: Maybe<IDeleteMutationResponse>
  deleteConfiguration?: Maybe<IDeleteMutationResponse>
  deleteContactHistory?: Maybe<IDeleteMutationResponse>
  deleteContent?: Maybe<IDeleteMutationResponse>
  deleteContentDownload?: Maybe<IDeleteMutationResponse>
  deleteContentVisit?: Maybe<IDeleteMutationResponse>
  deleteCountry?: Maybe<IDeleteMutationResponse>
  deleteCustomTag?: Maybe<IDeleteMutationResponse>
  deleteDemographic?: Maybe<IDeleteMutationResponse>
  deleteDuration?: Maybe<IDeleteMutationResponse>
  deleteEmailReceiver?: Maybe<IDeleteMutationResponse>
  deleteEnhancedRequestContent?: Maybe<IDeleteMutationResponse>
  deleteEvent?: Maybe<IDeleteMutationResponse>
  deleteEventFeature?: Maybe<IDeleteMutationResponse>
  deleteEventFormat?: Maybe<IDeleteMutationResponse>
  deleteExistingCustomer?: Maybe<IDeleteMutationResponse>
  deleteExpert?: Maybe<IDeleteMutationResponse>
  deleteFeature?: Maybe<IDeleteMutationResponse>
  deleteFreeAskAiLog?: Maybe<IDeleteMutationResponse>
  deleteFreeContentLog?: Maybe<IDeleteMutationResponse>
  deleteFreeSearchLog?: Maybe<IDeleteMutationResponse>
  deleteHq?: Maybe<IDeleteMutationResponse>
  deleteIltaData?: Maybe<IDeleteMutationResponse>
  deleteIltaSponsorship?: Maybe<IDeleteMutationResponse>
  deleteInstallation?: Maybe<IDeleteMutationResponse>
  deleteIntegration?: Maybe<IDeleteMutationResponse>
  deleteListingRequest?: Maybe<IDeleteMutationResponse>
  deleteNewsletterCategory?: Maybe<IDeleteMutationResponse>
  deleteNewsletterSubscription?: Maybe<IDeleteMutationResponse>
  deleteNotificationSent?: Maybe<IDeleteMutationResponse>
  deleteOffice?: Maybe<IDeleteMutationResponse>
  deletePhase?: Maybe<IDeleteMutationResponse>
  deletePlatformLanguage?: Maybe<IDeleteMutationResponse>
  /** Delete a portfolio custom tag and remove it from all solutions */
  deletePortfolioTag?: Maybe<Scalars['Boolean']['output']>
  deletePracticeArea?: Maybe<IDeleteMutationResponse>
  deletePremiumAudience?: Maybe<IDeleteMutationResponse>
  deletePremiumOrganization?: Maybe<IDeleteMutationResponse>
  deletePremiumPricingPlan?: Maybe<IDeleteMutationResponse>
  deletePrivacyPolicy?: Maybe<IDeleteMutationResponse>
  deletePublisherAction?: Maybe<IDeleteMutationResponse>
  deleteRecordLockingOpenEntity?: Maybe<IDeleteMutationResponse>
  deleteRecurrence?: Maybe<IDeleteMutationResponse>
  deleteRegionsServed?: Maybe<IDeleteMutationResponse>
  deleteResourceInvitation?: Maybe<IDeleteMutationResponse>
  deleteReview?: Maybe<IDeleteMutationResponse>
  deleteReviewWorkflowsWorkflow?: Maybe<IDeleteMutationResponse>
  deleteReviewWorkflowsWorkflowStage?: Maybe<IDeleteMutationResponse>
  deleteSecurity?: Maybe<IDeleteMutationResponse>
  /** Delete a shared portfolio (portfolio admin only, same org): removes all shared-portfolio-solution rows, all memberships, then the portfolio. */
  deleteSharedPortfolio: Scalars['Boolean']['output']
  deleteSharedPortfolioMembership?: Maybe<IDeleteMutationResponse>
  deleteSharedPortfolioSolution?: Maybe<IDeleteMutationResponse>
  deleteSlugUpdate?: Maybe<IDeleteMutationResponse>
  deleteSolution?: Maybe<IDeleteMutationResponse>
  deleteSolutionRequest?: Maybe<IDeleteMutationResponse>
  deleteSubTopic?: Maybe<IDeleteMutationResponse>
  deleteSubjectMatter?: Maybe<IDeleteMutationResponse>
  deleteTermsConditions?: Maybe<IDeleteMutationResponse>
  deleteTestimonials?: Maybe<IDeleteMutationResponse>
  deleteTheme?: Maybe<IDeleteMutationResponse>
  deleteTopic?: Maybe<IDeleteMutationResponse>
  deleteTypeOfUser?: Maybe<IDeleteMutationResponse>
  deleteUploadFile?: Maybe<IUploadFile>
  /** Delete an existing user */
  deleteUser: IUserEntityResponse
  deleteUserSystemFeature?: Maybe<IDeleteMutationResponse>
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<IUsersPermissionsDeleteRolePayload>
  deleteVendor?: Maybe<IDeleteMutationResponse>
  deleteVendorTopic?: Maybe<IDeleteMutationResponse>
  /** Download A Content */
  downloadContent?: Maybe<Scalars['Boolean']['output']>
  /** Rename a portfolio custom tag */
  editPortfolioTag?: Maybe<ICustomTagResult>
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<IUsersPermissionsLoginPayload>
  /** Mutate shared-portfolio-solution by portfolio slug: Move, AddNote, Remove, or RemoveNote */
  followSharedPortfolioSolution?: Maybe<Scalars['Boolean']['output']>
  /** follow a vendor/alsp/consultant */
  followSolution?: Maybe<Scalars['Boolean']['output']>
  /** follow a followSubtopic */
  followSubtopic?: Maybe<Scalars['Boolean']['output']>
  /** Request a reset password token */
  forgotPassword?: Maybe<IUsersPermissionsPasswordPayload>
  login: IUsersPermissionsLoginPayload
  /** Register a user */
  register: IUsersPermissionsLoginPayload
  /** Registers a new premium organization */
  registerPremiumOrganization?: Maybe<IPremiumOrganization>
  /** Registers a new vendor organization */
  registerVendorOrganization?: Maybe<IVendor>
  /** Remove editors from a shared portfolio. Caller must be a portfolio admin in the same premium organization; administrator accounts cannot be removed. */
  removeMembersFromSharedPortfolio?: Maybe<ISharedPortfolioEntity>
  /** Remove a solution id from a portfolio custom tag */
  removePortfolioTagFromSolution?: Maybe<Scalars['Boolean']['output']>
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<IUsersPermissionsLoginPayload>
  /** Resource Invitation */
  shareContents?: Maybe<Scalars['Boolean']['output']>
  /** Vendor Status */
  shareVendorStatus?: Maybe<IVendorSatus>
  /** Submit a request to upgrade from the basic to the Premium version */
  submitEnhancedRequest?: Maybe<Scalars['Boolean']['output']>
  /** Submit newsletter subscripion */
  submitNewsletterSubscription?: Maybe<Scalars['Boolean']['output']>
  /** submit a vendor/alsp/consultant review */
  submitReview?: Maybe<Scalars['Boolean']['output']>
  updateAbout?: Maybe<IAbout>
  updateAnnouncement?: Maybe<IAnnouncement>
  updateArticleData?: Maybe<IArticleData>
  /** Updates the Ask AI log rating, optional feedback */
  updateAskAILogRating?: Maybe<IRatingResponse>
  updateAskAiLog?: Maybe<IAskAiLog>
  updateAttribute?: Maybe<IAttribute>
  updateAudience?: Maybe<IAudience>
  updateAuthor?: Maybe<IAuthor>
  updateBannerAnnouncement?: Maybe<IBannerAnnouncement>
  updateBlogTaxonomy?: Maybe<IBlogTaxonomy>
  updateCollection?: Maybe<ICollection>
  updateCompany?: Maybe<ICompany>
  updateConfiguration?: Maybe<IConfiguration>
  updateContactHistory?: Maybe<IContactHistory>
  updateContent?: Maybe<IContent>
  updateContentDownload?: Maybe<IContentDownload>
  updateContentVisit?: Maybe<IContentVisit>
  updateCountry?: Maybe<ICountry>
  updateCustomTag?: Maybe<ICustomTag>
  updateDemographic?: Maybe<IDemographic>
  updateDuration?: Maybe<IDuration>
  updateEmailReceiver?: Maybe<IEmailReceiver>
  updateEnhancedRequestContent?: Maybe<IEnhancedRequestContent>
  updateEvent?: Maybe<IEvent>
  updateEventFeature?: Maybe<IEventFeature>
  updateEventFormat?: Maybe<IEventFormat>
  updateExistingCustomer?: Maybe<IExistingCustomer>
  updateExpert?: Maybe<IExpert>
  updateFeature?: Maybe<IFeature>
  updateFreeAskAiLog?: Maybe<IFreeAskAiLog>
  updateFreeContentLog?: Maybe<IFreeContentLog>
  updateFreeSearchLog?: Maybe<IFreeSearchLog>
  updateHq?: Maybe<IHq>
  updateIltaData?: Maybe<IIltaData>
  updateIltaSponsorship?: Maybe<IIltaSponsorship>
  updateInstallation?: Maybe<IInstallation>
  updateIntegration?: Maybe<IIntegration>
  updateListingRequest?: Maybe<IListingRequest>
  updateNewsletterCategory?: Maybe<INewsletterCategory>
  updateNewsletterSubscription?: Maybe<INewsletterSubscription>
  updateNotificationSent?: Maybe<INotificationSent>
  updateOffice?: Maybe<IOffice>
  updatePhase?: Maybe<IPhase>
  updatePlatformLanguage?: Maybe<IPlatformLanguage>
  updatePracticeArea?: Maybe<IPracticeArea>
  updatePremiumAudience?: Maybe<IPremiumAudience>
  updatePremiumOrganization?: Maybe<IPremiumOrganization>
  updatePremiumPricingPlan?: Maybe<IPremiumPricingPlan>
  updatePrivacyPolicy?: Maybe<IPrivacyPolicy>
  updatePublisherAction?: Maybe<IPublisherAction>
  updateRecordLockingOpenEntity?: Maybe<IRecordLockingOpenEntity>
  updateRecurrence?: Maybe<IRecurrence>
  updateRegionsServed?: Maybe<IRegionsServed>
  updateResourceInvitation?: Maybe<IResourceInvitation>
  updateReview?: Maybe<IReview>
  updateReviewWorkflowsWorkflow?: Maybe<IReviewWorkflowsWorkflow>
  updateReviewWorkflowsWorkflowStage?: Maybe<IReviewWorkflowsWorkflowStage>
  updateSecurity?: Maybe<ISecurity>
  updateSharedPortfolio?: Maybe<ISharedPortfolio>
  /** Set a member role to admin or editor (portfolio admin only). Cannot demote the sole administrator. */
  updateSharedPortfolioMemberRole?: Maybe<ISharedPortfolioMembershipEntity>
  /** Sync editors (admin only) and optionally rename the portfolio: pass name to update title (unique per org); editors sync same as before; portfolio admins are never removed. */
  updateSharedPortfolioMembers?: Maybe<ISharedPortfolioEntity>
  updateSharedPortfolioMembership?: Maybe<ISharedPortfolioMembership>
  /** Update a shared-portfolio-solution row (portfolio member): category and/or note; lastModifiedByUser is always the authenticated user. */
  updateSharedPortfolioSolution?: Maybe<ISharedPortfolioSolutionEntity>
  updateSlugUpdate?: Maybe<ISlugUpdate>
  updateSolution?: Maybe<ISolution>
  updateSolutionRequest?: Maybe<ISolutionRequest>
  updateSubTopic?: Maybe<ISubTopic>
  updateSubjectMatter?: Maybe<ISubjectMatter>
  updateTermsConditions?: Maybe<ITermsConditions>
  updateTestimonials?: Maybe<ITestimonials>
  updateTheme?: Maybe<ITheme>
  updateTopic?: Maybe<ITopic>
  updateTypeOfUser?: Maybe<ITypeOfUser>
  updateUploadFile: IUploadFile
  /** Update an existing user */
  updateUser: IUserEntityResponse
  /** Update user profile */
  updateUserProfile?: Maybe<IUser>
  updateUserSystemFeature?: Maybe<IUserSystemFeature>
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<IUsersPermissionsUpdateRolePayload>
  updateVendor?: Maybe<IVendor>
  updateVendorTopic?: Maybe<IVendorTopic>
  /** Visit A Content */
  visitContent?: Maybe<Scalars['Boolean']['output']>
}

export type IMutationAddPortfolioTagToSolutionArgs = {
  solutionDocumentId?: InputMaybe<Scalars['ID']['input']>
  solutionId?: InputMaybe<Scalars['Int']['input']>
  tagDocumentId: Scalars['ID']['input']
}

export type IMutationAddSolutionToSharedPortfolioArgs = {
  category: Scalars['String']['input']
  followingSolutionNote?: InputMaybe<Scalars['String']['input']>
  sharedID: Scalars['ID']['input']
  solution: Scalars['ID']['input']
}

export type IMutationChangeMyPasswordArgs = {
  input?: InputMaybe<IChangePasswordRequest>
}

export type IMutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input']
  password: Scalars['String']['input']
  passwordConfirmation: Scalars['String']['input']
}

export type IMutationClaimVendorListingArgs = {
  data?: InputMaybe<IClaimVendorListingInput>
}

export type IMutationCreateAnnouncementArgs = {
  data: IAnnouncementInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateArticleDataArgs = {
  data: IArticleDataInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateAskAiLogArgs = {
  data: IAskAiLogInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateAttributeArgs = {
  data: IAttributeInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateAudienceArgs = {
  data: IAudienceInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateAuthorArgs = {
  data: IAuthorInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateBlogTaxonomyArgs = {
  data: IBlogTaxonomyInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateCollectionArgs = {
  data: ICollectionInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateCompanyArgs = {
  data: ICompanyInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateContactHistoryArgs = {
  data: IContactHistoryInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateContentArgs = {
  data: IContentInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateContentDownloadArgs = {
  data: IContentDownloadInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateContentVisitArgs = {
  data: IContentVisitInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateCountryArgs = {
  data: ICountryInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateCustomTagArgs = {
  data: ICustomTagInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateDemographicArgs = {
  data: IDemographicInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateDurationArgs = {
  data: IDurationInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateEmailReceiverArgs = {
  data: IEmailReceiverInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateEventArgs = {
  data: IEventInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateEventFeatureArgs = {
  data: IEventFeatureInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateEventFormatArgs = {
  data: IEventFormatInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateExistingCustomerArgs = {
  data: IExistingCustomerInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateExpertArgs = {
  data: IExpertInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateFeatureArgs = {
  data: IFeatureInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateFreeAskAiLogArgs = {
  data: IFreeAskAiLogInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateFreeContentLogArgs = {
  data: IFreeContentLogInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateFreeSearchLogArgs = {
  data: IFreeSearchLogInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateHqArgs = {
  data: IHqInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateIltaSponsorshipArgs = {
  data: IIltaSponsorshipInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateInstallationArgs = {
  data: IInstallationInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateIntegrationArgs = {
  data: IIntegrationInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateListingRequestArgs = {
  data: IListingRequestInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateListingRequestDataArgs = {
  data?: InputMaybe<IListingRequestData>
}

export type IMutationCreateNewsletterCategoryArgs = {
  data: INewsletterCategoryInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateNewsletterSubscriptionArgs = {
  data: INewsletterSubscriptionInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateNotificationSentArgs = {
  data: INotificationSentInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateOfficeArgs = {
  data: IOfficeInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreatePhaseArgs = {
  data: IPhaseInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreatePlatformLanguageArgs = {
  data: IPlatformLanguageInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreatePortfolioTagArgs = {
  isSharedPortfolio?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
  portfolioId?: InputMaybe<Scalars['String']['input']>
}

export type IMutationCreatePracticeAreaArgs = {
  data: IPracticeAreaInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreatePremiumAudienceArgs = {
  data: IPremiumAudienceInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreatePremiumOrganizationArgs = {
  data: IPremiumOrganizationInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreatePremiumPricingPlanArgs = {
  data: IPremiumPricingPlanInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreatePublisherActionArgs = {
  data: IPublisherActionInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateRecordLockingOpenEntityArgs = {
  data: IRecordLockingOpenEntityInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateRecurrenceArgs = {
  data: IRecurrenceInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateRegionsServedArgs = {
  data: IRegionsServedInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateResourceInvitationArgs = {
  data: IResourceInvitationInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateReviewArgs = {
  data: IReviewInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateReviewWorkflowsWorkflowArgs = {
  data: IReviewWorkflowsWorkflowInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateReviewWorkflowsWorkflowStageArgs = {
  data: IReviewWorkflowsWorkflowStageInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateSecurityArgs = {
  data: ISecurityInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateSharedPortfolioArgs = {
  data: ISharedPortfolioInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateSharedPortfolioMembershipArgs = {
  data: ISharedPortfolioMembershipInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateSharedPortfolioWithMembersArgs = {
  members?: InputMaybe<Array<ISharedPortfolioMemberInput>>
  name: Scalars['String']['input']
}

export type IMutationCreateSlugUpdateArgs = {
  data: ISlugUpdateInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateSolutionArgs = {
  data: ISolutionInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateSolutionRequestArgs = {
  data: ISolutionRequestInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateSubTopicArgs = {
  data: ISubTopicInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateSubjectMatterArgs = {
  data: ISubjectMatterInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateTestimonialsArgs = {
  data: ITestimonialsInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateThemeArgs = {
  data: IThemeInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateTopicArgs = {
  data: ITopicInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateTypeOfUserArgs = {
  data: ITypeOfUserInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateUserArgs = {
  data: IUserInput
}

export type IMutationCreateUserSystemFeatureArgs = {
  data: IUserSystemFeatureInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateUsersPermissionsRoleArgs = {
  data: IUsersPermissionsRoleInput
}

export type IMutationCreateVendorArgs = {
  data: IVendorInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationCreateVendorTopicArgs = {
  data: IVendorTopicInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationDeleteAnnouncementArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteArticleDataArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteAskAiLogArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteAttributeArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteAudienceArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteAuthorArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteBlogTaxonomyArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteCollectionArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteCompanyArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteContactHistoryArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteContentArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteContentDownloadArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteContentVisitArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteCountryArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteCustomTagArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteDemographicArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteDurationArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteEmailReceiverArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteEventArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteEventFeatureArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteEventFormatArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteExistingCustomerArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteExpertArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteFeatureArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteFreeAskAiLogArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteFreeContentLogArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteFreeSearchLogArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteHqArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteIltaSponsorshipArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteInstallationArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteIntegrationArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteListingRequestArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteNewsletterCategoryArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteNewsletterSubscriptionArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteNotificationSentArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteOfficeArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeletePhaseArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeletePlatformLanguageArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeletePortfolioTagArgs = {
  tagDocumentId: Scalars['ID']['input']
}

export type IMutationDeletePracticeAreaArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeletePremiumAudienceArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeletePremiumOrganizationArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeletePremiumPricingPlanArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeletePublisherActionArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteRecordLockingOpenEntityArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteRecurrenceArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteRegionsServedArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteResourceInvitationArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteReviewArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteSecurityArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteSharedPortfolioArgs = {
  sharedPortfolioId: Scalars['ID']['input']
}

export type IMutationDeleteSharedPortfolioMembershipArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteSharedPortfolioSolutionArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteSlugUpdateArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteSolutionArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteSolutionRequestArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteSubTopicArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteSubjectMatterArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteTestimonialsArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteThemeArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteTopicArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteTypeOfUserArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input']
}

export type IMutationDeleteUserArgs = {
  id: Scalars['ID']['input']
}

export type IMutationDeleteUserSystemFeatureArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input']
}

export type IMutationDeleteVendorArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDeleteVendorTopicArgs = {
  documentId: Scalars['ID']['input']
}

export type IMutationDownloadContentArgs = {
  data: IContentId
}

export type IMutationEditPortfolioTagArgs = {
  name: Scalars['String']['input']
  sharedPortfolioId?: InputMaybe<Scalars['ID']['input']>
  tagDocumentId: Scalars['ID']['input']
}

export type IMutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input']
}

export type IMutationFollowSharedPortfolioSolutionArgs = {
  categoryType?: InputMaybe<Scalars['String']['input']>
  follow: Scalars['Boolean']['input']
  followingSolutionNote?: InputMaybe<Scalars['String']['input']>
  portfolioSlug: Scalars['String']['input']
  solutionId: Scalars['ID']['input']
  updateType: Scalars['String']['input']
}

export type IMutationFollowSolutionArgs = {
  follow?: InputMaybe<Scalars['Boolean']['input']>
  followType?: InputMaybe<Scalars['String']['input']>
  followingSolutionNote?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
}

export type IMutationFollowSubtopicArgs = {
  follow?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
}

export type IMutationForgotPasswordArgs = {
  email: Scalars['String']['input']
}

export type IMutationLoginArgs = {
  input: IUsersPermissionsLoginInput
}

export type IMutationRegisterArgs = {
  input: IUsersPermissionsRegisterInput
}

export type IMutationRegisterPremiumOrganizationArgs = {
  data: IRegisterPremiumOrganizationInput
}

export type IMutationRegisterVendorOrganizationArgs = {
  data: IRegisterVendorOrganizationInput
}

export type IMutationRemoveMembersFromSharedPortfolioArgs = {
  memberEmails: Array<Scalars['String']['input']>
  sharedPortfolioId: Scalars['ID']['input']
}

export type IMutationRemovePortfolioTagFromSolutionArgs = {
  solutionDocumentId?: InputMaybe<Scalars['ID']['input']>
  solutionId?: InputMaybe<Scalars['Int']['input']>
  tagDocumentId: Scalars['ID']['input']
}

export type IMutationResetPasswordArgs = {
  code: Scalars['String']['input']
  password: Scalars['String']['input']
  passwordConfirmation: Scalars['String']['input']
}

export type IMutationShareContentsArgs = {
  data: IResourceInvitationInput
}

export type IMutationShareVendorStatusArgs = {
  data?: InputMaybe<IVendorName>
}

export type IMutationSubmitEnhancedRequestArgs = {
  data: ISolutionId
}

export type IMutationSubmitNewsletterSubscriptionArgs = {
  data: INewsletterSubscriptionInput
}

export type IMutationSubmitReviewArgs = {
  data: IReviewInput
}

export type IMutationUpdateAboutArgs = {
  data: IAboutInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateAnnouncementArgs = {
  data: IAnnouncementInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateArticleDataArgs = {
  data: IArticleDataInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateAskAiLogRatingArgs = {
  data: IInputRatingData
}

export type IMutationUpdateAskAiLogArgs = {
  data: IAskAiLogInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateAttributeArgs = {
  data: IAttributeInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateAudienceArgs = {
  data: IAudienceInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateAuthorArgs = {
  data: IAuthorInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateBannerAnnouncementArgs = {
  data: IBannerAnnouncementInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateBlogTaxonomyArgs = {
  data: IBlogTaxonomyInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateCollectionArgs = {
  data: ICollectionInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateCompanyArgs = {
  data: ICompanyInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateConfigurationArgs = {
  data: IConfigurationInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateContactHistoryArgs = {
  data: IContactHistoryInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateContentArgs = {
  data: IContentInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateContentDownloadArgs = {
  data: IContentDownloadInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateContentVisitArgs = {
  data: IContentVisitInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateCountryArgs = {
  data: ICountryInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateCustomTagArgs = {
  data: ICustomTagInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateDemographicArgs = {
  data: IDemographicInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateDurationArgs = {
  data: IDurationInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateEmailReceiverArgs = {
  data: IEmailReceiverInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateEnhancedRequestContentArgs = {
  data: IEnhancedRequestContentInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateEventArgs = {
  data: IEventInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateEventFeatureArgs = {
  data: IEventFeatureInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateEventFormatArgs = {
  data: IEventFormatInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateExistingCustomerArgs = {
  data: IExistingCustomerInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateExpertArgs = {
  data: IExpertInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateFeatureArgs = {
  data: IFeatureInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateFreeAskAiLogArgs = {
  data: IFreeAskAiLogInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateFreeContentLogArgs = {
  data: IFreeContentLogInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateFreeSearchLogArgs = {
  data: IFreeSearchLogInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateHqArgs = {
  data: IHqInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateIltaDataArgs = {
  data: IIltaDataInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateIltaSponsorshipArgs = {
  data: IIltaSponsorshipInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateInstallationArgs = {
  data: IInstallationInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateIntegrationArgs = {
  data: IIntegrationInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateListingRequestArgs = {
  data: IListingRequestInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateNewsletterCategoryArgs = {
  data: INewsletterCategoryInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateNewsletterSubscriptionArgs = {
  data: INewsletterSubscriptionInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateNotificationSentArgs = {
  data: INotificationSentInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateOfficeArgs = {
  data: IOfficeInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdatePhaseArgs = {
  data: IPhaseInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdatePlatformLanguageArgs = {
  data: IPlatformLanguageInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdatePracticeAreaArgs = {
  data: IPracticeAreaInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdatePremiumAudienceArgs = {
  data: IPremiumAudienceInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdatePremiumOrganizationArgs = {
  data: IPremiumOrganizationInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdatePremiumPricingPlanArgs = {
  data: IPremiumPricingPlanInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdatePrivacyPolicyArgs = {
  data: IPrivacyPolicyInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdatePublisherActionArgs = {
  data: IPublisherActionInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateRecordLockingOpenEntityArgs = {
  data: IRecordLockingOpenEntityInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateRecurrenceArgs = {
  data: IRecurrenceInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateRegionsServedArgs = {
  data: IRegionsServedInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateResourceInvitationArgs = {
  data: IResourceInvitationInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateReviewArgs = {
  data: IReviewInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateReviewWorkflowsWorkflowArgs = {
  data: IReviewWorkflowsWorkflowInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateReviewWorkflowsWorkflowStageArgs = {
  data: IReviewWorkflowsWorkflowStageInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateSecurityArgs = {
  data: ISecurityInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateSharedPortfolioArgs = {
  data: ISharedPortfolioInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateSharedPortfolioMemberRoleArgs = {
  memberUserId: Scalars['ID']['input']
  role: Scalars['String']['input']
  sharedPortfolioId: Scalars['ID']['input']
}

export type IMutationUpdateSharedPortfolioMembersArgs = {
  members: Array<ISharedPortfolioMemberInput>
  name?: InputMaybe<Scalars['String']['input']>
  sharedPortfolioId: Scalars['ID']['input']
}

export type IMutationUpdateSharedPortfolioMembershipArgs = {
  data: ISharedPortfolioMembershipInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateSharedPortfolioSolutionArgs = {
  category?: InputMaybe<Scalars['String']['input']>
  followingSolutionNote?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

export type IMutationUpdateSlugUpdateArgs = {
  data: ISlugUpdateInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateSolutionArgs = {
  data: ISolutionInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateSolutionRequestArgs = {
  data: ISolutionRequestInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateSubTopicArgs = {
  data: ISubTopicInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateSubjectMatterArgs = {
  data: ISubjectMatterInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateTermsConditionsArgs = {
  data: ITermsConditionsInput
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateTestimonialsArgs = {
  data: ITestimonialsInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateThemeArgs = {
  data: IThemeInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateTopicArgs = {
  data: ITopicInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateTypeOfUserArgs = {
  data: ITypeOfUserInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateUploadFileArgs = {
  id: Scalars['ID']['input']
  info?: InputMaybe<IFileInfoInput>
}

export type IMutationUpdateUserArgs = {
  data: IUserInput
  id: Scalars['ID']['input']
}

export type IMutationUpdateUserProfileArgs = {
  data: IUpdateUserProfileInput
  id: Scalars['ID']['input']
}

export type IMutationUpdateUserSystemFeatureArgs = {
  data: IUserSystemFeatureInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateUsersPermissionsRoleArgs = {
  data: IUsersPermissionsRoleInput
  id: Scalars['ID']['input']
}

export type IMutationUpdateVendorArgs = {
  data: IVendorInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationUpdateVendorTopicArgs = {
  data: IVendorTopicInput
  documentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}

export type IMutationVisitContentArgs = {
  data: IContentId
}

export type IMySharedContentsFilters = {
  contentType?: InputMaybe<Scalars['String']['input']>
  subTopicIds?: InputMaybe<Scalars['String']['input']>
}

export type IMySharedContentsReturnType = {
  __typename?: 'MySharedContentsReturnType'
  contents: Array<IContentEntity>
  total: Scalars['Int']['output']
}

export type INewsletterCategory = {
  __typename?: 'NewsletterCategory'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type INewsletterCategoryEntityResponseCollection = {
  __typename?: 'NewsletterCategoryEntityResponseCollection'
  nodes: Array<INewsletterCategory>
  pageInfo: IPagination
}

export type INewsletterCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<INewsletterCategoryFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<INewsletterCategoryFiltersInput>
  or?: InputMaybe<Array<InputMaybe<INewsletterCategoryFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type INewsletterCategoryInput = {
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type INewsletterCategoryRelationResponseCollection = {
  __typename?: 'NewsletterCategoryRelationResponseCollection'
  nodes: Array<INewsletterCategory>
}

export type INewsletterSubscription = {
  __typename?: 'NewsletterSubscription'
  categories: Array<Maybe<INewsletterCategory>>
  categories_connection?: Maybe<INewsletterCategoryRelationResponseCollection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  email?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  user?: Maybe<IUser>
}

export type INewsletterSubscriptionCategoriesArgs = {
  filters?: InputMaybe<INewsletterCategoryFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type INewsletterSubscriptionCategories_ConnectionArgs = {
  filters?: InputMaybe<INewsletterCategoryFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type INewsletterSubscriptionEntityResponseCollection = {
  __typename?: 'NewsletterSubscriptionEntityResponseCollection'
  nodes: Array<INewsletterSubscription>
  pageInfo: IPagination
}

export type INewsletterSubscriptionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<INewsletterSubscriptionFiltersInput>>>
  categories?: InputMaybe<INewsletterCategoryFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  email?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<INewsletterSubscriptionFiltersInput>
  or?: InputMaybe<Array<InputMaybe<INewsletterSubscriptionFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
  user?: InputMaybe<IUserFiltersInput>
}

export type INewsletterSubscriptionInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  companyName: Scalars['String']['input']
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  user?: InputMaybe<Scalars['ID']['input']>
}

export type INotificationSent = {
  __typename?: 'NotificationSent'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  solutionName: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type INotificationSentEntityResponseCollection = {
  __typename?: 'NotificationSentEntityResponseCollection'
  nodes: Array<INotificationSent>
  pageInfo: IPagination
}

export type INotificationSentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<INotificationSentFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  not?: InputMaybe<INotificationSentFiltersInput>
  or?: InputMaybe<Array<InputMaybe<INotificationSentFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  solutionName?: InputMaybe<IStringFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type INotificationSentInput = {
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  pushUpdateMessageDetails?: InputMaybe<Array<InputMaybe<IComponentSolutionPushUpdateMessageDetailsInput>>>
  solutionName?: InputMaybe<Scalars['String']['input']>
}

export type IOffice = {
  __typename?: 'Office'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IOfficeEntityResponseCollection = {
  __typename?: 'OfficeEntityResponseCollection'
  nodes: Array<IOffice>
  pageInfo: IPagination
}

export type IOfficeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IOfficeFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IOfficeFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IOfficeFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IOfficeInput = {
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IOfficeItem = {
  __typename?: 'OfficeItem'
  documentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type IOfficeRelationResponseCollection = {
  __typename?: 'OfficeRelationResponseCollection'
  nodes: Array<IOffice>
}

export type IOfficesFiltersInput = {
  name?: InputMaybe<IStringFilterInput>
}

export type IPagination = {
  __typename?: 'Pagination'
  page: Scalars['Int']['output']
  pageCount: Scalars['Int']['output']
  pageSize: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

export type IPaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  start?: InputMaybe<Scalars['Int']['input']>
}

export type IPaginationInput = {
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
}

export type IPhase = {
  __typename?: 'Phase'
  contents: Array<Maybe<IContent>>
  contents_connection?: Maybe<IContentRelationResponseCollection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  documentId: Scalars['ID']['output']
  priority: Scalars['Int']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  title: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IPhaseContentsArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IPhaseContents_ConnectionArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IPhaseEntityResponseCollection = {
  __typename?: 'PhaseEntityResponseCollection'
  nodes: Array<IPhase>
  pageInfo: IPagination
}

export type IPhaseFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IPhaseFiltersInput>>>
  contents?: InputMaybe<IContentFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  description?: InputMaybe<IStringFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  not?: InputMaybe<IPhaseFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IPhaseFiltersInput>>>
  priority?: InputMaybe<IIntFilterInput>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  title?: InputMaybe<IStringFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IPhaseInput = {
  contents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  description?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  priority?: InputMaybe<Scalars['Int']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type IPlatformLanguage = {
  __typename?: 'PlatformLanguage'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IPlatformLanguageEntityResponseCollection = {
  __typename?: 'PlatformLanguageEntityResponseCollection'
  nodes: Array<IPlatformLanguage>
  pageInfo: IPagination
}

export type IPlatformLanguageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IPlatformLanguageFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IPlatformLanguageFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IPlatformLanguageFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IPlatformLanguageInput = {
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IPlatformLanguageItem = {
  __typename?: 'PlatformLanguageItem'
  documentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type IPlatformLanguageRelationResponseCollection = {
  __typename?: 'PlatformLanguageRelationResponseCollection'
  nodes: Array<IPlatformLanguage>
}

export type IPlatformLanguagesFiltersInput = {
  name?: InputMaybe<IStringFilterInput>
}

export type IPopularTopic = {
  __typename?: 'PopularTopic'
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  slug: Scalars['String']['output']
  solutions: Array<IPopularTopicListing>
}

export type IPopularTopicListing = {
  __typename?: 'PopularTopicListing'
  id: Scalars['Int']['output']
  logo?: Maybe<IPopularTopicListingLogo>
  slug: Scalars['String']['output']
  type?: Maybe<IEnum_Solution_Type>
}

export type IPopularTopicListingLogo = {
  __typename?: 'PopularTopicListingLogo'
  url?: Maybe<Scalars['String']['output']>
}

export type IPracticeArea = {
  __typename?: 'PracticeArea'
  content: Array<Maybe<IContent>>
  content_connection?: Maybe<IContentRelationResponseCollection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IPracticeAreaContentArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IPracticeAreaContent_ConnectionArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IPracticeAreaEntityResponseCollection = {
  __typename?: 'PracticeAreaEntityResponseCollection'
  nodes: Array<IPracticeArea>
  pageInfo: IPagination
}

export type IPracticeAreaFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IPracticeAreaFiltersInput>>>
  content?: InputMaybe<IContentFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IPracticeAreaFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IPracticeAreaFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IPracticeAreaInput = {
  content?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IPracticeAreaItem = {
  __typename?: 'PracticeAreaItem'
  documentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type IPracticeAreaRelationResponseCollection = {
  __typename?: 'PracticeAreaRelationResponseCollection'
  nodes: Array<IPracticeArea>
}

export type IPracticeAreasFiltersInput = {
  name?: InputMaybe<IStringFilterInput>
}

export type IPremiumAudience = {
  __typename?: 'PremiumAudience'
  contents: Array<Maybe<IContent>>
  contents_connection?: Maybe<IContentRelationResponseCollection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  shouldShowOnHomepage?: Maybe<Scalars['Boolean']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IPremiumAudienceContentsArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IPremiumAudienceContents_ConnectionArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IPremiumAudienceEntityResponseCollection = {
  __typename?: 'PremiumAudienceEntityResponseCollection'
  nodes: Array<IPremiumAudience>
  pageInfo: IPagination
}

export type IPremiumAudienceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IPremiumAudienceFiltersInput>>>
  contents?: InputMaybe<IContentFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IPremiumAudienceFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IPremiumAudienceFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  shouldShowOnHomepage?: InputMaybe<IBooleanFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IPremiumAudienceInput = {
  contents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  shouldShowOnHomepage?: InputMaybe<Scalars['Boolean']['input']>
}

export type IPremiumAudienceRelationResponseCollection = {
  __typename?: 'PremiumAudienceRelationResponseCollection'
  nodes: Array<IPremiumAudience>
}

export type IPremiumOrganization = {
  __typename?: 'PremiumOrganization'
  billingAddress: IComponentBillingAddressBillingAddress
  bulkUploadInvitation?: Maybe<IUploadFile>
  cognitoProviderId?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  emailDomain: Scalars['String']['output']
  invitations?: Maybe<Array<Maybe<IComponentInvitationsInvitations>>>
  isVendor?: Maybe<Scalars['Boolean']['output']>
  leadSource?: Maybe<Scalars['String']['output']>
  members: Array<Maybe<IUser>>
  members_connection?: Maybe<IUserRelationResponseCollection>
  name: Scalars['String']['output']
  newsletterCategories: Array<Maybe<INewsletterCategory>>
  newsletterCategories_connection?: Maybe<INewsletterCategoryRelationResponseCollection>
  pricingPlan?: Maybe<IPremiumPricingPlan>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  registrationContact: Array<Maybe<IComponentRegistrationContactRegistrationContact>>
  shared_portfolios: Array<Maybe<ISharedPortfolio>>
  shared_portfolios_connection?: Maybe<ISharedPortfolioRelationResponseCollection>
  shouldSendResponse?: Maybe<Scalars['Boolean']['output']>
  solutions: Array<Maybe<ISolution>>
  solutions_connection?: Maybe<ISolutionRelationResponseCollection>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IPremiumOrganizationInvitationsArgs = {
  filters?: InputMaybe<IComponentInvitationsInvitationsFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IPremiumOrganizationMembersArgs = {
  filters?: InputMaybe<IUserFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IPremiumOrganizationMembers_ConnectionArgs = {
  filters?: InputMaybe<IUserFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IPremiumOrganizationNewsletterCategoriesArgs = {
  filters?: InputMaybe<INewsletterCategoryFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IPremiumOrganizationNewsletterCategories_ConnectionArgs = {
  filters?: InputMaybe<INewsletterCategoryFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IPremiumOrganizationRegistrationContactArgs = {
  filters?: InputMaybe<IComponentRegistrationContactRegistrationContactFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IPremiumOrganizationShared_PortfoliosArgs = {
  filters?: InputMaybe<ISharedPortfolioFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IPremiumOrganizationShared_Portfolios_ConnectionArgs = {
  filters?: InputMaybe<ISharedPortfolioFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IPremiumOrganizationSolutionsArgs = {
  filters?: InputMaybe<ISolutionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IPremiumOrganizationSolutions_ConnectionArgs = {
  filters?: InputMaybe<ISolutionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IPremiumOrganizationEntityResponseCollection = {
  __typename?: 'PremiumOrganizationEntityResponseCollection'
  nodes: Array<IPremiumOrganization>
  pageInfo: IPagination
}

export type IPremiumOrganizationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IPremiumOrganizationFiltersInput>>>
  billingAddress?: InputMaybe<IComponentBillingAddressBillingAddressFiltersInput>
  cognitoProviderId?: InputMaybe<IStringFilterInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  emailDomain?: InputMaybe<IStringFilterInput>
  invitations?: InputMaybe<IComponentInvitationsInvitationsFiltersInput>
  isVendor?: InputMaybe<IBooleanFilterInput>
  leadSource?: InputMaybe<IStringFilterInput>
  members?: InputMaybe<IUserFiltersInput>
  name?: InputMaybe<IStringFilterInput>
  newsletterCategories?: InputMaybe<INewsletterCategoryFiltersInput>
  not?: InputMaybe<IPremiumOrganizationFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IPremiumOrganizationFiltersInput>>>
  pricingPlan?: InputMaybe<IPremiumPricingPlanFiltersInput>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  registrationContact?: InputMaybe<IComponentRegistrationContactRegistrationContactFiltersInput>
  shared_portfolios?: InputMaybe<ISharedPortfolioFiltersInput>
  shouldSendResponse?: InputMaybe<IBooleanFilterInput>
  solutions?: InputMaybe<ISolutionFiltersInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IPremiumOrganizationInput = {
  billingAddress?: InputMaybe<IComponentBillingAddressBillingAddressInput>
  bulkUploadInvitation?: InputMaybe<Scalars['ID']['input']>
  cognitoProviderId?: InputMaybe<Scalars['String']['input']>
  emailDomain?: InputMaybe<Scalars['String']['input']>
  invitations?: InputMaybe<Array<InputMaybe<IComponentInvitationsInvitationsInput>>>
  isVendor?: InputMaybe<Scalars['Boolean']['input']>
  leadSource?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  members?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  name?: InputMaybe<Scalars['String']['input']>
  newsletterCategories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  premiumOrganizationStatus?: InputMaybe<IEnum_Premiumorganization_Premiumorganizationstatus>
  pricingPlan?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  registrationContact?: InputMaybe<Array<InputMaybe<IComponentRegistrationContactRegistrationContactInput>>>
  shared_portfolios?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  shouldSendResponse?: InputMaybe<Scalars['Boolean']['input']>
  solutions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  vendor?: InputMaybe<Scalars['ID']['input']>
}

export type IPremiumOrganizationRelationResponseCollection = {
  __typename?: 'PremiumOrganizationRelationResponseCollection'
  nodes: Array<IPremiumOrganization>
}

export type IPremiumPricingPlan = {
  __typename?: 'PremiumPricingPlan'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  isActive?: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
  pricePerYear: Scalars['Int']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  stripeRedirectUrl: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IPremiumPricingPlanEntityResponseCollection = {
  __typename?: 'PremiumPricingPlanEntityResponseCollection'
  nodes: Array<IPremiumPricingPlan>
  pageInfo: IPagination
}

export type IPremiumPricingPlanFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IPremiumPricingPlanFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  isActive?: InputMaybe<IBooleanFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IPremiumPricingPlanFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IPremiumPricingPlanFiltersInput>>>
  pricePerYear?: InputMaybe<IIntFilterInput>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  stripeRedirectUrl?: InputMaybe<IStringFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IPremiumPricingPlanInput = {
  companySize?: InputMaybe<IEnum_Premiumpricingplan_Companysize>
  companyType?: InputMaybe<IEnum_Premiumpricingplan_Companytype>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  premiumOrganizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  pricePerYear?: InputMaybe<Scalars['Int']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  stripeRedirectUrl?: InputMaybe<Scalars['String']['input']>
}

export type IPrivacyPolicy = {
  __typename?: 'PrivacyPolicy'
  content?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  date?: Maybe<Scalars['Date']['output']>
  documentId: Scalars['ID']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  summary?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IPrivacyPolicyInput = {
  content?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['Date']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
}

/** Personal followed-solutions list (private portfolio row or stub); use with filters as private_portfolio. */
export type IPrivateFollowingPortfolioStub = {
  __typename?: 'PrivateFollowingPortfolioStub'
  documentId: Scalars['String']['output']
  name: Scalars['String']['output']
  slug?: Maybe<Scalars['String']['output']>
}

export enum IPublicationFilter {
  HasPublishedVersion = 'HAS_PUBLISHED_VERSION',
  HasPublishedVersionDocument = 'HAS_PUBLISHED_VERSION_DOCUMENT',
  Modified = 'MODIFIED',
  NeverPublished = 'NEVER_PUBLISHED',
  NeverPublishedDocument = 'NEVER_PUBLISHED_DOCUMENT',
  PublishedWithoutDraft = 'PUBLISHED_WITHOUT_DRAFT',
  PublishedWithDraft = 'PUBLISHED_WITH_DRAFT',
  Unmodified = 'UNMODIFIED',
}

export enum IPublicationStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export type IPublisherAction = {
  __typename?: 'PublisherAction'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  entityId: Scalars['String']['output']
  entitySlug: Scalars['String']['output']
  executeAt: Scalars['DateTime']['output']
  mode: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IPublisherActionEntityResponseCollection = {
  __typename?: 'PublisherActionEntityResponseCollection'
  nodes: Array<IPublisherAction>
  pageInfo: IPagination
}

export type IPublisherActionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IPublisherActionFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  entityId?: InputMaybe<IStringFilterInput>
  entitySlug?: InputMaybe<IStringFilterInput>
  executeAt?: InputMaybe<IDateTimeFilterInput>
  mode?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IPublisherActionFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IPublisherActionFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IPublisherActionInput = {
  entityId?: InputMaybe<Scalars['String']['input']>
  entitySlug?: InputMaybe<Scalars['String']['input']>
  executeAt?: InputMaybe<Scalars['DateTime']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  mode?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IQuery = {
  __typename?: 'Query'
  about?: Maybe<IAbout>
  aiSmartSearch: ISmartsearchData
  announcement?: Maybe<IAnnouncement>
  announcements: Array<Maybe<IAnnouncement>>
  announcements_connection?: Maybe<IAnnouncementEntityResponseCollection>
  articleData?: Maybe<IArticleData>
  articleDatas: Array<Maybe<IArticleData>>
  articleDatas_connection?: Maybe<IArticleDataEntityResponseCollection>
  askAiLog?: Maybe<IAskAiLog>
  askAiLogs: Array<Maybe<IAskAiLog>>
  askAiLogs_connection?: Maybe<IAskAiLogEntityResponseCollection>
  attribute?: Maybe<IAttribute>
  attributes: Array<Maybe<IAttribute>>
  attributes_connection?: Maybe<IAttributeEntityResponseCollection>
  audience?: Maybe<IAudience>
  audiences: Array<Maybe<IAudience>>
  audiences_connection?: Maybe<IAudienceEntityResponseCollection>
  author?: Maybe<IAuthor>
  authors: Array<Maybe<IAuthor>>
  authors_connection?: Maybe<IAuthorEntityResponseCollection>
  autosuggest: IAutosuggestData
  bannerAnnouncement?: Maybe<IBannerAnnouncement>
  blogTaxonomy?: Maybe<IBlogTaxonomy>
  blogTaxonomys: Array<Maybe<IBlogTaxonomy>>
  blogTaxonomys_connection?: Maybe<IBlogTaxonomyEntityResponseCollection>
  /** Check Free Search and Update Free Search Entry */
  checkFreeSearch?: Maybe<ICheckFreeSearchResultType>
  collection?: Maybe<ICollection>
  collections: Array<Maybe<ICollection>>
  collections_connection?: Maybe<ICollectionEntityResponseCollection>
  companies: Array<Maybe<ICompany>>
  companies_connection?: Maybe<ICompanyEntityResponseCollection>
  company?: Maybe<ICompany>
  configuration?: Maybe<IConfiguration>
  contactHistories: Array<Maybe<IContactHistory>>
  contactHistories_connection?: Maybe<IContactHistoryEntityResponseCollection>
  contactHistory?: Maybe<IContactHistory>
  content?: Maybe<IContent>
  /** Return article contents */
  contentBySlug?: Maybe<IContentEntityBySlug>
  contentDownload?: Maybe<IContentDownload>
  contentDownloads: Array<Maybe<IContentDownload>>
  contentDownloads_connection?: Maybe<IContentDownloadEntityResponseCollection>
  /** Return filtered content */
  contentResults: IContentSearchReturnType
  contentVisit?: Maybe<IContentVisit>
  /** Aggregation for the Content Visit */
  contentVisitDownloads: Array<ISharedResourceEntity>
  contentVisits: Array<Maybe<IContentVisit>>
  contentVisits_connection?: Maybe<IContentVisitEntityResponseCollection>
  contents: Array<Maybe<IContent>>
  contents_connection?: Maybe<IContentEntityResponseCollection>
  countries: Array<Maybe<ICountry>>
  countries_connection?: Maybe<ICountryEntityResponseCollection>
  country?: Maybe<ICountry>
  customTag?: Maybe<ICustomTag>
  /** Topics/subtopics for solutions in a custom tag (same org) */
  customTagTopics?: Maybe<Array<Maybe<IFollowingTopicEntity>>>
  customTags: Array<Maybe<ICustomTag>>
  customTags_connection?: Maybe<ICustomTagEntityResponseCollection>
  demographic?: Maybe<IDemographic>
  demographics: Array<Maybe<IDemographic>>
  demographics_connection?: Maybe<IDemographicEntityResponseCollection>
  /** Return download material file */
  downloadMaterialFile: IDownloadMaterialFileEntity
  duration?: Maybe<IDuration>
  durations: Array<Maybe<IDuration>>
  durations_connection?: Maybe<IDurationEntityResponseCollection>
  emailReceiver?: Maybe<IEmailReceiver>
  emailReceivers: Array<Maybe<IEmailReceiver>>
  emailReceivers_connection?: Maybe<IEmailReceiverEntityResponseCollection>
  enhancedRequestContent?: Maybe<IEnhancedRequestContent>
  event?: Maybe<IEvent>
  eventFeature?: Maybe<IEventFeature>
  eventFeatures: Array<Maybe<IEventFeature>>
  eventFeatures_connection?: Maybe<IEventFeatureEntityResponseCollection>
  eventFormat?: Maybe<IEventFormat>
  eventFormats: Array<Maybe<IEventFormat>>
  eventFormats_connection?: Maybe<IEventFormatEntityResponseCollection>
  /** Return filtered events */
  eventResults: IEventSearchReturnType
  events: Array<Maybe<IEvent>>
  events_connection?: Maybe<IEventEntityResponseCollection>
  existingCustomer?: Maybe<IExistingCustomer>
  existingCustomers: Array<Maybe<IExistingCustomer>>
  /** Fetch paginated existing customer records with search and sorting */
  existingCustomersPagination: Array<IExistingCustomerItem>
  existingCustomers_connection?: Maybe<IExistingCustomerEntityResponseCollection>
  expert?: Maybe<IExpert>
  experts: Array<Maybe<IExpert>>
  experts_connection?: Maybe<IExpertEntityResponseCollection>
  feature?: Maybe<IFeature>
  /** Return article contents */
  featuredContents: Array<IContentEntity>
  features: Array<Maybe<IFeature>>
  features_connection?: Maybe<IFeatureEntityResponseCollection>
  /** Return filtered solution */
  findAnnouncementBySolutionId: ISearchAnnouncementsResult
  /** folloing topics */
  followingTopics?: Maybe<Array<Maybe<IFollowingTopicEntity>>>
  freeAskAiLog?: Maybe<IFreeAskAiLog>
  freeAskAiLogs: Array<Maybe<IFreeAskAiLog>>
  freeAskAiLogs_connection?: Maybe<IFreeAskAiLogEntityResponseCollection>
  freeContentLog?: Maybe<IFreeContentLog>
  freeContentLogs: Array<Maybe<IFreeContentLog>>
  freeContentLogs_connection?: Maybe<IFreeContentLogEntityResponseCollection>
  freeSearchLog?: Maybe<IFreeSearchLog>
  freeSearchLogs: Array<Maybe<IFreeSearchLog>>
  freeSearchLogs_connection?: Maybe<IFreeSearchLogEntityResponseCollection>
  /** Fetch all master datasets in a single query */
  getAllMasterData: IGetAllMasterDataResult
  /** Fetch a shared portfolio custom tag by slug */
  getCustomTagBySlug?: Maybe<ICustomTagResult>
  /** Fetch paginated integration records with search and sorting */
  getIntegrationsPagination: Array<IIntegrationItem>
  /** Portfolio custom tags for the authenticated user */
  getMyCustomTags: Array<ICustomTagResult>
  /** Fetch paginated office records with search and sorting */
  getOfficesPagination: Array<IOfficeItem>
  /** Fetch paginated practice area records with search and sorting */
  getPracticeAreasPagination: Array<IPracticeAreaItem>
  hq?: Maybe<IHq>
  hqs: Array<Maybe<IHq>>
  /** Fetch paginated HQ records with search and sorting */
  hqsPagination: Array<IHqItem>
  hqs_connection?: Maybe<IHqEntityResponseCollection>
  i18NLocale?: Maybe<II18NLocale>
  i18NLocales: Array<Maybe<II18NLocale>>
  i18NLocales_connection?: Maybe<II18NLocaleEntityResponseCollection>
  iltaData?: Maybe<IIltaData>
  iltaSponsorship?: Maybe<IIltaSponsorship>
  iltaSponsorships: Array<Maybe<IIltaSponsorship>>
  iltaSponsorships_connection?: Maybe<IIltaSponsorshipEntityResponseCollection>
  installation?: Maybe<IInstallation>
  installations: Array<Maybe<IInstallation>>
  installations_connection?: Maybe<IInstallationEntityResponseCollection>
  integration?: Maybe<IIntegration>
  integrations: Array<Maybe<IIntegration>>
  integrations_connection?: Maybe<IIntegrationEntityResponseCollection>
  /** invited users list */
  invitedUsers: IInvitedUsersResult
  /** is following a vendor/alsp/consultant */
  isFollow?: Maybe<Scalars['String']['output']>
  isUserInConfig: Scalars['Boolean']['output']
  listingRequest?: Maybe<IListingRequest>
  listingRequests: Array<Maybe<IListingRequest>>
  listingRequests_connection?: Maybe<IListingRequestEntityResponseCollection>
  /** Return locations for event filtering */
  location?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  me?: Maybe<IUsersPermissionsMe>
  /** query for non-premium users to return available topics/subTopics */
  myResourcesProductTypes: IShareableTopicsReturnType
  /** Return the list of my resources shared by premium users */
  mySharedContents: IMySharedContentsReturnType
  newsletterCategories: Array<Maybe<INewsletterCategory>>
  newsletterCategories_connection?: Maybe<INewsletterCategoryEntityResponseCollection>
  newsletterCategory?: Maybe<INewsletterCategory>
  newsletterSubscription?: Maybe<INewsletterSubscription>
  newsletterSubscriptions: Array<Maybe<INewsletterSubscription>>
  newsletterSubscriptions_connection?: Maybe<INewsletterSubscriptionEntityResponseCollection>
  notificationSent?: Maybe<INotificationSent>
  notificationSents: Array<Maybe<INotificationSent>>
  notificationSents_connection?: Maybe<INotificationSentEntityResponseCollection>
  office?: Maybe<IOffice>
  offices: Array<Maybe<IOffice>>
  offices_connection?: Maybe<IOfficeEntityResponseCollection>
  /** Return organizations for event filtering */
  organization?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  phase?: Maybe<IPhase>
  phases: Array<Maybe<IPhase>>
  phases_connection?: Maybe<IPhaseEntityResponseCollection>
  platformLanguage?: Maybe<IPlatformLanguage>
  platformLanguages: Array<Maybe<IPlatformLanguage>>
  /** Fetch paginated platform language records with search and sorting */
  platformLanguagesPagination: Array<IPlatformLanguageItem>
  platformLanguages_connection?: Maybe<IPlatformLanguageEntityResponseCollection>
  /** Return a list of popular topics */
  popularTopics: Array<IPopularTopic>
  practiceArea?: Maybe<IPracticeArea>
  practiceAreas: Array<Maybe<IPracticeArea>>
  practiceAreas_connection?: Maybe<IPracticeAreaEntityResponseCollection>
  premiumAudience?: Maybe<IPremiumAudience>
  premiumAudiences: Array<Maybe<IPremiumAudience>>
  premiumAudiences_connection?: Maybe<IPremiumAudienceEntityResponseCollection>
  premiumOrganization?: Maybe<IPremiumOrganization>
  premiumOrganizations: Array<Maybe<IPremiumOrganization>>
  premiumOrganizations_connection?: Maybe<IPremiumOrganizationEntityResponseCollection>
  premiumPricingPlan?: Maybe<IPremiumPricingPlan>
  premiumPricingPlans: Array<Maybe<IPremiumPricingPlan>>
  premiumPricingPlans_connection?: Maybe<IPremiumPricingPlanEntityResponseCollection>
  /** Return the draft or published version of an article for CMS Live Preview (requires the preview secret) */
  previewContentBySlug?: Maybe<IContentEntityBySlug>
  privacyPolicy?: Maybe<IPrivacyPolicy>
  publisherAction?: Maybe<IPublisherAction>
  publisherActions: Array<Maybe<IPublisherAction>>
  publisherActions_connection?: Maybe<IPublisherActionEntityResponseCollection>
  recordLockingOpenEntities: Array<Maybe<IRecordLockingOpenEntity>>
  recordLockingOpenEntities_connection?: Maybe<IRecordLockingOpenEntityEntityResponseCollection>
  recordLockingOpenEntity?: Maybe<IRecordLockingOpenEntity>
  recurrence?: Maybe<IRecurrence>
  recurrences: Array<Maybe<IRecurrence>>
  recurrences_connection?: Maybe<IRecurrenceEntityResponseCollection>
  regionsServed?: Maybe<IRegionsServed>
  regionsServeds: Array<Maybe<IRegionsServed>>
  regionsServeds_connection?: Maybe<IRegionsServedEntityResponseCollection>
  /** Return article contents */
  relatedArticlesOfContent: IContentSearchReturnType
  /** Return Related Content By Solution */
  relatedContentBySolution?: Maybe<IRelatedContentBySolutionhReturnType>
  /** folloing subtopic topics */
  relatedSubtopicTopics?: Maybe<Array<Maybe<IFollowingTopicEntity>>>
  resourceInvitation?: Maybe<IResourceInvitation>
  resourceInvitations: Array<Maybe<IResourceInvitation>>
  resourceInvitations_connection?: Maybe<IResourceInvitationEntityResponseCollection>
  review?: Maybe<IReview>
  reviewWorkflowsWorkflow?: Maybe<IReviewWorkflowsWorkflow>
  reviewWorkflowsWorkflowStage?: Maybe<IReviewWorkflowsWorkflowStage>
  reviewWorkflowsWorkflowStages: Array<Maybe<IReviewWorkflowsWorkflowStage>>
  reviewWorkflowsWorkflowStages_connection?: Maybe<IReviewWorkflowsWorkflowStageEntityResponseCollection>
  reviewWorkflowsWorkflows: Array<Maybe<IReviewWorkflowsWorkflow>>
  reviewWorkflowsWorkflows_connection?: Maybe<IReviewWorkflowsWorkflowEntityResponseCollection>
  reviews: Array<Maybe<IReview>>
  reviews_connection?: Maybe<IReviewEntityResponseCollection>
  /** Search portfolio custom tags by name for the authenticated user */
  searchCustomTags: Array<ICustomTagResult>
  /** Search premium-org users by username/email/company for shared-portfolio editor picker */
  searchSharedPortfolioOrganizationUsers: ISharedPortfolioOrganizationUsersResult
  /** Return filtered solution */
  searchSolutions: ISearchSolutionsResultType
  /** Return filtered subtopics */
  searchSubtopics: ISearchSubtopicsResultType
  /** Return filtered searchUnfollowedRelatedSubtopics */
  searchUnfollowedRelatedSubtopics: IUnFollowedRelatedSubtopicsResult
  /** Return filtered solution for a specific vendor */
  searchVendorSolutions: ISearchSolutionsResult
  securities: Array<Maybe<ISecurity>>
  securities_connection?: Maybe<ISecurityEntityResponseCollection>
  security?: Maybe<ISecurity>
  /** Return all the resources that you could share */
  shareableContents: IShareableContentsReturnType
  /** Return all the topics/subTopics which are related to the contents that you could share */
  shareableTopics: IShareableTopicsReturnType
  sharedPortfolio?: Maybe<ISharedPortfolio>
  sharedPortfolioMembership?: Maybe<ISharedPortfolioMembership>
  sharedPortfolioMemberships: Array<Maybe<ISharedPortfolioMembership>>
  sharedPortfolioMemberships_connection?: Maybe<ISharedPortfolioMembershipEntityResponseCollection>
  sharedPortfolioSolution?: Maybe<ISharedPortfolioSolution>
  sharedPortfolioSolutions: Array<Maybe<ISharedPortfolioSolution>>
  sharedPortfolioSolutions_connection?: Maybe<ISharedPortfolioSolutionEntityResponseCollection>
  /** Topics/subtopics for solutions in a shared portfolio (member, same org) */
  sharedPortfolioTopics?: Maybe<Array<Maybe<IFollowingTopicEntity>>>
  sharedPortfolios: Array<Maybe<ISharedPortfolio>>
  /** Return caller premium-org shared portfolios with optional slug/id, pagination, and private/shared filters */
  sharedPortfoliosForMyOrganization: ISharedPortfoliosForMyOrganizationPayload
  sharedPortfolios_connection?: Maybe<ISharedPortfolioEntityResponseCollection>
  showRelatedContentFeature: Scalars['Boolean']['output']
  /** Return similar solutions */
  similarSolutions: ISimilarSolutionsResult
  slugUpdate?: Maybe<ISlugUpdate>
  slugUpdates: Array<Maybe<ISlugUpdate>>
  slugUpdates_connection?: Maybe<ISlugUpdateEntityResponseCollection>
  solution?: Maybe<ISolution>
  solutionRequest?: Maybe<ISolutionRequest>
  solutionRequests: Array<Maybe<ISolutionRequest>>
  solutionRequests_connection?: Maybe<ISolutionRequestEntityResponseCollection>
  solutions: Array<Maybe<ISolution>>
  /** Return the count of solutions */
  solutionsCount: Scalars['Int']['output']
  solutions_connection?: Maybe<ISolutionEntityResponseCollection>
  subTopic?: Maybe<ISubTopic>
  subTopics: Array<Maybe<ISubTopic>>
  subTopics_connection?: Maybe<ISubTopicEntityResponseCollection>
  subjectMatter?: Maybe<ISubjectMatter>
  subjectMatters: Array<Maybe<ISubjectMatter>>
  subjectMatters_connection?: Maybe<ISubjectMatterEntityResponseCollection>
  termsConditions?: Maybe<ITermsConditions>
  testimonials?: Maybe<ITestimonials>
  testimonialsPlural: Array<Maybe<ITestimonials>>
  testimonialsPlural_connection?: Maybe<ITestimonialsEntityResponseCollection>
  theme?: Maybe<ITheme>
  themes: Array<Maybe<ITheme>>
  themes_connection?: Maybe<IThemeEntityResponseCollection>
  topic?: Maybe<ITopic>
  topics: Array<Maybe<ITopic>>
  topics_connection?: Maybe<ITopicEntityResponseCollection>
  /** Return trending contents */
  trendingContents: Array<IContentEntity>
  typeOfUser?: Maybe<ITypeOfUser>
  typeOfUsers: Array<Maybe<ITypeOfUser>>
  typeOfUsers_connection?: Maybe<ITypeOfUserEntityResponseCollection>
  uploadFile?: Maybe<IUploadFile>
  uploadFiles: Array<Maybe<IUploadFile>>
  uploadFiles_connection?: Maybe<IUploadFileEntityResponseCollection>
  user?: Maybe<IUser>
  userInfo?: Maybe<IUsersPermissionsMe>
  userSystemFeature?: Maybe<IUserSystemFeature>
  userSystemFeatures: Array<Maybe<IUserSystemFeature>>
  userSystemFeatures_connection?: Maybe<IUserSystemFeatureEntityResponseCollection>
  users: Array<Maybe<IUser>>
  usersPermissionsRole?: Maybe<IUsersPermissionsRole>
  usersPermissionsRoles: Array<Maybe<IUsersPermissionsRole>>
  usersPermissionsRoles_connection?: Maybe<IUsersPermissionsRoleEntityResponseCollection>
  users_connection?: Maybe<IUserEntityResponseCollection>
  vendor?: Maybe<IVendor>
  vendorTopic?: Maybe<IVendorTopic>
  vendorTopics: Array<Maybe<IVendorTopic>>
  vendorTopics_connection?: Maybe<IVendorTopicEntityResponseCollection>
  vendors: Array<Maybe<IVendor>>
  vendors_connection?: Maybe<IVendorEntityResponseCollection>
}

export type IQueryAboutArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryAiSmartSearchArgs = {
  accessFreeASKAI?: InputMaybe<Scalars['Boolean']['input']>
  checkCount?: InputMaybe<Scalars['Boolean']['input']>
  keyword?: InputMaybe<Scalars['String']['input']>
  uniqueAddress?: InputMaybe<Scalars['String']['input']>
}

export type IQueryAnnouncementArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryAnnouncementsArgs = {
  filters?: InputMaybe<IAnnouncementFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryAnnouncements_ConnectionArgs = {
  filters?: InputMaybe<IAnnouncementFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryArticleDataArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryArticleDatasArgs = {
  filters?: InputMaybe<IArticleDataFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryArticleDatas_ConnectionArgs = {
  filters?: InputMaybe<IArticleDataFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryAskAiLogArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryAskAiLogsArgs = {
  filters?: InputMaybe<IAskAiLogFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryAskAiLogs_ConnectionArgs = {
  filters?: InputMaybe<IAskAiLogFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryAttributeArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryAttributesArgs = {
  filters?: InputMaybe<IAttributeFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryAttributes_ConnectionArgs = {
  filters?: InputMaybe<IAttributeFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryAudienceArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryAudiencesArgs = {
  filters?: InputMaybe<IAudienceFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryAudiences_ConnectionArgs = {
  filters?: InputMaybe<IAudienceFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryAuthorArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryAuthorsArgs = {
  filters?: InputMaybe<IAuthorFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryAuthors_ConnectionArgs = {
  filters?: InputMaybe<IAuthorFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryAutosuggestArgs = {
  accessFreeSearch?: InputMaybe<Scalars['Boolean']['input']>
  customAccessQuery?: InputMaybe<Scalars['String']['input']>
  keyword?: InputMaybe<Scalars['String']['input']>
  uniqueAddress?: InputMaybe<Scalars['String']['input']>
}

export type IQueryBannerAnnouncementArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryBlogTaxonomyArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryBlogTaxonomysArgs = {
  filters?: InputMaybe<IBlogTaxonomyFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryBlogTaxonomys_ConnectionArgs = {
  filters?: InputMaybe<IBlogTaxonomyFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryCheckFreeSearchArgs = {
  accessFreeSearch?: InputMaybe<Scalars['Boolean']['input']>
  customAccessQuery?: InputMaybe<Scalars['String']['input']>
  uniqueAddress?: InputMaybe<Scalars['String']['input']>
}

export type IQueryCollectionArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryCollectionsArgs = {
  filters?: InputMaybe<ICollectionFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryCollections_ConnectionArgs = {
  filters?: InputMaybe<ICollectionFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryCompaniesArgs = {
  filters?: InputMaybe<ICompanyFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryCompanies_ConnectionArgs = {
  filters?: InputMaybe<ICompanyFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryCompanyArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryConfigurationArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryContactHistoriesArgs = {
  filters?: InputMaybe<IContactHistoryFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryContactHistories_ConnectionArgs = {
  filters?: InputMaybe<IContactHistoryFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryContactHistoryArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryContentArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryContentBySlugArgs = {
  accessFreeArticle?: InputMaybe<Scalars['Boolean']['input']>
  slug: Scalars['String']['input']
  uniqueAddress?: InputMaybe<Scalars['String']['input']>
}

export type IQueryContentDownloadArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryContentDownloadsArgs = {
  filters?: InputMaybe<IContentDownloadFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryContentDownloads_ConnectionArgs = {
  filters?: InputMaybe<IContentDownloadFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryContentResultsArgs = {
  gReCaptchaToken?: InputMaybe<Scalars['String']['input']>
  query?: InputMaybe<Scalars['JSON']['input']>
}

export type IQueryContentVisitArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryContentVisitsArgs = {
  filters?: InputMaybe<IContentVisitFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryContentVisits_ConnectionArgs = {
  filters?: InputMaybe<IContentVisitFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryContentsArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryContents_ConnectionArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryCountriesArgs = {
  filters?: InputMaybe<ICountryFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryCountries_ConnectionArgs = {
  filters?: InputMaybe<ICountryFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryCountryArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryCustomTagArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryCustomTagTopicsArgs = {
  customTagId?: InputMaybe<Scalars['ID']['input']>
}

export type IQueryCustomTagsArgs = {
  filters?: InputMaybe<ICustomTagFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryCustomTags_ConnectionArgs = {
  filters?: InputMaybe<ICustomTagFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryDemographicArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryDemographicsArgs = {
  filters?: InputMaybe<IDemographicFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryDemographics_ConnectionArgs = {
  filters?: InputMaybe<IDemographicFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryDownloadMaterialFileArgs = {
  id: Scalars['String']['input']
}

export type IQueryDurationArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryDurationsArgs = {
  filters?: InputMaybe<IDurationFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryDurations_ConnectionArgs = {
  filters?: InputMaybe<IDurationFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryEmailReceiverArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryEmailReceiversArgs = {
  filters?: InputMaybe<IEmailReceiverFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryEmailReceivers_ConnectionArgs = {
  filters?: InputMaybe<IEmailReceiverFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryEnhancedRequestContentArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryEventArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryEventFeatureArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryEventFeaturesArgs = {
  filters?: InputMaybe<IEventFeatureFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryEventFeatures_ConnectionArgs = {
  filters?: InputMaybe<IEventFeatureFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryEventFormatArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryEventFormatsArgs = {
  filters?: InputMaybe<IEventFormatFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryEventFormats_ConnectionArgs = {
  filters?: InputMaybe<IEventFormatFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryEventResultsArgs = {
  query?: InputMaybe<Scalars['JSON']['input']>
}

export type IQueryEventsArgs = {
  filters?: InputMaybe<IEventFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryEvents_ConnectionArgs = {
  filters?: InputMaybe<IEventFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryExistingCustomerArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryExistingCustomersArgs = {
  filters?: InputMaybe<IExistingCustomerFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryExistingCustomersPaginationArgs = {
  filters?: InputMaybe<IExistingCustomersFiltersInput>
  pagination: IPaginationInput
  sort?: InputMaybe<Scalars['String']['input']>
}

export type IQueryExistingCustomers_ConnectionArgs = {
  filters?: InputMaybe<IExistingCustomerFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryExpertArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryExpertsArgs = {
  filters?: InputMaybe<IExpertFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryExperts_ConnectionArgs = {
  filters?: InputMaybe<IExpertFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryFeatureArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryFeaturedContentsArgs = {
  contentType: IEnum_Content_Contenttype
  limit: Scalars['Int']['input']
  start: Scalars['Int']['input']
  subTopicSlug: Scalars['String']['input']
}

export type IQueryFeaturesArgs = {
  filters?: InputMaybe<IFeatureFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryFeatures_ConnectionArgs = {
  filters?: InputMaybe<IFeatureFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryFindAnnouncementBySolutionIdArgs = {
  query?: InputMaybe<Scalars['JSON']['input']>
}

export type IQueryFreeAskAiLogArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryFreeAskAiLogsArgs = {
  filters?: InputMaybe<IFreeAskAiLogFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryFreeAskAiLogs_ConnectionArgs = {
  filters?: InputMaybe<IFreeAskAiLogFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryFreeContentLogArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryFreeContentLogsArgs = {
  filters?: InputMaybe<IFreeContentLogFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryFreeContentLogs_ConnectionArgs = {
  filters?: InputMaybe<IFreeContentLogFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryFreeSearchLogArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryFreeSearchLogsArgs = {
  filters?: InputMaybe<IFreeSearchLogFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryFreeSearchLogs_ConnectionArgs = {
  filters?: InputMaybe<IFreeSearchLogFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryGetCustomTagBySlugArgs = {
  slug: Scalars['String']['input']
}

export type IQueryGetIntegrationsPaginationArgs = {
  filters?: InputMaybe<IIntegrationsFiltersInput>
  pagination: IPaginationInput
  sort?: InputMaybe<Scalars['String']['input']>
}

export type IQueryGetMyCustomTagsArgs = {
  isSharedPortfolio?: InputMaybe<Scalars['Boolean']['input']>
  portfolioId?: InputMaybe<Scalars['String']['input']>
}

export type IQueryGetOfficesPaginationArgs = {
  filters?: InputMaybe<IOfficesFiltersInput>
  pagination: IPaginationInput
  sort?: InputMaybe<Scalars['String']['input']>
}

export type IQueryGetPracticeAreasPaginationArgs = {
  filters?: InputMaybe<IPracticeAreasFiltersInput>
  pagination: IPaginationInput
  sort?: InputMaybe<Scalars['String']['input']>
}

export type IQueryHqArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryHqsArgs = {
  filters?: InputMaybe<IHqFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryHqsPaginationArgs = {
  filters?: InputMaybe<IHqsFiltersInput>
  pagination: IPaginationInput
  sort?: InputMaybe<Scalars['String']['input']>
}

export type IQueryHqs_ConnectionArgs = {
  filters?: InputMaybe<IHqFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryI18NLocaleArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryI18NLocalesArgs = {
  filters?: InputMaybe<II18NLocaleFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryI18NLocales_ConnectionArgs = {
  filters?: InputMaybe<II18NLocaleFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryIltaDataArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryIltaSponsorshipArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryIltaSponsorshipsArgs = {
  filters?: InputMaybe<IIltaSponsorshipFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryIltaSponsorships_ConnectionArgs = {
  filters?: InputMaybe<IIltaSponsorshipFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryInstallationArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryInstallationsArgs = {
  filters?: InputMaybe<IInstallationFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryInstallations_ConnectionArgs = {
  filters?: InputMaybe<IInstallationFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryIntegrationArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryIntegrationsArgs = {
  filters?: InputMaybe<IIntegrationFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryIntegrations_ConnectionArgs = {
  filters?: InputMaybe<IIntegrationFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryInvitedUsersArgs = {
  query?: InputMaybe<Scalars['JSON']['input']>
}

export type IQueryIsFollowArgs = {
  id?: InputMaybe<Scalars['String']['input']>
}

export type IQueryListingRequestArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryListingRequestsArgs = {
  filters?: InputMaybe<IListingRequestFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryListingRequests_ConnectionArgs = {
  filters?: InputMaybe<IListingRequestFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryMySharedContentsArgs = {
  filters: IMySharedContentsFilters
  limit: Scalars['Int']['input']
  offset: Scalars['Int']['input']
}

export type IQueryNewsletterCategoriesArgs = {
  filters?: InputMaybe<INewsletterCategoryFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryNewsletterCategories_ConnectionArgs = {
  filters?: InputMaybe<INewsletterCategoryFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryNewsletterCategoryArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryNewsletterSubscriptionArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryNewsletterSubscriptionsArgs = {
  filters?: InputMaybe<INewsletterSubscriptionFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryNewsletterSubscriptions_ConnectionArgs = {
  filters?: InputMaybe<INewsletterSubscriptionFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryNotificationSentArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryNotificationSentsArgs = {
  filters?: InputMaybe<INotificationSentFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryNotificationSents_ConnectionArgs = {
  filters?: InputMaybe<INotificationSentFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryOfficeArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryOfficesArgs = {
  filters?: InputMaybe<IOfficeFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryOffices_ConnectionArgs = {
  filters?: InputMaybe<IOfficeFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPhaseArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPhasesArgs = {
  filters?: InputMaybe<IPhaseFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPhases_ConnectionArgs = {
  filters?: InputMaybe<IPhaseFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPlatformLanguageArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPlatformLanguagesArgs = {
  filters?: InputMaybe<IPlatformLanguageFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPlatformLanguagesPaginationArgs = {
  filters?: InputMaybe<IPlatformLanguagesFiltersInput>
  pagination: IPaginationInput
  sort?: InputMaybe<Scalars['String']['input']>
}

export type IQueryPlatformLanguages_ConnectionArgs = {
  filters?: InputMaybe<IPlatformLanguageFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPopularTopicsArgs = {
  vendorLimit: Scalars['Int']['input']
}

export type IQueryPracticeAreaArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPracticeAreasArgs = {
  filters?: InputMaybe<IPracticeAreaFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPracticeAreas_ConnectionArgs = {
  filters?: InputMaybe<IPracticeAreaFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPremiumAudienceArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPremiumAudiencesArgs = {
  filters?: InputMaybe<IPremiumAudienceFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPremiumAudiences_ConnectionArgs = {
  filters?: InputMaybe<IPremiumAudienceFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPremiumOrganizationArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPremiumOrganizationsArgs = {
  filters?: InputMaybe<IPremiumOrganizationFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPremiumOrganizations_ConnectionArgs = {
  filters?: InputMaybe<IPremiumOrganizationFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPremiumPricingPlanArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPremiumPricingPlansArgs = {
  filters?: InputMaybe<IPremiumPricingPlanFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPremiumPricingPlans_ConnectionArgs = {
  filters?: InputMaybe<IPremiumPricingPlanFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPreviewContentBySlugArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>
  secret: Scalars['String']['input']
  slug: Scalars['String']['input']
  status?: InputMaybe<Scalars['String']['input']>
}

export type IQueryPrivacyPolicyArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPublisherActionArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPublisherActionsArgs = {
  filters?: InputMaybe<IPublisherActionFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryPublisherActions_ConnectionArgs = {
  filters?: InputMaybe<IPublisherActionFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryRecordLockingOpenEntitiesArgs = {
  filters?: InputMaybe<IRecordLockingOpenEntityFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryRecordLockingOpenEntities_ConnectionArgs = {
  filters?: InputMaybe<IRecordLockingOpenEntityFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryRecordLockingOpenEntityArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryRecurrenceArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryRecurrencesArgs = {
  filters?: InputMaybe<IRecurrenceFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryRecurrences_ConnectionArgs = {
  filters?: InputMaybe<IRecurrenceFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryRegionsServedArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryRegionsServedsArgs = {
  filters?: InputMaybe<IRegionsServedFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryRegionsServeds_ConnectionArgs = {
  filters?: InputMaybe<IRegionsServedFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryRelatedArticlesOfContentArgs = {
  slug: Scalars['String']['input']
}

export type IQueryRelatedContentBySolutionArgs = {
  query?: InputMaybe<Scalars['JSON']['input']>
}

export type IQueryRelatedSubtopicTopicsArgs = {
  query?: InputMaybe<Scalars['JSON']['input']>
}

export type IQueryResourceInvitationArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryResourceInvitationsArgs = {
  filters?: InputMaybe<IResourceInvitationFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryResourceInvitations_ConnectionArgs = {
  filters?: InputMaybe<IResourceInvitationFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryReviewArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<IReviewWorkflowsWorkflowStageFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<IReviewWorkflowsWorkflowStageFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryReviewWorkflowsWorkflowsArgs = {
  filters?: InputMaybe<IReviewWorkflowsWorkflowFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryReviewWorkflowsWorkflows_ConnectionArgs = {
  filters?: InputMaybe<IReviewWorkflowsWorkflowFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryReviewsArgs = {
  filters?: InputMaybe<IReviewFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryReviews_ConnectionArgs = {
  filters?: InputMaybe<IReviewFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySearchCustomTagsArgs = {
  isSharedPortfolio?: InputMaybe<Scalars['Boolean']['input']>
  keyword?: InputMaybe<Scalars['String']['input']>
  portfolioId?: InputMaybe<Scalars['String']['input']>
}

export type IQuerySearchSharedPortfolioOrganizationUsersArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type IQuerySearchSolutionsArgs = {
  query?: InputMaybe<Scalars['JSON']['input']>
}

export type IQuerySearchSubtopicsArgs = {
  query?: InputMaybe<Scalars['JSON']['input']>
}

export type IQuerySearchUnfollowedRelatedSubtopicsArgs = {
  query?: InputMaybe<Scalars['JSON']['input']>
}

export type IQuerySearchVendorSolutionsArgs = {
  query?: InputMaybe<Scalars['JSON']['input']>
}

export type IQuerySecuritiesArgs = {
  filters?: InputMaybe<ISecurityFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySecurities_ConnectionArgs = {
  filters?: InputMaybe<ISecurityFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySecurityArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryShareableContentsArgs = {
  filters: IMySharedContentsFilters
  limit: Scalars['Int']['input']
  offset: Scalars['Int']['input']
}

export type IQuerySharedPortfolioArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySharedPortfolioMembershipArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySharedPortfolioMembershipsArgs = {
  filters?: InputMaybe<ISharedPortfolioMembershipFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySharedPortfolioMemberships_ConnectionArgs = {
  filters?: InputMaybe<ISharedPortfolioMembershipFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySharedPortfolioSolutionArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySharedPortfolioSolutionsArgs = {
  filters?: InputMaybe<ISharedPortfolioSolutionFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySharedPortfolioSolutions_ConnectionArgs = {
  filters?: InputMaybe<ISharedPortfolioSolutionFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySharedPortfolioTopicsArgs = {
  sharedPortfolioId?: InputMaybe<Scalars['ID']['input']>
  sharedPortfolioSlug?: InputMaybe<Scalars['String']['input']>
}

export type IQuerySharedPortfoliosArgs = {
  filters?: InputMaybe<ISharedPortfolioFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySharedPortfoliosForMyOrganizationArgs = {
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  sharedPortfolioId?: InputMaybe<Scalars['ID']['input']>
  sharedPortfolioSlug?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type IQuerySharedPortfolios_ConnectionArgs = {
  filters?: InputMaybe<ISharedPortfolioFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySimilarSolutionsArgs = {
  from?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
}

export type IQuerySlugUpdateArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySlugUpdatesArgs = {
  filters?: InputMaybe<ISlugUpdateFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySlugUpdates_ConnectionArgs = {
  filters?: InputMaybe<ISlugUpdateFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySolutionArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySolutionRequestArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySolutionRequestsArgs = {
  filters?: InputMaybe<ISolutionRequestFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySolutionRequests_ConnectionArgs = {
  filters?: InputMaybe<ISolutionRequestFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySolutionsArgs = {
  filters?: InputMaybe<ISolutionFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySolutionsCountArgs = {
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type IQuerySolutions_ConnectionArgs = {
  filters?: InputMaybe<ISolutionFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySubTopicArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySubTopicsArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySubTopics_ConnectionArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySubjectMatterArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySubjectMattersArgs = {
  filters?: InputMaybe<ISubjectMatterFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQuerySubjectMatters_ConnectionArgs = {
  filters?: InputMaybe<ISubjectMatterFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryTermsConditionsArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryTestimonialsArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryTestimonialsPluralArgs = {
  filters?: InputMaybe<ITestimonialsFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryTestimonialsPlural_ConnectionArgs = {
  filters?: InputMaybe<ITestimonialsFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryThemeArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryThemesArgs = {
  filters?: InputMaybe<IThemeFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryThemes_ConnectionArgs = {
  filters?: InputMaybe<IThemeFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryTopicArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryTopicsArgs = {
  filters?: InputMaybe<ITopicFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryTopics_ConnectionArgs = {
  filters?: InputMaybe<ITopicFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryTrendingContentsArgs = {
  audience?: InputMaybe<Scalars['String']['input']>
}

export type IQueryTypeOfUserArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryTypeOfUsersArgs = {
  filters?: InputMaybe<ITypeOfUserFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryTypeOfUsers_ConnectionArgs = {
  filters?: InputMaybe<ITypeOfUserFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryUploadFileArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryUploadFilesArgs = {
  filters?: InputMaybe<IUploadFileFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryUploadFiles_ConnectionArgs = {
  filters?: InputMaybe<IUploadFileFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryUserArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryUserInfoArgs = {
  token?: InputMaybe<Scalars['String']['input']>
}

export type IQueryUserSystemFeatureArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryUserSystemFeaturesArgs = {
  filters?: InputMaybe<IUserSystemFeatureFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryUserSystemFeatures_ConnectionArgs = {
  filters?: InputMaybe<IUserSystemFeatureFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryUsersArgs = {
  filters?: InputMaybe<IUserFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryUsersPermissionsRoleArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<IUsersPermissionsRoleFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryUsersPermissionsRoles_ConnectionArgs = {
  filters?: InputMaybe<IUsersPermissionsRoleFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryUsers_ConnectionArgs = {
  filters?: InputMaybe<IUserFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryVendorArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryVendorTopicArgs = {
  documentId: Scalars['ID']['input']
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  publicationFilter?: InputMaybe<IPublicationFilter>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryVendorTopicsArgs = {
  filters?: InputMaybe<IVendorTopicFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryVendorTopics_ConnectionArgs = {
  filters?: InputMaybe<IVendorTopicFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryVendorsArgs = {
  filters?: InputMaybe<IVendorFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IQueryVendors_ConnectionArgs = {
  filters?: InputMaybe<IVendorFiltersInput>
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<IPaginationArg>
  publicationFilter?: InputMaybe<IPublicationFilter>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<IPublicationStatus>
}

export type IRatingResponse = {
  __typename?: 'RatingResponse'
  message?: Maybe<Scalars['String']['output']>
  success?: Maybe<Scalars['Boolean']['output']>
}

export type IRecordLockingOpenEntity = {
  __typename?: 'RecordLockingOpenEntity'
  connectionId?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  entityDocumentId?: Maybe<Scalars['String']['output']>
  entityId?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  user?: Maybe<Scalars['String']['output']>
}

export type IRecordLockingOpenEntityEntityResponseCollection = {
  __typename?: 'RecordLockingOpenEntityEntityResponseCollection'
  nodes: Array<IRecordLockingOpenEntity>
  pageInfo: IPagination
}

export type IRecordLockingOpenEntityFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IRecordLockingOpenEntityFiltersInput>>>
  connectionId?: InputMaybe<IStringFilterInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  entityDocumentId?: InputMaybe<IStringFilterInput>
  entityId?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IRecordLockingOpenEntityFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IRecordLockingOpenEntityFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
  user?: InputMaybe<IStringFilterInput>
}

export type IRecordLockingOpenEntityInput = {
  connectionId?: InputMaybe<Scalars['String']['input']>
  entityDocumentId?: InputMaybe<Scalars['String']['input']>
  entityId?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  user?: InputMaybe<Scalars['String']['input']>
}

export type IRecurrence = {
  __typename?: 'Recurrence'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IRecurrenceEntityResponseCollection = {
  __typename?: 'RecurrenceEntityResponseCollection'
  nodes: Array<IRecurrence>
  pageInfo: IPagination
}

export type IRecurrenceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IRecurrenceFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IRecurrenceFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IRecurrenceFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IRecurrenceInput = {
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IRegionsServed = {
  __typename?: 'RegionsServed'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IRegionsServedEntityResponseCollection = {
  __typename?: 'RegionsServedEntityResponseCollection'
  nodes: Array<IRegionsServed>
  pageInfo: IPagination
}

export type IRegionsServedFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IRegionsServedFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IRegionsServedFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IRegionsServedFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IRegionsServedInput = {
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IRegionsServedRelationResponseCollection = {
  __typename?: 'RegionsServedRelationResponseCollection'
  nodes: Array<IRegionsServed>
}

export type IRegisterPremiumOrganizationInput = {
  billingAddress: IComponentBillingAddressBillingAddressInput
  emailDomain: Scalars['String']['input']
  gReCaptchaToken?: InputMaybe<Scalars['String']['input']>
  leadSource?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  pricingPlan: Scalars['ID']['input']
  registrationContact: Array<InputMaybe<IComponentRegistrationContactRegistrationContactInput>>
  shouldSendResponse?: InputMaybe<Scalars['Boolean']['input']>
}

export type IRegisterVendorOrganizationInput = {
  companySize?: InputMaybe<Scalars['String']['input']>
  gReCaptchaToken?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  registrationContact: Array<InputMaybe<IComponentRegistrationContactRegistrationContactInput>>
  shouldSendResponse?: InputMaybe<Scalars['Boolean']['input']>
}

export type IRelatedContentBySolution = {
  __typename?: 'RelatedContentBySolution'
  contents?: Maybe<Array<Maybe<IContentItem>>>
  total?: Maybe<Scalars['Int']['output']>
}

export type IRelatedContentBySolutionhReturnType = {
  __typename?: 'RelatedContentBySolutionhReturnType'
  data?: Maybe<IRelatedContentBySolution>
  success?: Maybe<Scalars['Boolean']['output']>
}

export type IResourceInvitation = {
  __typename?: 'ResourceInvitation'
  businessEmail: Scalars['String']['output']
  companyLawFirmName: Scalars['String']['output']
  contents: Array<Maybe<IContent>>
  contents_connection?: Maybe<IContentRelationResponseCollection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  shared_by?: Maybe<IUser>
  shared_to?: Maybe<IUser>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IResourceInvitationContentsArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IResourceInvitationContents_ConnectionArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IResourceInvitationEntity = {
  __typename?: 'ResourceInvitationEntity'
  attributes?: Maybe<IResourceInvitation>
  businessEmail: Scalars['String']['output']
  companyLawFirmName: Scalars['String']['output']
  contents: Array<Maybe<ISharedResourceEntity>>
  dateInvited: Scalars['Date']['output']
  documentId: Scalars['String']['output']
  id?: Maybe<Scalars['ID']['output']>
  name: Scalars['String']['output']
  status: Scalars['Boolean']['output']
}

export type IResourceInvitationEntityResponseCollection = {
  __typename?: 'ResourceInvitationEntityResponseCollection'
  nodes: Array<IResourceInvitation>
  pageInfo: IPagination
}

export type IResourceInvitationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IResourceInvitationFiltersInput>>>
  businessEmail?: InputMaybe<IStringFilterInput>
  companyLawFirmName?: InputMaybe<IStringFilterInput>
  contents?: InputMaybe<IContentFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IResourceInvitationFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IResourceInvitationFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  shared_by?: InputMaybe<IUserFiltersInput>
  shared_to?: InputMaybe<IUserFiltersInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IResourceInvitationInput = {
  businessEmail?: InputMaybe<Scalars['String']['input']>
  companyLawFirmName?: InputMaybe<Scalars['String']['input']>
  content_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  contents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  invitations?: InputMaybe<Array<IInvitationInput>>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  shared_by?: InputMaybe<Scalars['ID']['input']>
  shared_to?: InputMaybe<Scalars['ID']['input']>
}

export type IResourceInvitationRelationResponseCollection = {
  __typename?: 'ResourceInvitationRelationResponseCollection'
  nodes: Array<IResourceInvitation>
}

export type IReview = {
  __typename?: 'Review'
  anonymous?: Maybe<Scalars['Boolean']['output']>
  content?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  ip?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  rating?: Maybe<Scalars['Float']['output']>
  solution?: Maybe<ISolution>
  solutionDispName?: Maybe<Scalars['String']['output']>
  status?: Maybe<IEnum_Review_Status>
  submittedBy?: Maybe<IUser>
  submitterSubTitle?: Maybe<Scalars['String']['output']>
  submitterTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IReviewEntityResponseCollection = {
  __typename?: 'ReviewEntityResponseCollection'
  nodes: Array<IReview>
  pageInfo: IPagination
}

export type IReviewFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IReviewFiltersInput>>>
  anonymous?: InputMaybe<IBooleanFilterInput>
  content?: InputMaybe<IStringFilterInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  ip?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IReviewFiltersInput>
  notes?: InputMaybe<IStringFilterInput>
  or?: InputMaybe<Array<InputMaybe<IReviewFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  rating?: InputMaybe<IFloatFilterInput>
  solution?: InputMaybe<ISolutionFiltersInput>
  solutionDispName?: InputMaybe<IStringFilterInput>
  status?: InputMaybe<IStringFilterInput>
  submittedBy?: InputMaybe<IUserFiltersInput>
  submitterSubTitle?: InputMaybe<IStringFilterInput>
  submitterTitle?: InputMaybe<IStringFilterInput>
  title?: InputMaybe<IStringFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IReviewInput = {
  anonymous?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Scalars['String']['input']>
  gReCaptchaToken?: InputMaybe<Scalars['String']['input']>
  ip?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  rating?: InputMaybe<Scalars['Float']['input']>
  solution?: InputMaybe<Scalars['ID']['input']>
  solutionDispName?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<IEnum_Review_Status>
  submittedBy?: InputMaybe<Scalars['ID']['input']>
  submitterSubTitle?: InputMaybe<Scalars['String']['input']>
  submitterTitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type IReviewRelationResponseCollection = {
  __typename?: 'ReviewRelationResponseCollection'
  nodes: Array<IReview>
}

export type IReviewWorkflowsWorkflow = {
  __typename?: 'ReviewWorkflowsWorkflow'
  contentTypes: Scalars['JSON']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  stageRequiredToPublish?: Maybe<IReviewWorkflowsWorkflowStage>
  stages: Array<Maybe<IReviewWorkflowsWorkflowStage>>
  stages_connection?: Maybe<IReviewWorkflowsWorkflowStageRelationResponseCollection>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<IReviewWorkflowsWorkflowStageFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<IReviewWorkflowsWorkflowStageFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IReviewWorkflowsWorkflowEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowEntityResponseCollection'
  nodes: Array<IReviewWorkflowsWorkflow>
  pageInfo: IPagination
}

export type IReviewWorkflowsWorkflowFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IReviewWorkflowsWorkflowFiltersInput>>>
  contentTypes?: InputMaybe<IJsonFilterInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IReviewWorkflowsWorkflowFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IReviewWorkflowsWorkflowFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  stageRequiredToPublish?: InputMaybe<IReviewWorkflowsWorkflowStageFiltersInput>
  stages?: InputMaybe<IReviewWorkflowsWorkflowStageFiltersInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IReviewWorkflowsWorkflowInput = {
  contentTypes?: InputMaybe<Scalars['JSON']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  stageRequiredToPublish?: InputMaybe<Scalars['ID']['input']>
  stages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type IReviewWorkflowsWorkflowStage = {
  __typename?: 'ReviewWorkflowsWorkflowStage'
  color?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  workflow?: Maybe<IReviewWorkflowsWorkflow>
}

export type IReviewWorkflowsWorkflowStageEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageEntityResponseCollection'
  nodes: Array<IReviewWorkflowsWorkflowStage>
  pageInfo: IPagination
}

export type IReviewWorkflowsWorkflowStageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IReviewWorkflowsWorkflowStageFiltersInput>>>
  color?: InputMaybe<IStringFilterInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IReviewWorkflowsWorkflowStageFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IReviewWorkflowsWorkflowStageFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
  workflow?: InputMaybe<IReviewWorkflowsWorkflowFiltersInput>
}

export type IReviewWorkflowsWorkflowStageInput = {
  color?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  workflow?: InputMaybe<Scalars['ID']['input']>
}

export type IReviewWorkflowsWorkflowStageRelationResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageRelationResponseCollection'
  nodes: Array<IReviewWorkflowsWorkflowStage>
}

export type ISearchAnnouncementsResult = {
  __typename?: 'SearchAnnouncementsResult'
  announcement?: Maybe<IAnnouncementItem>
}

export type ISearchSolutionsResult = {
  __typename?: 'SearchSolutionsResult'
  solutions?: Maybe<Array<Maybe<ISolutionItem>>>
  total?: Maybe<Scalars['Int']['output']>
}

export type ISearchSolutionsResultType = {
  __typename?: 'SearchSolutionsResultType'
  isFreeSearch?: Maybe<Scalars['Boolean']['output']>
  isFreeSearchLeft?: Maybe<Scalars['Int']['output']>
  solutions?: Maybe<Array<Maybe<ISolutionItem>>>
  total?: Maybe<Scalars['Int']['output']>
}

export type ISearchSubtopicsResultType = {
  __typename?: 'SearchSubtopicsResultType'
  subtopics?: Maybe<Array<Maybe<ISubtopicItem>>>
  total?: Maybe<Scalars['Int']['output']>
}

export type ISecurity = {
  __typename?: 'Security'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  id?: Maybe<Scalars['Int']['output']>
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ISecurityEntityResponseCollection = {
  __typename?: 'SecurityEntityResponseCollection'
  nodes: Array<ISecurity>
  pageInfo: IPagination
}

export type ISecurityFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ISecurityFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<ISecurityFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ISecurityFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type ISecurityInput = {
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ISecurityRelationResponseCollection = {
  __typename?: 'SecurityRelationResponseCollection'
  nodes: Array<ISecurity>
}

export type IShareableContentsReturnType = {
  __typename?: 'ShareableContentsReturnType'
  contents?: Maybe<Array<IContentEntity>>
  total?: Maybe<Scalars['Int']['output']>
}

export type IShareableTopicInfo = {
  __typename?: 'ShareableTopicInfo'
  id: Scalars['Int']['output']
  isPremium?: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
  subTopics?: Maybe<Array<ISubTopicInfo>>
}

export type IShareableTopicsReturnType = {
  __typename?: 'ShareableTopicsReturnType'
  topics: Array<IShareableTopicInfo>
}

export type ISharedPortfolio = {
  __typename?: 'SharedPortfolio'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdByUser?: Maybe<IUser>
  documentId: Scalars['ID']['output']
  isSharedPortfolio?: Maybe<Scalars['Boolean']['output']>
  lastModifiedByUser?: Maybe<IUser>
  name: Scalars['String']['output']
  premium_organizations: Array<Maybe<IPremiumOrganization>>
  premium_organizations_connection?: Maybe<IPremiumOrganizationRelationResponseCollection>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  shared_portfolio_memberships: Array<Maybe<ISharedPortfolioMembership>>
  shared_portfolio_memberships_connection?: Maybe<ISharedPortfolioMembershipRelationResponseCollection>
  shared_portfolio_solutions: Array<Maybe<ISharedPortfolioSolution>>
  shared_portfolio_solutions_connection?: Maybe<ISharedPortfolioSolutionRelationResponseCollection>
  slug?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ISharedPortfolioPremium_OrganizationsArgs = {
  filters?: InputMaybe<IPremiumOrganizationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISharedPortfolioPremium_Organizations_ConnectionArgs = {
  filters?: InputMaybe<IPremiumOrganizationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISharedPortfolioShared_Portfolio_MembershipsArgs = {
  filters?: InputMaybe<ISharedPortfolioMembershipFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISharedPortfolioShared_Portfolio_Memberships_ConnectionArgs = {
  filters?: InputMaybe<ISharedPortfolioMembershipFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISharedPortfolioShared_Portfolio_SolutionsArgs = {
  filters?: InputMaybe<ISharedPortfolioSolutionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISharedPortfolioShared_Portfolio_Solutions_ConnectionArgs = {
  filters?: InputMaybe<ISharedPortfolioSolutionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISharedPortfolioEntity = {
  __typename?: 'SharedPortfolioEntity'
  attributes?: Maybe<ISharedPortfolio>
  id?: Maybe<Scalars['ID']['output']>
}

export type ISharedPortfolioEntityResponseCollection = {
  __typename?: 'SharedPortfolioEntityResponseCollection'
  nodes: Array<ISharedPortfolio>
  pageInfo: IPagination
}

export type ISharedPortfolioFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ISharedPortfolioFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  createdByUser?: InputMaybe<IUserFiltersInput>
  documentId?: InputMaybe<IIdFilterInput>
  isSharedPortfolio?: InputMaybe<IBooleanFilterInput>
  lastModifiedByUser?: InputMaybe<IUserFiltersInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<ISharedPortfolioFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ISharedPortfolioFiltersInput>>>
  premium_organizations?: InputMaybe<IPremiumOrganizationFiltersInput>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  shared_portfolio_memberships?: InputMaybe<ISharedPortfolioMembershipFiltersInput>
  shared_portfolio_solutions?: InputMaybe<ISharedPortfolioSolutionFiltersInput>
  slug?: InputMaybe<IStringFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type ISharedPortfolioInput = {
  createdByUser?: InputMaybe<Scalars['ID']['input']>
  isSharedPortfolio?: InputMaybe<Scalars['Boolean']['input']>
  lastModifiedByUser?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  premium_organizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  shared_portfolio_memberships?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  shared_portfolio_solutions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  slug?: InputMaybe<Scalars['String']['input']>
}

export type ISharedPortfolioMemberInput = {
  email: Scalars['String']['input']
  name?: InputMaybe<Scalars['String']['input']>
  role?: InputMaybe<Scalars['String']['input']>
}

export type ISharedPortfolioMembership = {
  __typename?: 'SharedPortfolioMembership'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  isActive?: Maybe<Scalars['Boolean']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  role: IEnum_Sharedportfoliomembership_Role
  sharedPortfolio?: Maybe<ISharedPortfolio>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  user?: Maybe<IUser>
}

export type ISharedPortfolioMembershipEntity = {
  __typename?: 'SharedPortfolioMembershipEntity'
  attributes?: Maybe<ISharedPortfolioMembership>
  id?: Maybe<Scalars['ID']['output']>
}

export type ISharedPortfolioMembershipEntityResponseCollection = {
  __typename?: 'SharedPortfolioMembershipEntityResponseCollection'
  nodes: Array<ISharedPortfolioMembership>
  pageInfo: IPagination
}

export type ISharedPortfolioMembershipFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ISharedPortfolioMembershipFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  isActive?: InputMaybe<IBooleanFilterInput>
  not?: InputMaybe<ISharedPortfolioMembershipFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ISharedPortfolioMembershipFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  role?: InputMaybe<IStringFilterInput>
  sharedPortfolio?: InputMaybe<ISharedPortfolioFiltersInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
  user?: InputMaybe<IUserFiltersInput>
}

export type ISharedPortfolioMembershipInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  role?: InputMaybe<IEnum_Sharedportfoliomembership_Role>
  sharedPortfolio?: InputMaybe<Scalars['ID']['input']>
  user?: InputMaybe<Scalars['ID']['input']>
}

export type ISharedPortfolioMembershipRelationResponseCollection = {
  __typename?: 'SharedPortfolioMembershipRelationResponseCollection'
  nodes: Array<ISharedPortfolioMembership>
}

export type ISharedPortfolioOrganizationUser = {
  __typename?: 'SharedPortfolioOrganizationUser'
  email: Scalars['String']['output']
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
}

export type ISharedPortfolioOrganizationUsersResult = {
  __typename?: 'SharedPortfolioOrganizationUsersResult'
  users: Array<ISharedPortfolioOrganizationUser>
}

export type ISharedPortfolioRelationResponseCollection = {
  __typename?: 'SharedPortfolioRelationResponseCollection'
  nodes: Array<ISharedPortfolio>
}

export type ISharedPortfolioSolution = {
  __typename?: 'SharedPortfolioSolution'
  category?: Maybe<IEnum_Sharedportfoliosolution_Category>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  followingSolutionNote?: Maybe<Scalars['String']['output']>
  lastModifiedByUser?: Maybe<IUser>
  noteCreatedAt?: Maybe<Scalars['DateTime']['output']>
  noteCreatedByUser?: Maybe<IUser>
  noteLastEditedAt?: Maybe<Scalars['DateTime']['output']>
  noteLastEditedByUser?: Maybe<IUser>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  sharedPortfolio?: Maybe<ISharedPortfolio>
  solution?: Maybe<ISolution>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ISharedPortfolioSolutionEntity = {
  __typename?: 'SharedPortfolioSolutionEntity'
  attributes?: Maybe<ISharedPortfolioSolution>
  id?: Maybe<Scalars['ID']['output']>
}

export type ISharedPortfolioSolutionEntityResponseCollection = {
  __typename?: 'SharedPortfolioSolutionEntityResponseCollection'
  nodes: Array<ISharedPortfolioSolution>
  pageInfo: IPagination
}

export type ISharedPortfolioSolutionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ISharedPortfolioSolutionFiltersInput>>>
  category?: InputMaybe<IStringFilterInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  followingSolutionNote?: InputMaybe<IStringFilterInput>
  lastModifiedByUser?: InputMaybe<IUserFiltersInput>
  not?: InputMaybe<ISharedPortfolioSolutionFiltersInput>
  noteCreatedAt?: InputMaybe<IDateTimeFilterInput>
  noteCreatedByUser?: InputMaybe<IUserFiltersInput>
  noteLastEditedAt?: InputMaybe<IDateTimeFilterInput>
  noteLastEditedByUser?: InputMaybe<IUserFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ISharedPortfolioSolutionFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  sharedPortfolio?: InputMaybe<ISharedPortfolioFiltersInput>
  solution?: InputMaybe<ISolutionFiltersInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type ISharedPortfolioSolutionRelationResponseCollection = {
  __typename?: 'SharedPortfolioSolutionRelationResponseCollection'
  nodes: Array<ISharedPortfolioSolution>
}

export type ISharedPortfolioSummary = {
  __typename?: 'SharedPortfolioSummary'
  documentId?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
}

export type ISharedPortfoliosForMyOrganizationPayload = {
  __typename?: 'SharedPortfoliosForMyOrganizationPayload'
  portfolios: Array<ISharedPortfolioEntity>
  /** Always present for org-wide list; null when querying a single sharedPortfolioId. */
  privateFollowingPortfolio?: Maybe<IPrivateFollowingPortfolioStub>
  sharedPortfoliosPagination: ISharedPortfoliosPagination
}

export type ISharedPortfoliosPagination = {
  __typename?: 'SharedPortfoliosPagination'
  page: Scalars['Int']['output']
  pageCount: Scalars['Int']['output']
  pageSize: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

export type ISharedResourceEntity = {
  __typename?: 'SharedResourceEntity'
  documentId?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  sharedResources: IContentVisitDownloadCountResult
  slug?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type ISimilarSolutionItem = {
  __typename?: 'SimilarSolutionItem'
  displayName?: Maybe<Scalars['String']['output']>
  logo?: Maybe<Scalars['String']['output']>
  rating?: Maybe<Scalars['Float']['output']>
  reviewCnt?: Maybe<Scalars['Int']['output']>
  slug?: Maybe<Scalars['String']['output']>
  type?: Maybe<IEnum_Solution_Item_Type>
}

export type ISimilarSolutionsResult = {
  __typename?: 'SimilarSolutionsResult'
  solutions: Array<ISimilarSolutionItem>
}

export type ISlugUpdate = {
  __typename?: 'SlugUpdate'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  newSlug?: Maybe<Scalars['String']['output']>
  oldSlug?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  type?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ISlugUpdateEntityResponseCollection = {
  __typename?: 'SlugUpdateEntityResponseCollection'
  nodes: Array<ISlugUpdate>
  pageInfo: IPagination
}

export type ISlugUpdateFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ISlugUpdateFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  newSlug?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<ISlugUpdateFiltersInput>
  oldSlug?: InputMaybe<IStringFilterInput>
  or?: InputMaybe<Array<InputMaybe<ISlugUpdateFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  type?: InputMaybe<IStringFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type ISlugUpdateInput = {
  locale?: InputMaybe<Scalars['String']['input']>
  newSlug?: InputMaybe<Scalars['String']['input']>
  oldSlug?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type ISmartSearchSources = {
  __typename?: 'SmartSearchSources'
  contentType?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  logo?: Maybe<Scalars['String']['output']>
  sourceUrl?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type ISmartsearch = {
  __typename?: 'Smartsearch'
  id: Scalars['ID']['output']
  identicalId?: Maybe<Scalars['Int']['output']>
  logs: Array<ISmartSearchLog>
  result: Scalars['String']['output']
  sources: Array<ISmartSearchSources>
}

export type ISmartsearchData = {
  __typename?: 'SmartsearchData'
  data?: Maybe<ISmartsearch>
  error?: Maybe<Scalars['String']['output']>
  isFreeASKAI?: Maybe<Scalars['Boolean']['output']>
  isFreeASKAILeft?: Maybe<Scalars['Int']['output']>
  success: Scalars['Boolean']['output']
}

export type ISolution = {
  __typename?: 'Solution'
  alspData?: Maybe<IComponentSolutionAlspData>
  announcement: Array<Maybe<IAnnouncement>>
  announcement_connection?: Maybe<IAnnouncementRelationResponseCollection>
  articles?: Maybe<Array<Maybe<IComponentGlobalArticle>>>
  authoredContents: Array<Maybe<IContent>>
  authoredContents_connection?: Maybe<IContentRelationResponseCollection>
  collections: Array<Maybe<ICollection>>
  collections_connection?: Maybe<ICollectionRelationResponseCollection>
  company?: Maybe<ICompany>
  consolidationData?: Maybe<IComponentSolutionPropsConsolidation>
  consultantData?: Maybe<IComponentSolutionConsultantData>
  contents: Array<Maybe<IContent>>
  contents_connection?: Maybe<IContentRelationResponseCollection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  customTagIds?: Maybe<Scalars['JSON']['output']>
  descOtherExistingCustomer?: Maybe<Scalars['String']['output']>
  descOtherIntegration?: Maybe<Scalars['String']['output']>
  displayName?: Maybe<Scalars['String']['output']>
  documentId: Scalars['ID']['output']
  domain?: Maybe<Scalars['String']['output']>
  existingCustomers: Array<Maybe<IExistingCustomer>>
  existingCustomers_connection?: Maybe<IExistingCustomerRelationResponseCollection>
  features: Array<Maybe<IFeature>>
  features_connection?: Maybe<IFeatureRelationResponseCollection>
  founders?: Maybe<Array<Maybe<IComponentAboutPropsTeamMember>>>
  graveyardData?: Maybe<IComponentSolutionPropsGraveyard>
  hqs: Array<Maybe<IHq>>
  hqs_connection?: Maybe<IHqRelationResponseCollection>
  id: Scalars['ID']['output']
  iltaSponsorships: Array<Maybe<IIltaSponsorship>>
  iltaSponsorships_connection?: Maybe<IIltaSponsorshipRelationResponseCollection>
  isBeta?: Maybe<Scalars['Boolean']['output']>
  isDiverseLeadership?: Maybe<Scalars['Boolean']['output']>
  isEnhanced?: Maybe<Scalars['Boolean']['output']>
  isPremium?: Maybe<Scalars['Boolean']['output']>
  isStartup?: Maybe<Scalars['Boolean']['output']>
  languages: Array<Maybe<IPlatformLanguage>>
  languages_connection?: Maybe<IPlatformLanguageRelationResponseCollection>
  linkedin?: Maybe<Scalars['String']['output']>
  logo?: Maybe<IUploadFile>
  longDescription?: Maybe<Scalars['String']['output']>
  offices: Array<Maybe<IOffice>>
  offices_connection?: Maybe<IOfficeRelationResponseCollection>
  oldSlug?: Maybe<Scalars['String']['output']>
  premiumOrganization?: Maybe<IPremiumOrganization>
  productData?: Maybe<IComponentSolutionProductData>
  productType?: Maybe<IEnum_Solution_Producttype>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  rating?: Maybe<Scalars['Float']['output']>
  regionsServed: Array<Maybe<IRegionsServed>>
  regionsServed_connection?: Maybe<IRegionsServedRelationResponseCollection>
  reviews: Array<Maybe<IReview>>
  reviews_connection?: Maybe<IReviewRelationResponseCollection>
  shared_portfolio_solutions: Array<Maybe<ISharedPortfolioSolution>>
  shared_portfolio_solutions_connection?: Maybe<ISharedPortfolioSolutionRelationResponseCollection>
  shortDescription?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
  subTopics: Array<Maybe<ISubTopic>>
  subTopics_connection?: Maybe<ISubTopicRelationResponseCollection>
  topics: Array<Maybe<ITopic>>
  topics_connection?: Maybe<ITopicRelationResponseCollection>
  twitter?: Maybe<Scalars['String']['output']>
  type: IEnum_Solution_Type
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  vendor?: Maybe<IVendor>
  vendorResources?: Maybe<Array<Maybe<IComponentSolutionPropsVendorResource>>>
  website?: Maybe<Scalars['String']['output']>
  yearFounded?: Maybe<Scalars['Int']['output']>
}

export type ISolutionAnnouncementArgs = {
  filters?: InputMaybe<IAnnouncementFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionAnnouncement_ConnectionArgs = {
  filters?: InputMaybe<IAnnouncementFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionArticlesArgs = {
  filters?: InputMaybe<IComponentGlobalArticleFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionAuthoredContentsArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionAuthoredContents_ConnectionArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionCollectionsArgs = {
  filters?: InputMaybe<ICollectionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionCollections_ConnectionArgs = {
  filters?: InputMaybe<ICollectionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionContentsArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionContents_ConnectionArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionExistingCustomersArgs = {
  filters?: InputMaybe<IExistingCustomerFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionExistingCustomers_ConnectionArgs = {
  filters?: InputMaybe<IExistingCustomerFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionFeaturesArgs = {
  filters?: InputMaybe<IFeatureFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionFeatures_ConnectionArgs = {
  filters?: InputMaybe<IFeatureFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionFoundersArgs = {
  filters?: InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionHqsArgs = {
  filters?: InputMaybe<IHqFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionHqs_ConnectionArgs = {
  filters?: InputMaybe<IHqFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionIltaSponsorshipsArgs = {
  filters?: InputMaybe<IIltaSponsorshipFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionIltaSponsorships_ConnectionArgs = {
  filters?: InputMaybe<IIltaSponsorshipFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionLanguagesArgs = {
  filters?: InputMaybe<IPlatformLanguageFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionLanguages_ConnectionArgs = {
  filters?: InputMaybe<IPlatformLanguageFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionOfficesArgs = {
  filters?: InputMaybe<IOfficeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionOffices_ConnectionArgs = {
  filters?: InputMaybe<IOfficeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRegionsServedArgs = {
  filters?: InputMaybe<IRegionsServedFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRegionsServed_ConnectionArgs = {
  filters?: InputMaybe<IRegionsServedFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionReviewsArgs = {
  filters?: InputMaybe<IReviewFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionReviews_ConnectionArgs = {
  filters?: InputMaybe<IReviewFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionShared_Portfolio_SolutionsArgs = {
  filters?: InputMaybe<ISharedPortfolioSolutionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionShared_Portfolio_Solutions_ConnectionArgs = {
  filters?: InputMaybe<ISharedPortfolioSolutionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionSubTopicsArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionSubTopics_ConnectionArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionTopicsArgs = {
  filters?: InputMaybe<ITopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionTopics_ConnectionArgs = {
  filters?: InputMaybe<ITopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionVendorResourcesArgs = {
  filters?: InputMaybe<IComponentSolutionPropsVendorResourceFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionEntityResponseCollection = {
  __typename?: 'SolutionEntityResponseCollection'
  nodes: Array<ISolution>
  pageInfo: IPagination
}

export type ISolutionFiltersInput = {
  alspData?: InputMaybe<IComponentSolutionAlspDataFiltersInput>
  and?: InputMaybe<Array<InputMaybe<ISolutionFiltersInput>>>
  announcement?: InputMaybe<IAnnouncementFiltersInput>
  articles?: InputMaybe<IComponentGlobalArticleFiltersInput>
  authoredContents?: InputMaybe<IContentFiltersInput>
  collections?: InputMaybe<ICollectionFiltersInput>
  company?: InputMaybe<ICompanyFiltersInput>
  consolidationData?: InputMaybe<IComponentSolutionPropsConsolidationFiltersInput>
  consultantData?: InputMaybe<IComponentSolutionConsultantDataFiltersInput>
  contents?: InputMaybe<IContentFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  customTagIds?: InputMaybe<IJsonFilterInput>
  descOtherExistingCustomer?: InputMaybe<IStringFilterInput>
  descOtherIntegration?: InputMaybe<IStringFilterInput>
  displayName?: InputMaybe<IStringFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  domain?: InputMaybe<IStringFilterInput>
  existingCustomers?: InputMaybe<IExistingCustomerFiltersInput>
  features?: InputMaybe<IFeatureFiltersInput>
  founders?: InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>
  graveyardData?: InputMaybe<IComponentSolutionPropsGraveyardFiltersInput>
  hqs?: InputMaybe<IHqFiltersInput>
  iltaSponsorships?: InputMaybe<IIltaSponsorshipFiltersInput>
  isBeta?: InputMaybe<IBooleanFilterInput>
  isDiverseLeadership?: InputMaybe<IBooleanFilterInput>
  isEnhanced?: InputMaybe<IBooleanFilterInput>
  isPremium?: InputMaybe<IBooleanFilterInput>
  isStartup?: InputMaybe<IBooleanFilterInput>
  languages?: InputMaybe<IPlatformLanguageFiltersInput>
  linkedin?: InputMaybe<IStringFilterInput>
  longDescription?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<ISolutionFiltersInput>
  offices?: InputMaybe<IOfficeFiltersInput>
  oldSlug?: InputMaybe<IStringFilterInput>
  or?: InputMaybe<Array<InputMaybe<ISolutionFiltersInput>>>
  premiumOrganization?: InputMaybe<IPremiumOrganizationFiltersInput>
  productData?: InputMaybe<IComponentSolutionProductDataFiltersInput>
  productType?: InputMaybe<IStringFilterInput>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  rating?: InputMaybe<IFloatFilterInput>
  regionsServed?: InputMaybe<IRegionsServedFiltersInput>
  reviews?: InputMaybe<IReviewFiltersInput>
  shared_portfolio_solutions?: InputMaybe<ISharedPortfolioSolutionFiltersInput>
  shortDescription?: InputMaybe<IStringFilterInput>
  slug?: InputMaybe<IStringFilterInput>
  subTopics?: InputMaybe<ISubTopicFiltersInput>
  topics?: InputMaybe<ITopicFiltersInput>
  twitter?: InputMaybe<IStringFilterInput>
  type?: InputMaybe<IStringFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
  vendor?: InputMaybe<IVendorFiltersInput>
  vendorResources?: InputMaybe<IComponentSolutionPropsVendorResourceFiltersInput>
  website?: InputMaybe<IStringFilterInput>
  yearFounded?: InputMaybe<IIntFilterInput>
}

export type ISolutionId = {
  solution_id: Scalars['String']['input']
}

export type ISolutionInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>
  alspData?: InputMaybe<IComponentSolutionAlspDataInput>
  announcement?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  articles?: InputMaybe<Array<InputMaybe<IComponentGlobalArticleInput>>>
  authoredContents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  collections?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  company?: InputMaybe<Scalars['ID']['input']>
  consolidationData?: InputMaybe<IComponentSolutionPropsConsolidationInput>
  consultantData?: InputMaybe<IComponentSolutionConsultantDataInput>
  contents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  customTagIds?: InputMaybe<Scalars['JSON']['input']>
  descOtherExistingCustomer?: InputMaybe<Scalars['String']['input']>
  descOtherIntegration?: InputMaybe<Scalars['String']['input']>
  displayName?: InputMaybe<Scalars['String']['input']>
  domain?: InputMaybe<Scalars['String']['input']>
  enablePushUpdate?: InputMaybe<Scalars['Boolean']['input']>
  existingCustomers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  featured?: InputMaybe<Scalars['Boolean']['input']>
  featuredOnHome?: InputMaybe<Scalars['Boolean']['input']>
  features?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  firstPublishAt?: InputMaybe<Scalars['DateTime']['input']>
  followedUsers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  founders?: InputMaybe<Array<InputMaybe<IComponentAboutPropsTeamMemberInput>>>
  graveyardData?: InputMaybe<IComponentSolutionPropsGraveyardInput>
  hqs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  iltaSponsorships?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  isBeta?: InputMaybe<Scalars['Boolean']['input']>
  isDiverseLeadership?: InputMaybe<Scalars['Boolean']['input']>
  isEnhanced?: InputMaybe<Scalars['Boolean']['input']>
  isPremium?: InputMaybe<Scalars['Boolean']['input']>
  isStartup?: InputMaybe<Scalars['Boolean']['input']>
  languages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  linkedin?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  logo?: InputMaybe<Scalars['ID']['input']>
  longDescription?: InputMaybe<Scalars['String']['input']>
  offices?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  oldSlug?: InputMaybe<Scalars['String']['input']>
  pendingSubTopicNotificationIds?: InputMaybe<Scalars['JSON']['input']>
  premiumOrganization?: InputMaybe<Scalars['ID']['input']>
  productData?: InputMaybe<IComponentSolutionProductDataInput>
  productType?: InputMaybe<IEnum_Solution_Producttype>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  pushUpdate?: InputMaybe<Scalars['String']['input']>
  rating?: InputMaybe<Scalars['Float']['input']>
  regionsServed?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  reviews?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  shared_portfolio_solutions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  shortDescription?: InputMaybe<Scalars['String']['input']>
  similarSolutions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  slug?: InputMaybe<Scalars['String']['input']>
  solutionLevel?: InputMaybe<IEnum_Solution_Solutionlevel>
  subTopics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  topics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  twitter?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<IEnum_Solution_Type>
  vendor?: InputMaybe<Scalars['ID']['input']>
  vendorResources?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsVendorResourceInput>>>
  website?: InputMaybe<Scalars['String']['input']>
  yearFounded?: InputMaybe<Scalars['Int']['input']>
}

export type ISolutionItem = {
  __typename?: 'SolutionItem'
  consolidation?: Maybe<IComponentSolutionPropsConsolidation>
  customTagsWithName?: Maybe<Array<Maybe<ICustomTagItem>>>
  dataHostingLocations?: Maybe<Array<Maybe<ILocations>>>
  description?: Maybe<Scalars['String']['output']>
  displayName: Scalars['String']['output']
  documentId: Scalars['ID']['output']
  follow: Scalars['Boolean']['output']
  followedSolutionsData?: Maybe<IComponentFollowingSolutionsData>
  graveyard?: Maybe<IComponentSolutionPropsGraveyard>
  id?: Maybe<Scalars['Int']['output']>
  iltaSponsorshipLogo?: Maybe<Scalars['String']['output']>
  isBeta?: Maybe<Scalars['Boolean']['output']>
  isCompany: Scalars['Boolean']['output']
  isDiverseLeadership?: Maybe<Scalars['Boolean']['output']>
  isEnhanced?: Maybe<Scalars['Boolean']['output']>
  isPremium?: Maybe<Scalars['Boolean']['output']>
  isStartup?: Maybe<Scalars['Boolean']['output']>
  logo?: Maybe<Scalars['String']['output']>
  offices?: Maybe<Array<Maybe<IOffice>>>
  rating?: Maybe<Scalars['Float']['output']>
  reviewCnt?: Maybe<Scalars['Int']['output']>
  score?: Maybe<Scalars['Float']['output']>
  security?: Maybe<Array<Maybe<ISecurity>>>
  shared_portfolio_solutions?: Maybe<Array<Maybe<ISolutionSharedPortfolioSolutionData>>>
  slug: Scalars['String']['output']
  subTopics: Array<Scalars['String']['output']>
  type: IEnum_Solution_Item_Type
  valueProposition?: Maybe<Scalars['String']['output']>
  vendor?: Maybe<IVendor>
}

export type ISolutionRelationResponseCollection = {
  __typename?: 'SolutionRelationResponseCollection'
  nodes: Array<ISolution>
}

export type ISolutionRequest = {
  __typename?: 'SolutionRequest'
  alspData?: Maybe<IComponentSolutionRequestAlspData>
  announcement?: Maybe<IAnnouncement>
  articles?: Maybe<Array<Maybe<IComponentGlobalArticle>>>
  consultantData?: Maybe<IComponentSolutionRequestConsultantData>
  converted?: Maybe<Scalars['Boolean']['output']>
  convertedAt?: Maybe<Scalars['DateTime']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  descOtherExistingCustomer?: Maybe<Scalars['String']['output']>
  descOtherIntegration?: Maybe<Scalars['String']['output']>
  documentId: Scalars['ID']['output']
  existingCustomers: Array<Maybe<IExistingCustomer>>
  existingCustomers_connection?: Maybe<IExistingCustomerRelationResponseCollection>
  features: Array<Maybe<IFeature>>
  features_connection?: Maybe<IFeatureRelationResponseCollection>
  founders?: Maybe<Array<Maybe<IComponentAboutPropsTeamMember>>>
  hqs: Array<Maybe<IHq>>
  hqs_connection?: Maybe<IHqRelationResponseCollection>
  id: Scalars['ID']['output']
  isEnhanced?: Maybe<Scalars['Boolean']['output']>
  languages: Array<Maybe<IPlatformLanguage>>
  languages_connection?: Maybe<IPlatformLanguageRelationResponseCollection>
  linkedin?: Maybe<Scalars['String']['output']>
  logo?: Maybe<IUploadFile>
  longDescription?: Maybe<Scalars['String']['output']>
  offices: Array<Maybe<IOffice>>
  offices_connection?: Maybe<IOfficeRelationResponseCollection>
  productData?: Maybe<IComponentSolutionRequestProductData>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  regionsServed: Array<Maybe<IRegionsServed>>
  regionsServed_connection?: Maybe<IRegionsServedRelationResponseCollection>
  shortDescription?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
  subTopics: Array<Maybe<ISubTopic>>
  subTopics_connection?: Maybe<ISubTopicRelationResponseCollection>
  submittedBy?: Maybe<IUser>
  topics: Array<Maybe<ITopic>>
  topics_connection?: Maybe<ITopicRelationResponseCollection>
  twitter?: Maybe<Scalars['String']['output']>
  type: IEnum_Solutionrequest_Type
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  vendorResources?: Maybe<Array<Maybe<IComponentSolutionPropsVendorResource>>>
  website?: Maybe<Scalars['String']['output']>
  yearFounded?: Maybe<Scalars['Int']['output']>
}

export type ISolutionRequestArticlesArgs = {
  filters?: InputMaybe<IComponentGlobalArticleFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRequestExistingCustomersArgs = {
  filters?: InputMaybe<IExistingCustomerFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRequestExistingCustomers_ConnectionArgs = {
  filters?: InputMaybe<IExistingCustomerFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRequestFeaturesArgs = {
  filters?: InputMaybe<IFeatureFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRequestFeatures_ConnectionArgs = {
  filters?: InputMaybe<IFeatureFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRequestFoundersArgs = {
  filters?: InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRequestHqsArgs = {
  filters?: InputMaybe<IHqFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRequestHqs_ConnectionArgs = {
  filters?: InputMaybe<IHqFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRequestLanguagesArgs = {
  filters?: InputMaybe<IPlatformLanguageFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRequestLanguages_ConnectionArgs = {
  filters?: InputMaybe<IPlatformLanguageFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRequestOfficesArgs = {
  filters?: InputMaybe<IOfficeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRequestOffices_ConnectionArgs = {
  filters?: InputMaybe<IOfficeFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRequestRegionsServedArgs = {
  filters?: InputMaybe<IRegionsServedFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRequestRegionsServed_ConnectionArgs = {
  filters?: InputMaybe<IRegionsServedFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRequestSubTopicsArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRequestSubTopics_ConnectionArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRequestTopicsArgs = {
  filters?: InputMaybe<ITopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRequestTopics_ConnectionArgs = {
  filters?: InputMaybe<ITopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRequestVendorResourcesArgs = {
  filters?: InputMaybe<IComponentSolutionPropsVendorResourceFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISolutionRequestEntityResponseCollection = {
  __typename?: 'SolutionRequestEntityResponseCollection'
  nodes: Array<ISolutionRequest>
  pageInfo: IPagination
}

export type ISolutionRequestFiltersInput = {
  alspData?: InputMaybe<IComponentSolutionRequestAlspDataFiltersInput>
  and?: InputMaybe<Array<InputMaybe<ISolutionRequestFiltersInput>>>
  announcement?: InputMaybe<IAnnouncementFiltersInput>
  articles?: InputMaybe<IComponentGlobalArticleFiltersInput>
  consultantData?: InputMaybe<IComponentSolutionRequestConsultantDataFiltersInput>
  converted?: InputMaybe<IBooleanFilterInput>
  convertedAt?: InputMaybe<IDateTimeFilterInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  descOtherExistingCustomer?: InputMaybe<IStringFilterInput>
  descOtherIntegration?: InputMaybe<IStringFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  existingCustomers?: InputMaybe<IExistingCustomerFiltersInput>
  features?: InputMaybe<IFeatureFiltersInput>
  founders?: InputMaybe<IComponentAboutPropsTeamMemberFiltersInput>
  hqs?: InputMaybe<IHqFiltersInput>
  isEnhanced?: InputMaybe<IBooleanFilterInput>
  languages?: InputMaybe<IPlatformLanguageFiltersInput>
  linkedin?: InputMaybe<IStringFilterInput>
  longDescription?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<ISolutionRequestFiltersInput>
  offices?: InputMaybe<IOfficeFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ISolutionRequestFiltersInput>>>
  productData?: InputMaybe<IComponentSolutionRequestProductDataFiltersInput>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  regionsServed?: InputMaybe<IRegionsServedFiltersInput>
  shortDescription?: InputMaybe<IStringFilterInput>
  slug?: InputMaybe<IStringFilterInput>
  subTopics?: InputMaybe<ISubTopicFiltersInput>
  submittedBy?: InputMaybe<IUserFiltersInput>
  topics?: InputMaybe<ITopicFiltersInput>
  twitter?: InputMaybe<IStringFilterInput>
  type?: InputMaybe<IStringFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
  vendorResources?: InputMaybe<IComponentSolutionPropsVendorResourceFiltersInput>
  website?: InputMaybe<IStringFilterInput>
  yearFounded?: InputMaybe<IIntFilterInput>
}

export type ISolutionRequestInput = {
  alspData?: InputMaybe<IComponentSolutionRequestAlspDataInput>
  announcement?: InputMaybe<Scalars['ID']['input']>
  articles?: InputMaybe<Array<InputMaybe<IComponentGlobalArticleInput>>>
  consultantData?: InputMaybe<IComponentSolutionRequestConsultantDataInput>
  converted?: InputMaybe<Scalars['Boolean']['input']>
  convertedAt?: InputMaybe<Scalars['DateTime']['input']>
  descOtherExistingCustomer?: InputMaybe<Scalars['String']['input']>
  descOtherIntegration?: InputMaybe<Scalars['String']['input']>
  existingCustomers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  features?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  founders?: InputMaybe<Array<InputMaybe<IComponentAboutPropsTeamMemberInput>>>
  gReCaptchaToken?: InputMaybe<Scalars['String']['input']>
  hqs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  isEnhanced?: InputMaybe<Scalars['Boolean']['input']>
  languages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  linkedin?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  logo?: InputMaybe<Scalars['ID']['input']>
  longDescription?: InputMaybe<Scalars['String']['input']>
  offices?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  productData?: InputMaybe<IComponentSolutionRequestProductDataInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  regionsServed?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  shortDescription?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  subTopics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  submittedBy?: InputMaybe<Scalars['ID']['input']>
  topics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  twitter?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<IEnum_Solutionrequest_Type>
  vendorResources?: InputMaybe<Array<InputMaybe<IComponentSolutionPropsVendorResourceInput>>>
  website?: InputMaybe<Scalars['String']['input']>
  yearFounded?: InputMaybe<Scalars['Int']['input']>
}

export type ISolutionSharedPortfolioSolutionData = {
  __typename?: 'SolutionSharedPortfolioSolutionData'
  category?: Maybe<Scalars['String']['output']>
  followingSolutionNote?: Maybe<Scalars['String']['output']>
  members?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  organizationId?: Maybe<Scalars['ID']['output']>
  portfolioId?: Maybe<Scalars['ID']['output']>
  sharedPortfolio?: Maybe<Scalars['ID']['output']>
  slug?: Maybe<Scalars['String']['output']>
}

export type IStringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  containsi?: InputMaybe<Scalars['String']['input']>
  endsWith?: InputMaybe<Scalars['String']['input']>
  eq?: InputMaybe<Scalars['String']['input']>
  eqi?: InputMaybe<Scalars['String']['input']>
  gt?: InputMaybe<Scalars['String']['input']>
  gte?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  lt?: InputMaybe<Scalars['String']['input']>
  lte?: InputMaybe<Scalars['String']['input']>
  ne?: InputMaybe<Scalars['String']['input']>
  nei?: InputMaybe<Scalars['String']['input']>
  not?: InputMaybe<IStringFilterInput>
  notContains?: InputMaybe<Scalars['String']['input']>
  notContainsi?: InputMaybe<Scalars['String']['input']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  notNull?: InputMaybe<Scalars['Boolean']['input']>
  null?: InputMaybe<Scalars['Boolean']['input']>
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  startsWith?: InputMaybe<Scalars['String']['input']>
}

export type ISubTopic = {
  __typename?: 'SubTopic'
  contents: Array<Maybe<IContent>>
  contents_connection?: Maybe<IContentRelationResponseCollection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  documentId: Scalars['ID']['output']
  expert?: Maybe<IExpert>
  features: Array<Maybe<IFeature>>
  features_connection?: Maybe<IFeatureRelationResponseCollection>
  followedUsers: Array<Maybe<IUser>>
  followedUsers_connection?: Maybe<IUserRelationResponseCollection>
  id: Scalars['ID']['output']
  isPremium?: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  secondaryExpert?: Maybe<IExpert>
  slug?: Maybe<Scalars['String']['output']>
  solutions: Array<Maybe<ISolution>>
  solutions_connection?: Maybe<ISolutionRelationResponseCollection>
  topics: Array<Maybe<ITopic>>
  topics_connection?: Maybe<ITopicRelationResponseCollection>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ISubTopicContentsArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISubTopicContents_ConnectionArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISubTopicFeaturesArgs = {
  filters?: InputMaybe<IFeatureFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISubTopicFeatures_ConnectionArgs = {
  filters?: InputMaybe<IFeatureFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISubTopicFollowedUsersArgs = {
  filters?: InputMaybe<IUserFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISubTopicFollowedUsers_ConnectionArgs = {
  filters?: InputMaybe<IUserFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISubTopicSolutionsArgs = {
  filters?: InputMaybe<ISolutionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISubTopicSolutions_ConnectionArgs = {
  filters?: InputMaybe<ISolutionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISubTopicTopicsArgs = {
  filters?: InputMaybe<ITopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISubTopicTopics_ConnectionArgs = {
  filters?: InputMaybe<ITopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISubTopicEntityResponseCollection = {
  __typename?: 'SubTopicEntityResponseCollection'
  nodes: Array<ISubTopic>
  pageInfo: IPagination
}

export type ISubTopicFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ISubTopicFiltersInput>>>
  contents?: InputMaybe<IContentFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  description?: InputMaybe<IStringFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  expert?: InputMaybe<IExpertFiltersInput>
  features?: InputMaybe<IFeatureFiltersInput>
  followedUsers?: InputMaybe<IUserFiltersInput>
  isPremium?: InputMaybe<IBooleanFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<ISubTopicFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ISubTopicFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  secondaryExpert?: InputMaybe<IExpertFiltersInput>
  slug?: InputMaybe<IStringFilterInput>
  solutions?: InputMaybe<ISolutionFiltersInput>
  topics?: InputMaybe<ITopicFiltersInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type ISubTopicInfo = {
  __typename?: 'SubTopicInfo'
  id?: Maybe<Scalars['Int']['output']>
  isPremium?: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
}

export type ISubTopicInput = {
  contents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  description?: InputMaybe<Scalars['String']['input']>
  expert?: InputMaybe<Scalars['ID']['input']>
  featuredOnHome?: InputMaybe<Scalars['Boolean']['input']>
  features?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  followedUsers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  isPremium?: InputMaybe<Scalars['Boolean']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  secondaryExpert?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  solutions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  topics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type ISubTopicRelationResponseCollection = {
  __typename?: 'SubTopicRelationResponseCollection'
  nodes: Array<ISubTopic>
}

export type ISubjectMatter = {
  __typename?: 'SubjectMatter'
  contents: Array<Maybe<IContent>>
  contents_connection?: Maybe<IContentRelationResponseCollection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  documentId: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ISubjectMatterContentsArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISubjectMatterContents_ConnectionArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ISubjectMatterEntityResponseCollection = {
  __typename?: 'SubjectMatterEntityResponseCollection'
  nodes: Array<ISubjectMatter>
  pageInfo: IPagination
}

export type ISubjectMatterFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ISubjectMatterFiltersInput>>>
  contents?: InputMaybe<IContentFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  description?: InputMaybe<IStringFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<ISubjectMatterFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ISubjectMatterFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  slug?: InputMaybe<IStringFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type ISubjectMatterInput = {
  contents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  description?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
}

export type ISubjectMatterRelationResponseCollection = {
  __typename?: 'SubjectMatterRelationResponseCollection'
  nodes: Array<ISubjectMatter>
}

export type ISubtopicItem = {
  __typename?: 'SubtopicItem'
  contentsTotalCount?: Maybe<Scalars['Int']['output']>
  description?: Maybe<Scalars['String']['output']>
  documentId?: Maybe<Scalars['String']['output']>
  featuredOnHome?: Maybe<Scalars['Boolean']['output']>
  iconName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isPremium?: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
  slug: Scalars['String']['output']
  solutionsTotalCount?: Maybe<Scalars['Int']['output']>
  topicName?: Maybe<Scalars['String']['output']>
  topicSlug?: Maybe<Scalars['String']['output']>
}

export type ISuggest = {
  __typename?: 'Suggest'
  id: Scalars['Int']['output']
  keyword: Scalars['String']['output']
  logo?: Maybe<Scalars['String']['output']>
  model: ISuggestModel
  slug: Scalars['String']['output']
}

export enum ISuggestModel {
  AlsPs = 'ALSPs',
  Companies = 'Companies',
  Consultants = 'Consultants',
  Contents = 'Contents',
  Events = 'Events',
  SubTopics = 'SubTopics',
  Topics = 'Topics',
  Vendors = 'Vendors',
}

export type ITaxonomy = {
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type ITermsConditions = {
  __typename?: 'TermsConditions'
  content?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  date?: Maybe<Scalars['Date']['output']>
  documentId: Scalars['ID']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  summary?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ITermsConditionsInput = {
  content?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['Date']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
}

export type ITestimonials = {
  __typename?: 'Testimonials'
  author?: Maybe<IComponentTestimonialsPropsAuthor>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  documentId: Scalars['ID']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ITestimonialsEntityResponseCollection = {
  __typename?: 'TestimonialsEntityResponseCollection'
  nodes: Array<ITestimonials>
  pageInfo: IPagination
}

export type ITestimonialsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ITestimonialsFiltersInput>>>
  author?: InputMaybe<IComponentTestimonialsPropsAuthorFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  description?: InputMaybe<IStringFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  not?: InputMaybe<ITestimonialsFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ITestimonialsFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type ITestimonialsInput = {
  author?: InputMaybe<IComponentTestimonialsPropsAuthorInput>
  description?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ITheme = {
  __typename?: 'Theme'
  contents: Array<Maybe<IContent>>
  contents_connection?: Maybe<IContentRelationResponseCollection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  documentId: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IThemeContentsArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IThemeContents_ConnectionArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IThemeEntityResponseCollection = {
  __typename?: 'ThemeEntityResponseCollection'
  nodes: Array<ITheme>
  pageInfo: IPagination
}

export type IThemeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IThemeFiltersInput>>>
  contents?: InputMaybe<IContentFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  description?: InputMaybe<IStringFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IThemeFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IThemeFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  slug?: InputMaybe<IStringFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IThemeInput = {
  contents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  description?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
}

export type IThemeRelationResponseCollection = {
  __typename?: 'ThemeRelationResponseCollection'
  nodes: Array<ITheme>
}

export type ITopic = {
  __typename?: 'Topic'
  contents: Array<Maybe<IContent>>
  contents_connection?: Maybe<IContentRelationResponseCollection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  documentId: Scalars['ID']['output']
  expert?: Maybe<IExpert>
  iconName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isPremium?: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  secondaryExpert?: Maybe<IExpert>
  slug: Scalars['String']['output']
  solutions: Array<Maybe<ISolution>>
  solutions_connection?: Maybe<ISolutionRelationResponseCollection>
  subTopics: Array<Maybe<ISubTopic>>
  subTopics_connection?: Maybe<ISubTopicRelationResponseCollection>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ITopicContentsArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ITopicContents_ConnectionArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ITopicSolutionsArgs = {
  filters?: InputMaybe<ISolutionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ITopicSolutions_ConnectionArgs = {
  filters?: InputMaybe<ISolutionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ITopicSubTopicsArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ITopicSubTopics_ConnectionArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ITopicEntityResponseCollection = {
  __typename?: 'TopicEntityResponseCollection'
  nodes: Array<ITopic>
  pageInfo: IPagination
}

export type ITopicFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ITopicFiltersInput>>>
  contents?: InputMaybe<IContentFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  description?: InputMaybe<IStringFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  expert?: InputMaybe<IExpertFiltersInput>
  iconName?: InputMaybe<IStringFilterInput>
  isPremium?: InputMaybe<IBooleanFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<ITopicFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ITopicFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  secondaryExpert?: InputMaybe<IExpertFiltersInput>
  slug?: InputMaybe<IStringFilterInput>
  solutions?: InputMaybe<ISolutionFiltersInput>
  subTopics?: InputMaybe<ISubTopicFiltersInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type ITopicInput = {
  contents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  description?: InputMaybe<Scalars['String']['input']>
  expert?: InputMaybe<Scalars['ID']['input']>
  featuredOnHome?: InputMaybe<Scalars['Boolean']['input']>
  iconName?: InputMaybe<Scalars['String']['input']>
  isPremium?: InputMaybe<Scalars['Boolean']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  secondaryExpert?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  solutions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  subTopics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type ITopicRelationResponseCollection = {
  __typename?: 'TopicRelationResponseCollection'
  nodes: Array<ITopic>
}

export type ITypeOfUser = {
  __typename?: 'TypeOfUser'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ITypeOfUserEntityResponseCollection = {
  __typename?: 'TypeOfUserEntityResponseCollection'
  nodes: Array<ITypeOfUser>
  pageInfo: IPagination
}

export type ITypeOfUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ITypeOfUserFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<ITypeOfUserFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ITypeOfUserFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type ITypeOfUserInput = {
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ITypeOfUserRelationResponseCollection = {
  __typename?: 'TypeOfUserRelationResponseCollection'
  nodes: Array<ITypeOfUser>
}

export type IUnFollowedRelatedSubtopics = {
  __typename?: 'UnFollowedRelatedSubtopics'
  documentId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isPremium?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
  slug: Scalars['String']['output']
  topicName?: Maybe<Scalars['String']['output']>
  topicSlug?: Maybe<Scalars['String']['output']>
}

export type IUnFollowedRelatedSubtopicsResult = {
  __typename?: 'UnFollowedRelatedSubtopicsResult'
  subtopics?: Maybe<Array<Maybe<IUnFollowedRelatedSubtopics>>>
  total?: Maybe<Scalars['Int']['output']>
}

export type IUpdateUserProfileInput = {
  companyName?: InputMaybe<Scalars['String']['input']>
  companySize?: InputMaybe<Scalars['String']['input']>
  companyType?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['ID']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  subscribed?: InputMaybe<Scalars['Boolean']['input']>
  userToken?: InputMaybe<Scalars['String']['input']>
  username?: InputMaybe<Scalars['String']['input']>
}

export type IUploadFile = {
  __typename?: 'UploadFile'
  alternativeText?: Maybe<Scalars['String']['output']>
  caption?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  ext?: Maybe<Scalars['String']['output']>
  focalPoint?: Maybe<Scalars['JSON']['output']>
  formats?: Maybe<Scalars['JSON']['output']>
  hash: Scalars['String']['output']
  height?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  mime: Scalars['String']['output']
  name: Scalars['String']['output']
  previewUrl?: Maybe<Scalars['String']['output']>
  provider: Scalars['String']['output']
  provider_metadata?: Maybe<Scalars['JSON']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  related?: Maybe<Array<Maybe<IGenericMorph>>>
  size: Scalars['Float']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  url: Scalars['String']['output']
  width?: Maybe<Scalars['Int']['output']>
}

export type IUploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection'
  nodes: Array<IUploadFile>
  pageInfo: IPagination
}

export type IUploadFileFiltersInput = {
  alternativeText?: InputMaybe<IStringFilterInput>
  and?: InputMaybe<Array<InputMaybe<IUploadFileFiltersInput>>>
  caption?: InputMaybe<IStringFilterInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  ext?: InputMaybe<IStringFilterInput>
  focalPoint?: InputMaybe<IJsonFilterInput>
  formats?: InputMaybe<IJsonFilterInput>
  hash?: InputMaybe<IStringFilterInput>
  height?: InputMaybe<IIntFilterInput>
  mime?: InputMaybe<IStringFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IUploadFileFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IUploadFileFiltersInput>>>
  previewUrl?: InputMaybe<IStringFilterInput>
  provider?: InputMaybe<IStringFilterInput>
  provider_metadata?: InputMaybe<IJsonFilterInput>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  size?: InputMaybe<IFloatFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
  url?: InputMaybe<IStringFilterInput>
  width?: InputMaybe<IIntFilterInput>
}

export type IUploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection'
  nodes: Array<IUploadFile>
}

export type IUser = {
  __typename?: 'User'
  blocked?: Maybe<Scalars['Boolean']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  companySize?: Maybe<IEnum_User_Companysize>
  companyType?: Maybe<IEnum_User_Companytype>
  confirmed?: Maybe<Scalars['Boolean']['output']>
  country?: Maybe<ICountry>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  email: Scalars['String']['output']
  external_id?: Maybe<Scalars['String']['output']>
  followedSubTopics: Array<Maybe<ISubTopic>>
  followedSubTopics_connection?: Maybe<ISubTopicRelationResponseCollection>
  followingSolutions?: Maybe<Array<Maybe<IComponentSolutionSolutionsFollowing>>>
  isPremium?: Maybe<Scalars['Boolean']['output']>
  isVendor?: Maybe<Scalars['Boolean']['output']>
  jobTitle?: Maybe<Scalars['String']['output']>
  portfolioCustomTags?: Maybe<Array<Maybe<IComponentUserPortfolioCustomTag>>>
  premiumOrganization?: Maybe<IPremiumOrganization>
  provider?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  resource_invitations_shared_by: Array<Maybe<IResourceInvitation>>
  resource_invitations_shared_by_connection?: Maybe<IResourceInvitationRelationResponseCollection>
  resource_invitations_shared_to: Array<Maybe<IResourceInvitation>>
  resource_invitations_shared_to_connection?: Maybe<IResourceInvitationRelationResponseCollection>
  reviews: Array<Maybe<IReview>>
  reviews_connection?: Maybe<IReviewRelationResponseCollection>
  role?: Maybe<IUsersPermissionsRole>
  shared_portfolios: Array<Maybe<ISharedPortfolio>>
  shared_portfolios_connection?: Maybe<ISharedPortfolioRelationResponseCollection>
  subscribeNewsletterCategories: Array<Maybe<INewsletterCategory>>
  subscribeNewsletterCategories_connection?: Maybe<INewsletterCategoryRelationResponseCollection>
  subscribed?: Maybe<Scalars['Boolean']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  user_system_features: Array<Maybe<IUserSystemFeature>>
  user_system_features_connection?: Maybe<IUserSystemFeatureRelationResponseCollection>
  username: Scalars['String']['output']
  vendor?: Maybe<IVendor>
}

export type IUserFollowedSubTopicsArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUserFollowedSubTopics_ConnectionArgs = {
  filters?: InputMaybe<ISubTopicFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUserFollowingSolutionsArgs = {
  filters?: InputMaybe<IComponentSolutionSolutionsFollowingFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUserPortfolioCustomTagsArgs = {
  filters?: InputMaybe<IComponentUserPortfolioCustomTagFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUserResource_Invitations_Shared_ByArgs = {
  filters?: InputMaybe<IResourceInvitationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUserResource_Invitations_Shared_By_ConnectionArgs = {
  filters?: InputMaybe<IResourceInvitationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUserResource_Invitations_Shared_ToArgs = {
  filters?: InputMaybe<IResourceInvitationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUserResource_Invitations_Shared_To_ConnectionArgs = {
  filters?: InputMaybe<IResourceInvitationFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUserReviewsArgs = {
  filters?: InputMaybe<IReviewFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUserReviews_ConnectionArgs = {
  filters?: InputMaybe<IReviewFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUserShared_PortfoliosArgs = {
  filters?: InputMaybe<ISharedPortfolioFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUserShared_Portfolios_ConnectionArgs = {
  filters?: InputMaybe<ISharedPortfolioFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUserSubscribeNewsletterCategoriesArgs = {
  filters?: InputMaybe<INewsletterCategoryFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUserSubscribeNewsletterCategories_ConnectionArgs = {
  filters?: InputMaybe<INewsletterCategoryFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUserUser_System_FeaturesArgs = {
  filters?: InputMaybe<IUserSystemFeatureFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUserUser_System_Features_ConnectionArgs = {
  filters?: InputMaybe<IUserSystemFeatureFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUserEntityResponse = {
  __typename?: 'UserEntityResponse'
  data?: Maybe<IUser>
}

export type IUserEntityResponseCollection = {
  __typename?: 'UserEntityResponseCollection'
  nodes: Array<IUser>
  pageInfo: IPagination
}

export type IUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IUserFiltersInput>>>
  blocked?: InputMaybe<IBooleanFilterInput>
  companyName?: InputMaybe<IStringFilterInput>
  companySize?: InputMaybe<IStringFilterInput>
  companyType?: InputMaybe<IStringFilterInput>
  confirmed?: InputMaybe<IBooleanFilterInput>
  country?: InputMaybe<ICountryFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  email?: InputMaybe<IStringFilterInput>
  external_id?: InputMaybe<IStringFilterInput>
  followedSubTopics?: InputMaybe<ISubTopicFiltersInput>
  followingSolutions?: InputMaybe<IComponentSolutionSolutionsFollowingFiltersInput>
  isPremium?: InputMaybe<IBooleanFilterInput>
  isVendor?: InputMaybe<IBooleanFilterInput>
  jobTitle?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IUserFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IUserFiltersInput>>>
  portfolioCustomTags?: InputMaybe<IComponentUserPortfolioCustomTagFiltersInput>
  premiumOrganization?: InputMaybe<IPremiumOrganizationFiltersInput>
  provider?: InputMaybe<IStringFilterInput>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  resource_invitations_shared_by?: InputMaybe<IResourceInvitationFiltersInput>
  resource_invitations_shared_to?: InputMaybe<IResourceInvitationFiltersInput>
  reviews?: InputMaybe<IReviewFiltersInput>
  role?: InputMaybe<IUsersPermissionsRoleFiltersInput>
  shared_portfolios?: InputMaybe<ISharedPortfolioFiltersInput>
  subscribeNewsletterCategories?: InputMaybe<INewsletterCategoryFiltersInput>
  subscribed?: InputMaybe<IBooleanFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
  user_system_features?: InputMaybe<IUserSystemFeatureFiltersInput>
  username?: InputMaybe<IStringFilterInput>
  vendor?: InputMaybe<IVendorFiltersInput>
}

export type IUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  companySize?: InputMaybe<IEnum_User_Companysize>
  companyType?: InputMaybe<IEnum_User_Companytype>
  confirmationToken?: InputMaybe<Scalars['String']['input']>
  confirmed?: InputMaybe<Scalars['Boolean']['input']>
  country?: InputMaybe<Scalars['ID']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  external_id?: InputMaybe<Scalars['String']['input']>
  followedSubTopics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  followingSolutions?: InputMaybe<Array<InputMaybe<IComponentSolutionSolutionsFollowingInput>>>
  isPremium?: InputMaybe<Scalars['Boolean']['input']>
  isVendor?: InputMaybe<Scalars['Boolean']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  password?: InputMaybe<Scalars['String']['input']>
  portfolioCustomTags?: InputMaybe<Array<InputMaybe<IComponentUserPortfolioCustomTagInput>>>
  premiumOrganization?: InputMaybe<Scalars['ID']['input']>
  provider?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>
  resource_invitations_shared_by?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  resource_invitations_shared_to?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  reviews?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  role?: InputMaybe<Scalars['ID']['input']>
  shared_portfolios?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  subscribeNewsletterCategories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  subscribed?: InputMaybe<Scalars['Boolean']['input']>
  userAccessLevel?: InputMaybe<IEnum_User_Useraccesslevel>
  userAccessLevelSetByAdmin?: InputMaybe<Scalars['Boolean']['input']>
  user_system_features?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  username?: InputMaybe<Scalars['String']['input']>
  vendor?: InputMaybe<Scalars['ID']['input']>
}

export type IUserRelationResponseCollection = {
  __typename?: 'UserRelationResponseCollection'
  nodes: Array<IUser>
}

export type IUserSystemFeature = {
  __typename?: 'UserSystemFeature'
  Title: Scalars['String']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  isEnabled?: Maybe<Scalars['Boolean']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IUserSystemFeatureEntityResponseCollection = {
  __typename?: 'UserSystemFeatureEntityResponseCollection'
  nodes: Array<IUserSystemFeature>
  pageInfo: IPagination
}

export type IUserSystemFeatureFiltersInput = {
  Title?: InputMaybe<IStringFilterInput>
  and?: InputMaybe<Array<InputMaybe<IUserSystemFeatureFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  isEnabled?: InputMaybe<IBooleanFilterInput>
  not?: InputMaybe<IUserSystemFeatureFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IUserSystemFeatureFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IUserSystemFeatureInput = {
  Title?: InputMaybe<Scalars['String']['input']>
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IUserSystemFeatureRelationResponseCollection = {
  __typename?: 'UserSystemFeatureRelationResponseCollection'
  nodes: Array<IUserSystemFeature>
}

export type IUsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload'
  ok: Scalars['Boolean']['output']
}

export type IUsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload'
  ok: Scalars['Boolean']['output']
}

export type IUsersPermissionsLoginInput = {
  identifier: Scalars['String']['input']
  password: Scalars['String']['input']
  provider?: Scalars['String']['input']
}

export type IUsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload'
  jwt?: Maybe<Scalars['String']['output']>
  user: IUsersPermissionsMe
}

export type IUsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe'
  blocked?: Maybe<Scalars['Boolean']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  companySize?: Maybe<Scalars['String']['output']>
  companyType?: Maybe<Scalars['String']['output']>
  confirmed?: Maybe<Scalars['Boolean']['output']>
  country?: Maybe<ICountry>
  documentId: Scalars['ID']['output']
  email?: Maybe<Scalars['String']['output']>
  external_id?: Maybe<Scalars['String']['output']>
  followedSubTopics?: Maybe<Array<Maybe<ISubTopic>>>
  hasVendorCentralAccess?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  isPremium?: Maybe<Scalars['Boolean']['output']>
  isVendor?: Maybe<Scalars['Boolean']['output']>
  jobTitle?: Maybe<Scalars['String']['output']>
  premiumOrganization?: Maybe<IPremiumOrganization>
  role?: Maybe<IUsersPermissionsMeRole>
  username: Scalars['String']['output']
  vendor?: Maybe<IVendor>
}

export type IUsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole'
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  type?: Maybe<Scalars['String']['output']>
}

export type IUsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload'
  ok: Scalars['Boolean']['output']
}

export type IUsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission'
  action: Scalars['String']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  role?: Maybe<IUsersPermissionsRole>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IUsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<IStringFilterInput>
  and?: InputMaybe<Array<InputMaybe<IUsersPermissionsPermissionFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  not?: InputMaybe<IUsersPermissionsPermissionFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IUsersPermissionsPermissionFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  role?: InputMaybe<IUsersPermissionsRoleFiltersInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IUsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection'
  nodes: Array<IUsersPermissionsPermission>
}

export type IUsersPermissionsRegisterInput = {
  email: Scalars['String']['input']
  gReCaptchaToken?: InputMaybe<Scalars['String']['input']>
  password: Scalars['String']['input']
  username: Scalars['String']['input']
}

export type IUsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  documentId: Scalars['ID']['output']
  name: Scalars['String']['output']
  permissions: Array<Maybe<IUsersPermissionsPermission>>
  permissions_connection?: Maybe<IUsersPermissionsPermissionRelationResponseCollection>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  type?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  users: Array<Maybe<IUser>>
  users_connection?: Maybe<IUserRelationResponseCollection>
}

export type IUsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<IUsersPermissionsPermissionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUsersPermissionsRolePermissions_ConnectionArgs = {
  filters?: InputMaybe<IUsersPermissionsPermissionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<IUserFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUsersPermissionsRoleUsers_ConnectionArgs = {
  filters?: InputMaybe<IUserFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IUsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection'
  nodes: Array<IUsersPermissionsRole>
  pageInfo: IPagination
}

export type IUsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IUsersPermissionsRoleFiltersInput>>>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  description?: InputMaybe<IStringFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IUsersPermissionsRoleFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IUsersPermissionsRoleFiltersInput>>>
  permissions?: InputMaybe<IUsersPermissionsPermissionFiltersInput>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  type?: InputMaybe<IStringFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
  users?: InputMaybe<IUserFiltersInput>
}

export type IUsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type IUsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload'
  ok: Scalars['Boolean']['output']
}

export type IVendor = {
  __typename?: 'Vendor'
  companySize?: Maybe<IEnum_Vendor_Companysize>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  email?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  invitations?: Maybe<Array<Maybe<IComponentInvitationsInvitations>>>
  name: Scalars['String']['output']
  newsletterCategories: Array<Maybe<INewsletterCategory>>
  newsletterCategories_connection?: Maybe<INewsletterCategoryRelationResponseCollection>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  registrationContact: Array<Maybe<IComponentRegistrationContactRegistrationContact>>
  solutions: Array<Maybe<ISolution>>
  solutions_connection?: Maybe<ISolutionRelationResponseCollection>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  users: Array<Maybe<IUser>>
  users_connection?: Maybe<IUserRelationResponseCollection>
  vendorStatus?: Maybe<Scalars['String']['output']>
}

export type IVendorInvitationsArgs = {
  filters?: InputMaybe<IComponentInvitationsInvitationsFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IVendorNewsletterCategoriesArgs = {
  filters?: InputMaybe<INewsletterCategoryFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IVendorNewsletterCategories_ConnectionArgs = {
  filters?: InputMaybe<INewsletterCategoryFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IVendorRegistrationContactArgs = {
  filters?: InputMaybe<IComponentRegistrationContactRegistrationContactFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IVendorSolutionsArgs = {
  filters?: InputMaybe<ISolutionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IVendorSolutions_ConnectionArgs = {
  filters?: InputMaybe<ISolutionFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IVendorUsersArgs = {
  filters?: InputMaybe<IUserFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IVendorUsers_ConnectionArgs = {
  filters?: InputMaybe<IUserFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IVendorEntityResponseCollection = {
  __typename?: 'VendorEntityResponseCollection'
  nodes: Array<IVendor>
  pageInfo: IPagination
}

export type IVendorFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IVendorFiltersInput>>>
  companySize?: InputMaybe<IStringFilterInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  email?: InputMaybe<IStringFilterInput>
  invitations?: InputMaybe<IComponentInvitationsInvitationsFiltersInput>
  name?: InputMaybe<IStringFilterInput>
  newsletterCategories?: InputMaybe<INewsletterCategoryFiltersInput>
  not?: InputMaybe<IVendorFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IVendorFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  registrationContact?: InputMaybe<IComponentRegistrationContactRegistrationContactFiltersInput>
  solutions?: InputMaybe<ISolutionFiltersInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
  users?: InputMaybe<IUserFiltersInput>
}

export type IVendorInput = {
  companySize?: InputMaybe<IEnum_Vendor_Companysize>
  email?: InputMaybe<Scalars['String']['input']>
  firstPublishAt?: InputMaybe<Scalars['DateTime']['input']>
  invitations?: InputMaybe<Array<InputMaybe<IComponentInvitationsInvitationsInput>>>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  newsletterCategories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  premiumOrganization?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  registrationContact?: InputMaybe<Array<InputMaybe<IComponentRegistrationContactRegistrationContactInput>>>
  solutions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  vendorStatus?: InputMaybe<IEnum_Vendor_Vendorstatus>
  vendorSubscriptionLevel?: InputMaybe<IEnum_Vendor_Vendorsubscriptionlevel>
}

export type IVendorListingRequest = {
  audiences?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  ceoEmail?: InputMaybe<Scalars['String']['input']>
  ceoName?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  competitor?: InputMaybe<Scalars['String']['input']>
  deployments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descOtherExistingCustomer?: InputMaybe<Scalars['String']['input']>
  descOtherIntegration?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  existingCustomers?: InputMaybe<Array<InputMaybe<ITaxonomy>>>
  hqs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  integrations?: InputMaybe<Array<InputMaybe<ITaxonomy>>>
  isCreate?: InputMaybe<Scalars['Boolean']['input']>
  isOpenJobPosition?: InputMaybe<Scalars['Boolean']['input']>
  lanuages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  logo?: InputMaybe<Scalars['ID']['input']>
  longDescription?: InputMaybe<Scalars['String']['input']>
  marketEmail?: InputMaybe<Scalars['String']['input']>
  marketName?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  offices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  practiceAreas?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  productName?: InputMaybe<Scalars['String']['input']>
  shortDescription?: InputMaybe<Scalars['String']['input']>
  subTopics?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeOfUsers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<Scalars['String']['input']>
  yearFounded?: InputMaybe<Scalars['Int']['input']>
}

export type IVendorTopic = {
  __typename?: 'VendorTopic'
  contents: Array<Maybe<IContent>>
  contents_connection?: Maybe<IContentRelationResponseCollection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentId: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IVendorTopicContentsArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IVendorTopicContents_ConnectionArgs = {
  filters?: InputMaybe<IContentFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type IVendorTopicEntityResponseCollection = {
  __typename?: 'VendorTopicEntityResponseCollection'
  nodes: Array<IVendorTopic>
  pageInfo: IPagination
}

export type IVendorTopicFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IVendorTopicFiltersInput>>>
  contents?: InputMaybe<IContentFiltersInput>
  createdAt?: InputMaybe<IDateTimeFilterInput>
  documentId?: InputMaybe<IIdFilterInput>
  name?: InputMaybe<IStringFilterInput>
  not?: InputMaybe<IVendorTopicFiltersInput>
  or?: InputMaybe<Array<InputMaybe<IVendorTopicFiltersInput>>>
  publishedAt?: InputMaybe<IDateTimeFilterInput>
  updatedAt?: InputMaybe<IDateTimeFilterInput>
}

export type IVendorTopicInput = {
  contents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  locale?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type IVendorTopicRelationResponseCollection = {
  __typename?: 'VendorTopicRelationResponseCollection'
  nodes: Array<IVendorTopic>
}

export type IClaimVendorListingInput = {
  name: Scalars['String']['input']
  solutionName: Scalars['String']['input']
  userEmail: Scalars['String']['input']
}

export type IDownloadMaterialFileEntity = {
  __typename?: 'downloadMaterialFileEntity'
  url?: Maybe<Scalars['String']['output']>
}

export type IInputRatingData = {
  email?: InputMaybe<Scalars['String']['input']>
  feedback?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  identicalId?: InputMaybe<Scalars['Int']['input']>
  rating?: InputMaybe<Scalars['Int']['input']>
  userID?: InputMaybe<Scalars['String']['input']>
}

export type IInvitedUsersResult = {
  __typename?: 'invitedUsersResult'
  invitations?: Maybe<Array<Maybe<IResourceInvitationEntity>>>
  total?: Maybe<Scalars['Int']['output']>
}

export type ISmartSearchLog = {
  __typename?: 'smartSearchLog'
  message: Scalars['String']['output']
  timestamp: Scalars['String']['output']
}

export type IStatusResponse = {
  __typename?: 'statusResponse'
  status?: Maybe<Scalars['Boolean']['output']>
}

export type IVendorName = {
  name: Scalars['String']['input']
}

export type IVendorSatus = {
  __typename?: 'vendorSatus'
  data?: Maybe<IStatusResponse>
}

export type IGetAllMasterDataQueryVariables = Exact<{ [key: string]: never }>

export type IGetAllMasterDataQuery = {
  __typename?: 'Query'
  getAllMasterData: {
    __typename?: 'GetAllMasterDataResult'
    hqs: Array<{ __typename?: 'MasterDataItem'; id: string; documentId: string; name: string }>
    platformLanguages: Array<{ __typename?: 'MasterDataItem'; id: string; documentId: string; name: string }>
    subTopics: Array<{ __typename?: 'MasterDataItem'; id: string; documentId: string; name: string }>
    offices: Array<{ __typename?: 'MasterDataItem'; id: string; documentId: string; name: string }>
    regionsServed: Array<{ __typename?: 'MasterDataItem'; id: string; documentId: string; name: string }>
    demographics: Array<{ __typename?: 'MasterDataItem'; id: string; documentId: string; name: string }>
    typeOfUsers: Array<{ __typename?: 'MasterDataItem'; id: string; documentId: string; name: string }>
    existingCustomers: Array<{ __typename?: 'MasterDataItem'; id: string; documentId: string; name: string }>
    practiceAreas: Array<{ __typename?: 'MasterDataItem'; id: string; documentId: string; name: string }>
    attributes: Array<{ __typename?: 'MasterDataItem'; id: string; documentId: string; name: string }>
    integrations: Array<{ __typename?: 'MasterDataItem'; id: string; documentId: string; name: string }>
    securities: Array<{ __typename?: 'MasterDataItem'; id: string; documentId: string; name: string }>
    installations: Array<{ __typename?: 'MasterDataItem'; id: string; documentId: string; name: string }>
  }
}

export type ISearchContentsTotalQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']['input']>
}>

export type ISearchContentsTotalQuery = {
  __typename?: 'Query'
  contentResults: {
    __typename?: 'ContentSearchReturnType'
    success?: boolean | null
    data?: { __typename?: 'ContentSearchResult'; total?: number | null } | null
  }
}

export type IAddSolutionToSharedPortfolioMutationVariables = Exact<{
  sharedID: Scalars['ID']['input']
  category: Scalars['String']['input']
  followingSolutionNote?: InputMaybe<Scalars['String']['input']>
  solution: Scalars['ID']['input']
}>

export type IAddSolutionToSharedPortfolioMutation = {
  __typename?: 'Mutation'
  addSolutionToSharedPortfolio?: {
    __typename?: 'SharedPortfolioSolutionEntity'
    id?: string | null
    attributes?: {
      __typename?: 'SharedPortfolioSolution'
      documentId: string
      category?: IEnum_Sharedportfoliosolution_Category | null
      followingSolutionNote?: string | null
      createdAt?: any | null
      updatedAt?: any | null
      solution?: { __typename?: 'Solution'; documentId: string; displayName?: string | null } | null
      sharedPortfolio?: { __typename?: 'SharedPortfolio'; documentId: string; name: string } | null
      lastModifiedByUser?: { __typename?: 'User'; documentId: string; username: string; email: string } | null
    } | null
  } | null
}

export type IAddPortfolioTagToSolutionMutationVariables = Exact<{
  tagDocumentId: Scalars['ID']['input']
  solutionId?: InputMaybe<Scalars['Int']['input']>
  solutionDocumentId?: InputMaybe<Scalars['ID']['input']>
}>

export type IAddPortfolioTagToSolutionMutation = { __typename?: 'Mutation'; addPortfolioTagToSolution?: boolean | null }

export type IAllAuthorsQueryVariables = Exact<{ [key: string]: never }>

export type IAllAuthorsQuery = {
  __typename?: 'Query'
  authors: Array<{
    __typename?: 'Author'
    documentId: string
    firstName: string
    lastName: string
    displayName?: string | null
    jobTitle?: string | null
    company?: string | null
    slug?: string | null
    avatar?: { __typename?: 'UploadFile'; url: string } | null
  } | null>
}

export type IAllAuthorSlugsQueryVariables = Exact<{ [key: string]: never }>

export type IAllAuthorSlugsQuery = {
  __typename?: 'Query'
  authors: Array<{ __typename?: 'Author'; slug?: string | null } | null>
}

export type IAllBlogTaxonomySlugsQueryVariables = Exact<{ [key: string]: never }>

export type IAllBlogTaxonomySlugsQuery = {
  __typename?: 'Query'
  blogTaxonomys: Array<{ __typename?: 'BlogTaxonomy'; slug?: string | null } | null>
}

export type IAllCollectionSlugQueryVariables = Exact<{ [key: string]: never }>

export type IAllCollectionSlugQuery = {
  __typename?: 'Query'
  collections: Array<{ __typename?: 'Collection'; slug?: string | null } | null>
}

export type IAllContentSlugsQueryVariables = Exact<{
  start: Scalars['Int']['input']
}>

export type IAllContentSlugsQuery = {
  __typename?: 'Query'
  contents: Array<{ __typename?: 'Content'; documentId: string; slug: string } | null>
}

export type IAllIndustryAnalysisQueryVariables = Exact<{
  start: Scalars['Int']['input']
}>

export type IAllIndustryAnalysisQuery = {
  __typename?: 'Query'
  contents: Array<{
    __typename?: 'Content'
    documentId: string
    title: string
    snippet: string
    createdAt?: any | null
    publishedTime?: any | null
    contentType?: IEnum_Content_Contenttype | null
    documentType?: IEnum_Content_Documenttype | null
    isMaintained?: boolean | null
    lastMaintained?: any | null
    slug: string
    publishedAt?: any | null
    subjectMatterIds?: Array<string | null> | null
    themeIds?: Array<string | null> | null
    vendorTopicIds?: Array<string | null> | null
    defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
    blogTaxonomies: Array<{
      __typename?: 'BlogTaxonomy'
      documentId: string
      slug?: string | null
      name?: string | null
    } | null>
    audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
    subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
    writer?: Array<{
      __typename?: 'ComponentContentContentWriter'
      writerOption: IEnum_Componentcontentcontentwriter_Writeroption
      oneTimeAuthorName?: string | null
      author?: {
        __typename?: 'Author'
        firstName: string
        lastName: string
        jobTitle?: string | null
        company?: string | null
        bio?: string | null
        slug?: string | null
        avatar?: { __typename?: 'UploadFile'; url: string } | null
      } | null
      expert?: {
        __typename?: 'Expert'
        documentId: string
        firstName: string
        lastName: string
        displayName?: string | null
        title?: string | null
        company?: string | null
        bio?: string | null
        slug?: string | null
        avatar?: { __typename?: 'UploadFile'; url: string } | null
        expertiseSubTopics: Array<{
          __typename?: 'SubTopic'
          documentId: string
          name: string
          slug?: string | null
          topics: Array<{
            __typename?: 'Topic'
            documentId: string
            name: string
            description?: string | null
            slug: string
          } | null>
        } | null>
        expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
        contents: Array<{ __typename?: 'Content'; documentId: string } | null>
      } | null
      solution?: {
        __typename?: 'Solution'
        displayName?: string | null
        slug?: string | null
        type: IEnum_Solution_Type
        shortDescription?: string | null
        logo?: { __typename?: 'UploadFile'; url: string } | null
      } | null
    } | null> | null
    themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
    vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
  } | null>
}

export type IAllIndustryAnalysisSlugsQueryVariables = Exact<{
  start: Scalars['Int']['input']
}>

export type IAllIndustryAnalysisSlugsQuery = {
  __typename?: 'Query'
  contents: Array<{ __typename?: 'Content'; documentId: string; slug: string } | null>
}

export type IAllSolutionRequestsItemsFragment = {
  __typename?: 'SolutionRequest'
  documentId: string
  website?: string | null
  slug?: string | null
  shortDescription?: string | null
  longDescription?: string | null
  linkedin?: string | null
  twitter?: string | null
  type: IEnum_Solutionrequest_Type
  yearFounded?: number | null
  createdAt?: any | null
  publishedAt?: any | null
  updatedAt?: any | null
  topics: Array<{ __typename?: 'Topic'; documentId: string; slug: string; name: string } | null>
  subTopics: Array<{
    __typename?: 'SubTopic'
    documentId: string
    slug?: string | null
    name: string
    features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
  } | null>
  logo?: { __typename?: 'UploadFile'; id: string; url: string } | null
  offices: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
  hqs: Array<{ __typename?: 'Hq'; documentId: string; name: string } | null>
  regionsServed: Array<{ __typename?: 'RegionsServed'; documentId: string; name: string } | null>
  languages: Array<{ __typename?: 'PlatformLanguage'; documentId: string; name: string } | null>
  articles?: Array<{
    __typename?: 'ComponentGlobalArticle'
    id: string
    title?: string | null
    publishedBy?: string | null
    date?: any | null
    link?: string | null
    image?: { __typename?: 'UploadFile'; url: string; id: string } | null
  } | null> | null
  features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
  existingCustomers: Array<{ __typename?: 'ExistingCustomer'; documentId: string; name: string } | null>
  announcement?: { __typename?: 'Announcement'; announcement: string; optionalLink?: string | null } | null
}

export type IAllSolutionRequestsSlugsQueryVariables = Exact<{
  filters?: InputMaybe<ISolutionRequestFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>
}>

export type IAllSolutionRequestsSlugsQuery = {
  __typename?: 'Query'
  solutionRequests: Array<{
    __typename?: 'SolutionRequest'
    documentId: string
    website?: string | null
    slug?: string | null
    shortDescription?: string | null
    longDescription?: string | null
    linkedin?: string | null
    twitter?: string | null
    type: IEnum_Solutionrequest_Type
    yearFounded?: number | null
    createdAt?: any | null
    publishedAt?: any | null
    updatedAt?: any | null
    topics: Array<{ __typename?: 'Topic'; documentId: string; slug: string; name: string } | null>
    subTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      slug?: string | null
      name: string
      features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
    } | null>
    logo?: { __typename?: 'UploadFile'; id: string; url: string } | null
    offices: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
    hqs: Array<{ __typename?: 'Hq'; documentId: string; name: string } | null>
    regionsServed: Array<{ __typename?: 'RegionsServed'; documentId: string; name: string } | null>
    languages: Array<{ __typename?: 'PlatformLanguage'; documentId: string; name: string } | null>
    articles?: Array<{
      __typename?: 'ComponentGlobalArticle'
      id: string
      title?: string | null
      publishedBy?: string | null
      date?: any | null
      link?: string | null
      image?: { __typename?: 'UploadFile'; url: string; id: string } | null
    } | null> | null
    features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
    existingCustomers: Array<{ __typename?: 'ExistingCustomer'; documentId: string; name: string } | null>
    announcement?: { __typename?: 'Announcement'; announcement: string; optionalLink?: string | null } | null
  } | null>
}

export type IAllSolutionSlugsQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']['input']>
  start: Scalars['Int']['input']
}>

export type IAllSolutionSlugsQuery = {
  __typename?: 'Query'
  solutions: Array<{ __typename?: 'Solution'; slug?: string | null } | null>
}

export type IAlspBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input']
  includeIlta: Scalars['Boolean']['input']
}>

export type IAlspBySlugQuery = {
  __typename?: 'Query'
  solutions: Array<{
    __typename?: 'Solution'
    productType?: IEnum_Solution_Producttype | null
    id: string
    documentId: string
    displayName?: string | null
    oldSlug?: string | null
    type: IEnum_Solution_Type
    website?: string | null
    linkedin?: string | null
    twitter?: string | null
    isPremium?: boolean | null
    slug?: string | null
    shortDescription?: string | null
    longDescription?: string | null
    isBeta?: boolean | null
    isStartup?: boolean | null
    rating?: number | null
    yearFounded?: number | null
    createdAt?: any | null
    publishedAt?: any | null
    descOtherExistingCustomer?: string | null
    descOtherIntegration?: string | null
    isDiverseLeadership?: boolean | null
    alspData?: {
      __typename?: 'ComponentSolutionAlspData'
      name?: string | null
      serviceName?: string | null
      size?: number | null
      partners?: string | null
      fundingInfo?: IEnum_Componentsolutionalspdata_Fundinginfo | null
      fundingAmount?: IEnum_Componentsolutionalspdata_Fundingamount | null
      fundingDetails?: string | null
      openToInvestment?: boolean | null
      valueProposition?: string | null
      security: Array<{ __typename?: 'Security'; documentId: string; name: string } | null>
      audiences: Array<{ __typename?: 'Demographic'; documentId: string; name: string } | null>
      enhancedListingData?: {
        __typename?: 'ComponentSolutionPropsAlspEnhanced'
        serviceDescription?: string | null
        technologyPartners?: string | null
        averageLengthOfEngagement?: number | null
        pricingData?: string | null
        callToAction?: { __typename?: 'ComponentGlobalCallToAction'; label?: string | null; url?: string | null } | null
        dedicatedResources?: Array<{
          __typename?: 'ComponentSolutionPropsDedicatedResource'
          count?: number | null
          type?: IEnum_Componentsolutionpropsdedicatedresource_Type | null
        } | null> | null
        specialists?: Array<{
          __typename?: 'ComponentAboutPropsTeamMember'
          name?: string | null
          role?: string | null
          bio?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
        } | null> | null
        screenshots?: Array<{
          __typename?: 'ComponentGlobalPicture'
          id: string
          title?: string | null
          summary?: string | null
          image?: { __typename?: 'UploadFile'; url: string; id: string } | null
        } | null> | null
        videos?: Array<{
          __typename?: 'ComponentSolutionPropsVideo'
          title?: string | null
          summary?: string | null
          url?: string | null
        } | null> | null
        caseStudies?: Array<{
          __typename?: 'ComponentGlobalSuccessStory'
          name?: string | null
          link?: string | null
        } | null> | null
        testimonials?: Array<{
          __typename?: 'ComponentTestimonialsTestimonials'
          id: string
          description?: string | null
          author?: {
            __typename?: 'ComponentTestimonialsPropsAuthor'
            name?: string | null
            role?: string | null
            company?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
          } | null
        } | null> | null
      } | null
    } | null
    consolidationData?: {
      __typename?: 'ComponentSolutionPropsConsolidation'
      date?: any | null
      amount?: number | null
      article?: string | null
      articleLink?: string | null
      originalTargetName?: string | null
      buyer?: string | null
      enableInActiveDir?: boolean | null
    } | null
    graveyardData?: { __typename?: 'ComponentSolutionPropsGraveyard'; date?: any | null } | null
    founders?: Array<{
      __typename?: 'ComponentAboutPropsTeamMember'
      name?: string | null
      role?: string | null
      bio?: string | null
      title?: string | null
      externalLink?: string | null
      avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
    } | null> | null
    vendor?: {
      __typename?: 'Vendor'
      publishedAt?: any | null
      documentId: string
      users: Array<{ __typename?: 'User'; external_id?: string | null } | null>
    } | null
    topics: Array<{ __typename?: 'Topic'; documentId: string; slug: string; name: string } | null>
    subTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      slug?: string | null
      name: string
      features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
    } | null>
    logo?: { __typename?: 'UploadFile'; id: string; url: string } | null
    company?: { __typename?: 'Company'; name: string; slug?: string | null } | null
    reviews: Array<{
      __typename?: 'Review'
      anonymous?: boolean | null
      rating?: number | null
      title?: string | null
      content?: string | null
      submitterTitle?: string | null
      submitterSubTitle?: string | null
      solutionDispName?: string | null
      createdAt?: any | null
      updatedAt?: any | null
      publishedAt?: any | null
      solution?: {
        __typename?: 'Solution'
        displayName?: string | null
        slug?: string | null
        rating?: number | null
        company?: { __typename?: 'Company'; slug?: string | null } | null
        logo?: { __typename?: 'UploadFile'; url: string } | null
      } | null
    } | null>
    offices: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
    hqs: Array<{ __typename?: 'Hq'; documentId: string; name: string } | null>
    regionsServed: Array<{ __typename?: 'RegionsServed'; documentId: string; name: string } | null>
    languages: Array<{ __typename?: 'PlatformLanguage'; documentId: string; name: string } | null>
    articles?: Array<{
      __typename?: 'ComponentGlobalArticle'
      id: string
      title?: string | null
      publishedBy?: string | null
      date?: any | null
      link?: string | null
      image?: { __typename?: 'UploadFile'; url: string; id: string } | null
    } | null> | null
    vendorResources?: Array<{
      __typename?: 'ComponentSolutionPropsVendorResource'
      type?: IEnum_Componentsolutionpropsvendorresource_Type | null
      content?: {
        __typename?: 'Content'
        documentId: string
        title: string
        snippet: string
        createdAt?: any | null
        publishedTime?: any | null
        contentType?: IEnum_Content_Contenttype | null
        documentType?: IEnum_Content_Documenttype | null
        isMaintained?: boolean | null
        lastMaintained?: any | null
        slug: string
        publishedAt?: any | null
        subjectMatterIds?: Array<string | null> | null
        themeIds?: Array<string | null> | null
        vendorTopicIds?: Array<string | null> | null
        defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
        blogTaxonomies: Array<{
          __typename?: 'BlogTaxonomy'
          documentId: string
          slug?: string | null
          name?: string | null
        } | null>
        audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
        subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
        writer?: Array<{
          __typename?: 'ComponentContentContentWriter'
          writerOption: IEnum_Componentcontentcontentwriter_Writeroption
          oneTimeAuthorName?: string | null
          author?: {
            __typename?: 'Author'
            firstName: string
            lastName: string
            jobTitle?: string | null
            company?: string | null
            bio?: string | null
            slug?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string } | null
          } | null
          expert?: {
            __typename?: 'Expert'
            documentId: string
            firstName: string
            lastName: string
            displayName?: string | null
            title?: string | null
            company?: string | null
            bio?: string | null
            slug?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string } | null
            expertiseSubTopics: Array<{
              __typename?: 'SubTopic'
              documentId: string
              name: string
              slug?: string | null
              topics: Array<{
                __typename?: 'Topic'
                documentId: string
                name: string
                description?: string | null
                slug: string
              } | null>
            } | null>
            expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
            contents: Array<{ __typename?: 'Content'; documentId: string } | null>
          } | null
          solution?: {
            __typename?: 'Solution'
            displayName?: string | null
            slug?: string | null
            type: IEnum_Solution_Type
            shortDescription?: string | null
            logo?: { __typename?: 'UploadFile'; url: string } | null
          } | null
        } | null> | null
        themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
        vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
      } | null
      external?: {
        __typename?: 'ComponentSolutionPropsVendorResourceExternal'
        title?: string | null
        summary?: string | null
        link?: string | null
        publishedDate?: any | null
        author?: string | null
        documentType?: IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype | null
      } | null
    } | null> | null
    features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
    existingCustomers: Array<{ __typename?: 'ExistingCustomer'; documentId: string; name: string } | null>
    iltaSponsorships?: Array<{
      __typename?: 'IltaSponsorship'
      documentId: string
      name?: string | null
      logo?: { __typename?: 'UploadFile'; documentId: string; url: string } | null
    } | null>
    announcement: Array<{
      __typename?: 'Announcement'
      id: string
      announcement: string
      optionalLink?: string | null
      publishedAt?: any | null
      documentId: string
      isArchived?: boolean | null
    } | null>
  } | null>
}

export type IAuthorBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input']
}>

export type IAuthorBySlugQuery = {
  __typename?: 'Query'
  authors: Array<{
    __typename?: 'Author'
    firstName: string
    lastName: string
    jobTitle?: string | null
    company?: string | null
    bio?: string | null
    linkedin?: string | null
    twitter?: string | null
    slug?: string | null
    avatar?: { __typename?: 'UploadFile'; url: string } | null
    subjectMatters: Array<{ __typename?: 'SubjectMatter'; name?: string | null; slug?: string | null } | null>
    themes: Array<{ __typename?: 'Theme'; name?: string | null; slug?: string | null } | null>
  } | null>
}

export type IAutosuggestQueryVariables = Exact<{
  keyword: Scalars['String']['input']
  accessFreeSearch?: InputMaybe<Scalars['Boolean']['input']>
  uniqueAddress?: InputMaybe<Scalars['String']['input']>
  customAccessQuery?: InputMaybe<Scalars['String']['input']>
}>

export type IAutosuggestQuery = {
  __typename?: 'Query'
  autosuggest: {
    __typename?: 'AutosuggestData'
    success: boolean
    solutions: Array<{
      __typename?: 'Suggest'
      keyword: string
      model: ISuggestModel
      id: number
      logo?: string | null
      slug: string
    }>
    events: Array<{
      __typename?: 'Suggest'
      keyword: string
      model: ISuggestModel
      id: number
      logo?: string | null
      slug: string
    }>
    categories: Array<{
      __typename?: 'Suggest'
      keyword: string
      model: ISuggestModel
      id: number
      logo?: string | null
      slug: string
    }>
    companies: Array<{
      __typename?: 'Suggest'
      keyword: string
      model: ISuggestModel
      id: number
      logo?: string | null
      slug: string
    }>
    contents: Array<{
      __typename?: 'Suggest'
      keyword: string
      model: ISuggestModel
      id: number
      logo?: string | null
      slug: string
    }>
  }
}

export type IBlogTaxonomiesQueryVariables = Exact<{ [key: string]: never }>

export type IBlogTaxonomiesQuery = {
  __typename?: 'Query'
  blogTaxonomys: Array<{
    __typename?: 'BlogTaxonomy'
    name?: string | null
    slug?: string | null
    description?: string | null
  } | null>
}

export type IBlogTaxonomyBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input']
}>

export type IBlogTaxonomyBySlugQuery = {
  __typename?: 'Query'
  blogTaxonomys: Array<{
    __typename?: 'BlogTaxonomy'
    documentId: string
    name?: string | null
    slug?: string | null
    description?: string | null
    publishedAt?: any | null
    showVendorTopics?: boolean | null
    latestContent?: {
      __typename?: 'Content'
      documentId: string
      title: string
      snippet: string
      createdAt?: any | null
      publishedTime?: any | null
      contentType?: IEnum_Content_Contenttype | null
      documentType?: IEnum_Content_Documenttype | null
      isMaintained?: boolean | null
      lastMaintained?: any | null
      slug: string
      publishedAt?: any | null
      subjectMatterIds?: Array<string | null> | null
      themeIds?: Array<string | null> | null
      vendorTopicIds?: Array<string | null> | null
      defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
      blogTaxonomies: Array<{
        __typename?: 'BlogTaxonomy'
        documentId: string
        slug?: string | null
        name?: string | null
      } | null>
      audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
      subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
      writer?: Array<{
        __typename?: 'ComponentContentContentWriter'
        writerOption: IEnum_Componentcontentcontentwriter_Writeroption
        oneTimeAuthorName?: string | null
        author?: {
          __typename?: 'Author'
          firstName: string
          lastName: string
          jobTitle?: string | null
          company?: string | null
          bio?: string | null
          slug?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
        } | null
        expert?: {
          __typename?: 'Expert'
          documentId: string
          firstName: string
          lastName: string
          displayName?: string | null
          title?: string | null
          company?: string | null
          bio?: string | null
          slug?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
          expertiseSubTopics: Array<{
            __typename?: 'SubTopic'
            documentId: string
            name: string
            slug?: string | null
            topics: Array<{
              __typename?: 'Topic'
              documentId: string
              name: string
              description?: string | null
              slug: string
            } | null>
          } | null>
          expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
          contents: Array<{ __typename?: 'Content'; documentId: string } | null>
        } | null
        solution?: {
          __typename?: 'Solution'
          displayName?: string | null
          slug?: string | null
          type: IEnum_Solution_Type
          shortDescription?: string | null
          logo?: { __typename?: 'UploadFile'; url: string } | null
        } | null
      } | null> | null
      themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
      vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
    } | null
  } | null>
}

export type ICarouselSolutionsBySubTopicSlugQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']['input']>
}>

export type ICarouselSolutionsBySubTopicSlugQuery = {
  __typename?: 'Query'
  searchSolutions: {
    __typename?: 'SearchSolutionsResultType'
    total?: number | null
    solutions?: Array<{
      __typename?: 'SolutionItem'
      id?: number | null
      slug: string
      displayName: string
      logo?: string | null
      subTopics: Array<string>
      isPremium?: boolean | null
    } | null> | null
  }
}

export type IChangeMyPasswordMutationVariables = Exact<{
  input: IChangePasswordRequest
}>

export type IChangeMyPasswordMutation = {
  __typename?: 'Mutation'
  changeMyPassword?: {
    __typename?: 'ChangePasswordPayload'
    jwt?: string | null
    user: { __typename?: 'UsersPermissionsMe'; id: string; username: string; email?: string | null }
  } | null
}

export type ICheckFreeSearchQueryVariables = Exact<{
  accessFreeSearch?: InputMaybe<Scalars['Boolean']['input']>
  uniqueAddress?: InputMaybe<Scalars['String']['input']>
  customAccessQuery?: InputMaybe<Scalars['String']['input']>
}>

export type ICheckFreeSearchQuery = {
  __typename?: 'Query'
  checkFreeSearch?: {
    __typename?: 'CheckFreeSearchResultType'
    isFreeSearch?: boolean | null
    isFreeSearchLeft?: number | null
  } | null
}

export type IClaimVendorListingMutationVariables = Exact<{
  data?: InputMaybe<IClaimVendorListingInput>
}>

export type IClaimVendorListingMutation = {
  __typename?: 'Mutation'
  claimVendorListing?: {
    __typename?: 'vendorSatus'
    data?: { __typename?: 'statusResponse'; status?: boolean | null } | null
  } | null
}

export type IConsultancyBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input']
  includeIlta: Scalars['Boolean']['input']
}>

export type IConsultancyBySlugQuery = {
  __typename?: 'Query'
  solutions: Array<{
    __typename?: 'Solution'
    productType?: IEnum_Solution_Producttype | null
    id: string
    documentId: string
    displayName?: string | null
    oldSlug?: string | null
    type: IEnum_Solution_Type
    website?: string | null
    linkedin?: string | null
    twitter?: string | null
    isPremium?: boolean | null
    slug?: string | null
    shortDescription?: string | null
    longDescription?: string | null
    isBeta?: boolean | null
    isStartup?: boolean | null
    rating?: number | null
    yearFounded?: number | null
    createdAt?: any | null
    publishedAt?: any | null
    descOtherExistingCustomer?: string | null
    descOtherIntegration?: string | null
    isDiverseLeadership?: boolean | null
    consultantData?: {
      __typename?: 'ComponentSolutionConsultantData'
      name?: string | null
      serviceName?: string | null
      size?: number | null
      partners?: string | null
      fundingInfo?: IEnum_Componentsolutionconsultantdata_Fundinginfo | null
      fundingAmount?: IEnum_Componentsolutionconsultantdata_Fundingamount | null
      fundingDetails?: string | null
      openToInvestment?: boolean | null
      valueProposition?: string | null
      security: Array<{ __typename?: 'Security'; documentId: string; name: string } | null>
      audiences: Array<{ __typename?: 'Demographic'; documentId: string; name: string } | null>
      integrations: Array<{ __typename?: 'Integration'; documentId: string; name: string } | null>
      practiceAreas: Array<{ __typename?: 'PracticeArea'; documentId: string; name: string } | null>
      typeOfUser: Array<{ __typename?: 'TypeOfUser'; documentId: string; name?: string | null } | null>
      enhancedListingData?: {
        __typename?: 'ComponentSolutionPropsConsultantEnhanced'
        serviceDescription?: string | null
        technologyPartners?: string | null
        averageLengthOfEngagement?: number | null
        pricingData?: string | null
        callToAction?: { __typename?: 'ComponentGlobalCallToAction'; label?: string | null; url?: string | null } | null
        dedicatedResources?: Array<{
          __typename?: 'ComponentSolutionPropsDedicatedResource'
          count?: number | null
          type?: IEnum_Componentsolutionpropsdedicatedresource_Type | null
        } | null> | null
        caseStudies?: Array<{
          __typename?: 'ComponentGlobalSuccessStory'
          name?: string | null
          link?: string | null
        } | null> | null
        specialists?: Array<{
          __typename?: 'ComponentAboutPropsTeamMember'
          name?: string | null
          role?: string | null
          bio?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
        } | null> | null
        screenshots?: Array<{
          __typename?: 'ComponentGlobalPicture'
          id: string
          title?: string | null
          summary?: string | null
          image?: { __typename?: 'UploadFile'; url: string; id: string } | null
        } | null> | null
        videos?: Array<{
          __typename?: 'ComponentSolutionPropsVideo'
          title?: string | null
          summary?: string | null
          url?: string | null
        } | null> | null
        testimonials?: Array<{
          __typename?: 'ComponentTestimonialsTestimonials'
          id: string
          description?: string | null
          author?: {
            __typename?: 'ComponentTestimonialsPropsAuthor'
            name?: string | null
            role?: string | null
            company?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
          } | null
        } | null> | null
      } | null
    } | null
    consolidationData?: {
      __typename?: 'ComponentSolutionPropsConsolidation'
      date?: any | null
      amount?: number | null
      article?: string | null
      articleLink?: string | null
      originalTargetName?: string | null
      buyer?: string | null
      enableInActiveDir?: boolean | null
    } | null
    graveyardData?: { __typename?: 'ComponentSolutionPropsGraveyard'; date?: any | null } | null
    founders?: Array<{
      __typename?: 'ComponentAboutPropsTeamMember'
      name?: string | null
      role?: string | null
      bio?: string | null
      title?: string | null
      externalLink?: string | null
      avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
    } | null> | null
    vendor?: {
      __typename?: 'Vendor'
      publishedAt?: any | null
      documentId: string
      users: Array<{ __typename?: 'User'; external_id?: string | null } | null>
    } | null
    topics: Array<{ __typename?: 'Topic'; documentId: string; slug: string; name: string } | null>
    subTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      slug?: string | null
      name: string
      features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
    } | null>
    logo?: { __typename?: 'UploadFile'; id: string; url: string } | null
    company?: { __typename?: 'Company'; name: string; slug?: string | null } | null
    reviews: Array<{
      __typename?: 'Review'
      anonymous?: boolean | null
      rating?: number | null
      title?: string | null
      content?: string | null
      submitterTitle?: string | null
      submitterSubTitle?: string | null
      solutionDispName?: string | null
      createdAt?: any | null
      updatedAt?: any | null
      publishedAt?: any | null
      solution?: {
        __typename?: 'Solution'
        displayName?: string | null
        slug?: string | null
        rating?: number | null
        company?: { __typename?: 'Company'; slug?: string | null } | null
        logo?: { __typename?: 'UploadFile'; url: string } | null
      } | null
    } | null>
    offices: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
    hqs: Array<{ __typename?: 'Hq'; documentId: string; name: string } | null>
    regionsServed: Array<{ __typename?: 'RegionsServed'; documentId: string; name: string } | null>
    languages: Array<{ __typename?: 'PlatformLanguage'; documentId: string; name: string } | null>
    articles?: Array<{
      __typename?: 'ComponentGlobalArticle'
      id: string
      title?: string | null
      publishedBy?: string | null
      date?: any | null
      link?: string | null
      image?: { __typename?: 'UploadFile'; url: string; id: string } | null
    } | null> | null
    vendorResources?: Array<{
      __typename?: 'ComponentSolutionPropsVendorResource'
      type?: IEnum_Componentsolutionpropsvendorresource_Type | null
      content?: {
        __typename?: 'Content'
        documentId: string
        title: string
        snippet: string
        createdAt?: any | null
        publishedTime?: any | null
        contentType?: IEnum_Content_Contenttype | null
        documentType?: IEnum_Content_Documenttype | null
        isMaintained?: boolean | null
        lastMaintained?: any | null
        slug: string
        publishedAt?: any | null
        subjectMatterIds?: Array<string | null> | null
        themeIds?: Array<string | null> | null
        vendorTopicIds?: Array<string | null> | null
        defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
        blogTaxonomies: Array<{
          __typename?: 'BlogTaxonomy'
          documentId: string
          slug?: string | null
          name?: string | null
        } | null>
        audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
        subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
        writer?: Array<{
          __typename?: 'ComponentContentContentWriter'
          writerOption: IEnum_Componentcontentcontentwriter_Writeroption
          oneTimeAuthorName?: string | null
          author?: {
            __typename?: 'Author'
            firstName: string
            lastName: string
            jobTitle?: string | null
            company?: string | null
            bio?: string | null
            slug?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string } | null
          } | null
          expert?: {
            __typename?: 'Expert'
            documentId: string
            firstName: string
            lastName: string
            displayName?: string | null
            title?: string | null
            company?: string | null
            bio?: string | null
            slug?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string } | null
            expertiseSubTopics: Array<{
              __typename?: 'SubTopic'
              documentId: string
              name: string
              slug?: string | null
              topics: Array<{
                __typename?: 'Topic'
                documentId: string
                name: string
                description?: string | null
                slug: string
              } | null>
            } | null>
            expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
            contents: Array<{ __typename?: 'Content'; documentId: string } | null>
          } | null
          solution?: {
            __typename?: 'Solution'
            displayName?: string | null
            slug?: string | null
            type: IEnum_Solution_Type
            shortDescription?: string | null
            logo?: { __typename?: 'UploadFile'; url: string } | null
          } | null
        } | null> | null
        themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
        vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
      } | null
      external?: {
        __typename?: 'ComponentSolutionPropsVendorResourceExternal'
        title?: string | null
        summary?: string | null
        link?: string | null
        publishedDate?: any | null
        author?: string | null
        documentType?: IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype | null
      } | null
    } | null> | null
    features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
    existingCustomers: Array<{ __typename?: 'ExistingCustomer'; documentId: string; name: string } | null>
    iltaSponsorships?: Array<{
      __typename?: 'IltaSponsorship'
      documentId: string
      name?: string | null
      logo?: { __typename?: 'UploadFile'; documentId: string; url: string } | null
    } | null>
    announcement: Array<{
      __typename?: 'Announcement'
      id: string
      announcement: string
      optionalLink?: string | null
      publishedAt?: any | null
      documentId: string
      isArchived?: boolean | null
    } | null>
  } | null>
}

export type IContentBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input']
  accessFreeArticle?: InputMaybe<Scalars['Boolean']['input']>
  uniqueAddress?: InputMaybe<Scalars['String']['input']>
}>

export type IContentBySlugQuery = {
  __typename?: 'Query'
  contentBySlug?: {
    __typename: 'ContentEntityBySlug'
    isInvited?: boolean | null
    resourcePublishedAt?: string | null
    vendorSelfContent?: boolean | null
    isUserVendor?: boolean | null
    includeInKnowHow?: boolean | null
    includeInLegalTechForLawyers?: boolean | null
    includeInVendorContents?: boolean | null
    isFreeArticle?: boolean | null
    freeArticleLeft?: number | null
    content: {
      __typename: 'ContentEntity'
      id?: string | null
      attributes?: {
        __typename: 'Content'
        documentId: string
        title: string
        publishedAt?: any | null
        createdAt?: any | null
        publishedTime?: any | null
        lastMaintained?: any | null
        isMaintained?: boolean | null
        contentType?: IEnum_Content_Contenttype | null
        slug: string
        snippet: string
        isPremium?: boolean | null
        isLatestBlog?: boolean | null
        defaultImage: Array<{ __typename: 'UploadFile'; url: string } | null>
        blogTaxonomies: Array<{ __typename: 'BlogTaxonomy'; name?: string | null; slug?: string | null } | null>
        subjectMatters: Array<{ __typename: 'SubjectMatter'; name?: string | null; slug?: string | null } | null>
        downloadMaterial?: {
          __typename: 'ComponentContentDownloadMaterial'
          title?: string | null
          isEnabled?: boolean | null
          format?: IEnum_Componentcontentdownloadmaterial_Format | null
          lastUpdated?: any | null
          downloadButtonName?: string | null
          files?: { __typename?: 'UploadFile'; name: string } | null
        } | null
        writer?: Array<{
          __typename: 'ComponentContentContentWriter'
          writerOption: IEnum_Componentcontentcontentwriter_Writeroption
          oneTimeAuthorName?: string | null
          author?: {
            __typename?: 'Author'
            firstName: string
            lastName: string
            jobTitle?: string | null
            company?: string | null
            bio?: string | null
            slug?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string } | null
          } | null
          expert?: {
            __typename?: 'Expert'
            documentId: string
            firstName: string
            lastName: string
            displayName?: string | null
            title?: string | null
            company?: string | null
            bio?: string | null
            slug?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string } | null
            expertiseSubTopics: Array<{
              __typename?: 'SubTopic'
              documentId: string
              name: string
              slug?: string | null
              topics: Array<{
                __typename?: 'Topic'
                documentId: string
                name: string
                description?: string | null
                slug: string
              } | null>
            } | null>
            expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
            contents: Array<{ __typename?: 'Content'; documentId: string } | null>
          } | null
          solution?: {
            __typename?: 'Solution'
            displayName?: string | null
            slug?: string | null
            type: IEnum_Solution_Type
            shortDescription?: string | null
            logo?: { __typename?: 'UploadFile'; url: string } | null
          } | null
        } | null> | null
      } | null
    }
  } | null
}

export type IContentVisitDownloadsQueryVariables = Exact<{ [key: string]: never }>

export type IContentVisitDownloadsQuery = {
  __typename?: 'Query'
  contentVisitDownloads: Array<{
    __typename?: 'SharedResourceEntity'
    title?: string | null
    slug?: string | null
    sharedResources: {
      __typename?: 'ContentVisitDownloadCountResult'
      visits?: Array<{
        __typename?: 'ContentVisit'
        visited_by?: { __typename?: 'User'; documentId: string; username: string } | null
      } | null> | null
      downloads?: Array<{
        __typename?: 'ContentDownload'
        downloaded_by?: { __typename?: 'User'; documentId: string; username: string } | null
      } | null> | null
    }
  }>
}

export type ICreateAnnouncementMutationVariables = Exact<{
  data: IAnnouncementInput
}>

export type ICreateAnnouncementMutation = {
  __typename?: 'Mutation'
  createAnnouncement?: {
    __typename?: 'Announcement'
    documentId: string
    announcement: string
    optionalLink?: string | null
    createdAt?: any | null
  } | null
}

export type ICreatePortfolioTagMutationVariables = Exact<{
  name: Scalars['String']['input']
}>

export type ICreatePortfolioTagMutation = {
  __typename?: 'Mutation'
  createPortfolioTag?: {
    __typename?: 'CustomTagResult'
    id: string
    name: string
    slug?: string | null
    solutionIds?: Array<string | null> | null
    solutionDocumentIds?: Array<string | null> | null
  } | null
}

export type ICreateListingAlspMutationVariables = Exact<{
  data: IListingRequestData
}>

export type ICreateListingAlspMutation = {
  __typename?: 'Mutation'
  createListingRequestData?: {
    __typename?: 'ListingRequest'
    alspReq?: {
      __typename?: 'ComponentRequestListingReq'
      id: string
      listingName?: string | null
      userName?: string | null
      userRole?: string | null
      userEmail?: string | null
      phone?: string | null
      marketName?: string | null
      marketEmail?: string | null
      ceoName?: string | null
      ceoEmail?: string | null
      shortDescription?: string | null
      longDescription?: string | null
    } | null
    enhancedAlspReq?: {
      __typename?: 'ComponentRequestEnhancedListReq'
      founders?: Array<{ __typename?: 'ComponentAboutPropsTeamMember'; id: string } | null> | null
      specialists?: Array<{ __typename?: 'ComponentAboutPropsTeamMember'; id: string } | null> | null
      screenShots?: Array<{ __typename?: 'ComponentGlobalPicture'; id: string } | null> | null
      testimonials?: Array<{ __typename?: 'ComponentGlobalTestimonial'; id: string } | null> | null
    } | null
  } | null
}

export type ICreateListingConsultantMutationVariables = Exact<{
  data: IListingRequestData
}>

export type ICreateListingConsultantMutation = {
  __typename?: 'Mutation'
  createListingRequestData?: {
    __typename?: 'ListingRequest'
    consultantReq?: {
      __typename?: 'ComponentRequestListingReq'
      id: string
      listingName?: string | null
      userName?: string | null
      userRole?: string | null
      userEmail?: string | null
      phone?: string | null
      marketName?: string | null
      marketEmail?: string | null
      ceoName?: string | null
      ceoEmail?: string | null
      shortDescription?: string | null
      longDescription?: string | null
    } | null
    enhancedConsultantReq?: {
      __typename?: 'ComponentRequestEnhancedListReq'
      founders?: Array<{ __typename?: 'ComponentAboutPropsTeamMember'; id: string } | null> | null
      specialists?: Array<{ __typename?: 'ComponentAboutPropsTeamMember'; id: string } | null> | null
      screenShots?: Array<{ __typename?: 'ComponentGlobalPicture'; id: string } | null> | null
      testimonials?: Array<{ __typename?: 'ComponentGlobalTestimonial'; id: string } | null> | null
    } | null
  } | null
}

export type ICreateListingProductMutationVariables = Exact<{
  data: IListingRequestData
}>

export type ICreateListingProductMutation = {
  __typename?: 'Mutation'
  createListingRequestData?: {
    __typename?: 'ListingRequest'
    vendorReq?: {
      __typename?: 'ComponentRequestVendorReq'
      id: string
      companyName?: string | null
      email?: string | null
      name?: string | null
      ceoEmail?: string | null
      ceoName?: string | null
      marketEmail?: string | null
      marketName?: string | null
      website?: string | null
      productName?: string | null
      shortDescription?: string | null
      longDescription?: string | null
      isCreate?: boolean | null
      notes?: string | null
    } | null
    enhancedVendorReq?: {
      __typename?: 'ComponentRequestEnhancedVendorReq'
      screenShots?: Array<{ __typename?: 'ComponentGlobalPicture'; id: string } | null> | null
      testimonials?: Array<{ __typename?: 'ComponentGlobalTestimonial'; id: string } | null> | null
    } | null
  } | null
}

export type ICreateSharedPortfolioWithMembersMutationVariables = Exact<{
  name: Scalars['String']['input']
  members?: InputMaybe<Array<ISharedPortfolioMemberInput> | ISharedPortfolioMemberInput>
}>

export type ICreateSharedPortfolioWithMembersMutation = {
  __typename?: 'Mutation'
  createSharedPortfolioWithMembers?: {
    __typename?: 'SharedPortfolioEntity'
    id?: string | null
    attributes?: {
      __typename?: 'SharedPortfolio'
      documentId: string
      name: string
      slug?: string | null
      isSharedPortfolio?: boolean | null
      premium_organizations: Array<{ __typename?: 'PremiumOrganization'; documentId: string; name: string } | null>
      shared_portfolio_memberships: Array<{
        __typename?: 'SharedPortfolioMembership'
        documentId: string
        role: IEnum_Sharedportfoliomembership_Role
        isActive?: boolean | null
        user?: { __typename?: 'User'; documentId: string; username: string; email: string } | null
      } | null>
    } | null
  } | null
}

export type ICreateSolutionRequestMutationVariables = Exact<{
  data: ISolutionRequestInput
  status?: InputMaybe<IPublicationStatus>
}>

export type ICreateSolutionRequestMutation = {
  __typename?: 'Mutation'
  createSolutionRequest?: { __typename?: 'SolutionRequest'; id: string; documentId: string } | null
}

export type IDeleteAnnouncementMutationVariables = Exact<{
  documentId: Scalars['ID']['input']
}>

export type IDeleteAnnouncementMutation = {
  __typename?: 'Mutation'
  deleteAnnouncement?: { __typename?: 'DeleteMutationResponse'; documentId: string } | null
}

export type IDeletePortfolioTagMutationVariables = Exact<{
  tagDocumentId: Scalars['ID']['input']
}>

export type IDeletePortfolioTagMutation = { __typename?: 'Mutation'; deletePortfolioTag?: boolean | null }

export type IDeleteSharedPortfolioMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type IDeleteSharedPortfolioMutation = { __typename?: 'Mutation'; deleteSharedPortfolio: boolean }

export type IContentTeaserBySolutionFragment = {
  __typename: 'Content'
  documentId: string
  slug: string
  snippet: string
}

export type IDocumentTypeBySolutionIdQueryVariables = Exact<{
  solutionId: Scalars['ID']['input']
  documentType: Scalars['String']['input']
}>

export type IDocumentTypeBySolutionIdQuery = {
  __typename?: 'Query'
  contents: Array<{ __typename: 'Content'; documentId: string; slug: string; snippet: string } | null>
}

export type IDownloadContentMutationVariables = Exact<{
  content_id: Scalars['ID']['input']
}>

export type IDownloadContentMutation = { __typename?: 'Mutation'; downloadContent?: boolean | null }

export type IDownloadMaterialFilesQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type IDownloadMaterialFilesQuery = {
  __typename?: 'Query'
  downloadMaterialFile: { __typename?: 'downloadMaterialFileEntity'; url?: string | null }
}

export type IEditPortfolioTagMutationVariables = Exact<{
  tagDocumentId: Scalars['ID']['input']
  name: Scalars['String']['input']
  sharedPortfolioId?: InputMaybe<Scalars['ID']['input']>
}>

export type IEditPortfolioTagMutation = {
  __typename?: 'Mutation'
  editPortfolioTag?: {
    __typename?: 'CustomTagResult'
    id: string
    name: string
    slug?: string | null
    solutionIds?: Array<string | null> | null
    solutionDocumentIds?: Array<string | null> | null
  } | null
}

export type IEmailReceiversQueryVariables = Exact<{
  filters?: InputMaybe<IEmailReceiverFiltersInput>
  pagination?: InputMaybe<IPaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>
}>

export type IEmailReceiversQuery = {
  __typename?: 'Query'
  emailReceivers: Array<{
    __typename?: 'EmailReceiver'
    documentId: string
    email?: string | null
    enable?: boolean | null
  } | null>
}

export type IEventFeaturesQueryVariables = Exact<{ [key: string]: never }>

export type IEventFeaturesQuery = {
  __typename?: 'Query'
  eventFeatures: Array<{ __typename?: 'EventFeature'; documentId: string; name: string } | null>
}

export type IExpertBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input']
}>

export type IExpertBySlugQuery = {
  __typename?: 'Query'
  experts: Array<{
    __typename?: 'Expert'
    documentId: string
    firstName: string
    lastName: string
    title?: string | null
    bio?: string | null
    linkedin?: string | null
    twitter?: string | null
    slug?: string | null
    experience?: string | null
    avatar?: { __typename?: 'UploadFile'; url: string } | null
    expertiseSubTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      name: string
      slug?: string | null
      topics: Array<{
        __typename?: 'Topic'
        documentId: string
        name: string
        description?: string | null
        slug: string
      } | null>
    } | null>
    expertiseTopics: Array<{ __typename?: 'Topic'; documentId: string; name: string; slug: string } | null>
    secondaryExpertiseSubTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      name: string
      slug?: string | null
      topics: Array<{
        __typename?: 'Topic'
        documentId: string
        name: string
        description?: string | null
        slug: string
      } | null>
    } | null>
    secondaryExpertiseTopics: Array<{ __typename?: 'Topic'; documentId: string; name: string; slug: string } | null>
    contents: Array<{ __typename?: 'Content'; documentId: string } | null>
  } | null>
}

export type IExpertsQueryVariables = Exact<{ [key: string]: never }>

export type IExpertsQuery = {
  __typename?: 'Query'
  experts: Array<{
    __typename?: 'Expert'
    documentId: string
    firstName: string
    lastName: string
    displayName?: string | null
    title?: string | null
    company?: string | null
    bio?: string | null
    slug?: string | null
    avatar?: { __typename?: 'UploadFile'; url: string } | null
    expertiseSubTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      name: string
      slug?: string | null
      topics: Array<{
        __typename?: 'Topic'
        documentId: string
        name: string
        description?: string | null
        slug: string
      } | null>
    } | null>
    expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
    contents: Array<{ __typename?: 'Content'; documentId: string } | null>
  } | null>
}

export type IFeaturedContentsBySubTopicSlugQueryVariables = Exact<{
  contentType: IEnum_Content_Contenttype
  subTopicSlug: Scalars['String']['input']
  start: Scalars['Int']['input']
  limit: Scalars['Int']['input']
}>

export type IFeaturedContentsBySubTopicSlugQuery = {
  __typename?: 'Query'
  featuredContents: Array<{
    __typename?: 'ContentEntity'
    id?: string | null
    attributes?: {
      __typename?: 'Content'
      documentId: string
      title: string
      snippet: string
      createdAt?: any | null
      publishedTime?: any | null
      contentType?: IEnum_Content_Contenttype | null
      documentType?: IEnum_Content_Documenttype | null
      isMaintained?: boolean | null
      lastMaintained?: any | null
      slug: string
      publishedAt?: any | null
      subjectMatterIds?: Array<string | null> | null
      themeIds?: Array<string | null> | null
      vendorTopicIds?: Array<string | null> | null
      defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
      blogTaxonomies: Array<{
        __typename?: 'BlogTaxonomy'
        documentId: string
        slug?: string | null
        name?: string | null
      } | null>
      audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
      subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
      writer?: Array<{
        __typename?: 'ComponentContentContentWriter'
        writerOption: IEnum_Componentcontentcontentwriter_Writeroption
        oneTimeAuthorName?: string | null
        author?: {
          __typename?: 'Author'
          firstName: string
          lastName: string
          jobTitle?: string | null
          company?: string | null
          bio?: string | null
          slug?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
        } | null
        expert?: {
          __typename?: 'Expert'
          documentId: string
          firstName: string
          lastName: string
          displayName?: string | null
          title?: string | null
          company?: string | null
          bio?: string | null
          slug?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
          expertiseSubTopics: Array<{
            __typename?: 'SubTopic'
            documentId: string
            name: string
            slug?: string | null
            topics: Array<{
              __typename?: 'Topic'
              documentId: string
              name: string
              description?: string | null
              slug: string
            } | null>
          } | null>
          expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
          contents: Array<{ __typename?: 'Content'; documentId: string } | null>
        } | null
        solution?: {
          __typename?: 'Solution'
          displayName?: string | null
          slug?: string | null
          type: IEnum_Solution_Type
          shortDescription?: string | null
          logo?: { __typename?: 'UploadFile'; url: string } | null
        } | null
      } | null> | null
      themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
      vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
    } | null
  }>
}

export type IFindAnnouncementBySolutionIdQueryVariables = Exact<{
  solutionDocumentId: Scalars['ID']['input']
  status?: InputMaybe<IPublicationStatus>
}>

export type IFindAnnouncementBySolutionIdQuery = {
  __typename?: 'Query'
  announcements: Array<{
    __typename?: 'Announcement'
    documentId: string
    announcement: string
    optionalLink?: string | null
    publishedAt?: any | null
  } | null>
}

export type IFindArchivedAnnouncementBySolutionIdQueryVariables = Exact<{
  solutionDocumentId?: InputMaybe<Scalars['ID']['input']>
}>

export type IFindArchivedAnnouncementBySolutionIdQuery = {
  __typename?: 'Query'
  announcements: Array<{
    __typename?: 'Announcement'
    documentId: string
    announcement: string
    optionalLink?: string | null
    publishedAt?: any | null
    isArchived?: boolean | null
    previous_published_at?: any | null
    archived_at?: any | null
  } | null>
}

export type IFollowSharedPortfolioSolutionMutationVariables = Exact<{
  portfolioSlug: Scalars['String']['input']
  solutionId: Scalars['ID']['input']
  followingSolutionNote?: InputMaybe<Scalars['String']['input']>
  categoryType?: InputMaybe<Scalars['String']['input']>
  updateType: Scalars['String']['input']
  follow: Scalars['Boolean']['input']
}>

export type IFollowSharedPortfolioSolutionMutation = {
  __typename?: 'Mutation'
  followSharedPortfolioSolution?: boolean | null
}

export type IFollowSolutionMutationVariables = Exact<{
  id: Scalars['String']['input']
  follow?: InputMaybe<Scalars['Boolean']['input']>
  followType?: InputMaybe<Scalars['String']['input']>
  followingSolutionNote?: InputMaybe<Scalars['String']['input']>
}>

export type IFollowSolutionMutation = { __typename?: 'Mutation'; followSolution?: boolean | null }

export type IFollowSubtopicMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>
  follow?: InputMaybe<Scalars['Boolean']['input']>
}>

export type IFollowSubtopicMutation = { __typename?: 'Mutation'; followSubtopic?: boolean | null }

export type IAllContentsSlugItemFragment = { __typename?: 'Content'; documentId: string; slug: string }

export type IAllFeaturesQueryVariables = Exact<{ [key: string]: never }>

export type IAllFeaturesQuery = {
  __typename?: 'Query'
  features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
}

export type IAllSolutionsSlugItemFragment = { __typename?: 'Solution'; slug?: string | null }

export type IAuthorCardDataFragment = {
  __typename?: 'Author'
  firstName: string
  lastName: string
  jobTitle?: string | null
  company?: string | null
  bio?: string | null
  slug?: string | null
  avatar?: { __typename?: 'UploadFile'; url: string } | null
}

export type IAuthorFullItemFragment = {
  __typename?: 'Author'
  firstName: string
  lastName: string
  jobTitle?: string | null
  company?: string | null
  bio?: string | null
  linkedin?: string | null
  twitter?: string | null
  slug?: string | null
  avatar?: { __typename?: 'UploadFile'; url: string } | null
  subjectMatters: Array<{ __typename?: 'SubjectMatter'; name?: string | null; slug?: string | null } | null>
  themes: Array<{ __typename?: 'Theme'; name?: string | null; slug?: string | null } | null>
}

export type IAuthorItemFragment = {
  __typename?: 'Author'
  documentId: string
  firstName: string
  lastName: string
  displayName?: string | null
  jobTitle?: string | null
  company?: string | null
  slug?: string | null
  avatar?: { __typename?: 'UploadFile'; url: string } | null
}

export type IAutosuggestItemFragment = {
  __typename?: 'Suggest'
  keyword: string
  model: ISuggestModel
  id: number
  logo?: string | null
  slug: string
}

export type IBlogTaxonomyDataFragment = {
  __typename?: 'BlogTaxonomy'
  name?: string | null
  slug?: string | null
  description?: string | null
}

export type IBlogTaxonomyFullDataFragment = {
  __typename?: 'BlogTaxonomy'
  documentId: string
  name?: string | null
  slug?: string | null
  description?: string | null
  publishedAt?: any | null
  showVendorTopics?: boolean | null
  latestContent?: {
    __typename?: 'Content'
    documentId: string
    title: string
    snippet: string
    createdAt?: any | null
    publishedTime?: any | null
    contentType?: IEnum_Content_Contenttype | null
    documentType?: IEnum_Content_Documenttype | null
    isMaintained?: boolean | null
    lastMaintained?: any | null
    slug: string
    publishedAt?: any | null
    subjectMatterIds?: Array<string | null> | null
    themeIds?: Array<string | null> | null
    vendorTopicIds?: Array<string | null> | null
    defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
    blogTaxonomies: Array<{
      __typename?: 'BlogTaxonomy'
      documentId: string
      slug?: string | null
      name?: string | null
    } | null>
    audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
    subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
    writer?: Array<{
      __typename?: 'ComponentContentContentWriter'
      writerOption: IEnum_Componentcontentcontentwriter_Writeroption
      oneTimeAuthorName?: string | null
      author?: {
        __typename?: 'Author'
        firstName: string
        lastName: string
        jobTitle?: string | null
        company?: string | null
        bio?: string | null
        slug?: string | null
        avatar?: { __typename?: 'UploadFile'; url: string } | null
      } | null
      expert?: {
        __typename?: 'Expert'
        documentId: string
        firstName: string
        lastName: string
        displayName?: string | null
        title?: string | null
        company?: string | null
        bio?: string | null
        slug?: string | null
        avatar?: { __typename?: 'UploadFile'; url: string } | null
        expertiseSubTopics: Array<{
          __typename?: 'SubTopic'
          documentId: string
          name: string
          slug?: string | null
          topics: Array<{
            __typename?: 'Topic'
            documentId: string
            name: string
            description?: string | null
            slug: string
          } | null>
        } | null>
        expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
        contents: Array<{ __typename?: 'Content'; documentId: string } | null>
      } | null
      solution?: {
        __typename?: 'Solution'
        displayName?: string | null
        slug?: string | null
        type: IEnum_Solution_Type
        shortDescription?: string | null
        logo?: { __typename?: 'UploadFile'; url: string } | null
      } | null
    } | null> | null
    themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
    vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
  } | null
}

export type ICompanyDataFragment = {
  __typename?: 'Company'
  documentId: string
  slug?: string | null
  name: string
  description: string
  website: string
  services?: string | null
  yearFounded?: any | null
  size?: number | null
  openToInvestment?: boolean | null
  linkedin?: string | null
  twitter?: string | null
  fundingInfo?: IEnum_Company_Fundinginfo | null
  fundingAmount?: IEnum_Company_Fundingamount | null
  fundingDetails?: string | null
  isDiverseLeadership?: boolean | null
  logo?: { __typename?: 'UploadFile'; url: string } | null
  solutions: Array<{ __typename?: 'Solution'; slug?: string | null } | null>
  regionsServed: Array<{ __typename?: 'RegionsServed'; name: string } | null>
  hqs: Array<{ __typename?: 'Hq'; name: string } | null>
  iltaSponsorships?: Array<{
    __typename?: 'IltaSponsorship'
    name?: string | null
    logo?: { __typename?: 'UploadFile'; documentId: string; url: string } | null
  } | null>
  founders?: Array<{
    __typename?: 'ComponentCompanyCompanyFounder'
    id: string
    name?: string | null
    role?: string | null
    experiencedFounder?: boolean | null
    bio?: string | null
    title?: string | null
    externalLink?: string | null
    avatar?: { __typename?: 'UploadFile'; id: string; url: string } | null
  } | null> | null
}

export type IContentDataFragment = {
  __typename: 'Content'
  documentId: string
  title: string
  publishedAt?: any | null
  createdAt?: any | null
  publishedTime?: any | null
  lastMaintained?: any | null
  isMaintained?: boolean | null
  contentType?: IEnum_Content_Contenttype | null
  slug: string
  snippet: string
  isPremium?: boolean | null
  isLatestBlog?: boolean | null
  defaultImage: Array<{ __typename: 'UploadFile'; url: string } | null>
  blogTaxonomies: Array<{ __typename: 'BlogTaxonomy'; name?: string | null; slug?: string | null } | null>
  subjectMatters: Array<{ __typename: 'SubjectMatter'; name?: string | null; slug?: string | null } | null>
  downloadMaterial?: {
    __typename: 'ComponentContentDownloadMaterial'
    title?: string | null
    isEnabled?: boolean | null
    format?: IEnum_Componentcontentdownloadmaterial_Format | null
    lastUpdated?: any | null
    downloadButtonName?: string | null
    files?: { __typename?: 'UploadFile'; name: string } | null
  } | null
  writer?: Array<{
    __typename: 'ComponentContentContentWriter'
    writerOption: IEnum_Componentcontentcontentwriter_Writeroption
    oneTimeAuthorName?: string | null
    author?: {
      __typename?: 'Author'
      firstName: string
      lastName: string
      jobTitle?: string | null
      company?: string | null
      bio?: string | null
      slug?: string | null
      avatar?: { __typename?: 'UploadFile'; url: string } | null
    } | null
    expert?: {
      __typename?: 'Expert'
      documentId: string
      firstName: string
      lastName: string
      displayName?: string | null
      title?: string | null
      company?: string | null
      bio?: string | null
      slug?: string | null
      avatar?: { __typename?: 'UploadFile'; url: string } | null
      expertiseSubTopics: Array<{
        __typename?: 'SubTopic'
        documentId: string
        name: string
        slug?: string | null
        topics: Array<{
          __typename?: 'Topic'
          documentId: string
          name: string
          description?: string | null
          slug: string
        } | null>
      } | null>
      expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
      contents: Array<{ __typename?: 'Content'; documentId: string } | null>
    } | null
    solution?: {
      __typename?: 'Solution'
      displayName?: string | null
      slug?: string | null
      type: IEnum_Solution_Type
      shortDescription?: string | null
      logo?: { __typename?: 'UploadFile'; url: string } | null
    } | null
  } | null> | null
}

export type IContentDataDownloadMaterialFragment = {
  __typename?: 'ComponentContentDownloadMaterial'
  title?: string | null
  isEnabled?: boolean | null
  format?: IEnum_Componentcontentdownloadmaterial_Format | null
  lastUpdated?: any | null
  downloadButtonName?: string | null
  files?: { __typename?: 'UploadFile'; name: string } | null
}

export type IContentDataEntityFragment = {
  __typename?: 'ContentEntity'
  id?: string | null
  attributes?: {
    __typename: 'Content'
    documentId: string
    title: string
    publishedAt?: any | null
    createdAt?: any | null
    publishedTime?: any | null
    lastMaintained?: any | null
    isMaintained?: boolean | null
    contentType?: IEnum_Content_Contenttype | null
    slug: string
    snippet: string
    isPremium?: boolean | null
    isLatestBlog?: boolean | null
    defaultImage: Array<{ __typename: 'UploadFile'; url: string } | null>
    blogTaxonomies: Array<{ __typename: 'BlogTaxonomy'; name?: string | null; slug?: string | null } | null>
    subjectMatters: Array<{ __typename: 'SubjectMatter'; name?: string | null; slug?: string | null } | null>
    downloadMaterial?: {
      __typename: 'ComponentContentDownloadMaterial'
      title?: string | null
      isEnabled?: boolean | null
      format?: IEnum_Componentcontentdownloadmaterial_Format | null
      lastUpdated?: any | null
      downloadButtonName?: string | null
      files?: { __typename?: 'UploadFile'; name: string } | null
    } | null
    writer?: Array<{
      __typename: 'ComponentContentContentWriter'
      writerOption: IEnum_Componentcontentcontentwriter_Writeroption
      oneTimeAuthorName?: string | null
      author?: {
        __typename?: 'Author'
        firstName: string
        lastName: string
        jobTitle?: string | null
        company?: string | null
        bio?: string | null
        slug?: string | null
        avatar?: { __typename?: 'UploadFile'; url: string } | null
      } | null
      expert?: {
        __typename?: 'Expert'
        documentId: string
        firstName: string
        lastName: string
        displayName?: string | null
        title?: string | null
        company?: string | null
        bio?: string | null
        slug?: string | null
        avatar?: { __typename?: 'UploadFile'; url: string } | null
        expertiseSubTopics: Array<{
          __typename?: 'SubTopic'
          documentId: string
          name: string
          slug?: string | null
          topics: Array<{
            __typename?: 'Topic'
            documentId: string
            name: string
            description?: string | null
            slug: string
          } | null>
        } | null>
        expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
        contents: Array<{ __typename?: 'Content'; documentId: string } | null>
      } | null
      solution?: {
        __typename?: 'Solution'
        displayName?: string | null
        slug?: string | null
        type: IEnum_Solution_Type
        shortDescription?: string | null
        logo?: { __typename?: 'UploadFile'; url: string } | null
      } | null
    } | null> | null
  } | null
}

export type IContentItemFragment = {
  __typename?: 'ContentItem'
  documentId: string
  slug: string
  contentType?: IEnum_Content_Contenttype | null
  documentType?: IEnum_Content_Documenttype | null
  title: string
  snippet: string
  defaultImage?: string | null
  publishedTime: any
  isMaintained?: boolean | null
  lastMaintainedAt?: any | null
  subjectMatters?: string | null
  subjectMatterIds?: Array<string | null> | null
  themeIds?: Array<string | null> | null
  vendorTopicIds?: Array<string | null> | null
  themes?: string | null
  vendorTopics?: string | null
  writer?: {
    __typename?: 'ContentItemWriter'
    writerOption: IEnum_Componentcontentcontentwriter_Writeroption
    name: string
    avatar?: string | null
    title?: string | null
    url?: string | null
  } | null
  writers?: Array<{
    __typename?: 'ContentItemWriter'
    writerOption: IEnum_Componentcontentcontentwriter_Writeroption
    name: string
    avatar?: string | null
    title?: string | null
    url?: string | null
  }> | null
}

export type IContentItemWriterFragment = {
  __typename?: 'ContentItemWriter'
  writerOption: IEnum_Componentcontentcontentwriter_Writeroption
  name: string
  avatar?: string | null
  title?: string | null
  url?: string | null
}

export type IContentListItemFragment = {
  __typename?: 'Content'
  documentId: string
  title: string
  snippet: string
  createdAt?: any | null
  publishedTime?: any | null
  contentType?: IEnum_Content_Contenttype | null
  documentType?: IEnum_Content_Documenttype | null
  isMaintained?: boolean | null
  lastMaintained?: any | null
  slug: string
  publishedAt?: any | null
  subjectMatterIds?: Array<string | null> | null
  themeIds?: Array<string | null> | null
  vendorTopicIds?: Array<string | null> | null
  defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
  blogTaxonomies: Array<{
    __typename?: 'BlogTaxonomy'
    documentId: string
    slug?: string | null
    name?: string | null
  } | null>
  audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
  subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
  writer?: Array<{
    __typename?: 'ComponentContentContentWriter'
    writerOption: IEnum_Componentcontentcontentwriter_Writeroption
    oneTimeAuthorName?: string | null
    author?: {
      __typename?: 'Author'
      firstName: string
      lastName: string
      jobTitle?: string | null
      company?: string | null
      bio?: string | null
      slug?: string | null
      avatar?: { __typename?: 'UploadFile'; url: string } | null
    } | null
    expert?: {
      __typename?: 'Expert'
      documentId: string
      firstName: string
      lastName: string
      displayName?: string | null
      title?: string | null
      company?: string | null
      bio?: string | null
      slug?: string | null
      avatar?: { __typename?: 'UploadFile'; url: string } | null
      expertiseSubTopics: Array<{
        __typename?: 'SubTopic'
        documentId: string
        name: string
        slug?: string | null
        topics: Array<{
          __typename?: 'Topic'
          documentId: string
          name: string
          description?: string | null
          slug: string
        } | null>
      } | null>
      expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
      contents: Array<{ __typename?: 'Content'; documentId: string } | null>
    } | null
    solution?: {
      __typename?: 'Solution'
      displayName?: string | null
      slug?: string | null
      type: IEnum_Solution_Type
      shortDescription?: string | null
      logo?: { __typename?: 'UploadFile'; url: string } | null
    } | null
  } | null> | null
  themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
  vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
}

export type IContentListItemEntityFragment = {
  __typename?: 'ContentEntity'
  id?: string | null
  attributes?: {
    __typename?: 'Content'
    documentId: string
    title: string
    snippet: string
    createdAt?: any | null
    publishedTime?: any | null
    contentType?: IEnum_Content_Contenttype | null
    documentType?: IEnum_Content_Documenttype | null
    isMaintained?: boolean | null
    lastMaintained?: any | null
    slug: string
    publishedAt?: any | null
    subjectMatterIds?: Array<string | null> | null
    themeIds?: Array<string | null> | null
    vendorTopicIds?: Array<string | null> | null
    defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
    blogTaxonomies: Array<{
      __typename?: 'BlogTaxonomy'
      documentId: string
      slug?: string | null
      name?: string | null
    } | null>
    audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
    subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
    writer?: Array<{
      __typename?: 'ComponentContentContentWriter'
      writerOption: IEnum_Componentcontentcontentwriter_Writeroption
      oneTimeAuthorName?: string | null
      author?: {
        __typename?: 'Author'
        firstName: string
        lastName: string
        jobTitle?: string | null
        company?: string | null
        bio?: string | null
        slug?: string | null
        avatar?: { __typename?: 'UploadFile'; url: string } | null
      } | null
      expert?: {
        __typename?: 'Expert'
        documentId: string
        firstName: string
        lastName: string
        displayName?: string | null
        title?: string | null
        company?: string | null
        bio?: string | null
        slug?: string | null
        avatar?: { __typename?: 'UploadFile'; url: string } | null
        expertiseSubTopics: Array<{
          __typename?: 'SubTopic'
          documentId: string
          name: string
          slug?: string | null
          topics: Array<{
            __typename?: 'Topic'
            documentId: string
            name: string
            description?: string | null
            slug: string
          } | null>
        } | null>
        expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
        contents: Array<{ __typename?: 'Content'; documentId: string } | null>
      } | null
      solution?: {
        __typename?: 'Solution'
        displayName?: string | null
        slug?: string | null
        type: IEnum_Solution_Type
        shortDescription?: string | null
        logo?: { __typename?: 'UploadFile'; url: string } | null
      } | null
    } | null> | null
    themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
    vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
  } | null
}

export type IContentWriterFragment = {
  __typename?: 'ComponentContentContentWriter'
  writerOption: IEnum_Componentcontentcontentwriter_Writeroption
  oneTimeAuthorName?: string | null
  author?: {
    __typename?: 'Author'
    firstName: string
    lastName: string
    jobTitle?: string | null
    company?: string | null
    bio?: string | null
    slug?: string | null
    avatar?: { __typename?: 'UploadFile'; url: string } | null
  } | null
  expert?: {
    __typename?: 'Expert'
    documentId: string
    firstName: string
    lastName: string
    displayName?: string | null
    title?: string | null
    company?: string | null
    bio?: string | null
    slug?: string | null
    avatar?: { __typename?: 'UploadFile'; url: string } | null
    expertiseSubTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      name: string
      slug?: string | null
      topics: Array<{
        __typename?: 'Topic'
        documentId: string
        name: string
        description?: string | null
        slug: string
      } | null>
    } | null>
    expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
    contents: Array<{ __typename?: 'Content'; documentId: string } | null>
  } | null
  solution?: {
    __typename?: 'Solution'
    displayName?: string | null
    slug?: string | null
    type: IEnum_Solution_Type
    shortDescription?: string | null
    logo?: { __typename?: 'UploadFile'; url: string } | null
  } | null
}

export type IExpertCardDataFragment = {
  __typename?: 'Expert'
  documentId: string
  firstName: string
  lastName: string
  displayName?: string | null
  title?: string | null
  company?: string | null
  bio?: string | null
  slug?: string | null
  avatar?: { __typename?: 'UploadFile'; url: string } | null
  expertiseSubTopics: Array<{
    __typename?: 'SubTopic'
    documentId: string
    name: string
    slug?: string | null
    topics: Array<{
      __typename?: 'Topic'
      documentId: string
      name: string
      description?: string | null
      slug: string
    } | null>
  } | null>
  expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
  contents: Array<{ __typename?: 'Content'; documentId: string } | null>
}

export type IExpertFullItemFragment = {
  __typename?: 'Expert'
  documentId: string
  firstName: string
  lastName: string
  title?: string | null
  bio?: string | null
  linkedin?: string | null
  twitter?: string | null
  slug?: string | null
  experience?: string | null
  avatar?: { __typename?: 'UploadFile'; url: string } | null
  expertiseSubTopics: Array<{
    __typename?: 'SubTopic'
    documentId: string
    name: string
    slug?: string | null
    topics: Array<{
      __typename?: 'Topic'
      documentId: string
      name: string
      description?: string | null
      slug: string
    } | null>
  } | null>
  expertiseTopics: Array<{ __typename?: 'Topic'; documentId: string; name: string; slug: string } | null>
  secondaryExpertiseSubTopics: Array<{
    __typename?: 'SubTopic'
    documentId: string
    name: string
    slug?: string | null
    topics: Array<{
      __typename?: 'Topic'
      documentId: string
      name: string
      description?: string | null
      slug: string
    } | null>
  } | null>
  secondaryExpertiseTopics: Array<{ __typename?: 'Topic'; documentId: string; name: string; slug: string } | null>
  contents: Array<{ __typename?: 'Content'; documentId: string } | null>
}

export type IIltaSponsorshipItemFragment = {
  __typename?: 'IltaSponsorship'
  documentId: string
  name?: string | null
  level?: number | null
  description?: string | null
  logo?: { __typename?: 'UploadFile'; url: string } | null
}

export type IPhaseItemFragment = {
  __typename?: 'Phase'
  documentId: string
  title: string
  description?: string | null
}

export type IPremiumAudienceItemFragment = {
  __typename?: 'PremiumAudience'
  documentId: string
  name: string
  shouldShowOnHomepage?: boolean | null
}

export type IResourceInvitationEntityFragment = {
  __typename?: 'ResourceInvitationEntity'
  documentId: string
  name: string
  businessEmail: string
  companyLawFirmName: string
  dateInvited: any
  status: boolean
  contents: Array<{
    __typename?: 'SharedResourceEntity'
    documentId?: string | null
    title?: string | null
    slug?: string | null
    sharedResources: {
      __typename?: 'ContentVisitDownloadCountResult'
      visits?: Array<{
        __typename?: 'ContentVisit'
        visited_by?: { __typename?: 'User'; documentId: string; username: string } | null
      } | null> | null
      downloads?: Array<{
        __typename?: 'ContentDownload'
        downloaded_by?: { __typename?: 'User'; documentId: string; username: string } | null
      } | null> | null
    }
  } | null>
}

export type ISharedPortfolioUserSummaryFragment = {
  __typename?: 'User'
  documentId: string
  username: string
  email: string
  companyName?: string | null
  jobTitle?: string | null
  companyType?: IEnum_User_Companytype | null
  premiumOrganization?: {
    __typename?: 'PremiumOrganization'
    documentId: string
    name: string
    emailDomain: string
  } | null
  country?: { __typename?: 'Country'; documentId: string; name: string } | null
  role?: { __typename?: 'UsersPermissionsRole'; name: string; type?: string | null } | null
  vendor?: { __typename?: 'Vendor'; documentId: string; name: string; email?: string | null } | null
}

export type ISharedPortfolioMembershipItemFragment = {
  __typename?: 'SharedPortfolioMembership'
  documentId: string
  role: IEnum_Sharedportfoliomembership_Role
  isActive?: boolean | null
  user?: {
    __typename?: 'User'
    documentId: string
    username: string
    email: string
    companyName?: string | null
    jobTitle?: string | null
    companyType?: IEnum_User_Companytype | null
    premiumOrganization?: {
      __typename?: 'PremiumOrganization'
      documentId: string
      name: string
      emailDomain: string
    } | null
    country?: { __typename?: 'Country'; documentId: string; name: string } | null
    role?: { __typename?: 'UsersPermissionsRole'; name: string; type?: string | null } | null
    vendor?: { __typename?: 'Vendor'; documentId: string; name: string; email?: string | null } | null
  } | null
}

export type ISharedPortfolioSolutionItemFragment = {
  __typename?: 'SharedPortfolioSolution'
  documentId: string
  category?: IEnum_Sharedportfoliosolution_Category | null
  followingSolutionNote?: string | null
  createdAt?: any | null
  updatedAt?: any | null
  solution?: {
    __typename?: 'Solution'
    documentId: string
    id: string
    displayName?: string | null
    slug?: string | null
    isPremium?: boolean | null
  } | null
  sharedPortfolio?: { __typename?: 'SharedPortfolio'; documentId: string; name: string } | null
  lastModifiedByUser?: {
    __typename?: 'User'
    documentId: string
    username: string
    email: string
    companyName?: string | null
  } | null
}

export type ISharedPortfolioEntityItemFragment = {
  __typename?: 'SharedPortfolioEntity'
  id?: string | null
  attributes?: {
    __typename?: 'SharedPortfolio'
    documentId: string
    name: string
    slug?: string | null
    isSharedPortfolio?: boolean | null
    createdByUser?: {
      __typename?: 'User'
      documentId: string
      username: string
      email: string
      companyName?: string | null
      jobTitle?: string | null
      companyType?: IEnum_User_Companytype | null
      premiumOrganization?: {
        __typename?: 'PremiumOrganization'
        documentId: string
        name: string
        emailDomain: string
      } | null
      country?: { __typename?: 'Country'; documentId: string; name: string } | null
      role?: { __typename?: 'UsersPermissionsRole'; name: string; type?: string | null } | null
      vendor?: { __typename?: 'Vendor'; documentId: string; name: string; email?: string | null } | null
    } | null
    lastModifiedByUser?: { __typename?: 'User'; documentId: string; username: string; email: string } | null
    shared_portfolio_memberships: Array<{
      __typename?: 'SharedPortfolioMembership'
      documentId: string
      role: IEnum_Sharedportfoliomembership_Role
      isActive?: boolean | null
      user?: {
        __typename?: 'User'
        documentId: string
        username: string
        email: string
        companyName?: string | null
        jobTitle?: string | null
        companyType?: IEnum_User_Companytype | null
        premiumOrganization?: {
          __typename?: 'PremiumOrganization'
          documentId: string
          name: string
          emailDomain: string
        } | null
        country?: { __typename?: 'Country'; documentId: string; name: string } | null
        role?: { __typename?: 'UsersPermissionsRole'; name: string; type?: string | null } | null
        vendor?: { __typename?: 'Vendor'; documentId: string; name: string; email?: string | null } | null
      } | null
    } | null>
    shared_portfolio_solutions: Array<{
      __typename?: 'SharedPortfolioSolution'
      documentId: string
      category?: IEnum_Sharedportfoliosolution_Category | null
      followingSolutionNote?: string | null
      createdAt?: any | null
      updatedAt?: any | null
      solution?: {
        __typename?: 'Solution'
        documentId: string
        id: string
        displayName?: string | null
        slug?: string | null
        isPremium?: boolean | null
      } | null
      sharedPortfolio?: { __typename?: 'SharedPortfolio'; documentId: string; name: string } | null
      lastModifiedByUser?: {
        __typename?: 'User'
        documentId: string
        username: string
        email: string
        companyName?: string | null
      } | null
    } | null>
  } | null
}

export type ISimilarSolutionItemFragment = {
  __typename?: 'SimilarSolutionItem'
  type?: IEnum_Solution_Item_Type | null
  slug?: string | null
  displayName?: string | null
  logo?: string | null
  rating?: number | null
  reviewCnt?: number | null
}

export type ISmartsearchItemFragment = {
  __typename?: 'Smartsearch'
  result: string
  id: string
  identicalId?: number | null
  sources: Array<{
    __typename?: 'SmartSearchSources'
    sourceUrl?: string | null
    title?: string | null
    description?: string | null
    logo?: string | null
    contentType?: string | null
  }>
  logs: Array<{ __typename?: 'smartSearchLog'; message: string; timestamp: string }>
}

export type ISolutionAnnouncementFragment = {
  __typename?: 'Announcement'
  documentId: string
  announcement: string
  optionalLink?: string | null
  publishedAt?: any | null
  isArchived?: boolean | null
}

export type ISolutionCarouselItemFragment = {
  __typename?: 'SolutionItem'
  id?: number | null
  slug: string
  displayName: string
  logo?: string | null
  subTopics: Array<string>
  isPremium?: boolean | null
}

export type ISolutionAlspDataFragment = {
  __typename?: 'ComponentSolutionAlspData'
  name?: string | null
  serviceName?: string | null
  size?: number | null
  partners?: string | null
  fundingInfo?: IEnum_Componentsolutionalspdata_Fundinginfo | null
  fundingAmount?: IEnum_Componentsolutionalspdata_Fundingamount | null
  fundingDetails?: string | null
  openToInvestment?: boolean | null
  valueProposition?: string | null
  security: Array<{ __typename?: 'Security'; documentId: string; name: string } | null>
  audiences: Array<{ __typename?: 'Demographic'; documentId: string; name: string } | null>
  enhancedListingData?: {
    __typename?: 'ComponentSolutionPropsAlspEnhanced'
    serviceDescription?: string | null
    technologyPartners?: string | null
    averageLengthOfEngagement?: number | null
    pricingData?: string | null
    callToAction?: { __typename?: 'ComponentGlobalCallToAction'; label?: string | null; url?: string | null } | null
    dedicatedResources?: Array<{
      __typename?: 'ComponentSolutionPropsDedicatedResource'
      count?: number | null
      type?: IEnum_Componentsolutionpropsdedicatedresource_Type | null
    } | null> | null
    specialists?: Array<{
      __typename?: 'ComponentAboutPropsTeamMember'
      name?: string | null
      role?: string | null
      bio?: string | null
      avatar?: { __typename?: 'UploadFile'; url: string } | null
    } | null> | null
    screenshots?: Array<{
      __typename?: 'ComponentGlobalPicture'
      id: string
      title?: string | null
      summary?: string | null
      image?: { __typename?: 'UploadFile'; url: string; id: string } | null
    } | null> | null
    videos?: Array<{
      __typename?: 'ComponentSolutionPropsVideo'
      title?: string | null
      summary?: string | null
      url?: string | null
    } | null> | null
    caseStudies?: Array<{
      __typename?: 'ComponentGlobalSuccessStory'
      name?: string | null
      link?: string | null
    } | null> | null
    testimonials?: Array<{
      __typename?: 'ComponentTestimonialsTestimonials'
      id: string
      description?: string | null
      author?: {
        __typename?: 'ComponentTestimonialsPropsAuthor'
        name?: string | null
        role?: string | null
        company?: string | null
        avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
      } | null
    } | null> | null
  } | null
}

export type IAlspSolutionDataFragment = {
  __typename?: 'Solution'
  productType?: IEnum_Solution_Producttype | null
  id: string
  documentId: string
  displayName?: string | null
  oldSlug?: string | null
  type: IEnum_Solution_Type
  website?: string | null
  linkedin?: string | null
  twitter?: string | null
  isPremium?: boolean | null
  slug?: string | null
  shortDescription?: string | null
  longDescription?: string | null
  isBeta?: boolean | null
  isStartup?: boolean | null
  rating?: number | null
  yearFounded?: number | null
  createdAt?: any | null
  publishedAt?: any | null
  descOtherExistingCustomer?: string | null
  descOtherIntegration?: string | null
  isDiverseLeadership?: boolean | null
  alspData?: {
    __typename?: 'ComponentSolutionAlspData'
    name?: string | null
    serviceName?: string | null
    size?: number | null
    partners?: string | null
    fundingInfo?: IEnum_Componentsolutionalspdata_Fundinginfo | null
    fundingAmount?: IEnum_Componentsolutionalspdata_Fundingamount | null
    fundingDetails?: string | null
    openToInvestment?: boolean | null
    valueProposition?: string | null
    security: Array<{ __typename?: 'Security'; documentId: string; name: string } | null>
    audiences: Array<{ __typename?: 'Demographic'; documentId: string; name: string } | null>
    enhancedListingData?: {
      __typename?: 'ComponentSolutionPropsAlspEnhanced'
      serviceDescription?: string | null
      technologyPartners?: string | null
      averageLengthOfEngagement?: number | null
      pricingData?: string | null
      callToAction?: { __typename?: 'ComponentGlobalCallToAction'; label?: string | null; url?: string | null } | null
      dedicatedResources?: Array<{
        __typename?: 'ComponentSolutionPropsDedicatedResource'
        count?: number | null
        type?: IEnum_Componentsolutionpropsdedicatedresource_Type | null
      } | null> | null
      specialists?: Array<{
        __typename?: 'ComponentAboutPropsTeamMember'
        name?: string | null
        role?: string | null
        bio?: string | null
        avatar?: { __typename?: 'UploadFile'; url: string } | null
      } | null> | null
      screenshots?: Array<{
        __typename?: 'ComponentGlobalPicture'
        id: string
        title?: string | null
        summary?: string | null
        image?: { __typename?: 'UploadFile'; url: string; id: string } | null
      } | null> | null
      videos?: Array<{
        __typename?: 'ComponentSolutionPropsVideo'
        title?: string | null
        summary?: string | null
        url?: string | null
      } | null> | null
      caseStudies?: Array<{
        __typename?: 'ComponentGlobalSuccessStory'
        name?: string | null
        link?: string | null
      } | null> | null
      testimonials?: Array<{
        __typename?: 'ComponentTestimonialsTestimonials'
        id: string
        description?: string | null
        author?: {
          __typename?: 'ComponentTestimonialsPropsAuthor'
          name?: string | null
          role?: string | null
          company?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
        } | null
      } | null> | null
    } | null
  } | null
  consolidationData?: {
    __typename?: 'ComponentSolutionPropsConsolidation'
    date?: any | null
    amount?: number | null
    article?: string | null
    articleLink?: string | null
    originalTargetName?: string | null
    buyer?: string | null
    enableInActiveDir?: boolean | null
  } | null
  graveyardData?: { __typename?: 'ComponentSolutionPropsGraveyard'; date?: any | null } | null
  founders?: Array<{
    __typename?: 'ComponentAboutPropsTeamMember'
    name?: string | null
    role?: string | null
    bio?: string | null
    title?: string | null
    externalLink?: string | null
    avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
  } | null> | null
  vendor?: {
    __typename?: 'Vendor'
    publishedAt?: any | null
    documentId: string
    users: Array<{ __typename?: 'User'; external_id?: string | null } | null>
  } | null
  topics: Array<{ __typename?: 'Topic'; documentId: string; slug: string; name: string } | null>
  subTopics: Array<{
    __typename?: 'SubTopic'
    documentId: string
    slug?: string | null
    name: string
    features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
  } | null>
  logo?: { __typename?: 'UploadFile'; id: string; url: string } | null
  company?: { __typename?: 'Company'; name: string; slug?: string | null } | null
  reviews: Array<{
    __typename?: 'Review'
    anonymous?: boolean | null
    rating?: number | null
    title?: string | null
    content?: string | null
    submitterTitle?: string | null
    submitterSubTitle?: string | null
    solutionDispName?: string | null
    createdAt?: any | null
    updatedAt?: any | null
    publishedAt?: any | null
    solution?: {
      __typename?: 'Solution'
      displayName?: string | null
      slug?: string | null
      rating?: number | null
      company?: { __typename?: 'Company'; slug?: string | null } | null
      logo?: { __typename?: 'UploadFile'; url: string } | null
    } | null
  } | null>
  offices: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
  hqs: Array<{ __typename?: 'Hq'; documentId: string; name: string } | null>
  regionsServed: Array<{ __typename?: 'RegionsServed'; documentId: string; name: string } | null>
  languages: Array<{ __typename?: 'PlatformLanguage'; documentId: string; name: string } | null>
  articles?: Array<{
    __typename?: 'ComponentGlobalArticle'
    id: string
    title?: string | null
    publishedBy?: string | null
    date?: any | null
    link?: string | null
    image?: { __typename?: 'UploadFile'; url: string; id: string } | null
  } | null> | null
  vendorResources?: Array<{
    __typename?: 'ComponentSolutionPropsVendorResource'
    type?: IEnum_Componentsolutionpropsvendorresource_Type | null
    content?: {
      __typename?: 'Content'
      documentId: string
      title: string
      snippet: string
      createdAt?: any | null
      publishedTime?: any | null
      contentType?: IEnum_Content_Contenttype | null
      documentType?: IEnum_Content_Documenttype | null
      isMaintained?: boolean | null
      lastMaintained?: any | null
      slug: string
      publishedAt?: any | null
      subjectMatterIds?: Array<string | null> | null
      themeIds?: Array<string | null> | null
      vendorTopicIds?: Array<string | null> | null
      defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
      blogTaxonomies: Array<{
        __typename?: 'BlogTaxonomy'
        documentId: string
        slug?: string | null
        name?: string | null
      } | null>
      audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
      subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
      writer?: Array<{
        __typename?: 'ComponentContentContentWriter'
        writerOption: IEnum_Componentcontentcontentwriter_Writeroption
        oneTimeAuthorName?: string | null
        author?: {
          __typename?: 'Author'
          firstName: string
          lastName: string
          jobTitle?: string | null
          company?: string | null
          bio?: string | null
          slug?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
        } | null
        expert?: {
          __typename?: 'Expert'
          documentId: string
          firstName: string
          lastName: string
          displayName?: string | null
          title?: string | null
          company?: string | null
          bio?: string | null
          slug?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
          expertiseSubTopics: Array<{
            __typename?: 'SubTopic'
            documentId: string
            name: string
            slug?: string | null
            topics: Array<{
              __typename?: 'Topic'
              documentId: string
              name: string
              description?: string | null
              slug: string
            } | null>
          } | null>
          expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
          contents: Array<{ __typename?: 'Content'; documentId: string } | null>
        } | null
        solution?: {
          __typename?: 'Solution'
          displayName?: string | null
          slug?: string | null
          type: IEnum_Solution_Type
          shortDescription?: string | null
          logo?: { __typename?: 'UploadFile'; url: string } | null
        } | null
      } | null> | null
      themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
      vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
    } | null
    external?: {
      __typename?: 'ComponentSolutionPropsVendorResourceExternal'
      title?: string | null
      summary?: string | null
      link?: string | null
      publishedDate?: any | null
      author?: string | null
      documentType?: IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype | null
    } | null
  } | null> | null
  features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
  existingCustomers: Array<{ __typename?: 'ExistingCustomer'; documentId: string; name: string } | null>
  iltaSponsorships?: Array<{
    __typename?: 'IltaSponsorship'
    documentId: string
    name?: string | null
    logo?: { __typename?: 'UploadFile'; documentId: string; url: string } | null
  } | null>
  announcement: Array<{
    __typename?: 'Announcement'
    id: string
    announcement: string
    optionalLink?: string | null
    publishedAt?: any | null
    documentId: string
    isArchived?: boolean | null
  } | null>
}

export type IAlspSolutionEnhancedListingDataFragment = {
  __typename?: 'ComponentSolutionPropsAlspEnhanced'
  serviceDescription?: string | null
  technologyPartners?: string | null
  averageLengthOfEngagement?: number | null
  pricingData?: string | null
  callToAction?: { __typename?: 'ComponentGlobalCallToAction'; label?: string | null; url?: string | null } | null
  dedicatedResources?: Array<{
    __typename?: 'ComponentSolutionPropsDedicatedResource'
    count?: number | null
    type?: IEnum_Componentsolutionpropsdedicatedresource_Type | null
  } | null> | null
  specialists?: Array<{
    __typename?: 'ComponentAboutPropsTeamMember'
    name?: string | null
    role?: string | null
    bio?: string | null
    avatar?: { __typename?: 'UploadFile'; url: string } | null
  } | null> | null
  screenshots?: Array<{
    __typename?: 'ComponentGlobalPicture'
    id: string
    title?: string | null
    summary?: string | null
    image?: { __typename?: 'UploadFile'; url: string; id: string } | null
  } | null> | null
  videos?: Array<{
    __typename?: 'ComponentSolutionPropsVideo'
    title?: string | null
    summary?: string | null
    url?: string | null
  } | null> | null
  caseStudies?: Array<{
    __typename?: 'ComponentGlobalSuccessStory'
    name?: string | null
    link?: string | null
  } | null> | null
  testimonials?: Array<{
    __typename?: 'ComponentTestimonialsTestimonials'
    id: string
    description?: string | null
    author?: {
      __typename?: 'ComponentTestimonialsPropsAuthor'
      name?: string | null
      role?: string | null
      company?: string | null
      avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
    } | null
  } | null> | null
}

export type ICompanyFounderFragment = {
  __typename?: 'ComponentCompanyCompanyFounder'
  name?: string | null
  role?: string | null
  bio?: string | null
  title?: string | null
  externalLink?: string | null
  experiencedFounder?: boolean | null
  avatar?: { __typename?: 'UploadFile'; url: string } | null
}

export type ICompanyIltaSponsorshipFragment = {
  __typename?: 'IltaSponsorship'
  name?: string | null
  logo?: { __typename?: 'UploadFile'; documentId: string; url: string } | null
}

export type ISolutionConsultancyDataFragment = {
  __typename?: 'ComponentSolutionConsultantData'
  name?: string | null
  serviceName?: string | null
  size?: number | null
  partners?: string | null
  fundingInfo?: IEnum_Componentsolutionconsultantdata_Fundinginfo | null
  fundingAmount?: IEnum_Componentsolutionconsultantdata_Fundingamount | null
  fundingDetails?: string | null
  openToInvestment?: boolean | null
  valueProposition?: string | null
  security: Array<{ __typename?: 'Security'; documentId: string; name: string } | null>
  audiences: Array<{ __typename?: 'Demographic'; documentId: string; name: string } | null>
  integrations: Array<{ __typename?: 'Integration'; documentId: string; name: string } | null>
  practiceAreas: Array<{ __typename?: 'PracticeArea'; documentId: string; name: string } | null>
  typeOfUser: Array<{ __typename?: 'TypeOfUser'; documentId: string; name?: string | null } | null>
  enhancedListingData?: {
    __typename?: 'ComponentSolutionPropsConsultantEnhanced'
    serviceDescription?: string | null
    technologyPartners?: string | null
    averageLengthOfEngagement?: number | null
    pricingData?: string | null
    callToAction?: { __typename?: 'ComponentGlobalCallToAction'; label?: string | null; url?: string | null } | null
    dedicatedResources?: Array<{
      __typename?: 'ComponentSolutionPropsDedicatedResource'
      count?: number | null
      type?: IEnum_Componentsolutionpropsdedicatedresource_Type | null
    } | null> | null
    caseStudies?: Array<{
      __typename?: 'ComponentGlobalSuccessStory'
      name?: string | null
      link?: string | null
    } | null> | null
    specialists?: Array<{
      __typename?: 'ComponentAboutPropsTeamMember'
      name?: string | null
      role?: string | null
      bio?: string | null
      avatar?: { __typename?: 'UploadFile'; url: string } | null
    } | null> | null
    screenshots?: Array<{
      __typename?: 'ComponentGlobalPicture'
      id: string
      title?: string | null
      summary?: string | null
      image?: { __typename?: 'UploadFile'; url: string; id: string } | null
    } | null> | null
    videos?: Array<{
      __typename?: 'ComponentSolutionPropsVideo'
      title?: string | null
      summary?: string | null
      url?: string | null
    } | null> | null
    testimonials?: Array<{
      __typename?: 'ComponentTestimonialsTestimonials'
      id: string
      description?: string | null
      author?: {
        __typename?: 'ComponentTestimonialsPropsAuthor'
        name?: string | null
        role?: string | null
        company?: string | null
        avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
      } | null
    } | null> | null
  } | null
}

export type IConsultancySolutionDataFragment = {
  __typename?: 'Solution'
  productType?: IEnum_Solution_Producttype | null
  id: string
  documentId: string
  displayName?: string | null
  oldSlug?: string | null
  type: IEnum_Solution_Type
  website?: string | null
  linkedin?: string | null
  twitter?: string | null
  isPremium?: boolean | null
  slug?: string | null
  shortDescription?: string | null
  longDescription?: string | null
  isBeta?: boolean | null
  isStartup?: boolean | null
  rating?: number | null
  yearFounded?: number | null
  createdAt?: any | null
  publishedAt?: any | null
  descOtherExistingCustomer?: string | null
  descOtherIntegration?: string | null
  isDiverseLeadership?: boolean | null
  consultantData?: {
    __typename?: 'ComponentSolutionConsultantData'
    name?: string | null
    serviceName?: string | null
    size?: number | null
    partners?: string | null
    fundingInfo?: IEnum_Componentsolutionconsultantdata_Fundinginfo | null
    fundingAmount?: IEnum_Componentsolutionconsultantdata_Fundingamount | null
    fundingDetails?: string | null
    openToInvestment?: boolean | null
    valueProposition?: string | null
    security: Array<{ __typename?: 'Security'; documentId: string; name: string } | null>
    audiences: Array<{ __typename?: 'Demographic'; documentId: string; name: string } | null>
    integrations: Array<{ __typename?: 'Integration'; documentId: string; name: string } | null>
    practiceAreas: Array<{ __typename?: 'PracticeArea'; documentId: string; name: string } | null>
    typeOfUser: Array<{ __typename?: 'TypeOfUser'; documentId: string; name?: string | null } | null>
    enhancedListingData?: {
      __typename?: 'ComponentSolutionPropsConsultantEnhanced'
      serviceDescription?: string | null
      technologyPartners?: string | null
      averageLengthOfEngagement?: number | null
      pricingData?: string | null
      callToAction?: { __typename?: 'ComponentGlobalCallToAction'; label?: string | null; url?: string | null } | null
      dedicatedResources?: Array<{
        __typename?: 'ComponentSolutionPropsDedicatedResource'
        count?: number | null
        type?: IEnum_Componentsolutionpropsdedicatedresource_Type | null
      } | null> | null
      caseStudies?: Array<{
        __typename?: 'ComponentGlobalSuccessStory'
        name?: string | null
        link?: string | null
      } | null> | null
      specialists?: Array<{
        __typename?: 'ComponentAboutPropsTeamMember'
        name?: string | null
        role?: string | null
        bio?: string | null
        avatar?: { __typename?: 'UploadFile'; url: string } | null
      } | null> | null
      screenshots?: Array<{
        __typename?: 'ComponentGlobalPicture'
        id: string
        title?: string | null
        summary?: string | null
        image?: { __typename?: 'UploadFile'; url: string; id: string } | null
      } | null> | null
      videos?: Array<{
        __typename?: 'ComponentSolutionPropsVideo'
        title?: string | null
        summary?: string | null
        url?: string | null
      } | null> | null
      testimonials?: Array<{
        __typename?: 'ComponentTestimonialsTestimonials'
        id: string
        description?: string | null
        author?: {
          __typename?: 'ComponentTestimonialsPropsAuthor'
          name?: string | null
          role?: string | null
          company?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
        } | null
      } | null> | null
    } | null
  } | null
  consolidationData?: {
    __typename?: 'ComponentSolutionPropsConsolidation'
    date?: any | null
    amount?: number | null
    article?: string | null
    articleLink?: string | null
    originalTargetName?: string | null
    buyer?: string | null
    enableInActiveDir?: boolean | null
  } | null
  graveyardData?: { __typename?: 'ComponentSolutionPropsGraveyard'; date?: any | null } | null
  founders?: Array<{
    __typename?: 'ComponentAboutPropsTeamMember'
    name?: string | null
    role?: string | null
    bio?: string | null
    title?: string | null
    externalLink?: string | null
    avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
  } | null> | null
  vendor?: {
    __typename?: 'Vendor'
    publishedAt?: any | null
    documentId: string
    users: Array<{ __typename?: 'User'; external_id?: string | null } | null>
  } | null
  topics: Array<{ __typename?: 'Topic'; documentId: string; slug: string; name: string } | null>
  subTopics: Array<{
    __typename?: 'SubTopic'
    documentId: string
    slug?: string | null
    name: string
    features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
  } | null>
  logo?: { __typename?: 'UploadFile'; id: string; url: string } | null
  company?: { __typename?: 'Company'; name: string; slug?: string | null } | null
  reviews: Array<{
    __typename?: 'Review'
    anonymous?: boolean | null
    rating?: number | null
    title?: string | null
    content?: string | null
    submitterTitle?: string | null
    submitterSubTitle?: string | null
    solutionDispName?: string | null
    createdAt?: any | null
    updatedAt?: any | null
    publishedAt?: any | null
    solution?: {
      __typename?: 'Solution'
      displayName?: string | null
      slug?: string | null
      rating?: number | null
      company?: { __typename?: 'Company'; slug?: string | null } | null
      logo?: { __typename?: 'UploadFile'; url: string } | null
    } | null
  } | null>
  offices: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
  hqs: Array<{ __typename?: 'Hq'; documentId: string; name: string } | null>
  regionsServed: Array<{ __typename?: 'RegionsServed'; documentId: string; name: string } | null>
  languages: Array<{ __typename?: 'PlatformLanguage'; documentId: string; name: string } | null>
  articles?: Array<{
    __typename?: 'ComponentGlobalArticle'
    id: string
    title?: string | null
    publishedBy?: string | null
    date?: any | null
    link?: string | null
    image?: { __typename?: 'UploadFile'; url: string; id: string } | null
  } | null> | null
  vendorResources?: Array<{
    __typename?: 'ComponentSolutionPropsVendorResource'
    type?: IEnum_Componentsolutionpropsvendorresource_Type | null
    content?: {
      __typename?: 'Content'
      documentId: string
      title: string
      snippet: string
      createdAt?: any | null
      publishedTime?: any | null
      contentType?: IEnum_Content_Contenttype | null
      documentType?: IEnum_Content_Documenttype | null
      isMaintained?: boolean | null
      lastMaintained?: any | null
      slug: string
      publishedAt?: any | null
      subjectMatterIds?: Array<string | null> | null
      themeIds?: Array<string | null> | null
      vendorTopicIds?: Array<string | null> | null
      defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
      blogTaxonomies: Array<{
        __typename?: 'BlogTaxonomy'
        documentId: string
        slug?: string | null
        name?: string | null
      } | null>
      audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
      subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
      writer?: Array<{
        __typename?: 'ComponentContentContentWriter'
        writerOption: IEnum_Componentcontentcontentwriter_Writeroption
        oneTimeAuthorName?: string | null
        author?: {
          __typename?: 'Author'
          firstName: string
          lastName: string
          jobTitle?: string | null
          company?: string | null
          bio?: string | null
          slug?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
        } | null
        expert?: {
          __typename?: 'Expert'
          documentId: string
          firstName: string
          lastName: string
          displayName?: string | null
          title?: string | null
          company?: string | null
          bio?: string | null
          slug?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
          expertiseSubTopics: Array<{
            __typename?: 'SubTopic'
            documentId: string
            name: string
            slug?: string | null
            topics: Array<{
              __typename?: 'Topic'
              documentId: string
              name: string
              description?: string | null
              slug: string
            } | null>
          } | null>
          expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
          contents: Array<{ __typename?: 'Content'; documentId: string } | null>
        } | null
        solution?: {
          __typename?: 'Solution'
          displayName?: string | null
          slug?: string | null
          type: IEnum_Solution_Type
          shortDescription?: string | null
          logo?: { __typename?: 'UploadFile'; url: string } | null
        } | null
      } | null> | null
      themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
      vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
    } | null
    external?: {
      __typename?: 'ComponentSolutionPropsVendorResourceExternal'
      title?: string | null
      summary?: string | null
      link?: string | null
      publishedDate?: any | null
      author?: string | null
      documentType?: IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype | null
    } | null
  } | null> | null
  features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
  existingCustomers: Array<{ __typename?: 'ExistingCustomer'; documentId: string; name: string } | null>
  iltaSponsorships?: Array<{
    __typename?: 'IltaSponsorship'
    documentId: string
    name?: string | null
    logo?: { __typename?: 'UploadFile'; documentId: string; url: string } | null
  } | null>
  announcement: Array<{
    __typename?: 'Announcement'
    id: string
    announcement: string
    optionalLink?: string | null
    publishedAt?: any | null
    documentId: string
    isArchived?: boolean | null
  } | null>
}

export type IConsultancySolutionEnhancedListingDataFragment = {
  __typename?: 'ComponentSolutionPropsConsultantEnhanced'
  serviceDescription?: string | null
  technologyPartners?: string | null
  averageLengthOfEngagement?: number | null
  pricingData?: string | null
  callToAction?: { __typename?: 'ComponentGlobalCallToAction'; label?: string | null; url?: string | null } | null
  dedicatedResources?: Array<{
    __typename?: 'ComponentSolutionPropsDedicatedResource'
    count?: number | null
    type?: IEnum_Componentsolutionpropsdedicatedresource_Type | null
  } | null> | null
  caseStudies?: Array<{
    __typename?: 'ComponentGlobalSuccessStory'
    name?: string | null
    link?: string | null
  } | null> | null
  specialists?: Array<{
    __typename?: 'ComponentAboutPropsTeamMember'
    name?: string | null
    role?: string | null
    bio?: string | null
    avatar?: { __typename?: 'UploadFile'; url: string } | null
  } | null> | null
  screenshots?: Array<{
    __typename?: 'ComponentGlobalPicture'
    id: string
    title?: string | null
    summary?: string | null
    image?: { __typename?: 'UploadFile'; url: string; id: string } | null
  } | null> | null
  videos?: Array<{
    __typename?: 'ComponentSolutionPropsVideo'
    title?: string | null
    summary?: string | null
    url?: string | null
  } | null> | null
  testimonials?: Array<{
    __typename?: 'ComponentTestimonialsTestimonials'
    id: string
    description?: string | null
    author?: {
      __typename?: 'ComponentTestimonialsPropsAuthor'
      name?: string | null
      role?: string | null
      company?: string | null
      avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
    } | null
  } | null> | null
}

export type ISolutionFollowedSolutionsDataFragment = {
  __typename?: 'ComponentFollowingSolutionsData'
  followingType?: string | null
  followingSolutionNote?: string | null
  noteCreatedAt?: string | null
  noteCreatedByName?: string | null
  noteLastEditedAt?: string | null
  noteLastEditedByName?: string | null
}

export type IGeneralSolutionDataFragment = {
  __typename?: 'Solution'
  id: string
  documentId: string
  displayName?: string | null
  oldSlug?: string | null
  type: IEnum_Solution_Type
  website?: string | null
  linkedin?: string | null
  twitter?: string | null
  isPremium?: boolean | null
  slug?: string | null
  shortDescription?: string | null
  longDescription?: string | null
  isBeta?: boolean | null
  isStartup?: boolean | null
  rating?: number | null
  yearFounded?: number | null
  createdAt?: any | null
  publishedAt?: any | null
  descOtherExistingCustomer?: string | null
  descOtherIntegration?: string | null
  isDiverseLeadership?: boolean | null
  topics: Array<{ __typename?: 'Topic'; documentId: string; slug: string; name: string } | null>
  subTopics: Array<{
    __typename?: 'SubTopic'
    documentId: string
    slug?: string | null
    name: string
    features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
  } | null>
  logo?: { __typename?: 'UploadFile'; id: string; url: string } | null
  company?: { __typename?: 'Company'; name: string; slug?: string | null } | null
  reviews: Array<{
    __typename?: 'Review'
    anonymous?: boolean | null
    rating?: number | null
    title?: string | null
    content?: string | null
    submitterTitle?: string | null
    submitterSubTitle?: string | null
    solutionDispName?: string | null
    createdAt?: any | null
    updatedAt?: any | null
    publishedAt?: any | null
    solution?: {
      __typename?: 'Solution'
      displayName?: string | null
      slug?: string | null
      rating?: number | null
      company?: { __typename?: 'Company'; slug?: string | null } | null
      logo?: { __typename?: 'UploadFile'; url: string } | null
    } | null
  } | null>
  offices: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
  hqs: Array<{ __typename?: 'Hq'; documentId: string; name: string } | null>
  regionsServed: Array<{ __typename?: 'RegionsServed'; documentId: string; name: string } | null>
  languages: Array<{ __typename?: 'PlatformLanguage'; documentId: string; name: string } | null>
  articles?: Array<{
    __typename?: 'ComponentGlobalArticle'
    id: string
    title?: string | null
    publishedBy?: string | null
    date?: any | null
    link?: string | null
    image?: { __typename?: 'UploadFile'; url: string; id: string } | null
  } | null> | null
  vendorResources?: Array<{
    __typename?: 'ComponentSolutionPropsVendorResource'
    type?: IEnum_Componentsolutionpropsvendorresource_Type | null
    content?: {
      __typename?: 'Content'
      documentId: string
      title: string
      snippet: string
      createdAt?: any | null
      publishedTime?: any | null
      contentType?: IEnum_Content_Contenttype | null
      documentType?: IEnum_Content_Documenttype | null
      isMaintained?: boolean | null
      lastMaintained?: any | null
      slug: string
      publishedAt?: any | null
      subjectMatterIds?: Array<string | null> | null
      themeIds?: Array<string | null> | null
      vendorTopicIds?: Array<string | null> | null
      defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
      blogTaxonomies: Array<{
        __typename?: 'BlogTaxonomy'
        documentId: string
        slug?: string | null
        name?: string | null
      } | null>
      audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
      subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
      writer?: Array<{
        __typename?: 'ComponentContentContentWriter'
        writerOption: IEnum_Componentcontentcontentwriter_Writeroption
        oneTimeAuthorName?: string | null
        author?: {
          __typename?: 'Author'
          firstName: string
          lastName: string
          jobTitle?: string | null
          company?: string | null
          bio?: string | null
          slug?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
        } | null
        expert?: {
          __typename?: 'Expert'
          documentId: string
          firstName: string
          lastName: string
          displayName?: string | null
          title?: string | null
          company?: string | null
          bio?: string | null
          slug?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
          expertiseSubTopics: Array<{
            __typename?: 'SubTopic'
            documentId: string
            name: string
            slug?: string | null
            topics: Array<{
              __typename?: 'Topic'
              documentId: string
              name: string
              description?: string | null
              slug: string
            } | null>
          } | null>
          expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
          contents: Array<{ __typename?: 'Content'; documentId: string } | null>
        } | null
        solution?: {
          __typename?: 'Solution'
          displayName?: string | null
          slug?: string | null
          type: IEnum_Solution_Type
          shortDescription?: string | null
          logo?: { __typename?: 'UploadFile'; url: string } | null
        } | null
      } | null> | null
      themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
      vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
    } | null
    external?: {
      __typename?: 'ComponentSolutionPropsVendorResourceExternal'
      title?: string | null
      summary?: string | null
      link?: string | null
      publishedDate?: any | null
      author?: string | null
      documentType?: IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype | null
    } | null
  } | null> | null
  features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
  existingCustomers: Array<{ __typename?: 'ExistingCustomer'; documentId: string; name: string } | null>
  iltaSponsorships?: Array<{
    __typename?: 'IltaSponsorship'
    documentId: string
    name?: string | null
    logo?: { __typename?: 'UploadFile'; documentId: string; url: string } | null
  } | null>
  announcement: Array<{
    __typename?: 'Announcement'
    id: string
    announcement: string
    optionalLink?: string | null
    publishedAt?: any | null
    documentId: string
    isArchived?: boolean | null
  } | null>
}

export type IGeneralSolutionRequestDataFragment = {
  __typename?: 'SolutionRequest'
  id: string
  documentId: string
  website?: string | null
  slug?: string | null
  shortDescription?: string | null
  longDescription?: string | null
  linkedin?: string | null
  twitter?: string | null
  type: IEnum_Solutionrequest_Type
  yearFounded?: number | null
  createdAt?: any | null
  publishedAt?: any | null
  updatedAt?: any | null
  topics: Array<{ __typename?: 'Topic'; documentId: string; slug: string; name: string } | null>
  subTopics: Array<{
    __typename?: 'SubTopic'
    documentId: string
    slug?: string | null
    name: string
    features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
  } | null>
  logo?: { __typename?: 'UploadFile'; id: string; url: string } | null
  offices: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
  hqs: Array<{ __typename?: 'Hq'; documentId: string; name: string } | null>
  regionsServed: Array<{ __typename?: 'RegionsServed'; documentId: string; name: string } | null>
  languages: Array<{ __typename?: 'PlatformLanguage'; documentId: string; name: string } | null>
  articles?: Array<{
    __typename?: 'ComponentGlobalArticle'
    id: string
    title?: string | null
    publishedBy?: string | null
    date?: any | null
    link?: string | null
    image?: { __typename?: 'UploadFile'; url: string; id: string } | null
  } | null> | null
  features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
  existingCustomers: Array<{ __typename?: 'ExistingCustomer'; documentId: string; name: string } | null>
  announcement?: {
    __typename?: 'Announcement'
    documentId: string
    announcement: string
    optionalLink?: string | null
  } | null
}

export type IIltaSponsorshipLogoFragment = { __typename?: 'UploadFile'; documentId: string; url: string }

export type ISolutionProductDataFragment = {
  __typename?: 'ComponentSolutionProductData'
  name?: string | null
  tool?: string | null
  fundingInfo?: IEnum_Componentsolutionproductdata_Fundinginfo | null
  fundingAmount?: IEnum_Componentsolutionproductdata_Fundingamount | null
  fundingDetails?: string | null
  openToInvestment?: boolean | null
  valueProposition?: string | null
  audiences: Array<{ __typename?: 'Demographic'; documentId: string; name: string } | null>
  attributes: Array<{ __typename?: 'Attribute'; documentId: string; name: string } | null>
  deployments: Array<{ __typename?: 'Installation'; documentId: string; name: string } | null>
  integrations: Array<{ __typename?: 'Integration'; documentId: string; name: string } | null>
  practiceAreas: Array<{ __typename?: 'PracticeArea'; documentId: string; name: string } | null>
  typeOfUser: Array<{ __typename?: 'TypeOfUser'; documentId: string; name?: string | null } | null>
  security: Array<{ __typename?: 'Security'; documentId: string; name: string } | null>
  dataHostingLocations: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
  enhancedListingData?: {
    __typename?: 'ComponentSolutionPropsProductEnhanced'
    pricingData?: string | null
    callToAction?: { __typename?: 'ComponentGlobalCallToAction'; label?: string | null; url?: string | null } | null
    screenshots?: Array<{
      __typename?: 'ComponentGlobalPicture'
      id: string
      title?: string | null
      summary?: string | null
      image?: { __typename?: 'UploadFile'; url: string; id: string } | null
    } | null> | null
    videos?: Array<{
      __typename?: 'ComponentSolutionPropsVideo'
      title?: string | null
      summary?: string | null
      url?: string | null
    } | null> | null
    testimonials?: Array<{
      __typename?: 'ComponentTestimonialsTestimonials'
      id: string
      description?: string | null
      author?: {
        __typename?: 'ComponentTestimonialsPropsAuthor'
        name?: string | null
        role?: string | null
        company?: string | null
        avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
      } | null
    } | null> | null
  } | null
}

export type IProductSolutionDataFragment = {
  __typename?: 'Solution'
  productType?: IEnum_Solution_Producttype | null
  id: string
  documentId: string
  displayName?: string | null
  oldSlug?: string | null
  type: IEnum_Solution_Type
  website?: string | null
  linkedin?: string | null
  twitter?: string | null
  isPremium?: boolean | null
  slug?: string | null
  shortDescription?: string | null
  longDescription?: string | null
  isBeta?: boolean | null
  isStartup?: boolean | null
  rating?: number | null
  yearFounded?: number | null
  createdAt?: any | null
  publishedAt?: any | null
  descOtherExistingCustomer?: string | null
  descOtherIntegration?: string | null
  isDiverseLeadership?: boolean | null
  productData?: {
    __typename?: 'ComponentSolutionProductData'
    name?: string | null
    tool?: string | null
    fundingInfo?: IEnum_Componentsolutionproductdata_Fundinginfo | null
    fundingAmount?: IEnum_Componentsolutionproductdata_Fundingamount | null
    fundingDetails?: string | null
    openToInvestment?: boolean | null
    valueProposition?: string | null
    audiences: Array<{ __typename?: 'Demographic'; documentId: string; name: string } | null>
    attributes: Array<{ __typename?: 'Attribute'; documentId: string; name: string } | null>
    deployments: Array<{ __typename?: 'Installation'; documentId: string; name: string } | null>
    integrations: Array<{ __typename?: 'Integration'; documentId: string; name: string } | null>
    practiceAreas: Array<{ __typename?: 'PracticeArea'; documentId: string; name: string } | null>
    typeOfUser: Array<{ __typename?: 'TypeOfUser'; documentId: string; name?: string | null } | null>
    security: Array<{ __typename?: 'Security'; documentId: string; name: string } | null>
    dataHostingLocations: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
    enhancedListingData?: {
      __typename?: 'ComponentSolutionPropsProductEnhanced'
      pricingData?: string | null
      callToAction?: { __typename?: 'ComponentGlobalCallToAction'; label?: string | null; url?: string | null } | null
      screenshots?: Array<{
        __typename?: 'ComponentGlobalPicture'
        id: string
        title?: string | null
        summary?: string | null
        image?: { __typename?: 'UploadFile'; url: string; id: string } | null
      } | null> | null
      videos?: Array<{
        __typename?: 'ComponentSolutionPropsVideo'
        title?: string | null
        summary?: string | null
        url?: string | null
      } | null> | null
      testimonials?: Array<{
        __typename?: 'ComponentTestimonialsTestimonials'
        id: string
        description?: string | null
        author?: {
          __typename?: 'ComponentTestimonialsPropsAuthor'
          name?: string | null
          role?: string | null
          company?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
        } | null
      } | null> | null
    } | null
  } | null
  consolidationData?: {
    __typename?: 'ComponentSolutionPropsConsolidation'
    date?: any | null
    amount?: number | null
    article?: string | null
    articleLink?: string | null
    originalTargetName?: string | null
    buyer?: string | null
    enableInActiveDir?: boolean | null
  } | null
  graveyardData?: { __typename?: 'ComponentSolutionPropsGraveyard'; date?: any | null } | null
  founders?: Array<{
    __typename?: 'ComponentAboutPropsTeamMember'
    name?: string | null
    role?: string | null
    bio?: string | null
    title?: string | null
    externalLink?: string | null
    avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
  } | null> | null
  vendor?: {
    __typename?: 'Vendor'
    publishedAt?: any | null
    documentId: string
    users: Array<{ __typename?: 'User'; external_id?: string | null } | null>
  } | null
  topics: Array<{ __typename?: 'Topic'; documentId: string; slug: string; name: string } | null>
  subTopics: Array<{
    __typename?: 'SubTopic'
    documentId: string
    slug?: string | null
    name: string
    features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
  } | null>
  logo?: { __typename?: 'UploadFile'; id: string; url: string } | null
  company?: { __typename?: 'Company'; name: string; slug?: string | null } | null
  reviews: Array<{
    __typename?: 'Review'
    anonymous?: boolean | null
    rating?: number | null
    title?: string | null
    content?: string | null
    submitterTitle?: string | null
    submitterSubTitle?: string | null
    solutionDispName?: string | null
    createdAt?: any | null
    updatedAt?: any | null
    publishedAt?: any | null
    solution?: {
      __typename?: 'Solution'
      displayName?: string | null
      slug?: string | null
      rating?: number | null
      company?: { __typename?: 'Company'; slug?: string | null } | null
      logo?: { __typename?: 'UploadFile'; url: string } | null
    } | null
  } | null>
  offices: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
  hqs: Array<{ __typename?: 'Hq'; documentId: string; name: string } | null>
  regionsServed: Array<{ __typename?: 'RegionsServed'; documentId: string; name: string } | null>
  languages: Array<{ __typename?: 'PlatformLanguage'; documentId: string; name: string } | null>
  articles?: Array<{
    __typename?: 'ComponentGlobalArticle'
    id: string
    title?: string | null
    publishedBy?: string | null
    date?: any | null
    link?: string | null
    image?: { __typename?: 'UploadFile'; url: string; id: string } | null
  } | null> | null
  vendorResources?: Array<{
    __typename?: 'ComponentSolutionPropsVendorResource'
    type?: IEnum_Componentsolutionpropsvendorresource_Type | null
    content?: {
      __typename?: 'Content'
      documentId: string
      title: string
      snippet: string
      createdAt?: any | null
      publishedTime?: any | null
      contentType?: IEnum_Content_Contenttype | null
      documentType?: IEnum_Content_Documenttype | null
      isMaintained?: boolean | null
      lastMaintained?: any | null
      slug: string
      publishedAt?: any | null
      subjectMatterIds?: Array<string | null> | null
      themeIds?: Array<string | null> | null
      vendorTopicIds?: Array<string | null> | null
      defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
      blogTaxonomies: Array<{
        __typename?: 'BlogTaxonomy'
        documentId: string
        slug?: string | null
        name?: string | null
      } | null>
      audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
      subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
      writer?: Array<{
        __typename?: 'ComponentContentContentWriter'
        writerOption: IEnum_Componentcontentcontentwriter_Writeroption
        oneTimeAuthorName?: string | null
        author?: {
          __typename?: 'Author'
          firstName: string
          lastName: string
          jobTitle?: string | null
          company?: string | null
          bio?: string | null
          slug?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
        } | null
        expert?: {
          __typename?: 'Expert'
          documentId: string
          firstName: string
          lastName: string
          displayName?: string | null
          title?: string | null
          company?: string | null
          bio?: string | null
          slug?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
          expertiseSubTopics: Array<{
            __typename?: 'SubTopic'
            documentId: string
            name: string
            slug?: string | null
            topics: Array<{
              __typename?: 'Topic'
              documentId: string
              name: string
              description?: string | null
              slug: string
            } | null>
          } | null>
          expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
          contents: Array<{ __typename?: 'Content'; documentId: string } | null>
        } | null
        solution?: {
          __typename?: 'Solution'
          displayName?: string | null
          slug?: string | null
          type: IEnum_Solution_Type
          shortDescription?: string | null
          logo?: { __typename?: 'UploadFile'; url: string } | null
        } | null
      } | null> | null
      themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
      vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
    } | null
    external?: {
      __typename?: 'ComponentSolutionPropsVendorResourceExternal'
      title?: string | null
      summary?: string | null
      link?: string | null
      publishedDate?: any | null
      author?: string | null
      documentType?: IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype | null
    } | null
  } | null> | null
  features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
  existingCustomers: Array<{ __typename?: 'ExistingCustomer'; documentId: string; name: string } | null>
  iltaSponsorships?: Array<{
    __typename?: 'IltaSponsorship'
    documentId: string
    name?: string | null
    logo?: { __typename?: 'UploadFile'; documentId: string; url: string } | null
  } | null>
  announcement: Array<{
    __typename?: 'Announcement'
    id: string
    announcement: string
    optionalLink?: string | null
    publishedAt?: any | null
    documentId: string
    isArchived?: boolean | null
  } | null>
}

export type IProductSolutionEnhancedListingDataFragment = {
  __typename?: 'ComponentSolutionPropsProductEnhanced'
  pricingData?: string | null
  callToAction?: { __typename?: 'ComponentGlobalCallToAction'; label?: string | null; url?: string | null } | null
  screenshots?: Array<{
    __typename?: 'ComponentGlobalPicture'
    id: string
    title?: string | null
    summary?: string | null
    image?: { __typename?: 'UploadFile'; url: string; id: string } | null
  } | null> | null
  videos?: Array<{
    __typename?: 'ComponentSolutionPropsVideo'
    title?: string | null
    summary?: string | null
    url?: string | null
  } | null> | null
  testimonials?: Array<{
    __typename?: 'ComponentTestimonialsTestimonials'
    id: string
    description?: string | null
    author?: {
      __typename?: 'ComponentTestimonialsPropsAuthor'
      name?: string | null
      role?: string | null
      company?: string | null
      avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
    } | null
  } | null> | null
}

export type IGetProductSolutionSecurityDataQueryVariables = Exact<{
  slug: Scalars['String']['input']
}>

export type IGetProductSolutionSecurityDataQuery = {
  __typename?: 'Query'
  solutions: Array<{
    __typename: 'Solution'
    documentId: string
    slug?: string | null
    productData?: {
      __typename: 'ComponentSolutionProductData'
      name?: string | null
      security: Array<{ __typename: 'Security'; documentId: string; name: string } | null>
      dataHostingLocations: Array<{ __typename: 'Office'; documentId: string; name: string } | null>
    } | null
  } | null>
}

export type ISolutionArticleFragment = {
  __typename?: 'ComponentGlobalArticle'
  id: string
  title?: string | null
  publishedBy?: string | null
  date?: any | null
  link?: string | null
  image?: { __typename?: 'UploadFile'; url: string; id: string } | null
}

export type ISolutionAttributeFragment = { __typename?: 'Attribute'; documentId: string; name: string }

export type ISolutionAudienceFragment = { __typename?: 'Demographic'; documentId: string; name: string }

export type ISolutionCallToActionFragment = {
  __typename?: 'ComponentGlobalCallToAction'
  label?: string | null
  url?: string | null
}

export type ISolutionCardDataFragment = {
  __typename?: 'Solution'
  displayName?: string | null
  slug?: string | null
  type: IEnum_Solution_Type
  shortDescription?: string | null
  logo?: { __typename?: 'UploadFile'; url: string } | null
}

export type ISolutionCaseStudyFragment = {
  __typename?: 'ComponentGlobalSuccessStory'
  name?: string | null
  link?: string | null
}

export type ISolutionCompanyFragment = { __typename?: 'Company'; name: string; slug?: string | null }

export type ISolutionConsolidationDataFragment = {
  __typename?: 'ComponentSolutionPropsConsolidation'
  date?: any | null
  amount?: number | null
  article?: string | null
  articleLink?: string | null
  originalTargetName?: string | null
  buyer?: string | null
  enableInActiveDir?: boolean | null
}

export type ISolutionDedicatedResourceFragment = {
  __typename?: 'ComponentSolutionPropsDedicatedResource'
  count?: number | null
  type?: IEnum_Componentsolutionpropsdedicatedresource_Type | null
}

export type ISolutionDeploymentFragment = { __typename?: 'Installation'; documentId: string; name: string }

export type ISolutionExistingCustomerFragment = { __typename?: 'ExistingCustomer'; documentId: string; name: string }

export type ISolutionFeatureFragment = { __typename?: 'Feature'; documentId: string; name?: string | null }

export type ISolutionFounderFragment = {
  __typename?: 'ComponentAboutPropsTeamMember'
  name?: string | null
  role?: string | null
  bio?: string | null
  title?: string | null
  externalLink?: string | null
  avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
}

export type ISolutionGraveyardDataFragment = { __typename?: 'ComponentSolutionPropsGraveyard'; date?: any | null }

export type ISolutionHqFragment = { __typename?: 'Hq'; documentId: string; name: string }

export type ISolutionIltaSponsorshipFragment = {
  __typename?: 'IltaSponsorship'
  documentId: string
  name?: string | null
  logo?: { __typename?: 'UploadFile'; documentId: string; url: string } | null
}

export type ISolutionIntegrationFragment = { __typename?: 'Integration'; documentId: string; name: string }

export type ISolutionLanguageFragment = { __typename?: 'PlatformLanguage'; documentId: string; name: string }

export type ISolutionLogoFragment = { __typename?: 'UploadFile'; id: string; url: string }

export type ISolutionOfficeFragment = { __typename?: 'Office'; documentId: string; name: string }

export type ISolutionPracticeAreaFragment = { __typename?: 'PracticeArea'; documentId: string; name: string }

export type ISolutionRegionsServedFragment = { __typename?: 'RegionsServed'; documentId: string; name: string }

export type ISolutionRequestEnhancedListingDataFragment = {
  __typename?: 'ComponentSolutionRequestPropsProductEnhanced'
  pricingData?: string | null
  screenshots?: Array<{
    __typename?: 'ComponentGlobalPicture'
    id: string
    title?: string | null
    summary?: string | null
    image?: { __typename?: 'UploadFile'; url: string; id: string } | null
  } | null> | null
  videos?: Array<{
    __typename?: 'ComponentSolutionPropsVideo'
    title?: string | null
    summary?: string | null
    url?: string | null
  } | null> | null
  callToAction?: { __typename?: 'ComponentGlobalCallToAction'; label?: string | null; url?: string | null } | null
  testimonials?: Array<{
    __typename?: 'ComponentTestimonialsTestimonials'
    id: string
    description?: string | null
    author?: {
      __typename?: 'ComponentTestimonialsPropsAuthor'
      name?: string | null
      role?: string | null
      company?: string | null
      avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
    } | null
  } | null> | null
}

export type ISolutionRequestDatasFragment = {
  __typename?: 'ComponentSolutionRequestProductData'
  name?: string | null
  fundingAmount?: IEnum_Componentsolutionrequestproductdata_Fundingamount | null
  fundingInfo?: IEnum_Componentsolutionrequestproductdata_Fundinginfo | null
  valueProposition?: string | null
  audiences: Array<{ __typename?: 'Demographic'; documentId: string; name: string } | null>
  attributes: Array<{ __typename?: 'Attribute'; documentId: string; name: string } | null>
  integrations: Array<{ __typename?: 'Integration'; documentId: string; name: string } | null>
  practiceAreas: Array<{ __typename?: 'PracticeArea'; documentId: string; name: string } | null>
  typeOfUser: Array<{ __typename?: 'TypeOfUser'; documentId: string; name?: string | null } | null>
  enhancedListingData?: {
    __typename?: 'ComponentSolutionRequestPropsProductEnhanced'
    pricingData?: string | null
    screenshots?: Array<{
      __typename?: 'ComponentGlobalPicture'
      id: string
      title?: string | null
      summary?: string | null
      image?: { __typename?: 'UploadFile'; url: string; id: string } | null
    } | null> | null
    videos?: Array<{
      __typename?: 'ComponentSolutionPropsVideo'
      title?: string | null
      summary?: string | null
      url?: string | null
    } | null> | null
    callToAction?: { __typename?: 'ComponentGlobalCallToAction'; label?: string | null; url?: string | null } | null
    testimonials?: Array<{
      __typename?: 'ComponentTestimonialsTestimonials'
      id: string
      description?: string | null
      author?: {
        __typename?: 'ComponentTestimonialsPropsAuthor'
        name?: string | null
        role?: string | null
        company?: string | null
        avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
      } | null
    } | null> | null
  } | null
  security: Array<{ __typename?: 'Security'; documentId: string; name: string } | null>
  dataHosting: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
  deployments: Array<{ __typename?: 'Installation'; documentId: string; name: string } | null>
}

export type ISolutionRequestDataFragment = {
  __typename?: 'SolutionRequest'
  id: string
  documentId: string
  website?: string | null
  slug?: string | null
  shortDescription?: string | null
  longDescription?: string | null
  linkedin?: string | null
  twitter?: string | null
  type: IEnum_Solutionrequest_Type
  yearFounded?: number | null
  createdAt?: any | null
  publishedAt?: any | null
  updatedAt?: any | null
  productData?: {
    __typename?: 'ComponentSolutionRequestProductData'
    name?: string | null
    fundingAmount?: IEnum_Componentsolutionrequestproductdata_Fundingamount | null
    fundingInfo?: IEnum_Componentsolutionrequestproductdata_Fundinginfo | null
    valueProposition?: string | null
    audiences: Array<{ __typename?: 'Demographic'; documentId: string; name: string } | null>
    attributes: Array<{ __typename?: 'Attribute'; documentId: string; name: string } | null>
    integrations: Array<{ __typename?: 'Integration'; documentId: string; name: string } | null>
    practiceAreas: Array<{ __typename?: 'PracticeArea'; documentId: string; name: string } | null>
    typeOfUser: Array<{ __typename?: 'TypeOfUser'; documentId: string; name?: string | null } | null>
    enhancedListingData?: {
      __typename?: 'ComponentSolutionRequestPropsProductEnhanced'
      pricingData?: string | null
      screenshots?: Array<{
        __typename?: 'ComponentGlobalPicture'
        id: string
        title?: string | null
        summary?: string | null
        image?: { __typename?: 'UploadFile'; url: string; id: string } | null
      } | null> | null
      videos?: Array<{
        __typename?: 'ComponentSolutionPropsVideo'
        title?: string | null
        summary?: string | null
        url?: string | null
      } | null> | null
      callToAction?: { __typename?: 'ComponentGlobalCallToAction'; label?: string | null; url?: string | null } | null
      testimonials?: Array<{
        __typename?: 'ComponentTestimonialsTestimonials'
        id: string
        description?: string | null
        author?: {
          __typename?: 'ComponentTestimonialsPropsAuthor'
          name?: string | null
          role?: string | null
          company?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
        } | null
      } | null> | null
    } | null
    security: Array<{ __typename?: 'Security'; documentId: string; name: string } | null>
    dataHosting: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
    deployments: Array<{ __typename?: 'Installation'; documentId: string; name: string } | null>
  } | null
  topics: Array<{ __typename?: 'Topic'; documentId: string; slug: string; name: string } | null>
  subTopics: Array<{
    __typename?: 'SubTopic'
    documentId: string
    slug?: string | null
    name: string
    features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
  } | null>
  logo?: { __typename?: 'UploadFile'; id: string; url: string } | null
  offices: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
  hqs: Array<{ __typename?: 'Hq'; documentId: string; name: string } | null>
  regionsServed: Array<{ __typename?: 'RegionsServed'; documentId: string; name: string } | null>
  languages: Array<{ __typename?: 'PlatformLanguage'; documentId: string; name: string } | null>
  articles?: Array<{
    __typename?: 'ComponentGlobalArticle'
    id: string
    title?: string | null
    publishedBy?: string | null
    date?: any | null
    link?: string | null
    image?: { __typename?: 'UploadFile'; url: string; id: string } | null
  } | null> | null
  features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
  existingCustomers: Array<{ __typename?: 'ExistingCustomer'; documentId: string; name: string } | null>
  announcement?: {
    __typename?: 'Announcement'
    documentId: string
    announcement: string
    optionalLink?: string | null
  } | null
}

export type ISolutionReviewFragment = {
  __typename?: 'Review'
  anonymous?: boolean | null
  rating?: number | null
  title?: string | null
  content?: string | null
  submitterTitle?: string | null
  submitterSubTitle?: string | null
  solutionDispName?: string | null
  createdAt?: any | null
  updatedAt?: any | null
  publishedAt?: any | null
  solution?: {
    __typename?: 'Solution'
    displayName?: string | null
    slug?: string | null
    rating?: number | null
    company?: { __typename?: 'Company'; slug?: string | null } | null
    logo?: { __typename?: 'UploadFile'; url: string } | null
  } | null
}

export type ISolutionScreenshotFragment = {
  __typename?: 'ComponentGlobalPicture'
  id: string
  title?: string | null
  summary?: string | null
  image?: { __typename?: 'UploadFile'; url: string; id: string } | null
}

export type ISolutionSharedPortfolioSolutionDataFragment = {
  __typename?: 'SolutionSharedPortfolioSolutionData'
  category?: string | null
  followingSolutionNote?: string | null
  sharedPortfolio?: string | null
  slug?: string | null
  name?: string | null
  portfolioId?: string | null
  organizationId?: string | null
  members?: string | null
}

export type ISolutionSpecialistFragment = {
  __typename?: 'ComponentAboutPropsTeamMember'
  name?: string | null
  role?: string | null
  bio?: string | null
  avatar?: { __typename?: 'UploadFile'; url: string } | null
}

export type ISolutionStoryFragment = {
  __typename?: 'ComponentGlobalSuccessStory'
  name?: string | null
  link?: string | null
}

export type ISolutionSubTopicFragment = {
  __typename?: 'SubTopic'
  documentId: string
  slug?: string | null
  name: string
  features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
}

export type ISolutionTestimonialFragment = {
  __typename?: 'ComponentGlobalTestimonial'
  description?: string | null
  name?: string | null
  role?: string | null
  company?: string | null
  avatar?: { __typename?: 'UploadFile'; url: string } | null
}

export type ISolutionTestimonialEnhancedFragment = {
  __typename?: 'ComponentTestimonialsTestimonials'
  id: string
  description?: string | null
  author?: {
    __typename?: 'ComponentTestimonialsPropsAuthor'
    name?: string | null
    role?: string | null
    company?: string | null
    avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
  } | null
}

export type ISolutionTopicFragment = { __typename?: 'Topic'; documentId: string; slug: string; name: string }

export type ISolutionTypeOfUserFragment = { __typename?: 'TypeOfUser'; documentId: string; name?: string | null }

export type ISolutionVendorResourceFragment = {
  __typename?: 'ComponentSolutionPropsVendorResource'
  type?: IEnum_Componentsolutionpropsvendorresource_Type | null
  content?: {
    __typename?: 'Content'
    documentId: string
    title: string
    snippet: string
    createdAt?: any | null
    publishedTime?: any | null
    contentType?: IEnum_Content_Contenttype | null
    documentType?: IEnum_Content_Documenttype | null
    isMaintained?: boolean | null
    lastMaintained?: any | null
    slug: string
    publishedAt?: any | null
    subjectMatterIds?: Array<string | null> | null
    themeIds?: Array<string | null> | null
    vendorTopicIds?: Array<string | null> | null
    defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
    blogTaxonomies: Array<{
      __typename?: 'BlogTaxonomy'
      documentId: string
      slug?: string | null
      name?: string | null
    } | null>
    audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
    subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
    writer?: Array<{
      __typename?: 'ComponentContentContentWriter'
      writerOption: IEnum_Componentcontentcontentwriter_Writeroption
      oneTimeAuthorName?: string | null
      author?: {
        __typename?: 'Author'
        firstName: string
        lastName: string
        jobTitle?: string | null
        company?: string | null
        bio?: string | null
        slug?: string | null
        avatar?: { __typename?: 'UploadFile'; url: string } | null
      } | null
      expert?: {
        __typename?: 'Expert'
        documentId: string
        firstName: string
        lastName: string
        displayName?: string | null
        title?: string | null
        company?: string | null
        bio?: string | null
        slug?: string | null
        avatar?: { __typename?: 'UploadFile'; url: string } | null
        expertiseSubTopics: Array<{
          __typename?: 'SubTopic'
          documentId: string
          name: string
          slug?: string | null
          topics: Array<{
            __typename?: 'Topic'
            documentId: string
            name: string
            description?: string | null
            slug: string
          } | null>
        } | null>
        expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
        contents: Array<{ __typename?: 'Content'; documentId: string } | null>
      } | null
      solution?: {
        __typename?: 'Solution'
        displayName?: string | null
        slug?: string | null
        type: IEnum_Solution_Type
        shortDescription?: string | null
        logo?: { __typename?: 'UploadFile'; url: string } | null
      } | null
    } | null> | null
    themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
    vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
  } | null
  external?: {
    __typename?: 'ComponentSolutionPropsVendorResourceExternal'
    title?: string | null
    summary?: string | null
    link?: string | null
    publishedDate?: any | null
    author?: string | null
    documentType?: IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype | null
  } | null
}

export type ISolutionVendorResourceExternalFragment = {
  __typename?: 'ComponentSolutionPropsVendorResourceExternal'
  title?: string | null
  summary?: string | null
  link?: string | null
  publishedDate?: any | null
  author?: string | null
  documentType?: IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype | null
}

export type ISolutionVideoFragment = {
  __typename?: 'ComponentSolutionPropsVideo'
  title?: string | null
  summary?: string | null
  url?: string | null
}

export type ISolutionListItemFragment = {
  __typename?: 'SolutionItem'
  documentId: string
  slug: string
  type: IEnum_Solution_Item_Type
  displayName: string
  description?: string | null
  logo?: string | null
  subTopics: Array<string>
  follow: boolean
  rating?: number | null
  reviewCnt?: number | null
  isPremium?: boolean | null
  isStartup?: boolean | null
  isBeta?: boolean | null
  isDiverseLeadership?: boolean | null
  iltaSponsorshipLogo?: string | null
  consolidation?: {
    __typename?: 'ComponentSolutionPropsConsolidation'
    date?: any | null
    amount?: number | null
    article?: string | null
    articleLink?: string | null
    originalTargetName?: string | null
    buyer?: string | null
    enableInActiveDir?: boolean | null
  } | null
  graveyard?: { __typename?: 'ComponentSolutionPropsGraveyard'; date?: any | null } | null
  followedSolutionsData?: {
    __typename?: 'ComponentFollowingSolutionsData'
    followingType?: string | null
    followingSolutionNote?: string | null
    noteCreatedAt?: string | null
    noteCreatedByName?: string | null
    noteLastEditedAt?: string | null
    noteLastEditedByName?: string | null
  } | null
  shared_portfolio_solutions?: Array<{
    __typename?: 'SolutionSharedPortfolioSolutionData'
    category?: string | null
    followingSolutionNote?: string | null
    sharedPortfolio?: string | null
    slug?: string | null
    name?: string | null
    portfolioId?: string | null
    organizationId?: string | null
    members?: string | null
  } | null> | null
  customTagsWithName?: Array<{ __typename?: 'CustomTagItem'; id: string; name: string; slug: string } | null> | null
}

export type ISolutionRequestByIdQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ISolutionRequestByIdQuery = {
  __typename?: 'Query'
  solutionRequest?: {
    __typename?: 'SolutionRequest'
    id: string
    documentId: string
    website?: string | null
    slug?: string | null
    shortDescription?: string | null
    longDescription?: string | null
    linkedin?: string | null
    twitter?: string | null
    type: IEnum_Solutionrequest_Type
    yearFounded?: number | null
    createdAt?: any | null
    publishedAt?: any | null
    updatedAt?: any | null
    productData?: {
      __typename?: 'ComponentSolutionRequestProductData'
      name?: string | null
      fundingAmount?: IEnum_Componentsolutionrequestproductdata_Fundingamount | null
      fundingInfo?: IEnum_Componentsolutionrequestproductdata_Fundinginfo | null
      valueProposition?: string | null
      audiences: Array<{ __typename?: 'Demographic'; documentId: string; name: string } | null>
      attributes: Array<{ __typename?: 'Attribute'; documentId: string; name: string } | null>
      integrations: Array<{ __typename?: 'Integration'; documentId: string; name: string } | null>
      practiceAreas: Array<{ __typename?: 'PracticeArea'; documentId: string; name: string } | null>
      typeOfUser: Array<{ __typename?: 'TypeOfUser'; documentId: string; name?: string | null } | null>
      enhancedListingData?: {
        __typename?: 'ComponentSolutionRequestPropsProductEnhanced'
        pricingData?: string | null
        screenshots?: Array<{
          __typename?: 'ComponentGlobalPicture'
          id: string
          title?: string | null
          summary?: string | null
          image?: { __typename?: 'UploadFile'; url: string; id: string } | null
        } | null> | null
        videos?: Array<{
          __typename?: 'ComponentSolutionPropsVideo'
          title?: string | null
          summary?: string | null
          url?: string | null
        } | null> | null
        callToAction?: { __typename?: 'ComponentGlobalCallToAction'; label?: string | null; url?: string | null } | null
        testimonials?: Array<{
          __typename?: 'ComponentTestimonialsTestimonials'
          id: string
          description?: string | null
          author?: {
            __typename?: 'ComponentTestimonialsPropsAuthor'
            name?: string | null
            role?: string | null
            company?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
          } | null
        } | null> | null
      } | null
      security: Array<{ __typename?: 'Security'; documentId: string; name: string } | null>
      dataHosting: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
      deployments: Array<{ __typename?: 'Installation'; documentId: string; name: string } | null>
    } | null
    topics: Array<{ __typename?: 'Topic'; documentId: string; slug: string; name: string } | null>
    subTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      slug?: string | null
      name: string
      features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
    } | null>
    logo?: { __typename?: 'UploadFile'; id: string; url: string } | null
    offices: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
    hqs: Array<{ __typename?: 'Hq'; documentId: string; name: string } | null>
    regionsServed: Array<{ __typename?: 'RegionsServed'; documentId: string; name: string } | null>
    languages: Array<{ __typename?: 'PlatformLanguage'; documentId: string; name: string } | null>
    articles?: Array<{
      __typename?: 'ComponentGlobalArticle'
      id: string
      title?: string | null
      publishedBy?: string | null
      date?: any | null
      link?: string | null
      image?: { __typename?: 'UploadFile'; url: string; id: string } | null
    } | null> | null
    features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
    existingCustomers: Array<{ __typename?: 'ExistingCustomer'; documentId: string; name: string } | null>
    announcement?: {
      __typename?: 'Announcement'
      documentId: string
      announcement: string
      optionalLink?: string | null
    } | null
  } | null
}

export type ISubTopicFullItemFragment = {
  __typename?: 'SubTopic'
  id: string
  documentId: string
  slug?: string | null
  name: string
  description?: string | null
  isPremium?: boolean | null
  publishedAt?: any | null
  expert?: {
    __typename?: 'Expert'
    documentId: string
    firstName: string
    lastName: string
    displayName?: string | null
    title?: string | null
    company?: string | null
    bio?: string | null
    slug?: string | null
    avatar?: { __typename?: 'UploadFile'; url: string } | null
    expertiseSubTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      name: string
      slug?: string | null
      topics: Array<{
        __typename?: 'Topic'
        documentId: string
        name: string
        description?: string | null
        slug: string
      } | null>
    } | null>
    expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
    contents: Array<{ __typename?: 'Content'; documentId: string } | null>
  } | null
  secondaryExpert?: {
    __typename?: 'Expert'
    documentId: string
    firstName: string
    lastName: string
    displayName?: string | null
    title?: string | null
    company?: string | null
    bio?: string | null
    slug?: string | null
    avatar?: { __typename?: 'UploadFile'; url: string } | null
    expertiseSubTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      name: string
      slug?: string | null
      topics: Array<{
        __typename?: 'Topic'
        documentId: string
        name: string
        description?: string | null
        slug: string
      } | null>
    } | null>
    expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
    contents: Array<{ __typename?: 'Content'; documentId: string } | null>
  } | null
  contents: Array<{ __typename?: 'Content'; documentId: string } | null>
  topics: Array<{
    __typename?: 'Topic'
    documentId: string
    slug: string
    name: string
    iconName?: string | null
    description?: string | null
    isPremium?: boolean | null
    publishedAt?: any | null
  } | null>
  followedUsers: Array<{ __typename?: 'User'; documentId: string; username: string; email: string } | null>
}

export type ISubTopicItemFragment = {
  __typename?: 'SubTopic'
  id: string
  documentId: string
  slug?: string | null
  name: string
  description?: string | null
  isPremium?: boolean | null
  publishedAt?: any | null
  topics: Array<{
    __typename?: 'Topic'
    slug: string
    name: string
    description?: string | null
    iconName?: string | null
    isPremium?: boolean | null
    publishedAt?: any | null
  } | null>
}

export type ISubTopicItemWithoutSubFragment = {
  __typename?: 'SubTopic'
  documentId: string
  slug?: string | null
  name: string
  description?: string | null
  isPremium?: boolean | null
  publishedAt?: any | null
}

export type ITestimonialItemFragment = {
  __typename?: 'Testimonials'
  description?: string | null
  author?: {
    __typename?: 'ComponentTestimonialsPropsAuthor'
    name?: string | null
    role?: string | null
    company?: string | null
    avatar?: { __typename?: 'UploadFile'; url: string } | null
  } | null
}

export type ITopicFullItemFragment = {
  __typename?: 'Topic'
  documentId: string
  slug: string
  name: string
  iconName?: string | null
  description?: string | null
  isPremium?: boolean | null
  publishedAt?: any | null
  expert?: {
    __typename?: 'Expert'
    documentId: string
    firstName: string
    lastName: string
    displayName?: string | null
    title?: string | null
    company?: string | null
    bio?: string | null
    slug?: string | null
    avatar?: { __typename?: 'UploadFile'; url: string } | null
    expertiseSubTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      name: string
      slug?: string | null
      topics: Array<{
        __typename?: 'Topic'
        documentId: string
        name: string
        description?: string | null
        slug: string
      } | null>
    } | null>
    expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
    contents: Array<{ __typename?: 'Content'; documentId: string } | null>
  } | null
  secondaryExpert?: {
    __typename?: 'Expert'
    documentId: string
    firstName: string
    lastName: string
    displayName?: string | null
    title?: string | null
    company?: string | null
    bio?: string | null
    slug?: string | null
    avatar?: { __typename?: 'UploadFile'; url: string } | null
    expertiseSubTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      name: string
      slug?: string | null
      topics: Array<{
        __typename?: 'Topic'
        documentId: string
        name: string
        description?: string | null
        slug: string
      } | null>
    } | null>
    expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
    contents: Array<{ __typename?: 'Content'; documentId: string } | null>
  } | null
  subTopics: Array<{
    __typename?: 'SubTopic'
    documentId: string
    slug?: string | null
    name: string
    description?: string | null
    isPremium?: boolean | null
    publishedAt?: any | null
  } | null>
  contents: Array<{ __typename?: 'Content'; documentId: string } | null>
}

export type ITopicHeaderDataFragment = {
  __typename?: 'Topic'
  slug: string
  name: string
  description?: string | null
  isPremium?: boolean | null
  expert?: {
    __typename?: 'Expert'
    documentId: string
    firstName: string
    lastName: string
    displayName?: string | null
    title?: string | null
    company?: string | null
    bio?: string | null
    slug?: string | null
    avatar?: { __typename?: 'UploadFile'; url: string } | null
    expertiseSubTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      name: string
      slug?: string | null
      topics: Array<{
        __typename?: 'Topic'
        documentId: string
        name: string
        description?: string | null
        slug: string
      } | null>
    } | null>
    expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
    contents: Array<{ __typename?: 'Content'; documentId: string } | null>
  } | null
}

export type ITopicItemFragment = {
  __typename?: 'Topic'
  documentId: string
  slug: string
  name: string
  iconName?: string | null
  description?: string | null
  isPremium?: boolean | null
  publishedAt?: any | null
  subTopics: Array<{
    __typename?: 'SubTopic'
    documentId: string
    slug?: string | null
    name: string
    description?: string | null
    isPremium?: boolean | null
    publishedAt?: any | null
  } | null>
}

export type ITopicItemWithoutSubFragment = {
  __typename?: 'Topic'
  slug: string
  name: string
  description?: string | null
  iconName?: string | null
  isPremium?: boolean | null
  publishedAt?: any | null
}

export type IGetAboutQueryVariables = Exact<{ [key: string]: never }>

export type IGetAboutQuery = {
  __typename?: 'Query'
  about?: {
    __typename?: 'About'
    documentId: string
    createdAt?: any | null
    updatedAt?: any | null
    title?: string | null
    description?: string | null
    who?: string | null
    what?: string | null
    email?: string | null
    phone?: any | null
    publishedAt?: any | null
    ourTeam?: Array<{
      __typename?: 'ComponentAboutPropsTeamMember'
      name?: string | null
      role?: string | null
      bio?: string | null
      externalLink?: string | null
      title?: string | null
      avatar?: { __typename?: 'UploadFile'; url: string } | null
    } | null> | null
  } | null
}

export type IGetAllCompaniesQueryVariables = Exact<{ [key: string]: never }>

export type IGetAllCompaniesQuery = {
  __typename?: 'Query'
  companies: Array<{ __typename?: 'Company'; documentId: string; name: string; slug?: string | null } | null>
}

export type IGetAnnouncementByIdQueryVariables = Exact<{
  documentId: Scalars['ID']['input']
}>

export type IGetAnnouncementByIdQuery = {
  __typename?: 'Query'
  announcements: Array<{
    __typename?: 'Announcement'
    documentId: string
    announcement: string
    optionalLink?: string | null
    publishedAt?: any | null
    isArchived?: boolean | null
    previous_published_at?: any | null
    archived_at?: any | null
  } | null>
}

export type IGetAudiencesQueryVariables = Exact<{ [key: string]: never }>

export type IGetAudiencesQuery = {
  __typename?: 'Query'
  demographics: Array<{ __typename?: 'Demographic'; documentId: string; name: string } | null>
}

export type IGetBannerAnnouncementQueryVariables = Exact<{ [key: string]: never }>

export type IGetBannerAnnouncementQuery = {
  __typename?: 'Query'
  bannerAnnouncement?: {
    __typename?: 'BannerAnnouncement'
    documentId: string
    createdAt?: any | null
    updatedAt?: any | null
    title: string
    externalLink: string
    publishedAt?: any | null
    linkButtonLabel?: string | null
  } | null
}

export type IGetCollectionsQueryVariables = Exact<{ [key: string]: never }>

export type IGetCollectionsQuery = {
  __typename?: 'Query'
  collections: Array<{
    __typename?: 'Collection'
    documentId: string
    name: string
    description?: string | null
    featuredOnHomepage?: boolean | null
    slug?: string | null
    publishedAt?: any | null
    iconName?: { __typename?: 'UploadFile'; documentId: string; url: string } | null
    contents: Array<{
      __typename?: 'Content'
      documentId: string
      title: string
      slug: string
      snippet: string
      isMaintained?: boolean | null
      isPremium?: boolean | null
    } | null>
    solutions: Array<{
      __typename?: 'Solution'
      documentId: string
      displayName?: string | null
      type: IEnum_Solution_Type
      website?: string | null
      isPremium?: boolean | null
      slug?: string | null
      shortDescription?: string | null
      longDescription?: string | null
    } | null>
  } | null>
}

export type IGetCollectionsBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input']
}>

export type IGetCollectionsBySlugQuery = {
  __typename?: 'Query'
  collections: Array<{
    __typename?: 'Collection'
    documentId: string
    name: string
    description?: string | null
    featuredOnHomepage?: boolean | null
    slug?: string | null
    publishedAt?: any | null
    contents: Array<{
      __typename?: 'Content'
      documentId: string
      title: string
      slug: string
      snippet: string
      isMaintained?: boolean | null
      isPremium?: boolean | null
      publishedTime?: any | null
      defaultImage: Array<{ __typename?: 'UploadFile'; documentId: string; url: string } | null>
    } | null>
    solutions: Array<{
      __typename?: 'Solution'
      documentId: string
      displayName?: string | null
      type: IEnum_Solution_Type
      website?: string | null
      isPremium?: boolean | null
      slug?: string | null
      shortDescription?: string | null
      longDescription?: string | null
    } | null>
  } | null>
}

export type IGetCompanyBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input']
  includeIlta: Scalars['Boolean']['input']
}>

export type IGetCompanyBySlugQuery = {
  __typename?: 'Query'
  companies: Array<{
    __typename?: 'Company'
    documentId: string
    slug?: string | null
    name: string
    description: string
    website: string
    services?: string | null
    yearFounded?: any | null
    size?: number | null
    openToInvestment?: boolean | null
    linkedin?: string | null
    twitter?: string | null
    fundingInfo?: IEnum_Company_Fundinginfo | null
    fundingAmount?: IEnum_Company_Fundingamount | null
    fundingDetails?: string | null
    isDiverseLeadership?: boolean | null
    logo?: { __typename?: 'UploadFile'; url: string } | null
    solutions: Array<{ __typename?: 'Solution'; slug?: string | null } | null>
    regionsServed: Array<{ __typename?: 'RegionsServed'; name: string } | null>
    hqs: Array<{ __typename?: 'Hq'; name: string } | null>
    iltaSponsorships?: Array<{
      __typename?: 'IltaSponsorship'
      name?: string | null
      logo?: { __typename?: 'UploadFile'; documentId: string; url: string } | null
    } | null>
    founders?: Array<{
      __typename?: 'ComponentCompanyCompanyFounder'
      id: string
      name?: string | null
      role?: string | null
      experiencedFounder?: boolean | null
      bio?: string | null
      title?: string | null
      externalLink?: string | null
      avatar?: { __typename?: 'UploadFile'; id: string; url: string } | null
    } | null> | null
  } | null>
}

export type IGetCountriesQueryVariables = Exact<{ [key: string]: never }>

export type IGetCountriesQuery = {
  __typename?: 'Query'
  countries: Array<{
    __typename?: 'Country'
    documentId: string
    code: string
    name: string
    alpha2: string
    alpha3?: string | null
  } | null>
}

export type IGetCustomTagBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input']
}>

export type IGetCustomTagBySlugQuery = {
  __typename?: 'Query'
  getCustomTagBySlug?: {
    __typename?: 'CustomTagResult'
    id: string
    name: string
    slug?: string | null
    solutionDocumentIds?: Array<string | null> | null
    portfolioId?: string | null
    isSharedPortfolio?: boolean | null
    sharedPortfolio?: {
      __typename?: 'SharedPortfolioSummary'
      documentId?: string | null
      name?: string | null
      slug?: string | null
    } | null
  } | null
}

export type IGetExistingCustomersPaginationQueryVariables = Exact<{
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  search?: InputMaybe<Scalars['String']['input']>
}>

export type IGetExistingCustomersPaginationQuery = {
  __typename?: 'Query'
  existingCustomers: Array<{ __typename?: 'ExistingCustomer'; documentId: string; name: string } | null>
}

export type IGetDurationsQueryVariables = Exact<{ [key: string]: never }>

export type IGetDurationsQuery = {
  __typename?: 'Query'
  durations: Array<{ __typename?: 'Duration'; documentId: string; name: string; days?: number | null } | null>
}

export type IGetEnhancedRequestContentQueryVariables = Exact<{ [key: string]: never }>

export type IGetEnhancedRequestContentQuery = {
  __typename?: 'Query'
  enhancedRequestContent?: {
    __typename?: 'EnhancedRequestContent'
    createdAt?: any | null
    updatedAt?: any | null
    title?: string | null
    description?: string | null
    moreVisibility?: string | null
    callToAction?: string | null
    screenshots?: string | null
    competitor?: string | null
    publishedAt?: any | null
  } | null
}

export type IEventsQueryVariables = Exact<{ [key: string]: never }>

export type IEventsQuery = {
  __typename?: 'Query'
  events: Array<{
    __typename?: 'Event'
    documentId: string
    title: string
    updatedAt?: any | null
    date?: any | null
    description?: string | null
    country: string
    city?: string | null
    featured?: boolean | null
    slug: string
    logo?: { __typename?: 'UploadFile'; url: string } | null
    durationId?: { __typename?: 'Duration'; documentId: string; name: string; days?: number | null } | null
    formatId?: { __typename?: 'EventFormat'; documentId: string; name: string } | null
    features: Array<{ __typename?: 'EventFeature'; documentId: string; name: string } | null>
    audiences: Array<{ __typename?: 'Audience'; documentId: string; name: string } | null>
  } | null>
}

export type IGetEventsByOffsetQueryVariables = Exact<{
  start?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type IGetEventsByOffsetQuery = {
  __typename?: 'Query'
  events: Array<{
    __typename?: 'Event'
    documentId: string
    title: string
    date?: any | null
    updatedAt?: any | null
    description?: string | null
    country: string
    city?: string | null
    featured?: boolean | null
    slug: string
    logo?: { __typename?: 'UploadFile'; url: string } | null
    durationId?: { __typename?: 'Duration'; documentId: string; name: string } | null
    formatId?: { __typename?: 'EventFormat'; documentId: string; name: string } | null
    features: Array<{ __typename?: 'EventFeature'; documentId: string; name: string } | null>
    audiences: Array<{ __typename?: 'Audience'; documentId: string; name: string } | null>
  } | null>
}

export type IGetEventsBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input']
}>

export type IGetEventsBySlugQuery = {
  __typename?: 'Query'
  events: Array<{
    __typename?: 'Event'
    documentId: string
    slug: string
    createdAt?: any | null
    updatedAt?: any | null
    date?: any | null
    title: string
    website: string
    description?: string | null
    organizer: string
    notes?: string | null
    country: string
    city?: string | null
    featured?: boolean | null
    logo?: { __typename?: 'UploadFile'; url: string } | null
    formatId?: { __typename?: 'EventFormat'; documentId: string; name: string } | null
    audiences: Array<{ __typename?: 'Audience'; documentId: string; name: string } | null>
    durationId?: { __typename?: 'Duration'; documentId: string; name: string } | null
    recurrenceId?: { __typename?: 'Recurrence'; documentId: string; name: string } | null
  } | null>
}

export type IGetExistingCustomersQueryVariables = Exact<{ [key: string]: never }>

export type IGetExistingCustomersQuery = {
  __typename?: 'Query'
  existingCustomers: Array<{ __typename?: 'ExistingCustomer'; documentId: string; name: string } | null>
}

export type IGetAttributesQueryVariables = Exact<{ [key: string]: never }>

export type IGetAttributesQuery = {
  __typename?: 'Query'
  attributes: Array<{ __typename?: 'Attribute'; documentId: string; name: string } | null>
}

export type IGetFollowingTopicsQueryVariables = Exact<{ [key: string]: never }>

export type IGetFollowingTopicsQuery = {
  __typename?: 'Query'
  followingTopics?: Array<{
    __typename?: 'FollowingTopicEntity'
    documentId?: string | null
    name: string
    slug: string
    isPremium?: boolean | null
    iconName?: string | null
    description?: string | null
    featuredOnHome?: boolean | null
    createdAt?: any | null
    updatedAt?: any | null
    publishedAt?: any | null
    subTopics?: Array<{
      __typename?: 'SubtopicItem'
      id: string
      documentId?: string | null
      name: string
      slug: string
      description?: string | null
      featuredOnHome?: boolean | null
      isPremium?: boolean | null
    } | null> | null
  } | null> | null
}

export type IGetFormatsQueryVariables = Exact<{ [key: string]: never }>

export type IGetFormatsQuery = {
  __typename?: 'Query'
  eventFormats: Array<{ __typename?: 'EventFormat'; documentId: string; name: string } | null>
}

export type IGetIltaSponsorshipsQueryVariables = Exact<{ [key: string]: never }>

export type IGetIltaSponsorshipsQuery = {
  __typename?: 'Query'
  iltaSponsorships: Array<{
    __typename?: 'IltaSponsorship'
    documentId: string
    name?: string | null
    level?: number | null
    description?: string | null
    logo?: { __typename?: 'UploadFile'; url: string } | null
  } | null>
}

export type IGetInstallationsQueryVariables = Exact<{ [key: string]: never }>

export type IGetInstallationsQuery = {
  __typename?: 'Query'
  installations: Array<{ __typename?: 'Installation'; documentId: string; name: string } | null>
}

export type IGetIntegrationsQueryVariables = Exact<{ [key: string]: never }>

export type IGetIntegrationsQuery = {
  __typename?: 'Query'
  integrations: Array<{ __typename?: 'Integration'; documentId: string; name: string } | null>
}

export type IGetIntegrationsPaginationQueryVariables = Exact<{
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  search?: InputMaybe<Scalars['String']['input']>
}>

export type IGetIntegrationsPaginationQuery = {
  __typename?: 'Query'
  integrations: Array<{ __typename?: 'Integration'; documentId: string; name: string } | null>
}

export type IGetInvitedUsersQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']['input']>
}>

export type IGetInvitedUsersQuery = {
  __typename?: 'Query'
  invitedUsers: {
    __typename?: 'invitedUsersResult'
    total?: number | null
    invitations?: Array<{
      __typename?: 'ResourceInvitationEntity'
      documentId: string
      name: string
      businessEmail: string
      companyLawFirmName: string
      dateInvited: any
      status: boolean
      contents: Array<{
        __typename?: 'SharedResourceEntity'
        documentId?: string | null
        title?: string | null
        slug?: string | null
        sharedResources: {
          __typename?: 'ContentVisitDownloadCountResult'
          visits?: Array<{
            __typename?: 'ContentVisit'
            visited_by?: { __typename?: 'User'; documentId: string; username: string } | null
          } | null> | null
          downloads?: Array<{
            __typename?: 'ContentDownload'
            downloaded_by?: { __typename?: 'User'; documentId: string; username: string } | null
          } | null> | null
        }
      } | null>
    } | null> | null
  }
}

export type IGetLanguagesQueryVariables = Exact<{ [key: string]: never }>

export type IGetLanguagesQuery = {
  __typename?: 'Query'
  platformLanguages: Array<{ __typename?: 'PlatformLanguage'; documentId: string; name: string } | null>
}

export type IGetLanguagesPaginationQueryVariables = Exact<{
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  search?: InputMaybe<Scalars['String']['input']>
}>

export type IGetLanguagesPaginationQuery = {
  __typename?: 'Query'
  platformLanguages: Array<{ __typename?: 'PlatformLanguage'; documentId: string; name: string } | null>
}

export type IGetLocationsQueryVariables = Exact<{ [key: string]: never }>

export type IGetLocationsQuery = { __typename?: 'Query'; location?: Array<string | null> | null }

export type IGetMyCustomTagsQueryVariables = Exact<{ [key: string]: never }>

export type IGetMyCustomTagsQuery = {
  __typename?: 'Query'
  getMyCustomTags: Array<{
    __typename?: 'CustomTagResult'
    id: string
    name: string
    slug?: string | null
    solutionIds?: Array<string | null> | null
    solutionDocumentIds?: Array<string | null> | null
    portfolioId?: string | null
  }>
}

export type IGetMyResourcesProductTypesQueryVariables = Exact<{ [key: string]: never }>

export type IGetMyResourcesProductTypesQuery = {
  __typename?: 'Query'
  myResourcesProductTypes: {
    __typename?: 'ShareableTopicsReturnType'
    topics: Array<{
      __typename?: 'ShareableTopicInfo'
      id: number
      name: string
      isPremium?: boolean | null
      subTopics?: Array<{
        __typename?: 'SubTopicInfo'
        id?: number | null
        name: string
        isPremium?: boolean | null
      }> | null
    }>
  }
}

export type IGetNewsletterCategoriesQueryVariables = Exact<{ [key: string]: never }>

export type IGetNewsletterCategoriesQuery = {
  __typename?: 'Query'
  newsletterCategories: Array<{ __typename?: 'NewsletterCategory'; documentId: string; name?: string | null } | null>
}

export type IGetOfficesQueryVariables = Exact<{ [key: string]: never }>

export type IGetOfficesQuery = {
  __typename?: 'Query'
  offices: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
}

export type IGetOfficesPaginationQueryVariables = Exact<{
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  search?: InputMaybe<Scalars['String']['input']>
}>

export type IGetOfficesPaginationQuery = {
  __typename?: 'Query'
  offices: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
}

export type IGetOrganizationQueryVariables = Exact<{ [key: string]: never }>

export type IGetOrganizationQuery = { __typename?: 'Query'; organization?: Array<string | null> | null }

export type IGetOrganizationNamesQueryVariables = Exact<{ [key: string]: never }>

export type IGetOrganizationNamesQuery = {
  __typename?: 'Query'
  premiumOrganizations: Array<{ __typename?: 'PremiumOrganization'; name: string } | null>
}

export type IPhasesQueryVariables = Exact<{ [key: string]: never }>

export type IPhasesQuery = {
  __typename?: 'Query'
  phases: Array<{ __typename?: 'Phase'; documentId: string; title: string; description?: string | null } | null>
}

export type IGetPracticeAreasQueryVariables = Exact<{ [key: string]: never }>

export type IGetPracticeAreasQuery = {
  __typename?: 'Query'
  practiceAreas: Array<{ __typename?: 'PracticeArea'; documentId: string; name: string } | null>
}

export type IGetPracticeAreasPaginationQueryVariables = Exact<{
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  search?: InputMaybe<Scalars['String']['input']>
}>

export type IGetPracticeAreasPaginationQuery = {
  __typename?: 'Query'
  practiceAreas: Array<{ __typename?: 'PracticeArea'; documentId: string; name: string } | null>
}

export type IGetPremiumOrganizationsByDomainEmailQueryVariables = Exact<{
  domainEmail: Scalars['String']['input']
}>

export type IGetPremiumOrganizationsByDomainEmailQuery = {
  __typename?: 'Query'
  premiumOrganizations: Array<{ __typename?: 'PremiumOrganization'; name: string } | null>
}

export type IGetPricingPlansQueryVariables = Exact<{ [key: string]: never }>

export type IGetPricingPlansQuery = {
  __typename?: 'Query'
  premiumPricingPlans: Array<{
    __typename?: 'PremiumPricingPlan'
    documentId: string
    name: string
    pricePerYear: number
    stripeRedirectUrl: string
  } | null>
}

export type IGetPrivacyPolicyQueryVariables = Exact<{ [key: string]: never }>

export type IGetPrivacyPolicyQuery = {
  __typename?: 'Query'
  privacyPolicy?: {
    __typename?: 'PrivacyPolicy'
    summary?: string | null
    content?: string | null
    date?: any | null
  } | null
}

export type IGetRegionsServedQueryVariables = Exact<{ [key: string]: never }>

export type IGetRegionsServedQuery = {
  __typename?: 'Query'
  regionsServeds: Array<{ __typename?: 'RegionsServed'; documentId: string; name: string } | null>
}

export type IGetRelatedSubtopicTopicsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']['input']>
}>

export type IGetRelatedSubtopicTopicsQuery = {
  __typename?: 'Query'
  relatedSubtopicTopics?: Array<{
    __typename?: 'FollowingTopicEntity'
    documentId?: string | null
    name: string
    slug: string
    isPremium?: boolean | null
    iconName?: string | null
    description?: string | null
    featuredOnHome?: boolean | null
    createdAt?: any | null
    updatedAt?: any | null
    publishedAt?: any | null
    subTopics?: Array<{
      __typename?: 'SubtopicItem'
      id: string
      documentId?: string | null
      name: string
      slug: string
      description?: string | null
      featuredOnHome?: boolean | null
      isPremium?: boolean | null
    } | null> | null
  } | null> | null
}

export type IGetSsoOrganizationCognitoProvidersQueryVariables = Exact<{ [key: string]: never }>

export type IGetSsoOrganizationCognitoProvidersQuery = {
  __typename?: 'Query'
  premiumOrganizations: Array<{ __typename?: 'PremiumOrganization'; cognitoProviderId?: string | null } | null>
}

export type IGetSecuritiesQueryVariables = Exact<{ [key: string]: never }>

export type IGetSecuritiesQuery = {
  __typename?: 'Query'
  securities: Array<{ __typename?: 'Security'; id?: number | null; name: string } | null>
}

export type IGetShareableContentsQueryVariables = Exact<{
  offset: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  query: IMySharedContentsFilters
}>

export type IGetShareableContentsQuery = {
  __typename?: 'Query'
  shareableContents: {
    __typename?: 'ShareableContentsReturnType'
    total?: number | null
    contents?: Array<{
      __typename?: 'ContentEntity'
      id?: string | null
      attributes?: {
        __typename?: 'Content'
        documentId: string
        title: string
        snippet: string
        createdAt?: any | null
        publishedTime?: any | null
        contentType?: IEnum_Content_Contenttype | null
        documentType?: IEnum_Content_Documenttype | null
        isMaintained?: boolean | null
        lastMaintained?: any | null
        slug: string
        publishedAt?: any | null
        subjectMatterIds?: Array<string | null> | null
        themeIds?: Array<string | null> | null
        vendorTopicIds?: Array<string | null> | null
        defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
        blogTaxonomies: Array<{
          __typename?: 'BlogTaxonomy'
          documentId: string
          slug?: string | null
          name?: string | null
        } | null>
        audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
        subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
        writer?: Array<{
          __typename?: 'ComponentContentContentWriter'
          writerOption: IEnum_Componentcontentcontentwriter_Writeroption
          oneTimeAuthorName?: string | null
          author?: {
            __typename?: 'Author'
            firstName: string
            lastName: string
            jobTitle?: string | null
            company?: string | null
            bio?: string | null
            slug?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string } | null
          } | null
          expert?: {
            __typename?: 'Expert'
            documentId: string
            firstName: string
            lastName: string
            displayName?: string | null
            title?: string | null
            company?: string | null
            bio?: string | null
            slug?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string } | null
            expertiseSubTopics: Array<{
              __typename?: 'SubTopic'
              documentId: string
              name: string
              slug?: string | null
              topics: Array<{
                __typename?: 'Topic'
                documentId: string
                name: string
                description?: string | null
                slug: string
              } | null>
            } | null>
            expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
            contents: Array<{ __typename?: 'Content'; documentId: string } | null>
          } | null
          solution?: {
            __typename?: 'Solution'
            displayName?: string | null
            slug?: string | null
            type: IEnum_Solution_Type
            shortDescription?: string | null
            logo?: { __typename?: 'UploadFile'; url: string } | null
          } | null
        } | null> | null
        themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
        vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
      } | null
    }> | null
  }
}

export type IGetShareableTopicsQueryVariables = Exact<{ [key: string]: never }>

export type IGetShareableTopicsQuery = {
  __typename?: 'Query'
  shareableTopics: {
    __typename?: 'ShareableTopicsReturnType'
    topics: Array<{
      __typename?: 'ShareableTopicInfo'
      id: number
      name: string
      isPremium?: boolean | null
      subTopics?: Array<{
        __typename?: 'SubTopicInfo'
        id?: number | null
        name: string
        isPremium?: boolean | null
      }> | null
    }>
  }
}

export type IGetSharedPortfolioBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>
  sharedPortfolioId?: InputMaybe<Scalars['ID']['input']>
}>

export type IGetSharedPortfolioBySlugQuery = {
  __typename?: 'Query'
  sharedPortfoliosForMyOrganization: {
    __typename?: 'SharedPortfoliosForMyOrganizationPayload'
    portfolios: Array<{
      __typename?: 'SharedPortfolioEntity'
      id?: string | null
      attributes?: {
        __typename?: 'SharedPortfolio'
        documentId: string
        name: string
        slug?: string | null
        isSharedPortfolio?: boolean | null
        createdByUser?: {
          __typename?: 'User'
          documentId: string
          username: string
          email: string
          companyName?: string | null
          jobTitle?: string | null
          companyType?: IEnum_User_Companytype | null
          premiumOrganization?: {
            __typename?: 'PremiumOrganization'
            documentId: string
            name: string
            emailDomain: string
          } | null
          country?: { __typename?: 'Country'; documentId: string; name: string } | null
          role?: { __typename?: 'UsersPermissionsRole'; name: string; type?: string | null } | null
          vendor?: { __typename?: 'Vendor'; documentId: string; name: string; email?: string | null } | null
        } | null
        lastModifiedByUser?: { __typename?: 'User'; documentId: string; username: string; email: string } | null
        shared_portfolio_memberships: Array<{
          __typename?: 'SharedPortfolioMembership'
          documentId: string
          role: IEnum_Sharedportfoliomembership_Role
          isActive?: boolean | null
          user?: {
            __typename?: 'User'
            documentId: string
            username: string
            email: string
            companyName?: string | null
            jobTitle?: string | null
            companyType?: IEnum_User_Companytype | null
            premiumOrganization?: {
              __typename?: 'PremiumOrganization'
              documentId: string
              name: string
              emailDomain: string
            } | null
            country?: { __typename?: 'Country'; documentId: string; name: string } | null
            role?: { __typename?: 'UsersPermissionsRole'; name: string; type?: string | null } | null
            vendor?: { __typename?: 'Vendor'; documentId: string; name: string; email?: string | null } | null
          } | null
        } | null>
        shared_portfolio_solutions: Array<{
          __typename?: 'SharedPortfolioSolution'
          documentId: string
          category?: IEnum_Sharedportfoliosolution_Category | null
          followingSolutionNote?: string | null
          createdAt?: any | null
          updatedAt?: any | null
          solution?: {
            __typename?: 'Solution'
            documentId: string
            id: string
            displayName?: string | null
            slug?: string | null
            isPremium?: boolean | null
          } | null
          sharedPortfolio?: { __typename?: 'SharedPortfolio'; documentId: string; name: string } | null
          lastModifiedByUser?: {
            __typename?: 'User'
            documentId: string
            username: string
            email: string
            companyName?: string | null
          } | null
        } | null>
      } | null
    }>
  }
}

export type IGetSharedPortfolioTopicsQueryVariables = Exact<{
  sharedPortfolioSlug?: InputMaybe<Scalars['String']['input']>
  sharedPortfolioId?: InputMaybe<Scalars['ID']['input']>
}>

export type IGetSharedPortfolioTopicsQuery = {
  __typename?: 'Query'
  sharedPortfolioTopics?: Array<{
    __typename?: 'FollowingTopicEntity'
    documentId?: string | null
    name: string
    slug: string
    isPremium?: boolean | null
    iconName?: string | null
    description?: string | null
    featuredOnHome?: boolean | null
    createdAt?: any | null
    updatedAt?: any | null
    publishedAt?: any | null
    subTopics?: Array<{
      __typename?: 'SubtopicItem'
      id: string
      documentId?: string | null
      name: string
      slug: string
      description?: string | null
      featuredOnHome?: boolean | null
      isPremium?: boolean | null
    } | null> | null
  } | null> | null
}

export type IGetSlugUpdatesQueryVariables = Exact<{
  type: Scalars['String']['input']
  oldSlug: Scalars['String']['input']
}>

export type IGetSlugUpdatesQuery = {
  __typename?: 'Query'
  slugUpdates: Array<{ __typename?: 'SlugUpdate'; newSlug?: string | null } | null>
}

export type ISolutionsForVendorQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']['input']>
}>

export type ISolutionsForVendorQuery = {
  __typename?: 'Query'
  searchVendorSolutions: {
    __typename?: 'SearchSolutionsResult'
    total?: number | null
    solutions?: Array<{
      __typename?: 'SolutionItem'
      id?: number | null
      documentId: string
      slug: string
      type: IEnum_Solution_Item_Type
      displayName: string
      isPremium?: boolean | null
      isStartup?: boolean | null
      isBeta?: boolean | null
      isDiverseLeadership?: boolean | null
      subTopics: Array<string>
      rating?: number | null
      reviewCnt?: number | null
      description?: string | null
      logo?: string | null
      valueProposition?: string | null
      offices?: Array<{ __typename?: 'Office'; id: string; name: string } | null> | null
      security?: Array<{ __typename?: 'Security'; id?: number | null; name: string } | null> | null
    } | null> | null
  }
}

export type IGetSubTopicBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input']
}>

export type IGetSubTopicBySlugQuery = {
  __typename?: 'Query'
  subTopics: Array<{
    __typename?: 'SubTopic'
    id: string
    documentId: string
    slug?: string | null
    name: string
    description?: string | null
    isPremium?: boolean | null
    publishedAt?: any | null
    expert?: {
      __typename?: 'Expert'
      documentId: string
      firstName: string
      lastName: string
      displayName?: string | null
      title?: string | null
      company?: string | null
      bio?: string | null
      slug?: string | null
      avatar?: { __typename?: 'UploadFile'; url: string } | null
      expertiseSubTopics: Array<{
        __typename?: 'SubTopic'
        documentId: string
        name: string
        slug?: string | null
        topics: Array<{
          __typename?: 'Topic'
          documentId: string
          name: string
          description?: string | null
          slug: string
        } | null>
      } | null>
      expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
      contents: Array<{ __typename?: 'Content'; documentId: string } | null>
    } | null
    secondaryExpert?: {
      __typename?: 'Expert'
      documentId: string
      firstName: string
      lastName: string
      displayName?: string | null
      title?: string | null
      company?: string | null
      bio?: string | null
      slug?: string | null
      avatar?: { __typename?: 'UploadFile'; url: string } | null
      expertiseSubTopics: Array<{
        __typename?: 'SubTopic'
        documentId: string
        name: string
        slug?: string | null
        topics: Array<{
          __typename?: 'Topic'
          documentId: string
          name: string
          description?: string | null
          slug: string
        } | null>
      } | null>
      expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
      contents: Array<{ __typename?: 'Content'; documentId: string } | null>
    } | null
    contents: Array<{ __typename?: 'Content'; documentId: string } | null>
    topics: Array<{
      __typename?: 'Topic'
      documentId: string
      slug: string
      name: string
      iconName?: string | null
      description?: string | null
      isPremium?: boolean | null
      publishedAt?: any | null
    } | null>
    followedUsers: Array<{ __typename?: 'User'; documentId: string; username: string; email: string } | null>
  } | null>
}

export type IGetSubTopicsQueryVariables = Exact<{
  start: Scalars['Int']['input']
}>

export type IGetSubTopicsQuery = {
  __typename?: 'Query'
  subTopics: Array<{
    __typename?: 'SubTopic'
    id: string
    documentId: string
    slug?: string | null
    name: string
    description?: string | null
    isPremium?: boolean | null
    publishedAt?: any | null
    topics: Array<{
      __typename?: 'Topic'
      slug: string
      name: string
      description?: string | null
      iconName?: string | null
      isPremium?: boolean | null
      publishedAt?: any | null
    } | null>
  } | null>
}

export type IGetFeaturesQueryVariables = Exact<{ [key: string]: never }>

export type IGetFeaturesQuery = {
  __typename?: 'Query'
  subTopics: Array<{
    __typename?: 'SubTopic'
    features: Array<{ __typename?: 'Feature'; name?: string | null } | null>
  } | null>
}

export type IGetSubjectMatterQueryVariables = Exact<{ [key: string]: never }>

export type IGetSubjectMatterQuery = {
  __typename?: 'Query'
  subjectMatters: Array<{
    __typename?: 'SubjectMatter'
    documentId: string
    name?: string | null
    slug?: string | null
    description?: string | null
  } | null>
}

export type IGetTermsConditionsQueryVariables = Exact<{ [key: string]: never }>

export type IGetTermsConditionsQuery = {
  __typename?: 'Query'
  termsConditions?: {
    __typename?: 'TermsConditions'
    summary?: string | null
    content?: string | null
    date?: any | null
  } | null
}

export type IGetThemeQueryVariables = Exact<{ [key: string]: never }>

export type IGetThemeQuery = {
  __typename?: 'Query'
  themes: Array<{
    __typename?: 'Theme'
    documentId: string
    name?: string | null
    slug?: string | null
    description?: string | null
  } | null>
}

export type IGetTopicBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input']
}>

export type IGetTopicBySlugQuery = {
  __typename?: 'Query'
  topics: Array<{
    __typename?: 'Topic'
    documentId: string
    slug: string
    name: string
    iconName?: string | null
    description?: string | null
    isPremium?: boolean | null
    publishedAt?: any | null
    expert?: {
      __typename?: 'Expert'
      documentId: string
      firstName: string
      lastName: string
      displayName?: string | null
      title?: string | null
      company?: string | null
      bio?: string | null
      slug?: string | null
      avatar?: { __typename?: 'UploadFile'; url: string } | null
      expertiseSubTopics: Array<{
        __typename?: 'SubTopic'
        documentId: string
        name: string
        slug?: string | null
        topics: Array<{
          __typename?: 'Topic'
          documentId: string
          name: string
          description?: string | null
          slug: string
        } | null>
      } | null>
      expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
      contents: Array<{ __typename?: 'Content'; documentId: string } | null>
    } | null
    secondaryExpert?: {
      __typename?: 'Expert'
      documentId: string
      firstName: string
      lastName: string
      displayName?: string | null
      title?: string | null
      company?: string | null
      bio?: string | null
      slug?: string | null
      avatar?: { __typename?: 'UploadFile'; url: string } | null
      expertiseSubTopics: Array<{
        __typename?: 'SubTopic'
        documentId: string
        name: string
        slug?: string | null
        topics: Array<{
          __typename?: 'Topic'
          documentId: string
          name: string
          description?: string | null
          slug: string
        } | null>
      } | null>
      expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
      contents: Array<{ __typename?: 'Content'; documentId: string } | null>
    } | null
    subTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      slug?: string | null
      name: string
      description?: string | null
      isPremium?: boolean | null
      publishedAt?: any | null
    } | null>
    contents: Array<{ __typename?: 'Content'; documentId: string } | null>
  } | null>
}

export type IGetTopicsQueryVariables = Exact<{ [key: string]: never }>

export type IGetTopicsQuery = {
  __typename?: 'Query'
  topics: Array<{
    __typename?: 'Topic'
    documentId: string
    slug: string
    name: string
    iconName?: string | null
    description?: string | null
    isPremium?: boolean | null
    publishedAt?: any | null
    subTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      slug?: string | null
      name: string
      description?: string | null
      isPremium?: boolean | null
      publishedAt?: any | null
    } | null>
  } | null>
}

export type IGetTopicsForHeaderQueryVariables = Exact<{ [key: string]: never }>

export type IGetTopicsForHeaderQuery = {
  __typename?: 'Query'
  topics: Array<{
    __typename?: 'Topic'
    documentId: string
    slug: string
    name: string
    iconName?: string | null
    description?: string | null
    isPremium?: boolean | null
    publishedAt?: any | null
    subTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      slug?: string | null
      name: string
      description?: string | null
      isPremium?: boolean | null
      publishedAt?: any | null
    } | null>
  } | null>
}

export type IGetTopicsWithoutSubsQueryVariables = Exact<{ [key: string]: never }>

export type IGetTopicsWithoutSubsQuery = {
  __typename?: 'Query'
  topics: Array<{
    __typename?: 'Topic'
    name: string
    slug: string
    iconName?: string | null
    isPremium?: boolean | null
    subTopics: Array<{ __typename?: 'SubTopic'; name: string; slug?: string | null } | null>
  } | null>
}

export type IGetTypeOfUsersQueryVariables = Exact<{ [key: string]: never }>

export type IGetTypeOfUsersQuery = {
  __typename?: 'Query'
  typeOfUsers: Array<{ __typename?: 'TypeOfUser'; documentId: string; name?: string | null } | null>
}

export type IGetVendorTopicsQueryVariables = Exact<{ [key: string]: never }>

export type IGetVendorTopicsQuery = {
  __typename?: 'Query'
  vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
}

export type IGlobalTestimonialsQueryVariables = Exact<{ [key: string]: never }>

export type IGlobalTestimonialsQuery = {
  __typename?: 'Query'
  testimonialsPlural: Array<{
    __typename?: 'Testimonials'
    description?: string | null
    author?: {
      __typename?: 'ComponentTestimonialsPropsAuthor'
      name?: string | null
      role?: string | null
      company?: string | null
      avatar?: { __typename?: 'UploadFile'; url: string } | null
    } | null
  } | null>
}

export type IHqsQueryVariables = Exact<{ [key: string]: never }>

export type IHqsQuery = {
  __typename?: 'Query'
  hqs: Array<{ __typename?: 'Hq'; documentId: string; name: string } | null>
}

export type IHqsPaginationQueryVariables = Exact<{
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  search?: InputMaybe<Scalars['String']['input']>
}>

export type IHqsPaginationQuery = {
  __typename?: 'Query'
  hqs: Array<{ __typename?: 'Hq'; documentId: string; name: string } | null>
}

export type IIsFollowQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>
}>

export type IIsFollowQuery = { __typename?: 'Query'; isFollow?: string | null }

export type IIsUserInConfigQueryVariables = Exact<{ [key: string]: never }>

export type IIsUserInConfigQuery = { __typename?: 'Query'; isUserInConfig: boolean }

export type ILoginMutationVariables = Exact<{
  input: IUsersPermissionsLoginInput
}>

export type ILoginMutation = {
  __typename?: 'Mutation'
  login: {
    __typename?: 'UsersPermissionsLoginPayload'
    jwt?: string | null
    user: {
      __typename?: 'UsersPermissionsMe'
      id: string
      username: string
      email?: string | null
      confirmed?: boolean | null
    }
  }
}

export type IMySharedContentsQueryVariables = Exact<{
  offset: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  query: IMySharedContentsFilters
}>

export type IMySharedContentsQuery = {
  __typename?: 'Query'
  mySharedContents: {
    __typename?: 'MySharedContentsReturnType'
    total: number
    contents: Array<{
      __typename?: 'ContentEntity'
      id?: string | null
      attributes?: {
        __typename?: 'Content'
        documentId: string
        title: string
        snippet: string
        createdAt?: any | null
        publishedTime?: any | null
        contentType?: IEnum_Content_Contenttype | null
        documentType?: IEnum_Content_Documenttype | null
        isMaintained?: boolean | null
        lastMaintained?: any | null
        slug: string
        publishedAt?: any | null
        subjectMatterIds?: Array<string | null> | null
        themeIds?: Array<string | null> | null
        vendorTopicIds?: Array<string | null> | null
        defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
        blogTaxonomies: Array<{
          __typename?: 'BlogTaxonomy'
          documentId: string
          slug?: string | null
          name?: string | null
        } | null>
        audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
        subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
        writer?: Array<{
          __typename?: 'ComponentContentContentWriter'
          writerOption: IEnum_Componentcontentcontentwriter_Writeroption
          oneTimeAuthorName?: string | null
          author?: {
            __typename?: 'Author'
            firstName: string
            lastName: string
            jobTitle?: string | null
            company?: string | null
            bio?: string | null
            slug?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string } | null
          } | null
          expert?: {
            __typename?: 'Expert'
            documentId: string
            firstName: string
            lastName: string
            displayName?: string | null
            title?: string | null
            company?: string | null
            bio?: string | null
            slug?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string } | null
            expertiseSubTopics: Array<{
              __typename?: 'SubTopic'
              documentId: string
              name: string
              slug?: string | null
              topics: Array<{
                __typename?: 'Topic'
                documentId: string
                name: string
                description?: string | null
                slug: string
              } | null>
            } | null>
            expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
            contents: Array<{ __typename?: 'Content'; documentId: string } | null>
          } | null
          solution?: {
            __typename?: 'Solution'
            displayName?: string | null
            slug?: string | null
            type: IEnum_Solution_Type
            shortDescription?: string | null
            logo?: { __typename?: 'UploadFile'; url: string } | null
          } | null
        } | null> | null
        themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
        vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
      } | null
    }>
  }
}

export type IPhasesForSubTopicQueryVariables = Exact<{ [key: string]: never }>

export type IPhasesForSubTopicQuery = {
  __typename?: 'Query'
  phases: Array<{ __typename?: 'Phase'; documentId: string; title: string; description?: string | null } | null>
}

export type IPopularTopicsQueryVariables = Exact<{
  vendorLimit: Scalars['Int']['input']
}>

export type IPopularTopicsQuery = {
  __typename?: 'Query'
  popularTopics: Array<{
    __typename?: 'PopularTopic'
    id: number
    name: string
    slug: string
    solutions: Array<{
      __typename?: 'PopularTopicListing'
      slug: string
      type?: IEnum_Solution_Type | null
      logo?: { __typename?: 'PopularTopicListingLogo'; url?: string | null } | null
    }>
  }>
}

export type IPostShareContentsMutationVariables = Exact<{
  data: IResourceInvitationInput
}>

export type IPostShareContentsMutation = { __typename?: 'Mutation'; shareContents?: boolean | null }

export type IPostshareVendorStatusMutationVariables = Exact<{
  data?: InputMaybe<IVendorName>
}>

export type IPostshareVendorStatusMutation = {
  __typename?: 'Mutation'
  shareVendorStatus?: {
    __typename?: 'vendorSatus'
    data?: { __typename?: 'statusResponse'; status?: boolean | null } | null
  } | null
}

export type IPremiumAudiencesQueryVariables = Exact<{
  filters?: InputMaybe<IPremiumAudienceFiltersInput>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>
}>

export type IPremiumAudiencesQuery = {
  __typename?: 'Query'
  premiumAudiences: Array<{
    __typename?: 'PremiumAudience'
    documentId: string
    name: string
    shouldShowOnHomepage?: boolean | null
  } | null>
}

export type IPremiumSubTopicsQueryVariables = Exact<{ [key: string]: never }>

export type IPremiumSubTopicsQuery = {
  __typename?: 'Query'
  subTopics: Array<{
    __typename?: 'SubTopic'
    id: string
    documentId: string
    slug?: string | null
    name: string
    description?: string | null
    isPremium?: boolean | null
    publishedAt?: any | null
    topics: Array<{
      __typename?: 'Topic'
      slug: string
      name: string
      description?: string | null
      iconName?: string | null
      isPremium?: boolean | null
      publishedAt?: any | null
    } | null>
  } | null>
}

export type IPremiumSubTopicsWithContentsQueryVariables = Exact<{ [key: string]: never }>

export type IPremiumSubTopicsWithContentsQuery = {
  __typename?: 'Query'
  subTopics: Array<{
    __typename?: 'SubTopic'
    id: string
    documentId: string
    slug?: string | null
    name: string
    description?: string | null
    isPremium?: boolean | null
    publishedAt?: any | null
    contents: Array<{
      __typename?: 'Content'
      documentId: string
      title: string
      snippet: string
      createdAt?: any | null
      publishedTime?: any | null
      contentType?: IEnum_Content_Contenttype | null
      documentType?: IEnum_Content_Documenttype | null
      isMaintained?: boolean | null
      lastMaintained?: any | null
      slug: string
      publishedAt?: any | null
      subjectMatterIds?: Array<string | null> | null
      themeIds?: Array<string | null> | null
      vendorTopicIds?: Array<string | null> | null
      defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
      blogTaxonomies: Array<{
        __typename?: 'BlogTaxonomy'
        documentId: string
        slug?: string | null
        name?: string | null
      } | null>
      audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
      subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
      writer?: Array<{
        __typename?: 'ComponentContentContentWriter'
        writerOption: IEnum_Componentcontentcontentwriter_Writeroption
        oneTimeAuthorName?: string | null
        author?: {
          __typename?: 'Author'
          firstName: string
          lastName: string
          jobTitle?: string | null
          company?: string | null
          bio?: string | null
          slug?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
        } | null
        expert?: {
          __typename?: 'Expert'
          documentId: string
          firstName: string
          lastName: string
          displayName?: string | null
          title?: string | null
          company?: string | null
          bio?: string | null
          slug?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
          expertiseSubTopics: Array<{
            __typename?: 'SubTopic'
            documentId: string
            name: string
            slug?: string | null
            topics: Array<{
              __typename?: 'Topic'
              documentId: string
              name: string
              description?: string | null
              slug: string
            } | null>
          } | null>
          expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
          contents: Array<{ __typename?: 'Content'; documentId: string } | null>
        } | null
        solution?: {
          __typename?: 'Solution'
          displayName?: string | null
          slug?: string | null
          type: IEnum_Solution_Type
          shortDescription?: string | null
          logo?: { __typename?: 'UploadFile'; url: string } | null
        } | null
      } | null> | null
      themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
      vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
    } | null>
    topics: Array<{
      __typename?: 'Topic'
      slug: string
      name: string
      description?: string | null
      iconName?: string | null
      isPremium?: boolean | null
      publishedAt?: any | null
    } | null>
  } | null>
}

export type IPremiumTopicsQueryVariables = Exact<{ [key: string]: never }>

export type IPremiumTopicsQuery = {
  __typename?: 'Query'
  topics: Array<{
    __typename?: 'Topic'
    documentId: string
    slug: string
    name: string
    iconName?: string | null
    description?: string | null
    isPremium?: boolean | null
    publishedAt?: any | null
    subTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      slug?: string | null
      name: string
      description?: string | null
      isPremium?: boolean | null
      publishedAt?: any | null
    } | null>
  } | null>
}

export type IPremiumTopicsWithContentsQueryVariables = Exact<{ [key: string]: never }>

export type IPremiumTopicsWithContentsQuery = {
  __typename?: 'Query'
  topics: Array<{
    __typename?: 'Topic'
    documentId: string
    slug: string
    name: string
    iconName?: string | null
    description?: string | null
    isPremium?: boolean | null
    publishedAt?: any | null
    contents: Array<{
      __typename?: 'Content'
      documentId: string
      title: string
      snippet: string
      createdAt?: any | null
      publishedTime?: any | null
      contentType?: IEnum_Content_Contenttype | null
      documentType?: IEnum_Content_Documenttype | null
      isMaintained?: boolean | null
      lastMaintained?: any | null
      slug: string
      publishedAt?: any | null
      subjectMatterIds?: Array<string | null> | null
      themeIds?: Array<string | null> | null
      vendorTopicIds?: Array<string | null> | null
      defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
      blogTaxonomies: Array<{
        __typename?: 'BlogTaxonomy'
        documentId: string
        slug?: string | null
        name?: string | null
      } | null>
      audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
      subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
      writer?: Array<{
        __typename?: 'ComponentContentContentWriter'
        writerOption: IEnum_Componentcontentcontentwriter_Writeroption
        oneTimeAuthorName?: string | null
        author?: {
          __typename?: 'Author'
          firstName: string
          lastName: string
          jobTitle?: string | null
          company?: string | null
          bio?: string | null
          slug?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
        } | null
        expert?: {
          __typename?: 'Expert'
          documentId: string
          firstName: string
          lastName: string
          displayName?: string | null
          title?: string | null
          company?: string | null
          bio?: string | null
          slug?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
          expertiseSubTopics: Array<{
            __typename?: 'SubTopic'
            documentId: string
            name: string
            slug?: string | null
            topics: Array<{
              __typename?: 'Topic'
              documentId: string
              name: string
              description?: string | null
              slug: string
            } | null>
          } | null>
          expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
          contents: Array<{ __typename?: 'Content'; documentId: string } | null>
        } | null
        solution?: {
          __typename?: 'Solution'
          displayName?: string | null
          slug?: string | null
          type: IEnum_Solution_Type
          shortDescription?: string | null
          logo?: { __typename?: 'UploadFile'; url: string } | null
        } | null
      } | null> | null
      themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
      vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
    } | null>
    subTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      slug?: string | null
      name: string
      description?: string | null
      isPremium?: boolean | null
      publishedAt?: any | null
    } | null>
  } | null>
}

export type IPreviewContentBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input']
  secret: Scalars['String']['input']
  status?: InputMaybe<Scalars['String']['input']>
  documentId?: InputMaybe<Scalars['String']['input']>
}>

export type IPreviewContentBySlugQuery = {
  __typename?: 'Query'
  previewContentBySlug?: {
    __typename: 'ContentEntityBySlug'
    isInvited?: boolean | null
    resourcePublishedAt?: string | null
    vendorSelfContent?: boolean | null
    isUserVendor?: boolean | null
    includeInKnowHow?: boolean | null
    includeInLegalTechForLawyers?: boolean | null
    includeInVendorContents?: boolean | null
    isFreeArticle?: boolean | null
    freeArticleLeft?: number | null
    content: {
      __typename: 'ContentEntity'
      id?: string | null
      attributes?: {
        __typename: 'Content'
        documentId: string
        title: string
        publishedAt?: any | null
        createdAt?: any | null
        publishedTime?: any | null
        lastMaintained?: any | null
        isMaintained?: boolean | null
        contentType?: IEnum_Content_Contenttype | null
        slug: string
        snippet: string
        isPremium?: boolean | null
        isLatestBlog?: boolean | null
        defaultImage: Array<{ __typename: 'UploadFile'; url: string } | null>
        blogTaxonomies: Array<{ __typename: 'BlogTaxonomy'; name?: string | null; slug?: string | null } | null>
        subjectMatters: Array<{ __typename: 'SubjectMatter'; name?: string | null; slug?: string | null } | null>
        downloadMaterial?: {
          __typename: 'ComponentContentDownloadMaterial'
          title?: string | null
          isEnabled?: boolean | null
          format?: IEnum_Componentcontentdownloadmaterial_Format | null
          lastUpdated?: any | null
          downloadButtonName?: string | null
          files?: { __typename?: 'UploadFile'; name: string } | null
        } | null
        writer?: Array<{
          __typename: 'ComponentContentContentWriter'
          writerOption: IEnum_Componentcontentcontentwriter_Writeroption
          oneTimeAuthorName?: string | null
          author?: {
            __typename?: 'Author'
            firstName: string
            lastName: string
            jobTitle?: string | null
            company?: string | null
            bio?: string | null
            slug?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string } | null
          } | null
          expert?: {
            __typename?: 'Expert'
            documentId: string
            firstName: string
            lastName: string
            displayName?: string | null
            title?: string | null
            company?: string | null
            bio?: string | null
            slug?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string } | null
            expertiseSubTopics: Array<{
              __typename?: 'SubTopic'
              documentId: string
              name: string
              slug?: string | null
              topics: Array<{
                __typename?: 'Topic'
                documentId: string
                name: string
                description?: string | null
                slug: string
              } | null>
            } | null>
            expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
            contents: Array<{ __typename?: 'Content'; documentId: string } | null>
          } | null
          solution?: {
            __typename?: 'Solution'
            displayName?: string | null
            slug?: string | null
            type: IEnum_Solution_Type
            shortDescription?: string | null
            logo?: { __typename?: 'UploadFile'; url: string } | null
          } | null
        } | null> | null
      } | null
    }
  } | null
}

export type IProductBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input']
  includeIlta: Scalars['Boolean']['input']
}>

export type IProductBySlugQuery = {
  __typename?: 'Query'
  solutions: Array<{
    __typename?: 'Solution'
    productType?: IEnum_Solution_Producttype | null
    id: string
    documentId: string
    displayName?: string | null
    oldSlug?: string | null
    type: IEnum_Solution_Type
    website?: string | null
    linkedin?: string | null
    twitter?: string | null
    isPremium?: boolean | null
    slug?: string | null
    shortDescription?: string | null
    longDescription?: string | null
    isBeta?: boolean | null
    isStartup?: boolean | null
    rating?: number | null
    yearFounded?: number | null
    createdAt?: any | null
    publishedAt?: any | null
    descOtherExistingCustomer?: string | null
    descOtherIntegration?: string | null
    isDiverseLeadership?: boolean | null
    productData?: {
      __typename?: 'ComponentSolutionProductData'
      name?: string | null
      tool?: string | null
      fundingInfo?: IEnum_Componentsolutionproductdata_Fundinginfo | null
      fundingAmount?: IEnum_Componentsolutionproductdata_Fundingamount | null
      fundingDetails?: string | null
      openToInvestment?: boolean | null
      valueProposition?: string | null
      audiences: Array<{ __typename?: 'Demographic'; documentId: string; name: string } | null>
      attributes: Array<{ __typename?: 'Attribute'; documentId: string; name: string } | null>
      deployments: Array<{ __typename?: 'Installation'; documentId: string; name: string } | null>
      integrations: Array<{ __typename?: 'Integration'; documentId: string; name: string } | null>
      practiceAreas: Array<{ __typename?: 'PracticeArea'; documentId: string; name: string } | null>
      typeOfUser: Array<{ __typename?: 'TypeOfUser'; documentId: string; name?: string | null } | null>
      security: Array<{ __typename?: 'Security'; documentId: string; name: string } | null>
      dataHostingLocations: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
      enhancedListingData?: {
        __typename?: 'ComponentSolutionPropsProductEnhanced'
        pricingData?: string | null
        callToAction?: { __typename?: 'ComponentGlobalCallToAction'; label?: string | null; url?: string | null } | null
        screenshots?: Array<{
          __typename?: 'ComponentGlobalPicture'
          id: string
          title?: string | null
          summary?: string | null
          image?: { __typename?: 'UploadFile'; url: string; id: string } | null
        } | null> | null
        videos?: Array<{
          __typename?: 'ComponentSolutionPropsVideo'
          title?: string | null
          summary?: string | null
          url?: string | null
        } | null> | null
        testimonials?: Array<{
          __typename?: 'ComponentTestimonialsTestimonials'
          id: string
          description?: string | null
          author?: {
            __typename?: 'ComponentTestimonialsPropsAuthor'
            name?: string | null
            role?: string | null
            company?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
          } | null
        } | null> | null
      } | null
    } | null
    consolidationData?: {
      __typename?: 'ComponentSolutionPropsConsolidation'
      date?: any | null
      amount?: number | null
      article?: string | null
      articleLink?: string | null
      originalTargetName?: string | null
      buyer?: string | null
      enableInActiveDir?: boolean | null
    } | null
    graveyardData?: { __typename?: 'ComponentSolutionPropsGraveyard'; date?: any | null } | null
    founders?: Array<{
      __typename?: 'ComponentAboutPropsTeamMember'
      name?: string | null
      role?: string | null
      bio?: string | null
      title?: string | null
      externalLink?: string | null
      avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
    } | null> | null
    vendor?: {
      __typename?: 'Vendor'
      publishedAt?: any | null
      documentId: string
      users: Array<{ __typename?: 'User'; external_id?: string | null } | null>
    } | null
    topics: Array<{ __typename?: 'Topic'; documentId: string; slug: string; name: string } | null>
    subTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      slug?: string | null
      name: string
      features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
    } | null>
    logo?: { __typename?: 'UploadFile'; id: string; url: string } | null
    company?: { __typename?: 'Company'; name: string; slug?: string | null } | null
    reviews: Array<{
      __typename?: 'Review'
      anonymous?: boolean | null
      rating?: number | null
      title?: string | null
      content?: string | null
      submitterTitle?: string | null
      submitterSubTitle?: string | null
      solutionDispName?: string | null
      createdAt?: any | null
      updatedAt?: any | null
      publishedAt?: any | null
      solution?: {
        __typename?: 'Solution'
        displayName?: string | null
        slug?: string | null
        rating?: number | null
        company?: { __typename?: 'Company'; slug?: string | null } | null
        logo?: { __typename?: 'UploadFile'; url: string } | null
      } | null
    } | null>
    offices: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
    hqs: Array<{ __typename?: 'Hq'; documentId: string; name: string } | null>
    regionsServed: Array<{ __typename?: 'RegionsServed'; documentId: string; name: string } | null>
    languages: Array<{ __typename?: 'PlatformLanguage'; documentId: string; name: string } | null>
    articles?: Array<{
      __typename?: 'ComponentGlobalArticle'
      id: string
      title?: string | null
      publishedBy?: string | null
      date?: any | null
      link?: string | null
      image?: { __typename?: 'UploadFile'; url: string; id: string } | null
    } | null> | null
    vendorResources?: Array<{
      __typename?: 'ComponentSolutionPropsVendorResource'
      type?: IEnum_Componentsolutionpropsvendorresource_Type | null
      content?: {
        __typename?: 'Content'
        documentId: string
        title: string
        snippet: string
        createdAt?: any | null
        publishedTime?: any | null
        contentType?: IEnum_Content_Contenttype | null
        documentType?: IEnum_Content_Documenttype | null
        isMaintained?: boolean | null
        lastMaintained?: any | null
        slug: string
        publishedAt?: any | null
        subjectMatterIds?: Array<string | null> | null
        themeIds?: Array<string | null> | null
        vendorTopicIds?: Array<string | null> | null
        defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
        blogTaxonomies: Array<{
          __typename?: 'BlogTaxonomy'
          documentId: string
          slug?: string | null
          name?: string | null
        } | null>
        audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
        subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
        writer?: Array<{
          __typename?: 'ComponentContentContentWriter'
          writerOption: IEnum_Componentcontentcontentwriter_Writeroption
          oneTimeAuthorName?: string | null
          author?: {
            __typename?: 'Author'
            firstName: string
            lastName: string
            jobTitle?: string | null
            company?: string | null
            bio?: string | null
            slug?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string } | null
          } | null
          expert?: {
            __typename?: 'Expert'
            documentId: string
            firstName: string
            lastName: string
            displayName?: string | null
            title?: string | null
            company?: string | null
            bio?: string | null
            slug?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string } | null
            expertiseSubTopics: Array<{
              __typename?: 'SubTopic'
              documentId: string
              name: string
              slug?: string | null
              topics: Array<{
                __typename?: 'Topic'
                documentId: string
                name: string
                description?: string | null
                slug: string
              } | null>
            } | null>
            expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
            contents: Array<{ __typename?: 'Content'; documentId: string } | null>
          } | null
          solution?: {
            __typename?: 'Solution'
            displayName?: string | null
            slug?: string | null
            type: IEnum_Solution_Type
            shortDescription?: string | null
            logo?: { __typename?: 'UploadFile'; url: string } | null
          } | null
        } | null> | null
        themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
        vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
      } | null
      external?: {
        __typename?: 'ComponentSolutionPropsVendorResourceExternal'
        title?: string | null
        summary?: string | null
        link?: string | null
        publishedDate?: any | null
        author?: string | null
        documentType?: IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype | null
      } | null
    } | null> | null
    features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
    existingCustomers: Array<{ __typename?: 'ExistingCustomer'; documentId: string; name: string } | null>
    iltaSponsorships?: Array<{
      __typename?: 'IltaSponsorship'
      documentId: string
      name?: string | null
      logo?: { __typename?: 'UploadFile'; documentId: string; url: string } | null
    } | null>
    announcement: Array<{
      __typename?: 'Announcement'
      id: string
      announcement: string
      optionalLink?: string | null
      publishedAt?: any | null
      documentId: string
      isArchived?: boolean | null
    } | null>
  } | null>
}

export type IPublishedVendorByDocumentIdQueryVariables = Exact<{
  documentId: Scalars['ID']['input']
}>

export type IPublishedVendorByDocumentIdQuery = {
  __typename?: 'Query'
  vendor?: {
    __typename?: 'Vendor'
    documentId: string
    publishedAt?: any | null
    users: Array<{ __typename?: 'User'; external_id?: string | null } | null>
  } | null
}

export type IUpdateAskAiLogRatingMutationVariables = Exact<{
  data: IInputRatingData
}>

export type IUpdateAskAiLogRatingMutation = {
  __typename?: 'Mutation'
  updateAskAILogRating?: { __typename?: 'RatingResponse'; success?: boolean | null; message?: string | null } | null
}

export type IRegisterMutationVariables = Exact<{
  input: IUsersPermissionsRegisterInput
}>

export type IRegisterMutation = {
  __typename?: 'Mutation'
  register: {
    __typename?: 'UsersPermissionsLoginPayload'
    jwt?: string | null
    user: { __typename?: 'UsersPermissionsMe'; id: string; username: string; email?: string | null }
  }
}

export type IRegisterPremiumOrganizationMutationVariables = Exact<{
  name: Scalars['String']['input']
  registrationContact:
    | Array<IComponentRegistrationContactRegistrationContactInput>
    | IComponentRegistrationContactRegistrationContactInput
  billingAddress: IComponentBillingAddressBillingAddressInput
  emailDomain: Scalars['String']['input']
  pricingPlan: Scalars['ID']['input']
  gReCaptchaToken?: InputMaybe<Scalars['String']['input']>
  leadSource?: InputMaybe<Scalars['String']['input']>
  shouldSendResponse: Scalars['Boolean']['input']
}>

export type IRegisterPremiumOrganizationMutation = {
  __typename?: 'Mutation'
  registerPremiumOrganization?: { __typename?: 'PremiumOrganization'; name: string } | null
}

export type IRegisterVendorOrganizationMutationVariables = Exact<{
  name: Scalars['String']['input']
  companySize: Scalars['String']['input']
  registrationContact:
    | Array<IComponentRegistrationContactRegistrationContactInput>
    | IComponentRegistrationContactRegistrationContactInput
  gReCaptchaToken?: InputMaybe<Scalars['String']['input']>
  shouldSendResponse: Scalars['Boolean']['input']
}>

export type IRegisterVendorOrganizationMutation = {
  __typename?: 'Mutation'
  registerVendorOrganization?: { __typename?: 'Vendor'; name: string } | null
}

export type IRelatedArticlesOfContentQueryVariables = Exact<{
  slug: Scalars['String']['input']
}>

export type IRelatedArticlesOfContentQuery = {
  __typename?: 'Query'
  relatedArticlesOfContent: {
    __typename?: 'ContentSearchReturnType'
    success?: boolean | null
    data?: {
      __typename?: 'ContentSearchResult'
      total?: number | null
      contents?: Array<{
        __typename?: 'ContentItem'
        documentId: string
        slug: string
        contentType?: IEnum_Content_Contenttype | null
        documentType?: IEnum_Content_Documenttype | null
        title: string
        snippet: string
        defaultImage?: string | null
        publishedTime: any
        isMaintained?: boolean | null
        lastMaintainedAt?: any | null
        subjectMatters?: string | null
        subjectMatterIds?: Array<string | null> | null
        themeIds?: Array<string | null> | null
        vendorTopicIds?: Array<string | null> | null
        themes?: string | null
        vendorTopics?: string | null
        writer?: {
          __typename?: 'ContentItemWriter'
          writerOption: IEnum_Componentcontentcontentwriter_Writeroption
          name: string
          avatar?: string | null
          title?: string | null
          url?: string | null
        } | null
        writers?: Array<{
          __typename?: 'ContentItemWriter'
          writerOption: IEnum_Componentcontentcontentwriter_Writeroption
          name: string
          avatar?: string | null
          title?: string | null
          url?: string | null
        }> | null
      } | null> | null
    } | null
  }
}

export type IRelatedContentBySolutionQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']['input']>
}>

export type IRelatedContentBySolutionQuery = {
  __typename?: 'Query'
  relatedContentBySolution?: {
    __typename?: 'RelatedContentBySolutionhReturnType'
    success?: boolean | null
    data?: {
      __typename?: 'RelatedContentBySolution'
      total?: number | null
      contents?: Array<{
        __typename?: 'ContentItem'
        documentId: string
        slug: string
        contentType?: IEnum_Content_Contenttype | null
        documentType?: IEnum_Content_Documenttype | null
        title: string
        snippet: string
        defaultImage?: string | null
        publishedTime: any
        isMaintained?: boolean | null
        lastMaintainedAt?: any | null
        subjectMatters?: string | null
        subjectMatterIds?: Array<string | null> | null
        themeIds?: Array<string | null> | null
        vendorTopicIds?: Array<string | null> | null
        themes?: string | null
        vendorTopics?: string | null
        writer?: {
          __typename?: 'ContentItemWriter'
          writerOption: IEnum_Componentcontentcontentwriter_Writeroption
          name: string
          avatar?: string | null
          title?: string | null
          url?: string | null
        } | null
        writers?: Array<{
          __typename?: 'ContentItemWriter'
          writerOption: IEnum_Componentcontentcontentwriter_Writeroption
          name: string
          avatar?: string | null
          title?: string | null
          url?: string | null
        }> | null
      } | null> | null
    } | null
  } | null
}

export type IRemovePortfolioTagFromSolutionMutationVariables = Exact<{
  tagDocumentId: Scalars['ID']['input']
  solutionId?: InputMaybe<Scalars['Int']['input']>
  solutionDocumentId?: InputMaybe<Scalars['ID']['input']>
}>

export type IRemovePortfolioTagFromSolutionMutation = {
  __typename?: 'Mutation'
  removePortfolioTagFromSolution?: boolean | null
}

export type ISearchContentsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']['input']>
  gReCaptchaToken?: InputMaybe<Scalars['String']['input']>
}>

export type ISearchContentsQuery = {
  __typename?: 'Query'
  contentResults: {
    __typename?: 'ContentSearchReturnType'
    success?: boolean | null
    data?: {
      __typename?: 'ContentSearchResult'
      total?: number | null
      contents?: Array<{
        __typename?: 'ContentItem'
        documentId: string
        slug: string
        contentType?: IEnum_Content_Contenttype | null
        documentType?: IEnum_Content_Documenttype | null
        title: string
        snippet: string
        defaultImage?: string | null
        publishedTime: any
        isMaintained?: boolean | null
        lastMaintainedAt?: any | null
        subjectMatters?: string | null
        subjectMatterIds?: Array<string | null> | null
        themeIds?: Array<string | null> | null
        vendorTopicIds?: Array<string | null> | null
        themes?: string | null
        vendorTopics?: string | null
        writer?: {
          __typename?: 'ContentItemWriter'
          writerOption: IEnum_Componentcontentcontentwriter_Writeroption
          name: string
          avatar?: string | null
          title?: string | null
          url?: string | null
        } | null
        writers?: Array<{
          __typename?: 'ContentItemWriter'
          writerOption: IEnum_Componentcontentcontentwriter_Writeroption
          name: string
          avatar?: string | null
          title?: string | null
          url?: string | null
        }> | null
      } | null> | null
    } | null
  }
}

export type ISearchCustomTagsQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>
}>

export type ISearchCustomTagsQuery = {
  __typename?: 'Query'
  searchCustomTags: Array<{
    __typename?: 'CustomTagResult'
    id: string
    name: string
    slug?: string | null
    solutionIds?: Array<string | null> | null
    solutionDocumentIds?: Array<string | null> | null
  }>
}

export type ISearchEventsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']['input']>
}>

export type ISearchEventsQuery = {
  __typename?: 'Query'
  eventResults: {
    __typename?: 'EventSearchReturnType'
    success?: boolean | null
    data?: {
      __typename?: 'EventSearchResult'
      total?: number | null
      events?: Array<{
        __typename?: 'Event'
        title: string
        description?: string | null
        date?: any | null
        updatedAt?: any | null
        city?: string | null
        country: string
        slug: string
        createdAt?: any | null
        organizer: string
        featured?: boolean | null
        website: string
        notes?: string | null
        logo?: { __typename?: 'UploadFile'; url: string } | null
        durationId?: { __typename?: 'Duration'; name: string; days?: number | null } | null
        formatId?: { __typename?: 'EventFormat'; name: string } | null
        recurrenceId?: { __typename?: 'Recurrence'; name: string } | null
        features: Array<{ __typename?: 'EventFeature'; name: string } | null>
      } | null> | null
    } | null
  }
}

export type ISearchGraveyardConsolidationQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']['input']>
}>

export type ISearchGraveyardConsolidationQuery = {
  __typename?: 'Query'
  searchSolutions: {
    __typename?: 'SearchSolutionsResultType'
    total?: number | null
    solutions?: Array<{
      __typename?: 'SolutionItem'
      documentId: string
      slug: string
      type: IEnum_Solution_Item_Type
      displayName: string
      description?: string | null
      logo?: string | null
      subTopics: Array<string>
      follow: boolean
      rating?: number | null
      reviewCnt?: number | null
      isPremium?: boolean | null
      isStartup?: boolean | null
      isBeta?: boolean | null
      isDiverseLeadership?: boolean | null
      iltaSponsorshipLogo?: string | null
      consolidation?: {
        __typename?: 'ComponentSolutionPropsConsolidation'
        date?: any | null
        amount?: number | null
        article?: string | null
        articleLink?: string | null
        originalTargetName?: string | null
        buyer?: string | null
        enableInActiveDir?: boolean | null
      } | null
      graveyard?: { __typename?: 'ComponentSolutionPropsGraveyard'; date?: any | null } | null
      followedSolutionsData?: {
        __typename?: 'ComponentFollowingSolutionsData'
        followingType?: string | null
        followingSolutionNote?: string | null
        noteCreatedAt?: string | null
        noteCreatedByName?: string | null
        noteLastEditedAt?: string | null
        noteLastEditedByName?: string | null
      } | null
      shared_portfolio_solutions?: Array<{
        __typename?: 'SolutionSharedPortfolioSolutionData'
        category?: string | null
        followingSolutionNote?: string | null
        sharedPortfolio?: string | null
        slug?: string | null
        name?: string | null
        portfolioId?: string | null
        organizationId?: string | null
        members?: string | null
      } | null> | null
      customTagsWithName?: Array<{ __typename?: 'CustomTagItem'; id: string; name: string; slug: string } | null> | null
    } | null> | null
  }
}

export type ISearchPortfolioEditorsQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type ISearchPortfolioEditorsQuery = {
  __typename?: 'Query'
  searchSharedPortfolioOrganizationUsers: {
    __typename?: 'SharedPortfolioOrganizationUsersResult'
    users: Array<{ __typename?: 'SharedPortfolioOrganizationUser'; id: string; email: string; name?: string | null }>
  }
}

export type ISearchSolutionsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']['input']>
}>

export type ISearchSolutionsQuery = {
  __typename?: 'Query'
  searchSolutions: {
    __typename?: 'SearchSolutionsResultType'
    total?: number | null
    isFreeSearch?: boolean | null
    isFreeSearchLeft?: number | null
    solutions?: Array<{
      __typename?: 'SolutionItem'
      documentId: string
      slug: string
      type: IEnum_Solution_Item_Type
      displayName: string
      description?: string | null
      logo?: string | null
      subTopics: Array<string>
      follow: boolean
      rating?: number | null
      reviewCnt?: number | null
      isPremium?: boolean | null
      isStartup?: boolean | null
      isBeta?: boolean | null
      isDiverseLeadership?: boolean | null
      iltaSponsorshipLogo?: string | null
      consolidation?: {
        __typename?: 'ComponentSolutionPropsConsolidation'
        date?: any | null
        amount?: number | null
        article?: string | null
        articleLink?: string | null
        originalTargetName?: string | null
        buyer?: string | null
        enableInActiveDir?: boolean | null
      } | null
      graveyard?: { __typename?: 'ComponentSolutionPropsGraveyard'; date?: any | null } | null
      followedSolutionsData?: {
        __typename?: 'ComponentFollowingSolutionsData'
        followingType?: string | null
        followingSolutionNote?: string | null
        noteCreatedAt?: string | null
        noteCreatedByName?: string | null
        noteLastEditedAt?: string | null
        noteLastEditedByName?: string | null
      } | null
      shared_portfolio_solutions?: Array<{
        __typename?: 'SolutionSharedPortfolioSolutionData'
        category?: string | null
        followingSolutionNote?: string | null
        sharedPortfolio?: string | null
        slug?: string | null
        name?: string | null
        portfolioId?: string | null
        organizationId?: string | null
        members?: string | null
      } | null> | null
      customTagsWithName?: Array<{ __typename?: 'CustomTagItem'; id: string; name: string; slug: string } | null> | null
    } | null> | null
  }
}

export type ISearchSubtopicsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']['input']>
}>

export type ISearchSubtopicsQuery = {
  __typename?: 'Query'
  searchSubtopics: {
    __typename?: 'SearchSubtopicsResultType'
    total?: number | null
    subtopics?: Array<{
      __typename?: 'SubtopicItem'
      documentId?: string | null
      slug: string
      name: string
      description?: string | null
      featuredOnHome?: boolean | null
      isPremium?: boolean | null
      solutionsTotalCount?: number | null
      contentsTotalCount?: number | null
      topicSlug?: string | null
      topicName?: string | null
      iconName?: string | null
    } | null> | null
  }
}

export type ISubtopicListItemFragment = {
  __typename?: 'SubtopicItem'
  documentId?: string | null
  slug: string
  name: string
  description?: string | null
  featuredOnHome?: boolean | null
  isPremium?: boolean | null
  solutionsTotalCount?: number | null
  contentsTotalCount?: number | null
  topicSlug?: string | null
  topicName?: string | null
  iconName?: string | null
}

export type ISearchUnfollowedRelatedSubtopicsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']['input']>
}>

export type ISearchUnfollowedRelatedSubtopicsQuery = {
  __typename?: 'Query'
  searchUnfollowedRelatedSubtopics: {
    __typename?: 'UnFollowedRelatedSubtopicsResult'
    total?: number | null
    subtopics?: Array<{
      __typename?: 'UnFollowedRelatedSubtopics'
      documentId?: string | null
      slug: string
      name?: string | null
      topicSlug?: string | null
      topicName?: string | null
      isPremium?: boolean | null
    } | null> | null
  }
}

export type IGetSharedPortfoliosForMyOrganizationQueryVariables = Exact<{
  sharedPortfolioId?: InputMaybe<Scalars['ID']['input']>
  sharedPortfolioSlug?: InputMaybe<Scalars['String']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}>

export type IGetSharedPortfoliosForMyOrganizationQuery = {
  __typename?: 'Query'
  sharedPortfoliosForMyOrganization: {
    __typename?: 'SharedPortfoliosForMyOrganizationPayload'
    privateFollowingPortfolio?: {
      __typename?: 'PrivateFollowingPortfolioStub'
      documentId: string
      name: string
      slug?: string | null
    } | null
    portfolios: Array<{
      __typename?: 'SharedPortfolioEntity'
      id?: string | null
      attributes?: {
        __typename?: 'SharedPortfolio'
        documentId: string
        name: string
        slug?: string | null
        isSharedPortfolio?: boolean | null
        createdByUser?: {
          __typename?: 'User'
          documentId: string
          username: string
          email: string
          companyName?: string | null
          jobTitle?: string | null
          companyType?: IEnum_User_Companytype | null
          premiumOrganization?: {
            __typename?: 'PremiumOrganization'
            documentId: string
            name: string
            emailDomain: string
          } | null
          country?: { __typename?: 'Country'; documentId: string; name: string } | null
          role?: { __typename?: 'UsersPermissionsRole'; name: string; type?: string | null } | null
          vendor?: { __typename?: 'Vendor'; documentId: string; name: string; email?: string | null } | null
        } | null
        lastModifiedByUser?: { __typename?: 'User'; documentId: string; username: string; email: string } | null
        shared_portfolio_memberships: Array<{
          __typename?: 'SharedPortfolioMembership'
          documentId: string
          role: IEnum_Sharedportfoliomembership_Role
          isActive?: boolean | null
          user?: {
            __typename?: 'User'
            documentId: string
            username: string
            email: string
            companyName?: string | null
            jobTitle?: string | null
            companyType?: IEnum_User_Companytype | null
            premiumOrganization?: {
              __typename?: 'PremiumOrganization'
              documentId: string
              name: string
              emailDomain: string
            } | null
            country?: { __typename?: 'Country'; documentId: string; name: string } | null
            role?: { __typename?: 'UsersPermissionsRole'; name: string; type?: string | null } | null
            vendor?: { __typename?: 'Vendor'; documentId: string; name: string; email?: string | null } | null
          } | null
        } | null>
        shared_portfolio_solutions: Array<{
          __typename?: 'SharedPortfolioSolution'
          documentId: string
          category?: IEnum_Sharedportfoliosolution_Category | null
          followingSolutionNote?: string | null
          createdAt?: any | null
          updatedAt?: any | null
          solution?: {
            __typename?: 'Solution'
            documentId: string
            id: string
            displayName?: string | null
            slug?: string | null
            isPremium?: boolean | null
          } | null
          sharedPortfolio?: { __typename?: 'SharedPortfolio'; documentId: string; name: string } | null
          lastModifiedByUser?: {
            __typename?: 'User'
            documentId: string
            username: string
            email: string
            companyName?: string | null
          } | null
        } | null>
      } | null
    }>
    sharedPortfoliosPagination: {
      __typename?: 'SharedPortfoliosPagination'
      total: number
      page: number
      pageSize: number
      pageCount: number
    }
  }
}

export type IShowRelatedContentFeatureQueryVariables = Exact<{ [key: string]: never }>

export type IShowRelatedContentFeatureQuery = { __typename?: 'Query'; showRelatedContentFeature: boolean }

export type ISimilarSolutionsQueryVariables = Exact<{
  id: Scalars['String']['input']
  from?: InputMaybe<Scalars['String']['input']>
}>

export type ISimilarSolutionsQuery = {
  __typename?: 'Query'
  similarSolutions: {
    __typename?: 'SimilarSolutionsResult'
    solutions: Array<{
      __typename?: 'SimilarSolutionItem'
      type?: IEnum_Solution_Item_Type | null
      slug?: string | null
      displayName?: string | null
      logo?: string | null
      rating?: number | null
      reviewCnt?: number | null
    }>
  }
}

export type IAiSmartSearchQueryVariables = Exact<{
  keyword: Scalars['String']['input']
  accessFreeASKAI?: InputMaybe<Scalars['Boolean']['input']>
  uniqueAddress?: InputMaybe<Scalars['String']['input']>
  checkCount?: InputMaybe<Scalars['Boolean']['input']>
}>

export type IAiSmartSearchQuery = {
  __typename?: 'Query'
  aiSmartSearch: {
    __typename?: 'SmartsearchData'
    success: boolean
    isFreeASKAI?: boolean | null
    isFreeASKAILeft?: number | null
    data?: {
      __typename?: 'Smartsearch'
      result: string
      id: string
      identicalId?: number | null
      sources: Array<{
        __typename?: 'SmartSearchSources'
        sourceUrl?: string | null
        title?: string | null
        description?: string | null
        logo?: string | null
        contentType?: string | null
      }>
      logs: Array<{ __typename?: 'smartSearchLog'; message: string; timestamp: string }>
    } | null
  }
}

export type ISolutionRequestsBySulgQueryVariables = Exact<{
  slug: Scalars['String']['input']
  status?: InputMaybe<IPublicationStatus>
}>

export type ISolutionRequestsBySulgQuery = {
  __typename?: 'Query'
  solutionRequests: Array<{
    __typename?: 'SolutionRequest'
    documentId: string
    type: IEnum_Solutionrequest_Type
    website?: string | null
    linkedin?: string | null
    twitter?: string | null
    slug?: string | null
    shortDescription?: string | null
    longDescription?: string | null
    descOtherExistingCustomer?: string | null
    descOtherIntegration?: string | null
    yearFounded?: number | null
    createdAt?: any | null
    publishedAt?: any | null
    topics: Array<{ __typename?: 'Topic'; documentId: string; slug: string; name: string } | null>
    productData?: {
      __typename?: 'ComponentSolutionRequestProductData'
      tool?: string | null
      name?: string | null
      fundingAmount?: IEnum_Componentsolutionrequestproductdata_Fundingamount | null
      fundingInfo?: IEnum_Componentsolutionrequestproductdata_Fundinginfo | null
      valueProposition?: string | null
      audiences: Array<{ __typename?: 'Demographic'; documentId: string; name: string } | null>
      attributes: Array<{ __typename?: 'Attribute'; documentId: string; name: string } | null>
      integrations: Array<{ __typename?: 'Integration'; documentId: string; name: string } | null>
      practiceAreas: Array<{ __typename?: 'PracticeArea'; documentId: string; name: string } | null>
      typeOfUser: Array<{ __typename?: 'TypeOfUser'; documentId: string; name?: string | null } | null>
      enhancedListingData?: {
        __typename?: 'ComponentSolutionRequestPropsProductEnhanced'
        pricingData?: string | null
        screenshots?: Array<{
          __typename?: 'ComponentGlobalPicture'
          id: string
          title?: string | null
          summary?: string | null
          image?: { __typename?: 'UploadFile'; url: string; id: string } | null
        } | null> | null
        videos?: Array<{
          __typename?: 'ComponentSolutionPropsVideo'
          title?: string | null
          summary?: string | null
          url?: string | null
        } | null> | null
        callToAction?: { __typename?: 'ComponentGlobalCallToAction'; label?: string | null; url?: string | null } | null
        testimonials?: Array<{
          __typename?: 'ComponentTestimonialsTestimonials'
          id: string
          description?: string | null
          author?: {
            __typename?: 'ComponentTestimonialsPropsAuthor'
            name?: string | null
            role?: string | null
            company?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
          } | null
        } | null> | null
      } | null
      security: Array<{ __typename?: 'Security'; documentId: string; name: string } | null>
      deployments: Array<{ __typename?: 'Installation'; documentId: string; name: string } | null>
      dataHosting: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
    } | null
    alspData?: {
      __typename?: 'ComponentSolutionRequestAlspData'
      name?: string | null
      serviceName?: string | null
      size?: number | null
      partners?: string | null
      fundingAmount?: IEnum_Componentsolutionrequestalspdata_Fundingamount | null
      fundingInfo?: IEnum_Componentsolutionrequestalspdata_Fundinginfo | null
      valueProposition?: string | null
      security: Array<{ __typename?: 'Security'; documentId: string; name: string } | null>
      audiences: Array<{ __typename?: 'Demographic'; documentId: string; name: string } | null>
      enhancedListingData?: {
        __typename?: 'ComponentSolutionPropsAlspEnhanced'
        serviceDescription?: string | null
        technologyPartners?: string | null
        averageLengthOfEngagement?: number | null
        pricingData?: string | null
        callToAction?: { __typename?: 'ComponentGlobalCallToAction'; label?: string | null; url?: string | null } | null
        dedicatedResources?: Array<{
          __typename?: 'ComponentSolutionPropsDedicatedResource'
          count?: number | null
          type?: IEnum_Componentsolutionpropsdedicatedresource_Type | null
        } | null> | null
        specialists?: Array<{
          __typename?: 'ComponentAboutPropsTeamMember'
          name?: string | null
          role?: string | null
          bio?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
        } | null> | null
        screenshots?: Array<{
          __typename?: 'ComponentGlobalPicture'
          id: string
          title?: string | null
          summary?: string | null
          image?: { __typename?: 'UploadFile'; url: string; id: string } | null
        } | null> | null
        videos?: Array<{
          __typename?: 'ComponentSolutionPropsVideo'
          title?: string | null
          summary?: string | null
          url?: string | null
        } | null> | null
        caseStudies?: Array<{
          __typename?: 'ComponentGlobalSuccessStory'
          name?: string | null
          link?: string | null
        } | null> | null
        testimonials?: Array<{
          __typename?: 'ComponentTestimonialsTestimonials'
          id: string
          description?: string | null
          author?: {
            __typename?: 'ComponentTestimonialsPropsAuthor'
            name?: string | null
            role?: string | null
            company?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
          } | null
        } | null> | null
      } | null
    } | null
    consultantData?: {
      __typename?: 'ComponentSolutionRequestConsultantData'
      name?: string | null
      serviceName?: string | null
      size?: number | null
      partners?: string | null
      fundingInfo?: IEnum_Componentsolutionrequestconsultantdata_Fundinginfo | null
      fundingAmount?: IEnum_Componentsolutionrequestconsultantdata_Fundingamount | null
      valueProposition?: string | null
      audiences: Array<{ __typename?: 'Demographic'; documentId: string; name: string } | null>
      integrations: Array<{ __typename?: 'Integration'; documentId: string; name: string } | null>
      practiceAreas: Array<{ __typename?: 'PracticeArea'; documentId: string; name: string } | null>
      typeOfUser: Array<{ __typename?: 'TypeOfUser'; documentId: string; name?: string | null } | null>
      security: Array<{ __typename?: 'Security'; id?: number | null; name: string } | null>
      enhancedListingData?: {
        __typename?: 'ComponentSolutionPropsConsultantEnhanced'
        serviceDescription?: string | null
        technologyPartners?: string | null
        averageLengthOfEngagement?: number | null
        pricingData?: string | null
        callToAction?: { __typename?: 'ComponentGlobalCallToAction'; label?: string | null; url?: string | null } | null
        dedicatedResources?: Array<{
          __typename?: 'ComponentSolutionPropsDedicatedResource'
          count?: number | null
          type?: IEnum_Componentsolutionpropsdedicatedresource_Type | null
        } | null> | null
        caseStudies?: Array<{
          __typename?: 'ComponentGlobalSuccessStory'
          name?: string | null
          link?: string | null
        } | null> | null
        specialists?: Array<{
          __typename?: 'ComponentAboutPropsTeamMember'
          name?: string | null
          role?: string | null
          bio?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
        } | null> | null
        screenshots?: Array<{
          __typename?: 'ComponentGlobalPicture'
          id: string
          title?: string | null
          summary?: string | null
          image?: { __typename?: 'UploadFile'; url: string; id: string } | null
        } | null> | null
        videos?: Array<{
          __typename?: 'ComponentSolutionPropsVideo'
          title?: string | null
          summary?: string | null
          url?: string | null
        } | null> | null
        testimonials?: Array<{
          __typename?: 'ComponentTestimonialsTestimonials'
          id: string
          description?: string | null
          author?: {
            __typename?: 'ComponentTestimonialsPropsAuthor'
            name?: string | null
            role?: string | null
            company?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string; id: string } | null
          } | null
        } | null> | null
      } | null
    } | null
    founders?: Array<{
      __typename?: 'ComponentAboutPropsTeamMember'
      name?: string | null
      externalLink?: string | null
      title?: string | null
      avatar?: { __typename?: 'UploadFile'; id: string; url: string } | null
    } | null> | null
    subTopics: Array<{
      __typename?: 'SubTopic'
      documentId: string
      slug?: string | null
      name: string
      features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
    } | null>
    logo?: { __typename?: 'UploadFile'; id: string; url: string } | null
    offices: Array<{ __typename?: 'Office'; documentId: string; name: string } | null>
    hqs: Array<{ __typename?: 'Hq'; documentId: string; name: string } | null>
    regionsServed: Array<{ __typename?: 'RegionsServed'; documentId: string; name: string } | null>
    languages: Array<{ __typename?: 'PlatformLanguage'; documentId: string; name: string } | null>
    articles?: Array<{
      __typename?: 'ComponentGlobalArticle'
      id: string
      title?: string | null
      publishedBy?: string | null
      date?: any | null
      link?: string | null
      image?: { __typename?: 'UploadFile'; url: string; id: string } | null
    } | null> | null
    vendorResources?: Array<{
      __typename?: 'ComponentSolutionPropsVendorResource'
      type?: IEnum_Componentsolutionpropsvendorresource_Type | null
      content?: {
        __typename?: 'Content'
        documentId: string
        title: string
        snippet: string
        createdAt?: any | null
        publishedTime?: any | null
        contentType?: IEnum_Content_Contenttype | null
        documentType?: IEnum_Content_Documenttype | null
        isMaintained?: boolean | null
        lastMaintained?: any | null
        slug: string
        publishedAt?: any | null
        subjectMatterIds?: Array<string | null> | null
        themeIds?: Array<string | null> | null
        vendorTopicIds?: Array<string | null> | null
        defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
        blogTaxonomies: Array<{
          __typename?: 'BlogTaxonomy'
          documentId: string
          slug?: string | null
          name?: string | null
        } | null>
        audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
        subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
        writer?: Array<{
          __typename?: 'ComponentContentContentWriter'
          writerOption: IEnum_Componentcontentcontentwriter_Writeroption
          oneTimeAuthorName?: string | null
          author?: {
            __typename?: 'Author'
            firstName: string
            lastName: string
            jobTitle?: string | null
            company?: string | null
            bio?: string | null
            slug?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string } | null
          } | null
          expert?: {
            __typename?: 'Expert'
            documentId: string
            firstName: string
            lastName: string
            displayName?: string | null
            title?: string | null
            company?: string | null
            bio?: string | null
            slug?: string | null
            avatar?: { __typename?: 'UploadFile'; url: string } | null
            expertiseSubTopics: Array<{
              __typename?: 'SubTopic'
              documentId: string
              name: string
              slug?: string | null
              topics: Array<{
                __typename?: 'Topic'
                documentId: string
                name: string
                description?: string | null
                slug: string
              } | null>
            } | null>
            expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
            contents: Array<{ __typename?: 'Content'; documentId: string } | null>
          } | null
          solution?: {
            __typename?: 'Solution'
            displayName?: string | null
            slug?: string | null
            type: IEnum_Solution_Type
            shortDescription?: string | null
            logo?: { __typename?: 'UploadFile'; url: string } | null
          } | null
        } | null> | null
        themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
        vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
      } | null
      external?: {
        __typename?: 'ComponentSolutionPropsVendorResourceExternal'
        title?: string | null
        summary?: string | null
        link?: string | null
        publishedDate?: any | null
        author?: string | null
        documentType?: IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype | null
      } | null
    } | null> | null
    features: Array<{ __typename?: 'Feature'; documentId: string; name?: string | null } | null>
    existingCustomers: Array<{ __typename?: 'ExistingCustomer'; documentId: string; name: string } | null>
    announcement?: {
      __typename?: 'Announcement'
      documentId: string
      announcement: string
      optionalLink?: string | null
      publishedAt?: any | null
    } | null
  } | null>
}

export type ISolutionVendorBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input']
}>

export type ISolutionVendorBySlugQuery = {
  __typename?: 'Query'
  solutions: Array<{
    __typename?: 'Solution'
    documentId: string
    slug?: string | null
    vendor?: { __typename?: 'Vendor'; users: Array<{ __typename?: 'User'; external_id?: string | null } | null> } | null
  } | null>
}

export type ISubmitEnhancedRequestMutationVariables = Exact<{
  solution_id: Scalars['String']['input']
}>

export type ISubmitEnhancedRequestMutation = { __typename?: 'Mutation'; submitEnhancedRequest?: boolean | null }

export type ISubmitNewsletterSubscriptionMutationVariables = Exact<{
  data: INewsletterSubscriptionInput
}>

export type ISubmitNewsletterSubscriptionMutation = {
  __typename?: 'Mutation'
  submitNewsletterSubscription?: boolean | null
}

export type ISubmitReviewMutationVariables = Exact<{
  data: IReviewInput
}>

export type ISubmitReviewMutation = { __typename?: 'Mutation'; submitReview?: boolean | null }

export type ITrendingContentsQueryVariables = Exact<{
  audience: Scalars['String']['input']
}>

export type ITrendingContentsQuery = {
  __typename?: 'Query'
  trendingContents: Array<{
    __typename?: 'ContentEntity'
    id?: string | null
    attributes?: {
      __typename?: 'Content'
      documentId: string
      title: string
      snippet: string
      createdAt?: any | null
      publishedTime?: any | null
      contentType?: IEnum_Content_Contenttype | null
      documentType?: IEnum_Content_Documenttype | null
      isMaintained?: boolean | null
      lastMaintained?: any | null
      slug: string
      publishedAt?: any | null
      subjectMatterIds?: Array<string | null> | null
      themeIds?: Array<string | null> | null
      vendorTopicIds?: Array<string | null> | null
      defaultImage: Array<{ __typename?: 'UploadFile'; url: string } | null>
      blogTaxonomies: Array<{
        __typename?: 'BlogTaxonomy'
        documentId: string
        slug?: string | null
        name?: string | null
      } | null>
      audiences: Array<{ __typename?: 'PremiumAudience'; documentId: string; name: string } | null>
      subjectMatters: Array<{ __typename?: 'SubjectMatter'; documentId: string; name?: string | null } | null>
      writer?: Array<{
        __typename?: 'ComponentContentContentWriter'
        writerOption: IEnum_Componentcontentcontentwriter_Writeroption
        oneTimeAuthorName?: string | null
        author?: {
          __typename?: 'Author'
          firstName: string
          lastName: string
          jobTitle?: string | null
          company?: string | null
          bio?: string | null
          slug?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
        } | null
        expert?: {
          __typename?: 'Expert'
          documentId: string
          firstName: string
          lastName: string
          displayName?: string | null
          title?: string | null
          company?: string | null
          bio?: string | null
          slug?: string | null
          avatar?: { __typename?: 'UploadFile'; url: string } | null
          expertiseSubTopics: Array<{
            __typename?: 'SubTopic'
            documentId: string
            name: string
            slug?: string | null
            topics: Array<{
              __typename?: 'Topic'
              documentId: string
              name: string
              description?: string | null
              slug: string
            } | null>
          } | null>
          expertiseTopics: Array<{ __typename?: 'Topic'; name: string; slug: string } | null>
          contents: Array<{ __typename?: 'Content'; documentId: string } | null>
        } | null
        solution?: {
          __typename?: 'Solution'
          displayName?: string | null
          slug?: string | null
          type: IEnum_Solution_Type
          shortDescription?: string | null
          logo?: { __typename?: 'UploadFile'; url: string } | null
        } | null
      } | null> | null
      themes: Array<{ __typename?: 'Theme'; documentId: string; name?: string | null } | null>
      vendorTopics: Array<{ __typename?: 'VendorTopic'; documentId: string; name?: string | null } | null>
    } | null
  }>
}

export type IUpdateAnnouncementMutationVariables = Exact<{
  documentId: Scalars['ID']['input']
  data: IAnnouncementInput
  status?: InputMaybe<IPublicationStatus>
}>

export type IUpdateAnnouncementMutation = {
  __typename?: 'Mutation'
  updateAnnouncement?: {
    __typename?: 'Announcement'
    documentId: string
    announcement: string
    optionalLink?: string | null
    updatedAt?: any | null
  } | null
}

export type IUpdateSharedPortfolioMembersMutationVariables = Exact<{
  sharedPortfolioId: Scalars['ID']['input']
  members: Array<ISharedPortfolioMemberInput> | ISharedPortfolioMemberInput
  name?: InputMaybe<Scalars['String']['input']>
}>

export type IUpdateSharedPortfolioMembersMutation = {
  __typename?: 'Mutation'
  updateSharedPortfolioMembers?: {
    __typename?: 'SharedPortfolioEntity'
    id?: string | null
    attributes?: { __typename?: 'SharedPortfolio'; documentId: string; name: string; slug?: string | null } | null
  } | null
}

export type IUpdateSharedPortfolioSolutionMutationVariables = Exact<{
  id: Scalars['ID']['input']
  category?: InputMaybe<Scalars['String']['input']>
  followingSolutionNote?: InputMaybe<Scalars['String']['input']>
}>

export type IUpdateSharedPortfolioSolutionMutation = {
  __typename?: 'Mutation'
  updateSharedPortfolioSolution?: {
    __typename?: 'SharedPortfolioSolutionEntity'
    id?: string | null
    attributes?: {
      __typename?: 'SharedPortfolioSolution'
      documentId: string
      category?: IEnum_Sharedportfoliosolution_Category | null
      followingSolutionNote?: string | null
      createdAt?: any | null
      updatedAt?: any | null
      solution?: { __typename?: 'Solution'; documentId: string; displayName?: string | null } | null
      sharedPortfolio?: { __typename?: 'SharedPortfolio'; documentId: string; name: string } | null
      lastModifiedByUser?: { __typename?: 'User'; documentId: string; username: string; email: string } | null
    } | null
  } | null
}

export type IUpdateSolutionRequestMutationVariables = Exact<{
  documentId: Scalars['ID']['input']
  data: ISolutionRequestInput
  status?: InputMaybe<IPublicationStatus>
}>

export type IUpdateSolutionRequestMutation = {
  __typename?: 'Mutation'
  updateSolutionRequest?: {
    __typename?: 'SolutionRequest'
    id: string
    documentId: string
    updatedAt?: any | null
  } | null
}

export type IUpdateUserProfileMutationVariables = Exact<{
  id: Scalars['ID']['input']
  data: IUpdateUserProfileInput
}>

export type IUpdateUserProfileMutation = {
  __typename?: 'Mutation'
  updateUserProfile?: {
    __typename: 'User'
    external_id?: string | null
    username: string
    email: string
    confirmed?: boolean | null
    blocked?: boolean | null
    isPremium?: boolean | null
    isVendor?: boolean | null
    jobTitle?: string | null
    companyName?: string | null
    companyType?: IEnum_User_Companytype | null
    companySize?: IEnum_User_Companysize | null
    country?: { __typename?: 'Country'; name: string } | null
    vendor?: { __typename?: 'Vendor'; name: string; email?: string | null } | null
    role?: { __typename: 'UsersPermissionsRole'; name: string } | null
  } | null
}

export type IUserInfoQueryVariables = Exact<{
  token: Scalars['String']['input']
}>

export type IUserInfoQuery = {
  __typename?: 'Query'
  userInfo?: {
    __typename: 'UsersPermissionsMe'
    external_id?: string | null
    username: string
    email?: string | null
    confirmed?: boolean | null
    blocked?: boolean | null
    isPremium?: boolean | null
    isVendor?: boolean | null
    hasVendorCentralAccess?: boolean | null
    jobTitle?: string | null
    companyName?: string | null
    companyType?: string | null
    companySize?: string | null
    country?: { __typename?: 'Country'; documentId: string; code: string; name: string; alpha2: string } | null
    vendor?: {
      __typename?: 'Vendor'
      documentId: string
      name: string
      email?: string | null
      publishedAt?: any | null
    } | null
    role?: { __typename: 'UsersPermissionsMeRole'; name: string } | null
    premiumOrganization?: { __typename?: 'PremiumOrganization'; documentId: string; name: string } | null
    followedSubTopics?: Array<{ __typename?: 'SubTopic'; slug?: string | null; name: string } | null> | null
  } | null
}

export type IVendorAnalysisForSolutionFragment = {
  __typename: 'Content'
  documentId: string
  slug: string
  snippet: string
}

export type IVendorAnalysisBySolutionIdQueryVariables = Exact<{
  solutionId: Scalars['ID']['input']
}>

export type IVendorAnalysisBySolutionIdQuery = {
  __typename?: 'Query'
  contents: Array<{ __typename: 'Content'; documentId: string; slug: string; snippet: string } | null>
}

export type IVisitContentMutationVariables = Exact<{
  content_id: Scalars['ID']['input']
}>

export type IVisitContentMutation = { __typename?: 'Mutation'; visitContent?: boolean | null }

export const SolutionTopicFragmentDoc = gql`
  fragment solutionTopic on Topic {
    documentId
    slug
    name
  }
`
export const SolutionFeatureFragmentDoc = gql`
  fragment solutionFeature on Feature {
    documentId
    name
  }
`
export const SolutionSubTopicFragmentDoc = gql`
  fragment solutionSubTopic on SubTopic {
    documentId
    slug
    name
    features {
      ...solutionFeature
    }
  }
  ${SolutionFeatureFragmentDoc}
`
export const SolutionLogoFragmentDoc = gql`
  fragment solutionLogo on UploadFile {
    id
    url
  }
`
export const SolutionOfficeFragmentDoc = gql`
  fragment solutionOffice on Office {
    documentId
    name
  }
`
export const SolutionHqFragmentDoc = gql`
  fragment solutionHq on Hq {
    documentId
    name
  }
`
export const SolutionRegionsServedFragmentDoc = gql`
  fragment solutionRegionsServed on RegionsServed {
    documentId
    name
  }
`
export const SolutionLanguageFragmentDoc = gql`
  fragment solutionLanguage on PlatformLanguage {
    documentId
    name
  }
`
export const SolutionArticleFragmentDoc = gql`
  fragment solutionArticle on ComponentGlobalArticle {
    id
    image {
      url
      id
    }
    title
    publishedBy
    date
    link
  }
`
export const SolutionExistingCustomerFragmentDoc = gql`
  fragment solutionExistingCustomer on ExistingCustomer {
    documentId
    name
  }
`
export const AllSolutionRequestsItemsFragmentDoc = gql`
  fragment allSolutionRequestsItems on SolutionRequest {
    documentId
    topics {
      ...solutionTopic
    }
    subTopics {
      ...solutionSubTopic
    }
    logo {
      ...solutionLogo
    }
    website
    slug
    shortDescription
    longDescription
    linkedin
    twitter
    type
    offices {
      ...solutionOffice
    }
    hqs {
      ...solutionHq
    }
    regionsServed {
      ...solutionRegionsServed
    }
    languages {
      ...solutionLanguage
    }
    articles {
      ...solutionArticle
    }
    features {
      ...solutionFeature
    }
    existingCustomers {
      ...solutionExistingCustomer
    }
    yearFounded
    createdAt
    publishedAt
    updatedAt
    announcement {
      announcement
      optionalLink
    }
  }
  ${SolutionTopicFragmentDoc}
  ${SolutionSubTopicFragmentDoc}
  ${SolutionLogoFragmentDoc}
  ${SolutionOfficeFragmentDoc}
  ${SolutionHqFragmentDoc}
  ${SolutionRegionsServedFragmentDoc}
  ${SolutionLanguageFragmentDoc}
  ${SolutionArticleFragmentDoc}
  ${SolutionFeatureFragmentDoc}
  ${SolutionExistingCustomerFragmentDoc}
`
export const ContentTeaserBySolutionFragmentDoc = gql`
  fragment contentTeaserBySolution on Content {
    documentId
    __typename
    slug
    snippet
  }
`
export const AllContentsSlugItemFragmentDoc = gql`
  fragment allContentsSlugItem on Content {
    documentId
    slug
  }
`
export const AllSolutionsSlugItemFragmentDoc = gql`
  fragment allSolutionsSlugItem on Solution {
    slug
  }
`
export const AuthorFullItemFragmentDoc = gql`
  fragment authorFullItem on Author {
    firstName
    lastName
    jobTitle
    company
    bio
    linkedin
    twitter
    slug
    avatar {
      url
    }
    subjectMatters {
      name
      slug
    }
    themes {
      name
      slug
    }
  }
`
export const AuthorItemFragmentDoc = gql`
  fragment authorItem on Author {
    documentId
    firstName
    lastName
    displayName
    jobTitle
    company
    slug
    avatar {
      url
    }
  }
`
export const AutosuggestItemFragmentDoc = gql`
  fragment autosuggestItem on Suggest {
    keyword
    model
    id
    logo
    slug
  }
`
export const BlogTaxonomyDataFragmentDoc = gql`
  fragment blogTaxonomyData on BlogTaxonomy {
    name
    slug
    description
  }
`
export const AuthorCardDataFragmentDoc = gql`
  fragment authorCardData on Author {
    firstName
    lastName
    jobTitle
    company
    bio
    slug
    avatar {
      url
    }
  }
`
export const ExpertCardDataFragmentDoc = gql`
  fragment expertCardData on Expert {
    documentId
    firstName
    lastName
    displayName
    title
    company
    bio
    slug
    avatar {
      url
    }
    expertiseSubTopics {
      documentId
      name
      slug
      topics {
        documentId
        name
        description
        slug
      }
    }
    expertiseTopics {
      name
      slug
    }
    contents {
      documentId
    }
  }
`
export const SolutionCardDataFragmentDoc = gql`
  fragment solutionCardData on Solution {
    displayName
    slug
    type
    shortDescription
    logo {
      url
    }
  }
`
export const ContentWriterFragmentDoc = gql`
  fragment contentWriter on ComponentContentContentWriter {
    writerOption
    author {
      ...authorCardData
    }
    expert {
      ...expertCardData
    }
    solution {
      ...solutionCardData
    }
    oneTimeAuthorName
  }
  ${AuthorCardDataFragmentDoc}
  ${ExpertCardDataFragmentDoc}
  ${SolutionCardDataFragmentDoc}
`
export const ContentListItemFragmentDoc = gql`
  fragment contentListItem on Content {
    documentId
    title
    snippet
    createdAt
    publishedTime
    contentType
    documentType
    isMaintained
    lastMaintained
    slug
    publishedAt
    defaultImage {
      url
    }
    blogTaxonomies {
      documentId
      slug
      name
    }
    audiences {
      documentId
      name
    }
    subjectMatters {
      documentId
      name
    }
    subjectMatterIds
    themeIds
    vendorTopicIds
    writer {
      ...contentWriter
    }
    themes {
      documentId
      name
    }
    vendorTopics {
      documentId
      name
    }
  }
  ${ContentWriterFragmentDoc}
`
export const BlogTaxonomyFullDataFragmentDoc = gql`
  fragment blogTaxonomyFullData on BlogTaxonomy {
    documentId
    name
    slug
    description
    publishedAt
    latestContent {
      ...contentListItem
    }
    showVendorTopics
  }
  ${ContentListItemFragmentDoc}
`
export const IltaSponsorshipLogoFragmentDoc = gql`
  fragment iltaSponsorshipLogo on UploadFile {
    documentId
    url
  }
`
export const CompanyIltaSponsorshipFragmentDoc = gql`
  fragment companyIltaSponsorship on IltaSponsorship {
    name
    logo {
      ...iltaSponsorshipLogo
    }
  }
  ${IltaSponsorshipLogoFragmentDoc}
`
export const CompanyDataFragmentDoc = gql`
  fragment companyData on Company {
    documentId
    slug
    name
    description
    website
    logo {
      url
    }
    solutions {
      slug
    }
    services
    yearFounded
    size
    regionsServed {
      name
    }
    hqs {
      name
    }
    iltaSponsorships @include(if: $includeIlta) {
      ...companyIltaSponsorship
    }
    openToInvestment
    linkedin
    twitter
    fundingInfo
    fundingAmount
    fundingDetails
    founders {
      id
      avatar {
        id
        url
      }
      name
      role
      experiencedFounder
      bio
      title
      externalLink
    }
    isDiverseLeadership
  }
  ${CompanyIltaSponsorshipFragmentDoc}
`
export const ContentDataDownloadMaterialFragmentDoc = gql`
  fragment contentDataDownloadMaterial on ComponentContentDownloadMaterial {
    title
    isEnabled
    format
    lastUpdated
    downloadButtonName
    files {
      name
    }
  }
`
export const ContentDataFragmentDoc = gql`
  fragment contentData on Content {
    documentId
    title
    publishedAt
    createdAt
    publishedTime
    lastMaintained
    isMaintained
    contentType
    slug
    snippet
    isPremium
    isLatestBlog
    defaultImage {
      url
      __typename
    }
    blogTaxonomies {
      name
      slug
      __typename
    }
    subjectMatters {
      name
      slug
      __typename
    }
    downloadMaterial {
      ...contentDataDownloadMaterial
      __typename
    }
    writer {
      ...contentWriter
      __typename
    }
    __typename
  }
  ${ContentDataDownloadMaterialFragmentDoc}
  ${ContentWriterFragmentDoc}
`
export const ContentDataEntityFragmentDoc = gql`
  fragment contentDataEntity on ContentEntity {
    id
    attributes {
      ...contentData
    }
  }
  ${ContentDataFragmentDoc}
`
export const ContentItemWriterFragmentDoc = gql`
  fragment contentItemWriter on ContentItemWriter {
    writerOption
    name
    avatar
    title
    url
  }
`
export const ContentItemFragmentDoc = gql`
  fragment contentItem on ContentItem {
    documentId
    slug
    contentType
    documentType
    title
    snippet
    defaultImage
    writer {
      ...contentItemWriter
    }
    writers {
      ...contentItemWriter
    }
    publishedTime
    isMaintained
    lastMaintainedAt
    subjectMatters
    subjectMatterIds
    themeIds
    vendorTopicIds
    themes
    vendorTopics
  }
  ${ContentItemWriterFragmentDoc}
`
export const ContentListItemEntityFragmentDoc = gql`
  fragment contentListItemEntity on ContentEntity {
    id
    attributes {
      ...contentListItem
    }
  }
  ${ContentListItemFragmentDoc}
`
export const ExpertFullItemFragmentDoc = gql`
  fragment expertFullItem on Expert {
    documentId
    firstName
    lastName
    title
    bio
    linkedin
    twitter
    slug
    experience
    avatar {
      url
    }
    expertiseSubTopics {
      documentId
      name
      slug
      topics {
        documentId
        name
        description
        slug
      }
    }
    expertiseTopics {
      documentId
      name
      slug
    }
    secondaryExpertiseSubTopics {
      documentId
      name
      slug
      topics {
        documentId
        name
        description
        slug
      }
    }
    secondaryExpertiseTopics {
      documentId
      name
      slug
    }
    contents {
      documentId
    }
  }
`
export const IltaSponsorshipItemFragmentDoc = gql`
  fragment iltaSponsorshipItem on IltaSponsorship {
    documentId
    name
    logo {
      url
    }
    level
    description
  }
`
export const PhaseItemFragmentDoc = gql`
  fragment phaseItem on Phase {
    documentId
    title
    description
  }
`
export const PremiumAudienceItemFragmentDoc = gql`
  fragment premiumAudienceItem on PremiumAudience {
    documentId
    name
    shouldShowOnHomepage
  }
`
export const ResourceInvitationEntityFragmentDoc = gql`
  fragment resourceInvitationEntity on ResourceInvitationEntity {
    documentId
    name
    businessEmail
    companyLawFirmName
    dateInvited
    status
    contents {
      documentId
      title
      slug
      sharedResources {
        visits {
          visited_by {
            documentId
            username
          }
        }
        downloads {
          downloaded_by {
            documentId
            username
          }
        }
      }
    }
  }
`
export const SharedPortfolioUserSummaryFragmentDoc = gql`
  fragment sharedPortfolioUserSummary on User {
    documentId
    username
    email
    companyName
    jobTitle
    companyType
    premiumOrganization {
      documentId
      name
      emailDomain
    }
    country {
      documentId
      name
    }
    role {
      name
      type
    }
    vendor {
      documentId
      name
      email
    }
  }
`
export const SharedPortfolioMembershipItemFragmentDoc = gql`
  fragment sharedPortfolioMembershipItem on SharedPortfolioMembership {
    documentId
    role
    isActive
    user {
      ...sharedPortfolioUserSummary
    }
  }
  ${SharedPortfolioUserSummaryFragmentDoc}
`
export const SharedPortfolioSolutionItemFragmentDoc = gql`
  fragment sharedPortfolioSolutionItem on SharedPortfolioSolution {
    documentId
    category
    followingSolutionNote
    createdAt
    updatedAt
    solution {
      documentId
      id
      displayName
      slug
      isPremium
    }
    sharedPortfolio {
      documentId
      name
    }
    lastModifiedByUser {
      documentId
      username
      email
      companyName
    }
  }
`
export const SharedPortfolioEntityItemFragmentDoc = gql`
  fragment sharedPortfolioEntityItem on SharedPortfolioEntity {
    id
    attributes {
      documentId
      name
      slug
      isSharedPortfolio
      createdByUser {
        ...sharedPortfolioUserSummary
      }
      lastModifiedByUser {
        documentId
        username
        email
      }
      shared_portfolio_memberships {
        ...sharedPortfolioMembershipItem
      }
      shared_portfolio_solutions {
        ...sharedPortfolioSolutionItem
      }
    }
  }
  ${SharedPortfolioUserSummaryFragmentDoc}
  ${SharedPortfolioMembershipItemFragmentDoc}
  ${SharedPortfolioSolutionItemFragmentDoc}
`
export const SimilarSolutionItemFragmentDoc = gql`
  fragment similarSolutionItem on SimilarSolutionItem {
    type
    slug
    displayName
    logo
    rating
    reviewCnt
  }
`
export const SmartsearchItemFragmentDoc = gql`
  fragment smartsearchItem on Smartsearch {
    result
    id
    identicalId
    sources {
      sourceUrl
      title
      description
      logo
      contentType
    }
    logs {
      message
      timestamp
    }
  }
`
export const SolutionCarouselItemFragmentDoc = gql`
  fragment solutionCarouselItem on SolutionItem {
    id
    slug
    displayName
    logo
    subTopics
    isPremium
  }
`
export const SolutionCompanyFragmentDoc = gql`
  fragment solutionCompany on Company {
    name
    slug
  }
`
export const SolutionReviewFragmentDoc = gql`
  fragment solutionReview on Review {
    anonymous
    rating
    title
    content
    submitterTitle
    submitterSubTitle
    solutionDispName
    createdAt
    updatedAt
    publishedAt
    solution {
      displayName
      slug
      rating
      company {
        slug
      }
      logo {
        url
      }
    }
  }
`
export const SolutionVendorResourceExternalFragmentDoc = gql`
  fragment solutionVendorResourceExternal on ComponentSolutionPropsVendorResourceExternal {
    title
    summary
    link
    publishedDate
    author
    documentType
  }
`
export const SolutionVendorResourceFragmentDoc = gql`
  fragment solutionVendorResource on ComponentSolutionPropsVendorResource {
    type
    content {
      ...contentListItem
    }
    external {
      ...solutionVendorResourceExternal
    }
  }
  ${ContentListItemFragmentDoc}
  ${SolutionVendorResourceExternalFragmentDoc}
`
export const SolutionIltaSponsorshipFragmentDoc = gql`
  fragment solutionIltaSponsorship on IltaSponsorship {
    documentId
    name
    logo {
      ...iltaSponsorshipLogo
    }
  }
  ${IltaSponsorshipLogoFragmentDoc}
`
export const SolutionAnnouncementFragmentDoc = gql`
  fragment solutionAnnouncement on Announcement {
    documentId
    announcement
    optionalLink
    publishedAt
    isArchived
  }
`
export const GeneralSolutionDataFragmentDoc = gql`
  fragment generalSolutionData on Solution {
    id
    documentId
    displayName
    oldSlug
    type
    topics {
      ...solutionTopic
    }
    subTopics {
      ...solutionSubTopic
    }
    logo {
      ...solutionLogo
    }
    company {
      ...solutionCompany
    }
    website
    linkedin
    twitter
    isPremium
    slug
    shortDescription
    longDescription
    isBeta
    isStartup
    reviews {
      ...solutionReview
    }
    rating
    offices {
      ...solutionOffice
    }
    hqs {
      ...solutionHq
    }
    regionsServed {
      ...solutionRegionsServed
    }
    languages {
      ...solutionLanguage
    }
    articles {
      ...solutionArticle
    }
    vendorResources {
      ...solutionVendorResource
    }
    features {
      ...solutionFeature
    }
    existingCustomers {
      ...solutionExistingCustomer
    }
    iltaSponsorships @include(if: $includeIlta) {
      ...solutionIltaSponsorship
    }
    yearFounded
    createdAt
    publishedAt
    announcement {
      id
      announcement
      optionalLink
      publishedAt
    }
    descOtherExistingCustomer
    descOtherIntegration
    isDiverseLeadership
    announcement {
      ...solutionAnnouncement
    }
  }
  ${SolutionTopicFragmentDoc}
  ${SolutionSubTopicFragmentDoc}
  ${SolutionLogoFragmentDoc}
  ${SolutionCompanyFragmentDoc}
  ${SolutionReviewFragmentDoc}
  ${SolutionOfficeFragmentDoc}
  ${SolutionHqFragmentDoc}
  ${SolutionRegionsServedFragmentDoc}
  ${SolutionLanguageFragmentDoc}
  ${SolutionArticleFragmentDoc}
  ${SolutionVendorResourceFragmentDoc}
  ${SolutionFeatureFragmentDoc}
  ${SolutionExistingCustomerFragmentDoc}
  ${SolutionIltaSponsorshipFragmentDoc}
  ${SolutionAnnouncementFragmentDoc}
`
export const SolutionAudienceFragmentDoc = gql`
  fragment solutionAudience on Demographic {
    documentId
    name
  }
`
export const SolutionCallToActionFragmentDoc = gql`
  fragment solutionCallToAction on ComponentGlobalCallToAction {
    label
    url
  }
`
export const SolutionDedicatedResourceFragmentDoc = gql`
  fragment solutionDedicatedResource on ComponentSolutionPropsDedicatedResource {
    count
    type
  }
`
export const SolutionSpecialistFragmentDoc = gql`
  fragment solutionSpecialist on ComponentAboutPropsTeamMember {
    avatar {
      url
    }
    name
    role
    bio
  }
`
export const SolutionScreenshotFragmentDoc = gql`
  fragment solutionScreenshot on ComponentGlobalPicture {
    id
    title
    summary
    image {
      url
      id
    }
  }
`
export const SolutionVideoFragmentDoc = gql`
  fragment solutionVideo on ComponentSolutionPropsVideo {
    title
    summary
    url
  }
`
export const SolutionCaseStudyFragmentDoc = gql`
  fragment solutionCaseStudy on ComponentGlobalSuccessStory {
    name
    link
  }
`
export const SolutionTestimonialEnhancedFragmentDoc = gql`
  fragment solutionTestimonialEnhanced on ComponentTestimonialsTestimonials {
    id
    description
    author {
      name
      role
      company
      avatar {
        url
        id
      }
    }
  }
`
export const AlspSolutionEnhancedListingDataFragmentDoc = gql`
  fragment alspSolutionEnhancedListingData on ComponentSolutionPropsAlspEnhanced {
    callToAction {
      ...solutionCallToAction
    }
    serviceDescription
    dedicatedResources {
      ...solutionDedicatedResource
    }
    technologyPartners
    averageLengthOfEngagement
    pricingData
    specialists {
      ...solutionSpecialist
    }
    screenshots {
      ...solutionScreenshot
    }
    videos {
      ...solutionVideo
    }
    caseStudies {
      ...solutionCaseStudy
    }
    testimonials {
      ...solutionTestimonialEnhanced
    }
  }
  ${SolutionCallToActionFragmentDoc}
  ${SolutionDedicatedResourceFragmentDoc}
  ${SolutionSpecialistFragmentDoc}
  ${SolutionScreenshotFragmentDoc}
  ${SolutionVideoFragmentDoc}
  ${SolutionCaseStudyFragmentDoc}
  ${SolutionTestimonialEnhancedFragmentDoc}
`
export const SolutionAlspDataFragmentDoc = gql`
  fragment solutionAlspData on ComponentSolutionAlspData {
    name
    serviceName
    size
    partners
    fundingInfo
    fundingAmount
    fundingDetails
    openToInvestment
    valueProposition
    security {
      documentId
      name
    }
    audiences {
      ...solutionAudience
    }
    enhancedListingData {
      ...alspSolutionEnhancedListingData
    }
  }
  ${SolutionAudienceFragmentDoc}
  ${AlspSolutionEnhancedListingDataFragmentDoc}
`
export const SolutionConsolidationDataFragmentDoc = gql`
  fragment solutionConsolidationData on ComponentSolutionPropsConsolidation {
    date
    amount
    article
    articleLink
    originalTargetName
    buyer
    enableInActiveDir
  }
`
export const SolutionGraveyardDataFragmentDoc = gql`
  fragment solutionGraveyardData on ComponentSolutionPropsGraveyard {
    date
  }
`
export const SolutionFounderFragmentDoc = gql`
  fragment solutionFounder on ComponentAboutPropsTeamMember {
    avatar {
      url
      id
    }
    name
    role
    bio
    title
    externalLink
  }
`
export const AlspSolutionDataFragmentDoc = gql`
  fragment alspSolutionData on Solution {
    ...generalSolutionData
    productType
    alspData {
      ...solutionAlspData
    }
    consolidationData {
      ...solutionConsolidationData
    }
    graveyardData {
      ...solutionGraveyardData
    }
    founders {
      ...solutionFounder
    }
    vendor {
      publishedAt
      documentId
      users {
        external_id
      }
    }
  }
  ${GeneralSolutionDataFragmentDoc}
  ${SolutionAlspDataFragmentDoc}
  ${SolutionConsolidationDataFragmentDoc}
  ${SolutionGraveyardDataFragmentDoc}
  ${SolutionFounderFragmentDoc}
`
export const CompanyFounderFragmentDoc = gql`
  fragment companyFounder on ComponentCompanyCompanyFounder {
    avatar {
      url
    }
    name
    role
    bio
    title
    externalLink
    experiencedFounder
  }
`
export const SolutionIntegrationFragmentDoc = gql`
  fragment solutionIntegration on Integration {
    documentId
    name
  }
`
export const SolutionPracticeAreaFragmentDoc = gql`
  fragment solutionPracticeArea on PracticeArea {
    documentId
    name
  }
`
export const SolutionTypeOfUserFragmentDoc = gql`
  fragment solutionTypeOfUser on TypeOfUser {
    documentId
    name
  }
`
export const ConsultancySolutionEnhancedListingDataFragmentDoc = gql`
  fragment consultancySolutionEnhancedListingData on ComponentSolutionPropsConsultantEnhanced {
    callToAction {
      ...solutionCallToAction
    }
    serviceDescription
    dedicatedResources {
      ...solutionDedicatedResource
    }
    technologyPartners
    averageLengthOfEngagement
    caseStudies {
      ...solutionCaseStudy
    }
    specialists {
      ...solutionSpecialist
    }
    screenshots {
      ...solutionScreenshot
    }
    videos {
      ...solutionVideo
    }
    pricingData
    testimonials {
      ...solutionTestimonialEnhanced
    }
  }
  ${SolutionCallToActionFragmentDoc}
  ${SolutionDedicatedResourceFragmentDoc}
  ${SolutionCaseStudyFragmentDoc}
  ${SolutionSpecialistFragmentDoc}
  ${SolutionScreenshotFragmentDoc}
  ${SolutionVideoFragmentDoc}
  ${SolutionTestimonialEnhancedFragmentDoc}
`
export const SolutionConsultancyDataFragmentDoc = gql`
  fragment solutionConsultancyData on ComponentSolutionConsultantData {
    name
    serviceName
    size
    partners
    fundingInfo
    fundingAmount
    fundingDetails
    openToInvestment
    valueProposition
    security {
      documentId
      name
    }
    audiences {
      ...solutionAudience
    }
    integrations {
      ...solutionIntegration
    }
    practiceAreas {
      ...solutionPracticeArea
    }
    typeOfUser {
      ...solutionTypeOfUser
    }
    enhancedListingData {
      ...consultancySolutionEnhancedListingData
    }
  }
  ${SolutionAudienceFragmentDoc}
  ${SolutionIntegrationFragmentDoc}
  ${SolutionPracticeAreaFragmentDoc}
  ${SolutionTypeOfUserFragmentDoc}
  ${ConsultancySolutionEnhancedListingDataFragmentDoc}
`
export const ConsultancySolutionDataFragmentDoc = gql`
  fragment consultancySolutionData on Solution {
    ...generalSolutionData
    productType
    consultantData {
      ...solutionConsultancyData
    }
    consolidationData {
      ...solutionConsolidationData
    }
    graveyardData {
      ...solutionGraveyardData
    }
    founders {
      ...solutionFounder
    }
    vendor {
      publishedAt
      documentId
      users {
        external_id
      }
    }
  }
  ${GeneralSolutionDataFragmentDoc}
  ${SolutionConsultancyDataFragmentDoc}
  ${SolutionConsolidationDataFragmentDoc}
  ${SolutionGraveyardDataFragmentDoc}
  ${SolutionFounderFragmentDoc}
`
export const SolutionAttributeFragmentDoc = gql`
  fragment solutionAttribute on Attribute {
    documentId
    name
  }
`
export const SolutionDeploymentFragmentDoc = gql`
  fragment solutionDeployment on Installation {
    documentId
    name
  }
`
export const ProductSolutionEnhancedListingDataFragmentDoc = gql`
  fragment productSolutionEnhancedListingData on ComponentSolutionPropsProductEnhanced {
    callToAction {
      ...solutionCallToAction
    }
    screenshots {
      ...solutionScreenshot
    }
    videos {
      ...solutionVideo
    }
    pricingData
    testimonials {
      ...solutionTestimonialEnhanced
    }
  }
  ${SolutionCallToActionFragmentDoc}
  ${SolutionScreenshotFragmentDoc}
  ${SolutionVideoFragmentDoc}
  ${SolutionTestimonialEnhancedFragmentDoc}
`
export const SolutionProductDataFragmentDoc = gql`
  fragment solutionProductData on ComponentSolutionProductData {
    name
    tool
    audiences {
      ...solutionAudience
    }
    attributes {
      ...solutionAttribute
    }
    deployments {
      ...solutionDeployment
    }
    integrations {
      ...solutionIntegration
    }
    practiceAreas {
      ...solutionPracticeArea
    }
    typeOfUser {
      ...solutionTypeOfUser
    }
    fundingInfo
    fundingAmount
    fundingDetails
    openToInvestment
    valueProposition
    security {
      documentId
      name
    }
    dataHostingLocations {
      documentId
      name
    }
    enhancedListingData {
      ...productSolutionEnhancedListingData
    }
  }
  ${SolutionAudienceFragmentDoc}
  ${SolutionAttributeFragmentDoc}
  ${SolutionDeploymentFragmentDoc}
  ${SolutionIntegrationFragmentDoc}
  ${SolutionPracticeAreaFragmentDoc}
  ${SolutionTypeOfUserFragmentDoc}
  ${ProductSolutionEnhancedListingDataFragmentDoc}
`
export const ProductSolutionDataFragmentDoc = gql`
  fragment productSolutionData on Solution {
    ...generalSolutionData
    productType
    productData {
      ...solutionProductData
    }
    consolidationData {
      ...solutionConsolidationData
    }
    graveyardData {
      ...solutionGraveyardData
    }
    founders {
      ...solutionFounder
    }
    vendor {
      publishedAt
      documentId
      users {
        external_id
      }
    }
  }
  ${GeneralSolutionDataFragmentDoc}
  ${SolutionProductDataFragmentDoc}
  ${SolutionConsolidationDataFragmentDoc}
  ${SolutionGraveyardDataFragmentDoc}
  ${SolutionFounderFragmentDoc}
`
export const GeneralSolutionRequestDataFragmentDoc = gql`
  fragment generalSolutionRequestData on SolutionRequest {
    id
    documentId
    topics {
      ...solutionTopic
    }
    subTopics {
      ...solutionSubTopic
    }
    logo {
      ...solutionLogo
    }
    website
    slug
    shortDescription
    longDescription
    linkedin
    twitter
    type
    offices {
      ...solutionOffice
    }
    hqs {
      ...solutionHq
    }
    regionsServed {
      ...solutionRegionsServed
    }
    languages {
      ...solutionLanguage
    }
    articles {
      ...solutionArticle
    }
    features {
      ...solutionFeature
    }
    existingCustomers {
      ...solutionExistingCustomer
    }
    yearFounded
    createdAt
    publishedAt
    updatedAt
    announcement {
      documentId
      announcement
      optionalLink
    }
  }
  ${SolutionTopicFragmentDoc}
  ${SolutionSubTopicFragmentDoc}
  ${SolutionLogoFragmentDoc}
  ${SolutionOfficeFragmentDoc}
  ${SolutionHqFragmentDoc}
  ${SolutionRegionsServedFragmentDoc}
  ${SolutionLanguageFragmentDoc}
  ${SolutionArticleFragmentDoc}
  ${SolutionFeatureFragmentDoc}
  ${SolutionExistingCustomerFragmentDoc}
`
export const SolutionRequestEnhancedListingDataFragmentDoc = gql`
  fragment solutionRequestEnhancedListingData on ComponentSolutionRequestPropsProductEnhanced {
    screenshots {
      ...solutionScreenshot
    }
    videos {
      ...solutionVideo
    }
    pricingData
    callToAction {
      ...solutionCallToAction
    }
    testimonials {
      ...solutionTestimonialEnhanced
    }
  }
  ${SolutionScreenshotFragmentDoc}
  ${SolutionVideoFragmentDoc}
  ${SolutionCallToActionFragmentDoc}
  ${SolutionTestimonialEnhancedFragmentDoc}
`
export const SolutionRequestDatasFragmentDoc = gql`
  fragment solutionRequestDatas on ComponentSolutionRequestProductData {
    name
    audiences {
      ...solutionAudience
    }
    attributes {
      ...solutionAttribute
    }
    integrations {
      ...solutionIntegration
    }
    fundingAmount
    fundingInfo
    practiceAreas {
      ...solutionPracticeArea
    }
    typeOfUser {
      ...solutionTypeOfUser
    }
    enhancedListingData {
      ...solutionRequestEnhancedListingData
    }
    valueProposition
    security {
      documentId
      name
    }
    dataHosting {
      documentId
      name
    }
    deployments {
      ...solutionDeployment
    }
  }
  ${SolutionAudienceFragmentDoc}
  ${SolutionAttributeFragmentDoc}
  ${SolutionIntegrationFragmentDoc}
  ${SolutionPracticeAreaFragmentDoc}
  ${SolutionTypeOfUserFragmentDoc}
  ${SolutionRequestEnhancedListingDataFragmentDoc}
  ${SolutionDeploymentFragmentDoc}
`
export const SolutionRequestDataFragmentDoc = gql`
  fragment solutionRequestData on SolutionRequest {
    ...generalSolutionRequestData
    productData {
      ...solutionRequestDatas
    }
  }
  ${GeneralSolutionRequestDataFragmentDoc}
  ${SolutionRequestDatasFragmentDoc}
`
export const SolutionStoryFragmentDoc = gql`
  fragment solutionStory on ComponentGlobalSuccessStory {
    name
    link
  }
`
export const SolutionTestimonialFragmentDoc = gql`
  fragment solutionTestimonial on ComponentGlobalTestimonial {
    description
    avatar {
      url
    }
    name
    role
    company
  }
`
export const SolutionFollowedSolutionsDataFragmentDoc = gql`
  fragment solutionFollowedSolutionsData on ComponentFollowingSolutionsData {
    followingType
    followingSolutionNote
    noteCreatedAt
    noteCreatedByName
    noteLastEditedAt
    noteLastEditedByName
  }
`
export const SolutionSharedPortfolioSolutionDataFragmentDoc = gql`
  fragment solutionSharedPortfolioSolutionData on SolutionSharedPortfolioSolutionData {
    category
    followingSolutionNote
    sharedPortfolio
    slug
    name
    portfolioId
    organizationId
    members
  }
`
export const SolutionListItemFragmentDoc = gql`
  fragment solutionListItem on SolutionItem {
    documentId
    slug
    type
    displayName
    description
    logo
    subTopics
    follow
    rating
    reviewCnt
    isPremium
    isStartup
    isBeta
    isDiverseLeadership
    consolidation {
      ...solutionConsolidationData
    }
    graveyard {
      ...solutionGraveyardData
    }
    iltaSponsorshipLogo
    followedSolutionsData {
      ...solutionFollowedSolutionsData
    }
    shared_portfolio_solutions {
      ...solutionSharedPortfolioSolutionData
    }
    customTagsWithName {
      id
      name
      slug
    }
  }
  ${SolutionConsolidationDataFragmentDoc}
  ${SolutionGraveyardDataFragmentDoc}
  ${SolutionFollowedSolutionsDataFragmentDoc}
  ${SolutionSharedPortfolioSolutionDataFragmentDoc}
`
export const TopicItemWithoutSubFragmentDoc = gql`
  fragment topicItemWithoutSub on Topic {
    slug
    name
    description
    iconName
    isPremium
    publishedAt
  }
`
export const SubTopicItemFragmentDoc = gql`
  fragment subTopicItem on SubTopic {
    id
    documentId
    slug
    name
    description
    isPremium
    publishedAt
    topics {
      ...topicItemWithoutSub
    }
  }
  ${TopicItemWithoutSubFragmentDoc}
`
export const SubTopicFullItemFragmentDoc = gql`
  fragment subTopicFullItem on SubTopic {
    ...subTopicItem
    expert {
      ...expertCardData
    }
    secondaryExpert {
      ...expertCardData
    }
    contents {
      documentId
    }
    topics {
      documentId
      slug
      name
      iconName
      description
      isPremium
      publishedAt
    }
    followedUsers {
      documentId
      username
      email
    }
  }
  ${SubTopicItemFragmentDoc}
  ${ExpertCardDataFragmentDoc}
`
export const TestimonialItemFragmentDoc = gql`
  fragment testimonialItem on Testimonials {
    description
    author {
      name
      role
      company
      avatar {
        url
      }
    }
  }
`
export const SubTopicItemWithoutSubFragmentDoc = gql`
  fragment subTopicItemWithoutSub on SubTopic {
    documentId
    slug
    name
    description
    isPremium
    publishedAt
  }
`
export const TopicItemFragmentDoc = gql`
  fragment topicItem on Topic {
    documentId
    slug
    name
    iconName
    description
    isPremium
    publishedAt
    subTopics(sort: "isPremium:asc") {
      ...subTopicItemWithoutSub
    }
  }
  ${SubTopicItemWithoutSubFragmentDoc}
`
export const TopicFullItemFragmentDoc = gql`
  fragment topicFullItem on Topic {
    ...topicItem
    expert {
      ...expertCardData
    }
    secondaryExpert {
      ...expertCardData
    }
    subTopics(sort: "isPremium:asc") {
      ...subTopicItemWithoutSub
    }
    contents {
      documentId
    }
  }
  ${TopicItemFragmentDoc}
  ${ExpertCardDataFragmentDoc}
  ${SubTopicItemWithoutSubFragmentDoc}
`
export const TopicHeaderDataFragmentDoc = gql`
  fragment topicHeaderData on Topic {
    slug
    name
    description
    isPremium
    expert {
      ...expertCardData
    }
  }
  ${ExpertCardDataFragmentDoc}
`
export const SubtopicListItemFragmentDoc = gql`
  fragment subtopicListItem on SubtopicItem {
    documentId
    slug
    name
    description
    featuredOnHome
    isPremium
    solutionsTotalCount
    contentsTotalCount
    topicSlug
    topicName
    iconName
  }
`
export const VendorAnalysisForSolutionFragmentDoc = gql`
  fragment vendorAnalysisForSolution on Content {
    documentId
    __typename
    slug
    snippet
  }
`
export const GetAllMasterDataDocument = gql`
  query GetAllMasterData {
    getAllMasterData {
      hqs {
        id
        documentId
        name
      }
      platformLanguages {
        id
        documentId
        name
      }
      subTopics {
        id
        documentId
        name
      }
      offices {
        id
        documentId
        name
      }
      regionsServed {
        id
        documentId
        name
      }
      demographics {
        id
        documentId
        name
      }
      typeOfUsers {
        id
        documentId
        name
      }
      existingCustomers {
        id
        documentId
        name
      }
      practiceAreas {
        id
        documentId
        name
      }
      attributes {
        id
        documentId
        name
      }
      integrations {
        id
        documentId
        name
      }
      securities {
        id
        documentId
        name
      }
      installations {
        id
        documentId
        name
      }
    }
  }
`

/**
 * __useGetAllMasterDataQuery__
 *
 * To run a query within a React component, call `useGetAllMasterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMasterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMasterDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllMasterDataQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetAllMasterDataQuery, IGetAllMasterDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetAllMasterDataQuery, IGetAllMasterDataQueryVariables>(GetAllMasterDataDocument, options)
}
export function useGetAllMasterDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetAllMasterDataQuery, IGetAllMasterDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetAllMasterDataQuery, IGetAllMasterDataQueryVariables>(GetAllMasterDataDocument, options)
}
export function useGetAllMasterDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetAllMasterDataQuery, IGetAllMasterDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetAllMasterDataQuery, IGetAllMasterDataQueryVariables>(
    GetAllMasterDataDocument,
    options,
  )
}
export type GetAllMasterDataQueryHookResult = ReturnType<typeof useGetAllMasterDataQuery>
export type GetAllMasterDataLazyQueryHookResult = ReturnType<typeof useGetAllMasterDataLazyQuery>
export type GetAllMasterDataSuspenseQueryHookResult = ReturnType<typeof useGetAllMasterDataSuspenseQuery>
export type GetAllMasterDataQueryResult = Apollo.QueryResult<IGetAllMasterDataQuery, IGetAllMasterDataQueryVariables>
export const SearchContentsTotalDocument = gql`
  query searchContentsTotal($query: JSON) {
    contentResults(query: $query) {
      success
      data {
        total
      }
    }
  }
`

/**
 * __useSearchContentsTotalQuery__
 *
 * To run a query within a React component, call `useSearchContentsTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContentsTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContentsTotalQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchContentsTotalQuery(
  baseOptions?: Apollo.QueryHookOptions<ISearchContentsTotalQuery, ISearchContentsTotalQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ISearchContentsTotalQuery, ISearchContentsTotalQueryVariables>(
    SearchContentsTotalDocument,
    options,
  )
}
export function useSearchContentsTotalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ISearchContentsTotalQuery, ISearchContentsTotalQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ISearchContentsTotalQuery, ISearchContentsTotalQueryVariables>(
    SearchContentsTotalDocument,
    options,
  )
}
export function useSearchContentsTotalSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ISearchContentsTotalQuery, ISearchContentsTotalQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ISearchContentsTotalQuery, ISearchContentsTotalQueryVariables>(
    SearchContentsTotalDocument,
    options,
  )
}
export type SearchContentsTotalQueryHookResult = ReturnType<typeof useSearchContentsTotalQuery>
export type SearchContentsTotalLazyQueryHookResult = ReturnType<typeof useSearchContentsTotalLazyQuery>
export type SearchContentsTotalSuspenseQueryHookResult = ReturnType<typeof useSearchContentsTotalSuspenseQuery>
export type SearchContentsTotalQueryResult = Apollo.QueryResult<
  ISearchContentsTotalQuery,
  ISearchContentsTotalQueryVariables
>
export const AddSolutionToSharedPortfolioDocument = gql`
  mutation AddSolutionToSharedPortfolio(
    $sharedID: ID!
    $category: String!
    $followingSolutionNote: String
    $solution: ID!
  ) {
    addSolutionToSharedPortfolio(
      sharedID: $sharedID
      category: $category
      followingSolutionNote: $followingSolutionNote
      solution: $solution
    ) {
      id
      attributes {
        documentId
        category
        followingSolutionNote
        createdAt
        updatedAt
        solution {
          documentId
          displayName
        }
        sharedPortfolio {
          documentId
          name
        }
        lastModifiedByUser {
          documentId
          username
          email
        }
      }
    }
  }
`
export type IAddSolutionToSharedPortfolioMutationFn = Apollo.MutationFunction<
  IAddSolutionToSharedPortfolioMutation,
  IAddSolutionToSharedPortfolioMutationVariables
>

/**
 * __useAddSolutionToSharedPortfolioMutation__
 *
 * To run a mutation, you first call `useAddSolutionToSharedPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSolutionToSharedPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSolutionToSharedPortfolioMutation, { data, loading, error }] = useAddSolutionToSharedPortfolioMutation({
 *   variables: {
 *      sharedID: // value for 'sharedID'
 *      category: // value for 'category'
 *      followingSolutionNote: // value for 'followingSolutionNote'
 *      solution: // value for 'solution'
 *   },
 * });
 */
export function useAddSolutionToSharedPortfolioMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IAddSolutionToSharedPortfolioMutation,
    IAddSolutionToSharedPortfolioMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IAddSolutionToSharedPortfolioMutation, IAddSolutionToSharedPortfolioMutationVariables>(
    AddSolutionToSharedPortfolioDocument,
    options,
  )
}
export type AddSolutionToSharedPortfolioMutationHookResult = ReturnType<typeof useAddSolutionToSharedPortfolioMutation>
export type AddSolutionToSharedPortfolioMutationResult = Apollo.MutationResult<IAddSolutionToSharedPortfolioMutation>
export type AddSolutionToSharedPortfolioMutationOptions = Apollo.BaseMutationOptions<
  IAddSolutionToSharedPortfolioMutation,
  IAddSolutionToSharedPortfolioMutationVariables
>
export const AddPortfolioTagToSolutionDocument = gql`
  mutation addPortfolioTagToSolution($tagDocumentId: ID!, $solutionId: Int, $solutionDocumentId: ID) {
    addPortfolioTagToSolution(
      tagDocumentId: $tagDocumentId
      solutionId: $solutionId
      solutionDocumentId: $solutionDocumentId
    )
  }
`
export type IAddPortfolioTagToSolutionMutationFn = Apollo.MutationFunction<
  IAddPortfolioTagToSolutionMutation,
  IAddPortfolioTagToSolutionMutationVariables
>

/**
 * __useAddPortfolioTagToSolutionMutation__
 *
 * To run a mutation, you first call `useAddPortfolioTagToSolutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPortfolioTagToSolutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPortfolioTagToSolutionMutation, { data, loading, error }] = useAddPortfolioTagToSolutionMutation({
 *   variables: {
 *      tagDocumentId: // value for 'tagDocumentId'
 *      solutionId: // value for 'solutionId'
 *      solutionDocumentId: // value for 'solutionDocumentId'
 *   },
 * });
 */
export function useAddPortfolioTagToSolutionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IAddPortfolioTagToSolutionMutation,
    IAddPortfolioTagToSolutionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IAddPortfolioTagToSolutionMutation, IAddPortfolioTagToSolutionMutationVariables>(
    AddPortfolioTagToSolutionDocument,
    options,
  )
}
export type AddPortfolioTagToSolutionMutationHookResult = ReturnType<typeof useAddPortfolioTagToSolutionMutation>
export type AddPortfolioTagToSolutionMutationResult = Apollo.MutationResult<IAddPortfolioTagToSolutionMutation>
export type AddPortfolioTagToSolutionMutationOptions = Apollo.BaseMutationOptions<
  IAddPortfolioTagToSolutionMutation,
  IAddPortfolioTagToSolutionMutationVariables
>
export const AllAuthorsDocument = gql`
  query allAuthors {
    authors(sort: "firstName:asc") {
      ...authorItem
    }
  }
  ${AuthorItemFragmentDoc}
`

/**
 * __useAllAuthorsQuery__
 *
 * To run a query within a React component, call `useAllAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAuthorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAuthorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAuthorsQuery(baseOptions?: Apollo.QueryHookOptions<IAllAuthorsQuery, IAllAuthorsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllAuthorsQuery, IAllAuthorsQueryVariables>(AllAuthorsDocument, options)
}
export function useAllAuthorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllAuthorsQuery, IAllAuthorsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllAuthorsQuery, IAllAuthorsQueryVariables>(AllAuthorsDocument, options)
}
export function useAllAuthorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllAuthorsQuery, IAllAuthorsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllAuthorsQuery, IAllAuthorsQueryVariables>(AllAuthorsDocument, options)
}
export type AllAuthorsQueryHookResult = ReturnType<typeof useAllAuthorsQuery>
export type AllAuthorsLazyQueryHookResult = ReturnType<typeof useAllAuthorsLazyQuery>
export type AllAuthorsSuspenseQueryHookResult = ReturnType<typeof useAllAuthorsSuspenseQuery>
export type AllAuthorsQueryResult = Apollo.QueryResult<IAllAuthorsQuery, IAllAuthorsQueryVariables>
export const AllAuthorSlugsDocument = gql`
  query allAuthorSlugs {
    authors(sort: "firstName:asc") {
      slug
    }
  }
`

/**
 * __useAllAuthorSlugsQuery__
 *
 * To run a query within a React component, call `useAllAuthorSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAuthorSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAuthorSlugsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAuthorSlugsQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllAuthorSlugsQuery, IAllAuthorSlugsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllAuthorSlugsQuery, IAllAuthorSlugsQueryVariables>(AllAuthorSlugsDocument, options)
}
export function useAllAuthorSlugsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllAuthorSlugsQuery, IAllAuthorSlugsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllAuthorSlugsQuery, IAllAuthorSlugsQueryVariables>(AllAuthorSlugsDocument, options)
}
export function useAllAuthorSlugsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllAuthorSlugsQuery, IAllAuthorSlugsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllAuthorSlugsQuery, IAllAuthorSlugsQueryVariables>(AllAuthorSlugsDocument, options)
}
export type AllAuthorSlugsQueryHookResult = ReturnType<typeof useAllAuthorSlugsQuery>
export type AllAuthorSlugsLazyQueryHookResult = ReturnType<typeof useAllAuthorSlugsLazyQuery>
export type AllAuthorSlugsSuspenseQueryHookResult = ReturnType<typeof useAllAuthorSlugsSuspenseQuery>
export type AllAuthorSlugsQueryResult = Apollo.QueryResult<IAllAuthorSlugsQuery, IAllAuthorSlugsQueryVariables>
export const AllBlogTaxonomySlugsDocument = gql`
  query allBlogTaxonomySlugs {
    blogTaxonomys {
      slug
    }
  }
`

/**
 * __useAllBlogTaxonomySlugsQuery__
 *
 * To run a query within a React component, call `useAllBlogTaxonomySlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllBlogTaxonomySlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBlogTaxonomySlugsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllBlogTaxonomySlugsQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllBlogTaxonomySlugsQuery, IAllBlogTaxonomySlugsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllBlogTaxonomySlugsQuery, IAllBlogTaxonomySlugsQueryVariables>(
    AllBlogTaxonomySlugsDocument,
    options,
  )
}
export function useAllBlogTaxonomySlugsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllBlogTaxonomySlugsQuery, IAllBlogTaxonomySlugsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllBlogTaxonomySlugsQuery, IAllBlogTaxonomySlugsQueryVariables>(
    AllBlogTaxonomySlugsDocument,
    options,
  )
}
export function useAllBlogTaxonomySlugsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllBlogTaxonomySlugsQuery, IAllBlogTaxonomySlugsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllBlogTaxonomySlugsQuery, IAllBlogTaxonomySlugsQueryVariables>(
    AllBlogTaxonomySlugsDocument,
    options,
  )
}
export type AllBlogTaxonomySlugsQueryHookResult = ReturnType<typeof useAllBlogTaxonomySlugsQuery>
export type AllBlogTaxonomySlugsLazyQueryHookResult = ReturnType<typeof useAllBlogTaxonomySlugsLazyQuery>
export type AllBlogTaxonomySlugsSuspenseQueryHookResult = ReturnType<typeof useAllBlogTaxonomySlugsSuspenseQuery>
export type AllBlogTaxonomySlugsQueryResult = Apollo.QueryResult<
  IAllBlogTaxonomySlugsQuery,
  IAllBlogTaxonomySlugsQueryVariables
>
export const AllCollectionSlugDocument = gql`
  query allCollectionSlug {
    collections(sort: "name:asc") {
      slug
    }
  }
`

/**
 * __useAllCollectionSlugQuery__
 *
 * To run a query within a React component, call `useAllCollectionSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCollectionSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCollectionSlugQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCollectionSlugQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllCollectionSlugQuery, IAllCollectionSlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllCollectionSlugQuery, IAllCollectionSlugQueryVariables>(AllCollectionSlugDocument, options)
}
export function useAllCollectionSlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllCollectionSlugQuery, IAllCollectionSlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllCollectionSlugQuery, IAllCollectionSlugQueryVariables>(
    AllCollectionSlugDocument,
    options,
  )
}
export function useAllCollectionSlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllCollectionSlugQuery, IAllCollectionSlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllCollectionSlugQuery, IAllCollectionSlugQueryVariables>(
    AllCollectionSlugDocument,
    options,
  )
}
export type AllCollectionSlugQueryHookResult = ReturnType<typeof useAllCollectionSlugQuery>
export type AllCollectionSlugLazyQueryHookResult = ReturnType<typeof useAllCollectionSlugLazyQuery>
export type AllCollectionSlugSuspenseQueryHookResult = ReturnType<typeof useAllCollectionSlugSuspenseQuery>
export type AllCollectionSlugQueryResult = Apollo.QueryResult<IAllCollectionSlugQuery, IAllCollectionSlugQueryVariables>
export const AllContentSlugsDocument = gql`
  query allContentSlugs($start: Int!) {
    contents(filters: { contentType: { ne: "Industry Analysis" } }, pagination: { start: $start }) {
      ...allContentsSlugItem
    }
  }
  ${AllContentsSlugItemFragmentDoc}
`

/**
 * __useAllContentSlugsQuery__
 *
 * To run a query within a React component, call `useAllContentSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllContentSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllContentSlugsQuery({
 *   variables: {
 *      start: // value for 'start'
 *   },
 * });
 */
export function useAllContentSlugsQuery(
  baseOptions: Apollo.QueryHookOptions<IAllContentSlugsQuery, IAllContentSlugsQueryVariables> &
    ({ variables: IAllContentSlugsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllContentSlugsQuery, IAllContentSlugsQueryVariables>(AllContentSlugsDocument, options)
}
export function useAllContentSlugsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllContentSlugsQuery, IAllContentSlugsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllContentSlugsQuery, IAllContentSlugsQueryVariables>(AllContentSlugsDocument, options)
}
export function useAllContentSlugsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllContentSlugsQuery, IAllContentSlugsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllContentSlugsQuery, IAllContentSlugsQueryVariables>(
    AllContentSlugsDocument,
    options,
  )
}
export type AllContentSlugsQueryHookResult = ReturnType<typeof useAllContentSlugsQuery>
export type AllContentSlugsLazyQueryHookResult = ReturnType<typeof useAllContentSlugsLazyQuery>
export type AllContentSlugsSuspenseQueryHookResult = ReturnType<typeof useAllContentSlugsSuspenseQuery>
export type AllContentSlugsQueryResult = Apollo.QueryResult<IAllContentSlugsQuery, IAllContentSlugsQueryVariables>
export const AllIndustryAnalysisDocument = gql`
  query allIndustryAnalysis($start: Int!) {
    contents(filters: { contentType: { eq: "Industry Analysis" } }, pagination: { start: $start }) {
      ...contentListItem
    }
  }
  ${ContentListItemFragmentDoc}
`

/**
 * __useAllIndustryAnalysisQuery__
 *
 * To run a query within a React component, call `useAllIndustryAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllIndustryAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllIndustryAnalysisQuery({
 *   variables: {
 *      start: // value for 'start'
 *   },
 * });
 */
export function useAllIndustryAnalysisQuery(
  baseOptions: Apollo.QueryHookOptions<IAllIndustryAnalysisQuery, IAllIndustryAnalysisQueryVariables> &
    ({ variables: IAllIndustryAnalysisQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllIndustryAnalysisQuery, IAllIndustryAnalysisQueryVariables>(
    AllIndustryAnalysisDocument,
    options,
  )
}
export function useAllIndustryAnalysisLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllIndustryAnalysisQuery, IAllIndustryAnalysisQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllIndustryAnalysisQuery, IAllIndustryAnalysisQueryVariables>(
    AllIndustryAnalysisDocument,
    options,
  )
}
export function useAllIndustryAnalysisSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllIndustryAnalysisQuery, IAllIndustryAnalysisQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllIndustryAnalysisQuery, IAllIndustryAnalysisQueryVariables>(
    AllIndustryAnalysisDocument,
    options,
  )
}
export type AllIndustryAnalysisQueryHookResult = ReturnType<typeof useAllIndustryAnalysisQuery>
export type AllIndustryAnalysisLazyQueryHookResult = ReturnType<typeof useAllIndustryAnalysisLazyQuery>
export type AllIndustryAnalysisSuspenseQueryHookResult = ReturnType<typeof useAllIndustryAnalysisSuspenseQuery>
export type AllIndustryAnalysisQueryResult = Apollo.QueryResult<
  IAllIndustryAnalysisQuery,
  IAllIndustryAnalysisQueryVariables
>
export const AllIndustryAnalysisSlugsDocument = gql`
  query allIndustryAnalysisSlugs($start: Int!) {
    contents(filters: { contentType: { eq: "Industry Analysis" } }, pagination: { start: $start }) {
      ...allContentsSlugItem
    }
  }
  ${AllContentsSlugItemFragmentDoc}
`

/**
 * __useAllIndustryAnalysisSlugsQuery__
 *
 * To run a query within a React component, call `useAllIndustryAnalysisSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllIndustryAnalysisSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllIndustryAnalysisSlugsQuery({
 *   variables: {
 *      start: // value for 'start'
 *   },
 * });
 */
export function useAllIndustryAnalysisSlugsQuery(
  baseOptions: Apollo.QueryHookOptions<IAllIndustryAnalysisSlugsQuery, IAllIndustryAnalysisSlugsQueryVariables> &
    ({ variables: IAllIndustryAnalysisSlugsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllIndustryAnalysisSlugsQuery, IAllIndustryAnalysisSlugsQueryVariables>(
    AllIndustryAnalysisSlugsDocument,
    options,
  )
}
export function useAllIndustryAnalysisSlugsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllIndustryAnalysisSlugsQuery, IAllIndustryAnalysisSlugsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllIndustryAnalysisSlugsQuery, IAllIndustryAnalysisSlugsQueryVariables>(
    AllIndustryAnalysisSlugsDocument,
    options,
  )
}
export function useAllIndustryAnalysisSlugsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllIndustryAnalysisSlugsQuery,
    IAllIndustryAnalysisSlugsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllIndustryAnalysisSlugsQuery, IAllIndustryAnalysisSlugsQueryVariables>(
    AllIndustryAnalysisSlugsDocument,
    options,
  )
}
export type AllIndustryAnalysisSlugsQueryHookResult = ReturnType<typeof useAllIndustryAnalysisSlugsQuery>
export type AllIndustryAnalysisSlugsLazyQueryHookResult = ReturnType<typeof useAllIndustryAnalysisSlugsLazyQuery>
export type AllIndustryAnalysisSlugsSuspenseQueryHookResult = ReturnType<
  typeof useAllIndustryAnalysisSlugsSuspenseQuery
>
export type AllIndustryAnalysisSlugsQueryResult = Apollo.QueryResult<
  IAllIndustryAnalysisSlugsQuery,
  IAllIndustryAnalysisSlugsQueryVariables
>
export const AllSolutionRequestsSlugsDocument = gql`
  query allSolutionRequestsSlugs($filters: SolutionRequestFiltersInput, $pagination: PaginationArg, $sort: [String]) {
    solutionRequests(status: DRAFT, filters: $filters, pagination: $pagination, sort: $sort) {
      ...allSolutionRequestsItems
    }
  }
  ${AllSolutionRequestsItemsFragmentDoc}
`

/**
 * __useAllSolutionRequestsSlugsQuery__
 *
 * To run a query within a React component, call `useAllSolutionRequestsSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSolutionRequestsSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSolutionRequestsSlugsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAllSolutionRequestsSlugsQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllSolutionRequestsSlugsQuery, IAllSolutionRequestsSlugsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllSolutionRequestsSlugsQuery, IAllSolutionRequestsSlugsQueryVariables>(
    AllSolutionRequestsSlugsDocument,
    options,
  )
}
export function useAllSolutionRequestsSlugsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllSolutionRequestsSlugsQuery, IAllSolutionRequestsSlugsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllSolutionRequestsSlugsQuery, IAllSolutionRequestsSlugsQueryVariables>(
    AllSolutionRequestsSlugsDocument,
    options,
  )
}
export function useAllSolutionRequestsSlugsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllSolutionRequestsSlugsQuery,
    IAllSolutionRequestsSlugsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllSolutionRequestsSlugsQuery, IAllSolutionRequestsSlugsQueryVariables>(
    AllSolutionRequestsSlugsDocument,
    options,
  )
}
export type AllSolutionRequestsSlugsQueryHookResult = ReturnType<typeof useAllSolutionRequestsSlugsQuery>
export type AllSolutionRequestsSlugsLazyQueryHookResult = ReturnType<typeof useAllSolutionRequestsSlugsLazyQuery>
export type AllSolutionRequestsSlugsSuspenseQueryHookResult = ReturnType<
  typeof useAllSolutionRequestsSlugsSuspenseQuery
>
export type AllSolutionRequestsSlugsQueryResult = Apollo.QueryResult<
  IAllSolutionRequestsSlugsQuery,
  IAllSolutionRequestsSlugsQueryVariables
>
export const AllSolutionSlugsDocument = gql`
  query allSolutionSlugs($type: String, $start: Int!) {
    solutions(filters: { type: { eq: $type } }, pagination: { start: $start }) {
      ...allSolutionsSlugItem
    }
  }
  ${AllSolutionsSlugItemFragmentDoc}
`

/**
 * __useAllSolutionSlugsQuery__
 *
 * To run a query within a React component, call `useAllSolutionSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSolutionSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSolutionSlugsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      start: // value for 'start'
 *   },
 * });
 */
export function useAllSolutionSlugsQuery(
  baseOptions: Apollo.QueryHookOptions<IAllSolutionSlugsQuery, IAllSolutionSlugsQueryVariables> &
    ({ variables: IAllSolutionSlugsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllSolutionSlugsQuery, IAllSolutionSlugsQueryVariables>(AllSolutionSlugsDocument, options)
}
export function useAllSolutionSlugsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllSolutionSlugsQuery, IAllSolutionSlugsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllSolutionSlugsQuery, IAllSolutionSlugsQueryVariables>(AllSolutionSlugsDocument, options)
}
export function useAllSolutionSlugsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllSolutionSlugsQuery, IAllSolutionSlugsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllSolutionSlugsQuery, IAllSolutionSlugsQueryVariables>(
    AllSolutionSlugsDocument,
    options,
  )
}
export type AllSolutionSlugsQueryHookResult = ReturnType<typeof useAllSolutionSlugsQuery>
export type AllSolutionSlugsLazyQueryHookResult = ReturnType<typeof useAllSolutionSlugsLazyQuery>
export type AllSolutionSlugsSuspenseQueryHookResult = ReturnType<typeof useAllSolutionSlugsSuspenseQuery>
export type AllSolutionSlugsQueryResult = Apollo.QueryResult<IAllSolutionSlugsQuery, IAllSolutionSlugsQueryVariables>
export const AlspBySlugDocument = gql`
  query alspBySlug($slug: String!, $includeIlta: Boolean!) {
    solutions(filters: { type: { eq: "ALSP" }, or: [{ slug: { eq: $slug } }, { oldSlug: { contains: $slug } }] }) {
      ...alspSolutionData
    }
  }
  ${AlspSolutionDataFragmentDoc}
`

/**
 * __useAlspBySlugQuery__
 *
 * To run a query within a React component, call `useAlspBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlspBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlspBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      includeIlta: // value for 'includeIlta'
 *   },
 * });
 */
export function useAlspBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<IAlspBySlugQuery, IAlspBySlugQueryVariables> &
    ({ variables: IAlspBySlugQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAlspBySlugQuery, IAlspBySlugQueryVariables>(AlspBySlugDocument, options)
}
export function useAlspBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAlspBySlugQuery, IAlspBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAlspBySlugQuery, IAlspBySlugQueryVariables>(AlspBySlugDocument, options)
}
export function useAlspBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAlspBySlugQuery, IAlspBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAlspBySlugQuery, IAlspBySlugQueryVariables>(AlspBySlugDocument, options)
}
export type AlspBySlugQueryHookResult = ReturnType<typeof useAlspBySlugQuery>
export type AlspBySlugLazyQueryHookResult = ReturnType<typeof useAlspBySlugLazyQuery>
export type AlspBySlugSuspenseQueryHookResult = ReturnType<typeof useAlspBySlugSuspenseQuery>
export type AlspBySlugQueryResult = Apollo.QueryResult<IAlspBySlugQuery, IAlspBySlugQueryVariables>
export const AuthorBySlugDocument = gql`
  query authorBySlug($slug: String!) {
    authors(filters: { slug: { eq: $slug } }) {
      ...authorFullItem
    }
  }
  ${AuthorFullItemFragmentDoc}
`

/**
 * __useAuthorBySlugQuery__
 *
 * To run a query within a React component, call `useAuthorBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useAuthorBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<IAuthorBySlugQuery, IAuthorBySlugQueryVariables> &
    ({ variables: IAuthorBySlugQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAuthorBySlugQuery, IAuthorBySlugQueryVariables>(AuthorBySlugDocument, options)
}
export function useAuthorBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAuthorBySlugQuery, IAuthorBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAuthorBySlugQuery, IAuthorBySlugQueryVariables>(AuthorBySlugDocument, options)
}
export function useAuthorBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAuthorBySlugQuery, IAuthorBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAuthorBySlugQuery, IAuthorBySlugQueryVariables>(AuthorBySlugDocument, options)
}
export type AuthorBySlugQueryHookResult = ReturnType<typeof useAuthorBySlugQuery>
export type AuthorBySlugLazyQueryHookResult = ReturnType<typeof useAuthorBySlugLazyQuery>
export type AuthorBySlugSuspenseQueryHookResult = ReturnType<typeof useAuthorBySlugSuspenseQuery>
export type AuthorBySlugQueryResult = Apollo.QueryResult<IAuthorBySlugQuery, IAuthorBySlugQueryVariables>
export const AutosuggestDocument = gql`
  query autosuggest($keyword: String!, $accessFreeSearch: Boolean, $uniqueAddress: String, $customAccessQuery: String) {
    autosuggest(
      keyword: $keyword
      accessFreeSearch: $accessFreeSearch
      uniqueAddress: $uniqueAddress
      customAccessQuery: $customAccessQuery
    ) {
      success
      solutions {
        ...autosuggestItem
      }
      events {
        ...autosuggestItem
      }
      categories {
        ...autosuggestItem
      }
      companies {
        ...autosuggestItem
      }
      contents {
        ...autosuggestItem
      }
    }
  }
  ${AutosuggestItemFragmentDoc}
`

/**
 * __useAutosuggestQuery__
 *
 * To run a query within a React component, call `useAutosuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutosuggestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutosuggestQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      accessFreeSearch: // value for 'accessFreeSearch'
 *      uniqueAddress: // value for 'uniqueAddress'
 *      customAccessQuery: // value for 'customAccessQuery'
 *   },
 * });
 */
export function useAutosuggestQuery(
  baseOptions: Apollo.QueryHookOptions<IAutosuggestQuery, IAutosuggestQueryVariables> &
    ({ variables: IAutosuggestQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAutosuggestQuery, IAutosuggestQueryVariables>(AutosuggestDocument, options)
}
export function useAutosuggestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAutosuggestQuery, IAutosuggestQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAutosuggestQuery, IAutosuggestQueryVariables>(AutosuggestDocument, options)
}
export function useAutosuggestSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAutosuggestQuery, IAutosuggestQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAutosuggestQuery, IAutosuggestQueryVariables>(AutosuggestDocument, options)
}
export type AutosuggestQueryHookResult = ReturnType<typeof useAutosuggestQuery>
export type AutosuggestLazyQueryHookResult = ReturnType<typeof useAutosuggestLazyQuery>
export type AutosuggestSuspenseQueryHookResult = ReturnType<typeof useAutosuggestSuspenseQuery>
export type AutosuggestQueryResult = Apollo.QueryResult<IAutosuggestQuery, IAutosuggestQueryVariables>
export const BlogTaxonomiesDocument = gql`
  query blogTaxonomies {
    blogTaxonomys {
      ...blogTaxonomyData
    }
  }
  ${BlogTaxonomyDataFragmentDoc}
`

/**
 * __useBlogTaxonomiesQuery__
 *
 * To run a query within a React component, call `useBlogTaxonomiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogTaxonomiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogTaxonomiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBlogTaxonomiesQuery(
  baseOptions?: Apollo.QueryHookOptions<IBlogTaxonomiesQuery, IBlogTaxonomiesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IBlogTaxonomiesQuery, IBlogTaxonomiesQueryVariables>(BlogTaxonomiesDocument, options)
}
export function useBlogTaxonomiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IBlogTaxonomiesQuery, IBlogTaxonomiesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IBlogTaxonomiesQuery, IBlogTaxonomiesQueryVariables>(BlogTaxonomiesDocument, options)
}
export function useBlogTaxonomiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IBlogTaxonomiesQuery, IBlogTaxonomiesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IBlogTaxonomiesQuery, IBlogTaxonomiesQueryVariables>(BlogTaxonomiesDocument, options)
}
export type BlogTaxonomiesQueryHookResult = ReturnType<typeof useBlogTaxonomiesQuery>
export type BlogTaxonomiesLazyQueryHookResult = ReturnType<typeof useBlogTaxonomiesLazyQuery>
export type BlogTaxonomiesSuspenseQueryHookResult = ReturnType<typeof useBlogTaxonomiesSuspenseQuery>
export type BlogTaxonomiesQueryResult = Apollo.QueryResult<IBlogTaxonomiesQuery, IBlogTaxonomiesQueryVariables>
export const BlogTaxonomyBySlugDocument = gql`
  query blogTaxonomyBySlug($slug: String!) {
    blogTaxonomys(filters: { slug: { eq: $slug } }) {
      ...blogTaxonomyFullData
    }
  }
  ${BlogTaxonomyFullDataFragmentDoc}
`

/**
 * __useBlogTaxonomyBySlugQuery__
 *
 * To run a query within a React component, call `useBlogTaxonomyBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogTaxonomyBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogTaxonomyBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useBlogTaxonomyBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<IBlogTaxonomyBySlugQuery, IBlogTaxonomyBySlugQueryVariables> &
    ({ variables: IBlogTaxonomyBySlugQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IBlogTaxonomyBySlugQuery, IBlogTaxonomyBySlugQueryVariables>(
    BlogTaxonomyBySlugDocument,
    options,
  )
}
export function useBlogTaxonomyBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IBlogTaxonomyBySlugQuery, IBlogTaxonomyBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IBlogTaxonomyBySlugQuery, IBlogTaxonomyBySlugQueryVariables>(
    BlogTaxonomyBySlugDocument,
    options,
  )
}
export function useBlogTaxonomyBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IBlogTaxonomyBySlugQuery, IBlogTaxonomyBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IBlogTaxonomyBySlugQuery, IBlogTaxonomyBySlugQueryVariables>(
    BlogTaxonomyBySlugDocument,
    options,
  )
}
export type BlogTaxonomyBySlugQueryHookResult = ReturnType<typeof useBlogTaxonomyBySlugQuery>
export type BlogTaxonomyBySlugLazyQueryHookResult = ReturnType<typeof useBlogTaxonomyBySlugLazyQuery>
export type BlogTaxonomyBySlugSuspenseQueryHookResult = ReturnType<typeof useBlogTaxonomyBySlugSuspenseQuery>
export type BlogTaxonomyBySlugQueryResult = Apollo.QueryResult<
  IBlogTaxonomyBySlugQuery,
  IBlogTaxonomyBySlugQueryVariables
>
export const CarouselSolutionsBySubTopicSlugDocument = gql`
  query carouselSolutionsBySubTopicSlug($query: JSON) {
    searchSolutions(query: $query) {
      total
      solutions {
        ...solutionCarouselItem
      }
    }
  }
  ${SolutionCarouselItemFragmentDoc}
`

/**
 * __useCarouselSolutionsBySubTopicSlugQuery__
 *
 * To run a query within a React component, call `useCarouselSolutionsBySubTopicSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarouselSolutionsBySubTopicSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarouselSolutionsBySubTopicSlugQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useCarouselSolutionsBySubTopicSlugQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ICarouselSolutionsBySubTopicSlugQuery,
    ICarouselSolutionsBySubTopicSlugQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ICarouselSolutionsBySubTopicSlugQuery, ICarouselSolutionsBySubTopicSlugQueryVariables>(
    CarouselSolutionsBySubTopicSlugDocument,
    options,
  )
}
export function useCarouselSolutionsBySubTopicSlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ICarouselSolutionsBySubTopicSlugQuery,
    ICarouselSolutionsBySubTopicSlugQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ICarouselSolutionsBySubTopicSlugQuery, ICarouselSolutionsBySubTopicSlugQueryVariables>(
    CarouselSolutionsBySubTopicSlugDocument,
    options,
  )
}
export function useCarouselSolutionsBySubTopicSlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ICarouselSolutionsBySubTopicSlugQuery,
    ICarouselSolutionsBySubTopicSlugQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ICarouselSolutionsBySubTopicSlugQuery, ICarouselSolutionsBySubTopicSlugQueryVariables>(
    CarouselSolutionsBySubTopicSlugDocument,
    options,
  )
}
export type CarouselSolutionsBySubTopicSlugQueryHookResult = ReturnType<typeof useCarouselSolutionsBySubTopicSlugQuery>
export type CarouselSolutionsBySubTopicSlugLazyQueryHookResult = ReturnType<
  typeof useCarouselSolutionsBySubTopicSlugLazyQuery
>
export type CarouselSolutionsBySubTopicSlugSuspenseQueryHookResult = ReturnType<
  typeof useCarouselSolutionsBySubTopicSlugSuspenseQuery
>
export type CarouselSolutionsBySubTopicSlugQueryResult = Apollo.QueryResult<
  ICarouselSolutionsBySubTopicSlugQuery,
  ICarouselSolutionsBySubTopicSlugQueryVariables
>
export const ChangeMyPasswordDocument = gql`
  mutation changeMyPassword($input: ChangePasswordRequest!) {
    changeMyPassword(input: $input) {
      jwt
      user {
        id
        username
        email
      }
    }
  }
`
export type IChangeMyPasswordMutationFn = Apollo.MutationFunction<
  IChangeMyPasswordMutation,
  IChangeMyPasswordMutationVariables
>

/**
 * __useChangeMyPasswordMutation__
 *
 * To run a mutation, you first call `useChangeMyPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeMyPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeMyPasswordMutation, { data, loading, error }] = useChangeMyPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeMyPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<IChangeMyPasswordMutation, IChangeMyPasswordMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IChangeMyPasswordMutation, IChangeMyPasswordMutationVariables>(
    ChangeMyPasswordDocument,
    options,
  )
}
export type ChangeMyPasswordMutationHookResult = ReturnType<typeof useChangeMyPasswordMutation>
export type ChangeMyPasswordMutationResult = Apollo.MutationResult<IChangeMyPasswordMutation>
export type ChangeMyPasswordMutationOptions = Apollo.BaseMutationOptions<
  IChangeMyPasswordMutation,
  IChangeMyPasswordMutationVariables
>
export const CheckFreeSearchDocument = gql`
  query checkFreeSearch($accessFreeSearch: Boolean, $uniqueAddress: String, $customAccessQuery: String) {
    checkFreeSearch(
      accessFreeSearch: $accessFreeSearch
      uniqueAddress: $uniqueAddress
      customAccessQuery: $customAccessQuery
    ) {
      isFreeSearch
      isFreeSearchLeft
    }
  }
`

/**
 * __useCheckFreeSearchQuery__
 *
 * To run a query within a React component, call `useCheckFreeSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckFreeSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckFreeSearchQuery({
 *   variables: {
 *      accessFreeSearch: // value for 'accessFreeSearch'
 *      uniqueAddress: // value for 'uniqueAddress'
 *      customAccessQuery: // value for 'customAccessQuery'
 *   },
 * });
 */
export function useCheckFreeSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<ICheckFreeSearchQuery, ICheckFreeSearchQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ICheckFreeSearchQuery, ICheckFreeSearchQueryVariables>(CheckFreeSearchDocument, options)
}
export function useCheckFreeSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ICheckFreeSearchQuery, ICheckFreeSearchQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ICheckFreeSearchQuery, ICheckFreeSearchQueryVariables>(CheckFreeSearchDocument, options)
}
export function useCheckFreeSearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ICheckFreeSearchQuery, ICheckFreeSearchQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ICheckFreeSearchQuery, ICheckFreeSearchQueryVariables>(
    CheckFreeSearchDocument,
    options,
  )
}
export type CheckFreeSearchQueryHookResult = ReturnType<typeof useCheckFreeSearchQuery>
export type CheckFreeSearchLazyQueryHookResult = ReturnType<typeof useCheckFreeSearchLazyQuery>
export type CheckFreeSearchSuspenseQueryHookResult = ReturnType<typeof useCheckFreeSearchSuspenseQuery>
export type CheckFreeSearchQueryResult = Apollo.QueryResult<ICheckFreeSearchQuery, ICheckFreeSearchQueryVariables>
export const ClaimVendorListingDocument = gql`
  mutation claimVendorListing($data: claimVendorListingInput) {
    claimVendorListing(data: $data) {
      data {
        status
      }
    }
  }
`
export type IClaimVendorListingMutationFn = Apollo.MutationFunction<
  IClaimVendorListingMutation,
  IClaimVendorListingMutationVariables
>

/**
 * __useClaimVendorListingMutation__
 *
 * To run a mutation, you first call `useClaimVendorListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimVendorListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimVendorListingMutation, { data, loading, error }] = useClaimVendorListingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useClaimVendorListingMutation(
  baseOptions?: Apollo.MutationHookOptions<IClaimVendorListingMutation, IClaimVendorListingMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IClaimVendorListingMutation, IClaimVendorListingMutationVariables>(
    ClaimVendorListingDocument,
    options,
  )
}
export type ClaimVendorListingMutationHookResult = ReturnType<typeof useClaimVendorListingMutation>
export type ClaimVendorListingMutationResult = Apollo.MutationResult<IClaimVendorListingMutation>
export type ClaimVendorListingMutationOptions = Apollo.BaseMutationOptions<
  IClaimVendorListingMutation,
  IClaimVendorListingMutationVariables
>
export const ConsultancyBySlugDocument = gql`
  query consultancyBySlug($slug: String!, $includeIlta: Boolean!) {
    solutions(
      filters: { type: { eq: "Consultancy" }, or: [{ slug: { eq: $slug } }, { oldSlug: { contains: $slug } }] }
    ) {
      ...consultancySolutionData
    }
  }
  ${ConsultancySolutionDataFragmentDoc}
`

/**
 * __useConsultancyBySlugQuery__
 *
 * To run a query within a React component, call `useConsultancyBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultancyBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultancyBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      includeIlta: // value for 'includeIlta'
 *   },
 * });
 */
export function useConsultancyBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<IConsultancyBySlugQuery, IConsultancyBySlugQueryVariables> &
    ({ variables: IConsultancyBySlugQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IConsultancyBySlugQuery, IConsultancyBySlugQueryVariables>(ConsultancyBySlugDocument, options)
}
export function useConsultancyBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IConsultancyBySlugQuery, IConsultancyBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IConsultancyBySlugQuery, IConsultancyBySlugQueryVariables>(
    ConsultancyBySlugDocument,
    options,
  )
}
export function useConsultancyBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IConsultancyBySlugQuery, IConsultancyBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IConsultancyBySlugQuery, IConsultancyBySlugQueryVariables>(
    ConsultancyBySlugDocument,
    options,
  )
}
export type ConsultancyBySlugQueryHookResult = ReturnType<typeof useConsultancyBySlugQuery>
export type ConsultancyBySlugLazyQueryHookResult = ReturnType<typeof useConsultancyBySlugLazyQuery>
export type ConsultancyBySlugSuspenseQueryHookResult = ReturnType<typeof useConsultancyBySlugSuspenseQuery>
export type ConsultancyBySlugQueryResult = Apollo.QueryResult<IConsultancyBySlugQuery, IConsultancyBySlugQueryVariables>
export const ContentBySlugDocument = gql`
  query contentBySlug($slug: String!, $accessFreeArticle: Boolean, $uniqueAddress: String) {
    contentBySlug(slug: $slug, accessFreeArticle: $accessFreeArticle, uniqueAddress: $uniqueAddress) {
      isInvited
      resourcePublishedAt
      vendorSelfContent
      isUserVendor
      includeInKnowHow
      includeInLegalTechForLawyers
      includeInVendorContents
      isFreeArticle
      freeArticleLeft
      content {
        id
        attributes {
          ...contentData
        }
        __typename
      }
      __typename
    }
  }
  ${ContentDataFragmentDoc}
`

/**
 * __useContentBySlugQuery__
 *
 * To run a query within a React component, call `useContentBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      accessFreeArticle: // value for 'accessFreeArticle'
 *      uniqueAddress: // value for 'uniqueAddress'
 *   },
 * });
 */
export function useContentBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<IContentBySlugQuery, IContentBySlugQueryVariables> &
    ({ variables: IContentBySlugQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IContentBySlugQuery, IContentBySlugQueryVariables>(ContentBySlugDocument, options)
}
export function useContentBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IContentBySlugQuery, IContentBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IContentBySlugQuery, IContentBySlugQueryVariables>(ContentBySlugDocument, options)
}
export function useContentBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IContentBySlugQuery, IContentBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IContentBySlugQuery, IContentBySlugQueryVariables>(ContentBySlugDocument, options)
}
export type ContentBySlugQueryHookResult = ReturnType<typeof useContentBySlugQuery>
export type ContentBySlugLazyQueryHookResult = ReturnType<typeof useContentBySlugLazyQuery>
export type ContentBySlugSuspenseQueryHookResult = ReturnType<typeof useContentBySlugSuspenseQuery>
export type ContentBySlugQueryResult = Apollo.QueryResult<IContentBySlugQuery, IContentBySlugQueryVariables>
export const ContentVisitDownloadsDocument = gql`
  query contentVisitDownloads {
    contentVisitDownloads {
      title
      slug
      sharedResources {
        visits {
          visited_by {
            documentId
            username
          }
        }
        downloads {
          downloaded_by {
            documentId
            username
          }
        }
      }
    }
  }
`

/**
 * __useContentVisitDownloadsQuery__
 *
 * To run a query within a React component, call `useContentVisitDownloadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentVisitDownloadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentVisitDownloadsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContentVisitDownloadsQuery(
  baseOptions?: Apollo.QueryHookOptions<IContentVisitDownloadsQuery, IContentVisitDownloadsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IContentVisitDownloadsQuery, IContentVisitDownloadsQueryVariables>(
    ContentVisitDownloadsDocument,
    options,
  )
}
export function useContentVisitDownloadsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IContentVisitDownloadsQuery, IContentVisitDownloadsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IContentVisitDownloadsQuery, IContentVisitDownloadsQueryVariables>(
    ContentVisitDownloadsDocument,
    options,
  )
}
export function useContentVisitDownloadsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IContentVisitDownloadsQuery, IContentVisitDownloadsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IContentVisitDownloadsQuery, IContentVisitDownloadsQueryVariables>(
    ContentVisitDownloadsDocument,
    options,
  )
}
export type ContentVisitDownloadsQueryHookResult = ReturnType<typeof useContentVisitDownloadsQuery>
export type ContentVisitDownloadsLazyQueryHookResult = ReturnType<typeof useContentVisitDownloadsLazyQuery>
export type ContentVisitDownloadsSuspenseQueryHookResult = ReturnType<typeof useContentVisitDownloadsSuspenseQuery>
export type ContentVisitDownloadsQueryResult = Apollo.QueryResult<
  IContentVisitDownloadsQuery,
  IContentVisitDownloadsQueryVariables
>
export const CreateAnnouncementDocument = gql`
  mutation createAnnouncement($data: AnnouncementInput!) {
    createAnnouncement(status: DRAFT, data: $data) {
      documentId
      announcement
      optionalLink
      createdAt
    }
  }
`
export type ICreateAnnouncementMutationFn = Apollo.MutationFunction<
  ICreateAnnouncementMutation,
  ICreateAnnouncementMutationVariables
>

/**
 * __useCreateAnnouncementMutation__
 *
 * To run a mutation, you first call `useCreateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnouncementMutation, { data, loading, error }] = useCreateAnnouncementMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAnnouncementMutation(
  baseOptions?: Apollo.MutationHookOptions<ICreateAnnouncementMutation, ICreateAnnouncementMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ICreateAnnouncementMutation, ICreateAnnouncementMutationVariables>(
    CreateAnnouncementDocument,
    options,
  )
}
export type CreateAnnouncementMutationHookResult = ReturnType<typeof useCreateAnnouncementMutation>
export type CreateAnnouncementMutationResult = Apollo.MutationResult<ICreateAnnouncementMutation>
export type CreateAnnouncementMutationOptions = Apollo.BaseMutationOptions<
  ICreateAnnouncementMutation,
  ICreateAnnouncementMutationVariables
>
export const CreatePortfolioTagDocument = gql`
  mutation createPortfolioTag($name: String!) {
    createPortfolioTag(name: $name) {
      id
      name
      slug
      solutionIds
      solutionDocumentIds
    }
  }
`
export type ICreatePortfolioTagMutationFn = Apollo.MutationFunction<
  ICreatePortfolioTagMutation,
  ICreatePortfolioTagMutationVariables
>

/**
 * __useCreatePortfolioTagMutation__
 *
 * To run a mutation, you first call `useCreatePortfolioTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortfolioTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortfolioTagMutation, { data, loading, error }] = useCreatePortfolioTagMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreatePortfolioTagMutation(
  baseOptions?: Apollo.MutationHookOptions<ICreatePortfolioTagMutation, ICreatePortfolioTagMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ICreatePortfolioTagMutation, ICreatePortfolioTagMutationVariables>(
    CreatePortfolioTagDocument,
    options,
  )
}
export type CreatePortfolioTagMutationHookResult = ReturnType<typeof useCreatePortfolioTagMutation>
export type CreatePortfolioTagMutationResult = Apollo.MutationResult<ICreatePortfolioTagMutation>
export type CreatePortfolioTagMutationOptions = Apollo.BaseMutationOptions<
  ICreatePortfolioTagMutation,
  ICreatePortfolioTagMutationVariables
>
export const CreateListingAlspDocument = gql`
  mutation createListingAlsp($data: ListingRequestData!) {
    createListingRequestData(data: $data) {
      alspReq {
        id
        listingName
        userName
        userRole
        userEmail
        phone
        marketName
        marketEmail
        ceoName
        ceoEmail
        shortDescription
        longDescription
      }
      enhancedAlspReq {
        founders {
          id
        }
        specialists {
          id
        }
        screenShots {
          id
        }
        testimonials {
          id
        }
      }
    }
  }
`
export type ICreateListingAlspMutationFn = Apollo.MutationFunction<
  ICreateListingAlspMutation,
  ICreateListingAlspMutationVariables
>

/**
 * __useCreateListingAlspMutation__
 *
 * To run a mutation, you first call `useCreateListingAlspMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListingAlspMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListingAlspMutation, { data, loading, error }] = useCreateListingAlspMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateListingAlspMutation(
  baseOptions?: Apollo.MutationHookOptions<ICreateListingAlspMutation, ICreateListingAlspMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ICreateListingAlspMutation, ICreateListingAlspMutationVariables>(
    CreateListingAlspDocument,
    options,
  )
}
export type CreateListingAlspMutationHookResult = ReturnType<typeof useCreateListingAlspMutation>
export type CreateListingAlspMutationResult = Apollo.MutationResult<ICreateListingAlspMutation>
export type CreateListingAlspMutationOptions = Apollo.BaseMutationOptions<
  ICreateListingAlspMutation,
  ICreateListingAlspMutationVariables
>
export const CreateListingConsultantDocument = gql`
  mutation createListingConsultant($data: ListingRequestData!) {
    createListingRequestData(data: $data) {
      consultantReq {
        id
        listingName
        userName
        userRole
        userEmail
        phone
        marketName
        marketEmail
        ceoName
        ceoEmail
        shortDescription
        longDescription
      }
      enhancedConsultantReq {
        founders {
          id
        }
        specialists {
          id
        }
        screenShots {
          id
        }
        testimonials {
          id
        }
      }
    }
  }
`
export type ICreateListingConsultantMutationFn = Apollo.MutationFunction<
  ICreateListingConsultantMutation,
  ICreateListingConsultantMutationVariables
>

/**
 * __useCreateListingConsultantMutation__
 *
 * To run a mutation, you first call `useCreateListingConsultantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListingConsultantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListingConsultantMutation, { data, loading, error }] = useCreateListingConsultantMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateListingConsultantMutation(
  baseOptions?: Apollo.MutationHookOptions<ICreateListingConsultantMutation, ICreateListingConsultantMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ICreateListingConsultantMutation, ICreateListingConsultantMutationVariables>(
    CreateListingConsultantDocument,
    options,
  )
}
export type CreateListingConsultantMutationHookResult = ReturnType<typeof useCreateListingConsultantMutation>
export type CreateListingConsultantMutationResult = Apollo.MutationResult<ICreateListingConsultantMutation>
export type CreateListingConsultantMutationOptions = Apollo.BaseMutationOptions<
  ICreateListingConsultantMutation,
  ICreateListingConsultantMutationVariables
>
export const CreateListingProductDocument = gql`
  mutation createListingProduct($data: ListingRequestData!) {
    createListingRequestData(data: $data) {
      vendorReq {
        id
        companyName
        email
        name
        ceoEmail
        ceoName
        marketEmail
        marketName
        website
        productName
        shortDescription
        longDescription
        isCreate
        notes
      }
      enhancedVendorReq {
        screenShots {
          id
        }
        testimonials {
          id
        }
      }
    }
  }
`
export type ICreateListingProductMutationFn = Apollo.MutationFunction<
  ICreateListingProductMutation,
  ICreateListingProductMutationVariables
>

/**
 * __useCreateListingProductMutation__
 *
 * To run a mutation, you first call `useCreateListingProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListingProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListingProductMutation, { data, loading, error }] = useCreateListingProductMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateListingProductMutation(
  baseOptions?: Apollo.MutationHookOptions<ICreateListingProductMutation, ICreateListingProductMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ICreateListingProductMutation, ICreateListingProductMutationVariables>(
    CreateListingProductDocument,
    options,
  )
}
export type CreateListingProductMutationHookResult = ReturnType<typeof useCreateListingProductMutation>
export type CreateListingProductMutationResult = Apollo.MutationResult<ICreateListingProductMutation>
export type CreateListingProductMutationOptions = Apollo.BaseMutationOptions<
  ICreateListingProductMutation,
  ICreateListingProductMutationVariables
>
export const CreateSharedPortfolioWithMembersDocument = gql`
  mutation createSharedPortfolioWithMembers($name: String!, $members: [SharedPortfolioMemberInput!]) {
    createSharedPortfolioWithMembers(name: $name, members: $members) {
      id
      attributes {
        documentId
        name
        slug
        isSharedPortfolio
        premium_organizations {
          documentId
          name
        }
        shared_portfolio_memberships {
          documentId
          role
          isActive
          user {
            documentId
            username
            email
          }
        }
      }
    }
  }
`
export type ICreateSharedPortfolioWithMembersMutationFn = Apollo.MutationFunction<
  ICreateSharedPortfolioWithMembersMutation,
  ICreateSharedPortfolioWithMembersMutationVariables
>

/**
 * __useCreateSharedPortfolioWithMembersMutation__
 *
 * To run a mutation, you first call `useCreateSharedPortfolioWithMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSharedPortfolioWithMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSharedPortfolioWithMembersMutation, { data, loading, error }] = useCreateSharedPortfolioWithMembersMutation({
 *   variables: {
 *      name: // value for 'name'
 *      members: // value for 'members'
 *   },
 * });
 */
export function useCreateSharedPortfolioWithMembersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateSharedPortfolioWithMembersMutation,
    ICreateSharedPortfolioWithMembersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ICreateSharedPortfolioWithMembersMutation,
    ICreateSharedPortfolioWithMembersMutationVariables
  >(CreateSharedPortfolioWithMembersDocument, options)
}
export type CreateSharedPortfolioWithMembersMutationHookResult = ReturnType<
  typeof useCreateSharedPortfolioWithMembersMutation
>
export type CreateSharedPortfolioWithMembersMutationResult =
  Apollo.MutationResult<ICreateSharedPortfolioWithMembersMutation>
export type CreateSharedPortfolioWithMembersMutationOptions = Apollo.BaseMutationOptions<
  ICreateSharedPortfolioWithMembersMutation,
  ICreateSharedPortfolioWithMembersMutationVariables
>
export const CreateSolutionRequestDocument = gql`
  mutation createSolutionRequest($data: SolutionRequestInput!, $status: PublicationStatus) {
    createSolutionRequest(data: $data, status: $status) {
      id
      documentId
    }
  }
`
export type ICreateSolutionRequestMutationFn = Apollo.MutationFunction<
  ICreateSolutionRequestMutation,
  ICreateSolutionRequestMutationVariables
>

/**
 * __useCreateSolutionRequestMutation__
 *
 * To run a mutation, you first call `useCreateSolutionRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSolutionRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSolutionRequestMutation, { data, loading, error }] = useCreateSolutionRequestMutation({
 *   variables: {
 *      data: // value for 'data'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useCreateSolutionRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<ICreateSolutionRequestMutation, ICreateSolutionRequestMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ICreateSolutionRequestMutation, ICreateSolutionRequestMutationVariables>(
    CreateSolutionRequestDocument,
    options,
  )
}
export type CreateSolutionRequestMutationHookResult = ReturnType<typeof useCreateSolutionRequestMutation>
export type CreateSolutionRequestMutationResult = Apollo.MutationResult<ICreateSolutionRequestMutation>
export type CreateSolutionRequestMutationOptions = Apollo.BaseMutationOptions<
  ICreateSolutionRequestMutation,
  ICreateSolutionRequestMutationVariables
>
export const DeleteAnnouncementDocument = gql`
  mutation deleteAnnouncement($documentId: ID!) {
    deleteAnnouncement(documentId: $documentId) {
      documentId
    }
  }
`
export type IDeleteAnnouncementMutationFn = Apollo.MutationFunction<
  IDeleteAnnouncementMutation,
  IDeleteAnnouncementMutationVariables
>

/**
 * __useDeleteAnnouncementMutation__
 *
 * To run a mutation, you first call `useDeleteAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnnouncementMutation, { data, loading, error }] = useDeleteAnnouncementMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteAnnouncementMutation(
  baseOptions?: Apollo.MutationHookOptions<IDeleteAnnouncementMutation, IDeleteAnnouncementMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IDeleteAnnouncementMutation, IDeleteAnnouncementMutationVariables>(
    DeleteAnnouncementDocument,
    options,
  )
}
export type DeleteAnnouncementMutationHookResult = ReturnType<typeof useDeleteAnnouncementMutation>
export type DeleteAnnouncementMutationResult = Apollo.MutationResult<IDeleteAnnouncementMutation>
export type DeleteAnnouncementMutationOptions = Apollo.BaseMutationOptions<
  IDeleteAnnouncementMutation,
  IDeleteAnnouncementMutationVariables
>
export const DeletePortfolioTagDocument = gql`
  mutation deletePortfolioTag($tagDocumentId: ID!) {
    deletePortfolioTag(tagDocumentId: $tagDocumentId)
  }
`
export type IDeletePortfolioTagMutationFn = Apollo.MutationFunction<
  IDeletePortfolioTagMutation,
  IDeletePortfolioTagMutationVariables
>

/**
 * __useDeletePortfolioTagMutation__
 *
 * To run a mutation, you first call `useDeletePortfolioTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePortfolioTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePortfolioTagMutation, { data, loading, error }] = useDeletePortfolioTagMutation({
 *   variables: {
 *      tagDocumentId: // value for 'tagDocumentId'
 *   },
 * });
 */
export function useDeletePortfolioTagMutation(
  baseOptions?: Apollo.MutationHookOptions<IDeletePortfolioTagMutation, IDeletePortfolioTagMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IDeletePortfolioTagMutation, IDeletePortfolioTagMutationVariables>(
    DeletePortfolioTagDocument,
    options,
  )
}
export type DeletePortfolioTagMutationHookResult = ReturnType<typeof useDeletePortfolioTagMutation>
export type DeletePortfolioTagMutationResult = Apollo.MutationResult<IDeletePortfolioTagMutation>
export type DeletePortfolioTagMutationOptions = Apollo.BaseMutationOptions<
  IDeletePortfolioTagMutation,
  IDeletePortfolioTagMutationVariables
>
export const DeleteSharedPortfolioDocument = gql`
  mutation deleteSharedPortfolio($id: ID!) {
    deleteSharedPortfolio(sharedPortfolioId: $id)
  }
`
export type IDeleteSharedPortfolioMutationFn = Apollo.MutationFunction<
  IDeleteSharedPortfolioMutation,
  IDeleteSharedPortfolioMutationVariables
>

/**
 * __useDeleteSharedPortfolioMutation__
 *
 * To run a mutation, you first call `useDeleteSharedPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSharedPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSharedPortfolioMutation, { data, loading, error }] = useDeleteSharedPortfolioMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSharedPortfolioMutation(
  baseOptions?: Apollo.MutationHookOptions<IDeleteSharedPortfolioMutation, IDeleteSharedPortfolioMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IDeleteSharedPortfolioMutation, IDeleteSharedPortfolioMutationVariables>(
    DeleteSharedPortfolioDocument,
    options,
  )
}
export type DeleteSharedPortfolioMutationHookResult = ReturnType<typeof useDeleteSharedPortfolioMutation>
export type DeleteSharedPortfolioMutationResult = Apollo.MutationResult<IDeleteSharedPortfolioMutation>
export type DeleteSharedPortfolioMutationOptions = Apollo.BaseMutationOptions<
  IDeleteSharedPortfolioMutation,
  IDeleteSharedPortfolioMutationVariables
>
export const DocumentTypeBySolutionIdDocument = gql`
  query documentTypeBySolutionId($solutionId: ID!, $documentType: String!) {
    contents(filters: { documentType: { eq: $documentType }, resourceSolutions: { documentId: { eq: $solutionId } } }) {
      ...contentTeaserBySolution
    }
  }
  ${ContentTeaserBySolutionFragmentDoc}
`

/**
 * __useDocumentTypeBySolutionIdQuery__
 *
 * To run a query within a React component, call `useDocumentTypeBySolutionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentTypeBySolutionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentTypeBySolutionIdQuery({
 *   variables: {
 *      solutionId: // value for 'solutionId'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useDocumentTypeBySolutionIdQuery(
  baseOptions: Apollo.QueryHookOptions<IDocumentTypeBySolutionIdQuery, IDocumentTypeBySolutionIdQueryVariables> &
    ({ variables: IDocumentTypeBySolutionIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IDocumentTypeBySolutionIdQuery, IDocumentTypeBySolutionIdQueryVariables>(
    DocumentTypeBySolutionIdDocument,
    options,
  )
}
export function useDocumentTypeBySolutionIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IDocumentTypeBySolutionIdQuery, IDocumentTypeBySolutionIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IDocumentTypeBySolutionIdQuery, IDocumentTypeBySolutionIdQueryVariables>(
    DocumentTypeBySolutionIdDocument,
    options,
  )
}
export function useDocumentTypeBySolutionIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IDocumentTypeBySolutionIdQuery,
    IDocumentTypeBySolutionIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IDocumentTypeBySolutionIdQuery, IDocumentTypeBySolutionIdQueryVariables>(
    DocumentTypeBySolutionIdDocument,
    options,
  )
}
export type DocumentTypeBySolutionIdQueryHookResult = ReturnType<typeof useDocumentTypeBySolutionIdQuery>
export type DocumentTypeBySolutionIdLazyQueryHookResult = ReturnType<typeof useDocumentTypeBySolutionIdLazyQuery>
export type DocumentTypeBySolutionIdSuspenseQueryHookResult = ReturnType<
  typeof useDocumentTypeBySolutionIdSuspenseQuery
>
export type DocumentTypeBySolutionIdQueryResult = Apollo.QueryResult<
  IDocumentTypeBySolutionIdQuery,
  IDocumentTypeBySolutionIdQueryVariables
>
export const DownloadContentDocument = gql`
  mutation downloadContent($content_id: ID!) {
    downloadContent(data: { content_id: $content_id })
  }
`
export type IDownloadContentMutationFn = Apollo.MutationFunction<
  IDownloadContentMutation,
  IDownloadContentMutationVariables
>

/**
 * __useDownloadContentMutation__
 *
 * To run a mutation, you first call `useDownloadContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadContentMutation, { data, loading, error }] = useDownloadContentMutation({
 *   variables: {
 *      content_id: // value for 'content_id'
 *   },
 * });
 */
export function useDownloadContentMutation(
  baseOptions?: Apollo.MutationHookOptions<IDownloadContentMutation, IDownloadContentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IDownloadContentMutation, IDownloadContentMutationVariables>(
    DownloadContentDocument,
    options,
  )
}
export type DownloadContentMutationHookResult = ReturnType<typeof useDownloadContentMutation>
export type DownloadContentMutationResult = Apollo.MutationResult<IDownloadContentMutation>
export type DownloadContentMutationOptions = Apollo.BaseMutationOptions<
  IDownloadContentMutation,
  IDownloadContentMutationVariables
>
export const DownloadMaterialFilesDocument = gql`
  query downloadMaterialFiles($id: String!) {
    downloadMaterialFile(id: $id) {
      url
    }
  }
`

/**
 * __useDownloadMaterialFilesQuery__
 *
 * To run a query within a React component, call `useDownloadMaterialFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadMaterialFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadMaterialFilesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadMaterialFilesQuery(
  baseOptions: Apollo.QueryHookOptions<IDownloadMaterialFilesQuery, IDownloadMaterialFilesQueryVariables> &
    ({ variables: IDownloadMaterialFilesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IDownloadMaterialFilesQuery, IDownloadMaterialFilesQueryVariables>(
    DownloadMaterialFilesDocument,
    options,
  )
}
export function useDownloadMaterialFilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IDownloadMaterialFilesQuery, IDownloadMaterialFilesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IDownloadMaterialFilesQuery, IDownloadMaterialFilesQueryVariables>(
    DownloadMaterialFilesDocument,
    options,
  )
}
export function useDownloadMaterialFilesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IDownloadMaterialFilesQuery, IDownloadMaterialFilesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IDownloadMaterialFilesQuery, IDownloadMaterialFilesQueryVariables>(
    DownloadMaterialFilesDocument,
    options,
  )
}
export type DownloadMaterialFilesQueryHookResult = ReturnType<typeof useDownloadMaterialFilesQuery>
export type DownloadMaterialFilesLazyQueryHookResult = ReturnType<typeof useDownloadMaterialFilesLazyQuery>
export type DownloadMaterialFilesSuspenseQueryHookResult = ReturnType<typeof useDownloadMaterialFilesSuspenseQuery>
export type DownloadMaterialFilesQueryResult = Apollo.QueryResult<
  IDownloadMaterialFilesQuery,
  IDownloadMaterialFilesQueryVariables
>
export const EditPortfolioTagDocument = gql`
  mutation editPortfolioTag($tagDocumentId: ID!, $name: String!, $sharedPortfolioId: ID) {
    editPortfolioTag(tagDocumentId: $tagDocumentId, name: $name, sharedPortfolioId: $sharedPortfolioId) {
      id
      name
      slug
      solutionIds
      solutionDocumentIds
    }
  }
`
export type IEditPortfolioTagMutationFn = Apollo.MutationFunction<
  IEditPortfolioTagMutation,
  IEditPortfolioTagMutationVariables
>

/**
 * __useEditPortfolioTagMutation__
 *
 * To run a mutation, you first call `useEditPortfolioTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPortfolioTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPortfolioTagMutation, { data, loading, error }] = useEditPortfolioTagMutation({
 *   variables: {
 *      tagDocumentId: // value for 'tagDocumentId'
 *      name: // value for 'name'
 *      sharedPortfolioId: // value for 'sharedPortfolioId'
 *   },
 * });
 */
export function useEditPortfolioTagMutation(
  baseOptions?: Apollo.MutationHookOptions<IEditPortfolioTagMutation, IEditPortfolioTagMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IEditPortfolioTagMutation, IEditPortfolioTagMutationVariables>(
    EditPortfolioTagDocument,
    options,
  )
}
export type EditPortfolioTagMutationHookResult = ReturnType<typeof useEditPortfolioTagMutation>
export type EditPortfolioTagMutationResult = Apollo.MutationResult<IEditPortfolioTagMutation>
export type EditPortfolioTagMutationOptions = Apollo.BaseMutationOptions<
  IEditPortfolioTagMutation,
  IEditPortfolioTagMutationVariables
>
export const EmailReceiversDocument = gql`
  query emailReceivers($filters: EmailReceiverFiltersInput, $pagination: PaginationArg, $sort: [String]) {
    emailReceivers(filters: $filters, pagination: $pagination, sort: $sort) {
      documentId
      email
      enable
    }
  }
`

/**
 * __useEmailReceiversQuery__
 *
 * To run a query within a React component, call `useEmailReceiversQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailReceiversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailReceiversQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useEmailReceiversQuery(
  baseOptions?: Apollo.QueryHookOptions<IEmailReceiversQuery, IEmailReceiversQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IEmailReceiversQuery, IEmailReceiversQueryVariables>(EmailReceiversDocument, options)
}
export function useEmailReceiversLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IEmailReceiversQuery, IEmailReceiversQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IEmailReceiversQuery, IEmailReceiversQueryVariables>(EmailReceiversDocument, options)
}
export function useEmailReceiversSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IEmailReceiversQuery, IEmailReceiversQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IEmailReceiversQuery, IEmailReceiversQueryVariables>(EmailReceiversDocument, options)
}
export type EmailReceiversQueryHookResult = ReturnType<typeof useEmailReceiversQuery>
export type EmailReceiversLazyQueryHookResult = ReturnType<typeof useEmailReceiversLazyQuery>
export type EmailReceiversSuspenseQueryHookResult = ReturnType<typeof useEmailReceiversSuspenseQuery>
export type EmailReceiversQueryResult = Apollo.QueryResult<IEmailReceiversQuery, IEmailReceiversQueryVariables>
export const EventFeaturesDocument = gql`
  query eventFeatures {
    eventFeatures(sort: "name:asc") {
      documentId
      name
    }
  }
`

/**
 * __useEventFeaturesQuery__
 *
 * To run a query within a React component, call `useEventFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventFeaturesQuery(
  baseOptions?: Apollo.QueryHookOptions<IEventFeaturesQuery, IEventFeaturesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IEventFeaturesQuery, IEventFeaturesQueryVariables>(EventFeaturesDocument, options)
}
export function useEventFeaturesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IEventFeaturesQuery, IEventFeaturesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IEventFeaturesQuery, IEventFeaturesQueryVariables>(EventFeaturesDocument, options)
}
export function useEventFeaturesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IEventFeaturesQuery, IEventFeaturesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IEventFeaturesQuery, IEventFeaturesQueryVariables>(EventFeaturesDocument, options)
}
export type EventFeaturesQueryHookResult = ReturnType<typeof useEventFeaturesQuery>
export type EventFeaturesLazyQueryHookResult = ReturnType<typeof useEventFeaturesLazyQuery>
export type EventFeaturesSuspenseQueryHookResult = ReturnType<typeof useEventFeaturesSuspenseQuery>
export type EventFeaturesQueryResult = Apollo.QueryResult<IEventFeaturesQuery, IEventFeaturesQueryVariables>
export const ExpertBySlugDocument = gql`
  query expertBySlug($slug: String!) {
    experts(filters: { slug: { eq: $slug } }) {
      ...expertFullItem
    }
  }
  ${ExpertFullItemFragmentDoc}
`

/**
 * __useExpertBySlugQuery__
 *
 * To run a query within a React component, call `useExpertBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useExpertBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<IExpertBySlugQuery, IExpertBySlugQueryVariables> &
    ({ variables: IExpertBySlugQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IExpertBySlugQuery, IExpertBySlugQueryVariables>(ExpertBySlugDocument, options)
}
export function useExpertBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IExpertBySlugQuery, IExpertBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IExpertBySlugQuery, IExpertBySlugQueryVariables>(ExpertBySlugDocument, options)
}
export function useExpertBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IExpertBySlugQuery, IExpertBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IExpertBySlugQuery, IExpertBySlugQueryVariables>(ExpertBySlugDocument, options)
}
export type ExpertBySlugQueryHookResult = ReturnType<typeof useExpertBySlugQuery>
export type ExpertBySlugLazyQueryHookResult = ReturnType<typeof useExpertBySlugLazyQuery>
export type ExpertBySlugSuspenseQueryHookResult = ReturnType<typeof useExpertBySlugSuspenseQuery>
export type ExpertBySlugQueryResult = Apollo.QueryResult<IExpertBySlugQuery, IExpertBySlugQueryVariables>
export const ExpertsDocument = gql`
  query experts {
    experts(sort: "firstName:asc") {
      ...expertCardData
    }
  }
  ${ExpertCardDataFragmentDoc}
`

/**
 * __useExpertsQuery__
 *
 * To run a query within a React component, call `useExpertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertsQuery({
 *   variables: {
 *   },
 * });
 */
export function useExpertsQuery(baseOptions?: Apollo.QueryHookOptions<IExpertsQuery, IExpertsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IExpertsQuery, IExpertsQueryVariables>(ExpertsDocument, options)
}
export function useExpertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IExpertsQuery, IExpertsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IExpertsQuery, IExpertsQueryVariables>(ExpertsDocument, options)
}
export function useExpertsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IExpertsQuery, IExpertsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IExpertsQuery, IExpertsQueryVariables>(ExpertsDocument, options)
}
export type ExpertsQueryHookResult = ReturnType<typeof useExpertsQuery>
export type ExpertsLazyQueryHookResult = ReturnType<typeof useExpertsLazyQuery>
export type ExpertsSuspenseQueryHookResult = ReturnType<typeof useExpertsSuspenseQuery>
export type ExpertsQueryResult = Apollo.QueryResult<IExpertsQuery, IExpertsQueryVariables>
export const FeaturedContentsBySubTopicSlugDocument = gql`
  query featuredContentsBySubTopicSlug(
    $contentType: ENUM_CONTENT_CONTENTTYPE!
    $subTopicSlug: String!
    $start: Int!
    $limit: Int!
  ) {
    featuredContents(contentType: $contentType, subTopicSlug: $subTopicSlug, start: $start, limit: $limit) {
      id
      attributes {
        ...contentListItem
      }
    }
  }
  ${ContentListItemFragmentDoc}
`

/**
 * __useFeaturedContentsBySubTopicSlugQuery__
 *
 * To run a query within a React component, call `useFeaturedContentsBySubTopicSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturedContentsBySubTopicSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturedContentsBySubTopicSlugQuery({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      subTopicSlug: // value for 'subTopicSlug'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFeaturedContentsBySubTopicSlugQuery(
  baseOptions: Apollo.QueryHookOptions<
    IFeaturedContentsBySubTopicSlugQuery,
    IFeaturedContentsBySubTopicSlugQueryVariables
  > &
    ({ variables: IFeaturedContentsBySubTopicSlugQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IFeaturedContentsBySubTopicSlugQuery, IFeaturedContentsBySubTopicSlugQueryVariables>(
    FeaturedContentsBySubTopicSlugDocument,
    options,
  )
}
export function useFeaturedContentsBySubTopicSlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IFeaturedContentsBySubTopicSlugQuery,
    IFeaturedContentsBySubTopicSlugQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IFeaturedContentsBySubTopicSlugQuery, IFeaturedContentsBySubTopicSlugQueryVariables>(
    FeaturedContentsBySubTopicSlugDocument,
    options,
  )
}
export function useFeaturedContentsBySubTopicSlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IFeaturedContentsBySubTopicSlugQuery,
    IFeaturedContentsBySubTopicSlugQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IFeaturedContentsBySubTopicSlugQuery, IFeaturedContentsBySubTopicSlugQueryVariables>(
    FeaturedContentsBySubTopicSlugDocument,
    options,
  )
}
export type FeaturedContentsBySubTopicSlugQueryHookResult = ReturnType<typeof useFeaturedContentsBySubTopicSlugQuery>
export type FeaturedContentsBySubTopicSlugLazyQueryHookResult = ReturnType<
  typeof useFeaturedContentsBySubTopicSlugLazyQuery
>
export type FeaturedContentsBySubTopicSlugSuspenseQueryHookResult = ReturnType<
  typeof useFeaturedContentsBySubTopicSlugSuspenseQuery
>
export type FeaturedContentsBySubTopicSlugQueryResult = Apollo.QueryResult<
  IFeaturedContentsBySubTopicSlugQuery,
  IFeaturedContentsBySubTopicSlugQueryVariables
>
export const FindAnnouncementBySolutionIdDocument = gql`
  query findAnnouncementBySolutionId($solutionDocumentId: ID!, $status: PublicationStatus) {
    announcements(
      status: $status
      filters: { solution: { documentId: { eq: $solutionDocumentId } }, isArchived: { eq: false } }
    ) {
      documentId
      announcement
      optionalLink
      publishedAt
    }
  }
`

/**
 * __useFindAnnouncementBySolutionIdQuery__
 *
 * To run a query within a React component, call `useFindAnnouncementBySolutionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAnnouncementBySolutionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAnnouncementBySolutionIdQuery({
 *   variables: {
 *      solutionDocumentId: // value for 'solutionDocumentId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useFindAnnouncementBySolutionIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    IFindAnnouncementBySolutionIdQuery,
    IFindAnnouncementBySolutionIdQueryVariables
  > &
    ({ variables: IFindAnnouncementBySolutionIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IFindAnnouncementBySolutionIdQuery, IFindAnnouncementBySolutionIdQueryVariables>(
    FindAnnouncementBySolutionIdDocument,
    options,
  )
}
export function useFindAnnouncementBySolutionIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IFindAnnouncementBySolutionIdQuery,
    IFindAnnouncementBySolutionIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IFindAnnouncementBySolutionIdQuery, IFindAnnouncementBySolutionIdQueryVariables>(
    FindAnnouncementBySolutionIdDocument,
    options,
  )
}
export function useFindAnnouncementBySolutionIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IFindAnnouncementBySolutionIdQuery,
    IFindAnnouncementBySolutionIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IFindAnnouncementBySolutionIdQuery, IFindAnnouncementBySolutionIdQueryVariables>(
    FindAnnouncementBySolutionIdDocument,
    options,
  )
}
export type FindAnnouncementBySolutionIdQueryHookResult = ReturnType<typeof useFindAnnouncementBySolutionIdQuery>
export type FindAnnouncementBySolutionIdLazyQueryHookResult = ReturnType<
  typeof useFindAnnouncementBySolutionIdLazyQuery
>
export type FindAnnouncementBySolutionIdSuspenseQueryHookResult = ReturnType<
  typeof useFindAnnouncementBySolutionIdSuspenseQuery
>
export type FindAnnouncementBySolutionIdQueryResult = Apollo.QueryResult<
  IFindAnnouncementBySolutionIdQuery,
  IFindAnnouncementBySolutionIdQueryVariables
>
export const FindArchivedAnnouncementBySolutionIdDocument = gql`
  query findArchivedAnnouncementBySolutionId($solutionDocumentId: ID) {
    announcements(
      status: DRAFT
      filters: {
        solution: { documentId: { eq: $solutionDocumentId } }
        publishedAt: { null: true }
        isArchived: { eq: true }
      }
      sort: ["id:desc"]
    ) {
      documentId
      announcement
      optionalLink
      publishedAt
      isArchived
      previous_published_at
      archived_at
    }
  }
`

/**
 * __useFindArchivedAnnouncementBySolutionIdQuery__
 *
 * To run a query within a React component, call `useFindArchivedAnnouncementBySolutionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindArchivedAnnouncementBySolutionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindArchivedAnnouncementBySolutionIdQuery({
 *   variables: {
 *      solutionDocumentId: // value for 'solutionDocumentId'
 *   },
 * });
 */
export function useFindArchivedAnnouncementBySolutionIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IFindArchivedAnnouncementBySolutionIdQuery,
    IFindArchivedAnnouncementBySolutionIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IFindArchivedAnnouncementBySolutionIdQuery,
    IFindArchivedAnnouncementBySolutionIdQueryVariables
  >(FindArchivedAnnouncementBySolutionIdDocument, options)
}
export function useFindArchivedAnnouncementBySolutionIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IFindArchivedAnnouncementBySolutionIdQuery,
    IFindArchivedAnnouncementBySolutionIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IFindArchivedAnnouncementBySolutionIdQuery,
    IFindArchivedAnnouncementBySolutionIdQueryVariables
  >(FindArchivedAnnouncementBySolutionIdDocument, options)
}
export function useFindArchivedAnnouncementBySolutionIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IFindArchivedAnnouncementBySolutionIdQuery,
    IFindArchivedAnnouncementBySolutionIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IFindArchivedAnnouncementBySolutionIdQuery,
    IFindArchivedAnnouncementBySolutionIdQueryVariables
  >(FindArchivedAnnouncementBySolutionIdDocument, options)
}
export type FindArchivedAnnouncementBySolutionIdQueryHookResult = ReturnType<
  typeof useFindArchivedAnnouncementBySolutionIdQuery
>
export type FindArchivedAnnouncementBySolutionIdLazyQueryHookResult = ReturnType<
  typeof useFindArchivedAnnouncementBySolutionIdLazyQuery
>
export type FindArchivedAnnouncementBySolutionIdSuspenseQueryHookResult = ReturnType<
  typeof useFindArchivedAnnouncementBySolutionIdSuspenseQuery
>
export type FindArchivedAnnouncementBySolutionIdQueryResult = Apollo.QueryResult<
  IFindArchivedAnnouncementBySolutionIdQuery,
  IFindArchivedAnnouncementBySolutionIdQueryVariables
>
export const FollowSharedPortfolioSolutionDocument = gql`
  mutation followSharedPortfolioSolution(
    $portfolioSlug: String!
    $solutionId: ID!
    $followingSolutionNote: String
    $categoryType: String
    $updateType: String!
    $follow: Boolean!
  ) {
    followSharedPortfolioSolution(
      portfolioSlug: $portfolioSlug
      solutionId: $solutionId
      followingSolutionNote: $followingSolutionNote
      categoryType: $categoryType
      updateType: $updateType
      follow: $follow
    )
  }
`
export type IFollowSharedPortfolioSolutionMutationFn = Apollo.MutationFunction<
  IFollowSharedPortfolioSolutionMutation,
  IFollowSharedPortfolioSolutionMutationVariables
>

/**
 * __useFollowSharedPortfolioSolutionMutation__
 *
 * To run a mutation, you first call `useFollowSharedPortfolioSolutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowSharedPortfolioSolutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followSharedPortfolioSolutionMutation, { data, loading, error }] = useFollowSharedPortfolioSolutionMutation({
 *   variables: {
 *      portfolioSlug: // value for 'portfolioSlug'
 *      solutionId: // value for 'solutionId'
 *      followingSolutionNote: // value for 'followingSolutionNote'
 *      categoryType: // value for 'categoryType'
 *      updateType: // value for 'updateType'
 *      follow: // value for 'follow'
 *   },
 * });
 */
export function useFollowSharedPortfolioSolutionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IFollowSharedPortfolioSolutionMutation,
    IFollowSharedPortfolioSolutionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IFollowSharedPortfolioSolutionMutation, IFollowSharedPortfolioSolutionMutationVariables>(
    FollowSharedPortfolioSolutionDocument,
    options,
  )
}
export type FollowSharedPortfolioSolutionMutationHookResult = ReturnType<
  typeof useFollowSharedPortfolioSolutionMutation
>
export type FollowSharedPortfolioSolutionMutationResult = Apollo.MutationResult<IFollowSharedPortfolioSolutionMutation>
export type FollowSharedPortfolioSolutionMutationOptions = Apollo.BaseMutationOptions<
  IFollowSharedPortfolioSolutionMutation,
  IFollowSharedPortfolioSolutionMutationVariables
>
export const FollowSolutionDocument = gql`
  mutation followSolution($id: String!, $follow: Boolean, $followType: String, $followingSolutionNote: String) {
    followSolution(id: $id, follow: $follow, followType: $followType, followingSolutionNote: $followingSolutionNote)
  }
`
export type IFollowSolutionMutationFn = Apollo.MutationFunction<
  IFollowSolutionMutation,
  IFollowSolutionMutationVariables
>

/**
 * __useFollowSolutionMutation__
 *
 * To run a mutation, you first call `useFollowSolutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowSolutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followSolutionMutation, { data, loading, error }] = useFollowSolutionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      follow: // value for 'follow'
 *      followType: // value for 'followType'
 *      followingSolutionNote: // value for 'followingSolutionNote'
 *   },
 * });
 */
export function useFollowSolutionMutation(
  baseOptions?: Apollo.MutationHookOptions<IFollowSolutionMutation, IFollowSolutionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IFollowSolutionMutation, IFollowSolutionMutationVariables>(FollowSolutionDocument, options)
}
export type FollowSolutionMutationHookResult = ReturnType<typeof useFollowSolutionMutation>
export type FollowSolutionMutationResult = Apollo.MutationResult<IFollowSolutionMutation>
export type FollowSolutionMutationOptions = Apollo.BaseMutationOptions<
  IFollowSolutionMutation,
  IFollowSolutionMutationVariables
>
export const FollowSubtopicDocument = gql`
  mutation followSubtopic($id: String, $follow: Boolean) {
    followSubtopic(id: $id, follow: $follow)
  }
`
export type IFollowSubtopicMutationFn = Apollo.MutationFunction<
  IFollowSubtopicMutation,
  IFollowSubtopicMutationVariables
>

/**
 * __useFollowSubtopicMutation__
 *
 * To run a mutation, you first call `useFollowSubtopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowSubtopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followSubtopicMutation, { data, loading, error }] = useFollowSubtopicMutation({
 *   variables: {
 *      id: // value for 'id'
 *      follow: // value for 'follow'
 *   },
 * });
 */
export function useFollowSubtopicMutation(
  baseOptions?: Apollo.MutationHookOptions<IFollowSubtopicMutation, IFollowSubtopicMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IFollowSubtopicMutation, IFollowSubtopicMutationVariables>(FollowSubtopicDocument, options)
}
export type FollowSubtopicMutationHookResult = ReturnType<typeof useFollowSubtopicMutation>
export type FollowSubtopicMutationResult = Apollo.MutationResult<IFollowSubtopicMutation>
export type FollowSubtopicMutationOptions = Apollo.BaseMutationOptions<
  IFollowSubtopicMutation,
  IFollowSubtopicMutationVariables
>
export const AllFeaturesDocument = gql`
  query allFeatures {
    features {
      documentId
      name
    }
  }
`

/**
 * __useAllFeaturesQuery__
 *
 * To run a query within a React component, call `useAllFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllFeaturesQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllFeaturesQuery, IAllFeaturesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllFeaturesQuery, IAllFeaturesQueryVariables>(AllFeaturesDocument, options)
}
export function useAllFeaturesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllFeaturesQuery, IAllFeaturesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllFeaturesQuery, IAllFeaturesQueryVariables>(AllFeaturesDocument, options)
}
export function useAllFeaturesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllFeaturesQuery, IAllFeaturesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllFeaturesQuery, IAllFeaturesQueryVariables>(AllFeaturesDocument, options)
}
export type AllFeaturesQueryHookResult = ReturnType<typeof useAllFeaturesQuery>
export type AllFeaturesLazyQueryHookResult = ReturnType<typeof useAllFeaturesLazyQuery>
export type AllFeaturesSuspenseQueryHookResult = ReturnType<typeof useAllFeaturesSuspenseQuery>
export type AllFeaturesQueryResult = Apollo.QueryResult<IAllFeaturesQuery, IAllFeaturesQueryVariables>
export const GetProductSolutionSecurityDataDocument = gql`
  query getProductSolutionSecurityData($slug: String!) {
    solutions(filters: { slug: { eq: $slug } }) {
      documentId
      slug
      productData {
        name
        security {
          documentId
          name
          __typename
        }
        dataHostingLocations {
          documentId
          name
          __typename
        }
        __typename
      }
      __typename
    }
  }
`

/**
 * __useGetProductSolutionSecurityDataQuery__
 *
 * To run a query within a React component, call `useGetProductSolutionSecurityDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductSolutionSecurityDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductSolutionSecurityDataQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetProductSolutionSecurityDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetProductSolutionSecurityDataQuery,
    IGetProductSolutionSecurityDataQueryVariables
  > &
    ({ variables: IGetProductSolutionSecurityDataQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetProductSolutionSecurityDataQuery, IGetProductSolutionSecurityDataQueryVariables>(
    GetProductSolutionSecurityDataDocument,
    options,
  )
}
export function useGetProductSolutionSecurityDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetProductSolutionSecurityDataQuery,
    IGetProductSolutionSecurityDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetProductSolutionSecurityDataQuery, IGetProductSolutionSecurityDataQueryVariables>(
    GetProductSolutionSecurityDataDocument,
    options,
  )
}
export function useGetProductSolutionSecurityDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IGetProductSolutionSecurityDataQuery,
    IGetProductSolutionSecurityDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetProductSolutionSecurityDataQuery, IGetProductSolutionSecurityDataQueryVariables>(
    GetProductSolutionSecurityDataDocument,
    options,
  )
}
export type GetProductSolutionSecurityDataQueryHookResult = ReturnType<typeof useGetProductSolutionSecurityDataQuery>
export type GetProductSolutionSecurityDataLazyQueryHookResult = ReturnType<
  typeof useGetProductSolutionSecurityDataLazyQuery
>
export type GetProductSolutionSecurityDataSuspenseQueryHookResult = ReturnType<
  typeof useGetProductSolutionSecurityDataSuspenseQuery
>
export type GetProductSolutionSecurityDataQueryResult = Apollo.QueryResult<
  IGetProductSolutionSecurityDataQuery,
  IGetProductSolutionSecurityDataQueryVariables
>
export const SolutionRequestByIdDocument = gql`
  query solutionRequestByID($id: ID!) {
    solutionRequest(documentId: $id) {
      ...solutionRequestData
    }
  }
  ${SolutionRequestDataFragmentDoc}
`

/**
 * __useSolutionRequestByIdQuery__
 *
 * To run a query within a React component, call `useSolutionRequestByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolutionRequestByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolutionRequestByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSolutionRequestByIdQuery(
  baseOptions: Apollo.QueryHookOptions<ISolutionRequestByIdQuery, ISolutionRequestByIdQueryVariables> &
    ({ variables: ISolutionRequestByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ISolutionRequestByIdQuery, ISolutionRequestByIdQueryVariables>(
    SolutionRequestByIdDocument,
    options,
  )
}
export function useSolutionRequestByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ISolutionRequestByIdQuery, ISolutionRequestByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ISolutionRequestByIdQuery, ISolutionRequestByIdQueryVariables>(
    SolutionRequestByIdDocument,
    options,
  )
}
export function useSolutionRequestByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ISolutionRequestByIdQuery, ISolutionRequestByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ISolutionRequestByIdQuery, ISolutionRequestByIdQueryVariables>(
    SolutionRequestByIdDocument,
    options,
  )
}
export type SolutionRequestByIdQueryHookResult = ReturnType<typeof useSolutionRequestByIdQuery>
export type SolutionRequestByIdLazyQueryHookResult = ReturnType<typeof useSolutionRequestByIdLazyQuery>
export type SolutionRequestByIdSuspenseQueryHookResult = ReturnType<typeof useSolutionRequestByIdSuspenseQuery>
export type SolutionRequestByIdQueryResult = Apollo.QueryResult<
  ISolutionRequestByIdQuery,
  ISolutionRequestByIdQueryVariables
>
export const GetAboutDocument = gql`
  query getAbout {
    about {
      documentId
      createdAt
      updatedAt
      title
      description
      who
      what
      email
      phone
      ourTeam {
        avatar {
          url
        }
        name
        role
        bio
        externalLink
        title
      }
      publishedAt
    }
  }
`

/**
 * __useGetAboutQuery__
 *
 * To run a query within a React component, call `useGetAboutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAboutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAboutQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAboutQuery(baseOptions?: Apollo.QueryHookOptions<IGetAboutQuery, IGetAboutQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetAboutQuery, IGetAboutQueryVariables>(GetAboutDocument, options)
}
export function useGetAboutLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetAboutQuery, IGetAboutQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetAboutQuery, IGetAboutQueryVariables>(GetAboutDocument, options)
}
export function useGetAboutSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetAboutQuery, IGetAboutQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetAboutQuery, IGetAboutQueryVariables>(GetAboutDocument, options)
}
export type GetAboutQueryHookResult = ReturnType<typeof useGetAboutQuery>
export type GetAboutLazyQueryHookResult = ReturnType<typeof useGetAboutLazyQuery>
export type GetAboutSuspenseQueryHookResult = ReturnType<typeof useGetAboutSuspenseQuery>
export type GetAboutQueryResult = Apollo.QueryResult<IGetAboutQuery, IGetAboutQueryVariables>
export const GetAllCompaniesDocument = gql`
  query getAllCompanies {
    companies(sort: "name:asc") {
      documentId
      name
      slug
    }
  }
`

/**
 * __useGetAllCompaniesQuery__
 *
 * To run a query within a React component, call `useGetAllCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCompaniesQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetAllCompaniesQuery, IGetAllCompaniesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetAllCompaniesQuery, IGetAllCompaniesQueryVariables>(GetAllCompaniesDocument, options)
}
export function useGetAllCompaniesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetAllCompaniesQuery, IGetAllCompaniesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetAllCompaniesQuery, IGetAllCompaniesQueryVariables>(GetAllCompaniesDocument, options)
}
export function useGetAllCompaniesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetAllCompaniesQuery, IGetAllCompaniesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetAllCompaniesQuery, IGetAllCompaniesQueryVariables>(
    GetAllCompaniesDocument,
    options,
  )
}
export type GetAllCompaniesQueryHookResult = ReturnType<typeof useGetAllCompaniesQuery>
export type GetAllCompaniesLazyQueryHookResult = ReturnType<typeof useGetAllCompaniesLazyQuery>
export type GetAllCompaniesSuspenseQueryHookResult = ReturnType<typeof useGetAllCompaniesSuspenseQuery>
export type GetAllCompaniesQueryResult = Apollo.QueryResult<IGetAllCompaniesQuery, IGetAllCompaniesQueryVariables>
export const GetAnnouncementByIdDocument = gql`
  query getAnnouncementById($documentId: ID!) {
    announcements(status: DRAFT, filters: { documentId: { eq: $documentId } }) {
      documentId
      announcement
      optionalLink
      publishedAt
      isArchived
      previous_published_at
      archived_at
    }
  }
`

/**
 * __useGetAnnouncementByIdQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementByIdQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetAnnouncementByIdQuery(
  baseOptions: Apollo.QueryHookOptions<IGetAnnouncementByIdQuery, IGetAnnouncementByIdQueryVariables> &
    ({ variables: IGetAnnouncementByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetAnnouncementByIdQuery, IGetAnnouncementByIdQueryVariables>(
    GetAnnouncementByIdDocument,
    options,
  )
}
export function useGetAnnouncementByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetAnnouncementByIdQuery, IGetAnnouncementByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetAnnouncementByIdQuery, IGetAnnouncementByIdQueryVariables>(
    GetAnnouncementByIdDocument,
    options,
  )
}
export function useGetAnnouncementByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetAnnouncementByIdQuery, IGetAnnouncementByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetAnnouncementByIdQuery, IGetAnnouncementByIdQueryVariables>(
    GetAnnouncementByIdDocument,
    options,
  )
}
export type GetAnnouncementByIdQueryHookResult = ReturnType<typeof useGetAnnouncementByIdQuery>
export type GetAnnouncementByIdLazyQueryHookResult = ReturnType<typeof useGetAnnouncementByIdLazyQuery>
export type GetAnnouncementByIdSuspenseQueryHookResult = ReturnType<typeof useGetAnnouncementByIdSuspenseQuery>
export type GetAnnouncementByIdQueryResult = Apollo.QueryResult<
  IGetAnnouncementByIdQuery,
  IGetAnnouncementByIdQueryVariables
>
export const GetAudiencesDocument = gql`
  query getAudiences {
    demographics(sort: "updatedAt") {
      documentId
      name
    }
  }
`

/**
 * __useGetAudiencesQuery__
 *
 * To run a query within a React component, call `useGetAudiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAudiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAudiencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAudiencesQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetAudiencesQuery, IGetAudiencesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetAudiencesQuery, IGetAudiencesQueryVariables>(GetAudiencesDocument, options)
}
export function useGetAudiencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetAudiencesQuery, IGetAudiencesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetAudiencesQuery, IGetAudiencesQueryVariables>(GetAudiencesDocument, options)
}
export function useGetAudiencesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetAudiencesQuery, IGetAudiencesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetAudiencesQuery, IGetAudiencesQueryVariables>(GetAudiencesDocument, options)
}
export type GetAudiencesQueryHookResult = ReturnType<typeof useGetAudiencesQuery>
export type GetAudiencesLazyQueryHookResult = ReturnType<typeof useGetAudiencesLazyQuery>
export type GetAudiencesSuspenseQueryHookResult = ReturnType<typeof useGetAudiencesSuspenseQuery>
export type GetAudiencesQueryResult = Apollo.QueryResult<IGetAudiencesQuery, IGetAudiencesQueryVariables>
export const GetBannerAnnouncementDocument = gql`
  query getBannerAnnouncement {
    bannerAnnouncement {
      documentId
      createdAt
      updatedAt
      title
      externalLink
      publishedAt
      linkButtonLabel
    }
  }
`

/**
 * __useGetBannerAnnouncementQuery__
 *
 * To run a query within a React component, call `useGetBannerAnnouncementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBannerAnnouncementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBannerAnnouncementQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBannerAnnouncementQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetBannerAnnouncementQuery, IGetBannerAnnouncementQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetBannerAnnouncementQuery, IGetBannerAnnouncementQueryVariables>(
    GetBannerAnnouncementDocument,
    options,
  )
}
export function useGetBannerAnnouncementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetBannerAnnouncementQuery, IGetBannerAnnouncementQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetBannerAnnouncementQuery, IGetBannerAnnouncementQueryVariables>(
    GetBannerAnnouncementDocument,
    options,
  )
}
export function useGetBannerAnnouncementSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetBannerAnnouncementQuery, IGetBannerAnnouncementQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetBannerAnnouncementQuery, IGetBannerAnnouncementQueryVariables>(
    GetBannerAnnouncementDocument,
    options,
  )
}
export type GetBannerAnnouncementQueryHookResult = ReturnType<typeof useGetBannerAnnouncementQuery>
export type GetBannerAnnouncementLazyQueryHookResult = ReturnType<typeof useGetBannerAnnouncementLazyQuery>
export type GetBannerAnnouncementSuspenseQueryHookResult = ReturnType<typeof useGetBannerAnnouncementSuspenseQuery>
export type GetBannerAnnouncementQueryResult = Apollo.QueryResult<
  IGetBannerAnnouncementQuery,
  IGetBannerAnnouncementQueryVariables
>
export const GetCollectionsDocument = gql`
  query getCollections {
    collections(sort: "name:asc") {
      documentId
      name
      description
      featuredOnHomepage
      slug
      publishedAt
      iconName {
        documentId
        url
      }
      contents(sort: "title:asc") {
        documentId
        title
        slug
        snippet
        isMaintained
        isPremium
      }
      solutions(sort: "displayName:asc") {
        documentId
        displayName
        type
        website
        isPremium
        slug
        shortDescription
        longDescription
      }
    }
  }
`

/**
 * __useGetCollectionsQuery__
 *
 * To run a query within a React component, call `useGetCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCollectionsQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetCollectionsQuery, IGetCollectionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetCollectionsQuery, IGetCollectionsQueryVariables>(GetCollectionsDocument, options)
}
export function useGetCollectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetCollectionsQuery, IGetCollectionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetCollectionsQuery, IGetCollectionsQueryVariables>(GetCollectionsDocument, options)
}
export function useGetCollectionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetCollectionsQuery, IGetCollectionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetCollectionsQuery, IGetCollectionsQueryVariables>(GetCollectionsDocument, options)
}
export type GetCollectionsQueryHookResult = ReturnType<typeof useGetCollectionsQuery>
export type GetCollectionsLazyQueryHookResult = ReturnType<typeof useGetCollectionsLazyQuery>
export type GetCollectionsSuspenseQueryHookResult = ReturnType<typeof useGetCollectionsSuspenseQuery>
export type GetCollectionsQueryResult = Apollo.QueryResult<IGetCollectionsQuery, IGetCollectionsQueryVariables>
export const GetCollectionsBySlugDocument = gql`
  query getCollectionsBySlug($slug: String!) {
    collections(filters: { slug: { eq: $slug } }) {
      documentId
      name
      description
      featuredOnHomepage
      slug
      publishedAt
      contents(pagination: { limit: -1 }) {
        documentId
        title
        slug
        snippet
        isMaintained
        isPremium
        publishedTime
        defaultImage {
          documentId
          url
        }
      }
      solutions(sort: "displayName:asc") {
        documentId
        displayName
        type
        website
        isPremium
        slug
        shortDescription
        longDescription
      }
    }
  }
`

/**
 * __useGetCollectionsBySlugQuery__
 *
 * To run a query within a React component, call `useGetCollectionsBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetCollectionsBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<IGetCollectionsBySlugQuery, IGetCollectionsBySlugQueryVariables> &
    ({ variables: IGetCollectionsBySlugQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetCollectionsBySlugQuery, IGetCollectionsBySlugQueryVariables>(
    GetCollectionsBySlugDocument,
    options,
  )
}
export function useGetCollectionsBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetCollectionsBySlugQuery, IGetCollectionsBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetCollectionsBySlugQuery, IGetCollectionsBySlugQueryVariables>(
    GetCollectionsBySlugDocument,
    options,
  )
}
export function useGetCollectionsBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetCollectionsBySlugQuery, IGetCollectionsBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetCollectionsBySlugQuery, IGetCollectionsBySlugQueryVariables>(
    GetCollectionsBySlugDocument,
    options,
  )
}
export type GetCollectionsBySlugQueryHookResult = ReturnType<typeof useGetCollectionsBySlugQuery>
export type GetCollectionsBySlugLazyQueryHookResult = ReturnType<typeof useGetCollectionsBySlugLazyQuery>
export type GetCollectionsBySlugSuspenseQueryHookResult = ReturnType<typeof useGetCollectionsBySlugSuspenseQuery>
export type GetCollectionsBySlugQueryResult = Apollo.QueryResult<
  IGetCollectionsBySlugQuery,
  IGetCollectionsBySlugQueryVariables
>
export const GetCompanyBySlugDocument = gql`
  query getCompanyBySlug($slug: String!, $includeIlta: Boolean!) {
    companies(filters: { slug: { eq: $slug } }) {
      ...companyData
    }
  }
  ${CompanyDataFragmentDoc}
`

/**
 * __useGetCompanyBySlugQuery__
 *
 * To run a query within a React component, call `useGetCompanyBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      includeIlta: // value for 'includeIlta'
 *   },
 * });
 */
export function useGetCompanyBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<IGetCompanyBySlugQuery, IGetCompanyBySlugQueryVariables> &
    ({ variables: IGetCompanyBySlugQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetCompanyBySlugQuery, IGetCompanyBySlugQueryVariables>(GetCompanyBySlugDocument, options)
}
export function useGetCompanyBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetCompanyBySlugQuery, IGetCompanyBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetCompanyBySlugQuery, IGetCompanyBySlugQueryVariables>(GetCompanyBySlugDocument, options)
}
export function useGetCompanyBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetCompanyBySlugQuery, IGetCompanyBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetCompanyBySlugQuery, IGetCompanyBySlugQueryVariables>(
    GetCompanyBySlugDocument,
    options,
  )
}
export type GetCompanyBySlugQueryHookResult = ReturnType<typeof useGetCompanyBySlugQuery>
export type GetCompanyBySlugLazyQueryHookResult = ReturnType<typeof useGetCompanyBySlugLazyQuery>
export type GetCompanyBySlugSuspenseQueryHookResult = ReturnType<typeof useGetCompanyBySlugSuspenseQuery>
export type GetCompanyBySlugQueryResult = Apollo.QueryResult<IGetCompanyBySlugQuery, IGetCompanyBySlugQueryVariables>
export const GetCountriesDocument = gql`
  query getCountries {
    countries(sort: "name:asc", pagination: { limit: -1 }, status: PUBLISHED) {
      documentId
      code
      name
      alpha2
      alpha3
    }
  }
`

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetCountriesQuery, IGetCountriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetCountriesQuery, IGetCountriesQueryVariables>(GetCountriesDocument, options)
}
export function useGetCountriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetCountriesQuery, IGetCountriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetCountriesQuery, IGetCountriesQueryVariables>(GetCountriesDocument, options)
}
export function useGetCountriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetCountriesQuery, IGetCountriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetCountriesQuery, IGetCountriesQueryVariables>(GetCountriesDocument, options)
}
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>
export type GetCountriesSuspenseQueryHookResult = ReturnType<typeof useGetCountriesSuspenseQuery>
export type GetCountriesQueryResult = Apollo.QueryResult<IGetCountriesQuery, IGetCountriesQueryVariables>
export const GetCustomTagBySlugDocument = gql`
  query getCustomTagBySlug($slug: String!) {
    getCustomTagBySlug(slug: $slug) {
      id
      name
      slug
      solutionDocumentIds
      portfolioId
      isSharedPortfolio
      sharedPortfolio {
        documentId
        name
        slug
      }
    }
  }
`

/**
 * __useGetCustomTagBySlugQuery__
 *
 * To run a query within a React component, call `useGetCustomTagBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomTagBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomTagBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetCustomTagBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<IGetCustomTagBySlugQuery, IGetCustomTagBySlugQueryVariables> &
    ({ variables: IGetCustomTagBySlugQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetCustomTagBySlugQuery, IGetCustomTagBySlugQueryVariables>(
    GetCustomTagBySlugDocument,
    options,
  )
}
export function useGetCustomTagBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetCustomTagBySlugQuery, IGetCustomTagBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetCustomTagBySlugQuery, IGetCustomTagBySlugQueryVariables>(
    GetCustomTagBySlugDocument,
    options,
  )
}
export function useGetCustomTagBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetCustomTagBySlugQuery, IGetCustomTagBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetCustomTagBySlugQuery, IGetCustomTagBySlugQueryVariables>(
    GetCustomTagBySlugDocument,
    options,
  )
}
export type GetCustomTagBySlugQueryHookResult = ReturnType<typeof useGetCustomTagBySlugQuery>
export type GetCustomTagBySlugLazyQueryHookResult = ReturnType<typeof useGetCustomTagBySlugLazyQuery>
export type GetCustomTagBySlugSuspenseQueryHookResult = ReturnType<typeof useGetCustomTagBySlugSuspenseQuery>
export type GetCustomTagBySlugQueryResult = Apollo.QueryResult<
  IGetCustomTagBySlugQuery,
  IGetCustomTagBySlugQueryVariables
>
export const GetExistingCustomersPaginationDocument = gql`
  query getExistingCustomersPagination($page: Int!, $pageSize: Int!, $search: String) {
    existingCustomers(
      pagination: { page: $page, pageSize: $pageSize }
      sort: "name:asc"
      filters: { name: { containsi: $search } }
    ) {
      documentId
      name
    }
  }
`

/**
 * __useGetExistingCustomersPaginationQuery__
 *
 * To run a query within a React component, call `useGetExistingCustomersPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExistingCustomersPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExistingCustomersPaginationQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetExistingCustomersPaginationQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetExistingCustomersPaginationQuery,
    IGetExistingCustomersPaginationQueryVariables
  > &
    ({ variables: IGetExistingCustomersPaginationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetExistingCustomersPaginationQuery, IGetExistingCustomersPaginationQueryVariables>(
    GetExistingCustomersPaginationDocument,
    options,
  )
}
export function useGetExistingCustomersPaginationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetExistingCustomersPaginationQuery,
    IGetExistingCustomersPaginationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetExistingCustomersPaginationQuery, IGetExistingCustomersPaginationQueryVariables>(
    GetExistingCustomersPaginationDocument,
    options,
  )
}
export function useGetExistingCustomersPaginationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IGetExistingCustomersPaginationQuery,
    IGetExistingCustomersPaginationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetExistingCustomersPaginationQuery, IGetExistingCustomersPaginationQueryVariables>(
    GetExistingCustomersPaginationDocument,
    options,
  )
}
export type GetExistingCustomersPaginationQueryHookResult = ReturnType<typeof useGetExistingCustomersPaginationQuery>
export type GetExistingCustomersPaginationLazyQueryHookResult = ReturnType<
  typeof useGetExistingCustomersPaginationLazyQuery
>
export type GetExistingCustomersPaginationSuspenseQueryHookResult = ReturnType<
  typeof useGetExistingCustomersPaginationSuspenseQuery
>
export type GetExistingCustomersPaginationQueryResult = Apollo.QueryResult<
  IGetExistingCustomersPaginationQuery,
  IGetExistingCustomersPaginationQueryVariables
>
export const GetDurationsDocument = gql`
  query getDurations {
    durations {
      documentId
      name
      days
    }
  }
`

/**
 * __useGetDurationsQuery__
 *
 * To run a query within a React component, call `useGetDurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDurationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDurationsQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetDurationsQuery, IGetDurationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetDurationsQuery, IGetDurationsQueryVariables>(GetDurationsDocument, options)
}
export function useGetDurationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetDurationsQuery, IGetDurationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetDurationsQuery, IGetDurationsQueryVariables>(GetDurationsDocument, options)
}
export function useGetDurationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetDurationsQuery, IGetDurationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetDurationsQuery, IGetDurationsQueryVariables>(GetDurationsDocument, options)
}
export type GetDurationsQueryHookResult = ReturnType<typeof useGetDurationsQuery>
export type GetDurationsLazyQueryHookResult = ReturnType<typeof useGetDurationsLazyQuery>
export type GetDurationsSuspenseQueryHookResult = ReturnType<typeof useGetDurationsSuspenseQuery>
export type GetDurationsQueryResult = Apollo.QueryResult<IGetDurationsQuery, IGetDurationsQueryVariables>
export const GetEnhancedRequestContentDocument = gql`
  query getEnhancedRequestContent {
    enhancedRequestContent {
      createdAt
      updatedAt
      title
      description
      moreVisibility
      callToAction
      screenshots
      competitor
      publishedAt
    }
  }
`

/**
 * __useGetEnhancedRequestContentQuery__
 *
 * To run a query within a React component, call `useGetEnhancedRequestContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnhancedRequestContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnhancedRequestContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEnhancedRequestContentQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetEnhancedRequestContentQuery, IGetEnhancedRequestContentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetEnhancedRequestContentQuery, IGetEnhancedRequestContentQueryVariables>(
    GetEnhancedRequestContentDocument,
    options,
  )
}
export function useGetEnhancedRequestContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetEnhancedRequestContentQuery, IGetEnhancedRequestContentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetEnhancedRequestContentQuery, IGetEnhancedRequestContentQueryVariables>(
    GetEnhancedRequestContentDocument,
    options,
  )
}
export function useGetEnhancedRequestContentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IGetEnhancedRequestContentQuery,
    IGetEnhancedRequestContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetEnhancedRequestContentQuery, IGetEnhancedRequestContentQueryVariables>(
    GetEnhancedRequestContentDocument,
    options,
  )
}
export type GetEnhancedRequestContentQueryHookResult = ReturnType<typeof useGetEnhancedRequestContentQuery>
export type GetEnhancedRequestContentLazyQueryHookResult = ReturnType<typeof useGetEnhancedRequestContentLazyQuery>
export type GetEnhancedRequestContentSuspenseQueryHookResult = ReturnType<
  typeof useGetEnhancedRequestContentSuspenseQuery
>
export type GetEnhancedRequestContentQueryResult = Apollo.QueryResult<
  IGetEnhancedRequestContentQuery,
  IGetEnhancedRequestContentQueryVariables
>
export const EventsDocument = gql`
  query events {
    events {
      documentId
      title
      updatedAt
      date
      description
      logo {
        url
      }
      country
      city
      durationId {
        documentId
        name
        days
      }
      formatId {
        documentId
        name
      }
      featured
      slug
      features {
        documentId
        name
      }
      audiences {
        documentId
        name
      }
    }
  }
`

/**
 * __useEventsQuery__
 *
 * To run a query within a React component, call `useEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventsQuery(baseOptions?: Apollo.QueryHookOptions<IEventsQuery, IEventsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IEventsQuery, IEventsQueryVariables>(EventsDocument, options)
}
export function useEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IEventsQuery, IEventsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IEventsQuery, IEventsQueryVariables>(EventsDocument, options)
}
export function useEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IEventsQuery, IEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IEventsQuery, IEventsQueryVariables>(EventsDocument, options)
}
export type EventsQueryHookResult = ReturnType<typeof useEventsQuery>
export type EventsLazyQueryHookResult = ReturnType<typeof useEventsLazyQuery>
export type EventsSuspenseQueryHookResult = ReturnType<typeof useEventsSuspenseQuery>
export type EventsQueryResult = Apollo.QueryResult<IEventsQuery, IEventsQueryVariables>
export const GetEventsByOffsetDocument = gql`
  query getEventsByOffset($start: Int, $limit: Int) {
    events(pagination: { start: $start, limit: $limit }) {
      documentId
      title
      date
      updatedAt
      description
      logo {
        url
      }
      country
      city
      durationId {
        documentId
        name
      }
      formatId {
        documentId
        name
      }
      featured
      slug
      features {
        documentId
        name
      }
      audiences {
        documentId
        name
      }
    }
  }
`

/**
 * __useGetEventsByOffsetQuery__
 *
 * To run a query within a React component, call `useGetEventsByOffsetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsByOffsetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsByOffsetQuery({
 *   variables: {
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetEventsByOffsetQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetEventsByOffsetQuery, IGetEventsByOffsetQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetEventsByOffsetQuery, IGetEventsByOffsetQueryVariables>(GetEventsByOffsetDocument, options)
}
export function useGetEventsByOffsetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetEventsByOffsetQuery, IGetEventsByOffsetQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetEventsByOffsetQuery, IGetEventsByOffsetQueryVariables>(
    GetEventsByOffsetDocument,
    options,
  )
}
export function useGetEventsByOffsetSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetEventsByOffsetQuery, IGetEventsByOffsetQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetEventsByOffsetQuery, IGetEventsByOffsetQueryVariables>(
    GetEventsByOffsetDocument,
    options,
  )
}
export type GetEventsByOffsetQueryHookResult = ReturnType<typeof useGetEventsByOffsetQuery>
export type GetEventsByOffsetLazyQueryHookResult = ReturnType<typeof useGetEventsByOffsetLazyQuery>
export type GetEventsByOffsetSuspenseQueryHookResult = ReturnType<typeof useGetEventsByOffsetSuspenseQuery>
export type GetEventsByOffsetQueryResult = Apollo.QueryResult<IGetEventsByOffsetQuery, IGetEventsByOffsetQueryVariables>
export const GetEventsBySlugDocument = gql`
  query getEventsBySlug($slug: String!) {
    events(filters: { slug: { eq: $slug } }) {
      documentId
      slug
      createdAt
      updatedAt
      date
      title
      website
      description
      organizer
      logo {
        url
      }
      notes
      country
      city
      featured
      formatId {
        documentId
        name
      }
      audiences {
        documentId
        name
      }
      durationId {
        documentId
        name
      }
      recurrenceId {
        documentId
        name
      }
    }
  }
`

/**
 * __useGetEventsBySlugQuery__
 *
 * To run a query within a React component, call `useGetEventsBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetEventsBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<IGetEventsBySlugQuery, IGetEventsBySlugQueryVariables> &
    ({ variables: IGetEventsBySlugQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetEventsBySlugQuery, IGetEventsBySlugQueryVariables>(GetEventsBySlugDocument, options)
}
export function useGetEventsBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetEventsBySlugQuery, IGetEventsBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetEventsBySlugQuery, IGetEventsBySlugQueryVariables>(GetEventsBySlugDocument, options)
}
export function useGetEventsBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetEventsBySlugQuery, IGetEventsBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetEventsBySlugQuery, IGetEventsBySlugQueryVariables>(
    GetEventsBySlugDocument,
    options,
  )
}
export type GetEventsBySlugQueryHookResult = ReturnType<typeof useGetEventsBySlugQuery>
export type GetEventsBySlugLazyQueryHookResult = ReturnType<typeof useGetEventsBySlugLazyQuery>
export type GetEventsBySlugSuspenseQueryHookResult = ReturnType<typeof useGetEventsBySlugSuspenseQuery>
export type GetEventsBySlugQueryResult = Apollo.QueryResult<IGetEventsBySlugQuery, IGetEventsBySlugQueryVariables>
export const GetExistingCustomersDocument = gql`
  query getExistingCustomers {
    existingCustomers(pagination: { limit: -1 }, sort: "name") {
      documentId
      name
    }
  }
`

/**
 * __useGetExistingCustomersQuery__
 *
 * To run a query within a React component, call `useGetExistingCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExistingCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExistingCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExistingCustomersQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetExistingCustomersQuery, IGetExistingCustomersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetExistingCustomersQuery, IGetExistingCustomersQueryVariables>(
    GetExistingCustomersDocument,
    options,
  )
}
export function useGetExistingCustomersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetExistingCustomersQuery, IGetExistingCustomersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetExistingCustomersQuery, IGetExistingCustomersQueryVariables>(
    GetExistingCustomersDocument,
    options,
  )
}
export function useGetExistingCustomersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetExistingCustomersQuery, IGetExistingCustomersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetExistingCustomersQuery, IGetExistingCustomersQueryVariables>(
    GetExistingCustomersDocument,
    options,
  )
}
export type GetExistingCustomersQueryHookResult = ReturnType<typeof useGetExistingCustomersQuery>
export type GetExistingCustomersLazyQueryHookResult = ReturnType<typeof useGetExistingCustomersLazyQuery>
export type GetExistingCustomersSuspenseQueryHookResult = ReturnType<typeof useGetExistingCustomersSuspenseQuery>
export type GetExistingCustomersQueryResult = Apollo.QueryResult<
  IGetExistingCustomersQuery,
  IGetExistingCustomersQueryVariables
>
export const GetAttributesDocument = gql`
  query getAttributes {
    attributes(sort: "name:asc") {
      documentId
      name
    }
  }
`

/**
 * __useGetAttributesQuery__
 *
 * To run a query within a React component, call `useGetAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttributesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAttributesQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetAttributesQuery, IGetAttributesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetAttributesQuery, IGetAttributesQueryVariables>(GetAttributesDocument, options)
}
export function useGetAttributesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetAttributesQuery, IGetAttributesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetAttributesQuery, IGetAttributesQueryVariables>(GetAttributesDocument, options)
}
export function useGetAttributesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetAttributesQuery, IGetAttributesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetAttributesQuery, IGetAttributesQueryVariables>(GetAttributesDocument, options)
}
export type GetAttributesQueryHookResult = ReturnType<typeof useGetAttributesQuery>
export type GetAttributesLazyQueryHookResult = ReturnType<typeof useGetAttributesLazyQuery>
export type GetAttributesSuspenseQueryHookResult = ReturnType<typeof useGetAttributesSuspenseQuery>
export type GetAttributesQueryResult = Apollo.QueryResult<IGetAttributesQuery, IGetAttributesQueryVariables>
export const GetFollowingTopicsDocument = gql`
  query getFollowingTopics {
    followingTopics {
      documentId
      name
      slug
      isPremium
      iconName
      description
      featuredOnHome
      createdAt
      updatedAt
      publishedAt
      subTopics {
        id
        documentId
        name
        slug
        description
        featuredOnHome
        isPremium
      }
    }
  }
`

/**
 * __useGetFollowingTopicsQuery__
 *
 * To run a query within a React component, call `useGetFollowingTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFollowingTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFollowingTopicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFollowingTopicsQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetFollowingTopicsQuery, IGetFollowingTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetFollowingTopicsQuery, IGetFollowingTopicsQueryVariables>(
    GetFollowingTopicsDocument,
    options,
  )
}
export function useGetFollowingTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetFollowingTopicsQuery, IGetFollowingTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetFollowingTopicsQuery, IGetFollowingTopicsQueryVariables>(
    GetFollowingTopicsDocument,
    options,
  )
}
export function useGetFollowingTopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetFollowingTopicsQuery, IGetFollowingTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetFollowingTopicsQuery, IGetFollowingTopicsQueryVariables>(
    GetFollowingTopicsDocument,
    options,
  )
}
export type GetFollowingTopicsQueryHookResult = ReturnType<typeof useGetFollowingTopicsQuery>
export type GetFollowingTopicsLazyQueryHookResult = ReturnType<typeof useGetFollowingTopicsLazyQuery>
export type GetFollowingTopicsSuspenseQueryHookResult = ReturnType<typeof useGetFollowingTopicsSuspenseQuery>
export type GetFollowingTopicsQueryResult = Apollo.QueryResult<
  IGetFollowingTopicsQuery,
  IGetFollowingTopicsQueryVariables
>
export const GetFormatsDocument = gql`
  query getFormats {
    eventFormats {
      documentId
      name
    }
  }
`

/**
 * __useGetFormatsQuery__
 *
 * To run a query within a React component, call `useGetFormatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFormatsQuery(baseOptions?: Apollo.QueryHookOptions<IGetFormatsQuery, IGetFormatsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetFormatsQuery, IGetFormatsQueryVariables>(GetFormatsDocument, options)
}
export function useGetFormatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetFormatsQuery, IGetFormatsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetFormatsQuery, IGetFormatsQueryVariables>(GetFormatsDocument, options)
}
export function useGetFormatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetFormatsQuery, IGetFormatsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetFormatsQuery, IGetFormatsQueryVariables>(GetFormatsDocument, options)
}
export type GetFormatsQueryHookResult = ReturnType<typeof useGetFormatsQuery>
export type GetFormatsLazyQueryHookResult = ReturnType<typeof useGetFormatsLazyQuery>
export type GetFormatsSuspenseQueryHookResult = ReturnType<typeof useGetFormatsSuspenseQuery>
export type GetFormatsQueryResult = Apollo.QueryResult<IGetFormatsQuery, IGetFormatsQueryVariables>
export const GetIltaSponsorshipsDocument = gql`
  query getIltaSponsorships {
    iltaSponsorships(sort: "level:asc") {
      ...iltaSponsorshipItem
    }
  }
  ${IltaSponsorshipItemFragmentDoc}
`

/**
 * __useGetIltaSponsorshipsQuery__
 *
 * To run a query within a React component, call `useGetIltaSponsorshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIltaSponsorshipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIltaSponsorshipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIltaSponsorshipsQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetIltaSponsorshipsQuery, IGetIltaSponsorshipsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetIltaSponsorshipsQuery, IGetIltaSponsorshipsQueryVariables>(
    GetIltaSponsorshipsDocument,
    options,
  )
}
export function useGetIltaSponsorshipsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetIltaSponsorshipsQuery, IGetIltaSponsorshipsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetIltaSponsorshipsQuery, IGetIltaSponsorshipsQueryVariables>(
    GetIltaSponsorshipsDocument,
    options,
  )
}
export function useGetIltaSponsorshipsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetIltaSponsorshipsQuery, IGetIltaSponsorshipsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetIltaSponsorshipsQuery, IGetIltaSponsorshipsQueryVariables>(
    GetIltaSponsorshipsDocument,
    options,
  )
}
export type GetIltaSponsorshipsQueryHookResult = ReturnType<typeof useGetIltaSponsorshipsQuery>
export type GetIltaSponsorshipsLazyQueryHookResult = ReturnType<typeof useGetIltaSponsorshipsLazyQuery>
export type GetIltaSponsorshipsSuspenseQueryHookResult = ReturnType<typeof useGetIltaSponsorshipsSuspenseQuery>
export type GetIltaSponsorshipsQueryResult = Apollo.QueryResult<
  IGetIltaSponsorshipsQuery,
  IGetIltaSponsorshipsQueryVariables
>
export const GetInstallationsDocument = gql`
  query getInstallations {
    installations {
      documentId
      name
    }
  }
`

/**
 * __useGetInstallationsQuery__
 *
 * To run a query within a React component, call `useGetInstallationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInstallationsQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetInstallationsQuery, IGetInstallationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetInstallationsQuery, IGetInstallationsQueryVariables>(GetInstallationsDocument, options)
}
export function useGetInstallationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetInstallationsQuery, IGetInstallationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetInstallationsQuery, IGetInstallationsQueryVariables>(GetInstallationsDocument, options)
}
export function useGetInstallationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetInstallationsQuery, IGetInstallationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetInstallationsQuery, IGetInstallationsQueryVariables>(
    GetInstallationsDocument,
    options,
  )
}
export type GetInstallationsQueryHookResult = ReturnType<typeof useGetInstallationsQuery>
export type GetInstallationsLazyQueryHookResult = ReturnType<typeof useGetInstallationsLazyQuery>
export type GetInstallationsSuspenseQueryHookResult = ReturnType<typeof useGetInstallationsSuspenseQuery>
export type GetInstallationsQueryResult = Apollo.QueryResult<IGetInstallationsQuery, IGetInstallationsQueryVariables>
export const GetIntegrationsDocument = gql`
  query getIntegrations {
    integrations(sort: "name", pagination: { limit: -1 }) {
      documentId
      name
    }
  }
`

/**
 * __useGetIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntegrationsQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetIntegrationsQuery, IGetIntegrationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetIntegrationsQuery, IGetIntegrationsQueryVariables>(GetIntegrationsDocument, options)
}
export function useGetIntegrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetIntegrationsQuery, IGetIntegrationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetIntegrationsQuery, IGetIntegrationsQueryVariables>(GetIntegrationsDocument, options)
}
export function useGetIntegrationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetIntegrationsQuery, IGetIntegrationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetIntegrationsQuery, IGetIntegrationsQueryVariables>(
    GetIntegrationsDocument,
    options,
  )
}
export type GetIntegrationsQueryHookResult = ReturnType<typeof useGetIntegrationsQuery>
export type GetIntegrationsLazyQueryHookResult = ReturnType<typeof useGetIntegrationsLazyQuery>
export type GetIntegrationsSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationsSuspenseQuery>
export type GetIntegrationsQueryResult = Apollo.QueryResult<IGetIntegrationsQuery, IGetIntegrationsQueryVariables>
export const GetIntegrationsPaginationDocument = gql`
  query getIntegrationsPagination($page: Int!, $pageSize: Int!, $search: String) {
    integrations(
      pagination: { page: $page, pageSize: $pageSize }
      sort: "name"
      filters: { name: { containsi: $search } }
    ) {
      documentId
      name
    }
  }
`

/**
 * __useGetIntegrationsPaginationQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsPaginationQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetIntegrationsPaginationQuery(
  baseOptions: Apollo.QueryHookOptions<IGetIntegrationsPaginationQuery, IGetIntegrationsPaginationQueryVariables> &
    ({ variables: IGetIntegrationsPaginationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetIntegrationsPaginationQuery, IGetIntegrationsPaginationQueryVariables>(
    GetIntegrationsPaginationDocument,
    options,
  )
}
export function useGetIntegrationsPaginationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetIntegrationsPaginationQuery, IGetIntegrationsPaginationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetIntegrationsPaginationQuery, IGetIntegrationsPaginationQueryVariables>(
    GetIntegrationsPaginationDocument,
    options,
  )
}
export function useGetIntegrationsPaginationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IGetIntegrationsPaginationQuery,
    IGetIntegrationsPaginationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetIntegrationsPaginationQuery, IGetIntegrationsPaginationQueryVariables>(
    GetIntegrationsPaginationDocument,
    options,
  )
}
export type GetIntegrationsPaginationQueryHookResult = ReturnType<typeof useGetIntegrationsPaginationQuery>
export type GetIntegrationsPaginationLazyQueryHookResult = ReturnType<typeof useGetIntegrationsPaginationLazyQuery>
export type GetIntegrationsPaginationSuspenseQueryHookResult = ReturnType<
  typeof useGetIntegrationsPaginationSuspenseQuery
>
export type GetIntegrationsPaginationQueryResult = Apollo.QueryResult<
  IGetIntegrationsPaginationQuery,
  IGetIntegrationsPaginationQueryVariables
>
export const GetInvitedUsersDocument = gql`
  query getInvitedUsers($query: JSON) {
    invitedUsers(query: $query) {
      total
      invitations {
        ...resourceInvitationEntity
      }
    }
  }
  ${ResourceInvitationEntityFragmentDoc}
`

/**
 * __useGetInvitedUsersQuery__
 *
 * To run a query within a React component, call `useGetInvitedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitedUsersQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetInvitedUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetInvitedUsersQuery, IGetInvitedUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetInvitedUsersQuery, IGetInvitedUsersQueryVariables>(GetInvitedUsersDocument, options)
}
export function useGetInvitedUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetInvitedUsersQuery, IGetInvitedUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetInvitedUsersQuery, IGetInvitedUsersQueryVariables>(GetInvitedUsersDocument, options)
}
export function useGetInvitedUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetInvitedUsersQuery, IGetInvitedUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetInvitedUsersQuery, IGetInvitedUsersQueryVariables>(
    GetInvitedUsersDocument,
    options,
  )
}
export type GetInvitedUsersQueryHookResult = ReturnType<typeof useGetInvitedUsersQuery>
export type GetInvitedUsersLazyQueryHookResult = ReturnType<typeof useGetInvitedUsersLazyQuery>
export type GetInvitedUsersSuspenseQueryHookResult = ReturnType<typeof useGetInvitedUsersSuspenseQuery>
export type GetInvitedUsersQueryResult = Apollo.QueryResult<IGetInvitedUsersQuery, IGetInvitedUsersQueryVariables>
export const GetLanguagesDocument = gql`
  query getLanguages {
    platformLanguages(sort: "name:asc") {
      documentId
      name
    }
  }
`

/**
 * __useGetLanguagesQuery__
 *
 * To run a query within a React component, call `useGetLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLanguagesQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetLanguagesQuery, IGetLanguagesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetLanguagesQuery, IGetLanguagesQueryVariables>(GetLanguagesDocument, options)
}
export function useGetLanguagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetLanguagesQuery, IGetLanguagesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetLanguagesQuery, IGetLanguagesQueryVariables>(GetLanguagesDocument, options)
}
export function useGetLanguagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetLanguagesQuery, IGetLanguagesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetLanguagesQuery, IGetLanguagesQueryVariables>(GetLanguagesDocument, options)
}
export type GetLanguagesQueryHookResult = ReturnType<typeof useGetLanguagesQuery>
export type GetLanguagesLazyQueryHookResult = ReturnType<typeof useGetLanguagesLazyQuery>
export type GetLanguagesSuspenseQueryHookResult = ReturnType<typeof useGetLanguagesSuspenseQuery>
export type GetLanguagesQueryResult = Apollo.QueryResult<IGetLanguagesQuery, IGetLanguagesQueryVariables>
export const GetLanguagesPaginationDocument = gql`
  query getLanguagesPagination($page: Int!, $pageSize: Int!, $search: String) {
    platformLanguages(
      pagination: { page: $page, pageSize: $pageSize }
      sort: "name:asc"
      filters: { name: { containsi: $search } }
    ) {
      documentId
      name
    }
  }
`

/**
 * __useGetLanguagesPaginationQuery__
 *
 * To run a query within a React component, call `useGetLanguagesPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesPaginationQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetLanguagesPaginationQuery(
  baseOptions: Apollo.QueryHookOptions<IGetLanguagesPaginationQuery, IGetLanguagesPaginationQueryVariables> &
    ({ variables: IGetLanguagesPaginationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetLanguagesPaginationQuery, IGetLanguagesPaginationQueryVariables>(
    GetLanguagesPaginationDocument,
    options,
  )
}
export function useGetLanguagesPaginationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetLanguagesPaginationQuery, IGetLanguagesPaginationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetLanguagesPaginationQuery, IGetLanguagesPaginationQueryVariables>(
    GetLanguagesPaginationDocument,
    options,
  )
}
export function useGetLanguagesPaginationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetLanguagesPaginationQuery, IGetLanguagesPaginationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetLanguagesPaginationQuery, IGetLanguagesPaginationQueryVariables>(
    GetLanguagesPaginationDocument,
    options,
  )
}
export type GetLanguagesPaginationQueryHookResult = ReturnType<typeof useGetLanguagesPaginationQuery>
export type GetLanguagesPaginationLazyQueryHookResult = ReturnType<typeof useGetLanguagesPaginationLazyQuery>
export type GetLanguagesPaginationSuspenseQueryHookResult = ReturnType<typeof useGetLanguagesPaginationSuspenseQuery>
export type GetLanguagesPaginationQueryResult = Apollo.QueryResult<
  IGetLanguagesPaginationQuery,
  IGetLanguagesPaginationQueryVariables
>
export const GetLocationsDocument = gql`
  query getLocations {
    location
  }
`

/**
 * __useGetLocationsQuery__
 *
 * To run a query within a React component, call `useGetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocationsQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetLocationsQuery, IGetLocationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetLocationsQuery, IGetLocationsQueryVariables>(GetLocationsDocument, options)
}
export function useGetLocationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetLocationsQuery, IGetLocationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetLocationsQuery, IGetLocationsQueryVariables>(GetLocationsDocument, options)
}
export function useGetLocationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetLocationsQuery, IGetLocationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetLocationsQuery, IGetLocationsQueryVariables>(GetLocationsDocument, options)
}
export type GetLocationsQueryHookResult = ReturnType<typeof useGetLocationsQuery>
export type GetLocationsLazyQueryHookResult = ReturnType<typeof useGetLocationsLazyQuery>
export type GetLocationsSuspenseQueryHookResult = ReturnType<typeof useGetLocationsSuspenseQuery>
export type GetLocationsQueryResult = Apollo.QueryResult<IGetLocationsQuery, IGetLocationsQueryVariables>
export const GetMyCustomTagsDocument = gql`
  query getMyCustomTags {
    getMyCustomTags {
      id
      name
      slug
      solutionIds
      solutionDocumentIds
      portfolioId
    }
  }
`

/**
 * __useGetMyCustomTagsQuery__
 *
 * To run a query within a React component, call `useGetMyCustomTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCustomTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCustomTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyCustomTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetMyCustomTagsQuery, IGetMyCustomTagsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetMyCustomTagsQuery, IGetMyCustomTagsQueryVariables>(GetMyCustomTagsDocument, options)
}
export function useGetMyCustomTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetMyCustomTagsQuery, IGetMyCustomTagsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetMyCustomTagsQuery, IGetMyCustomTagsQueryVariables>(GetMyCustomTagsDocument, options)
}
export function useGetMyCustomTagsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetMyCustomTagsQuery, IGetMyCustomTagsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetMyCustomTagsQuery, IGetMyCustomTagsQueryVariables>(
    GetMyCustomTagsDocument,
    options,
  )
}
export type GetMyCustomTagsQueryHookResult = ReturnType<typeof useGetMyCustomTagsQuery>
export type GetMyCustomTagsLazyQueryHookResult = ReturnType<typeof useGetMyCustomTagsLazyQuery>
export type GetMyCustomTagsSuspenseQueryHookResult = ReturnType<typeof useGetMyCustomTagsSuspenseQuery>
export type GetMyCustomTagsQueryResult = Apollo.QueryResult<IGetMyCustomTagsQuery, IGetMyCustomTagsQueryVariables>
export const GetMyResourcesProductTypesDocument = gql`
  query getMyResourcesProductTypes {
    myResourcesProductTypes {
      topics {
        id
        name
        isPremium
        subTopics {
          id
          name
          isPremium
        }
      }
    }
  }
`

/**
 * __useGetMyResourcesProductTypesQuery__
 *
 * To run a query within a React component, call `useGetMyResourcesProductTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyResourcesProductTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyResourcesProductTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyResourcesProductTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetMyResourcesProductTypesQuery, IGetMyResourcesProductTypesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetMyResourcesProductTypesQuery, IGetMyResourcesProductTypesQueryVariables>(
    GetMyResourcesProductTypesDocument,
    options,
  )
}
export function useGetMyResourcesProductTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetMyResourcesProductTypesQuery,
    IGetMyResourcesProductTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetMyResourcesProductTypesQuery, IGetMyResourcesProductTypesQueryVariables>(
    GetMyResourcesProductTypesDocument,
    options,
  )
}
export function useGetMyResourcesProductTypesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IGetMyResourcesProductTypesQuery,
    IGetMyResourcesProductTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetMyResourcesProductTypesQuery, IGetMyResourcesProductTypesQueryVariables>(
    GetMyResourcesProductTypesDocument,
    options,
  )
}
export type GetMyResourcesProductTypesQueryHookResult = ReturnType<typeof useGetMyResourcesProductTypesQuery>
export type GetMyResourcesProductTypesLazyQueryHookResult = ReturnType<typeof useGetMyResourcesProductTypesLazyQuery>
export type GetMyResourcesProductTypesSuspenseQueryHookResult = ReturnType<
  typeof useGetMyResourcesProductTypesSuspenseQuery
>
export type GetMyResourcesProductTypesQueryResult = Apollo.QueryResult<
  IGetMyResourcesProductTypesQuery,
  IGetMyResourcesProductTypesQueryVariables
>
export const GetNewsletterCategoriesDocument = gql`
  query getNewsletterCategories {
    newsletterCategories {
      documentId
      name
    }
  }
`

/**
 * __useGetNewsletterCategoriesQuery__
 *
 * To run a query within a React component, call `useGetNewsletterCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsletterCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsletterCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNewsletterCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetNewsletterCategoriesQuery, IGetNewsletterCategoriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetNewsletterCategoriesQuery, IGetNewsletterCategoriesQueryVariables>(
    GetNewsletterCategoriesDocument,
    options,
  )
}
export function useGetNewsletterCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetNewsletterCategoriesQuery, IGetNewsletterCategoriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetNewsletterCategoriesQuery, IGetNewsletterCategoriesQueryVariables>(
    GetNewsletterCategoriesDocument,
    options,
  )
}
export function useGetNewsletterCategoriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetNewsletterCategoriesQuery, IGetNewsletterCategoriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetNewsletterCategoriesQuery, IGetNewsletterCategoriesQueryVariables>(
    GetNewsletterCategoriesDocument,
    options,
  )
}
export type GetNewsletterCategoriesQueryHookResult = ReturnType<typeof useGetNewsletterCategoriesQuery>
export type GetNewsletterCategoriesLazyQueryHookResult = ReturnType<typeof useGetNewsletterCategoriesLazyQuery>
export type GetNewsletterCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetNewsletterCategoriesSuspenseQuery>
export type GetNewsletterCategoriesQueryResult = Apollo.QueryResult<
  IGetNewsletterCategoriesQuery,
  IGetNewsletterCategoriesQueryVariables
>
export const GetOfficesDocument = gql`
  query getOffices {
    offices(sort: "name:asc") {
      documentId
      name
    }
  }
`

/**
 * __useGetOfficesQuery__
 *
 * To run a query within a React component, call `useGetOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfficesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOfficesQuery(baseOptions?: Apollo.QueryHookOptions<IGetOfficesQuery, IGetOfficesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetOfficesQuery, IGetOfficesQueryVariables>(GetOfficesDocument, options)
}
export function useGetOfficesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetOfficesQuery, IGetOfficesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetOfficesQuery, IGetOfficesQueryVariables>(GetOfficesDocument, options)
}
export function useGetOfficesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetOfficesQuery, IGetOfficesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetOfficesQuery, IGetOfficesQueryVariables>(GetOfficesDocument, options)
}
export type GetOfficesQueryHookResult = ReturnType<typeof useGetOfficesQuery>
export type GetOfficesLazyQueryHookResult = ReturnType<typeof useGetOfficesLazyQuery>
export type GetOfficesSuspenseQueryHookResult = ReturnType<typeof useGetOfficesSuspenseQuery>
export type GetOfficesQueryResult = Apollo.QueryResult<IGetOfficesQuery, IGetOfficesQueryVariables>
export const GetOfficesPaginationDocument = gql`
  query getOfficesPagination($page: Int!, $pageSize: Int!, $search: String) {
    offices(
      pagination: { page: $page, pageSize: $pageSize }
      sort: "name:asc"
      filters: { name: { containsi: $search } }
    ) {
      documentId
      name
    }
  }
`

/**
 * __useGetOfficesPaginationQuery__
 *
 * To run a query within a React component, call `useGetOfficesPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfficesPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfficesPaginationQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetOfficesPaginationQuery(
  baseOptions: Apollo.QueryHookOptions<IGetOfficesPaginationQuery, IGetOfficesPaginationQueryVariables> &
    ({ variables: IGetOfficesPaginationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetOfficesPaginationQuery, IGetOfficesPaginationQueryVariables>(
    GetOfficesPaginationDocument,
    options,
  )
}
export function useGetOfficesPaginationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetOfficesPaginationQuery, IGetOfficesPaginationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetOfficesPaginationQuery, IGetOfficesPaginationQueryVariables>(
    GetOfficesPaginationDocument,
    options,
  )
}
export function useGetOfficesPaginationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetOfficesPaginationQuery, IGetOfficesPaginationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetOfficesPaginationQuery, IGetOfficesPaginationQueryVariables>(
    GetOfficesPaginationDocument,
    options,
  )
}
export type GetOfficesPaginationQueryHookResult = ReturnType<typeof useGetOfficesPaginationQuery>
export type GetOfficesPaginationLazyQueryHookResult = ReturnType<typeof useGetOfficesPaginationLazyQuery>
export type GetOfficesPaginationSuspenseQueryHookResult = ReturnType<typeof useGetOfficesPaginationSuspenseQuery>
export type GetOfficesPaginationQueryResult = Apollo.QueryResult<
  IGetOfficesPaginationQuery,
  IGetOfficesPaginationQueryVariables
>
export const GetOrganizationDocument = gql`
  query getOrganization {
    organization
  }
`

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetOrganizationQuery, IGetOrganizationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetOrganizationQuery, IGetOrganizationQueryVariables>(GetOrganizationDocument, options)
}
export function useGetOrganizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetOrganizationQuery, IGetOrganizationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetOrganizationQuery, IGetOrganizationQueryVariables>(GetOrganizationDocument, options)
}
export function useGetOrganizationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetOrganizationQuery, IGetOrganizationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetOrganizationQuery, IGetOrganizationQueryVariables>(
    GetOrganizationDocument,
    options,
  )
}
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>
export type GetOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationSuspenseQuery>
export type GetOrganizationQueryResult = Apollo.QueryResult<IGetOrganizationQuery, IGetOrganizationQueryVariables>
export const GetOrganizationNamesDocument = gql`
  query getOrganizationNames {
    premiumOrganizations {
      name
    }
  }
`

/**
 * __useGetOrganizationNamesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationNamesQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetOrganizationNamesQuery, IGetOrganizationNamesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetOrganizationNamesQuery, IGetOrganizationNamesQueryVariables>(
    GetOrganizationNamesDocument,
    options,
  )
}
export function useGetOrganizationNamesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetOrganizationNamesQuery, IGetOrganizationNamesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetOrganizationNamesQuery, IGetOrganizationNamesQueryVariables>(
    GetOrganizationNamesDocument,
    options,
  )
}
export function useGetOrganizationNamesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetOrganizationNamesQuery, IGetOrganizationNamesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetOrganizationNamesQuery, IGetOrganizationNamesQueryVariables>(
    GetOrganizationNamesDocument,
    options,
  )
}
export type GetOrganizationNamesQueryHookResult = ReturnType<typeof useGetOrganizationNamesQuery>
export type GetOrganizationNamesLazyQueryHookResult = ReturnType<typeof useGetOrganizationNamesLazyQuery>
export type GetOrganizationNamesSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationNamesSuspenseQuery>
export type GetOrganizationNamesQueryResult = Apollo.QueryResult<
  IGetOrganizationNamesQuery,
  IGetOrganizationNamesQueryVariables
>
export const PhasesDocument = gql`
  query phases {
    phases(sort: "title:asc", pagination: { limit: -1 }) {
      documentId
      title
      description
    }
  }
`

/**
 * __usePhasesQuery__
 *
 * To run a query within a React component, call `usePhasesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhasesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePhasesQuery(baseOptions?: Apollo.QueryHookOptions<IPhasesQuery, IPhasesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IPhasesQuery, IPhasesQueryVariables>(PhasesDocument, options)
}
export function usePhasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPhasesQuery, IPhasesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IPhasesQuery, IPhasesQueryVariables>(PhasesDocument, options)
}
export function usePhasesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IPhasesQuery, IPhasesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IPhasesQuery, IPhasesQueryVariables>(PhasesDocument, options)
}
export type PhasesQueryHookResult = ReturnType<typeof usePhasesQuery>
export type PhasesLazyQueryHookResult = ReturnType<typeof usePhasesLazyQuery>
export type PhasesSuspenseQueryHookResult = ReturnType<typeof usePhasesSuspenseQuery>
export type PhasesQueryResult = Apollo.QueryResult<IPhasesQuery, IPhasesQueryVariables>
export const GetPracticeAreasDocument = gql`
  query getPracticeAreas {
    practiceAreas(sort: "name:asc") {
      documentId
      name
    }
  }
`

/**
 * __useGetPracticeAreasQuery__
 *
 * To run a query within a React component, call `useGetPracticeAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticeAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticeAreasQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPracticeAreasQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetPracticeAreasQuery, IGetPracticeAreasQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetPracticeAreasQuery, IGetPracticeAreasQueryVariables>(GetPracticeAreasDocument, options)
}
export function useGetPracticeAreasLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetPracticeAreasQuery, IGetPracticeAreasQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetPracticeAreasQuery, IGetPracticeAreasQueryVariables>(GetPracticeAreasDocument, options)
}
export function useGetPracticeAreasSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetPracticeAreasQuery, IGetPracticeAreasQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetPracticeAreasQuery, IGetPracticeAreasQueryVariables>(
    GetPracticeAreasDocument,
    options,
  )
}
export type GetPracticeAreasQueryHookResult = ReturnType<typeof useGetPracticeAreasQuery>
export type GetPracticeAreasLazyQueryHookResult = ReturnType<typeof useGetPracticeAreasLazyQuery>
export type GetPracticeAreasSuspenseQueryHookResult = ReturnType<typeof useGetPracticeAreasSuspenseQuery>
export type GetPracticeAreasQueryResult = Apollo.QueryResult<IGetPracticeAreasQuery, IGetPracticeAreasQueryVariables>
export const GetPracticeAreasPaginationDocument = gql`
  query getPracticeAreasPagination($page: Int!, $pageSize: Int!, $search: String) {
    practiceAreas(
      pagination: { page: $page, pageSize: $pageSize }
      sort: "name:asc"
      filters: { name: { containsi: $search } }
    ) {
      documentId
      name
    }
  }
`

/**
 * __useGetPracticeAreasPaginationQuery__
 *
 * To run a query within a React component, call `useGetPracticeAreasPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticeAreasPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticeAreasPaginationQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPracticeAreasPaginationQuery(
  baseOptions: Apollo.QueryHookOptions<IGetPracticeAreasPaginationQuery, IGetPracticeAreasPaginationQueryVariables> &
    ({ variables: IGetPracticeAreasPaginationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetPracticeAreasPaginationQuery, IGetPracticeAreasPaginationQueryVariables>(
    GetPracticeAreasPaginationDocument,
    options,
  )
}
export function useGetPracticeAreasPaginationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetPracticeAreasPaginationQuery,
    IGetPracticeAreasPaginationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetPracticeAreasPaginationQuery, IGetPracticeAreasPaginationQueryVariables>(
    GetPracticeAreasPaginationDocument,
    options,
  )
}
export function useGetPracticeAreasPaginationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IGetPracticeAreasPaginationQuery,
    IGetPracticeAreasPaginationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetPracticeAreasPaginationQuery, IGetPracticeAreasPaginationQueryVariables>(
    GetPracticeAreasPaginationDocument,
    options,
  )
}
export type GetPracticeAreasPaginationQueryHookResult = ReturnType<typeof useGetPracticeAreasPaginationQuery>
export type GetPracticeAreasPaginationLazyQueryHookResult = ReturnType<typeof useGetPracticeAreasPaginationLazyQuery>
export type GetPracticeAreasPaginationSuspenseQueryHookResult = ReturnType<
  typeof useGetPracticeAreasPaginationSuspenseQuery
>
export type GetPracticeAreasPaginationQueryResult = Apollo.QueryResult<
  IGetPracticeAreasPaginationQuery,
  IGetPracticeAreasPaginationQueryVariables
>
export const GetPremiumOrganizationsByDomainEmailDocument = gql`
  query getPremiumOrganizationsByDomainEmail($domainEmail: String!) {
    premiumOrganizations(filters: { cognitoProviderId: { eq: $domainEmail } }) {
      name
    }
  }
`

/**
 * __useGetPremiumOrganizationsByDomainEmailQuery__
 *
 * To run a query within a React component, call `useGetPremiumOrganizationsByDomainEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPremiumOrganizationsByDomainEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPremiumOrganizationsByDomainEmailQuery({
 *   variables: {
 *      domainEmail: // value for 'domainEmail'
 *   },
 * });
 */
export function useGetPremiumOrganizationsByDomainEmailQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetPremiumOrganizationsByDomainEmailQuery,
    IGetPremiumOrganizationsByDomainEmailQueryVariables
  > &
    ({ variables: IGetPremiumOrganizationsByDomainEmailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetPremiumOrganizationsByDomainEmailQuery,
    IGetPremiumOrganizationsByDomainEmailQueryVariables
  >(GetPremiumOrganizationsByDomainEmailDocument, options)
}
export function useGetPremiumOrganizationsByDomainEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetPremiumOrganizationsByDomainEmailQuery,
    IGetPremiumOrganizationsByDomainEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetPremiumOrganizationsByDomainEmailQuery,
    IGetPremiumOrganizationsByDomainEmailQueryVariables
  >(GetPremiumOrganizationsByDomainEmailDocument, options)
}
export function useGetPremiumOrganizationsByDomainEmailSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IGetPremiumOrganizationsByDomainEmailQuery,
    IGetPremiumOrganizationsByDomainEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IGetPremiumOrganizationsByDomainEmailQuery,
    IGetPremiumOrganizationsByDomainEmailQueryVariables
  >(GetPremiumOrganizationsByDomainEmailDocument, options)
}
export type GetPremiumOrganizationsByDomainEmailQueryHookResult = ReturnType<
  typeof useGetPremiumOrganizationsByDomainEmailQuery
>
export type GetPremiumOrganizationsByDomainEmailLazyQueryHookResult = ReturnType<
  typeof useGetPremiumOrganizationsByDomainEmailLazyQuery
>
export type GetPremiumOrganizationsByDomainEmailSuspenseQueryHookResult = ReturnType<
  typeof useGetPremiumOrganizationsByDomainEmailSuspenseQuery
>
export type GetPremiumOrganizationsByDomainEmailQueryResult = Apollo.QueryResult<
  IGetPremiumOrganizationsByDomainEmailQuery,
  IGetPremiumOrganizationsByDomainEmailQueryVariables
>
export const GetPricingPlansDocument = gql`
  query getPricingPlans {
    premiumPricingPlans(filters: { isActive: { eq: true } }, sort: "name", pagination: { limit: -1 }) {
      documentId
      name
      pricePerYear
      stripeRedirectUrl
    }
  }
`

/**
 * __useGetPricingPlansQuery__
 *
 * To run a query within a React component, call `useGetPricingPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPricingPlansQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetPricingPlansQuery, IGetPricingPlansQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetPricingPlansQuery, IGetPricingPlansQueryVariables>(GetPricingPlansDocument, options)
}
export function useGetPricingPlansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetPricingPlansQuery, IGetPricingPlansQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetPricingPlansQuery, IGetPricingPlansQueryVariables>(GetPricingPlansDocument, options)
}
export function useGetPricingPlansSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetPricingPlansQuery, IGetPricingPlansQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetPricingPlansQuery, IGetPricingPlansQueryVariables>(
    GetPricingPlansDocument,
    options,
  )
}
export type GetPricingPlansQueryHookResult = ReturnType<typeof useGetPricingPlansQuery>
export type GetPricingPlansLazyQueryHookResult = ReturnType<typeof useGetPricingPlansLazyQuery>
export type GetPricingPlansSuspenseQueryHookResult = ReturnType<typeof useGetPricingPlansSuspenseQuery>
export type GetPricingPlansQueryResult = Apollo.QueryResult<IGetPricingPlansQuery, IGetPricingPlansQueryVariables>
export const GetPrivacyPolicyDocument = gql`
  query getPrivacyPolicy {
    privacyPolicy {
      summary
      content
      date
    }
  }
`

/**
 * __useGetPrivacyPolicyQuery__
 *
 * To run a query within a React component, call `useGetPrivacyPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrivacyPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrivacyPolicyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPrivacyPolicyQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetPrivacyPolicyQuery, IGetPrivacyPolicyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetPrivacyPolicyQuery, IGetPrivacyPolicyQueryVariables>(GetPrivacyPolicyDocument, options)
}
export function useGetPrivacyPolicyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetPrivacyPolicyQuery, IGetPrivacyPolicyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetPrivacyPolicyQuery, IGetPrivacyPolicyQueryVariables>(GetPrivacyPolicyDocument, options)
}
export function useGetPrivacyPolicySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetPrivacyPolicyQuery, IGetPrivacyPolicyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetPrivacyPolicyQuery, IGetPrivacyPolicyQueryVariables>(
    GetPrivacyPolicyDocument,
    options,
  )
}
export type GetPrivacyPolicyQueryHookResult = ReturnType<typeof useGetPrivacyPolicyQuery>
export type GetPrivacyPolicyLazyQueryHookResult = ReturnType<typeof useGetPrivacyPolicyLazyQuery>
export type GetPrivacyPolicySuspenseQueryHookResult = ReturnType<typeof useGetPrivacyPolicySuspenseQuery>
export type GetPrivacyPolicyQueryResult = Apollo.QueryResult<IGetPrivacyPolicyQuery, IGetPrivacyPolicyQueryVariables>
export const GetRegionsServedDocument = gql`
  query getRegionsServed {
    regionsServeds(sort: "name:asc") {
      documentId
      name
    }
  }
`

/**
 * __useGetRegionsServedQuery__
 *
 * To run a query within a React component, call `useGetRegionsServedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionsServedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionsServedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegionsServedQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetRegionsServedQuery, IGetRegionsServedQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetRegionsServedQuery, IGetRegionsServedQueryVariables>(GetRegionsServedDocument, options)
}
export function useGetRegionsServedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetRegionsServedQuery, IGetRegionsServedQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetRegionsServedQuery, IGetRegionsServedQueryVariables>(GetRegionsServedDocument, options)
}
export function useGetRegionsServedSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetRegionsServedQuery, IGetRegionsServedQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetRegionsServedQuery, IGetRegionsServedQueryVariables>(
    GetRegionsServedDocument,
    options,
  )
}
export type GetRegionsServedQueryHookResult = ReturnType<typeof useGetRegionsServedQuery>
export type GetRegionsServedLazyQueryHookResult = ReturnType<typeof useGetRegionsServedLazyQuery>
export type GetRegionsServedSuspenseQueryHookResult = ReturnType<typeof useGetRegionsServedSuspenseQuery>
export type GetRegionsServedQueryResult = Apollo.QueryResult<IGetRegionsServedQuery, IGetRegionsServedQueryVariables>
export const GetRelatedSubtopicTopicsDocument = gql`
  query getRelatedSubtopicTopics($query: JSON) {
    relatedSubtopicTopics(query: $query) {
      documentId
      name
      slug
      isPremium
      iconName
      description
      featuredOnHome
      createdAt
      updatedAt
      publishedAt
      subTopics {
        id
        documentId
        name
        slug
        description
        featuredOnHome
        isPremium
      }
    }
  }
`

/**
 * __useGetRelatedSubtopicTopicsQuery__
 *
 * To run a query within a React component, call `useGetRelatedSubtopicTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelatedSubtopicTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelatedSubtopicTopicsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetRelatedSubtopicTopicsQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetRelatedSubtopicTopicsQuery, IGetRelatedSubtopicTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetRelatedSubtopicTopicsQuery, IGetRelatedSubtopicTopicsQueryVariables>(
    GetRelatedSubtopicTopicsDocument,
    options,
  )
}
export function useGetRelatedSubtopicTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetRelatedSubtopicTopicsQuery, IGetRelatedSubtopicTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetRelatedSubtopicTopicsQuery, IGetRelatedSubtopicTopicsQueryVariables>(
    GetRelatedSubtopicTopicsDocument,
    options,
  )
}
export function useGetRelatedSubtopicTopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IGetRelatedSubtopicTopicsQuery,
    IGetRelatedSubtopicTopicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetRelatedSubtopicTopicsQuery, IGetRelatedSubtopicTopicsQueryVariables>(
    GetRelatedSubtopicTopicsDocument,
    options,
  )
}
export type GetRelatedSubtopicTopicsQueryHookResult = ReturnType<typeof useGetRelatedSubtopicTopicsQuery>
export type GetRelatedSubtopicTopicsLazyQueryHookResult = ReturnType<typeof useGetRelatedSubtopicTopicsLazyQuery>
export type GetRelatedSubtopicTopicsSuspenseQueryHookResult = ReturnType<
  typeof useGetRelatedSubtopicTopicsSuspenseQuery
>
export type GetRelatedSubtopicTopicsQueryResult = Apollo.QueryResult<
  IGetRelatedSubtopicTopicsQuery,
  IGetRelatedSubtopicTopicsQueryVariables
>
export const GetSsoOrganizationCognitoProvidersDocument = gql`
  query getSSOOrganizationCognitoProviders {
    premiumOrganizations(filters: { cognitoProviderId: { notNull: true } }) {
      cognitoProviderId
    }
  }
`

/**
 * __useGetSsoOrganizationCognitoProvidersQuery__
 *
 * To run a query within a React component, call `useGetSsoOrganizationCognitoProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSsoOrganizationCognitoProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSsoOrganizationCognitoProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSsoOrganizationCognitoProvidersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IGetSsoOrganizationCognitoProvidersQuery,
    IGetSsoOrganizationCognitoProvidersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetSsoOrganizationCognitoProvidersQuery, IGetSsoOrganizationCognitoProvidersQueryVariables>(
    GetSsoOrganizationCognitoProvidersDocument,
    options,
  )
}
export function useGetSsoOrganizationCognitoProvidersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetSsoOrganizationCognitoProvidersQuery,
    IGetSsoOrganizationCognitoProvidersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetSsoOrganizationCognitoProvidersQuery,
    IGetSsoOrganizationCognitoProvidersQueryVariables
  >(GetSsoOrganizationCognitoProvidersDocument, options)
}
export function useGetSsoOrganizationCognitoProvidersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IGetSsoOrganizationCognitoProvidersQuery,
    IGetSsoOrganizationCognitoProvidersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IGetSsoOrganizationCognitoProvidersQuery,
    IGetSsoOrganizationCognitoProvidersQueryVariables
  >(GetSsoOrganizationCognitoProvidersDocument, options)
}
export type GetSsoOrganizationCognitoProvidersQueryHookResult = ReturnType<
  typeof useGetSsoOrganizationCognitoProvidersQuery
>
export type GetSsoOrganizationCognitoProvidersLazyQueryHookResult = ReturnType<
  typeof useGetSsoOrganizationCognitoProvidersLazyQuery
>
export type GetSsoOrganizationCognitoProvidersSuspenseQueryHookResult = ReturnType<
  typeof useGetSsoOrganizationCognitoProvidersSuspenseQuery
>
export type GetSsoOrganizationCognitoProvidersQueryResult = Apollo.QueryResult<
  IGetSsoOrganizationCognitoProvidersQuery,
  IGetSsoOrganizationCognitoProvidersQueryVariables
>
export const GetSecuritiesDocument = gql`
  query getSecurities {
    securities(sort: "name:asc") {
      id
      name
    }
  }
`

/**
 * __useGetSecuritiesQuery__
 *
 * To run a query within a React component, call `useGetSecuritiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSecuritiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSecuritiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSecuritiesQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetSecuritiesQuery, IGetSecuritiesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetSecuritiesQuery, IGetSecuritiesQueryVariables>(GetSecuritiesDocument, options)
}
export function useGetSecuritiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetSecuritiesQuery, IGetSecuritiesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetSecuritiesQuery, IGetSecuritiesQueryVariables>(GetSecuritiesDocument, options)
}
export function useGetSecuritiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetSecuritiesQuery, IGetSecuritiesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetSecuritiesQuery, IGetSecuritiesQueryVariables>(GetSecuritiesDocument, options)
}
export type GetSecuritiesQueryHookResult = ReturnType<typeof useGetSecuritiesQuery>
export type GetSecuritiesLazyQueryHookResult = ReturnType<typeof useGetSecuritiesLazyQuery>
export type GetSecuritiesSuspenseQueryHookResult = ReturnType<typeof useGetSecuritiesSuspenseQuery>
export type GetSecuritiesQueryResult = Apollo.QueryResult<IGetSecuritiesQuery, IGetSecuritiesQueryVariables>
export const GetShareableContentsDocument = gql`
  query getShareableContents($offset: Int!, $limit: Int!, $query: MySharedContentsFilters!) {
    shareableContents(offset: $offset, limit: $limit, filters: $query) {
      total
      contents {
        id
        attributes {
          ...contentListItem
        }
      }
    }
  }
  ${ContentListItemFragmentDoc}
`

/**
 * __useGetShareableContentsQuery__
 *
 * To run a query within a React component, call `useGetShareableContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareableContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareableContentsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetShareableContentsQuery(
  baseOptions: Apollo.QueryHookOptions<IGetShareableContentsQuery, IGetShareableContentsQueryVariables> &
    ({ variables: IGetShareableContentsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetShareableContentsQuery, IGetShareableContentsQueryVariables>(
    GetShareableContentsDocument,
    options,
  )
}
export function useGetShareableContentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetShareableContentsQuery, IGetShareableContentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetShareableContentsQuery, IGetShareableContentsQueryVariables>(
    GetShareableContentsDocument,
    options,
  )
}
export function useGetShareableContentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetShareableContentsQuery, IGetShareableContentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetShareableContentsQuery, IGetShareableContentsQueryVariables>(
    GetShareableContentsDocument,
    options,
  )
}
export type GetShareableContentsQueryHookResult = ReturnType<typeof useGetShareableContentsQuery>
export type GetShareableContentsLazyQueryHookResult = ReturnType<typeof useGetShareableContentsLazyQuery>
export type GetShareableContentsSuspenseQueryHookResult = ReturnType<typeof useGetShareableContentsSuspenseQuery>
export type GetShareableContentsQueryResult = Apollo.QueryResult<
  IGetShareableContentsQuery,
  IGetShareableContentsQueryVariables
>
export const GetShareableTopicsDocument = gql`
  query getShareableTopics {
    shareableTopics {
      topics {
        id
        name
        isPremium
        subTopics {
          id
          name
          isPremium
        }
      }
    }
  }
`

/**
 * __useGetShareableTopicsQuery__
 *
 * To run a query within a React component, call `useGetShareableTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareableTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareableTopicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShareableTopicsQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetShareableTopicsQuery, IGetShareableTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetShareableTopicsQuery, IGetShareableTopicsQueryVariables>(
    GetShareableTopicsDocument,
    options,
  )
}
export function useGetShareableTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetShareableTopicsQuery, IGetShareableTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetShareableTopicsQuery, IGetShareableTopicsQueryVariables>(
    GetShareableTopicsDocument,
    options,
  )
}
export function useGetShareableTopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetShareableTopicsQuery, IGetShareableTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetShareableTopicsQuery, IGetShareableTopicsQueryVariables>(
    GetShareableTopicsDocument,
    options,
  )
}
export type GetShareableTopicsQueryHookResult = ReturnType<typeof useGetShareableTopicsQuery>
export type GetShareableTopicsLazyQueryHookResult = ReturnType<typeof useGetShareableTopicsLazyQuery>
export type GetShareableTopicsSuspenseQueryHookResult = ReturnType<typeof useGetShareableTopicsSuspenseQuery>
export type GetShareableTopicsQueryResult = Apollo.QueryResult<
  IGetShareableTopicsQuery,
  IGetShareableTopicsQueryVariables
>
export const GetSharedPortfolioBySlugDocument = gql`
  query getSharedPortfolioBySlug($slug: String, $sharedPortfolioId: ID) {
    sharedPortfoliosForMyOrganization(sharedPortfolioSlug: $slug, sharedPortfolioId: $sharedPortfolioId) {
      portfolios {
        ...sharedPortfolioEntityItem
      }
    }
  }
  ${SharedPortfolioEntityItemFragmentDoc}
`

/**
 * __useGetSharedPortfolioBySlugQuery__
 *
 * To run a query within a React component, call `useGetSharedPortfolioBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedPortfolioBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedPortfolioBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      sharedPortfolioId: // value for 'sharedPortfolioId'
 *   },
 * });
 */
export function useGetSharedPortfolioBySlugQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetSharedPortfolioBySlugQuery, IGetSharedPortfolioBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetSharedPortfolioBySlugQuery, IGetSharedPortfolioBySlugQueryVariables>(
    GetSharedPortfolioBySlugDocument,
    options,
  )
}
export function useGetSharedPortfolioBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetSharedPortfolioBySlugQuery, IGetSharedPortfolioBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetSharedPortfolioBySlugQuery, IGetSharedPortfolioBySlugQueryVariables>(
    GetSharedPortfolioBySlugDocument,
    options,
  )
}
export function useGetSharedPortfolioBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IGetSharedPortfolioBySlugQuery,
    IGetSharedPortfolioBySlugQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetSharedPortfolioBySlugQuery, IGetSharedPortfolioBySlugQueryVariables>(
    GetSharedPortfolioBySlugDocument,
    options,
  )
}
export type GetSharedPortfolioBySlugQueryHookResult = ReturnType<typeof useGetSharedPortfolioBySlugQuery>
export type GetSharedPortfolioBySlugLazyQueryHookResult = ReturnType<typeof useGetSharedPortfolioBySlugLazyQuery>
export type GetSharedPortfolioBySlugSuspenseQueryHookResult = ReturnType<
  typeof useGetSharedPortfolioBySlugSuspenseQuery
>
export type GetSharedPortfolioBySlugQueryResult = Apollo.QueryResult<
  IGetSharedPortfolioBySlugQuery,
  IGetSharedPortfolioBySlugQueryVariables
>
export const GetSharedPortfolioTopicsDocument = gql`
  query getSharedPortfolioTopics($sharedPortfolioSlug: String, $sharedPortfolioId: ID) {
    sharedPortfolioTopics(sharedPortfolioSlug: $sharedPortfolioSlug, sharedPortfolioId: $sharedPortfolioId) {
      documentId
      name
      slug
      isPremium
      iconName
      description
      featuredOnHome
      createdAt
      updatedAt
      publishedAt
      subTopics {
        id
        documentId
        name
        slug
        description
        featuredOnHome
        isPremium
      }
    }
  }
`

/**
 * __useGetSharedPortfolioTopicsQuery__
 *
 * To run a query within a React component, call `useGetSharedPortfolioTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedPortfolioTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedPortfolioTopicsQuery({
 *   variables: {
 *      sharedPortfolioSlug: // value for 'sharedPortfolioSlug'
 *      sharedPortfolioId: // value for 'sharedPortfolioId'
 *   },
 * });
 */
export function useGetSharedPortfolioTopicsQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetSharedPortfolioTopicsQuery, IGetSharedPortfolioTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetSharedPortfolioTopicsQuery, IGetSharedPortfolioTopicsQueryVariables>(
    GetSharedPortfolioTopicsDocument,
    options,
  )
}
export function useGetSharedPortfolioTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetSharedPortfolioTopicsQuery, IGetSharedPortfolioTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetSharedPortfolioTopicsQuery, IGetSharedPortfolioTopicsQueryVariables>(
    GetSharedPortfolioTopicsDocument,
    options,
  )
}
export function useGetSharedPortfolioTopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IGetSharedPortfolioTopicsQuery,
    IGetSharedPortfolioTopicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetSharedPortfolioTopicsQuery, IGetSharedPortfolioTopicsQueryVariables>(
    GetSharedPortfolioTopicsDocument,
    options,
  )
}
export type GetSharedPortfolioTopicsQueryHookResult = ReturnType<typeof useGetSharedPortfolioTopicsQuery>
export type GetSharedPortfolioTopicsLazyQueryHookResult = ReturnType<typeof useGetSharedPortfolioTopicsLazyQuery>
export type GetSharedPortfolioTopicsSuspenseQueryHookResult = ReturnType<
  typeof useGetSharedPortfolioTopicsSuspenseQuery
>
export type GetSharedPortfolioTopicsQueryResult = Apollo.QueryResult<
  IGetSharedPortfolioTopicsQuery,
  IGetSharedPortfolioTopicsQueryVariables
>
export const GetSlugUpdatesDocument = gql`
  query getSlugUpdates($type: String!, $oldSlug: String!) {
    slugUpdates(filters: { type: { eq: $type }, oldSlug: { eq: $oldSlug } }) {
      newSlug
    }
  }
`

/**
 * __useGetSlugUpdatesQuery__
 *
 * To run a query within a React component, call `useGetSlugUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlugUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlugUpdatesQuery({
 *   variables: {
 *      type: // value for 'type'
 *      oldSlug: // value for 'oldSlug'
 *   },
 * });
 */
export function useGetSlugUpdatesQuery(
  baseOptions: Apollo.QueryHookOptions<IGetSlugUpdatesQuery, IGetSlugUpdatesQueryVariables> &
    ({ variables: IGetSlugUpdatesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetSlugUpdatesQuery, IGetSlugUpdatesQueryVariables>(GetSlugUpdatesDocument, options)
}
export function useGetSlugUpdatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetSlugUpdatesQuery, IGetSlugUpdatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetSlugUpdatesQuery, IGetSlugUpdatesQueryVariables>(GetSlugUpdatesDocument, options)
}
export function useGetSlugUpdatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetSlugUpdatesQuery, IGetSlugUpdatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetSlugUpdatesQuery, IGetSlugUpdatesQueryVariables>(GetSlugUpdatesDocument, options)
}
export type GetSlugUpdatesQueryHookResult = ReturnType<typeof useGetSlugUpdatesQuery>
export type GetSlugUpdatesLazyQueryHookResult = ReturnType<typeof useGetSlugUpdatesLazyQuery>
export type GetSlugUpdatesSuspenseQueryHookResult = ReturnType<typeof useGetSlugUpdatesSuspenseQuery>
export type GetSlugUpdatesQueryResult = Apollo.QueryResult<IGetSlugUpdatesQuery, IGetSlugUpdatesQueryVariables>
export const SolutionsForVendorDocument = gql`
  query solutionsForVendor($query: JSON) {
    searchVendorSolutions(query: $query) {
      total
      solutions {
        id
        documentId
        slug
        type
        displayName
        isPremium
        isStartup
        isBeta
        isDiverseLeadership
        subTopics
        rating
        reviewCnt
        description
        logo
        valueProposition
        offices {
          id
          name
        }
        security {
          id
          name
        }
      }
    }
  }
`

/**
 * __useSolutionsForVendorQuery__
 *
 * To run a query within a React component, call `useSolutionsForVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolutionsForVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolutionsForVendorQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSolutionsForVendorQuery(
  baseOptions?: Apollo.QueryHookOptions<ISolutionsForVendorQuery, ISolutionsForVendorQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ISolutionsForVendorQuery, ISolutionsForVendorQueryVariables>(
    SolutionsForVendorDocument,
    options,
  )
}
export function useSolutionsForVendorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ISolutionsForVendorQuery, ISolutionsForVendorQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ISolutionsForVendorQuery, ISolutionsForVendorQueryVariables>(
    SolutionsForVendorDocument,
    options,
  )
}
export function useSolutionsForVendorSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ISolutionsForVendorQuery, ISolutionsForVendorQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ISolutionsForVendorQuery, ISolutionsForVendorQueryVariables>(
    SolutionsForVendorDocument,
    options,
  )
}
export type SolutionsForVendorQueryHookResult = ReturnType<typeof useSolutionsForVendorQuery>
export type SolutionsForVendorLazyQueryHookResult = ReturnType<typeof useSolutionsForVendorLazyQuery>
export type SolutionsForVendorSuspenseQueryHookResult = ReturnType<typeof useSolutionsForVendorSuspenseQuery>
export type SolutionsForVendorQueryResult = Apollo.QueryResult<
  ISolutionsForVendorQuery,
  ISolutionsForVendorQueryVariables
>
export const GetSubTopicBySlugDocument = gql`
  query getSubTopicBySlug($slug: String!) {
    subTopics(filters: { slug: { eq: $slug } }) {
      ...subTopicFullItem
    }
  }
  ${SubTopicFullItemFragmentDoc}
`

/**
 * __useGetSubTopicBySlugQuery__
 *
 * To run a query within a React component, call `useGetSubTopicBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubTopicBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubTopicBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetSubTopicBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<IGetSubTopicBySlugQuery, IGetSubTopicBySlugQueryVariables> &
    ({ variables: IGetSubTopicBySlugQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetSubTopicBySlugQuery, IGetSubTopicBySlugQueryVariables>(GetSubTopicBySlugDocument, options)
}
export function useGetSubTopicBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetSubTopicBySlugQuery, IGetSubTopicBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetSubTopicBySlugQuery, IGetSubTopicBySlugQueryVariables>(
    GetSubTopicBySlugDocument,
    options,
  )
}
export function useGetSubTopicBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetSubTopicBySlugQuery, IGetSubTopicBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetSubTopicBySlugQuery, IGetSubTopicBySlugQueryVariables>(
    GetSubTopicBySlugDocument,
    options,
  )
}
export type GetSubTopicBySlugQueryHookResult = ReturnType<typeof useGetSubTopicBySlugQuery>
export type GetSubTopicBySlugLazyQueryHookResult = ReturnType<typeof useGetSubTopicBySlugLazyQuery>
export type GetSubTopicBySlugSuspenseQueryHookResult = ReturnType<typeof useGetSubTopicBySlugSuspenseQuery>
export type GetSubTopicBySlugQueryResult = Apollo.QueryResult<IGetSubTopicBySlugQuery, IGetSubTopicBySlugQueryVariables>
export const GetSubTopicsDocument = gql`
  query getSubTopics($start: Int!) {
    subTopics(sort: "name:asc", pagination: { start: $start }) {
      ...subTopicItem
    }
  }
  ${SubTopicItemFragmentDoc}
`

/**
 * __useGetSubTopicsQuery__
 *
 * To run a query within a React component, call `useGetSubTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubTopicsQuery({
 *   variables: {
 *      start: // value for 'start'
 *   },
 * });
 */
export function useGetSubTopicsQuery(
  baseOptions: Apollo.QueryHookOptions<IGetSubTopicsQuery, IGetSubTopicsQueryVariables> &
    ({ variables: IGetSubTopicsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetSubTopicsQuery, IGetSubTopicsQueryVariables>(GetSubTopicsDocument, options)
}
export function useGetSubTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetSubTopicsQuery, IGetSubTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetSubTopicsQuery, IGetSubTopicsQueryVariables>(GetSubTopicsDocument, options)
}
export function useGetSubTopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetSubTopicsQuery, IGetSubTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetSubTopicsQuery, IGetSubTopicsQueryVariables>(GetSubTopicsDocument, options)
}
export type GetSubTopicsQueryHookResult = ReturnType<typeof useGetSubTopicsQuery>
export type GetSubTopicsLazyQueryHookResult = ReturnType<typeof useGetSubTopicsLazyQuery>
export type GetSubTopicsSuspenseQueryHookResult = ReturnType<typeof useGetSubTopicsSuspenseQuery>
export type GetSubTopicsQueryResult = Apollo.QueryResult<IGetSubTopicsQuery, IGetSubTopicsQueryVariables>
export const GetFeaturesDocument = gql`
  query getFeatures {
    subTopics {
      features {
        name
      }
    }
  }
`

/**
 * __useGetFeaturesQuery__
 *
 * To run a query within a React component, call `useGetFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeaturesQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetFeaturesQuery, IGetFeaturesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetFeaturesQuery, IGetFeaturesQueryVariables>(GetFeaturesDocument, options)
}
export function useGetFeaturesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetFeaturesQuery, IGetFeaturesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetFeaturesQuery, IGetFeaturesQueryVariables>(GetFeaturesDocument, options)
}
export function useGetFeaturesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetFeaturesQuery, IGetFeaturesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetFeaturesQuery, IGetFeaturesQueryVariables>(GetFeaturesDocument, options)
}
export type GetFeaturesQueryHookResult = ReturnType<typeof useGetFeaturesQuery>
export type GetFeaturesLazyQueryHookResult = ReturnType<typeof useGetFeaturesLazyQuery>
export type GetFeaturesSuspenseQueryHookResult = ReturnType<typeof useGetFeaturesSuspenseQuery>
export type GetFeaturesQueryResult = Apollo.QueryResult<IGetFeaturesQuery, IGetFeaturesQueryVariables>
export const GetSubjectMatterDocument = gql`
  query getSubjectMatter {
    subjectMatters(sort: "name:asc") {
      documentId
      name
      slug
      description
    }
  }
`

/**
 * __useGetSubjectMatterQuery__
 *
 * To run a query within a React component, call `useGetSubjectMatterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubjectMatterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubjectMatterQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubjectMatterQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetSubjectMatterQuery, IGetSubjectMatterQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetSubjectMatterQuery, IGetSubjectMatterQueryVariables>(GetSubjectMatterDocument, options)
}
export function useGetSubjectMatterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetSubjectMatterQuery, IGetSubjectMatterQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetSubjectMatterQuery, IGetSubjectMatterQueryVariables>(GetSubjectMatterDocument, options)
}
export function useGetSubjectMatterSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetSubjectMatterQuery, IGetSubjectMatterQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetSubjectMatterQuery, IGetSubjectMatterQueryVariables>(
    GetSubjectMatterDocument,
    options,
  )
}
export type GetSubjectMatterQueryHookResult = ReturnType<typeof useGetSubjectMatterQuery>
export type GetSubjectMatterLazyQueryHookResult = ReturnType<typeof useGetSubjectMatterLazyQuery>
export type GetSubjectMatterSuspenseQueryHookResult = ReturnType<typeof useGetSubjectMatterSuspenseQuery>
export type GetSubjectMatterQueryResult = Apollo.QueryResult<IGetSubjectMatterQuery, IGetSubjectMatterQueryVariables>
export const GetTermsConditionsDocument = gql`
  query getTermsConditions {
    termsConditions {
      summary
      content
      date
    }
  }
`

/**
 * __useGetTermsConditionsQuery__
 *
 * To run a query within a React component, call `useGetTermsConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsConditionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTermsConditionsQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetTermsConditionsQuery, IGetTermsConditionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetTermsConditionsQuery, IGetTermsConditionsQueryVariables>(
    GetTermsConditionsDocument,
    options,
  )
}
export function useGetTermsConditionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetTermsConditionsQuery, IGetTermsConditionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetTermsConditionsQuery, IGetTermsConditionsQueryVariables>(
    GetTermsConditionsDocument,
    options,
  )
}
export function useGetTermsConditionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetTermsConditionsQuery, IGetTermsConditionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetTermsConditionsQuery, IGetTermsConditionsQueryVariables>(
    GetTermsConditionsDocument,
    options,
  )
}
export type GetTermsConditionsQueryHookResult = ReturnType<typeof useGetTermsConditionsQuery>
export type GetTermsConditionsLazyQueryHookResult = ReturnType<typeof useGetTermsConditionsLazyQuery>
export type GetTermsConditionsSuspenseQueryHookResult = ReturnType<typeof useGetTermsConditionsSuspenseQuery>
export type GetTermsConditionsQueryResult = Apollo.QueryResult<
  IGetTermsConditionsQuery,
  IGetTermsConditionsQueryVariables
>
export const GetThemeDocument = gql`
  query getTheme {
    themes(sort: "name:asc") {
      documentId
      name
      slug
      description
    }
  }
`

/**
 * __useGetThemeQuery__
 *
 * To run a query within a React component, call `useGetThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThemeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetThemeQuery(baseOptions?: Apollo.QueryHookOptions<IGetThemeQuery, IGetThemeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetThemeQuery, IGetThemeQueryVariables>(GetThemeDocument, options)
}
export function useGetThemeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetThemeQuery, IGetThemeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetThemeQuery, IGetThemeQueryVariables>(GetThemeDocument, options)
}
export function useGetThemeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetThemeQuery, IGetThemeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetThemeQuery, IGetThemeQueryVariables>(GetThemeDocument, options)
}
export type GetThemeQueryHookResult = ReturnType<typeof useGetThemeQuery>
export type GetThemeLazyQueryHookResult = ReturnType<typeof useGetThemeLazyQuery>
export type GetThemeSuspenseQueryHookResult = ReturnType<typeof useGetThemeSuspenseQuery>
export type GetThemeQueryResult = Apollo.QueryResult<IGetThemeQuery, IGetThemeQueryVariables>
export const GetTopicBySlugDocument = gql`
  query getTopicBySlug($slug: String!) {
    topics(filters: { slug: { eq: $slug } }) {
      ...topicFullItem
    }
  }
  ${TopicFullItemFragmentDoc}
`

/**
 * __useGetTopicBySlugQuery__
 *
 * To run a query within a React component, call `useGetTopicBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetTopicBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<IGetTopicBySlugQuery, IGetTopicBySlugQueryVariables> &
    ({ variables: IGetTopicBySlugQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetTopicBySlugQuery, IGetTopicBySlugQueryVariables>(GetTopicBySlugDocument, options)
}
export function useGetTopicBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetTopicBySlugQuery, IGetTopicBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetTopicBySlugQuery, IGetTopicBySlugQueryVariables>(GetTopicBySlugDocument, options)
}
export function useGetTopicBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetTopicBySlugQuery, IGetTopicBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetTopicBySlugQuery, IGetTopicBySlugQueryVariables>(GetTopicBySlugDocument, options)
}
export type GetTopicBySlugQueryHookResult = ReturnType<typeof useGetTopicBySlugQuery>
export type GetTopicBySlugLazyQueryHookResult = ReturnType<typeof useGetTopicBySlugLazyQuery>
export type GetTopicBySlugSuspenseQueryHookResult = ReturnType<typeof useGetTopicBySlugSuspenseQuery>
export type GetTopicBySlugQueryResult = Apollo.QueryResult<IGetTopicBySlugQuery, IGetTopicBySlugQueryVariables>
export const GetTopicsDocument = gql`
  query getTopics {
    topics(sort: "name:asc", pagination: { limit: -1 }) {
      ...topicItem
    }
  }
  ${TopicItemFragmentDoc}
`

/**
 * __useGetTopicsQuery__
 *
 * To run a query within a React component, call `useGetTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTopicsQuery(baseOptions?: Apollo.QueryHookOptions<IGetTopicsQuery, IGetTopicsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetTopicsQuery, IGetTopicsQueryVariables>(GetTopicsDocument, options)
}
export function useGetTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetTopicsQuery, IGetTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetTopicsQuery, IGetTopicsQueryVariables>(GetTopicsDocument, options)
}
export function useGetTopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetTopicsQuery, IGetTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetTopicsQuery, IGetTopicsQueryVariables>(GetTopicsDocument, options)
}
export type GetTopicsQueryHookResult = ReturnType<typeof useGetTopicsQuery>
export type GetTopicsLazyQueryHookResult = ReturnType<typeof useGetTopicsLazyQuery>
export type GetTopicsSuspenseQueryHookResult = ReturnType<typeof useGetTopicsSuspenseQuery>
export type GetTopicsQueryResult = Apollo.QueryResult<IGetTopicsQuery, IGetTopicsQueryVariables>
export const GetTopicsForHeaderDocument = gql`
  query getTopicsForHeader {
    topics(sort: "name:asc", pagination: { limit: -1 }) {
      documentId
      slug
      name
      iconName
      description
      isPremium
      publishedAt
      subTopics(sort: "name:asc") {
        ...subTopicItemWithoutSub
      }
    }
  }
  ${SubTopicItemWithoutSubFragmentDoc}
`

/**
 * __useGetTopicsForHeaderQuery__
 *
 * To run a query within a React component, call `useGetTopicsForHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicsForHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicsForHeaderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTopicsForHeaderQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetTopicsForHeaderQuery, IGetTopicsForHeaderQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetTopicsForHeaderQuery, IGetTopicsForHeaderQueryVariables>(
    GetTopicsForHeaderDocument,
    options,
  )
}
export function useGetTopicsForHeaderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetTopicsForHeaderQuery, IGetTopicsForHeaderQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetTopicsForHeaderQuery, IGetTopicsForHeaderQueryVariables>(
    GetTopicsForHeaderDocument,
    options,
  )
}
export function useGetTopicsForHeaderSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetTopicsForHeaderQuery, IGetTopicsForHeaderQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetTopicsForHeaderQuery, IGetTopicsForHeaderQueryVariables>(
    GetTopicsForHeaderDocument,
    options,
  )
}
export type GetTopicsForHeaderQueryHookResult = ReturnType<typeof useGetTopicsForHeaderQuery>
export type GetTopicsForHeaderLazyQueryHookResult = ReturnType<typeof useGetTopicsForHeaderLazyQuery>
export type GetTopicsForHeaderSuspenseQueryHookResult = ReturnType<typeof useGetTopicsForHeaderSuspenseQuery>
export type GetTopicsForHeaderQueryResult = Apollo.QueryResult<
  IGetTopicsForHeaderQuery,
  IGetTopicsForHeaderQueryVariables
>
export const GetTopicsWithoutSubsDocument = gql`
  query getTopicsWithoutSubs {
    topics(sort: "name:asc", pagination: { limit: -1 }) {
      name
      slug
      iconName
      isPremium
      subTopics {
        name
        slug
      }
    }
  }
`

/**
 * __useGetTopicsWithoutSubsQuery__
 *
 * To run a query within a React component, call `useGetTopicsWithoutSubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicsWithoutSubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicsWithoutSubsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTopicsWithoutSubsQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetTopicsWithoutSubsQuery, IGetTopicsWithoutSubsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetTopicsWithoutSubsQuery, IGetTopicsWithoutSubsQueryVariables>(
    GetTopicsWithoutSubsDocument,
    options,
  )
}
export function useGetTopicsWithoutSubsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetTopicsWithoutSubsQuery, IGetTopicsWithoutSubsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetTopicsWithoutSubsQuery, IGetTopicsWithoutSubsQueryVariables>(
    GetTopicsWithoutSubsDocument,
    options,
  )
}
export function useGetTopicsWithoutSubsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetTopicsWithoutSubsQuery, IGetTopicsWithoutSubsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetTopicsWithoutSubsQuery, IGetTopicsWithoutSubsQueryVariables>(
    GetTopicsWithoutSubsDocument,
    options,
  )
}
export type GetTopicsWithoutSubsQueryHookResult = ReturnType<typeof useGetTopicsWithoutSubsQuery>
export type GetTopicsWithoutSubsLazyQueryHookResult = ReturnType<typeof useGetTopicsWithoutSubsLazyQuery>
export type GetTopicsWithoutSubsSuspenseQueryHookResult = ReturnType<typeof useGetTopicsWithoutSubsSuspenseQuery>
export type GetTopicsWithoutSubsQueryResult = Apollo.QueryResult<
  IGetTopicsWithoutSubsQuery,
  IGetTopicsWithoutSubsQueryVariables
>
export const GetTypeOfUsersDocument = gql`
  query getTypeOfUsers {
    typeOfUsers {
      documentId
      name
    }
  }
`

/**
 * __useGetTypeOfUsersQuery__
 *
 * To run a query within a React component, call `useGetTypeOfUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTypeOfUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTypeOfUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTypeOfUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetTypeOfUsersQuery, IGetTypeOfUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetTypeOfUsersQuery, IGetTypeOfUsersQueryVariables>(GetTypeOfUsersDocument, options)
}
export function useGetTypeOfUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetTypeOfUsersQuery, IGetTypeOfUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetTypeOfUsersQuery, IGetTypeOfUsersQueryVariables>(GetTypeOfUsersDocument, options)
}
export function useGetTypeOfUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetTypeOfUsersQuery, IGetTypeOfUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetTypeOfUsersQuery, IGetTypeOfUsersQueryVariables>(GetTypeOfUsersDocument, options)
}
export type GetTypeOfUsersQueryHookResult = ReturnType<typeof useGetTypeOfUsersQuery>
export type GetTypeOfUsersLazyQueryHookResult = ReturnType<typeof useGetTypeOfUsersLazyQuery>
export type GetTypeOfUsersSuspenseQueryHookResult = ReturnType<typeof useGetTypeOfUsersSuspenseQuery>
export type GetTypeOfUsersQueryResult = Apollo.QueryResult<IGetTypeOfUsersQuery, IGetTypeOfUsersQueryVariables>
export const GetVendorTopicsDocument = gql`
  query getVendorTopics {
    vendorTopics {
      documentId
      name
    }
  }
`

/**
 * __useGetVendorTopicsQuery__
 *
 * To run a query within a React component, call `useGetVendorTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorTopicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVendorTopicsQuery(
  baseOptions?: Apollo.QueryHookOptions<IGetVendorTopicsQuery, IGetVendorTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetVendorTopicsQuery, IGetVendorTopicsQueryVariables>(GetVendorTopicsDocument, options)
}
export function useGetVendorTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGetVendorTopicsQuery, IGetVendorTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetVendorTopicsQuery, IGetVendorTopicsQueryVariables>(GetVendorTopicsDocument, options)
}
export function useGetVendorTopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGetVendorTopicsQuery, IGetVendorTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGetVendorTopicsQuery, IGetVendorTopicsQueryVariables>(
    GetVendorTopicsDocument,
    options,
  )
}
export type GetVendorTopicsQueryHookResult = ReturnType<typeof useGetVendorTopicsQuery>
export type GetVendorTopicsLazyQueryHookResult = ReturnType<typeof useGetVendorTopicsLazyQuery>
export type GetVendorTopicsSuspenseQueryHookResult = ReturnType<typeof useGetVendorTopicsSuspenseQuery>
export type GetVendorTopicsQueryResult = Apollo.QueryResult<IGetVendorTopicsQuery, IGetVendorTopicsQueryVariables>
export const GlobalTestimonialsDocument = gql`
  query globalTestimonials {
    testimonialsPlural {
      ...testimonialItem
    }
  }
  ${TestimonialItemFragmentDoc}
`

/**
 * __useGlobalTestimonialsQuery__
 *
 * To run a query within a React component, call `useGlobalTestimonialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalTestimonialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalTestimonialsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalTestimonialsQuery(
  baseOptions?: Apollo.QueryHookOptions<IGlobalTestimonialsQuery, IGlobalTestimonialsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGlobalTestimonialsQuery, IGlobalTestimonialsQueryVariables>(
    GlobalTestimonialsDocument,
    options,
  )
}
export function useGlobalTestimonialsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IGlobalTestimonialsQuery, IGlobalTestimonialsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGlobalTestimonialsQuery, IGlobalTestimonialsQueryVariables>(
    GlobalTestimonialsDocument,
    options,
  )
}
export function useGlobalTestimonialsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IGlobalTestimonialsQuery, IGlobalTestimonialsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IGlobalTestimonialsQuery, IGlobalTestimonialsQueryVariables>(
    GlobalTestimonialsDocument,
    options,
  )
}
export type GlobalTestimonialsQueryHookResult = ReturnType<typeof useGlobalTestimonialsQuery>
export type GlobalTestimonialsLazyQueryHookResult = ReturnType<typeof useGlobalTestimonialsLazyQuery>
export type GlobalTestimonialsSuspenseQueryHookResult = ReturnType<typeof useGlobalTestimonialsSuspenseQuery>
export type GlobalTestimonialsQueryResult = Apollo.QueryResult<
  IGlobalTestimonialsQuery,
  IGlobalTestimonialsQueryVariables
>
export const HqsDocument = gql`
  query hqs {
    hqs(sort: "name:asc") {
      documentId
      name
    }
  }
`

/**
 * __useHqsQuery__
 *
 * To run a query within a React component, call `useHqsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHqsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHqsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHqsQuery(baseOptions?: Apollo.QueryHookOptions<IHqsQuery, IHqsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IHqsQuery, IHqsQueryVariables>(HqsDocument, options)
}
export function useHqsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IHqsQuery, IHqsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IHqsQuery, IHqsQueryVariables>(HqsDocument, options)
}
export function useHqsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IHqsQuery, IHqsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IHqsQuery, IHqsQueryVariables>(HqsDocument, options)
}
export type HqsQueryHookResult = ReturnType<typeof useHqsQuery>
export type HqsLazyQueryHookResult = ReturnType<typeof useHqsLazyQuery>
export type HqsSuspenseQueryHookResult = ReturnType<typeof useHqsSuspenseQuery>
export type HqsQueryResult = Apollo.QueryResult<IHqsQuery, IHqsQueryVariables>
export const HqsPaginationDocument = gql`
  query hqsPagination($page: Int!, $pageSize: Int!, $search: String) {
    hqs(pagination: { page: $page, pageSize: $pageSize }, sort: "name:asc", filters: { name: { containsi: $search } }) {
      documentId
      name
    }
  }
`

/**
 * __useHqsPaginationQuery__
 *
 * To run a query within a React component, call `useHqsPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHqsPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHqsPaginationQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useHqsPaginationQuery(
  baseOptions: Apollo.QueryHookOptions<IHqsPaginationQuery, IHqsPaginationQueryVariables> &
    ({ variables: IHqsPaginationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IHqsPaginationQuery, IHqsPaginationQueryVariables>(HqsPaginationDocument, options)
}
export function useHqsPaginationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IHqsPaginationQuery, IHqsPaginationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IHqsPaginationQuery, IHqsPaginationQueryVariables>(HqsPaginationDocument, options)
}
export function useHqsPaginationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IHqsPaginationQuery, IHqsPaginationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IHqsPaginationQuery, IHqsPaginationQueryVariables>(HqsPaginationDocument, options)
}
export type HqsPaginationQueryHookResult = ReturnType<typeof useHqsPaginationQuery>
export type HqsPaginationLazyQueryHookResult = ReturnType<typeof useHqsPaginationLazyQuery>
export type HqsPaginationSuspenseQueryHookResult = ReturnType<typeof useHqsPaginationSuspenseQuery>
export type HqsPaginationQueryResult = Apollo.QueryResult<IHqsPaginationQuery, IHqsPaginationQueryVariables>
export const IsFollowDocument = gql`
  query isFollow($id: String) {
    isFollow(id: $id)
  }
`

/**
 * __useIsFollowQuery__
 *
 * To run a query within a React component, call `useIsFollowQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsFollowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsFollowQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsFollowQuery(baseOptions?: Apollo.QueryHookOptions<IIsFollowQuery, IIsFollowQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IIsFollowQuery, IIsFollowQueryVariables>(IsFollowDocument, options)
}
export function useIsFollowLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IIsFollowQuery, IIsFollowQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IIsFollowQuery, IIsFollowQueryVariables>(IsFollowDocument, options)
}
export function useIsFollowSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IIsFollowQuery, IIsFollowQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IIsFollowQuery, IIsFollowQueryVariables>(IsFollowDocument, options)
}
export type IsFollowQueryHookResult = ReturnType<typeof useIsFollowQuery>
export type IsFollowLazyQueryHookResult = ReturnType<typeof useIsFollowLazyQuery>
export type IsFollowSuspenseQueryHookResult = ReturnType<typeof useIsFollowSuspenseQuery>
export type IsFollowQueryResult = Apollo.QueryResult<IIsFollowQuery, IIsFollowQueryVariables>
export const IsUserInConfigDocument = gql`
  query isUserInConfig {
    isUserInConfig
  }
`

/**
 * __useIsUserInConfigQuery__
 *
 * To run a query within a React component, call `useIsUserInConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsUserInConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsUserInConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsUserInConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<IIsUserInConfigQuery, IIsUserInConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IIsUserInConfigQuery, IIsUserInConfigQueryVariables>(IsUserInConfigDocument, options)
}
export function useIsUserInConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IIsUserInConfigQuery, IIsUserInConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IIsUserInConfigQuery, IIsUserInConfigQueryVariables>(IsUserInConfigDocument, options)
}
export function useIsUserInConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IIsUserInConfigQuery, IIsUserInConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IIsUserInConfigQuery, IIsUserInConfigQueryVariables>(IsUserInConfigDocument, options)
}
export type IsUserInConfigQueryHookResult = ReturnType<typeof useIsUserInConfigQuery>
export type IsUserInConfigLazyQueryHookResult = ReturnType<typeof useIsUserInConfigLazyQuery>
export type IsUserInConfigSuspenseQueryHookResult = ReturnType<typeof useIsUserInConfigSuspenseQuery>
export type IsUserInConfigQueryResult = Apollo.QueryResult<IIsUserInConfigQuery, IIsUserInConfigQueryVariables>
export const LoginDocument = gql`
  mutation login($input: UsersPermissionsLoginInput!) {
    login(input: $input) {
      jwt
      user {
        id
        username
        email
        confirmed
      }
    }
  }
`
export type ILoginMutationFn = Apollo.MutationFunction<ILoginMutation, ILoginMutationVariables>

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<ILoginMutation, ILoginMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ILoginMutation, ILoginMutationVariables>(LoginDocument, options)
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>
export type LoginMutationResult = Apollo.MutationResult<ILoginMutation>
export type LoginMutationOptions = Apollo.BaseMutationOptions<ILoginMutation, ILoginMutationVariables>
export const MySharedContentsDocument = gql`
  query mySharedContents($offset: Int!, $limit: Int!, $query: MySharedContentsFilters!) {
    mySharedContents(offset: $offset, limit: $limit, filters: $query) {
      total
      contents {
        id
        attributes {
          ...contentListItem
        }
      }
    }
  }
  ${ContentListItemFragmentDoc}
`

/**
 * __useMySharedContentsQuery__
 *
 * To run a query within a React component, call `useMySharedContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySharedContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySharedContentsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useMySharedContentsQuery(
  baseOptions: Apollo.QueryHookOptions<IMySharedContentsQuery, IMySharedContentsQueryVariables> &
    ({ variables: IMySharedContentsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IMySharedContentsQuery, IMySharedContentsQueryVariables>(MySharedContentsDocument, options)
}
export function useMySharedContentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IMySharedContentsQuery, IMySharedContentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IMySharedContentsQuery, IMySharedContentsQueryVariables>(MySharedContentsDocument, options)
}
export function useMySharedContentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IMySharedContentsQuery, IMySharedContentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IMySharedContentsQuery, IMySharedContentsQueryVariables>(
    MySharedContentsDocument,
    options,
  )
}
export type MySharedContentsQueryHookResult = ReturnType<typeof useMySharedContentsQuery>
export type MySharedContentsLazyQueryHookResult = ReturnType<typeof useMySharedContentsLazyQuery>
export type MySharedContentsSuspenseQueryHookResult = ReturnType<typeof useMySharedContentsSuspenseQuery>
export type MySharedContentsQueryResult = Apollo.QueryResult<IMySharedContentsQuery, IMySharedContentsQueryVariables>
export const PhasesForSubTopicDocument = gql`
  query phasesForSubTopic {
    phases(sort: "priority:asc", pagination: { limit: -1 }) {
      ...phaseItem
    }
  }
  ${PhaseItemFragmentDoc}
`

/**
 * __usePhasesForSubTopicQuery__
 *
 * To run a query within a React component, call `usePhasesForSubTopicQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhasesForSubTopicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhasesForSubTopicQuery({
 *   variables: {
 *   },
 * });
 */
export function usePhasesForSubTopicQuery(
  baseOptions?: Apollo.QueryHookOptions<IPhasesForSubTopicQuery, IPhasesForSubTopicQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IPhasesForSubTopicQuery, IPhasesForSubTopicQueryVariables>(PhasesForSubTopicDocument, options)
}
export function usePhasesForSubTopicLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IPhasesForSubTopicQuery, IPhasesForSubTopicQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IPhasesForSubTopicQuery, IPhasesForSubTopicQueryVariables>(
    PhasesForSubTopicDocument,
    options,
  )
}
export function usePhasesForSubTopicSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IPhasesForSubTopicQuery, IPhasesForSubTopicQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IPhasesForSubTopicQuery, IPhasesForSubTopicQueryVariables>(
    PhasesForSubTopicDocument,
    options,
  )
}
export type PhasesForSubTopicQueryHookResult = ReturnType<typeof usePhasesForSubTopicQuery>
export type PhasesForSubTopicLazyQueryHookResult = ReturnType<typeof usePhasesForSubTopicLazyQuery>
export type PhasesForSubTopicSuspenseQueryHookResult = ReturnType<typeof usePhasesForSubTopicSuspenseQuery>
export type PhasesForSubTopicQueryResult = Apollo.QueryResult<IPhasesForSubTopicQuery, IPhasesForSubTopicQueryVariables>
export const PopularTopicsDocument = gql`
  query popularTopics($vendorLimit: Int!) {
    popularTopics(vendorLimit: $vendorLimit) {
      id
      name
      slug
      solutions {
        logo {
          url
        }
        slug
        type
      }
    }
  }
`

/**
 * __usePopularTopicsQuery__
 *
 * To run a query within a React component, call `usePopularTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopularTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopularTopicsQuery({
 *   variables: {
 *      vendorLimit: // value for 'vendorLimit'
 *   },
 * });
 */
export function usePopularTopicsQuery(
  baseOptions: Apollo.QueryHookOptions<IPopularTopicsQuery, IPopularTopicsQueryVariables> &
    ({ variables: IPopularTopicsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IPopularTopicsQuery, IPopularTopicsQueryVariables>(PopularTopicsDocument, options)
}
export function usePopularTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IPopularTopicsQuery, IPopularTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IPopularTopicsQuery, IPopularTopicsQueryVariables>(PopularTopicsDocument, options)
}
export function usePopularTopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IPopularTopicsQuery, IPopularTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IPopularTopicsQuery, IPopularTopicsQueryVariables>(PopularTopicsDocument, options)
}
export type PopularTopicsQueryHookResult = ReturnType<typeof usePopularTopicsQuery>
export type PopularTopicsLazyQueryHookResult = ReturnType<typeof usePopularTopicsLazyQuery>
export type PopularTopicsSuspenseQueryHookResult = ReturnType<typeof usePopularTopicsSuspenseQuery>
export type PopularTopicsQueryResult = Apollo.QueryResult<IPopularTopicsQuery, IPopularTopicsQueryVariables>
export const PostShareContentsDocument = gql`
  mutation postShareContents($data: ResourceInvitationInput!) {
    shareContents(data: $data)
  }
`
export type IPostShareContentsMutationFn = Apollo.MutationFunction<
  IPostShareContentsMutation,
  IPostShareContentsMutationVariables
>

/**
 * __usePostShareContentsMutation__
 *
 * To run a mutation, you first call `usePostShareContentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostShareContentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postShareContentsMutation, { data, loading, error }] = usePostShareContentsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePostShareContentsMutation(
  baseOptions?: Apollo.MutationHookOptions<IPostShareContentsMutation, IPostShareContentsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IPostShareContentsMutation, IPostShareContentsMutationVariables>(
    PostShareContentsDocument,
    options,
  )
}
export type PostShareContentsMutationHookResult = ReturnType<typeof usePostShareContentsMutation>
export type PostShareContentsMutationResult = Apollo.MutationResult<IPostShareContentsMutation>
export type PostShareContentsMutationOptions = Apollo.BaseMutationOptions<
  IPostShareContentsMutation,
  IPostShareContentsMutationVariables
>
export const PostshareVendorStatusDocument = gql`
  mutation postshareVendorStatus($data: vendorName) {
    shareVendorStatus(data: $data) {
      data {
        status
      }
    }
  }
`
export type IPostshareVendorStatusMutationFn = Apollo.MutationFunction<
  IPostshareVendorStatusMutation,
  IPostshareVendorStatusMutationVariables
>

/**
 * __usePostshareVendorStatusMutation__
 *
 * To run a mutation, you first call `usePostshareVendorStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostshareVendorStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postshareVendorStatusMutation, { data, loading, error }] = usePostshareVendorStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePostshareVendorStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<IPostshareVendorStatusMutation, IPostshareVendorStatusMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IPostshareVendorStatusMutation, IPostshareVendorStatusMutationVariables>(
    PostshareVendorStatusDocument,
    options,
  )
}
export type PostshareVendorStatusMutationHookResult = ReturnType<typeof usePostshareVendorStatusMutation>
export type PostshareVendorStatusMutationResult = Apollo.MutationResult<IPostshareVendorStatusMutation>
export type PostshareVendorStatusMutationOptions = Apollo.BaseMutationOptions<
  IPostshareVendorStatusMutation,
  IPostshareVendorStatusMutationVariables
>
export const PremiumAudiencesDocument = gql`
  query premiumAudiences($filters: PremiumAudienceFiltersInput, $sort: [String] = []) {
    premiumAudiences(filters: $filters, sort: $sort) {
      ...premiumAudienceItem
    }
  }
  ${PremiumAudienceItemFragmentDoc}
`

/**
 * __usePremiumAudiencesQuery__
 *
 * To run a query within a React component, call `usePremiumAudiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePremiumAudiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePremiumAudiencesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePremiumAudiencesQuery(
  baseOptions?: Apollo.QueryHookOptions<IPremiumAudiencesQuery, IPremiumAudiencesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IPremiumAudiencesQuery, IPremiumAudiencesQueryVariables>(PremiumAudiencesDocument, options)
}
export function usePremiumAudiencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IPremiumAudiencesQuery, IPremiumAudiencesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IPremiumAudiencesQuery, IPremiumAudiencesQueryVariables>(PremiumAudiencesDocument, options)
}
export function usePremiumAudiencesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IPremiumAudiencesQuery, IPremiumAudiencesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IPremiumAudiencesQuery, IPremiumAudiencesQueryVariables>(
    PremiumAudiencesDocument,
    options,
  )
}
export type PremiumAudiencesQueryHookResult = ReturnType<typeof usePremiumAudiencesQuery>
export type PremiumAudiencesLazyQueryHookResult = ReturnType<typeof usePremiumAudiencesLazyQuery>
export type PremiumAudiencesSuspenseQueryHookResult = ReturnType<typeof usePremiumAudiencesSuspenseQuery>
export type PremiumAudiencesQueryResult = Apollo.QueryResult<IPremiumAudiencesQuery, IPremiumAudiencesQueryVariables>
export const PremiumSubTopicsDocument = gql`
  query premiumSubTopics {
    subTopics(filters: { isPremium: { eq: true } }, sort: "name:asc") {
      ...subTopicItem
    }
  }
  ${SubTopicItemFragmentDoc}
`

/**
 * __usePremiumSubTopicsQuery__
 *
 * To run a query within a React component, call `usePremiumSubTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePremiumSubTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePremiumSubTopicsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePremiumSubTopicsQuery(
  baseOptions?: Apollo.QueryHookOptions<IPremiumSubTopicsQuery, IPremiumSubTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IPremiumSubTopicsQuery, IPremiumSubTopicsQueryVariables>(PremiumSubTopicsDocument, options)
}
export function usePremiumSubTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IPremiumSubTopicsQuery, IPremiumSubTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IPremiumSubTopicsQuery, IPremiumSubTopicsQueryVariables>(PremiumSubTopicsDocument, options)
}
export function usePremiumSubTopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IPremiumSubTopicsQuery, IPremiumSubTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IPremiumSubTopicsQuery, IPremiumSubTopicsQueryVariables>(
    PremiumSubTopicsDocument,
    options,
  )
}
export type PremiumSubTopicsQueryHookResult = ReturnType<typeof usePremiumSubTopicsQuery>
export type PremiumSubTopicsLazyQueryHookResult = ReturnType<typeof usePremiumSubTopicsLazyQuery>
export type PremiumSubTopicsSuspenseQueryHookResult = ReturnType<typeof usePremiumSubTopicsSuspenseQuery>
export type PremiumSubTopicsQueryResult = Apollo.QueryResult<IPremiumSubTopicsQuery, IPremiumSubTopicsQueryVariables>
export const PremiumSubTopicsWithContentsDocument = gql`
  query premiumSubTopicsWithContents {
    subTopics(filters: { isPremium: { eq: true } }, sort: "name:asc") {
      ...subTopicItem
      contents(filters: { isPremium: { eq: true } }, pagination: { start: 0, limit: 10 }, sort: "publishedTime:desc") {
        ...contentListItem
      }
    }
  }
  ${SubTopicItemFragmentDoc}
  ${ContentListItemFragmentDoc}
`

/**
 * __usePremiumSubTopicsWithContentsQuery__
 *
 * To run a query within a React component, call `usePremiumSubTopicsWithContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePremiumSubTopicsWithContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePremiumSubTopicsWithContentsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePremiumSubTopicsWithContentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IPremiumSubTopicsWithContentsQuery,
    IPremiumSubTopicsWithContentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IPremiumSubTopicsWithContentsQuery, IPremiumSubTopicsWithContentsQueryVariables>(
    PremiumSubTopicsWithContentsDocument,
    options,
  )
}
export function usePremiumSubTopicsWithContentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IPremiumSubTopicsWithContentsQuery,
    IPremiumSubTopicsWithContentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IPremiumSubTopicsWithContentsQuery, IPremiumSubTopicsWithContentsQueryVariables>(
    PremiumSubTopicsWithContentsDocument,
    options,
  )
}
export function usePremiumSubTopicsWithContentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IPremiumSubTopicsWithContentsQuery,
    IPremiumSubTopicsWithContentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IPremiumSubTopicsWithContentsQuery, IPremiumSubTopicsWithContentsQueryVariables>(
    PremiumSubTopicsWithContentsDocument,
    options,
  )
}
export type PremiumSubTopicsWithContentsQueryHookResult = ReturnType<typeof usePremiumSubTopicsWithContentsQuery>
export type PremiumSubTopicsWithContentsLazyQueryHookResult = ReturnType<
  typeof usePremiumSubTopicsWithContentsLazyQuery
>
export type PremiumSubTopicsWithContentsSuspenseQueryHookResult = ReturnType<
  typeof usePremiumSubTopicsWithContentsSuspenseQuery
>
export type PremiumSubTopicsWithContentsQueryResult = Apollo.QueryResult<
  IPremiumSubTopicsWithContentsQuery,
  IPremiumSubTopicsWithContentsQueryVariables
>
export const PremiumTopicsDocument = gql`
  query premiumTopics {
    topics(filters: { isPremium: { eq: true } }, sort: "name:asc") {
      ...topicItem
    }
  }
  ${TopicItemFragmentDoc}
`

/**
 * __usePremiumTopicsQuery__
 *
 * To run a query within a React component, call `usePremiumTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePremiumTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePremiumTopicsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePremiumTopicsQuery(
  baseOptions?: Apollo.QueryHookOptions<IPremiumTopicsQuery, IPremiumTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IPremiumTopicsQuery, IPremiumTopicsQueryVariables>(PremiumTopicsDocument, options)
}
export function usePremiumTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IPremiumTopicsQuery, IPremiumTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IPremiumTopicsQuery, IPremiumTopicsQueryVariables>(PremiumTopicsDocument, options)
}
export function usePremiumTopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IPremiumTopicsQuery, IPremiumTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IPremiumTopicsQuery, IPremiumTopicsQueryVariables>(PremiumTopicsDocument, options)
}
export type PremiumTopicsQueryHookResult = ReturnType<typeof usePremiumTopicsQuery>
export type PremiumTopicsLazyQueryHookResult = ReturnType<typeof usePremiumTopicsLazyQuery>
export type PremiumTopicsSuspenseQueryHookResult = ReturnType<typeof usePremiumTopicsSuspenseQuery>
export type PremiumTopicsQueryResult = Apollo.QueryResult<IPremiumTopicsQuery, IPremiumTopicsQueryVariables>
export const PremiumTopicsWithContentsDocument = gql`
  query premiumTopicsWithContents {
    topics(filters: { isPremium: { eq: true } }, sort: "name:asc") {
      ...topicItem
      contents(filters: { isPremium: { eq: true } }, pagination: { start: 0, limit: 10 }, sort: "publishedTime:desc") {
        ...contentListItem
      }
    }
  }
  ${TopicItemFragmentDoc}
  ${ContentListItemFragmentDoc}
`

/**
 * __usePremiumTopicsWithContentsQuery__
 *
 * To run a query within a React component, call `usePremiumTopicsWithContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePremiumTopicsWithContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePremiumTopicsWithContentsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePremiumTopicsWithContentsQuery(
  baseOptions?: Apollo.QueryHookOptions<IPremiumTopicsWithContentsQuery, IPremiumTopicsWithContentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IPremiumTopicsWithContentsQuery, IPremiumTopicsWithContentsQueryVariables>(
    PremiumTopicsWithContentsDocument,
    options,
  )
}
export function usePremiumTopicsWithContentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IPremiumTopicsWithContentsQuery, IPremiumTopicsWithContentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IPremiumTopicsWithContentsQuery, IPremiumTopicsWithContentsQueryVariables>(
    PremiumTopicsWithContentsDocument,
    options,
  )
}
export function usePremiumTopicsWithContentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IPremiumTopicsWithContentsQuery,
    IPremiumTopicsWithContentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IPremiumTopicsWithContentsQuery, IPremiumTopicsWithContentsQueryVariables>(
    PremiumTopicsWithContentsDocument,
    options,
  )
}
export type PremiumTopicsWithContentsQueryHookResult = ReturnType<typeof usePremiumTopicsWithContentsQuery>
export type PremiumTopicsWithContentsLazyQueryHookResult = ReturnType<typeof usePremiumTopicsWithContentsLazyQuery>
export type PremiumTopicsWithContentsSuspenseQueryHookResult = ReturnType<
  typeof usePremiumTopicsWithContentsSuspenseQuery
>
export type PremiumTopicsWithContentsQueryResult = Apollo.QueryResult<
  IPremiumTopicsWithContentsQuery,
  IPremiumTopicsWithContentsQueryVariables
>
export const PreviewContentBySlugDocument = gql`
  query previewContentBySlug($slug: String!, $secret: String!, $status: String, $documentId: String) {
    previewContentBySlug(slug: $slug, secret: $secret, status: $status, documentId: $documentId) {
      isInvited
      resourcePublishedAt
      vendorSelfContent
      isUserVendor
      includeInKnowHow
      includeInLegalTechForLawyers
      includeInVendorContents
      isFreeArticle
      freeArticleLeft
      content {
        id
        attributes {
          ...contentData
        }
        __typename
      }
      __typename
    }
  }
  ${ContentDataFragmentDoc}
`

/**
 * __usePreviewContentBySlugQuery__
 *
 * To run a query within a React component, call `usePreviewContentBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewContentBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewContentBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      secret: // value for 'secret'
 *      status: // value for 'status'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function usePreviewContentBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<IPreviewContentBySlugQuery, IPreviewContentBySlugQueryVariables> &
    ({ variables: IPreviewContentBySlugQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IPreviewContentBySlugQuery, IPreviewContentBySlugQueryVariables>(
    PreviewContentBySlugDocument,
    options,
  )
}
export function usePreviewContentBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IPreviewContentBySlugQuery, IPreviewContentBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IPreviewContentBySlugQuery, IPreviewContentBySlugQueryVariables>(
    PreviewContentBySlugDocument,
    options,
  )
}
export function usePreviewContentBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IPreviewContentBySlugQuery, IPreviewContentBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IPreviewContentBySlugQuery, IPreviewContentBySlugQueryVariables>(
    PreviewContentBySlugDocument,
    options,
  )
}
export type PreviewContentBySlugQueryHookResult = ReturnType<typeof usePreviewContentBySlugQuery>
export type PreviewContentBySlugLazyQueryHookResult = ReturnType<typeof usePreviewContentBySlugLazyQuery>
export type PreviewContentBySlugSuspenseQueryHookResult = ReturnType<typeof usePreviewContentBySlugSuspenseQuery>
export type PreviewContentBySlugQueryResult = Apollo.QueryResult<
  IPreviewContentBySlugQuery,
  IPreviewContentBySlugQueryVariables
>
export const ProductBySlugDocument = gql`
  query productBySlug($slug: String!, $includeIlta: Boolean!) {
    solutions(filters: { type: { eq: "Product" }, or: [{ slug: { eq: $slug } }, { oldSlug: { contains: $slug } }] }) {
      ...productSolutionData
    }
  }
  ${ProductSolutionDataFragmentDoc}
`

/**
 * __useProductBySlugQuery__
 *
 * To run a query within a React component, call `useProductBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      includeIlta: // value for 'includeIlta'
 *   },
 * });
 */
export function useProductBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<IProductBySlugQuery, IProductBySlugQueryVariables> &
    ({ variables: IProductBySlugQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IProductBySlugQuery, IProductBySlugQueryVariables>(ProductBySlugDocument, options)
}
export function useProductBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IProductBySlugQuery, IProductBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IProductBySlugQuery, IProductBySlugQueryVariables>(ProductBySlugDocument, options)
}
export function useProductBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IProductBySlugQuery, IProductBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IProductBySlugQuery, IProductBySlugQueryVariables>(ProductBySlugDocument, options)
}
export type ProductBySlugQueryHookResult = ReturnType<typeof useProductBySlugQuery>
export type ProductBySlugLazyQueryHookResult = ReturnType<typeof useProductBySlugLazyQuery>
export type ProductBySlugSuspenseQueryHookResult = ReturnType<typeof useProductBySlugSuspenseQuery>
export type ProductBySlugQueryResult = Apollo.QueryResult<IProductBySlugQuery, IProductBySlugQueryVariables>
export const PublishedVendorByDocumentIdDocument = gql`
  query publishedVendorByDocumentId($documentId: ID!) {
    vendor(documentId: $documentId, status: PUBLISHED) {
      documentId
      publishedAt
      users {
        external_id
      }
    }
  }
`

/**
 * __usePublishedVendorByDocumentIdQuery__
 *
 * To run a query within a React component, call `usePublishedVendorByDocumentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishedVendorByDocumentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishedVendorByDocumentIdQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function usePublishedVendorByDocumentIdQuery(
  baseOptions: Apollo.QueryHookOptions<IPublishedVendorByDocumentIdQuery, IPublishedVendorByDocumentIdQueryVariables> &
    ({ variables: IPublishedVendorByDocumentIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IPublishedVendorByDocumentIdQuery, IPublishedVendorByDocumentIdQueryVariables>(
    PublishedVendorByDocumentIdDocument,
    options,
  )
}
export function usePublishedVendorByDocumentIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IPublishedVendorByDocumentIdQuery,
    IPublishedVendorByDocumentIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IPublishedVendorByDocumentIdQuery, IPublishedVendorByDocumentIdQueryVariables>(
    PublishedVendorByDocumentIdDocument,
    options,
  )
}
export function usePublishedVendorByDocumentIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IPublishedVendorByDocumentIdQuery,
    IPublishedVendorByDocumentIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IPublishedVendorByDocumentIdQuery, IPublishedVendorByDocumentIdQueryVariables>(
    PublishedVendorByDocumentIdDocument,
    options,
  )
}
export type PublishedVendorByDocumentIdQueryHookResult = ReturnType<typeof usePublishedVendorByDocumentIdQuery>
export type PublishedVendorByDocumentIdLazyQueryHookResult = ReturnType<typeof usePublishedVendorByDocumentIdLazyQuery>
export type PublishedVendorByDocumentIdSuspenseQueryHookResult = ReturnType<
  typeof usePublishedVendorByDocumentIdSuspenseQuery
>
export type PublishedVendorByDocumentIdQueryResult = Apollo.QueryResult<
  IPublishedVendorByDocumentIdQuery,
  IPublishedVendorByDocumentIdQueryVariables
>
export const UpdateAskAiLogRatingDocument = gql`
  mutation UpdateAskAILogRating($data: inputRatingData!) {
    updateAskAILogRating(data: $data) {
      success
      message
    }
  }
`
export type IUpdateAskAiLogRatingMutationFn = Apollo.MutationFunction<
  IUpdateAskAiLogRatingMutation,
  IUpdateAskAiLogRatingMutationVariables
>

/**
 * __useUpdateAskAiLogRatingMutation__
 *
 * To run a mutation, you first call `useUpdateAskAiLogRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAskAiLogRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAskAiLogRatingMutation, { data, loading, error }] = useUpdateAskAiLogRatingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAskAiLogRatingMutation(
  baseOptions?: Apollo.MutationHookOptions<IUpdateAskAiLogRatingMutation, IUpdateAskAiLogRatingMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateAskAiLogRatingMutation, IUpdateAskAiLogRatingMutationVariables>(
    UpdateAskAiLogRatingDocument,
    options,
  )
}
export type UpdateAskAiLogRatingMutationHookResult = ReturnType<typeof useUpdateAskAiLogRatingMutation>
export type UpdateAskAiLogRatingMutationResult = Apollo.MutationResult<IUpdateAskAiLogRatingMutation>
export type UpdateAskAiLogRatingMutationOptions = Apollo.BaseMutationOptions<
  IUpdateAskAiLogRatingMutation,
  IUpdateAskAiLogRatingMutationVariables
>
export const RegisterDocument = gql`
  mutation register($input: UsersPermissionsRegisterInput!) {
    register(input: $input) {
      jwt
      user {
        id
        username
        email
      }
    }
  }
`
export type IRegisterMutationFn = Apollo.MutationFunction<IRegisterMutation, IRegisterMutationVariables>

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<IRegisterMutation, IRegisterMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IRegisterMutation, IRegisterMutationVariables>(RegisterDocument, options)
}
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>
export type RegisterMutationResult = Apollo.MutationResult<IRegisterMutation>
export type RegisterMutationOptions = Apollo.BaseMutationOptions<IRegisterMutation, IRegisterMutationVariables>
export const RegisterPremiumOrganizationDocument = gql`
  mutation registerPremiumOrganization(
    $name: String!
    $registrationContact: [ComponentRegistrationContactRegistrationContactInput!]!
    $billingAddress: ComponentBillingAddressBillingAddressInput!
    $emailDomain: String!
    $pricingPlan: ID!
    $gReCaptchaToken: String
    $leadSource: String
    $shouldSendResponse: Boolean!
  ) {
    registerPremiumOrganization(
      data: {
        name: $name
        registrationContact: $registrationContact
        billingAddress: $billingAddress
        emailDomain: $emailDomain
        pricingPlan: $pricingPlan
        gReCaptchaToken: $gReCaptchaToken
        leadSource: $leadSource
        shouldSendResponse: $shouldSendResponse
      }
    ) {
      name
    }
  }
`
export type IRegisterPremiumOrganizationMutationFn = Apollo.MutationFunction<
  IRegisterPremiumOrganizationMutation,
  IRegisterPremiumOrganizationMutationVariables
>

/**
 * __useRegisterPremiumOrganizationMutation__
 *
 * To run a mutation, you first call `useRegisterPremiumOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterPremiumOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerPremiumOrganizationMutation, { data, loading, error }] = useRegisterPremiumOrganizationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      registrationContact: // value for 'registrationContact'
 *      billingAddress: // value for 'billingAddress'
 *      emailDomain: // value for 'emailDomain'
 *      pricingPlan: // value for 'pricingPlan'
 *      gReCaptchaToken: // value for 'gReCaptchaToken'
 *      leadSource: // value for 'leadSource'
 *      shouldSendResponse: // value for 'shouldSendResponse'
 *   },
 * });
 */
export function useRegisterPremiumOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IRegisterPremiumOrganizationMutation,
    IRegisterPremiumOrganizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IRegisterPremiumOrganizationMutation, IRegisterPremiumOrganizationMutationVariables>(
    RegisterPremiumOrganizationDocument,
    options,
  )
}
export type RegisterPremiumOrganizationMutationHookResult = ReturnType<typeof useRegisterPremiumOrganizationMutation>
export type RegisterPremiumOrganizationMutationResult = Apollo.MutationResult<IRegisterPremiumOrganizationMutation>
export type RegisterPremiumOrganizationMutationOptions = Apollo.BaseMutationOptions<
  IRegisterPremiumOrganizationMutation,
  IRegisterPremiumOrganizationMutationVariables
>
export const RegisterVendorOrganizationDocument = gql`
  mutation registerVendorOrganization(
    $name: String!
    $companySize: String!
    $registrationContact: [ComponentRegistrationContactRegistrationContactInput!]!
    $gReCaptchaToken: String
    $shouldSendResponse: Boolean!
  ) {
    registerVendorOrganization(
      data: {
        name: $name
        companySize: $companySize
        registrationContact: $registrationContact
        gReCaptchaToken: $gReCaptchaToken
        shouldSendResponse: $shouldSendResponse
      }
    ) {
      name
    }
  }
`
export type IRegisterVendorOrganizationMutationFn = Apollo.MutationFunction<
  IRegisterVendorOrganizationMutation,
  IRegisterVendorOrganizationMutationVariables
>

/**
 * __useRegisterVendorOrganizationMutation__
 *
 * To run a mutation, you first call `useRegisterVendorOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterVendorOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerVendorOrganizationMutation, { data, loading, error }] = useRegisterVendorOrganizationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      companySize: // value for 'companySize'
 *      registrationContact: // value for 'registrationContact'
 *      gReCaptchaToken: // value for 'gReCaptchaToken'
 *      shouldSendResponse: // value for 'shouldSendResponse'
 *   },
 * });
 */
export function useRegisterVendorOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IRegisterVendorOrganizationMutation,
    IRegisterVendorOrganizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IRegisterVendorOrganizationMutation, IRegisterVendorOrganizationMutationVariables>(
    RegisterVendorOrganizationDocument,
    options,
  )
}
export type RegisterVendorOrganizationMutationHookResult = ReturnType<typeof useRegisterVendorOrganizationMutation>
export type RegisterVendorOrganizationMutationResult = Apollo.MutationResult<IRegisterVendorOrganizationMutation>
export type RegisterVendorOrganizationMutationOptions = Apollo.BaseMutationOptions<
  IRegisterVendorOrganizationMutation,
  IRegisterVendorOrganizationMutationVariables
>
export const RelatedArticlesOfContentDocument = gql`
  query relatedArticlesOfContent($slug: String!) {
    relatedArticlesOfContent(slug: $slug) {
      success
      data {
        total
        contents {
          ...contentItem
        }
      }
    }
  }
  ${ContentItemFragmentDoc}
`

/**
 * __useRelatedArticlesOfContentQuery__
 *
 * To run a query within a React component, call `useRelatedArticlesOfContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedArticlesOfContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedArticlesOfContentQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useRelatedArticlesOfContentQuery(
  baseOptions: Apollo.QueryHookOptions<IRelatedArticlesOfContentQuery, IRelatedArticlesOfContentQueryVariables> &
    ({ variables: IRelatedArticlesOfContentQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IRelatedArticlesOfContentQuery, IRelatedArticlesOfContentQueryVariables>(
    RelatedArticlesOfContentDocument,
    options,
  )
}
export function useRelatedArticlesOfContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IRelatedArticlesOfContentQuery, IRelatedArticlesOfContentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IRelatedArticlesOfContentQuery, IRelatedArticlesOfContentQueryVariables>(
    RelatedArticlesOfContentDocument,
    options,
  )
}
export function useRelatedArticlesOfContentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IRelatedArticlesOfContentQuery,
    IRelatedArticlesOfContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IRelatedArticlesOfContentQuery, IRelatedArticlesOfContentQueryVariables>(
    RelatedArticlesOfContentDocument,
    options,
  )
}
export type RelatedArticlesOfContentQueryHookResult = ReturnType<typeof useRelatedArticlesOfContentQuery>
export type RelatedArticlesOfContentLazyQueryHookResult = ReturnType<typeof useRelatedArticlesOfContentLazyQuery>
export type RelatedArticlesOfContentSuspenseQueryHookResult = ReturnType<
  typeof useRelatedArticlesOfContentSuspenseQuery
>
export type RelatedArticlesOfContentQueryResult = Apollo.QueryResult<
  IRelatedArticlesOfContentQuery,
  IRelatedArticlesOfContentQueryVariables
>
export const RelatedContentBySolutionDocument = gql`
  query relatedContentBySolution($query: JSON) {
    relatedContentBySolution(query: $query) {
      success
      data {
        contents {
          ...contentItem
        }
        total
      }
    }
  }
  ${ContentItemFragmentDoc}
`

/**
 * __useRelatedContentBySolutionQuery__
 *
 * To run a query within a React component, call `useRelatedContentBySolutionQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedContentBySolutionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedContentBySolutionQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useRelatedContentBySolutionQuery(
  baseOptions?: Apollo.QueryHookOptions<IRelatedContentBySolutionQuery, IRelatedContentBySolutionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IRelatedContentBySolutionQuery, IRelatedContentBySolutionQueryVariables>(
    RelatedContentBySolutionDocument,
    options,
  )
}
export function useRelatedContentBySolutionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IRelatedContentBySolutionQuery, IRelatedContentBySolutionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IRelatedContentBySolutionQuery, IRelatedContentBySolutionQueryVariables>(
    RelatedContentBySolutionDocument,
    options,
  )
}
export function useRelatedContentBySolutionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IRelatedContentBySolutionQuery,
    IRelatedContentBySolutionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IRelatedContentBySolutionQuery, IRelatedContentBySolutionQueryVariables>(
    RelatedContentBySolutionDocument,
    options,
  )
}
export type RelatedContentBySolutionQueryHookResult = ReturnType<typeof useRelatedContentBySolutionQuery>
export type RelatedContentBySolutionLazyQueryHookResult = ReturnType<typeof useRelatedContentBySolutionLazyQuery>
export type RelatedContentBySolutionSuspenseQueryHookResult = ReturnType<
  typeof useRelatedContentBySolutionSuspenseQuery
>
export type RelatedContentBySolutionQueryResult = Apollo.QueryResult<
  IRelatedContentBySolutionQuery,
  IRelatedContentBySolutionQueryVariables
>
export const RemovePortfolioTagFromSolutionDocument = gql`
  mutation removePortfolioTagFromSolution($tagDocumentId: ID!, $solutionId: Int, $solutionDocumentId: ID) {
    removePortfolioTagFromSolution(
      tagDocumentId: $tagDocumentId
      solutionId: $solutionId
      solutionDocumentId: $solutionDocumentId
    )
  }
`
export type IRemovePortfolioTagFromSolutionMutationFn = Apollo.MutationFunction<
  IRemovePortfolioTagFromSolutionMutation,
  IRemovePortfolioTagFromSolutionMutationVariables
>

/**
 * __useRemovePortfolioTagFromSolutionMutation__
 *
 * To run a mutation, you first call `useRemovePortfolioTagFromSolutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePortfolioTagFromSolutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePortfolioTagFromSolutionMutation, { data, loading, error }] = useRemovePortfolioTagFromSolutionMutation({
 *   variables: {
 *      tagDocumentId: // value for 'tagDocumentId'
 *      solutionId: // value for 'solutionId'
 *      solutionDocumentId: // value for 'solutionDocumentId'
 *   },
 * });
 */
export function useRemovePortfolioTagFromSolutionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IRemovePortfolioTagFromSolutionMutation,
    IRemovePortfolioTagFromSolutionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IRemovePortfolioTagFromSolutionMutation, IRemovePortfolioTagFromSolutionMutationVariables>(
    RemovePortfolioTagFromSolutionDocument,
    options,
  )
}
export type RemovePortfolioTagFromSolutionMutationHookResult = ReturnType<
  typeof useRemovePortfolioTagFromSolutionMutation
>
export type RemovePortfolioTagFromSolutionMutationResult =
  Apollo.MutationResult<IRemovePortfolioTagFromSolutionMutation>
export type RemovePortfolioTagFromSolutionMutationOptions = Apollo.BaseMutationOptions<
  IRemovePortfolioTagFromSolutionMutation,
  IRemovePortfolioTagFromSolutionMutationVariables
>
export const SearchContentsDocument = gql`
  query searchContents($query: JSON, $gReCaptchaToken: String) {
    contentResults(query: $query, gReCaptchaToken: $gReCaptchaToken) {
      success
      data {
        total
        contents {
          ...contentItem
        }
      }
    }
  }
  ${ContentItemFragmentDoc}
`

/**
 * __useSearchContentsQuery__
 *
 * To run a query within a React component, call `useSearchContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContentsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      gReCaptchaToken: // value for 'gReCaptchaToken'
 *   },
 * });
 */
export function useSearchContentsQuery(
  baseOptions?: Apollo.QueryHookOptions<ISearchContentsQuery, ISearchContentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ISearchContentsQuery, ISearchContentsQueryVariables>(SearchContentsDocument, options)
}
export function useSearchContentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ISearchContentsQuery, ISearchContentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ISearchContentsQuery, ISearchContentsQueryVariables>(SearchContentsDocument, options)
}
export function useSearchContentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ISearchContentsQuery, ISearchContentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ISearchContentsQuery, ISearchContentsQueryVariables>(SearchContentsDocument, options)
}
export type SearchContentsQueryHookResult = ReturnType<typeof useSearchContentsQuery>
export type SearchContentsLazyQueryHookResult = ReturnType<typeof useSearchContentsLazyQuery>
export type SearchContentsSuspenseQueryHookResult = ReturnType<typeof useSearchContentsSuspenseQuery>
export type SearchContentsQueryResult = Apollo.QueryResult<ISearchContentsQuery, ISearchContentsQueryVariables>
export const SearchCustomTagsDocument = gql`
  query searchCustomTags($keyword: String) {
    searchCustomTags(keyword: $keyword) {
      id
      name
      slug
      solutionIds
      solutionDocumentIds
    }
  }
`

/**
 * __useSearchCustomTagsQuery__
 *
 * To run a query within a React component, call `useSearchCustomTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomTagsQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useSearchCustomTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<ISearchCustomTagsQuery, ISearchCustomTagsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ISearchCustomTagsQuery, ISearchCustomTagsQueryVariables>(SearchCustomTagsDocument, options)
}
export function useSearchCustomTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ISearchCustomTagsQuery, ISearchCustomTagsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ISearchCustomTagsQuery, ISearchCustomTagsQueryVariables>(SearchCustomTagsDocument, options)
}
export function useSearchCustomTagsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ISearchCustomTagsQuery, ISearchCustomTagsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ISearchCustomTagsQuery, ISearchCustomTagsQueryVariables>(
    SearchCustomTagsDocument,
    options,
  )
}
export type SearchCustomTagsQueryHookResult = ReturnType<typeof useSearchCustomTagsQuery>
export type SearchCustomTagsLazyQueryHookResult = ReturnType<typeof useSearchCustomTagsLazyQuery>
export type SearchCustomTagsSuspenseQueryHookResult = ReturnType<typeof useSearchCustomTagsSuspenseQuery>
export type SearchCustomTagsQueryResult = Apollo.QueryResult<ISearchCustomTagsQuery, ISearchCustomTagsQueryVariables>
export const SearchEventsDocument = gql`
  query searchEvents($query: JSON) {
    eventResults(query: $query) {
      success
      data {
        total
        events {
          title
          logo {
            url
          }
          description
          date
          updatedAt
          city
          country
          slug
          createdAt
          organizer
          featured
          website
          notes
          durationId {
            name
            days
          }
          formatId {
            name
          }
          recurrenceId {
            name
          }
          features {
            name
          }
        }
      }
    }
  }
`

/**
 * __useSearchEventsQuery__
 *
 * To run a query within a React component, call `useSearchEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEventsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<ISearchEventsQuery, ISearchEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ISearchEventsQuery, ISearchEventsQueryVariables>(SearchEventsDocument, options)
}
export function useSearchEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ISearchEventsQuery, ISearchEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ISearchEventsQuery, ISearchEventsQueryVariables>(SearchEventsDocument, options)
}
export function useSearchEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ISearchEventsQuery, ISearchEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ISearchEventsQuery, ISearchEventsQueryVariables>(SearchEventsDocument, options)
}
export type SearchEventsQueryHookResult = ReturnType<typeof useSearchEventsQuery>
export type SearchEventsLazyQueryHookResult = ReturnType<typeof useSearchEventsLazyQuery>
export type SearchEventsSuspenseQueryHookResult = ReturnType<typeof useSearchEventsSuspenseQuery>
export type SearchEventsQueryResult = Apollo.QueryResult<ISearchEventsQuery, ISearchEventsQueryVariables>
export const SearchGraveyardConsolidationDocument = gql`
  query searchGraveyardConsolidation($query: JSON) {
    searchSolutions(query: $query) {
      total
      solutions {
        ...solutionListItem
      }
    }
  }
  ${SolutionListItemFragmentDoc}
`

/**
 * __useSearchGraveyardConsolidationQuery__
 *
 * To run a query within a React component, call `useSearchGraveyardConsolidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchGraveyardConsolidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchGraveyardConsolidationQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchGraveyardConsolidationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ISearchGraveyardConsolidationQuery,
    ISearchGraveyardConsolidationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ISearchGraveyardConsolidationQuery, ISearchGraveyardConsolidationQueryVariables>(
    SearchGraveyardConsolidationDocument,
    options,
  )
}
export function useSearchGraveyardConsolidationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ISearchGraveyardConsolidationQuery,
    ISearchGraveyardConsolidationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ISearchGraveyardConsolidationQuery, ISearchGraveyardConsolidationQueryVariables>(
    SearchGraveyardConsolidationDocument,
    options,
  )
}
export function useSearchGraveyardConsolidationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ISearchGraveyardConsolidationQuery,
    ISearchGraveyardConsolidationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ISearchGraveyardConsolidationQuery, ISearchGraveyardConsolidationQueryVariables>(
    SearchGraveyardConsolidationDocument,
    options,
  )
}
export type SearchGraveyardConsolidationQueryHookResult = ReturnType<typeof useSearchGraveyardConsolidationQuery>
export type SearchGraveyardConsolidationLazyQueryHookResult = ReturnType<
  typeof useSearchGraveyardConsolidationLazyQuery
>
export type SearchGraveyardConsolidationSuspenseQueryHookResult = ReturnType<
  typeof useSearchGraveyardConsolidationSuspenseQuery
>
export type SearchGraveyardConsolidationQueryResult = Apollo.QueryResult<
  ISearchGraveyardConsolidationQuery,
  ISearchGraveyardConsolidationQueryVariables
>
export const SearchPortfolioEditorsDocument = gql`
  query SearchPortfolioEditors($keyword: String, $limit: Int) {
    searchSharedPortfolioOrganizationUsers(keyword: $keyword, limit: $limit) {
      users {
        id
        email
        name
      }
    }
  }
`

/**
 * __useSearchPortfolioEditorsQuery__
 *
 * To run a query within a React component, call `useSearchPortfolioEditorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPortfolioEditorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPortfolioEditorsQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchPortfolioEditorsQuery(
  baseOptions?: Apollo.QueryHookOptions<ISearchPortfolioEditorsQuery, ISearchPortfolioEditorsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ISearchPortfolioEditorsQuery, ISearchPortfolioEditorsQueryVariables>(
    SearchPortfolioEditorsDocument,
    options,
  )
}
export function useSearchPortfolioEditorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ISearchPortfolioEditorsQuery, ISearchPortfolioEditorsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ISearchPortfolioEditorsQuery, ISearchPortfolioEditorsQueryVariables>(
    SearchPortfolioEditorsDocument,
    options,
  )
}
export function useSearchPortfolioEditorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ISearchPortfolioEditorsQuery, ISearchPortfolioEditorsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ISearchPortfolioEditorsQuery, ISearchPortfolioEditorsQueryVariables>(
    SearchPortfolioEditorsDocument,
    options,
  )
}
export type SearchPortfolioEditorsQueryHookResult = ReturnType<typeof useSearchPortfolioEditorsQuery>
export type SearchPortfolioEditorsLazyQueryHookResult = ReturnType<typeof useSearchPortfolioEditorsLazyQuery>
export type SearchPortfolioEditorsSuspenseQueryHookResult = ReturnType<typeof useSearchPortfolioEditorsSuspenseQuery>
export type SearchPortfolioEditorsQueryResult = Apollo.QueryResult<
  ISearchPortfolioEditorsQuery,
  ISearchPortfolioEditorsQueryVariables
>
export const SearchSolutionsDocument = gql`
  query searchSolutions($query: JSON) {
    searchSolutions(query: $query) {
      total
      solutions {
        ...solutionListItem
      }
      isFreeSearch
      isFreeSearchLeft
    }
  }
  ${SolutionListItemFragmentDoc}
`

/**
 * __useSearchSolutionsQuery__
 *
 * To run a query within a React component, call `useSearchSolutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSolutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSolutionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchSolutionsQuery(
  baseOptions?: Apollo.QueryHookOptions<ISearchSolutionsQuery, ISearchSolutionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ISearchSolutionsQuery, ISearchSolutionsQueryVariables>(SearchSolutionsDocument, options)
}
export function useSearchSolutionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ISearchSolutionsQuery, ISearchSolutionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ISearchSolutionsQuery, ISearchSolutionsQueryVariables>(SearchSolutionsDocument, options)
}
export function useSearchSolutionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ISearchSolutionsQuery, ISearchSolutionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ISearchSolutionsQuery, ISearchSolutionsQueryVariables>(
    SearchSolutionsDocument,
    options,
  )
}
export type SearchSolutionsQueryHookResult = ReturnType<typeof useSearchSolutionsQuery>
export type SearchSolutionsLazyQueryHookResult = ReturnType<typeof useSearchSolutionsLazyQuery>
export type SearchSolutionsSuspenseQueryHookResult = ReturnType<typeof useSearchSolutionsSuspenseQuery>
export type SearchSolutionsQueryResult = Apollo.QueryResult<ISearchSolutionsQuery, ISearchSolutionsQueryVariables>
export const SearchSubtopicsDocument = gql`
  query searchSubtopics($query: JSON) {
    searchSubtopics(query: $query) {
      total
      subtopics {
        ...subtopicListItem
      }
    }
  }
  ${SubtopicListItemFragmentDoc}
`

/**
 * __useSearchSubtopicsQuery__
 *
 * To run a query within a React component, call `useSearchSubtopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSubtopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSubtopicsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchSubtopicsQuery(
  baseOptions?: Apollo.QueryHookOptions<ISearchSubtopicsQuery, ISearchSubtopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ISearchSubtopicsQuery, ISearchSubtopicsQueryVariables>(SearchSubtopicsDocument, options)
}
export function useSearchSubtopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ISearchSubtopicsQuery, ISearchSubtopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ISearchSubtopicsQuery, ISearchSubtopicsQueryVariables>(SearchSubtopicsDocument, options)
}
export function useSearchSubtopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ISearchSubtopicsQuery, ISearchSubtopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ISearchSubtopicsQuery, ISearchSubtopicsQueryVariables>(
    SearchSubtopicsDocument,
    options,
  )
}
export type SearchSubtopicsQueryHookResult = ReturnType<typeof useSearchSubtopicsQuery>
export type SearchSubtopicsLazyQueryHookResult = ReturnType<typeof useSearchSubtopicsLazyQuery>
export type SearchSubtopicsSuspenseQueryHookResult = ReturnType<typeof useSearchSubtopicsSuspenseQuery>
export type SearchSubtopicsQueryResult = Apollo.QueryResult<ISearchSubtopicsQuery, ISearchSubtopicsQueryVariables>
export const SearchUnfollowedRelatedSubtopicsDocument = gql`
  query searchUnfollowedRelatedSubtopics($query: JSON) {
    searchUnfollowedRelatedSubtopics(query: $query) {
      total
      subtopics {
        documentId
        slug
        name
        topicSlug
        topicName
        isPremium
      }
    }
  }
`

/**
 * __useSearchUnfollowedRelatedSubtopicsQuery__
 *
 * To run a query within a React component, call `useSearchUnfollowedRelatedSubtopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUnfollowedRelatedSubtopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUnfollowedRelatedSubtopicsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchUnfollowedRelatedSubtopicsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ISearchUnfollowedRelatedSubtopicsQuery,
    ISearchUnfollowedRelatedSubtopicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ISearchUnfollowedRelatedSubtopicsQuery, ISearchUnfollowedRelatedSubtopicsQueryVariables>(
    SearchUnfollowedRelatedSubtopicsDocument,
    options,
  )
}
export function useSearchUnfollowedRelatedSubtopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ISearchUnfollowedRelatedSubtopicsQuery,
    ISearchUnfollowedRelatedSubtopicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ISearchUnfollowedRelatedSubtopicsQuery, ISearchUnfollowedRelatedSubtopicsQueryVariables>(
    SearchUnfollowedRelatedSubtopicsDocument,
    options,
  )
}
export function useSearchUnfollowedRelatedSubtopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ISearchUnfollowedRelatedSubtopicsQuery,
    ISearchUnfollowedRelatedSubtopicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ISearchUnfollowedRelatedSubtopicsQuery,
    ISearchUnfollowedRelatedSubtopicsQueryVariables
  >(SearchUnfollowedRelatedSubtopicsDocument, options)
}
export type SearchUnfollowedRelatedSubtopicsQueryHookResult = ReturnType<
  typeof useSearchUnfollowedRelatedSubtopicsQuery
>
export type SearchUnfollowedRelatedSubtopicsLazyQueryHookResult = ReturnType<
  typeof useSearchUnfollowedRelatedSubtopicsLazyQuery
>
export type SearchUnfollowedRelatedSubtopicsSuspenseQueryHookResult = ReturnType<
  typeof useSearchUnfollowedRelatedSubtopicsSuspenseQuery
>
export type SearchUnfollowedRelatedSubtopicsQueryResult = Apollo.QueryResult<
  ISearchUnfollowedRelatedSubtopicsQuery,
  ISearchUnfollowedRelatedSubtopicsQueryVariables
>
export const GetSharedPortfoliosForMyOrganizationDocument = gql`
  query getSharedPortfoliosForMyOrganization(
    $sharedPortfolioId: ID
    $sharedPortfolioSlug: String
    $page: Int
    $pageSize: Int
    $type: String
  ) {
    sharedPortfoliosForMyOrganization(
      sharedPortfolioId: $sharedPortfolioId
      sharedPortfolioSlug: $sharedPortfolioSlug
      page: $page
      pageSize: $pageSize
      type: $type
    ) {
      privateFollowingPortfolio {
        documentId
        name
        slug
      }
      portfolios {
        ...sharedPortfolioEntityItem
      }
      sharedPortfoliosPagination {
        total
        page
        pageSize
        pageCount
      }
    }
  }
  ${SharedPortfolioEntityItemFragmentDoc}
`

/**
 * __useGetSharedPortfoliosForMyOrganizationQuery__
 *
 * To run a query within a React component, call `useGetSharedPortfoliosForMyOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedPortfoliosForMyOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedPortfoliosForMyOrganizationQuery({
 *   variables: {
 *      sharedPortfolioId: // value for 'sharedPortfolioId'
 *      sharedPortfolioSlug: // value for 'sharedPortfolioSlug'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetSharedPortfoliosForMyOrganizationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IGetSharedPortfoliosForMyOrganizationQuery,
    IGetSharedPortfoliosForMyOrganizationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetSharedPortfoliosForMyOrganizationQuery,
    IGetSharedPortfoliosForMyOrganizationQueryVariables
  >(GetSharedPortfoliosForMyOrganizationDocument, options)
}
export function useGetSharedPortfoliosForMyOrganizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetSharedPortfoliosForMyOrganizationQuery,
    IGetSharedPortfoliosForMyOrganizationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetSharedPortfoliosForMyOrganizationQuery,
    IGetSharedPortfoliosForMyOrganizationQueryVariables
  >(GetSharedPortfoliosForMyOrganizationDocument, options)
}
export function useGetSharedPortfoliosForMyOrganizationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IGetSharedPortfoliosForMyOrganizationQuery,
    IGetSharedPortfoliosForMyOrganizationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IGetSharedPortfoliosForMyOrganizationQuery,
    IGetSharedPortfoliosForMyOrganizationQueryVariables
  >(GetSharedPortfoliosForMyOrganizationDocument, options)
}
export type GetSharedPortfoliosForMyOrganizationQueryHookResult = ReturnType<
  typeof useGetSharedPortfoliosForMyOrganizationQuery
>
export type GetSharedPortfoliosForMyOrganizationLazyQueryHookResult = ReturnType<
  typeof useGetSharedPortfoliosForMyOrganizationLazyQuery
>
export type GetSharedPortfoliosForMyOrganizationSuspenseQueryHookResult = ReturnType<
  typeof useGetSharedPortfoliosForMyOrganizationSuspenseQuery
>
export type GetSharedPortfoliosForMyOrganizationQueryResult = Apollo.QueryResult<
  IGetSharedPortfoliosForMyOrganizationQuery,
  IGetSharedPortfoliosForMyOrganizationQueryVariables
>
export const ShowRelatedContentFeatureDocument = gql`
  query showRelatedContentFeature {
    showRelatedContentFeature
  }
`

/**
 * __useShowRelatedContentFeatureQuery__
 *
 * To run a query within a React component, call `useShowRelatedContentFeatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowRelatedContentFeatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowRelatedContentFeatureQuery({
 *   variables: {
 *   },
 * });
 */
export function useShowRelatedContentFeatureQuery(
  baseOptions?: Apollo.QueryHookOptions<IShowRelatedContentFeatureQuery, IShowRelatedContentFeatureQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IShowRelatedContentFeatureQuery, IShowRelatedContentFeatureQueryVariables>(
    ShowRelatedContentFeatureDocument,
    options,
  )
}
export function useShowRelatedContentFeatureLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IShowRelatedContentFeatureQuery, IShowRelatedContentFeatureQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IShowRelatedContentFeatureQuery, IShowRelatedContentFeatureQueryVariables>(
    ShowRelatedContentFeatureDocument,
    options,
  )
}
export function useShowRelatedContentFeatureSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IShowRelatedContentFeatureQuery,
    IShowRelatedContentFeatureQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IShowRelatedContentFeatureQuery, IShowRelatedContentFeatureQueryVariables>(
    ShowRelatedContentFeatureDocument,
    options,
  )
}
export type ShowRelatedContentFeatureQueryHookResult = ReturnType<typeof useShowRelatedContentFeatureQuery>
export type ShowRelatedContentFeatureLazyQueryHookResult = ReturnType<typeof useShowRelatedContentFeatureLazyQuery>
export type ShowRelatedContentFeatureSuspenseQueryHookResult = ReturnType<
  typeof useShowRelatedContentFeatureSuspenseQuery
>
export type ShowRelatedContentFeatureQueryResult = Apollo.QueryResult<
  IShowRelatedContentFeatureQuery,
  IShowRelatedContentFeatureQueryVariables
>
export const SimilarSolutionsDocument = gql`
  query similarSolutions($id: String!, $from: String) {
    similarSolutions(id: $id, from: $from) {
      solutions {
        ...similarSolutionItem
      }
    }
  }
  ${SimilarSolutionItemFragmentDoc}
`

/**
 * __useSimilarSolutionsQuery__
 *
 * To run a query within a React component, call `useSimilarSolutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimilarSolutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimilarSolutionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useSimilarSolutionsQuery(
  baseOptions: Apollo.QueryHookOptions<ISimilarSolutionsQuery, ISimilarSolutionsQueryVariables> &
    ({ variables: ISimilarSolutionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ISimilarSolutionsQuery, ISimilarSolutionsQueryVariables>(SimilarSolutionsDocument, options)
}
export function useSimilarSolutionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ISimilarSolutionsQuery, ISimilarSolutionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ISimilarSolutionsQuery, ISimilarSolutionsQueryVariables>(SimilarSolutionsDocument, options)
}
export function useSimilarSolutionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ISimilarSolutionsQuery, ISimilarSolutionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ISimilarSolutionsQuery, ISimilarSolutionsQueryVariables>(
    SimilarSolutionsDocument,
    options,
  )
}
export type SimilarSolutionsQueryHookResult = ReturnType<typeof useSimilarSolutionsQuery>
export type SimilarSolutionsLazyQueryHookResult = ReturnType<typeof useSimilarSolutionsLazyQuery>
export type SimilarSolutionsSuspenseQueryHookResult = ReturnType<typeof useSimilarSolutionsSuspenseQuery>
export type SimilarSolutionsQueryResult = Apollo.QueryResult<ISimilarSolutionsQuery, ISimilarSolutionsQueryVariables>
export const AiSmartSearchDocument = gql`
  query aiSmartSearch($keyword: String!, $accessFreeASKAI: Boolean, $uniqueAddress: String, $checkCount: Boolean) {
    aiSmartSearch(
      keyword: $keyword
      accessFreeASKAI: $accessFreeASKAI
      uniqueAddress: $uniqueAddress
      checkCount: $checkCount
    ) {
      success
      isFreeASKAI
      isFreeASKAILeft
      data {
        ...smartsearchItem
      }
    }
  }
  ${SmartsearchItemFragmentDoc}
`

/**
 * __useAiSmartSearchQuery__
 *
 * To run a query within a React component, call `useAiSmartSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiSmartSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiSmartSearchQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      accessFreeASKAI: // value for 'accessFreeASKAI'
 *      uniqueAddress: // value for 'uniqueAddress'
 *      checkCount: // value for 'checkCount'
 *   },
 * });
 */
export function useAiSmartSearchQuery(
  baseOptions: Apollo.QueryHookOptions<IAiSmartSearchQuery, IAiSmartSearchQueryVariables> &
    ({ variables: IAiSmartSearchQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAiSmartSearchQuery, IAiSmartSearchQueryVariables>(AiSmartSearchDocument, options)
}
export function useAiSmartSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAiSmartSearchQuery, IAiSmartSearchQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAiSmartSearchQuery, IAiSmartSearchQueryVariables>(AiSmartSearchDocument, options)
}
export function useAiSmartSearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAiSmartSearchQuery, IAiSmartSearchQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAiSmartSearchQuery, IAiSmartSearchQueryVariables>(AiSmartSearchDocument, options)
}
export type AiSmartSearchQueryHookResult = ReturnType<typeof useAiSmartSearchQuery>
export type AiSmartSearchLazyQueryHookResult = ReturnType<typeof useAiSmartSearchLazyQuery>
export type AiSmartSearchSuspenseQueryHookResult = ReturnType<typeof useAiSmartSearchSuspenseQuery>
export type AiSmartSearchQueryResult = Apollo.QueryResult<IAiSmartSearchQuery, IAiSmartSearchQueryVariables>
export const SolutionRequestsBySulgDocument = gql`
  query solutionRequestsBySulg($slug: String!, $status: PublicationStatus = DRAFT) {
    solutionRequests(status: $status, filters: { slug: { eq: $slug } }) {
      documentId
      type
      topics {
        ...solutionTopic
      }
      productData {
        tool
        name
        audiences {
          ...solutionAudience
        }
        attributes {
          ...solutionAttribute
        }
        integrations {
          ...solutionIntegration
        }
        fundingAmount
        fundingInfo
        practiceAreas {
          ...solutionPracticeArea
        }
        typeOfUser {
          ...solutionTypeOfUser
        }
        enhancedListingData {
          ...solutionRequestEnhancedListingData
        }
        valueProposition
        security {
          documentId
          name
        }
        deployments {
          ...solutionDeployment
        }
        dataHosting {
          documentId
          name
        }
      }
      alspData {
        name
        serviceName
        size
        partners
        fundingAmount
        fundingInfo
        valueProposition
        security {
          documentId
          name
        }
        audiences {
          ...solutionAudience
        }
        enhancedListingData {
          ...alspSolutionEnhancedListingData
        }
      }
      consultantData {
        name
        serviceName
        size
        partners
        audiences {
          ...solutionAudience
        }
        integrations {
          ...solutionIntegration
        }
        practiceAreas {
          ...solutionPracticeArea
        }
        typeOfUser {
          ...solutionTypeOfUser
        }
        fundingInfo
        fundingAmount
        valueProposition
        security {
          id
          name
        }
        audiences {
          ...solutionAudience
        }
        valueProposition
        enhancedListingData {
          ...consultancySolutionEnhancedListingData
        }
      }
      founders {
        name
        externalLink
        title
        avatar {
          id
          url
        }
      }
      subTopics {
        ...solutionSubTopic
      }
      logo {
        ...solutionLogo
      }
      website
      linkedin
      twitter
      slug
      shortDescription
      longDescription
      descOtherExistingCustomer
      descOtherIntegration
      offices {
        ...solutionOffice
      }
      hqs {
        ...solutionHq
      }
      regionsServed {
        ...solutionRegionsServed
      }
      languages {
        ...solutionLanguage
      }
      articles {
        ...solutionArticle
      }
      vendorResources {
        ...solutionVendorResource
      }
      features {
        ...solutionFeature
      }
      existingCustomers {
        ...solutionExistingCustomer
      }
      yearFounded
      createdAt
      publishedAt
      announcement {
        documentId
        announcement
        optionalLink
        publishedAt
      }
    }
  }
  ${SolutionTopicFragmentDoc}
  ${SolutionAudienceFragmentDoc}
  ${SolutionAttributeFragmentDoc}
  ${SolutionIntegrationFragmentDoc}
  ${SolutionPracticeAreaFragmentDoc}
  ${SolutionTypeOfUserFragmentDoc}
  ${SolutionRequestEnhancedListingDataFragmentDoc}
  ${SolutionDeploymentFragmentDoc}
  ${AlspSolutionEnhancedListingDataFragmentDoc}
  ${ConsultancySolutionEnhancedListingDataFragmentDoc}
  ${SolutionSubTopicFragmentDoc}
  ${SolutionLogoFragmentDoc}
  ${SolutionOfficeFragmentDoc}
  ${SolutionHqFragmentDoc}
  ${SolutionRegionsServedFragmentDoc}
  ${SolutionLanguageFragmentDoc}
  ${SolutionArticleFragmentDoc}
  ${SolutionVendorResourceFragmentDoc}
  ${SolutionFeatureFragmentDoc}
  ${SolutionExistingCustomerFragmentDoc}
`

/**
 * __useSolutionRequestsBySulgQuery__
 *
 * To run a query within a React component, call `useSolutionRequestsBySulgQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolutionRequestsBySulgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolutionRequestsBySulgQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSolutionRequestsBySulgQuery(
  baseOptions: Apollo.QueryHookOptions<ISolutionRequestsBySulgQuery, ISolutionRequestsBySulgQueryVariables> &
    ({ variables: ISolutionRequestsBySulgQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ISolutionRequestsBySulgQuery, ISolutionRequestsBySulgQueryVariables>(
    SolutionRequestsBySulgDocument,
    options,
  )
}
export function useSolutionRequestsBySulgLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ISolutionRequestsBySulgQuery, ISolutionRequestsBySulgQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ISolutionRequestsBySulgQuery, ISolutionRequestsBySulgQueryVariables>(
    SolutionRequestsBySulgDocument,
    options,
  )
}
export function useSolutionRequestsBySulgSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ISolutionRequestsBySulgQuery, ISolutionRequestsBySulgQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ISolutionRequestsBySulgQuery, ISolutionRequestsBySulgQueryVariables>(
    SolutionRequestsBySulgDocument,
    options,
  )
}
export type SolutionRequestsBySulgQueryHookResult = ReturnType<typeof useSolutionRequestsBySulgQuery>
export type SolutionRequestsBySulgLazyQueryHookResult = ReturnType<typeof useSolutionRequestsBySulgLazyQuery>
export type SolutionRequestsBySulgSuspenseQueryHookResult = ReturnType<typeof useSolutionRequestsBySulgSuspenseQuery>
export type SolutionRequestsBySulgQueryResult = Apollo.QueryResult<
  ISolutionRequestsBySulgQuery,
  ISolutionRequestsBySulgQueryVariables
>
export const SolutionVendorBySlugDocument = gql`
  query solutionVendorBySlug($slug: String!) {
    solutions(filters: { slug: { eq: $slug } }) {
      documentId
      slug
      vendor {
        users {
          external_id
        }
      }
    }
  }
`

/**
 * __useSolutionVendorBySlugQuery__
 *
 * To run a query within a React component, call `useSolutionVendorBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolutionVendorBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolutionVendorBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSolutionVendorBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<ISolutionVendorBySlugQuery, ISolutionVendorBySlugQueryVariables> &
    ({ variables: ISolutionVendorBySlugQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ISolutionVendorBySlugQuery, ISolutionVendorBySlugQueryVariables>(
    SolutionVendorBySlugDocument,
    options,
  )
}
export function useSolutionVendorBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ISolutionVendorBySlugQuery, ISolutionVendorBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ISolutionVendorBySlugQuery, ISolutionVendorBySlugQueryVariables>(
    SolutionVendorBySlugDocument,
    options,
  )
}
export function useSolutionVendorBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ISolutionVendorBySlugQuery, ISolutionVendorBySlugQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ISolutionVendorBySlugQuery, ISolutionVendorBySlugQueryVariables>(
    SolutionVendorBySlugDocument,
    options,
  )
}
export type SolutionVendorBySlugQueryHookResult = ReturnType<typeof useSolutionVendorBySlugQuery>
export type SolutionVendorBySlugLazyQueryHookResult = ReturnType<typeof useSolutionVendorBySlugLazyQuery>
export type SolutionVendorBySlugSuspenseQueryHookResult = ReturnType<typeof useSolutionVendorBySlugSuspenseQuery>
export type SolutionVendorBySlugQueryResult = Apollo.QueryResult<
  ISolutionVendorBySlugQuery,
  ISolutionVendorBySlugQueryVariables
>
export const SubmitEnhancedRequestDocument = gql`
  mutation submitEnhancedRequest($solution_id: String!) {
    submitEnhancedRequest(data: { solution_id: $solution_id })
  }
`
export type ISubmitEnhancedRequestMutationFn = Apollo.MutationFunction<
  ISubmitEnhancedRequestMutation,
  ISubmitEnhancedRequestMutationVariables
>

/**
 * __useSubmitEnhancedRequestMutation__
 *
 * To run a mutation, you first call `useSubmitEnhancedRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitEnhancedRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitEnhancedRequestMutation, { data, loading, error }] = useSubmitEnhancedRequestMutation({
 *   variables: {
 *      solution_id: // value for 'solution_id'
 *   },
 * });
 */
export function useSubmitEnhancedRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<ISubmitEnhancedRequestMutation, ISubmitEnhancedRequestMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ISubmitEnhancedRequestMutation, ISubmitEnhancedRequestMutationVariables>(
    SubmitEnhancedRequestDocument,
    options,
  )
}
export type SubmitEnhancedRequestMutationHookResult = ReturnType<typeof useSubmitEnhancedRequestMutation>
export type SubmitEnhancedRequestMutationResult = Apollo.MutationResult<ISubmitEnhancedRequestMutation>
export type SubmitEnhancedRequestMutationOptions = Apollo.BaseMutationOptions<
  ISubmitEnhancedRequestMutation,
  ISubmitEnhancedRequestMutationVariables
>
export const SubmitNewsletterSubscriptionDocument = gql`
  mutation submitNewsletterSubscription($data: NewsletterSubscriptionInput!) {
    submitNewsletterSubscription(data: $data)
  }
`
export type ISubmitNewsletterSubscriptionMutationFn = Apollo.MutationFunction<
  ISubmitNewsletterSubscriptionMutation,
  ISubmitNewsletterSubscriptionMutationVariables
>

/**
 * __useSubmitNewsletterSubscriptionMutation__
 *
 * To run a mutation, you first call `useSubmitNewsletterSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitNewsletterSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitNewsletterSubscriptionMutation, { data, loading, error }] = useSubmitNewsletterSubscriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSubmitNewsletterSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISubmitNewsletterSubscriptionMutation,
    ISubmitNewsletterSubscriptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ISubmitNewsletterSubscriptionMutation, ISubmitNewsletterSubscriptionMutationVariables>(
    SubmitNewsletterSubscriptionDocument,
    options,
  )
}
export type SubmitNewsletterSubscriptionMutationHookResult = ReturnType<typeof useSubmitNewsletterSubscriptionMutation>
export type SubmitNewsletterSubscriptionMutationResult = Apollo.MutationResult<ISubmitNewsletterSubscriptionMutation>
export type SubmitNewsletterSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  ISubmitNewsletterSubscriptionMutation,
  ISubmitNewsletterSubscriptionMutationVariables
>
export const SubmitReviewDocument = gql`
  mutation submitReview($data: ReviewInput!) {
    submitReview(data: $data)
  }
`
export type ISubmitReviewMutationFn = Apollo.MutationFunction<ISubmitReviewMutation, ISubmitReviewMutationVariables>

/**
 * __useSubmitReviewMutation__
 *
 * To run a mutation, you first call `useSubmitReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitReviewMutation, { data, loading, error }] = useSubmitReviewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSubmitReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<ISubmitReviewMutation, ISubmitReviewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ISubmitReviewMutation, ISubmitReviewMutationVariables>(SubmitReviewDocument, options)
}
export type SubmitReviewMutationHookResult = ReturnType<typeof useSubmitReviewMutation>
export type SubmitReviewMutationResult = Apollo.MutationResult<ISubmitReviewMutation>
export type SubmitReviewMutationOptions = Apollo.BaseMutationOptions<
  ISubmitReviewMutation,
  ISubmitReviewMutationVariables
>
export const TrendingContentsDocument = gql`
  query trendingContents($audience: String!) {
    trendingContents(audience: $audience) {
      id
      attributes {
        ...contentListItem
      }
    }
  }
  ${ContentListItemFragmentDoc}
`

/**
 * __useTrendingContentsQuery__
 *
 * To run a query within a React component, call `useTrendingContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrendingContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrendingContentsQuery({
 *   variables: {
 *      audience: // value for 'audience'
 *   },
 * });
 */
export function useTrendingContentsQuery(
  baseOptions: Apollo.QueryHookOptions<ITrendingContentsQuery, ITrendingContentsQueryVariables> &
    ({ variables: ITrendingContentsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ITrendingContentsQuery, ITrendingContentsQueryVariables>(TrendingContentsDocument, options)
}
export function useTrendingContentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ITrendingContentsQuery, ITrendingContentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ITrendingContentsQuery, ITrendingContentsQueryVariables>(TrendingContentsDocument, options)
}
export function useTrendingContentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ITrendingContentsQuery, ITrendingContentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ITrendingContentsQuery, ITrendingContentsQueryVariables>(
    TrendingContentsDocument,
    options,
  )
}
export type TrendingContentsQueryHookResult = ReturnType<typeof useTrendingContentsQuery>
export type TrendingContentsLazyQueryHookResult = ReturnType<typeof useTrendingContentsLazyQuery>
export type TrendingContentsSuspenseQueryHookResult = ReturnType<typeof useTrendingContentsSuspenseQuery>
export type TrendingContentsQueryResult = Apollo.QueryResult<ITrendingContentsQuery, ITrendingContentsQueryVariables>
export const UpdateAnnouncementDocument = gql`
  mutation updateAnnouncement($documentId: ID!, $data: AnnouncementInput!, $status: PublicationStatus) {
    updateAnnouncement(status: $status, documentId: $documentId, data: $data) {
      documentId
      announcement
      optionalLink
      updatedAt
    }
  }
`
export type IUpdateAnnouncementMutationFn = Apollo.MutationFunction<
  IUpdateAnnouncementMutation,
  IUpdateAnnouncementMutationVariables
>

/**
 * __useUpdateAnnouncementMutation__
 *
 * To run a mutation, you first call `useUpdateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnnouncementMutation, { data, loading, error }] = useUpdateAnnouncementMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      data: // value for 'data'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateAnnouncementMutation(
  baseOptions?: Apollo.MutationHookOptions<IUpdateAnnouncementMutation, IUpdateAnnouncementMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateAnnouncementMutation, IUpdateAnnouncementMutationVariables>(
    UpdateAnnouncementDocument,
    options,
  )
}
export type UpdateAnnouncementMutationHookResult = ReturnType<typeof useUpdateAnnouncementMutation>
export type UpdateAnnouncementMutationResult = Apollo.MutationResult<IUpdateAnnouncementMutation>
export type UpdateAnnouncementMutationOptions = Apollo.BaseMutationOptions<
  IUpdateAnnouncementMutation,
  IUpdateAnnouncementMutationVariables
>
export const UpdateSharedPortfolioMembersDocument = gql`
  mutation UpdateSharedPortfolioMembers(
    $sharedPortfolioId: ID!
    $members: [SharedPortfolioMemberInput!]!
    $name: String
  ) {
    updateSharedPortfolioMembers(sharedPortfolioId: $sharedPortfolioId, members: $members, name: $name) {
      id
      attributes {
        documentId
        name
        slug
      }
    }
  }
`
export type IUpdateSharedPortfolioMembersMutationFn = Apollo.MutationFunction<
  IUpdateSharedPortfolioMembersMutation,
  IUpdateSharedPortfolioMembersMutationVariables
>

/**
 * __useUpdateSharedPortfolioMembersMutation__
 *
 * To run a mutation, you first call `useUpdateSharedPortfolioMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSharedPortfolioMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSharedPortfolioMembersMutation, { data, loading, error }] = useUpdateSharedPortfolioMembersMutation({
 *   variables: {
 *      sharedPortfolioId: // value for 'sharedPortfolioId'
 *      members: // value for 'members'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateSharedPortfolioMembersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateSharedPortfolioMembersMutation,
    IUpdateSharedPortfolioMembersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateSharedPortfolioMembersMutation, IUpdateSharedPortfolioMembersMutationVariables>(
    UpdateSharedPortfolioMembersDocument,
    options,
  )
}
export type UpdateSharedPortfolioMembersMutationHookResult = ReturnType<typeof useUpdateSharedPortfolioMembersMutation>
export type UpdateSharedPortfolioMembersMutationResult = Apollo.MutationResult<IUpdateSharedPortfolioMembersMutation>
export type UpdateSharedPortfolioMembersMutationOptions = Apollo.BaseMutationOptions<
  IUpdateSharedPortfolioMembersMutation,
  IUpdateSharedPortfolioMembersMutationVariables
>
export const UpdateSharedPortfolioSolutionDocument = gql`
  mutation UpdateSharedPortfolioSolution($id: ID!, $category: String, $followingSolutionNote: String) {
    updateSharedPortfolioSolution(id: $id, category: $category, followingSolutionNote: $followingSolutionNote) {
      id
      attributes {
        documentId
        category
        followingSolutionNote
        createdAt
        updatedAt
        solution {
          documentId
          displayName
        }
        sharedPortfolio {
          documentId
          name
        }
        lastModifiedByUser {
          documentId
          username
          email
        }
      }
    }
  }
`
export type IUpdateSharedPortfolioSolutionMutationFn = Apollo.MutationFunction<
  IUpdateSharedPortfolioSolutionMutation,
  IUpdateSharedPortfolioSolutionMutationVariables
>

/**
 * __useUpdateSharedPortfolioSolutionMutation__
 *
 * To run a mutation, you first call `useUpdateSharedPortfolioSolutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSharedPortfolioSolutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSharedPortfolioSolutionMutation, { data, loading, error }] = useUpdateSharedPortfolioSolutionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      category: // value for 'category'
 *      followingSolutionNote: // value for 'followingSolutionNote'
 *   },
 * });
 */
export function useUpdateSharedPortfolioSolutionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateSharedPortfolioSolutionMutation,
    IUpdateSharedPortfolioSolutionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateSharedPortfolioSolutionMutation, IUpdateSharedPortfolioSolutionMutationVariables>(
    UpdateSharedPortfolioSolutionDocument,
    options,
  )
}
export type UpdateSharedPortfolioSolutionMutationHookResult = ReturnType<
  typeof useUpdateSharedPortfolioSolutionMutation
>
export type UpdateSharedPortfolioSolutionMutationResult = Apollo.MutationResult<IUpdateSharedPortfolioSolutionMutation>
export type UpdateSharedPortfolioSolutionMutationOptions = Apollo.BaseMutationOptions<
  IUpdateSharedPortfolioSolutionMutation,
  IUpdateSharedPortfolioSolutionMutationVariables
>
export const UpdateSolutionRequestDocument = gql`
  mutation updateSolutionRequest($documentId: ID!, $data: SolutionRequestInput!, $status: PublicationStatus) {
    updateSolutionRequest(documentId: $documentId, data: $data, status: $status) {
      id
      documentId
      updatedAt
    }
  }
`
export type IUpdateSolutionRequestMutationFn = Apollo.MutationFunction<
  IUpdateSolutionRequestMutation,
  IUpdateSolutionRequestMutationVariables
>

/**
 * __useUpdateSolutionRequestMutation__
 *
 * To run a mutation, you first call `useUpdateSolutionRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSolutionRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSolutionRequestMutation, { data, loading, error }] = useUpdateSolutionRequestMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      data: // value for 'data'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateSolutionRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<IUpdateSolutionRequestMutation, IUpdateSolutionRequestMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateSolutionRequestMutation, IUpdateSolutionRequestMutationVariables>(
    UpdateSolutionRequestDocument,
    options,
  )
}
export type UpdateSolutionRequestMutationHookResult = ReturnType<typeof useUpdateSolutionRequestMutation>
export type UpdateSolutionRequestMutationResult = Apollo.MutationResult<IUpdateSolutionRequestMutation>
export type UpdateSolutionRequestMutationOptions = Apollo.BaseMutationOptions<
  IUpdateSolutionRequestMutation,
  IUpdateSolutionRequestMutationVariables
>
export const UpdateUserProfileDocument = gql`
  mutation UpdateUserProfile($id: ID!, $data: UpdateUserProfileInput!) {
    updateUserProfile(id: $id, data: $data) {
      external_id
      username
      email
      confirmed
      blocked
      country {
        name
      }
      isPremium
      isVendor
      jobTitle
      vendor {
        name
        email
      }
      role {
        name
        __typename
      }
      companyName
      __typename
      companyType
      companySize
    }
  }
`
export type IUpdateUserProfileMutationFn = Apollo.MutationFunction<
  IUpdateUserProfileMutation,
  IUpdateUserProfileMutationVariables
>

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<IUpdateUserProfileMutation, IUpdateUserProfileMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateUserProfileMutation, IUpdateUserProfileMutationVariables>(
    UpdateUserProfileDocument,
    options,
  )
}
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>
export type UpdateUserProfileMutationResult = Apollo.MutationResult<IUpdateUserProfileMutation>
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<
  IUpdateUserProfileMutation,
  IUpdateUserProfileMutationVariables
>
export const UserInfoDocument = gql`
  query userInfo($token: String!) {
    userInfo(token: $token) {
      external_id
      username
      email
      confirmed
      blocked
      country {
        documentId
        code
        name
        alpha2
      }
      isPremium
      isVendor
      hasVendorCentralAccess
      jobTitle
      vendor {
        documentId
        name
        email
        publishedAt
      }
      role {
        name
        __typename
      }
      companyName
      __typename
      companyType
      companySize
      premiumOrganization {
        documentId
        name
      }
      followedSubTopics {
        slug
        name
      }
    }
  }
`

/**
 * __useUserInfoQuery__
 *
 * To run a query within a React component, call `useUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInfoQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUserInfoQuery(
  baseOptions: Apollo.QueryHookOptions<IUserInfoQuery, IUserInfoQueryVariables> &
    ({ variables: IUserInfoQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IUserInfoQuery, IUserInfoQueryVariables>(UserInfoDocument, options)
}
export function useUserInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IUserInfoQuery, IUserInfoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IUserInfoQuery, IUserInfoQueryVariables>(UserInfoDocument, options)
}
export function useUserInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IUserInfoQuery, IUserInfoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IUserInfoQuery, IUserInfoQueryVariables>(UserInfoDocument, options)
}
export type UserInfoQueryHookResult = ReturnType<typeof useUserInfoQuery>
export type UserInfoLazyQueryHookResult = ReturnType<typeof useUserInfoLazyQuery>
export type UserInfoSuspenseQueryHookResult = ReturnType<typeof useUserInfoSuspenseQuery>
export type UserInfoQueryResult = Apollo.QueryResult<IUserInfoQuery, IUserInfoQueryVariables>
export const VendorAnalysisBySolutionIdDocument = gql`
  query vendorAnalysisBySolutionId($solutionId: ID!) {
    contents(
      filters: { contentType: { eq: "Vendor Analysis" }, resourceSolutions: { documentId: { eq: $solutionId } } }
    ) {
      ...vendorAnalysisForSolution
    }
  }
  ${VendorAnalysisForSolutionFragmentDoc}
`

/**
 * __useVendorAnalysisBySolutionIdQuery__
 *
 * To run a query within a React component, call `useVendorAnalysisBySolutionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorAnalysisBySolutionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorAnalysisBySolutionIdQuery({
 *   variables: {
 *      solutionId: // value for 'solutionId'
 *   },
 * });
 */
export function useVendorAnalysisBySolutionIdQuery(
  baseOptions: Apollo.QueryHookOptions<IVendorAnalysisBySolutionIdQuery, IVendorAnalysisBySolutionIdQueryVariables> &
    ({ variables: IVendorAnalysisBySolutionIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IVendorAnalysisBySolutionIdQuery, IVendorAnalysisBySolutionIdQueryVariables>(
    VendorAnalysisBySolutionIdDocument,
    options,
  )
}
export function useVendorAnalysisBySolutionIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IVendorAnalysisBySolutionIdQuery,
    IVendorAnalysisBySolutionIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IVendorAnalysisBySolutionIdQuery, IVendorAnalysisBySolutionIdQueryVariables>(
    VendorAnalysisBySolutionIdDocument,
    options,
  )
}
export function useVendorAnalysisBySolutionIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IVendorAnalysisBySolutionIdQuery,
    IVendorAnalysisBySolutionIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IVendorAnalysisBySolutionIdQuery, IVendorAnalysisBySolutionIdQueryVariables>(
    VendorAnalysisBySolutionIdDocument,
    options,
  )
}
export type VendorAnalysisBySolutionIdQueryHookResult = ReturnType<typeof useVendorAnalysisBySolutionIdQuery>
export type VendorAnalysisBySolutionIdLazyQueryHookResult = ReturnType<typeof useVendorAnalysisBySolutionIdLazyQuery>
export type VendorAnalysisBySolutionIdSuspenseQueryHookResult = ReturnType<
  typeof useVendorAnalysisBySolutionIdSuspenseQuery
>
export type VendorAnalysisBySolutionIdQueryResult = Apollo.QueryResult<
  IVendorAnalysisBySolutionIdQuery,
  IVendorAnalysisBySolutionIdQueryVariables
>
export const VisitContentDocument = gql`
  mutation visitContent($content_id: ID!) {
    visitContent(data: { content_id: $content_id })
  }
`
export type IVisitContentMutationFn = Apollo.MutationFunction<IVisitContentMutation, IVisitContentMutationVariables>

/**
 * __useVisitContentMutation__
 *
 * To run a mutation, you first call `useVisitContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVisitContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [visitContentMutation, { data, loading, error }] = useVisitContentMutation({
 *   variables: {
 *      content_id: // value for 'content_id'
 *   },
 * });
 */
export function useVisitContentMutation(
  baseOptions?: Apollo.MutationHookOptions<IVisitContentMutation, IVisitContentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IVisitContentMutation, IVisitContentMutationVariables>(VisitContentDocument, options)
}
export type VisitContentMutationHookResult = ReturnType<typeof useVisitContentMutation>
export type VisitContentMutationResult = Apollo.MutationResult<IVisitContentMutation>
export type VisitContentMutationOptions = Apollo.BaseMutationOptions<
  IVisitContentMutation,
  IVisitContentMutationVariables
>
